export const GROUPS = [
    {
        "id": 8197594,
        "tempData": false,
        "gitlabId": 8197594,
        "name": "theCodeCampus",
        "projects": [
            {
                "id": 14061182,
                "gitlabId": 14061182,
                "name": "thecodecampus Zertifikate Server",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/thecodecampus.certificates.server.git",
                "stats": {
                    "id": 29681,
                    "status": "success",
                    "numberOfPipelines": 11,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 86,
                    "averageDurationOfPipelines_inMinutes": 1.43,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 6,
                    "numberOfFailedPipelines": 4,
                    "numberOfCanceledPipelines": 1,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 54.55,
                    "totalRepoSize": "188743",
                    "artifactsSize": "48754"
                },
                "pipelines": [
                    {
                        "id": 87304211,
                        "gitlabId": 87304211,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727896,
                            "isTestReportAvailable": false,
                            "duration": 92,
                            "duration_inMinutes": 1.53,
                            "created_at": "Oct-08-19",
                            "created_at_rawDateFormat": "2019-10-08T07:03:21.203Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 87303036,
                        "gitlabId": 87303036,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727901,
                            "isTestReportAvailable": false,
                            "duration": 106,
                            "duration_inMinutes": 1.77,
                            "created_at": "Oct-08-19",
                            "created_at_rawDateFormat": "2019-10-08T07:03:21.635Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 87302634,
                        "gitlabId": 87302634,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 727897,
                            "isTestReportAvailable": false,
                            "duration": 43,
                            "duration_inMinutes": 0.72,
                            "created_at": "Oct-08-19",
                            "created_at_rawDateFormat": "2019-10-08T07:03:21.427Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 87301530,
                        "gitlabId": 87301530,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 727895,
                            "isTestReportAvailable": false,
                            "duration": 87,
                            "duration_inMinutes": 1.45,
                            "created_at": "Oct-08-19",
                            "created_at_rawDateFormat": "2019-10-08T07:03:21.178Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 87300750,
                        "gitlabId": 87300750,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727894,
                            "isTestReportAvailable": false,
                            "duration": 96,
                            "duration_inMinutes": 1.6,
                            "created_at": "Oct-08-19",
                            "created_at_rawDateFormat": "2019-10-08T07:03:21.174Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 87298411,
                        "gitlabId": 87298411,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727900,
                            "isTestReportAvailable": false,
                            "duration": 134,
                            "duration_inMinutes": 2.23,
                            "created_at": "Oct-08-19",
                            "created_at_rawDateFormat": "2019-10-08T07:03:21.519Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 80182995,
                        "gitlabId": 80182995,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727898,
                            "isTestReportAvailable": false,
                            "duration": 108,
                            "duration_inMinutes": 1.8,
                            "created_at": "Sep-04-19",
                            "created_at_rawDateFormat": "2019-09-04T07:03:21.463Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 80181076,
                        "gitlabId": 80181076,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 727899,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-04-19",
                            "created_at_rawDateFormat": "2019-09-04T07:03:21.503Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 80178179,
                        "gitlabId": 80178179,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 727902,
                            "isTestReportAvailable": false,
                            "duration": 115,
                            "duration_inMinutes": 1.92,
                            "created_at": "Sep-04-19",
                            "created_at_rawDateFormat": "2019-09-04T07:03:21.745Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 80176480,
                        "gitlabId": 80176480,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727914,
                            "isTestReportAvailable": false,
                            "duration": 87,
                            "duration_inMinutes": 1.45,
                            "created_at": "Sep-04-19",
                            "created_at_rawDateFormat": "2019-09-04T07:03:22.582Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 80175647,
                        "gitlabId": 80175647,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 727903,
                            "isTestReportAvailable": false,
                            "duration": 73,
                            "duration_inMinutes": 1.22,
                            "created_at": "Sep-04-19",
                            "created_at_rawDateFormat": "2019-09-04T07:03:21.769Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29678,
                    "gitlabId": 8197594,
                    "name": "theCodeCampus"
                }
            },
            {
                "id": 14061087,
                "gitlabId": 14061087,
                "name": "thecodecampus Zertifikate Client",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/thecodecampus.certificates.client.git",
                "stats": {
                    "id": 29680,
                    "status": "success",
                    "numberOfPipelines": 21,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 208,
                    "averageDurationOfPipelines_inMinutes": 3.47,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 12,
                    "numberOfFailedPipelines": 8,
                    "numberOfCanceledPipelines": 1,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 57.14,
                    "totalRepoSize": "1289748",
                    "artifactsSize": "8959671"
                },
                "pipelines": [
                    {
                        "id": 256371118,
                        "gitlabId": 256371118,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727904,
                            "isTestReportAvailable": false,
                            "duration": 200,
                            "duration_inMinutes": 3.33,
                            "created_at": "Feb-15-21",
                            "created_at_rawDateFormat": "2021-02-15T07:03:21.774Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 243102952,
                        "gitlabId": 243102952,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727905,
                            "isTestReportAvailable": false,
                            "duration": 221,
                            "duration_inMinutes": 3.68,
                            "created_at": "Jan-18-21",
                            "created_at_rawDateFormat": "2021-01-18T07:03:21.794Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 243070117,
                        "gitlabId": 243070117,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727906,
                            "isTestReportAvailable": false,
                            "duration": 127,
                            "duration_inMinutes": 2.12,
                            "created_at": "Jan-18-21",
                            "created_at_rawDateFormat": "2021-01-18T07:03:21.883Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 241518403,
                        "gitlabId": 241518403,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727907,
                            "isTestReportAvailable": false,
                            "duration": 230,
                            "duration_inMinutes": 3.83,
                            "created_at": "Jan-14-21",
                            "created_at_rawDateFormat": "2021-01-14T07:03:22.015Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 241515304,
                        "gitlabId": 241515304,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 727909,
                            "isTestReportAvailable": false,
                            "duration": 207,
                            "duration_inMinutes": 3.45,
                            "created_at": "Jan-14-21",
                            "created_at_rawDateFormat": "2021-01-14T07:03:22.200Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 241513404,
                        "gitlabId": 241513404,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727908,
                            "isTestReportAvailable": false,
                            "duration": 121,
                            "duration_inMinutes": 2.02,
                            "created_at": "Jan-14-21",
                            "created_at_rawDateFormat": "2021-01-14T07:03:22.123Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 241510554,
                        "gitlabId": 241510554,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727912,
                            "isTestReportAvailable": false,
                            "duration": 224,
                            "duration_inMinutes": 3.73,
                            "created_at": "Jan-14-21",
                            "created_at_rawDateFormat": "2021-01-14T07:03:22.418Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 241508350,
                        "gitlabId": 241508350,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 727910,
                            "isTestReportAvailable": false,
                            "duration": 209,
                            "duration_inMinutes": 3.48,
                            "created_at": "Jan-14-21",
                            "created_at_rawDateFormat": "2021-01-14T07:03:22.354Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 241503678,
                        "gitlabId": 241503678,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 727911,
                            "isTestReportAvailable": false,
                            "duration": 119,
                            "duration_inMinutes": 1.98,
                            "created_at": "Jan-14-21",
                            "created_at_rawDateFormat": "2021-01-14T07:03:22.361Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 241500548,
                        "gitlabId": 241500548,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727925,
                            "isTestReportAvailable": false,
                            "duration": 199,
                            "duration_inMinutes": 3.32,
                            "created_at": "Jan-14-21",
                            "created_at_rawDateFormat": "2021-01-14T07:03:23.546Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 241500013,
                        "gitlabId": 241500013,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 727913,
                            "isTestReportAvailable": false,
                            "duration": 111,
                            "duration_inMinutes": 1.85,
                            "created_at": "Jan-14-21",
                            "created_at_rawDateFormat": "2021-01-14T07:03:22.482Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 241082077,
                        "gitlabId": 241082077,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727915,
                            "isTestReportAvailable": false,
                            "duration": 226,
                            "duration_inMinutes": 3.77,
                            "created_at": "Jan-13-21",
                            "created_at_rawDateFormat": "2021-01-13T07:03:22.605Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 238441882,
                        "gitlabId": 238441882,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727916,
                            "isTestReportAvailable": false,
                            "duration": 291,
                            "duration_inMinutes": 4.85,
                            "created_at": "Jan-07-21",
                            "created_at_rawDateFormat": "2021-01-07T07:03:22.630Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 238440501,
                        "gitlabId": 238440501,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 727917,
                            "isTestReportAvailable": false,
                            "duration": 203,
                            "duration_inMinutes": 3.38,
                            "created_at": "Jan-07-21",
                            "created_at_rawDateFormat": "2021-01-07T07:03:22.689Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 237662928,
                        "gitlabId": 237662928,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 727918,
                            "isTestReportAvailable": false,
                            "duration": 271,
                            "duration_inMinutes": 4.52,
                            "created_at": "Jan-05-21",
                            "created_at_rawDateFormat": "2021-01-05T07:03:22.912Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 237185574,
                        "gitlabId": 237185574,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 727938,
                            "isTestReportAvailable": false,
                            "duration": 207,
                            "duration_inMinutes": 3.45,
                            "created_at": "Jan-04-21",
                            "created_at_rawDateFormat": "2021-01-04T07:03:24.477Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 237181391,
                        "gitlabId": 237181391,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 727920,
                            "isTestReportAvailable": false,
                            "duration": 201,
                            "duration_inMinutes": 3.35,
                            "created_at": "Jan-04-21",
                            "created_at_rawDateFormat": "2021-01-04T07:03:23.145Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 229310911,
                        "gitlabId": 229310911,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 727922,
                            "isTestReportAvailable": false,
                            "duration": 252,
                            "duration_inMinutes": 4.2,
                            "created_at": "Dec-14-20",
                            "created_at_rawDateFormat": "2020-12-14T07:03:23.329Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 87293676,
                        "gitlabId": 87293676,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727919,
                            "isTestReportAvailable": false,
                            "duration": 273,
                            "duration_inMinutes": 4.55,
                            "created_at": "Oct-08-19",
                            "created_at_rawDateFormat": "2019-10-08T07:03:23.123Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 81243328,
                        "gitlabId": 81243328,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727921,
                            "isTestReportAvailable": false,
                            "duration": 264,
                            "duration_inMinutes": 4.4,
                            "created_at": "Sep-10-19",
                            "created_at_rawDateFormat": "2019-09-10T07:03:23.189Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 80225373,
                        "gitlabId": 80225373,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727932,
                            "isTestReportAvailable": false,
                            "duration": 220,
                            "duration_inMinutes": 3.67,
                            "created_at": "Sep-04-19",
                            "created_at_rawDateFormat": "2019-09-04T07:03:24.134Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29679,
                    "gitlabId": 8197594,
                    "name": "theCodeCampus"
                }
            },
            {
                "id": 13992461,
                "gitlabId": 13992461,
                "name": "thecodecampus-angular2.basic-server",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/thecodecampus-angular2.basic-server.git",
                "stats": {
                    "id": 29682,
                    "status": "failed",
                    "numberOfPipelines": 1,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 1,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 0,
                    "totalRepoSize": "807403",
                    "artifactsSize": "0"
                },
                "pipelines": [
                    {
                        "id": 78411736,
                        "gitlabId": 78411736,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 727923,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:03:23.412Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29680,
                    "gitlabId": 8197594,
                    "name": "theCodeCampus"
                }
            },
            {
                "id": 13987869,
                "gitlabId": 13987869,
                "name": "thecodecampus-angular2.advanced-app",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/thecodecampus-angular2.advanced-app.git",
                "stats": {
                    "id": 29679,
                    "status": "skipped",
                    "numberOfPipelines": 97,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 2,
                    "averageDurationOfPipelines_inMinutes": 0.03,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 2,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 95,
                    "pipelinesSuccessRatio": 2.06,
                    "totalRepoSize": "3198156",
                    "artifactsSize": "44616690"
                },
                "pipelines": [
                    {
                        "id": 481695286,
                        "gitlabId": 481695286,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727924,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:23.457Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481695199,
                        "gitlabId": 481695199,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727926,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:23.577Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481695181,
                        "gitlabId": 481695181,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727927,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:23.668Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481695146,
                        "gitlabId": 481695146,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727929,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:23.898Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481695106,
                        "gitlabId": 481695106,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727928,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:23.811Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481695074,
                        "gitlabId": 481695074,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727930,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:23.919Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481695056,
                        "gitlabId": 481695056,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727931,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:23.921Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481695027,
                        "gitlabId": 481695027,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727933,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:24.191Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481694963,
                        "gitlabId": 481694963,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727935,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:24.327Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481694927,
                        "gitlabId": 481694927,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727934,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:24.208Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481694904,
                        "gitlabId": 481694904,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727937,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:24.447Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481694891,
                        "gitlabId": 481694891,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727936,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:24.404Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481694868,
                        "gitlabId": 481694868,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727939,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:24.513Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481694846,
                        "gitlabId": 481694846,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727946,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:24.972Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481694826,
                        "gitlabId": 481694826,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727941,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:24.668Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481694804,
                        "gitlabId": 481694804,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727940,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:24.652Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249326,
                        "gitlabId": 253249326,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727942,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:24.731Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249315,
                        "gitlabId": 253249315,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727943,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:24.752Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249304,
                        "gitlabId": 253249304,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727944,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:24.779Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249293,
                        "gitlabId": 253249293,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727948,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.114Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249279,
                        "gitlabId": 253249279,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727945,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:24.916Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249268,
                        "gitlabId": 253249268,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727950,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.218Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249254,
                        "gitlabId": 253249254,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727947,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.112Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249235,
                        "gitlabId": 253249235,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727952,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.287Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249217,
                        "gitlabId": 253249217,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727949,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.209Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249207,
                        "gitlabId": 253249207,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727951,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.243Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249195,
                        "gitlabId": 253249195,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727953,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.389Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249168,
                        "gitlabId": 253249168,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727954,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.472Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249157,
                        "gitlabId": 253249157,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727957,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.527Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249150,
                        "gitlabId": 253249150,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727955,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.479Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249139,
                        "gitlabId": 253249139,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727956,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.501Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249127,
                        "gitlabId": 253249127,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727958,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.575Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249116,
                        "gitlabId": 253249116,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727959,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.647Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249084,
                        "gitlabId": 253249084,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727960,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.744Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249061,
                        "gitlabId": 253249061,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727964,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.892Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249048,
                        "gitlabId": 253249048,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727961,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.756Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249033,
                        "gitlabId": 253249033,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727962,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.811Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253249017,
                        "gitlabId": 253249017,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727963,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.836Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253248999,
                        "gitlabId": 253248999,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727965,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:25.895Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253248988,
                        "gitlabId": 253248988,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727966,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:26.001Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253248968,
                        "gitlabId": 253248968,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727967,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:26.010Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253248943,
                        "gitlabId": 253248943,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727968,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:26.114Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253248928,
                        "gitlabId": 253248928,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727970,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:26.182Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253248906,
                        "gitlabId": 253248906,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727969,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:26.161Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253248890,
                        "gitlabId": 253248890,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727981,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:27.272Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253248877,
                        "gitlabId": 253248877,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727972,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:26.360Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253248854,
                        "gitlabId": 253248854,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727971,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:26.284Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253248837,
                        "gitlabId": 253248837,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727975,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:26.471Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253248816,
                        "gitlabId": 253248816,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 727973,
                            "isTestReportAvailable": false,
                            "duration": 131,
                            "duration_inMinutes": 2.18,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:26.431Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974757,
                        "gitlabId": 247974757,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727974,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:26.438Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974744,
                        "gitlabId": 247974744,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727976,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:26.574Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974734,
                        "gitlabId": 247974734,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728001,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:28.857Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974719,
                        "gitlabId": 247974719,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727977,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:26.699Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974708,
                        "gitlabId": 247974708,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727978,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:26.830Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974688,
                        "gitlabId": 247974688,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727983,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:27.354Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974677,
                        "gitlabId": 247974677,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727979,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:26.842Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974667,
                        "gitlabId": 247974667,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727993,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:28.214Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974656,
                        "gitlabId": 247974656,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727980,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:27.088Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974639,
                        "gitlabId": 247974639,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727982,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:27.291Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974624,
                        "gitlabId": 247974624,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727984,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:27.442Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974611,
                        "gitlabId": 247974611,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727985,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:27.521Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974607,
                        "gitlabId": 247974607,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727987,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:27.664Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974568,
                        "gitlabId": 247974568,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727986,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:27.598Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974556,
                        "gitlabId": 247974556,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727988,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:27.742Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974539,
                        "gitlabId": 247974539,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727989,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:27.781Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974522,
                        "gitlabId": 247974522,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727990,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:27.875Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974502,
                        "gitlabId": 247974502,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727991,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:27.969Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974489,
                        "gitlabId": 247974489,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727992,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:28.023Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974474,
                        "gitlabId": 247974474,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727994,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:28.229Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974457,
                        "gitlabId": 247974457,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728003,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:29.031Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974440,
                        "gitlabId": 247974440,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727997,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:28.605Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974423,
                        "gitlabId": 247974423,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727998,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:28.733Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974403,
                        "gitlabId": 247974403,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727995,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:28.468Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974390,
                        "gitlabId": 247974390,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727996,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:28.504Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974381,
                        "gitlabId": 247974381,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 727999,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:28.746Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974368,
                        "gitlabId": 247974368,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728002,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:28.868Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974350,
                        "gitlabId": 247974350,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728000,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:28.852Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974332,
                        "gitlabId": 247974332,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728006,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:29.128Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974315,
                        "gitlabId": 247974315,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728004,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:29.051Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974301,
                        "gitlabId": 247974301,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728005,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:29.106Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247974283,
                        "gitlabId": 247974283,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728007,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:03:29.265Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 237109672,
                        "gitlabId": 237109672,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728008,
                            "isTestReportAvailable": false,
                            "duration": 86,
                            "duration_inMinutes": 1.43,
                            "created_at": "Jan-04-21",
                            "created_at_rawDateFormat": "2021-01-04T07:03:29.322Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 237108472,
                        "gitlabId": 237108472,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728009,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-04-21",
                            "created_at_rawDateFormat": "2021-01-04T07:03:29.378Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 237108454,
                        "gitlabId": 237108454,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728017,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-04-21",
                            "created_at_rawDateFormat": "2021-01-04T07:03:29.885Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 237107728,
                        "gitlabId": 237107728,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728011,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-04-21",
                            "created_at_rawDateFormat": "2021-01-04T07:03:29.452Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225252568,
                        "gitlabId": 225252568,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728010,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:03:29.385Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225252542,
                        "gitlabId": 225252542,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728013,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:03:29.593Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225252509,
                        "gitlabId": 225252509,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728012,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:03:29.579Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225252490,
                        "gitlabId": 225252490,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728018,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:03:29.893Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225252473,
                        "gitlabId": 225252473,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728175,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:03:42.055Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225252451,
                        "gitlabId": 225252451,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728164,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:03:41.430Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225252428,
                        "gitlabId": 225252428,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728168,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:03:41.728Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225252412,
                        "gitlabId": 225252412,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728169,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:03:41.736Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225252394,
                        "gitlabId": 225252394,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728170,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:03:41.827Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225252374,
                        "gitlabId": 225252374,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728171,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:03:41.964Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225252352,
                        "gitlabId": 225252352,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728173,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:03:42.026Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225252326,
                        "gitlabId": 225252326,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728172,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:03:41.999Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29687,
                    "gitlabId": 8197594,
                    "name": "theCodeCampus"
                }
            },
            {
                "id": 13987853,
                "gitlabId": 13987853,
                "name": "thecodecampus-angular2.advanced-slides",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/thecodecampus-angular2.advanced-slides.git",
                "stats": {
                    "id": 29690,
                    "status": "failed",
                    "numberOfPipelines": 62,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 205,
                    "averageDurationOfPipelines_inMinutes": 3.42,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 36,
                    "numberOfFailedPipelines": 18,
                    "numberOfCanceledPipelines": 3,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 5,
                    "pipelinesSuccessRatio": 58.06,
                    "totalRepoSize": "8986296",
                    "artifactsSize": "173552290"
                },
                "pipelines": [
                    {
                        "id": 482708506,
                        "gitlabId": 482708506,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728014,
                            "isTestReportAvailable": false,
                            "duration": 130,
                            "duration_inMinutes": 2.17,
                            "created_at": "Mar-02-22",
                            "created_at_rawDateFormat": "2022-03-02T07:03:29.666Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 482681231,
                        "gitlabId": 482681231,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728015,
                            "isTestReportAvailable": false,
                            "duration": 131,
                            "duration_inMinutes": 2.18,
                            "created_at": "Mar-02-22",
                            "created_at_rawDateFormat": "2022-03-02T07:03:29.744Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 482676239,
                        "gitlabId": 482676239,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728016,
                            "isTestReportAvailable": false,
                            "duration": 193,
                            "duration_inMinutes": 3.22,
                            "created_at": "Mar-02-22",
                            "created_at_rawDateFormat": "2022-03-02T07:03:29.858Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 482608162,
                        "gitlabId": 482608162,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728020,
                            "isTestReportAvailable": false,
                            "duration": 128,
                            "duration_inMinutes": 2.13,
                            "created_at": "Mar-02-22",
                            "created_at_rawDateFormat": "2022-03-02T07:03:30.045Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 482529799,
                        "gitlabId": 482529799,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728019,
                            "isTestReportAvailable": false,
                            "duration": 129,
                            "duration_inMinutes": 2.15,
                            "created_at": "Mar-02-22",
                            "created_at_rawDateFormat": "2022-03-02T07:03:29.966Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 482498193,
                        "gitlabId": 482498193,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728021,
                            "isTestReportAvailable": false,
                            "duration": 128,
                            "duration_inMinutes": 2.13,
                            "created_at": "Mar-02-22",
                            "created_at_rawDateFormat": "2022-03-02T07:03:30.086Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481955779,
                        "gitlabId": 481955779,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728024,
                            "isTestReportAvailable": false,
                            "duration": 126,
                            "duration_inMinutes": 2.1,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:30.192Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481930725,
                        "gitlabId": 481930725,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728022,
                            "isTestReportAvailable": false,
                            "duration": 127,
                            "duration_inMinutes": 2.12,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:30.146Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481881978,
                        "gitlabId": 481881978,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728023,
                            "isTestReportAvailable": false,
                            "duration": 127,
                            "duration_inMinutes": 2.12,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:30.162Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481791861,
                        "gitlabId": 481791861,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728025,
                            "isTestReportAvailable": false,
                            "duration": 127,
                            "duration_inMinutes": 2.12,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:30.269Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481676337,
                        "gitlabId": 481676337,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728027,
                            "isTestReportAvailable": false,
                            "duration": 129,
                            "duration_inMinutes": 2.15,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:30.415Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 481650125,
                        "gitlabId": 481650125,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728026,
                            "isTestReportAvailable": false,
                            "duration": 210,
                            "duration_inMinutes": 3.5,
                            "created_at": "Mar-01-22",
                            "created_at_rawDateFormat": "2022-03-01T07:03:30.356Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 460207845,
                        "gitlabId": 460207845,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728029,
                            "isTestReportAvailable": false,
                            "duration": 214,
                            "duration_inMinutes": 3.57,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:03:30.590Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 460204377,
                        "gitlabId": 460204377,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728076,
                            "isTestReportAvailable": false,
                            "duration": 187,
                            "duration_inMinutes": 3.12,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:03:33.759Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 460199361,
                        "gitlabId": 460199361,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728028,
                            "isTestReportAvailable": false,
                            "duration": 185,
                            "duration_inMinutes": 3.08,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:03:30.588Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 411367799,
                        "gitlabId": 411367799,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728030,
                            "isTestReportAvailable": false,
                            "duration": 170,
                            "duration_inMinutes": 2.83,
                            "created_at": "Nov-18-21",
                            "created_at_rawDateFormat": "2021-11-18T07:03:30.603Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 411367551,
                        "gitlabId": 411367551,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728031,
                            "isTestReportAvailable": false,
                            "duration": 171,
                            "duration_inMinutes": 2.85,
                            "created_at": "Nov-18-21",
                            "created_at_rawDateFormat": "2021-11-18T07:03:30.629Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 317095557,
                        "gitlabId": 317095557,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728032,
                            "isTestReportAvailable": false,
                            "duration": 328,
                            "duration_inMinutes": 5.47,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:03:30.691Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 303850170,
                        "gitlabId": 303850170,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728034,
                            "isTestReportAvailable": false,
                            "duration": 299,
                            "duration_inMinutes": 4.98,
                            "created_at": "May-17-21",
                            "created_at_rawDateFormat": "2021-05-17T07:03:30.927Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 303839953,
                        "gitlabId": 303839953,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728033,
                            "isTestReportAvailable": false,
                            "duration": 307,
                            "duration_inMinutes": 5.12,
                            "created_at": "May-17-21",
                            "created_at_rawDateFormat": "2021-05-17T07:03:30.870Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253009503,
                        "gitlabId": 253009503,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728038,
                            "isTestReportAvailable": false,
                            "duration": 331,
                            "duration_inMinutes": 5.52,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:31.194Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 252918607,
                        "gitlabId": 252918607,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728035,
                            "isTestReportAvailable": false,
                            "duration": 244,
                            "duration_inMinutes": 4.07,
                            "created_at": "Feb-08-21",
                            "created_at_rawDateFormat": "2021-02-08T07:03:30.934Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 238446535,
                        "gitlabId": 238446535,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728036,
                            "isTestReportAvailable": false,
                            "duration": 205,
                            "duration_inMinutes": 3.42,
                            "created_at": "Jan-07-21",
                            "created_at_rawDateFormat": "2021-01-07T07:03:31.073Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 237164676,
                        "gitlabId": 237164676,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728037,
                            "isTestReportAvailable": false,
                            "duration": 182,
                            "duration_inMinutes": 3.03,
                            "created_at": "Jan-04-21",
                            "created_at_rawDateFormat": "2021-01-04T07:03:31.128Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 237157932,
                        "gitlabId": 237157932,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728040,
                            "isTestReportAvailable": false,
                            "duration": 313,
                            "duration_inMinutes": 5.22,
                            "created_at": "Jan-04-21",
                            "created_at_rawDateFormat": "2021-01-04T07:03:31.304Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 237106695,
                        "gitlabId": 237106695,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728039,
                            "isTestReportAvailable": false,
                            "duration": 324,
                            "duration_inMinutes": 5.4,
                            "created_at": "Jan-04-21",
                            "created_at_rawDateFormat": "2021-01-04T07:03:31.244Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225279606,
                        "gitlabId": 225279606,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728041,
                            "isTestReportAvailable": false,
                            "duration": 156,
                            "duration_inMinutes": 2.6,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:03:31.471Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225278337,
                        "gitlabId": 225278337,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728042,
                            "isTestReportAvailable": false,
                            "duration": 119,
                            "duration_inMinutes": 1.98,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:03:31.472Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225277444,
                        "gitlabId": 225277444,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728044,
                            "isTestReportAvailable": false,
                            "duration": 222,
                            "duration_inMinutes": 3.7,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:03:31.586Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225219610,
                        "gitlabId": 225219610,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728043,
                            "isTestReportAvailable": false,
                            "duration": 327,
                            "duration_inMinutes": 5.45,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:03:31.513Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 207744067,
                        "gitlabId": 207744067,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728045,
                            "isTestReportAvailable": false,
                            "duration": 351,
                            "duration_inMinutes": 5.85,
                            "created_at": "Oct-26-20",
                            "created_at_rawDateFormat": "2020-10-26T07:03:31.699Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 202003469,
                        "gitlabId": 202003469,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728046,
                            "isTestReportAvailable": false,
                            "duration": 366,
                            "duration_inMinutes": 6.1,
                            "created_at": "Oct-13-20",
                            "created_at_rawDateFormat": "2020-10-13T07:03:31.727Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 151916493,
                        "gitlabId": 151916493,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728047,
                            "isTestReportAvailable": false,
                            "duration": 347,
                            "duration_inMinutes": 5.78,
                            "created_at": "Jun-02-20",
                            "created_at_rawDateFormat": "2020-06-02T07:03:31.948Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 119948755,
                        "gitlabId": 119948755,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728048,
                            "isTestReportAvailable": false,
                            "duration": 349,
                            "duration_inMinutes": 5.82,
                            "created_at": "Feb-21-20",
                            "created_at_rawDateFormat": "2020-02-21T07:03:31.960Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 119909641,
                        "gitlabId": 119909641,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728050,
                            "isTestReportAvailable": false,
                            "duration": 227,
                            "duration_inMinutes": 3.78,
                            "created_at": "Feb-21-20",
                            "created_at_rawDateFormat": "2020-02-21T07:03:32.140Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 119909312,
                        "gitlabId": 119909312,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728051,
                            "isTestReportAvailable": false,
                            "duration": 384,
                            "duration_inMinutes": 6.4,
                            "created_at": "Feb-21-20",
                            "created_at_rawDateFormat": "2020-02-21T07:03:32.156Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 119632411,
                        "gitlabId": 119632411,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728049,
                            "isTestReportAvailable": false,
                            "duration": 388,
                            "duration_inMinutes": 6.47,
                            "created_at": "Feb-20-20",
                            "created_at_rawDateFormat": "2020-02-20T07:03:31.980Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 95292588,
                        "gitlabId": 95292588,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728052,
                            "isTestReportAvailable": false,
                            "duration": 383,
                            "duration_inMinutes": 6.38,
                            "created_at": "Nov-12-19",
                            "created_at_rawDateFormat": "2019-11-12T07:03:32.207Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 95195072,
                        "gitlabId": 95195072,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728053,
                            "isTestReportAvailable": false,
                            "duration": 346,
                            "duration_inMinutes": 5.77,
                            "created_at": "Nov-11-19",
                            "created_at_rawDateFormat": "2019-11-11T07:03:32.233Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 95192776,
                        "gitlabId": 95192776,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728055,
                            "isTestReportAvailable": false,
                            "duration": 226,
                            "duration_inMinutes": 3.77,
                            "created_at": "Nov-11-19",
                            "created_at_rawDateFormat": "2019-11-11T07:03:32.412Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 92012701,
                        "gitlabId": 92012701,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728056,
                            "isTestReportAvailable": false,
                            "duration": 305,
                            "duration_inMinutes": 5.08,
                            "created_at": "Oct-28-19",
                            "created_at_rawDateFormat": "2019-10-28T07:03:32.421Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 91270330,
                        "gitlabId": 91270330,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728054,
                            "isTestReportAvailable": false,
                            "duration": 342,
                            "duration_inMinutes": 5.7,
                            "created_at": "Oct-24-19",
                            "created_at_rawDateFormat": "2019-10-24T07:03:32.403Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 90342480,
                        "gitlabId": 90342480,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728058,
                            "isTestReportAvailable": false,
                            "duration": 269,
                            "duration_inMinutes": 4.48,
                            "created_at": "Oct-21-19",
                            "created_at_rawDateFormat": "2019-10-21T07:03:32.539Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 90267759,
                        "gitlabId": 90267759,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728057,
                            "isTestReportAvailable": false,
                            "duration": 132,
                            "duration_inMinutes": 2.2,
                            "created_at": "Oct-21-19",
                            "created_at_rawDateFormat": "2019-10-21T07:03:32.521Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 86088233,
                        "gitlabId": 86088233,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728059,
                            "isTestReportAvailable": false,
                            "duration": 307,
                            "duration_inMinutes": 5.12,
                            "created_at": "Oct-02-19",
                            "created_at_rawDateFormat": "2019-10-02T07:03:32.665Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 86080778,
                        "gitlabId": 86080778,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728060,
                            "isTestReportAvailable": false,
                            "duration": 150,
                            "duration_inMinutes": 2.5,
                            "created_at": "Oct-02-19",
                            "created_at_rawDateFormat": "2019-10-02T07:03:32.672Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 86080505,
                        "gitlabId": 86080505,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728061,
                            "isTestReportAvailable": false,
                            "duration": 2,
                            "duration_inMinutes": 0.03,
                            "created_at": "Oct-02-19",
                            "created_at_rawDateFormat": "2019-10-02T07:03:32.698Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 85991236,
                        "gitlabId": 85991236,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728063,
                            "isTestReportAvailable": false,
                            "duration": 322,
                            "duration_inMinutes": 5.37,
                            "created_at": "Oct-02-19",
                            "created_at_rawDateFormat": "2019-10-02T07:03:32.870Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 85763482,
                        "gitlabId": 85763482,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728062,
                            "isTestReportAvailable": false,
                            "duration": 397,
                            "duration_inMinutes": 6.62,
                            "created_at": "Oct-01-19",
                            "created_at_rawDateFormat": "2019-10-01T07:03:32.803Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 85763257,
                        "gitlabId": 85763257,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728064,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Oct-01-19",
                            "created_at_rawDateFormat": "2019-10-01T07:03:32.916Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 85763093,
                        "gitlabId": 85763093,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728080,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Oct-01-19",
                            "created_at_rawDateFormat": "2019-10-01T07:03:34.083Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 85762989,
                        "gitlabId": 85762989,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728065,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Oct-01-19",
                            "created_at_rawDateFormat": "2019-10-01T07:03:32.952Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 85760692,
                        "gitlabId": 85760692,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728066,
                            "isTestReportAvailable": false,
                            "duration": 350,
                            "duration_inMinutes": 5.83,
                            "created_at": "Oct-01-19",
                            "created_at_rawDateFormat": "2019-10-01T07:03:33.099Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 84116047,
                        "gitlabId": 84116047,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728067,
                            "isTestReportAvailable": false,
                            "duration": 276,
                            "duration_inMinutes": 4.6,
                            "created_at": "Sep-24-19",
                            "created_at_rawDateFormat": "2019-09-24T07:03:33.148Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 81784377,
                        "gitlabId": 81784377,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728069,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-12-19",
                            "created_at_rawDateFormat": "2019-09-12T07:03:33.243Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 81746665,
                        "gitlabId": 81746665,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728068,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-12-19",
                            "created_at_rawDateFormat": "2019-09-12T07:03:33.209Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79258718,
                        "gitlabId": 79258718,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728070,
                            "isTestReportAvailable": false,
                            "duration": 246,
                            "duration_inMinutes": 4.1,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:03:33.367Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79091859,
                        "gitlabId": 79091859,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728071,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:03:33.413Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79090703,
                        "gitlabId": 79090703,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728072,
                            "isTestReportAvailable": false,
                            "duration": 252,
                            "duration_inMinutes": 4.2,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:03:33.476Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79087460,
                        "gitlabId": 79087460,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728073,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:03:33.561Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79086817,
                        "gitlabId": 79086817,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728074,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:03:33.617Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78413030,
                        "gitlabId": 78413030,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728401,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:04:00.440Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29685,
                    "gitlabId": 8197594,
                    "name": "theCodeCampus"
                }
            },
            {
                "id": 13987837,
                "gitlabId": 13987837,
                "name": "thecodecampus-angular2.basic-app",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/thecodecampus-angular2.basic-app.git",
                "stats": {
                    "id": 29720,
                    "status": "skipped",
                    "numberOfPipelines": 97,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 3,
                    "averageDurationOfPipelines_inMinutes": 0.05,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 3,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 94,
                    "pipelinesSuccessRatio": 3.09,
                    "totalRepoSize": "3198156",
                    "artifactsSize": "29141117"
                },
                "pipelines": [
                    {
                        "id": 380098792,
                        "gitlabId": 380098792,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728077,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:33.854Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098787,
                        "gitlabId": 380098787,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728075,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:33.733Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098750,
                        "gitlabId": 380098750,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728078,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:33.910Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098735,
                        "gitlabId": 380098735,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728101,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:35.529Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098724,
                        "gitlabId": 380098724,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728079,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:34.004Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098719,
                        "gitlabId": 380098719,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728081,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:34.135Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098694,
                        "gitlabId": 380098694,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728086,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:34.522Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098670,
                        "gitlabId": 380098670,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728082,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:34.176Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098638,
                        "gitlabId": 380098638,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728083,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:34.280Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098617,
                        "gitlabId": 380098617,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728084,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:34.349Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098602,
                        "gitlabId": 380098602,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728085,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:34.491Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098582,
                        "gitlabId": 380098582,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728090,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:34.857Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098546,
                        "gitlabId": 380098546,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728087,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:34.530Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098528,
                        "gitlabId": 380098528,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728088,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:34.639Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098504,
                        "gitlabId": 380098504,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728091,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:34.985Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098472,
                        "gitlabId": 380098472,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728093,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:35.072Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098416,
                        "gitlabId": 380098416,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728278,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:52.179Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098395,
                        "gitlabId": 380098395,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728280,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:52.349Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098381,
                        "gitlabId": 380098381,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728281,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:52.367Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098358,
                        "gitlabId": 380098358,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728282,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:52.487Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098333,
                        "gitlabId": 380098333,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728284,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:52.666Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098314,
                        "gitlabId": 380098314,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728283,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:52.646Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098278,
                        "gitlabId": 380098278,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728285,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:52.732Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098255,
                        "gitlabId": 380098255,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728288,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:53.031Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098239,
                        "gitlabId": 380098239,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728297,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:53.969Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098218,
                        "gitlabId": 380098218,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728286,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:52.948Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380098185,
                        "gitlabId": 380098185,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728287,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:52.993Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380097996,
                        "gitlabId": 380097996,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728292,
                            "isTestReportAvailable": false,
                            "duration": 64,
                            "duration_inMinutes": 1.07,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:53.525Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380066917,
                        "gitlabId": 380066917,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728290,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:53.269Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249778409,
                        "gitlabId": 249778409,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728291,
                            "isTestReportAvailable": false,
                            "duration": 118,
                            "duration_inMinutes": 1.97,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:53.463Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713729,
                        "gitlabId": 249713729,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728293,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:53.566Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713706,
                        "gitlabId": 249713706,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728294,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:53.570Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713683,
                        "gitlabId": 249713683,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728301,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:54.336Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713648,
                        "gitlabId": 249713648,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728298,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:54.067Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713615,
                        "gitlabId": 249713615,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728295,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:53.825Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713600,
                        "gitlabId": 249713600,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728296,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:53.868Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713570,
                        "gitlabId": 249713570,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728299,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:54.094Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713557,
                        "gitlabId": 249713557,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728300,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:54.121Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713543,
                        "gitlabId": 249713543,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728302,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:54.439Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713525,
                        "gitlabId": 249713525,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728305,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:54.570Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713504,
                        "gitlabId": 249713504,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728307,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:54.704Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713483,
                        "gitlabId": 249713483,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728304,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:54.567Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713462,
                        "gitlabId": 249713462,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728306,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:54.610Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713446,
                        "gitlabId": 249713446,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728308,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:54.725Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713420,
                        "gitlabId": 249713420,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728309,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:54.836Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713396,
                        "gitlabId": 249713396,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728310,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:54.842Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713368,
                        "gitlabId": 249713368,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728311,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:54.897Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713355,
                        "gitlabId": 249713355,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728312,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:54.984Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713331,
                        "gitlabId": 249713331,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728313,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:55.046Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713316,
                        "gitlabId": 249713316,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728332,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:56.386Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713297,
                        "gitlabId": 249713297,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728314,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:55.123Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713278,
                        "gitlabId": 249713278,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728316,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:55.302Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713258,
                        "gitlabId": 249713258,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728315,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:55.175Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713236,
                        "gitlabId": 249713236,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728317,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:55.305Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713219,
                        "gitlabId": 249713219,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728318,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:55.312Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249713192,
                        "gitlabId": 249713192,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728321,
                            "isTestReportAvailable": false,
                            "duration": 84,
                            "duration_inMinutes": 1.4,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:55.676Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247596329,
                        "gitlabId": 247596329,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728319,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:55.448Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247596311,
                        "gitlabId": 247596311,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728323,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:55.802Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247596296,
                        "gitlabId": 247596296,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728322,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:55.748Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247596272,
                        "gitlabId": 247596272,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728320,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:55.580Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247596259,
                        "gitlabId": 247596259,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728324,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:55.806Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247596234,
                        "gitlabId": 247596234,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728325,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:55.837Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247596202,
                        "gitlabId": 247596202,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728326,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:55.944Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247596177,
                        "gitlabId": 247596177,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728327,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:56.081Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247596170,
                        "gitlabId": 247596170,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728328,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:56.157Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247596155,
                        "gitlabId": 247596155,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728333,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:56.415Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247596132,
                        "gitlabId": 247596132,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728330,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:56.340Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247596118,
                        "gitlabId": 247596118,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728329,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:56.218Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247596096,
                        "gitlabId": 247596096,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728331,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:56.370Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247596064,
                        "gitlabId": 247596064,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728334,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:56.423Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247596043,
                        "gitlabId": 247596043,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728335,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:56.522Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247596016,
                        "gitlabId": 247596016,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728336,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:56.611Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247595991,
                        "gitlabId": 247595991,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728338,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:56.677Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247595977,
                        "gitlabId": 247595977,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728339,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:56.744Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247595940,
                        "gitlabId": 247595940,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728337,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:56.675Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247595921,
                        "gitlabId": 247595921,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728340,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:56.767Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247595896,
                        "gitlabId": 247595896,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728341,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:56.801Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247595880,
                        "gitlabId": 247595880,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728415,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:04:01.227Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247595864,
                        "gitlabId": 247595864,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728414,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:04:01.207Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247595845,
                        "gitlabId": 247595845,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728416,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:04:01.247Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247595828,
                        "gitlabId": 247595828,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728417,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:04:01.287Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247595803,
                        "gitlabId": 247595803,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728420,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:04:01.648Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225269031,
                        "gitlabId": 225269031,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728418,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:04:01.326Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225268992,
                        "gitlabId": 225268992,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728419,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:04:01.475Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225268966,
                        "gitlabId": 225268966,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728430,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:04:02.224Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225268946,
                        "gitlabId": 225268946,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728423,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:04:01.804Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225268924,
                        "gitlabId": 225268924,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728424,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:04:01.844Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225268903,
                        "gitlabId": 225268903,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728421,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:04:01.725Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225268880,
                        "gitlabId": 225268880,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728422,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:04:01.756Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225268861,
                        "gitlabId": 225268861,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728425,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:04:01.908Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225268841,
                        "gitlabId": 225268841,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728466,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:04:06.828Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225268815,
                        "gitlabId": 225268815,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728426,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:04:02.025Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225268802,
                        "gitlabId": 225268802,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728427,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:04:02.085Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225268774,
                        "gitlabId": 225268774,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728428,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:04:02.185Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225268737,
                        "gitlabId": 225268737,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728429,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:04:02.205Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225268708,
                        "gitlabId": 225268708,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728433,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:04:02.525Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225268679,
                        "gitlabId": 225268679,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728431,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:04:02.348Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29688,
                    "gitlabId": 8197594,
                    "name": "theCodeCampus"
                }
            },
            {
                "id": 13987821,
                "gitlabId": 13987821,
                "name": "thecodecampus-angular2.basic-slides",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/thecodecampus-angular2.basic-slides.git",
                "stats": {
                    "id": 29683,
                    "status": "success",
                    "numberOfPipelines": 81,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 191,
                    "averageDurationOfPipelines_inMinutes": 3.18,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 52,
                    "numberOfFailedPipelines": 24,
                    "numberOfCanceledPipelines": 1,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 4,
                    "pipelinesSuccessRatio": 64.2,
                    "totalRepoSize": "7979663",
                    "artifactsSize": "58138818"
                },
                "pipelines": [
                    {
                        "id": 460208601,
                        "gitlabId": 460208601,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728089,
                            "isTestReportAvailable": false,
                            "duration": 196,
                            "duration_inMinutes": 3.27,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:03:34.791Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 460207679,
                        "gitlabId": 460207679,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728095,
                            "isTestReportAvailable": false,
                            "duration": 190,
                            "duration_inMinutes": 3.17,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:03:35.210Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380047467,
                        "gitlabId": 380047467,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728092,
                            "isTestReportAvailable": false,
                            "duration": 224,
                            "duration_inMinutes": 3.73,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:35.054Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 249805417,
                        "gitlabId": 249805417,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728094,
                            "isTestReportAvailable": false,
                            "duration": 217,
                            "duration_inMinutes": 3.62,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:03:35.159Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247619874,
                        "gitlabId": 247619874,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728097,
                            "isTestReportAvailable": false,
                            "duration": 291,
                            "duration_inMinutes": 4.85,
                            "created_at": "Jan-27-21",
                            "created_at_rawDateFormat": "2021-01-27T07:03:35.401Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 239013736,
                        "gitlabId": 239013736,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728096,
                            "isTestReportAvailable": false,
                            "duration": 213,
                            "duration_inMinutes": 3.55,
                            "created_at": "Jan-08-21",
                            "created_at_rawDateFormat": "2021-01-08T07:03:35.349Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 238997855,
                        "gitlabId": 238997855,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728098,
                            "isTestReportAvailable": false,
                            "duration": 421,
                            "duration_inMinutes": 7.02,
                            "created_at": "Jan-08-21",
                            "created_at_rawDateFormat": "2021-01-08T07:03:35.467Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 238991798,
                        "gitlabId": 238991798,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728100,
                            "isTestReportAvailable": false,
                            "duration": 302,
                            "duration_inMinutes": 5.03,
                            "created_at": "Jan-08-21",
                            "created_at_rawDateFormat": "2021-01-08T07:03:35.502Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225218592,
                        "gitlabId": 225218592,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728099,
                            "isTestReportAvailable": false,
                            "duration": 317,
                            "duration_inMinutes": 5.28,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:03:35.473Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 225208473,
                        "gitlabId": 225208473,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728102,
                            "isTestReportAvailable": false,
                            "duration": 312,
                            "duration_inMinutes": 5.2,
                            "created_at": "Dec-04-20",
                            "created_at_rawDateFormat": "2020-12-04T07:03:35.617Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 207576120,
                        "gitlabId": 207576120,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728103,
                            "isTestReportAvailable": false,
                            "duration": 219,
                            "duration_inMinutes": 3.65,
                            "created_at": "Oct-26-20",
                            "created_at_rawDateFormat": "2020-10-26T07:03:35.707Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 207575770,
                        "gitlabId": 207575770,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728120,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Oct-26-20",
                            "created_at_rawDateFormat": "2020-10-26T07:03:37.117Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 207575764,
                        "gitlabId": 207575764,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728105,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Oct-26-20",
                            "created_at_rawDateFormat": "2020-10-26T07:03:35.814Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 204488733,
                        "gitlabId": 204488733,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728106,
                            "isTestReportAvailable": false,
                            "duration": 266,
                            "duration_inMinutes": 4.43,
                            "created_at": "Oct-19-20",
                            "created_at_rawDateFormat": "2020-10-19T07:03:35.850Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 202892988,
                        "gitlabId": 202892988,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728104,
                            "isTestReportAvailable": false,
                            "duration": 330,
                            "duration_inMinutes": 5.5,
                            "created_at": "Oct-15-20",
                            "created_at_rawDateFormat": "2020-10-15T07:03:35.774Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 202863274,
                        "gitlabId": 202863274,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728110,
                            "isTestReportAvailable": false,
                            "duration": 336,
                            "duration_inMinutes": 5.6,
                            "created_at": "Oct-15-20",
                            "created_at_rawDateFormat": "2020-10-15T07:03:36.343Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 202019075,
                        "gitlabId": 202019075,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728107,
                            "isTestReportAvailable": false,
                            "duration": 330,
                            "duration_inMinutes": 5.5,
                            "created_at": "Oct-13-20",
                            "created_at_rawDateFormat": "2020-10-13T07:03:36.025Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 202010938,
                        "gitlabId": 202010938,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728134,
                            "isTestReportAvailable": false,
                            "duration": 325,
                            "duration_inMinutes": 5.42,
                            "created_at": "Oct-13-20",
                            "created_at_rawDateFormat": "2020-10-13T07:03:37.953Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 182651603,
                        "gitlabId": 182651603,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728109,
                            "isTestReportAvailable": false,
                            "duration": 327,
                            "duration_inMinutes": 5.45,
                            "created_at": "Aug-27-20",
                            "created_at_rawDateFormat": "2020-08-27T07:03:36.339Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 143247624,
                        "gitlabId": 143247624,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728108,
                            "isTestReportAvailable": false,
                            "duration": 329,
                            "duration_inMinutes": 5.48,
                            "created_at": "May-06-20",
                            "created_at_rawDateFormat": "2020-05-06T07:03:36.285Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 139581235,
                        "gitlabId": 139581235,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728111,
                            "isTestReportAvailable": false,
                            "duration": 323,
                            "duration_inMinutes": 5.38,
                            "created_at": "Apr-24-20",
                            "created_at_rawDateFormat": "2020-04-24T07:03:36.384Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129091121,
                        "gitlabId": 129091121,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728112,
                            "isTestReportAvailable": false,
                            "duration": 271,
                            "duration_inMinutes": 4.52,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:03:36.575Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 127404337,
                        "gitlabId": 127404337,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728113,
                            "isTestReportAvailable": false,
                            "duration": 183,
                            "duration_inMinutes": 3.05,
                            "created_at": "Mar-18-20",
                            "created_at_rawDateFormat": "2020-03-18T07:03:36.596Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 126767304,
                        "gitlabId": 126767304,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728114,
                            "isTestReportAvailable": false,
                            "duration": 264,
                            "duration_inMinutes": 4.4,
                            "created_at": "Mar-16-20",
                            "created_at_rawDateFormat": "2020-03-16T07:03:36.631Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 126634500,
                        "gitlabId": 126634500,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728115,
                            "isTestReportAvailable": false,
                            "duration": 227,
                            "duration_inMinutes": 3.78,
                            "created_at": "Mar-16-20",
                            "created_at_rawDateFormat": "2020-03-16T07:03:36.665Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 96637128,
                        "gitlabId": 96637128,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728117,
                            "isTestReportAvailable": false,
                            "duration": 251,
                            "duration_inMinutes": 4.18,
                            "created_at": "Nov-18-19",
                            "created_at_rawDateFormat": "2019-11-18T07:03:36.879Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 96634087,
                        "gitlabId": 96634087,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728118,
                            "isTestReportAvailable": false,
                            "duration": 350,
                            "duration_inMinutes": 5.83,
                            "created_at": "Nov-18-19",
                            "created_at_rawDateFormat": "2019-11-18T07:03:36.915Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 92016044,
                        "gitlabId": 92016044,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728116,
                            "isTestReportAvailable": false,
                            "duration": 200,
                            "duration_inMinutes": 3.33,
                            "created_at": "Oct-28-19",
                            "created_at_rawDateFormat": "2019-10-28T07:03:36.873Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 92013020,
                        "gitlabId": 92013020,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728119,
                            "isTestReportAvailable": false,
                            "duration": 252,
                            "duration_inMinutes": 4.2,
                            "created_at": "Oct-28-19",
                            "created_at_rawDateFormat": "2019-10-28T07:03:36.939Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 86087801,
                        "gitlabId": 86087801,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728121,
                            "isTestReportAvailable": false,
                            "duration": 245,
                            "duration_inMinutes": 4.08,
                            "created_at": "Oct-02-19",
                            "created_at_rawDateFormat": "2019-10-02T07:03:37.136Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 86081453,
                        "gitlabId": 86081453,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728122,
                            "isTestReportAvailable": false,
                            "duration": 187,
                            "duration_inMinutes": 3.12,
                            "created_at": "Oct-02-19",
                            "created_at_rawDateFormat": "2019-10-02T07:03:37.208Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 85774992,
                        "gitlabId": 85774992,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728123,
                            "isTestReportAvailable": false,
                            "duration": 252,
                            "duration_inMinutes": 4.2,
                            "created_at": "Oct-01-19",
                            "created_at_rawDateFormat": "2019-10-01T07:03:37.264Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 85759917,
                        "gitlabId": 85759917,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728124,
                            "isTestReportAvailable": false,
                            "duration": 219,
                            "duration_inMinutes": 3.65,
                            "created_at": "Oct-01-19",
                            "created_at_rawDateFormat": "2019-10-01T07:03:37.310Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 85756909,
                        "gitlabId": 85756909,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728125,
                            "isTestReportAvailable": false,
                            "duration": 260,
                            "duration_inMinutes": 4.33,
                            "created_at": "Oct-01-19",
                            "created_at_rawDateFormat": "2019-10-01T07:03:37.362Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 85744764,
                        "gitlabId": 85744764,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728126,
                            "isTestReportAvailable": false,
                            "duration": 252,
                            "duration_inMinutes": 4.2,
                            "created_at": "Oct-01-19",
                            "created_at_rawDateFormat": "2019-10-01T07:03:37.407Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 85742026,
                        "gitlabId": 85742026,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728127,
                            "isTestReportAvailable": false,
                            "duration": 217,
                            "duration_inMinutes": 3.62,
                            "created_at": "Oct-01-19",
                            "created_at_rawDateFormat": "2019-10-01T07:03:37.475Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 85739100,
                        "gitlabId": 85739100,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728128,
                            "isTestReportAvailable": false,
                            "duration": 234,
                            "duration_inMinutes": 3.9,
                            "created_at": "Oct-01-19",
                            "created_at_rawDateFormat": "2019-10-01T07:03:37.515Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 85738251,
                        "gitlabId": 85738251,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728160,
                            "isTestReportAvailable": false,
                            "duration": 130,
                            "duration_inMinutes": 2.17,
                            "created_at": "Oct-01-19",
                            "created_at_rawDateFormat": "2019-10-01T07:03:40.892Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 85736366,
                        "gitlabId": 85736366,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728130,
                            "isTestReportAvailable": false,
                            "duration": 219,
                            "duration_inMinutes": 3.65,
                            "created_at": "Oct-01-19",
                            "created_at_rawDateFormat": "2019-10-01T07:03:37.696Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 85688525,
                        "gitlabId": 85688525,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728129,
                            "isTestReportAvailable": false,
                            "duration": 218,
                            "duration_inMinutes": 3.63,
                            "created_at": "Oct-01-19",
                            "created_at_rawDateFormat": "2019-10-01T07:03:37.685Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 85686290,
                        "gitlabId": 85686290,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728131,
                            "isTestReportAvailable": false,
                            "duration": 232,
                            "duration_inMinutes": 3.87,
                            "created_at": "Oct-01-19",
                            "created_at_rawDateFormat": "2019-10-01T07:03:37.743Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 85679309,
                        "gitlabId": 85679309,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728132,
                            "isTestReportAvailable": false,
                            "duration": 222,
                            "duration_inMinutes": 3.7,
                            "created_at": "Oct-01-19",
                            "created_at_rawDateFormat": "2019-10-01T07:03:37.769Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 85677260,
                        "gitlabId": 85677260,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728136,
                            "isTestReportAvailable": false,
                            "duration": 252,
                            "duration_inMinutes": 4.2,
                            "created_at": "Oct-01-19",
                            "created_at_rawDateFormat": "2019-10-01T07:03:38.198Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 84121936,
                        "gitlabId": 84121936,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728133,
                            "isTestReportAvailable": false,
                            "duration": 104,
                            "duration_inMinutes": 1.73,
                            "created_at": "Sep-24-19",
                            "created_at_rawDateFormat": "2019-09-24T07:03:37.952Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 84120919,
                        "gitlabId": 84120919,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728135,
                            "isTestReportAvailable": false,
                            "duration": 23,
                            "duration_inMinutes": 0.38,
                            "created_at": "Sep-24-19",
                            "created_at_rawDateFormat": "2019-09-24T07:03:38.047Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 84110961,
                        "gitlabId": 84110961,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728150,
                            "isTestReportAvailable": false,
                            "duration": 236,
                            "duration_inMinutes": 3.93,
                            "created_at": "Sep-24-19",
                            "created_at_rawDateFormat": "2019-09-24T07:03:39.325Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 84105369,
                        "gitlabId": 84105369,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728139,
                            "isTestReportAvailable": false,
                            "duration": 258,
                            "duration_inMinutes": 4.3,
                            "created_at": "Sep-24-19",
                            "created_at_rawDateFormat": "2019-09-24T07:03:38.364Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 84103425,
                        "gitlabId": 84103425,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728137,
                            "isTestReportAvailable": false,
                            "duration": 234,
                            "duration_inMinutes": 3.9,
                            "created_at": "Sep-24-19",
                            "created_at_rawDateFormat": "2019-09-24T07:03:38.246Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 84101643,
                        "gitlabId": 84101643,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728138,
                            "isTestReportAvailable": false,
                            "duration": 240,
                            "duration_inMinutes": 4,
                            "created_at": "Sep-24-19",
                            "created_at_rawDateFormat": "2019-09-24T07:03:38.322Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 84096185,
                        "gitlabId": 84096185,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728140,
                            "isTestReportAvailable": false,
                            "duration": 438,
                            "duration_inMinutes": 7.3,
                            "created_at": "Sep-24-19",
                            "created_at_rawDateFormat": "2019-09-24T07:03:38.463Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 84095323,
                        "gitlabId": 84095323,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728141,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-24-19",
                            "created_at_rawDateFormat": "2019-09-24T07:03:38.560Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 84093009,
                        "gitlabId": 84093009,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728142,
                            "isTestReportAvailable": false,
                            "duration": 147,
                            "duration_inMinutes": 2.45,
                            "created_at": "Sep-24-19",
                            "created_at_rawDateFormat": "2019-09-24T07:03:38.582Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 84090237,
                        "gitlabId": 84090237,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728143,
                            "isTestReportAvailable": false,
                            "duration": 115,
                            "duration_inMinutes": 1.92,
                            "created_at": "Sep-24-19",
                            "created_at_rawDateFormat": "2019-09-24T07:03:38.632Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 84088205,
                        "gitlabId": 84088205,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728144,
                            "isTestReportAvailable": false,
                            "duration": 220,
                            "duration_inMinutes": 3.67,
                            "created_at": "Sep-24-19",
                            "created_at_rawDateFormat": "2019-09-24T07:03:38.753Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 84084621,
                        "gitlabId": 84084621,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728146,
                            "isTestReportAvailable": false,
                            "duration": 245,
                            "duration_inMinutes": 4.08,
                            "created_at": "Sep-24-19",
                            "created_at_rawDateFormat": "2019-09-24T07:03:38.941Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 84074925,
                        "gitlabId": 84074925,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728145,
                            "isTestReportAvailable": false,
                            "duration": 266,
                            "duration_inMinutes": 4.43,
                            "created_at": "Sep-24-19",
                            "created_at_rawDateFormat": "2019-09-24T07:03:38.862Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 84074609,
                        "gitlabId": 84074609,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728147,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-24-19",
                            "created_at_rawDateFormat": "2019-09-24T07:03:39.004Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 81075095,
                        "gitlabId": 81075095,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728148,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Sep-09-19",
                            "created_at_rawDateFormat": "2019-09-09T07:03:39.084Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79090634,
                        "gitlabId": 79090634,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728153,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:03:39.384Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79089596,
                        "gitlabId": 79089596,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728152,
                            "isTestReportAvailable": false,
                            "duration": 241,
                            "duration_inMinutes": 4.02,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:03:39.362Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79087302,
                        "gitlabId": 79087302,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728149,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:03:39.278Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79086890,
                        "gitlabId": 79086890,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728151,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:03:39.342Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79080370,
                        "gitlabId": 79080370,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728165,
                            "isTestReportAvailable": false,
                            "duration": 287,
                            "duration_inMinutes": 4.78,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:03:41.443Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79076975,
                        "gitlabId": 79076975,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728154,
                            "isTestReportAvailable": false,
                            "duration": 265,
                            "duration_inMinutes": 4.42,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:03:39.601Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79075659,
                        "gitlabId": 79075659,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728167,
                            "isTestReportAvailable": false,
                            "duration": 253,
                            "duration_inMinutes": 4.22,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:03:41.704Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79075609,
                        "gitlabId": 79075609,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728156,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:03:39.772Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79074628,
                        "gitlabId": 79074628,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728155,
                            "isTestReportAvailable": false,
                            "duration": 238,
                            "duration_inMinutes": 3.97,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:03:39.637Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79074489,
                        "gitlabId": 79074489,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728157,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:03:40.757Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78409734,
                        "gitlabId": 78409734,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728158,
                            "isTestReportAvailable": false,
                            "duration": 287,
                            "duration_inMinutes": 4.78,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:03:40.813Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78404980,
                        "gitlabId": 78404980,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728159,
                            "isTestReportAvailable": false,
                            "duration": 339,
                            "duration_inMinutes": 5.65,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:03:40.883Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78404907,
                        "gitlabId": 78404907,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728161,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:03:41.084Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78404826,
                        "gitlabId": 78404826,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728166,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:03:41.693Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78400548,
                        "gitlabId": 78400548,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728163,
                            "isTestReportAvailable": false,
                            "duration": 254,
                            "duration_inMinutes": 4.23,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:03:41.236Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78398713,
                        "gitlabId": 78398713,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728162,
                            "isTestReportAvailable": false,
                            "duration": 153,
                            "duration_inMinutes": 2.55,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:03:41.179Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78398644,
                        "gitlabId": 78398644,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728342,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:03:56.914Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78398557,
                        "gitlabId": 78398557,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728343,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:03:56.967Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78398463,
                        "gitlabId": 78398463,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728345,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:03:57.013Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78396621,
                        "gitlabId": 78396621,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728344,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:03:56.990Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78396552,
                        "gitlabId": 78396552,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728346,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:03:57.031Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78396414,
                        "gitlabId": 78396414,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728347,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:03:57.058Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78396368,
                        "gitlabId": 78396368,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728348,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:03:57.186Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29691,
                    "gitlabId": 8197594,
                    "name": "theCodeCampus"
                }
            },
            {
                "id": 25893138,
                "gitlabId": 25893138,
                "name": "Typescript Solution Janik",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/typescript-solution-janik.git",
                "stats": {
                    "id": 29773,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "408944",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29784,
                    "gitlabId": 8197594,
                    "name": "theCodeCampus"
                }
            },
            {
                "id": 32791204,
                "gitlabId": 32791204,
                "name": "Intesive Testing",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/intesive-testing.git",
                "stats": {
                    "id": 29762,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "1929379",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29779,
                    "gitlabId": 8197594,
                    "name": "theCodeCampus"
                }
            },
            {
                "id": 15946245,
                "gitlabId": 15946245,
                "name": "TCC NestJS Server for Angular Basic",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/tcc-nestjs-server-for-angular-basic.git",
                "stats": {
                    "id": 29779,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "335544",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29776,
                    "gitlabId": 8197594,
                    "name": "theCodeCampus"
                }
            },
            {
                "id": 17163979,
                "gitlabId": 17163979,
                "name": "thecodecampus-typescript",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/thecodecampus-typescript.git",
                "stats": {
                    "id": 29757,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "723517",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29769,
                    "gitlabId": 8197594,
                    "name": "theCodeCampus"
                }
            },
            {
                "id": 21401434,
                "gitlabId": 21401434,
                "name": "testing-workshop",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/testing-workshop.git",
                "stats": {
                    "id": 29749,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "4844421",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29758,
                    "gitlabId": 8197594,
                    "name": "theCodeCampus"
                }
            },
            {
                "id": 22174225,
                "gitlabId": 22174225,
                "name": "thecodecampus-nestjs-slides",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/thecodecampus-nestjs-slides.git",
                "stats": {
                    "id": 29726,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "2160066",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29733,
                    "gitlabId": 8197594,
                    "name": "theCodeCampus"
                }
            },
            {
                "id": 33285745,
                "gitlabId": 33285745,
                "name": "On The Bleeding Edge",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/on-the-bleeding-edge.git",
                "stats": {
                    "id": 29734,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "0",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29742,
                    "gitlabId": 8197594,
                    "name": "theCodeCampus"
                }
            },
            {
                "id": 22174244,
                "gitlabId": 22174244,
                "name": "thecodecampus-nestjs-app",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/thecodecampus-nestjs-app.git",
                "stats": {
                    "id": 29738,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "775946",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29743,
                    "gitlabId": 8197594,
                    "name": "theCodeCampus"
                }
            }
        ],
        "subGroups": [
            {
                "id": 7629,
                "tempData": false,
                "gitlabId": 15960600,
                "name": "workshops"
            }
        ],
        "stats": {
            "id": 6707,
            "isThereSubgroups": true,
            "numberOfProjects": 5,
            "testCoverageOfAllProjects": null,
            "numberOfPipelines": 13,
            "numberOfTestReports": 0
        }
    },
    {
        "id": 6204426,
        "tempData": false,
        "gitlabId": 6204426,
        "name": "W11k Intern",
        "projects": [
            {
                "id": 21069994,
                "gitlabId": 21069994,
                "name": "GitLab-Stats",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/GitLab-Stats.git",
                "stats": {
                    "id": 29685,
                    "status": "success",
                    "numberOfPipelines": 74,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 728,
                    "averageDurationOfPipelines_inMinutes": 12.13,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 40,
                    "numberOfFailedPipelines": 27,
                    "numberOfCanceledPipelines": 7,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 54.05,
                    "totalRepoSize": "5599395",
                    "artifactsSize": "22238782"
                },
                "pipelines": [
                    {
                        "id": 491804770,
                        "gitlabId": 491804770,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728529,
                            "isTestReportAvailable": false,
                            "duration": 313,
                            "duration_inMinutes": 5.22,
                            "created_at": "Mar-14-22",
                            "created_at_rawDateFormat": "2022-03-14T07:04:13.446Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 491724845,
                        "gitlabId": 491724845,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728530,
                            "isTestReportAvailable": false,
                            "duration": 336,
                            "duration_inMinutes": 5.6,
                            "created_at": "Mar-14-22",
                            "created_at_rawDateFormat": "2022-03-14T07:04:13.626Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 491287451,
                        "gitlabId": 491287451,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728561,
                            "isTestReportAvailable": false,
                            "duration": 293,
                            "duration_inMinutes": 4.88,
                            "created_at": "Mar-14-22",
                            "created_at_rawDateFormat": "2022-03-14T07:04:16.969Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 488905057,
                        "gitlabId": 488905057,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728531,
                            "isTestReportAvailable": false,
                            "duration": 297,
                            "duration_inMinutes": 4.95,
                            "created_at": "Mar-10-22",
                            "created_at_rawDateFormat": "2022-03-10T07:04:13.967Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 484874221,
                        "gitlabId": 484874221,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728536,
                            "isTestReportAvailable": false,
                            "duration": 287,
                            "duration_inMinutes": 4.78,
                            "created_at": "Mar-04-22",
                            "created_at_rawDateFormat": "2022-03-04T07:04:14.721Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 484725984,
                        "gitlabId": 484725984,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728533,
                            "isTestReportAvailable": false,
                            "duration": 306,
                            "duration_inMinutes": 5.1,
                            "created_at": "Mar-04-22",
                            "created_at_rawDateFormat": "2022-03-04T07:04:14.461Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 424411839,
                        "gitlabId": 424411839,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728532,
                            "isTestReportAvailable": false,
                            "duration": 276,
                            "duration_inMinutes": 4.6,
                            "created_at": "Dec-07-21",
                            "created_at_rawDateFormat": "2021-12-07T07:04:14.223Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378704565,
                        "gitlabId": 378704565,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728535,
                            "isTestReportAvailable": false,
                            "duration": 313,
                            "duration_inMinutes": 5.22,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:04:14.687Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 349191956,
                        "gitlabId": 349191956,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728537,
                            "isTestReportAvailable": false,
                            "duration": 282,
                            "duration_inMinutes": 4.7,
                            "created_at": "Aug-06-21",
                            "created_at_rawDateFormat": "2021-08-06T07:04:14.744Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 348695788,
                        "gitlabId": 348695788,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728538,
                            "isTestReportAvailable": false,
                            "duration": 54,
                            "duration_inMinutes": 0.9,
                            "created_at": "Aug-05-21",
                            "created_at_rawDateFormat": "2021-08-05T07:04:14.758Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 348685953,
                        "gitlabId": 348685953,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728540,
                            "isTestReportAvailable": false,
                            "duration": 53,
                            "duration_inMinutes": 0.88,
                            "created_at": "Aug-05-21",
                            "created_at_rawDateFormat": "2021-08-05T07:04:15.003Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 348669215,
                        "gitlabId": 348669215,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728539,
                            "isTestReportAvailable": false,
                            "duration": 229,
                            "duration_inMinutes": 3.82,
                            "created_at": "Aug-05-21",
                            "created_at_rawDateFormat": "2021-08-05T07:04:14.985Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 348606683,
                        "gitlabId": 348606683,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728541,
                            "isTestReportAvailable": false,
                            "duration": 242,
                            "duration_inMinutes": 4.03,
                            "created_at": "Aug-05-21",
                            "created_at_rawDateFormat": "2021-08-05T07:04:15.076Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 329452225,
                        "gitlabId": 329452225,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728543,
                            "isTestReportAvailable": false,
                            "duration": 517,
                            "duration_inMinutes": 8.62,
                            "created_at": "Jun-30-21",
                            "created_at_rawDateFormat": "2021-06-30T07:04:15.438Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 321050784,
                        "gitlabId": 321050784,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728555,
                            "isTestReportAvailable": false,
                            "duration": 2593,
                            "duration_inMinutes": 43.22,
                            "created_at": "Jun-15-21",
                            "created_at_rawDateFormat": "2021-06-15T07:04:16.453Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 312778605,
                        "gitlabId": 312778605,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728544,
                            "isTestReportAvailable": false,
                            "duration": 2558,
                            "duration_inMinutes": 42.63,
                            "created_at": "Jun-01-21",
                            "created_at_rawDateFormat": "2021-06-01T07:04:15.641Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 311252558,
                        "gitlabId": 311252558,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728542,
                            "isTestReportAvailable": false,
                            "duration": 810,
                            "duration_inMinutes": 13.5,
                            "created_at": "May-28-21",
                            "created_at_rawDateFormat": "2021-05-28T07:04:15.406Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 311189107,
                        "gitlabId": 311189107,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728545,
                            "isTestReportAvailable": false,
                            "duration": 887,
                            "duration_inMinutes": 14.78,
                            "created_at": "May-28-21",
                            "created_at_rawDateFormat": "2021-05-28T07:04:15.680Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 309340207,
                        "gitlabId": 309340207,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728546,
                            "isTestReportAvailable": false,
                            "duration": 1127,
                            "duration_inMinutes": 18.78,
                            "created_at": "May-25-21",
                            "created_at_rawDateFormat": "2021-05-25T07:04:15.726Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 308598707,
                        "gitlabId": 308598707,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728547,
                            "isTestReportAvailable": false,
                            "duration": 1137,
                            "duration_inMinutes": 18.95,
                            "created_at": "May-24-21",
                            "created_at_rawDateFormat": "2021-05-24T07:04:15.904Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 293759404,
                        "gitlabId": 293759404,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728548,
                            "isTestReportAvailable": false,
                            "duration": 704,
                            "duration_inMinutes": 11.73,
                            "created_at": "Apr-28-21",
                            "created_at_rawDateFormat": "2021-04-28T07:04:15.980Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 293691236,
                        "gitlabId": 293691236,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728549,
                            "isTestReportAvailable": false,
                            "duration": 796,
                            "duration_inMinutes": 13.27,
                            "created_at": "Apr-28-21",
                            "created_at_rawDateFormat": "2021-04-28T07:04:16.006Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 293576336,
                        "gitlabId": 293576336,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728552,
                            "isTestReportAvailable": false,
                            "duration": 641,
                            "duration_inMinutes": 10.68,
                            "created_at": "Apr-28-21",
                            "created_at_rawDateFormat": "2021-04-28T07:04:16.297Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 293534746,
                        "gitlabId": 293534746,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728553,
                            "isTestReportAvailable": false,
                            "duration": 1040,
                            "duration_inMinutes": 17.33,
                            "created_at": "Apr-28-21",
                            "created_at_rawDateFormat": "2021-04-28T07:04:16.378Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 280699746,
                        "gitlabId": 280699746,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728551,
                            "isTestReportAvailable": false,
                            "duration": 789,
                            "duration_inMinutes": 13.15,
                            "created_at": "Apr-02-21",
                            "created_at_rawDateFormat": "2021-04-02T07:04:16.268Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 279428873,
                        "gitlabId": 279428873,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728554,
                            "isTestReportAvailable": false,
                            "duration": 918,
                            "duration_inMinutes": 15.3,
                            "created_at": "Mar-31-21",
                            "created_at_rawDateFormat": "2021-03-31T07:04:16.395Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 278377994,
                        "gitlabId": 278377994,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728556,
                            "isTestReportAvailable": false,
                            "duration": 1139,
                            "duration_inMinutes": 18.98,
                            "created_at": "Mar-29-21",
                            "created_at_rawDateFormat": "2021-03-29T07:04:16.610Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 277193002,
                        "gitlabId": 277193002,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728558,
                            "isTestReportAvailable": false,
                            "duration": 670,
                            "duration_inMinutes": 11.17,
                            "created_at": "Mar-26-21",
                            "created_at_rawDateFormat": "2021-03-26T07:04:16.855Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 260971839,
                        "gitlabId": 260971839,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728557,
                            "isTestReportAvailable": false,
                            "duration": 1927,
                            "duration_inMinutes": 32.12,
                            "created_at": "Feb-24-21",
                            "created_at_rawDateFormat": "2021-02-24T07:04:16.650Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 260963121,
                        "gitlabId": 260963121,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728559,
                            "isTestReportAvailable": false,
                            "duration": 1880,
                            "duration_inMinutes": 31.33,
                            "created_at": "Feb-24-21",
                            "created_at_rawDateFormat": "2021-02-24T07:04:16.900Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 260962515,
                        "gitlabId": 260962515,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728566,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-24-21",
                            "created_at_rawDateFormat": "2021-02-24T07:04:17.268Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 260961484,
                        "gitlabId": 260961484,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728562,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-24-21",
                            "created_at_rawDateFormat": "2021-02-24T07:04:17.064Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 258963242,
                        "gitlabId": 258963242,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728560,
                            "isTestReportAvailable": false,
                            "duration": 140,
                            "duration_inMinutes": 2.33,
                            "created_at": "Feb-19-21",
                            "created_at_rawDateFormat": "2021-02-19T07:04:16.914Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 258957706,
                        "gitlabId": 258957706,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728563,
                            "isTestReportAvailable": false,
                            "duration": 3790,
                            "duration_inMinutes": 63.17,
                            "created_at": "Feb-19-21",
                            "created_at_rawDateFormat": "2021-02-19T07:04:17.142Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 258953683,
                        "gitlabId": 258953683,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728564,
                            "isTestReportAvailable": false,
                            "duration": 3406,
                            "duration_inMinutes": 56.77,
                            "created_at": "Feb-19-21",
                            "created_at_rawDateFormat": "2021-02-19T07:04:17.157Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 258390859,
                        "gitlabId": 258390859,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728568,
                            "isTestReportAvailable": false,
                            "duration": 1330,
                            "duration_inMinutes": 22.17,
                            "created_at": "Feb-18-21",
                            "created_at_rawDateFormat": "2021-02-18T07:04:17.462Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 258372228,
                        "gitlabId": 258372228,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728565,
                            "isTestReportAvailable": false,
                            "duration": 185,
                            "duration_inMinutes": 3.08,
                            "created_at": "Feb-18-21",
                            "created_at_rawDateFormat": "2021-02-18T07:04:17.244Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 258167431,
                        "gitlabId": 258167431,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728567,
                            "isTestReportAvailable": false,
                            "duration": 2535,
                            "duration_inMinutes": 42.25,
                            "created_at": "Feb-18-21",
                            "created_at_rawDateFormat": "2021-02-18T07:04:17.332Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 257865919,
                        "gitlabId": 257865919,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728572,
                            "isTestReportAvailable": false,
                            "duration": 896,
                            "duration_inMinutes": 14.93,
                            "created_at": "Feb-18-21",
                            "created_at_rawDateFormat": "2021-02-18T07:04:17.586Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 257728996,
                        "gitlabId": 257728996,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728570,
                            "isTestReportAvailable": false,
                            "duration": 1257,
                            "duration_inMinutes": 20.95,
                            "created_at": "Feb-17-21",
                            "created_at_rawDateFormat": "2021-02-17T07:04:17.549Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 257684855,
                        "gitlabId": 257684855,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728569,
                            "isTestReportAvailable": false,
                            "duration": 1568,
                            "duration_inMinutes": 26.13,
                            "created_at": "Feb-17-21",
                            "created_at_rawDateFormat": "2021-02-17T07:04:17.515Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 257601653,
                        "gitlabId": 257601653,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728571,
                            "isTestReportAvailable": false,
                            "duration": 1368,
                            "duration_inMinutes": 22.8,
                            "created_at": "Feb-17-21",
                            "created_at_rawDateFormat": "2021-02-17T07:04:17.554Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 257597465,
                        "gitlabId": 257597465,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728582,
                            "isTestReportAvailable": false,
                            "duration": 1032,
                            "duration_inMinutes": 17.2,
                            "created_at": "Feb-17-21",
                            "created_at_rawDateFormat": "2021-02-17T07:04:18.361Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 257210842,
                        "gitlabId": 257210842,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728576,
                            "isTestReportAvailable": false,
                            "duration": 733,
                            "duration_inMinutes": 12.22,
                            "created_at": "Feb-16-21",
                            "created_at_rawDateFormat": "2021-02-16T07:04:17.928Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 257206543,
                        "gitlabId": 257206543,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728577,
                            "isTestReportAvailable": false,
                            "duration": 700,
                            "duration_inMinutes": 11.67,
                            "created_at": "Feb-16-21",
                            "created_at_rawDateFormat": "2021-02-16T07:04:18.065Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 257004665,
                        "gitlabId": 257004665,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728575,
                            "isTestReportAvailable": false,
                            "duration": 878,
                            "duration_inMinutes": 14.63,
                            "created_at": "Feb-16-21",
                            "created_at_rawDateFormat": "2021-02-16T07:04:17.896Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 256996554,
                        "gitlabId": 256996554,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728573,
                            "isTestReportAvailable": false,
                            "duration": 773,
                            "duration_inMinutes": 12.88,
                            "created_at": "Feb-16-21",
                            "created_at_rawDateFormat": "2021-02-16T07:04:17.812Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 256965893,
                        "gitlabId": 256965893,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728574,
                            "isTestReportAvailable": false,
                            "duration": 547,
                            "duration_inMinutes": 9.12,
                            "created_at": "Feb-16-21",
                            "created_at_rawDateFormat": "2021-02-16T07:04:17.865Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 256965089,
                        "gitlabId": 256965089,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728579,
                            "isTestReportAvailable": false,
                            "duration": 13,
                            "duration_inMinutes": 0.22,
                            "created_at": "Feb-16-21",
                            "created_at_rawDateFormat": "2021-02-16T07:04:18.155Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 256952627,
                        "gitlabId": 256952627,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728578,
                            "isTestReportAvailable": false,
                            "duration": 281,
                            "duration_inMinutes": 4.68,
                            "created_at": "Feb-16-21",
                            "created_at_rawDateFormat": "2021-02-16T07:04:18.133Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247091195,
                        "gitlabId": 247091195,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728580,
                            "isTestReportAvailable": false,
                            "duration": 273,
                            "duration_inMinutes": 4.55,
                            "created_at": "Jan-26-21",
                            "created_at_rawDateFormat": "2021-01-26T07:04:18.156Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 245662180,
                        "gitlabId": 245662180,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728583,
                            "isTestReportAvailable": false,
                            "duration": 354,
                            "duration_inMinutes": 5.9,
                            "created_at": "Jan-22-21",
                            "created_at_rawDateFormat": "2021-01-22T07:04:18.385Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 245539956,
                        "gitlabId": 245539956,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728581,
                            "isTestReportAvailable": false,
                            "duration": 552,
                            "duration_inMinutes": 9.2,
                            "created_at": "Jan-22-21",
                            "created_at_rawDateFormat": "2021-01-22T07:04:18.345Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 244577497,
                        "gitlabId": 244577497,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728584,
                            "isTestReportAvailable": false,
                            "duration": 564,
                            "duration_inMinutes": 9.4,
                            "created_at": "Jan-20-21",
                            "created_at_rawDateFormat": "2021-01-20T07:04:18.407Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 244568205,
                        "gitlabId": 244568205,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728585,
                            "isTestReportAvailable": false,
                            "duration": 598,
                            "duration_inMinutes": 9.97,
                            "created_at": "Jan-20-21",
                            "created_at_rawDateFormat": "2021-01-20T07:04:18.432Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235136193,
                        "gitlabId": 235136193,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728590,
                            "isTestReportAvailable": false,
                            "duration": 639,
                            "duration_inMinutes": 10.65,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:18.895Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235135419,
                        "gitlabId": 235135419,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728587,
                            "isTestReportAvailable": false,
                            "duration": 178,
                            "duration_inMinutes": 2.97,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:18.662Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235132696,
                        "gitlabId": 235132696,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728586,
                            "isTestReportAvailable": false,
                            "duration": 339,
                            "duration_inMinutes": 5.65,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:18.626Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235110445,
                        "gitlabId": 235110445,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728589,
                            "isTestReportAvailable": false,
                            "duration": 632,
                            "duration_inMinutes": 10.53,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:18.814Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235107015,
                        "gitlabId": 235107015,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728591,
                            "isTestReportAvailable": false,
                            "duration": 417,
                            "duration_inMinutes": 6.95,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:18.920Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235075774,
                        "gitlabId": 235075774,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728588,
                            "isTestReportAvailable": false,
                            "duration": 627,
                            "duration_inMinutes": 10.45,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:18.703Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235068916,
                        "gitlabId": 235068916,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728593,
                            "isTestReportAvailable": false,
                            "duration": 629,
                            "duration_inMinutes": 10.48,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:19.066Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235064087,
                        "gitlabId": 235064087,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728592,
                            "isTestReportAvailable": false,
                            "duration": 460,
                            "duration_inMinutes": 7.67,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:19.030Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235060643,
                        "gitlabId": 235060643,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728600,
                            "isTestReportAvailable": false,
                            "duration": 682,
                            "duration_inMinutes": 11.37,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:19.496Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235056304,
                        "gitlabId": 235056304,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728596,
                            "isTestReportAvailable": false,
                            "duration": 500,
                            "duration_inMinutes": 8.33,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:19.277Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235056165,
                        "gitlabId": 235056165,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728594,
                            "isTestReportAvailable": false,
                            "duration": 37,
                            "duration_inMinutes": 0.62,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:19.163Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235055686,
                        "gitlabId": 235055686,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728595,
                            "isTestReportAvailable": false,
                            "duration": 111,
                            "duration_inMinutes": 1.85,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:19.189Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235055349,
                        "gitlabId": 235055349,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728597,
                            "isTestReportAvailable": false,
                            "duration": 191,
                            "duration_inMinutes": 3.18,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:19.281Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235053305,
                        "gitlabId": 235053305,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728598,
                            "isTestReportAvailable": false,
                            "duration": 215,
                            "duration_inMinutes": 3.58,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:19.338Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235051340,
                        "gitlabId": 235051340,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728603,
                            "isTestReportAvailable": false,
                            "duration": 265,
                            "duration_inMinutes": 4.42,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:19.703Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235044501,
                        "gitlabId": 235044501,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728599,
                            "isTestReportAvailable": false,
                            "duration": 166,
                            "duration_inMinutes": 2.77,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:19.463Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235041749,
                        "gitlabId": 235041749,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728602,
                            "isTestReportAvailable": false,
                            "duration": 174,
                            "duration_inMinutes": 2.9,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:19.558Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235041203,
                        "gitlabId": 235041203,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728601,
                            "isTestReportAvailable": false,
                            "duration": 139,
                            "duration_inMinutes": 2.32,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:19.540Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235037647,
                        "gitlabId": 235037647,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728626,
                            "isTestReportAvailable": false,
                            "duration": 275,
                            "duration_inMinutes": 4.58,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:04:22.596Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29690,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 11175446,
                "gitlabId": 11175446,
                "name": "cocktail",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/cocktail.git",
                "stats": {
                    "id": 29686,
                    "status": "success",
                    "numberOfPipelines": 97,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": true,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 398,
                    "averageDurationOfPipelines_inMinutes": 6.63,
                    "testCoverage": 74.9,
                    "numberOfSuccessfulPipelines": 25,
                    "numberOfFailedPipelines": 67,
                    "numberOfCanceledPipelines": 5,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 25.77,
                    "totalRepoSize": "9741271",
                    "artifactsSize": "108991333"
                },
                "pipelines": [
                    {
                        "id": 486895395,
                        "gitlabId": 486895395,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728607,
                            "isTestReportAvailable": false,
                            "duration": 723,
                            "duration_inMinutes": 12.05,
                            "created_at": "Mar-08-22",
                            "created_at_rawDateFormat": "2022-03-08T07:04:19.880Z",
                            "testCoverage": 74.9
                        }
                    },
                    {
                        "id": 483735426,
                        "gitlabId": 483735426,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728604,
                            "isTestReportAvailable": false,
                            "duration": 678,
                            "duration_inMinutes": 11.3,
                            "created_at": "Mar-03-22",
                            "created_at_rawDateFormat": "2022-03-03T07:04:19.766Z",
                            "testCoverage": 74.9
                        }
                    },
                    {
                        "id": 474369497,
                        "gitlabId": 474369497,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728605,
                            "isTestReportAvailable": false,
                            "duration": 764,
                            "duration_inMinutes": 12.73,
                            "created_at": "Feb-18-22",
                            "created_at_rawDateFormat": "2022-02-18T07:04:19.796Z",
                            "testCoverage": 74.9
                        }
                    },
                    {
                        "id": 474367214,
                        "gitlabId": 474367214,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728606,
                            "isTestReportAvailable": false,
                            "duration": 331,
                            "duration_inMinutes": 5.52,
                            "created_at": "Feb-18-22",
                            "created_at_rawDateFormat": "2022-02-18T07:04:19.825Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 474366992,
                        "gitlabId": 474366992,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728614,
                            "isTestReportAvailable": false,
                            "duration": 350,
                            "duration_inMinutes": 5.83,
                            "created_at": "Feb-18-22",
                            "created_at_rawDateFormat": "2022-02-18T07:04:21.024Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 474353040,
                        "gitlabId": 474353040,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728627,
                            "isTestReportAvailable": false,
                            "duration": 629,
                            "duration_inMinutes": 10.48,
                            "created_at": "Feb-18-22",
                            "created_at_rawDateFormat": "2022-02-18T07:04:22.707Z",
                            "testCoverage": 74.9
                        }
                    },
                    {
                        "id": 474318667,
                        "gitlabId": 474318667,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728608,
                            "isTestReportAvailable": false,
                            "duration": 547,
                            "duration_inMinutes": 9.12,
                            "created_at": "Feb-18-22",
                            "created_at_rawDateFormat": "2022-02-18T07:04:20.042Z",
                            "testCoverage": 74.9
                        }
                    },
                    {
                        "id": 474034756,
                        "gitlabId": 474034756,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728609,
                            "isTestReportAvailable": false,
                            "duration": 752,
                            "duration_inMinutes": 12.53,
                            "created_at": "Feb-18-22",
                            "created_at_rawDateFormat": "2022-02-18T07:04:20.078Z",
                            "testCoverage": 74.9
                        }
                    },
                    {
                        "id": 474033961,
                        "gitlabId": 474033961,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728610,
                            "isTestReportAvailable": false,
                            "duration": 670,
                            "duration_inMinutes": 11.17,
                            "created_at": "Feb-18-22",
                            "created_at_rawDateFormat": "2022-02-18T07:04:20.153Z",
                            "testCoverage": 74.9
                        }
                    },
                    {
                        "id": 473767144,
                        "gitlabId": 473767144,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728612,
                            "isTestReportAvailable": false,
                            "duration": 569,
                            "duration_inMinutes": 9.48,
                            "created_at": "Feb-17-22",
                            "created_at_rawDateFormat": "2022-02-17T07:04:20.815Z",
                            "testCoverage": 74.9
                        }
                    },
                    {
                        "id": 473764954,
                        "gitlabId": 473764954,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728617,
                            "isTestReportAvailable": false,
                            "duration": 264,
                            "duration_inMinutes": 4.4,
                            "created_at": "Feb-17-22",
                            "created_at_rawDateFormat": "2022-02-17T07:04:21.277Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 473762999,
                        "gitlabId": 473762999,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728611,
                            "isTestReportAvailable": false,
                            "duration": 346,
                            "duration_inMinutes": 5.77,
                            "created_at": "Feb-17-22",
                            "created_at_rawDateFormat": "2022-02-17T07:04:20.426Z",
                            "testCoverage": 72.3
                        }
                    },
                    {
                        "id": 473715807,
                        "gitlabId": 473715807,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728613,
                            "isTestReportAvailable": false,
                            "duration": 557,
                            "duration_inMinutes": 9.28,
                            "created_at": "Feb-17-22",
                            "created_at_rawDateFormat": "2022-02-17T07:04:20.886Z",
                            "testCoverage": 75.22
                        }
                    },
                    {
                        "id": 473705353,
                        "gitlabId": 473705353,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728615,
                            "isTestReportAvailable": false,
                            "duration": 538,
                            "duration_inMinutes": 8.97,
                            "created_at": "Feb-17-22",
                            "created_at_rawDateFormat": "2022-02-17T07:04:21.093Z",
                            "testCoverage": 75.22
                        }
                    },
                    {
                        "id": 468359208,
                        "gitlabId": 468359208,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728616,
                            "isTestReportAvailable": false,
                            "duration": 511,
                            "duration_inMinutes": 8.52,
                            "created_at": "Feb-10-22",
                            "created_at_rawDateFormat": "2022-02-10T07:04:21.134Z",
                            "testCoverage": 75.12
                        }
                    },
                    {
                        "id": 468355233,
                        "gitlabId": 468355233,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728618,
                            "isTestReportAvailable": false,
                            "duration": 406,
                            "duration_inMinutes": 6.77,
                            "created_at": "Feb-10-22",
                            "created_at_rawDateFormat": "2022-02-10T07:04:21.279Z",
                            "testCoverage": 75.12
                        }
                    },
                    {
                        "id": 468353503,
                        "gitlabId": 468353503,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728619,
                            "isTestReportAvailable": false,
                            "duration": 119,
                            "duration_inMinutes": 1.98,
                            "created_at": "Feb-10-22",
                            "created_at_rawDateFormat": "2022-02-10T07:04:21.338Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 468352917,
                        "gitlabId": 468352917,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728620,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-10-22",
                            "created_at_rawDateFormat": "2022-02-10T07:04:21.373Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 468346092,
                        "gitlabId": 468346092,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728621,
                            "isTestReportAvailable": false,
                            "duration": 384,
                            "duration_inMinutes": 6.4,
                            "created_at": "Feb-10-22",
                            "created_at_rawDateFormat": "2022-02-10T07:04:21.577Z",
                            "testCoverage": 75.12
                        }
                    },
                    {
                        "id": 468337389,
                        "gitlabId": 468337389,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728623,
                            "isTestReportAvailable": false,
                            "duration": 119,
                            "duration_inMinutes": 1.98,
                            "created_at": "Feb-10-22",
                            "created_at_rawDateFormat": "2022-02-10T07:04:21.612Z",
                            "testCoverage": 74.14
                        }
                    },
                    {
                        "id": 468317722,
                        "gitlabId": 468317722,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728622,
                            "isTestReportAvailable": false,
                            "duration": 456,
                            "duration_inMinutes": 7.6,
                            "created_at": "Feb-10-22",
                            "created_at_rawDateFormat": "2022-02-10T07:04:21.598Z",
                            "testCoverage": 75.12
                        }
                    },
                    {
                        "id": 468312115,
                        "gitlabId": 468312115,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728666,
                            "isTestReportAvailable": false,
                            "duration": 350,
                            "duration_inMinutes": 5.83,
                            "created_at": "Feb-10-22",
                            "created_at_rawDateFormat": "2022-02-10T07:04:26.039Z",
                            "testCoverage": 75.15
                        }
                    },
                    {
                        "id": 468308156,
                        "gitlabId": 468308156,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728628,
                            "isTestReportAvailable": false,
                            "duration": 132,
                            "duration_inMinutes": 2.2,
                            "created_at": "Feb-10-22",
                            "created_at_rawDateFormat": "2022-02-10T07:04:22.786Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 468305353,
                        "gitlabId": 468305353,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728624,
                            "isTestReportAvailable": false,
                            "duration": 92,
                            "duration_inMinutes": 1.53,
                            "created_at": "Feb-10-22",
                            "created_at_rawDateFormat": "2022-02-10T07:04:21.880Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 468301357,
                        "gitlabId": 468301357,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728625,
                            "isTestReportAvailable": false,
                            "duration": 10,
                            "duration_inMinutes": 0.17,
                            "created_at": "Feb-10-22",
                            "created_at_rawDateFormat": "2022-02-10T07:04:21.892Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 468299658,
                        "gitlabId": 468299658,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728632,
                            "isTestReportAvailable": false,
                            "duration": 11,
                            "duration_inMinutes": 0.18,
                            "created_at": "Feb-10-22",
                            "created_at_rawDateFormat": "2022-02-10T07:04:23.171Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 258412125,
                        "gitlabId": 258412125,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728629,
                            "isTestReportAvailable": false,
                            "duration": 587,
                            "duration_inMinutes": 9.78,
                            "created_at": "Feb-18-21",
                            "created_at_rawDateFormat": "2021-02-18T07:04:22.855Z",
                            "testCoverage": 77.4
                        }
                    },
                    {
                        "id": 258406441,
                        "gitlabId": 258406441,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728630,
                            "isTestReportAvailable": false,
                            "duration": 819,
                            "duration_inMinutes": 13.65,
                            "created_at": "Feb-18-21",
                            "created_at_rawDateFormat": "2021-02-18T07:04:22.981Z",
                            "testCoverage": 92.74
                        }
                    },
                    {
                        "id": 258405329,
                        "gitlabId": 258405329,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728636,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-18-21",
                            "created_at_rawDateFormat": "2021-02-18T07:04:23.573Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 258403059,
                        "gitlabId": 258403059,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728634,
                            "isTestReportAvailable": false,
                            "duration": 286,
                            "duration_inMinutes": 4.77,
                            "created_at": "Feb-18-21",
                            "created_at_rawDateFormat": "2021-02-18T07:04:23.298Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 258402392,
                        "gitlabId": 258402392,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728631,
                            "isTestReportAvailable": false,
                            "duration": 80,
                            "duration_inMinutes": 1.33,
                            "created_at": "Feb-18-21",
                            "created_at_rawDateFormat": "2021-02-18T07:04:23.130Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 258399644,
                        "gitlabId": 258399644,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728633,
                            "isTestReportAvailable": false,
                            "duration": 196,
                            "duration_inMinutes": 3.27,
                            "created_at": "Feb-18-21",
                            "created_at_rawDateFormat": "2021-02-18T07:04:23.277Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 258389172,
                        "gitlabId": 258389172,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728635,
                            "isTestReportAvailable": false,
                            "duration": 180,
                            "duration_inMinutes": 3,
                            "created_at": "Feb-18-21",
                            "created_at_rawDateFormat": "2021-02-18T07:04:23.407Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 220524085,
                        "gitlabId": 220524085,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728638,
                            "isTestReportAvailable": false,
                            "duration": 904,
                            "duration_inMinutes": 15.07,
                            "created_at": "Nov-24-20",
                            "created_at_rawDateFormat": "2020-11-24T07:04:23.606Z",
                            "testCoverage": 74.14
                        }
                    },
                    {
                        "id": 220512166,
                        "gitlabId": 220512166,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728640,
                            "isTestReportAvailable": false,
                            "duration": 1500,
                            "duration_inMinutes": 25,
                            "created_at": "Nov-24-20",
                            "created_at_rawDateFormat": "2020-11-24T07:04:23.729Z",
                            "testCoverage": 74.14
                        }
                    },
                    {
                        "id": 214117096,
                        "gitlabId": 214117096,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728637,
                            "isTestReportAvailable": false,
                            "duration": 1515,
                            "duration_inMinutes": 25.25,
                            "created_at": "Nov-10-20",
                            "created_at_rawDateFormat": "2020-11-10T07:04:23.579Z",
                            "testCoverage": 74.12
                        }
                    },
                    {
                        "id": 214045254,
                        "gitlabId": 214045254,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728639,
                            "isTestReportAvailable": false,
                            "duration": 1908,
                            "duration_inMinutes": 31.8,
                            "created_at": "Nov-10-20",
                            "created_at_rawDateFormat": "2020-11-10T07:04:23.696Z",
                            "testCoverage": 74.12
                        }
                    },
                    {
                        "id": 214033774,
                        "gitlabId": 214033774,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728641,
                            "isTestReportAvailable": false,
                            "duration": 3,
                            "duration_inMinutes": 0.05,
                            "created_at": "Nov-10-20",
                            "created_at_rawDateFormat": "2020-11-10T07:04:23.876Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 214028001,
                        "gitlabId": 214028001,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728648,
                            "isTestReportAvailable": false,
                            "duration": 507,
                            "duration_inMinutes": 8.45,
                            "created_at": "Nov-10-20",
                            "created_at_rawDateFormat": "2020-11-10T07:04:24.478Z",
                            "testCoverage": 74.12
                        }
                    },
                    {
                        "id": 214024056,
                        "gitlabId": 214024056,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728643,
                            "isTestReportAvailable": false,
                            "duration": 526,
                            "duration_inMinutes": 8.77,
                            "created_at": "Nov-10-20",
                            "created_at_rawDateFormat": "2020-11-10T07:04:23.979Z",
                            "testCoverage": 74.12
                        }
                    },
                    {
                        "id": 214023221,
                        "gitlabId": 214023221,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728642,
                            "isTestReportAvailable": false,
                            "duration": 552,
                            "duration_inMinutes": 9.2,
                            "created_at": "Nov-10-20",
                            "created_at_rawDateFormat": "2020-11-10T07:04:23.965Z",
                            "testCoverage": 74.12
                        }
                    },
                    {
                        "id": 206285176,
                        "gitlabId": 206285176,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728649,
                            "isTestReportAvailable": false,
                            "duration": 731,
                            "duration_inMinutes": 12.18,
                            "created_at": "Oct-22-20",
                            "created_at_rawDateFormat": "2020-10-22T07:04:24.528Z",
                            "testCoverage": 74.12
                        }
                    },
                    {
                        "id": 206279998,
                        "gitlabId": 206279998,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728644,
                            "isTestReportAvailable": false,
                            "duration": 608,
                            "duration_inMinutes": 10.13,
                            "created_at": "Oct-22-20",
                            "created_at_rawDateFormat": "2020-10-22T07:04:24.141Z",
                            "testCoverage": 74.12
                        }
                    },
                    {
                        "id": 206249621,
                        "gitlabId": 206249621,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728645,
                            "isTestReportAvailable": false,
                            "duration": 735,
                            "duration_inMinutes": 12.25,
                            "created_at": "Oct-22-20",
                            "created_at_rawDateFormat": "2020-10-22T07:04:24.221Z",
                            "testCoverage": 74.12
                        }
                    },
                    {
                        "id": 201289276,
                        "gitlabId": 201289276,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728646,
                            "isTestReportAvailable": false,
                            "duration": 670,
                            "duration_inMinutes": 11.17,
                            "created_at": "Oct-12-20",
                            "created_at_rawDateFormat": "2020-10-12T07:04:24.249Z",
                            "testCoverage": 74.12
                        }
                    },
                    {
                        "id": 180038869,
                        "gitlabId": 180038869,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728647,
                            "isTestReportAvailable": false,
                            "duration": 285,
                            "duration_inMinutes": 4.75,
                            "created_at": "Aug-20-20",
                            "created_at_rawDateFormat": "2020-08-20T07:04:24.430Z",
                            "testCoverage": 61.23
                        }
                    },
                    {
                        "id": 164758456,
                        "gitlabId": 164758456,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728650,
                            "isTestReportAvailable": false,
                            "duration": 272,
                            "duration_inMinutes": 4.53,
                            "created_at": "Jul-09-20",
                            "created_at_rawDateFormat": "2020-07-09T07:04:24.577Z",
                            "testCoverage": 61.25
                        }
                    },
                    {
                        "id": 164758353,
                        "gitlabId": 164758353,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728651,
                            "isTestReportAvailable": false,
                            "duration": 99,
                            "duration_inMinutes": 1.65,
                            "created_at": "Jul-09-20",
                            "created_at_rawDateFormat": "2020-07-09T07:04:24.713Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 157097343,
                        "gitlabId": 157097343,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728669,
                            "isTestReportAvailable": false,
                            "duration": 101,
                            "duration_inMinutes": 1.68,
                            "created_at": "Jun-17-20",
                            "created_at_rawDateFormat": "2020-06-17T07:04:26.323Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 157074941,
                        "gitlabId": 157074941,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728652,
                            "isTestReportAvailable": false,
                            "duration": 275,
                            "duration_inMinutes": 4.58,
                            "created_at": "Jun-17-20",
                            "created_at_rawDateFormat": "2020-06-17T07:04:24.768Z",
                            "testCoverage": 61.04
                        }
                    },
                    {
                        "id": 154716078,
                        "gitlabId": 154716078,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728653,
                            "isTestReportAvailable": false,
                            "duration": 313,
                            "duration_inMinutes": 5.22,
                            "created_at": "Jun-10-20",
                            "created_at_rawDateFormat": "2020-06-10T07:04:24.801Z",
                            "testCoverage": 63.7
                        }
                    },
                    {
                        "id": 154701161,
                        "gitlabId": 154701161,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728654,
                            "isTestReportAvailable": false,
                            "duration": 307,
                            "duration_inMinutes": 5.12,
                            "created_at": "Jun-10-20",
                            "created_at_rawDateFormat": "2020-06-10T07:04:24.836Z",
                            "testCoverage": 63.7
                        }
                    },
                    {
                        "id": 142730870,
                        "gitlabId": 142730870,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728655,
                            "isTestReportAvailable": false,
                            "duration": 732,
                            "duration_inMinutes": 12.2,
                            "created_at": "May-05-20",
                            "created_at_rawDateFormat": "2020-05-05T07:04:25.000Z",
                            "testCoverage": 73.82
                        }
                    },
                    {
                        "id": 142330827,
                        "gitlabId": 142330827,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728662,
                            "isTestReportAvailable": false,
                            "duration": 620,
                            "duration_inMinutes": 10.33,
                            "created_at": "May-04-20",
                            "created_at_rawDateFormat": "2020-05-04T07:04:25.775Z",
                            "testCoverage": 73.82
                        }
                    },
                    {
                        "id": 142274733,
                        "gitlabId": 142274733,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728656,
                            "isTestReportAvailable": false,
                            "duration": 732,
                            "duration_inMinutes": 12.2,
                            "created_at": "May-04-20",
                            "created_at_rawDateFormat": "2020-05-04T07:04:25.069Z",
                            "testCoverage": 74
                        }
                    },
                    {
                        "id": 142272654,
                        "gitlabId": 142272654,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728657,
                            "isTestReportAvailable": false,
                            "duration": 637,
                            "duration_inMinutes": 10.62,
                            "created_at": "May-04-20",
                            "created_at_rawDateFormat": "2020-05-04T07:04:25.274Z",
                            "testCoverage": 74
                        }
                    },
                    {
                        "id": 141478801,
                        "gitlabId": 141478801,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728660,
                            "isTestReportAvailable": false,
                            "duration": 701,
                            "duration_inMinutes": 11.68,
                            "created_at": "Apr-30-20",
                            "created_at_rawDateFormat": "2020-04-30T07:04:25.562Z",
                            "testCoverage": 73.5
                        }
                    },
                    {
                        "id": 141462350,
                        "gitlabId": 141462350,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728658,
                            "isTestReportAvailable": false,
                            "duration": 323,
                            "duration_inMinutes": 5.38,
                            "created_at": "Apr-30-20",
                            "created_at_rawDateFormat": "2020-04-30T07:04:25.334Z",
                            "testCoverage": 69.68
                        }
                    },
                    {
                        "id": 141432900,
                        "gitlabId": 141432900,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728659,
                            "isTestReportAvailable": false,
                            "duration": 282,
                            "duration_inMinutes": 4.7,
                            "created_at": "Apr-30-20",
                            "created_at_rawDateFormat": "2020-04-30T07:04:25.531Z",
                            "testCoverage": 68.33
                        }
                    },
                    {
                        "id": 141389022,
                        "gitlabId": 141389022,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728661,
                            "isTestReportAvailable": false,
                            "duration": 310,
                            "duration_inMinutes": 5.17,
                            "created_at": "Apr-30-20",
                            "created_at_rawDateFormat": "2020-04-30T07:04:25.597Z",
                            "testCoverage": 68.71
                        }
                    },
                    {
                        "id": 141376951,
                        "gitlabId": 141376951,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728663,
                            "isTestReportAvailable": false,
                            "duration": 292,
                            "duration_inMinutes": 4.87,
                            "created_at": "Apr-30-20",
                            "created_at_rawDateFormat": "2020-04-30T07:04:25.793Z",
                            "testCoverage": 68.71
                        }
                    },
                    {
                        "id": 141031108,
                        "gitlabId": 141031108,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728664,
                            "isTestReportAvailable": false,
                            "duration": 291,
                            "duration_inMinutes": 4.85,
                            "created_at": "Apr-29-20",
                            "created_at_rawDateFormat": "2020-04-29T07:04:25.876Z",
                            "testCoverage": 68.71
                        }
                    },
                    {
                        "id": 141030832,
                        "gitlabId": 141030832,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728670,
                            "isTestReportAvailable": false,
                            "duration": 286,
                            "duration_inMinutes": 4.77,
                            "created_at": "Apr-29-20",
                            "created_at_rawDateFormat": "2020-04-29T07:04:26.329Z",
                            "testCoverage": 68.71
                        }
                    },
                    {
                        "id": 141025813,
                        "gitlabId": 141025813,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728665,
                            "isTestReportAvailable": false,
                            "duration": 287,
                            "duration_inMinutes": 4.78,
                            "created_at": "Apr-29-20",
                            "created_at_rawDateFormat": "2020-04-29T07:04:26.035Z",
                            "testCoverage": 68.71
                        }
                    },
                    {
                        "id": 140986922,
                        "gitlabId": 140986922,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728667,
                            "isTestReportAvailable": false,
                            "duration": 272,
                            "duration_inMinutes": 4.53,
                            "created_at": "Apr-29-20",
                            "created_at_rawDateFormat": "2020-04-29T07:04:26.078Z",
                            "testCoverage": 67.62
                        }
                    },
                    {
                        "id": 140932989,
                        "gitlabId": 140932989,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728668,
                            "isTestReportAvailable": false,
                            "duration": 106,
                            "duration_inMinutes": 1.77,
                            "created_at": "Apr-29-20",
                            "created_at_rawDateFormat": "2020-04-29T07:04:26.204Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 140659707,
                        "gitlabId": 140659707,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728673,
                            "isTestReportAvailable": false,
                            "duration": 99,
                            "duration_inMinutes": 1.65,
                            "created_at": "Apr-28-20",
                            "created_at_rawDateFormat": "2020-04-28T07:04:26.472Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 140618293,
                        "gitlabId": 140618293,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728672,
                            "isTestReportAvailable": false,
                            "duration": 108,
                            "duration_inMinutes": 1.8,
                            "created_at": "Apr-28-20",
                            "created_at_rawDateFormat": "2020-04-28T07:04:26.374Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 138286925,
                        "gitlabId": 138286925,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728671,
                            "isTestReportAvailable": false,
                            "duration": 106,
                            "duration_inMinutes": 1.77,
                            "created_at": "Apr-21-20",
                            "created_at_rawDateFormat": "2020-04-21T07:04:26.359Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 138251996,
                        "gitlabId": 138251996,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728715,
                            "isTestReportAvailable": false,
                            "duration": 103,
                            "duration_inMinutes": 1.72,
                            "created_at": "Apr-21-20",
                            "created_at_rawDateFormat": "2020-04-21T07:04:29.302Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130377690,
                        "gitlabId": 130377690,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728675,
                            "isTestReportAvailable": false,
                            "duration": 104,
                            "duration_inMinutes": 1.73,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:26.596Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130359053,
                        "gitlabId": 130359053,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728674,
                            "isTestReportAvailable": false,
                            "duration": 112,
                            "duration_inMinutes": 1.87,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:26.595Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 127712060,
                        "gitlabId": 127712060,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728677,
                            "isTestReportAvailable": false,
                            "duration": 296,
                            "duration_inMinutes": 4.93,
                            "created_at": "Mar-19-20",
                            "created_at_rawDateFormat": "2020-03-19T07:04:26.859Z",
                            "testCoverage": 74.62
                        }
                    },
                    {
                        "id": 127679820,
                        "gitlabId": 127679820,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728676,
                            "isTestReportAvailable": false,
                            "duration": 287,
                            "duration_inMinutes": 4.78,
                            "created_at": "Mar-19-20",
                            "created_at_rawDateFormat": "2020-03-19T07:04:26.656Z",
                            "testCoverage": 74.62
                        }
                    },
                    {
                        "id": 126960164,
                        "gitlabId": 126960164,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728679,
                            "isTestReportAvailable": false,
                            "duration": 108,
                            "duration_inMinutes": 1.8,
                            "created_at": "Mar-17-20",
                            "created_at_rawDateFormat": "2020-03-17T07:04:26.995Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 126952911,
                        "gitlabId": 126952911,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728678,
                            "isTestReportAvailable": false,
                            "duration": 307,
                            "duration_inMinutes": 5.12,
                            "created_at": "Mar-17-20",
                            "created_at_rawDateFormat": "2020-03-17T07:04:26.865Z",
                            "testCoverage": 74.52
                        }
                    },
                    {
                        "id": 126950768,
                        "gitlabId": 126950768,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728680,
                            "isTestReportAvailable": false,
                            "duration": 99,
                            "duration_inMinutes": 1.65,
                            "created_at": "Mar-17-20",
                            "created_at_rawDateFormat": "2020-03-17T07:04:27.031Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 126059860,
                        "gitlabId": 126059860,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728681,
                            "isTestReportAvailable": false,
                            "duration": 308,
                            "duration_inMinutes": 5.13,
                            "created_at": "Mar-13-20",
                            "created_at_rawDateFormat": "2020-03-13T07:04:27.066Z",
                            "testCoverage": 74.54
                        }
                    },
                    {
                        "id": 126049225,
                        "gitlabId": 126049225,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728683,
                            "isTestReportAvailable": false,
                            "duration": 284,
                            "duration_inMinutes": 4.73,
                            "created_at": "Mar-13-20",
                            "created_at_rawDateFormat": "2020-03-13T07:04:27.152Z",
                            "testCoverage": 73.44
                        }
                    },
                    {
                        "id": 126041299,
                        "gitlabId": 126041299,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728682,
                            "isTestReportAvailable": false,
                            "duration": 180,
                            "duration_inMinutes": 3,
                            "created_at": "Mar-13-20",
                            "created_at_rawDateFormat": "2020-03-13T07:04:27.125Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 126032803,
                        "gitlabId": 126032803,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728684,
                            "isTestReportAvailable": false,
                            "duration": 297,
                            "duration_inMinutes": 4.95,
                            "created_at": "Mar-13-20",
                            "created_at_rawDateFormat": "2020-03-13T07:04:27.262Z",
                            "testCoverage": 75
                        }
                    },
                    {
                        "id": 126029786,
                        "gitlabId": 126029786,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728685,
                            "isTestReportAvailable": false,
                            "duration": 108,
                            "duration_inMinutes": 1.8,
                            "created_at": "Mar-13-20",
                            "created_at_rawDateFormat": "2020-03-13T07:04:27.302Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 125747579,
                        "gitlabId": 125747579,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728686,
                            "isTestReportAvailable": false,
                            "duration": 293,
                            "duration_inMinutes": 4.88,
                            "created_at": "Mar-12-20",
                            "created_at_rawDateFormat": "2020-03-12T07:04:27.318Z",
                            "testCoverage": 74.81
                        }
                    },
                    {
                        "id": 125726179,
                        "gitlabId": 125726179,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728690,
                            "isTestReportAvailable": false,
                            "duration": 740,
                            "duration_inMinutes": 12.33,
                            "created_at": "Mar-12-20",
                            "created_at_rawDateFormat": "2020-03-12T07:04:27.650Z",
                            "testCoverage": 74.86
                        }
                    },
                    {
                        "id": 125715241,
                        "gitlabId": 125715241,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728688,
                            "isTestReportAvailable": false,
                            "duration": 641,
                            "duration_inMinutes": 10.68,
                            "created_at": "Mar-12-20",
                            "created_at_rawDateFormat": "2020-03-12T07:04:27.590Z",
                            "testCoverage": 74.86
                        }
                    },
                    {
                        "id": 125711213,
                        "gitlabId": 125711213,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728687,
                            "isTestReportAvailable": false,
                            "duration": 387,
                            "duration_inMinutes": 6.45,
                            "created_at": "Mar-12-20",
                            "created_at_rawDateFormat": "2020-03-12T07:04:27.527Z",
                            "testCoverage": 75.62
                        }
                    },
                    {
                        "id": 124421794,
                        "gitlabId": 124421794,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728689,
                            "isTestReportAvailable": false,
                            "duration": 379,
                            "duration_inMinutes": 6.32,
                            "created_at": "Mar-09-20",
                            "created_at_rawDateFormat": "2020-03-09T07:04:27.595Z",
                            "testCoverage": 74.86
                        }
                    },
                    {
                        "id": 124002941,
                        "gitlabId": 124002941,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728691,
                            "isTestReportAvailable": false,
                            "duration": 283,
                            "duration_inMinutes": 4.72,
                            "created_at": "Mar-06-20",
                            "created_at_rawDateFormat": "2020-03-06T07:04:27.766Z",
                            "testCoverage": 74.94
                        }
                    },
                    {
                        "id": 123999811,
                        "gitlabId": 123999811,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728692,
                            "isTestReportAvailable": false,
                            "duration": 171,
                            "duration_inMinutes": 2.85,
                            "created_at": "Mar-06-20",
                            "created_at_rawDateFormat": "2020-03-06T07:04:27.869Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 123986499,
                        "gitlabId": 123986499,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728693,
                            "isTestReportAvailable": false,
                            "duration": 302,
                            "duration_inMinutes": 5.03,
                            "created_at": "Mar-06-20",
                            "created_at_rawDateFormat": "2020-03-06T07:04:27.875Z",
                            "testCoverage": 75.06
                        }
                    },
                    {
                        "id": 123983339,
                        "gitlabId": 123983339,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728695,
                            "isTestReportAvailable": false,
                            "duration": 307,
                            "duration_inMinutes": 5.12,
                            "created_at": "Mar-06-20",
                            "created_at_rawDateFormat": "2020-03-06T07:04:27.932Z",
                            "testCoverage": 75.06
                        }
                    },
                    {
                        "id": 123970753,
                        "gitlabId": 123970753,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728694,
                            "isTestReportAvailable": false,
                            "duration": 305,
                            "duration_inMinutes": 5.08,
                            "created_at": "Mar-06-20",
                            "created_at_rawDateFormat": "2020-03-06T07:04:27.920Z",
                            "testCoverage": 74.94
                        }
                    },
                    {
                        "id": 123970572,
                        "gitlabId": 123970572,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728696,
                            "isTestReportAvailable": false,
                            "duration": 107,
                            "duration_inMinutes": 1.78,
                            "created_at": "Mar-06-20",
                            "created_at_rawDateFormat": "2020-03-06T07:04:28.033Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 123954669,
                        "gitlabId": 123954669,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728699,
                            "isTestReportAvailable": false,
                            "duration": 289,
                            "duration_inMinutes": 4.82,
                            "created_at": "Mar-06-20",
                            "created_at_rawDateFormat": "2020-03-06T07:04:28.243Z",
                            "testCoverage": 75.06
                        }
                    },
                    {
                        "id": 123945941,
                        "gitlabId": 123945941,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728701,
                            "isTestReportAvailable": false,
                            "duration": 778,
                            "duration_inMinutes": 12.97,
                            "created_at": "Mar-06-20",
                            "created_at_rawDateFormat": "2020-03-06T07:04:28.375Z",
                            "testCoverage": 74.86
                        }
                    },
                    {
                        "id": 123945117,
                        "gitlabId": 123945117,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728698,
                            "isTestReportAvailable": false,
                            "duration": 291,
                            "duration_inMinutes": 4.85,
                            "created_at": "Mar-06-20",
                            "created_at_rawDateFormat": "2020-03-06T07:04:28.223Z",
                            "testCoverage": 75.16
                        }
                    },
                    {
                        "id": 123944808,
                        "gitlabId": 123944808,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728697,
                            "isTestReportAvailable": false,
                            "duration": 293,
                            "duration_inMinutes": 4.88,
                            "created_at": "Mar-06-20",
                            "created_at_rawDateFormat": "2020-03-06T07:04:28.214Z",
                            "testCoverage": 75.36
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29693,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 4200382,
                "gitlabId": 4200382,
                "name": "es-isst.de",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/es-isst.de.git",
                "stats": {
                    "id": 29722,
                    "status": "failed",
                    "numberOfPipelines": 97,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 128,
                    "averageDurationOfPipelines_inMinutes": 2.13,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 13,
                    "numberOfFailedPipelines": 70,
                    "numberOfCanceledPipelines": 14,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 13.4,
                    "totalRepoSize": "26214400",
                    "artifactsSize": "1905928235"
                },
                "pipelines": [
                    {
                        "id": 102855100,
                        "gitlabId": 102855100,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728404,
                            "isTestReportAvailable": false,
                            "duration": 288,
                            "duration_inMinutes": 4.8,
                            "created_at": "Dec-13-19",
                            "created_at_rawDateFormat": "2019-12-13T07:04:00.636Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79883086,
                        "gitlabId": 79883086,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728405,
                            "isTestReportAvailable": false,
                            "duration": 417,
                            "duration_inMinutes": 6.95,
                            "created_at": "Sep-03-19",
                            "created_at_rawDateFormat": "2019-09-03T07:04:00.696Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79188866,
                        "gitlabId": 79188866,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728410,
                            "isTestReportAvailable": false,
                            "duration": 744,
                            "duration_inMinutes": 12.4,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:04:00.971Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79184771,
                        "gitlabId": 79184771,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728406,
                            "isTestReportAvailable": false,
                            "duration": 966,
                            "duration_inMinutes": 16.1,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:04:00.735Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79179917,
                        "gitlabId": 79179917,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728407,
                            "isTestReportAvailable": false,
                            "duration": 237,
                            "duration_inMinutes": 3.95,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:04:00.770Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79176057,
                        "gitlabId": 79176057,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728413,
                            "isTestReportAvailable": false,
                            "duration": 588,
                            "duration_inMinutes": 9.8,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:04:01.050Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 79082303,
                        "gitlabId": 79082303,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728408,
                            "isTestReportAvailable": false,
                            "duration": 3,
                            "duration_inMinutes": 0.05,
                            "created_at": "Aug-29-19",
                            "created_at_rawDateFormat": "2019-08-29T07:04:00.949Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78893198,
                        "gitlabId": 78893198,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728411,
                            "isTestReportAvailable": false,
                            "duration": 6,
                            "duration_inMinutes": 0.1,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:01.015Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78893004,
                        "gitlabId": 78893004,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728412,
                            "isTestReportAvailable": false,
                            "duration": 6,
                            "duration_inMinutes": 0.1,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:01.021Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78892530,
                        "gitlabId": 78892530,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728712,
                            "isTestReportAvailable": false,
                            "duration": 6,
                            "duration_inMinutes": 0.1,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:29.197Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78891219,
                        "gitlabId": 78891219,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728714,
                            "isTestReportAvailable": false,
                            "duration": 7,
                            "duration_inMinutes": 0.12,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:29.230Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78890816,
                        "gitlabId": 78890816,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728720,
                            "isTestReportAvailable": false,
                            "duration": 6,
                            "duration_inMinutes": 0.1,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:29.558Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78890584,
                        "gitlabId": 78890584,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728716,
                            "isTestReportAvailable": false,
                            "duration": 6,
                            "duration_inMinutes": 0.1,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:29.421Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78888831,
                        "gitlabId": 78888831,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728735,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:30.776Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78886685,
                        "gitlabId": 78886685,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728717,
                            "isTestReportAvailable": false,
                            "duration": 12,
                            "duration_inMinutes": 0.2,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:29.467Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78885955,
                        "gitlabId": 78885955,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728718,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:29.532Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78885640,
                        "gitlabId": 78885640,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728719,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:29.551Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78884810,
                        "gitlabId": 78884810,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728721,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:29.759Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78882599,
                        "gitlabId": 78882599,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728722,
                            "isTestReportAvailable": false,
                            "duration": 13,
                            "duration_inMinutes": 0.22,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:29.769Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78880914,
                        "gitlabId": 78880914,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728725,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:29.963Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78856093,
                        "gitlabId": 78856093,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728723,
                            "isTestReportAvailable": false,
                            "duration": 6,
                            "duration_inMinutes": 0.1,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:29.813Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78845953,
                        "gitlabId": 78845953,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728724,
                            "isTestReportAvailable": false,
                            "duration": 5,
                            "duration_inMinutes": 0.08,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:29.837Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78844921,
                        "gitlabId": 78844921,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728728,
                            "isTestReportAvailable": false,
                            "duration": 5,
                            "duration_inMinutes": 0.08,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:30.222Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78844064,
                        "gitlabId": 78844064,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728726,
                            "isTestReportAvailable": false,
                            "duration": 5,
                            "duration_inMinutes": 0.08,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:30.037Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78803791,
                        "gitlabId": 78803791,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728727,
                            "isTestReportAvailable": false,
                            "duration": 229,
                            "duration_inMinutes": 3.82,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:30.161Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78803628,
                        "gitlabId": 78803628,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728758,
                            "isTestReportAvailable": false,
                            "duration": 65,
                            "duration_inMinutes": 1.08,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:32.237Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78803299,
                        "gitlabId": 78803299,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728729,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:30.229Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78801968,
                        "gitlabId": 78801968,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728730,
                            "isTestReportAvailable": false,
                            "duration": 147,
                            "duration_inMinutes": 2.45,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:30.339Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78800334,
                        "gitlabId": 78800334,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728732,
                            "isTestReportAvailable": false,
                            "duration": 127,
                            "duration_inMinutes": 2.12,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:30.536Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78800201,
                        "gitlabId": 78800201,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728733,
                            "isTestReportAvailable": false,
                            "duration": 4,
                            "duration_inMinutes": 0.07,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:30.563Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78800092,
                        "gitlabId": 78800092,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728731,
                            "isTestReportAvailable": false,
                            "duration": 9,
                            "duration_inMinutes": 0.15,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:30.489Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78799561,
                        "gitlabId": 78799561,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728734,
                            "isTestReportAvailable": false,
                            "duration": 150,
                            "duration_inMinutes": 2.5,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:30.767Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78798959,
                        "gitlabId": 78798959,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728736,
                            "isTestReportAvailable": false,
                            "duration": 167,
                            "duration_inMinutes": 2.78,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:30.783Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78798905,
                        "gitlabId": 78798905,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728737,
                            "isTestReportAvailable": false,
                            "duration": 5,
                            "duration_inMinutes": 0.08,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:30.813Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78798553,
                        "gitlabId": 78798553,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728738,
                            "isTestReportAvailable": false,
                            "duration": 145,
                            "duration_inMinutes": 2.42,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:30.822Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78796334,
                        "gitlabId": 78796334,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728742,
                            "isTestReportAvailable": false,
                            "duration": 150,
                            "duration_inMinutes": 2.5,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:31.191Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78795830,
                        "gitlabId": 78795830,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728739,
                            "isTestReportAvailable": false,
                            "duration": 144,
                            "duration_inMinutes": 2.4,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:31.033Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78794760,
                        "gitlabId": 78794760,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728740,
                            "isTestReportAvailable": false,
                            "duration": 223,
                            "duration_inMinutes": 3.72,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:31.101Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78794359,
                        "gitlabId": 78794359,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728743,
                            "isTestReportAvailable": false,
                            "duration": 146,
                            "duration_inMinutes": 2.43,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:04:31.237Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78381128,
                        "gitlabId": 78381128,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728741,
                            "isTestReportAvailable": false,
                            "duration": 236,
                            "duration_inMinutes": 3.93,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:04:31.174Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78381010,
                        "gitlabId": 78381010,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728744,
                            "isTestReportAvailable": false,
                            "duration": 82,
                            "duration_inMinutes": 1.37,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:04:31.289Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78379968,
                        "gitlabId": 78379968,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728745,
                            "isTestReportAvailable": false,
                            "duration": 148,
                            "duration_inMinutes": 2.47,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:04:31.409Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78373570,
                        "gitlabId": 78373570,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728747,
                            "isTestReportAvailable": false,
                            "duration": 231,
                            "duration_inMinutes": 3.85,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:04:31.460Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78369396,
                        "gitlabId": 78369396,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728746,
                            "isTestReportAvailable": false,
                            "duration": 231,
                            "duration_inMinutes": 3.85,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:04:31.457Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78364795,
                        "gitlabId": 78364795,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728751,
                            "isTestReportAvailable": false,
                            "duration": 389,
                            "duration_inMinutes": 6.48,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:04:31.749Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78332014,
                        "gitlabId": 78332014,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728748,
                            "isTestReportAvailable": false,
                            "duration": 383,
                            "duration_inMinutes": 6.38,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:04:31.567Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78328739,
                        "gitlabId": 78328739,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728749,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:04:31.684Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78327783,
                        "gitlabId": 78327783,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728750,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:04:31.728Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78327299,
                        "gitlabId": 78327299,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728752,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:04:31.896Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78325458,
                        "gitlabId": 78325458,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728753,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:04:31.902Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78324761,
                        "gitlabId": 78324761,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728754,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:04:31.964Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78322670,
                        "gitlabId": 78322670,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728759,
                            "isTestReportAvailable": false,
                            "duration": 361,
                            "duration_inMinutes": 6.02,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:04:32.268Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78317617,
                        "gitlabId": 78317617,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728760,
                            "isTestReportAvailable": false,
                            "duration": 367,
                            "duration_inMinutes": 6.12,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:04:32.425Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78316403,
                        "gitlabId": 78316403,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728755,
                            "isTestReportAvailable": false,
                            "duration": 371,
                            "duration_inMinutes": 6.18,
                            "created_at": "Aug-26-19",
                            "created_at_rawDateFormat": "2019-08-26T07:04:32.194Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77741424,
                        "gitlabId": 77741424,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728757,
                            "isTestReportAvailable": false,
                            "duration": 12,
                            "duration_inMinutes": 0.2,
                            "created_at": "Aug-22-19",
                            "created_at_rawDateFormat": "2019-08-22T07:04:32.228Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77733621,
                        "gitlabId": 77733621,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728756,
                            "isTestReportAvailable": false,
                            "duration": 482,
                            "duration_inMinutes": 8.03,
                            "created_at": "Aug-22-19",
                            "created_at_rawDateFormat": "2019-08-22T07:04:32.227Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77731611,
                        "gitlabId": 77731611,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728762,
                            "isTestReportAvailable": false,
                            "duration": 312,
                            "duration_inMinutes": 5.2,
                            "created_at": "Aug-22-19",
                            "created_at_rawDateFormat": "2019-08-22T07:04:32.523Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77730826,
                        "gitlabId": 77730826,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728761,
                            "isTestReportAvailable": false,
                            "duration": 244,
                            "duration_inMinutes": 4.07,
                            "created_at": "Aug-22-19",
                            "created_at_rawDateFormat": "2019-08-22T07:04:32.497Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77729871,
                        "gitlabId": 77729871,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728783,
                            "isTestReportAvailable": false,
                            "duration": 284,
                            "duration_inMinutes": 4.73,
                            "created_at": "Aug-22-19",
                            "created_at_rawDateFormat": "2019-08-22T07:04:33.960Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77727411,
                        "gitlabId": 77727411,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728763,
                            "isTestReportAvailable": false,
                            "duration": 267,
                            "duration_inMinutes": 4.45,
                            "created_at": "Aug-22-19",
                            "created_at_rawDateFormat": "2019-08-22T07:04:32.559Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77721339,
                        "gitlabId": 77721339,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728765,
                            "isTestReportAvailable": false,
                            "duration": 355,
                            "duration_inMinutes": 5.92,
                            "created_at": "Aug-22-19",
                            "created_at_rawDateFormat": "2019-08-22T07:04:32.810Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77545455,
                        "gitlabId": 77545455,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728764,
                            "isTestReportAvailable": false,
                            "duration": 732,
                            "duration_inMinutes": 12.2,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:32.709Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77545279,
                        "gitlabId": 77545279,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728768,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:32.970Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77545229,
                        "gitlabId": 77545229,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728766,
                            "isTestReportAvailable": false,
                            "duration": 830,
                            "duration_inMinutes": 13.83,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:32.846Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77544999,
                        "gitlabId": 77544999,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728767,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:32.857Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77544935,
                        "gitlabId": 77544935,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728769,
                            "isTestReportAvailable": false,
                            "duration": 787,
                            "duration_inMinutes": 13.12,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:33.094Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77544809,
                        "gitlabId": 77544809,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728777,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:33.520Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77544721,
                        "gitlabId": 77544721,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728771,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:33.130Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77544667,
                        "gitlabId": 77544667,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728770,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:33.112Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77544531,
                        "gitlabId": 77544531,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728772,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:33.212Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77544470,
                        "gitlabId": 77544470,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728773,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:33.347Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77544410,
                        "gitlabId": 77544410,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728775,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:33.419Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77544348,
                        "gitlabId": 77544348,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728774,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:33.396Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77544319,
                        "gitlabId": 77544319,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728776,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:33.478Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77544278,
                        "gitlabId": 77544278,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728778,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:33.615Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77544207,
                        "gitlabId": 77544207,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728793,
                            "isTestReportAvailable": false,
                            "duration": 241,
                            "duration_inMinutes": 4.02,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:34.777Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77544144,
                        "gitlabId": 77544144,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728779,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:33.693Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77543971,
                        "gitlabId": 77543971,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728780,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:33.736Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77543892,
                        "gitlabId": 77543892,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728781,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:33.782Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77542587,
                        "gitlabId": 77542587,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728782,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:33.876Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77542489,
                        "gitlabId": 77542489,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728786,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:34.133Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77542431,
                        "gitlabId": 77542431,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728784,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:33.994Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77542336,
                        "gitlabId": 77542336,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728785,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:34.037Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77542234,
                        "gitlabId": 77542234,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728789,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:34.306Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77542091,
                        "gitlabId": 77542091,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728787,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:34.236Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77541974,
                        "gitlabId": 77541974,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728790,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:34.552Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77541681,
                        "gitlabId": 77541681,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728788,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:34.305Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77541584,
                        "gitlabId": 77541584,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728795,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:34.831Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77541237,
                        "gitlabId": 77541237,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728792,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:34.596Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77541159,
                        "gitlabId": 77541159,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728799,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:35.122Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77541077,
                        "gitlabId": 77541077,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728791,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:34.594Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77541026,
                        "gitlabId": 77541026,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728794,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:34.824Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77540770,
                        "gitlabId": 77540770,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728796,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:34.907Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77540666,
                        "gitlabId": 77540666,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728806,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:35.519Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77540333,
                        "gitlabId": 77540333,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728800,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:35.170Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77537634,
                        "gitlabId": 77537634,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728797,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:35.074Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77537553,
                        "gitlabId": 77537553,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728798,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:04:35.090Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29681,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 11571288,
                "gitlabId": 11571288,
                "name": "ng-dropping-stones",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/ng-dropping-stones.git",
                "stats": {
                    "id": 29684,
                    "status": "success",
                    "numberOfPipelines": 57,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 96,
                    "averageDurationOfPipelines_inMinutes": 1.6,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 19,
                    "numberOfFailedPipelines": 27,
                    "numberOfCanceledPipelines": 3,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 8,
                    "pipelinesSuccessRatio": 33.33,
                    "totalRepoSize": "43673190",
                    "artifactsSize": "143357982"
                },
                "pipelines": [
                    {
                        "id": 249465563,
                        "gitlabId": 249465563,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728700,
                            "isTestReportAvailable": false,
                            "duration": 113,
                            "duration_inMinutes": 1.88,
                            "created_at": "Feb-01-21",
                            "created_at_rawDateFormat": "2021-02-01T07:04:28.366Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 232756448,
                        "gitlabId": 232756448,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728704,
                            "isTestReportAvailable": false,
                            "duration": 205,
                            "duration_inMinutes": 3.42,
                            "created_at": "Dec-21-20",
                            "created_at_rawDateFormat": "2020-12-21T07:04:28.588Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 177040897,
                        "gitlabId": 177040897,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728702,
                            "isTestReportAvailable": false,
                            "duration": 217,
                            "duration_inMinutes": 3.62,
                            "created_at": "Aug-12-20",
                            "created_at_rawDateFormat": "2020-08-12T07:04:28.480Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 177040742,
                        "gitlabId": 177040742,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728703,
                            "isTestReportAvailable": false,
                            "duration": 171,
                            "duration_inMinutes": 2.85,
                            "created_at": "Aug-12-20",
                            "created_at_rawDateFormat": "2020-08-12T07:04:28.496Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 177039523,
                        "gitlabId": 177039523,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728713,
                            "isTestReportAvailable": false,
                            "duration": 111,
                            "duration_inMinutes": 1.85,
                            "created_at": "Aug-12-20",
                            "created_at_rawDateFormat": "2020-08-12T07:04:29.224Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 177039164,
                        "gitlabId": 177039164,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728705,
                            "isTestReportAvailable": false,
                            "duration": 53,
                            "duration_inMinutes": 0.88,
                            "created_at": "Aug-12-20",
                            "created_at_rawDateFormat": "2020-08-12T07:04:28.647Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 177036607,
                        "gitlabId": 177036607,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728706,
                            "isTestReportAvailable": false,
                            "duration": 52,
                            "duration_inMinutes": 0.87,
                            "created_at": "Aug-12-20",
                            "created_at_rawDateFormat": "2020-08-12T07:04:28.743Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 177034178,
                        "gitlabId": 177034178,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728707,
                            "isTestReportAvailable": false,
                            "duration": 177,
                            "duration_inMinutes": 2.95,
                            "created_at": "Aug-12-20",
                            "created_at_rawDateFormat": "2020-08-12T07:04:28.768Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 177026785,
                        "gitlabId": 177026785,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728708,
                            "isTestReportAvailable": false,
                            "duration": 53,
                            "duration_inMinutes": 0.88,
                            "created_at": "Aug-12-20",
                            "created_at_rawDateFormat": "2020-08-12T07:04:28.907Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 177014821,
                        "gitlabId": 177014821,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728709,
                            "isTestReportAvailable": false,
                            "duration": 134,
                            "duration_inMinutes": 2.23,
                            "created_at": "Aug-12-20",
                            "created_at_rawDateFormat": "2020-08-12T07:04:28.923Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 176994921,
                        "gitlabId": 176994921,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728711,
                            "isTestReportAvailable": false,
                            "duration": 176,
                            "duration_inMinutes": 2.93,
                            "created_at": "Aug-12-20",
                            "created_at_rawDateFormat": "2020-08-12T07:04:29.116Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 176992700,
                        "gitlabId": 176992700,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728710,
                            "isTestReportAvailable": false,
                            "duration": 135,
                            "duration_inMinutes": 2.25,
                            "created_at": "Aug-12-20",
                            "created_at_rawDateFormat": "2020-08-12T07:04:29.017Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 176987378,
                        "gitlabId": 176987378,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728891,
                            "isTestReportAvailable": false,
                            "duration": 157,
                            "duration_inMinutes": 2.62,
                            "created_at": "Aug-12-20",
                            "created_at_rawDateFormat": "2020-08-12T07:04:41.612Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 176983667,
                        "gitlabId": 176983667,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728895,
                            "isTestReportAvailable": false,
                            "duration": 159,
                            "duration_inMinutes": 2.65,
                            "created_at": "Aug-12-20",
                            "created_at_rawDateFormat": "2020-08-12T07:04:41.967Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 176980938,
                        "gitlabId": 176980938,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728892,
                            "isTestReportAvailable": false,
                            "duration": 193,
                            "duration_inMinutes": 3.22,
                            "created_at": "Aug-12-20",
                            "created_at_rawDateFormat": "2020-08-12T07:04:41.659Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 176980597,
                        "gitlabId": 176980597,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728897,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-12-20",
                            "created_at_rawDateFormat": "2020-08-12T07:04:42.058Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 176977037,
                        "gitlabId": 176977037,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728894,
                            "isTestReportAvailable": false,
                            "duration": 19,
                            "duration_inMinutes": 0.32,
                            "created_at": "Aug-12-20",
                            "created_at_rawDateFormat": "2020-08-12T07:04:41.929Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 176973789,
                        "gitlabId": 176973789,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728896,
                            "isTestReportAvailable": false,
                            "duration": 166,
                            "duration_inMinutes": 2.77,
                            "created_at": "Aug-12-20",
                            "created_at_rawDateFormat": "2020-08-12T07:04:42.007Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 176972741,
                        "gitlabId": 176972741,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728898,
                            "isTestReportAvailable": false,
                            "duration": 8,
                            "duration_inMinutes": 0.13,
                            "created_at": "Aug-12-20",
                            "created_at_rawDateFormat": "2020-08-12T07:04:42.129Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 115821954,
                        "gitlabId": 115821954,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728899,
                            "isTestReportAvailable": false,
                            "duration": 95,
                            "duration_inMinutes": 1.58,
                            "created_at": "Feb-07-20",
                            "created_at_rawDateFormat": "2020-02-07T07:04:42.183Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 115821946,
                        "gitlabId": 115821946,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728903,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Feb-07-20",
                            "created_at_rawDateFormat": "2020-02-07T07:04:42.592Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 105687928,
                        "gitlabId": 105687928,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728900,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-27-19",
                            "created_at_rawDateFormat": "2019-12-27T07:04:42.356Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 66537189,
                        "gitlabId": 66537189,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728902,
                            "isTestReportAvailable": false,
                            "duration": 375,
                            "duration_inMinutes": 6.25,
                            "created_at": "Jun-17-19",
                            "created_at_rawDateFormat": "2019-06-17T07:04:42.421Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 66534765,
                        "gitlabId": 66534765,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728901,
                            "isTestReportAvailable": false,
                            "duration": 126,
                            "duration_inMinutes": 2.1,
                            "created_at": "Jun-17-19",
                            "created_at_rawDateFormat": "2019-06-17T07:04:42.407Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 66533210,
                        "gitlabId": 66533210,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728908,
                            "isTestReportAvailable": false,
                            "duration": 87,
                            "duration_inMinutes": 1.45,
                            "created_at": "Jun-17-19",
                            "created_at_rawDateFormat": "2019-06-17T07:04:43.758Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 66498774,
                        "gitlabId": 66498774,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728907,
                            "isTestReportAvailable": false,
                            "duration": 111,
                            "duration_inMinutes": 1.85,
                            "created_at": "Jun-17-19",
                            "created_at_rawDateFormat": "2019-06-17T07:04:43.719Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 66498636,
                        "gitlabId": 66498636,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728905,
                            "isTestReportAvailable": false,
                            "duration": 11,
                            "duration_inMinutes": 0.18,
                            "created_at": "Jun-17-19",
                            "created_at_rawDateFormat": "2019-06-17T07:04:43.691Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 66497056,
                        "gitlabId": 66497056,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728906,
                            "isTestReportAvailable": false,
                            "duration": 11,
                            "duration_inMinutes": 0.18,
                            "created_at": "Jun-17-19",
                            "created_at_rawDateFormat": "2019-06-17T07:04:43.704Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 66495646,
                        "gitlabId": 66495646,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728915,
                            "isTestReportAvailable": false,
                            "duration": 121,
                            "duration_inMinutes": 2.02,
                            "created_at": "Jun-17-19",
                            "created_at_rawDateFormat": "2019-06-17T07:04:44.091Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 56342625,
                        "gitlabId": 56342625,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728909,
                            "isTestReportAvailable": false,
                            "duration": 91,
                            "duration_inMinutes": 1.52,
                            "created_at": "Apr-11-19",
                            "created_at_rawDateFormat": "2019-04-11T07:04:43.789Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 56327948,
                        "gitlabId": 56327948,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728911,
                            "isTestReportAvailable": false,
                            "duration": 116,
                            "duration_inMinutes": 1.93,
                            "created_at": "Apr-11-19",
                            "created_at_rawDateFormat": "2019-04-11T07:04:44.017Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 56327944,
                        "gitlabId": 56327944,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728912,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Apr-11-19",
                            "created_at_rawDateFormat": "2019-04-11T07:04:44.026Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 56126835,
                        "gitlabId": 56126835,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728910,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Apr-10-19",
                            "created_at_rawDateFormat": "2019-04-10T07:04:44.016Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 56079118,
                        "gitlabId": 56079118,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728913,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Apr-10-19",
                            "created_at_rawDateFormat": "2019-04-10T07:04:44.064Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 56061036,
                        "gitlabId": 56061036,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728914,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Apr-10-19",
                            "created_at_rawDateFormat": "2019-04-10T07:04:44.082Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 56061027,
                        "gitlabId": 56061027,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728918,
                            "isTestReportAvailable": false,
                            "duration": 94,
                            "duration_inMinutes": 1.57,
                            "created_at": "Apr-10-19",
                            "created_at_rawDateFormat": "2019-04-10T07:04:44.307Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54588811,
                        "gitlabId": 54588811,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728916,
                            "isTestReportAvailable": false,
                            "duration": 69,
                            "duration_inMinutes": 1.15,
                            "created_at": "Apr-01-19",
                            "created_at_rawDateFormat": "2019-04-01T07:04:44.275Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54558506,
                        "gitlabId": 54558506,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728917,
                            "isTestReportAvailable": false,
                            "duration": 79,
                            "duration_inMinutes": 1.32,
                            "created_at": "Apr-01-19",
                            "created_at_rawDateFormat": "2019-04-01T07:04:44.288Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54555479,
                        "gitlabId": 54555479,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728919,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Apr-01-19",
                            "created_at_rawDateFormat": "2019-04-01T07:04:44.313Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54555303,
                        "gitlabId": 54555303,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728920,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Apr-01-19",
                            "created_at_rawDateFormat": "2019-04-01T07:04:44.406Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54554937,
                        "gitlabId": 54554937,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728923,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Apr-01-19",
                            "created_at_rawDateFormat": "2019-04-01T07:04:44.605Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54553900,
                        "gitlabId": 54553900,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728921,
                            "isTestReportAvailable": false,
                            "duration": 96,
                            "duration_inMinutes": 1.6,
                            "created_at": "Apr-01-19",
                            "created_at_rawDateFormat": "2019-04-01T07:04:44.550Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54553397,
                        "gitlabId": 54553397,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728924,
                            "isTestReportAvailable": false,
                            "duration": 95,
                            "duration_inMinutes": 1.58,
                            "created_at": "Apr-01-19",
                            "created_at_rawDateFormat": "2019-04-01T07:04:44.625Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54552062,
                        "gitlabId": 54552062,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728926,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Apr-01-19",
                            "created_at_rawDateFormat": "2019-04-01T07:04:44.732Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54549751,
                        "gitlabId": 54549751,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728922,
                            "isTestReportAvailable": false,
                            "duration": 140,
                            "duration_inMinutes": 2.33,
                            "created_at": "Apr-01-19",
                            "created_at_rawDateFormat": "2019-04-01T07:04:44.579Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54548971,
                        "gitlabId": 54548971,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728925,
                            "isTestReportAvailable": false,
                            "duration": 96,
                            "duration_inMinutes": 1.6,
                            "created_at": "Apr-01-19",
                            "created_at_rawDateFormat": "2019-04-01T07:04:44.722Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54548568,
                        "gitlabId": 54548568,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728927,
                            "isTestReportAvailable": false,
                            "duration": 94,
                            "duration_inMinutes": 1.57,
                            "created_at": "Apr-01-19",
                            "created_at_rawDateFormat": "2019-04-01T07:04:44.816Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54546112,
                        "gitlabId": 54546112,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728928,
                            "isTestReportAvailable": false,
                            "duration": 98,
                            "duration_inMinutes": 1.63,
                            "created_at": "Apr-01-19",
                            "created_at_rawDateFormat": "2019-04-01T07:04:44.827Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54543496,
                        "gitlabId": 54543496,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728929,
                            "isTestReportAvailable": false,
                            "duration": 96,
                            "duration_inMinutes": 1.6,
                            "created_at": "Apr-01-19",
                            "created_at_rawDateFormat": "2019-04-01T07:04:44.855Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54542512,
                        "gitlabId": 54542512,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728930,
                            "isTestReportAvailable": false,
                            "duration": 99,
                            "duration_inMinutes": 1.65,
                            "created_at": "Apr-01-19",
                            "created_at_rawDateFormat": "2019-04-01T07:04:44.867Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54540572,
                        "gitlabId": 54540572,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728945,
                            "isTestReportAvailable": false,
                            "duration": 100,
                            "duration_inMinutes": 1.67,
                            "created_at": "Apr-01-19",
                            "created_at_rawDateFormat": "2019-04-01T07:04:46.146Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54537392,
                        "gitlabId": 54537392,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728931,
                            "isTestReportAvailable": false,
                            "duration": 169,
                            "duration_inMinutes": 2.82,
                            "created_at": "Apr-01-19",
                            "created_at_rawDateFormat": "2019-04-01T07:04:45.067Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54535651,
                        "gitlabId": 54535651,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728934,
                            "isTestReportAvailable": false,
                            "duration": 177,
                            "duration_inMinutes": 2.95,
                            "created_at": "Apr-01-19",
                            "created_at_rawDateFormat": "2019-04-01T07:04:45.156Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54286156,
                        "gitlabId": 54286156,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728932,
                            "isTestReportAvailable": false,
                            "duration": 183,
                            "duration_inMinutes": 3.05,
                            "created_at": "Mar-29-19",
                            "created_at_rawDateFormat": "2019-03-29T07:04:45.095Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54281017,
                        "gitlabId": 54281017,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728936,
                            "isTestReportAvailable": false,
                            "duration": 187,
                            "duration_inMinutes": 3.12,
                            "created_at": "Mar-29-19",
                            "created_at_rawDateFormat": "2019-03-29T07:04:45.441Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54268201,
                        "gitlabId": 54268201,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728933,
                            "isTestReportAvailable": false,
                            "duration": 155,
                            "duration_inMinutes": 2.58,
                            "created_at": "Mar-29-19",
                            "created_at_rawDateFormat": "2019-03-29T07:04:45.121Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 54265966,
                        "gitlabId": 54265966,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728940,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-29-19",
                            "created_at_rawDateFormat": "2019-03-29T07:04:45.699Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29683,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 31546399,
                "gitlabId": 31546399,
                "name": "w11k-ng-components",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/w11k-ng-components.git",
                "stats": {
                    "id": 29733,
                    "status": "success",
                    "numberOfPipelines": 6,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 43,
                    "averageDurationOfPipelines_inMinutes": 0.72,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 3,
                    "numberOfFailedPipelines": 1,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 2,
                    "pipelinesSuccessRatio": 50,
                    "totalRepoSize": "681574",
                    "artifactsSize": "960501"
                },
                "pipelines": [
                    {
                        "id": 414853984,
                        "gitlabId": 414853984,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728194,
                            "isTestReportAvailable": false,
                            "duration": 40,
                            "duration_inMinutes": 0.67,
                            "created_at": "Nov-23-21",
                            "created_at_rawDateFormat": "2021-11-23T07:03:43.255Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 414852240,
                        "gitlabId": 414852240,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728193,
                            "isTestReportAvailable": false,
                            "duration": 40,
                            "duration_inMinutes": 0.67,
                            "created_at": "Nov-23-21",
                            "created_at_rawDateFormat": "2021-11-23T07:03:43.250Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 414832591,
                        "gitlabId": 414832591,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728201,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-23-21",
                            "created_at_rawDateFormat": "2021-11-23T07:03:43.604Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 414832570,
                        "gitlabId": 414832570,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728195,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-23-21",
                            "created_at_rawDateFormat": "2021-11-23T07:03:43.299Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 414831417,
                        "gitlabId": 414831417,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728200,
                            "isTestReportAvailable": false,
                            "duration": 112,
                            "duration_inMinutes": 1.87,
                            "created_at": "Nov-23-21",
                            "created_at_rawDateFormat": "2021-11-23T07:03:43.597Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 414820518,
                        "gitlabId": 414820518,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728197,
                            "isTestReportAvailable": false,
                            "duration": 67,
                            "duration_inMinutes": 1.12,
                            "created_at": "Nov-23-21",
                            "created_at_rawDateFormat": "2021-11-23T07:03:43.537Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29721,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 30745648,
                "gitlabId": 30745648,
                "name": "Angular-components-of-W11K-Design-System",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/angular-components-of-w11k-design-system.git",
                "stats": {
                    "id": 29710,
                    "status": "skipped",
                    "numberOfPipelines": 20,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 21,
                    "averageDurationOfPipelines_inMinutes": 0.35,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 5,
                    "numberOfFailedPipelines": 7,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 8,
                    "pipelinesSuccessRatio": 25,
                    "totalRepoSize": "408944",
                    "artifactsSize": "109618"
                },
                "pipelines": [
                    {
                        "id": 409751766,
                        "gitlabId": 409751766,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728352,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:57.401Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409751732,
                        "gitlabId": 409751732,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728349,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:57.263Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409751122,
                        "gitlabId": 409751122,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728351,
                            "isTestReportAvailable": false,
                            "duration": 37,
                            "duration_inMinutes": 0.62,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:57.330Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409741910,
                        "gitlabId": 409741910,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728350,
                            "isTestReportAvailable": false,
                            "duration": 60,
                            "duration_inMinutes": 1,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:57.298Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409733749,
                        "gitlabId": 409733749,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728353,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:57.494Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409733728,
                        "gitlabId": 409733728,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728354,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:57.502Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409733144,
                        "gitlabId": 409733144,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728366,
                            "isTestReportAvailable": false,
                            "duration": 42,
                            "duration_inMinutes": 0.7,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:58.416Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409727987,
                        "gitlabId": 409727987,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728355,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:57.586Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409727967,
                        "gitlabId": 409727967,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728357,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:57.738Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409727082,
                        "gitlabId": 409727082,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728356,
                            "isTestReportAvailable": false,
                            "duration": 42,
                            "duration_inMinutes": 0.7,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:57.693Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409721364,
                        "gitlabId": 409721364,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728358,
                            "isTestReportAvailable": false,
                            "duration": 36,
                            "duration_inMinutes": 0.6,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:57.798Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409712135,
                        "gitlabId": 409712135,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728364,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:58.263Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409712088,
                        "gitlabId": 409712088,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 728359,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:57.882Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409711073,
                        "gitlabId": 409711073,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728360,
                            "isTestReportAvailable": false,
                            "duration": 67,
                            "duration_inMinutes": 1.12,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:57.992Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409707305,
                        "gitlabId": 409707305,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728361,
                            "isTestReportAvailable": false,
                            "duration": 56,
                            "duration_inMinutes": 0.93,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:58.099Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409695564,
                        "gitlabId": 409695564,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728378,
                            "isTestReportAvailable": false,
                            "duration": 54,
                            "duration_inMinutes": 0.9,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:59.185Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409691243,
                        "gitlabId": 409691243,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728362,
                            "isTestReportAvailable": false,
                            "duration": 3,
                            "duration_inMinutes": 0.05,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:58.138Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409687600,
                        "gitlabId": 409687600,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728363,
                            "isTestReportAvailable": false,
                            "duration": 8,
                            "duration_inMinutes": 0.13,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:58.251Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409677487,
                        "gitlabId": 409677487,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728365,
                            "isTestReportAvailable": false,
                            "duration": 4,
                            "duration_inMinutes": 0.07,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:58.360Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 409668309,
                        "gitlabId": 409668309,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728367,
                            "isTestReportAvailable": false,
                            "duration": 4,
                            "duration_inMinutes": 0.07,
                            "created_at": "Nov-16-21",
                            "created_at_rawDateFormat": "2021-11-16T07:03:58.449Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29718,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 30543397,
                "gitlabId": 30543397,
                "name": "paceteq-smartaudit",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/paceteq-smartaudit.git",
                "stats": {
                    "id": 29715,
                    "status": "success",
                    "numberOfPipelines": 2,
                    "areTestsAvailable": true,
                    "areTestCoveragesAvailable": true,
                    "numberOfTestReports": 1,
                    "averageDurationOfPipelines": 156,
                    "averageDurationOfPipelines_inMinutes": 2.6,
                    "testCoverage": 14.71,
                    "numberOfSuccessfulPipelines": 1,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 1,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 50,
                    "totalRepoSize": "1184890",
                    "artifactsSize": "147648409"
                },
                "pipelines": [
                    {
                        "id": 390384565,
                        "gitlabId": 390384565,
                        "status": "success",
                        "testReport": {
                            "id": 46620,
                            "error_count": 0,
                            "failed_count": 0,
                            "skipped_count": 0,
                            "success_count": 1,
                            "total_count": 1,
                            "total_time": 0.09,
                            "test_suites": [
                                {
                                    "id": 53888,
                                    "total_time": 0.09,
                                    "total_count": 1,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "build-windows-and-linux",
                                    "skipped_count": 0,
                                    "success_count": 1,
                                    "test_cases": [
                                        {
                                            "id": 3552565,
                                            "classname": " renders app with title",
                                            "execution_time": 0.09,
                                            "name": " renders app with title",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 728369,
                            "isTestReportAvailable": true,
                            "duration": 311,
                            "duration_inMinutes": 5.18,
                            "created_at": "Oct-18-21",
                            "created_at_rawDateFormat": "2021-10-18T07:03:58.530Z",
                            "testCoverage": 14.71
                        }
                    },
                    {
                        "id": 390183635,
                        "gitlabId": 390183635,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728368,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Oct-18-21",
                            "created_at_rawDateFormat": "2021-10-18T07:03:58.516Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29719,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 30543163,
                "gitlabId": 30543163,
                "name": "Griffwerk",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/griffwerk.git",
                "stats": {
                    "id": 29711,
                    "status": "manual",
                    "numberOfPipelines": 1,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 0,
                    "totalRepoSize": "8084520",
                    "artifactsSize": "0"
                },
                "pipelines": [
                    {
                        "id": 390176184,
                        "gitlabId": 390176184,
                        "status": "manual",
                        "testReport": null,
                        "stats": {
                            "id": 728370,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Oct-18-21",
                            "created_at_rawDateFormat": "2021-10-18T07:03:58.662Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29720,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 30041776,
                "gitlabId": 30041776,
                "name": "UX-Review App",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/ux-review-app.git",
                "stats": {
                    "id": 29791,
                    "status": "success",
                    "numberOfPipelines": 97,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": true,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 221,
                    "averageDurationOfPipelines_inMinutes": 3.68,
                    "testCoverage": 51.78,
                    "numberOfSuccessfulPipelines": 20,
                    "numberOfFailedPipelines": 75,
                    "numberOfCanceledPipelines": 2,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 20.62,
                    "totalRepoSize": "2516582",
                    "artifactsSize": "41663149"
                },
                "pipelines": [
                    {
                        "id": 462488183,
                        "gitlabId": 462488183,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728374,
                            "isTestReportAvailable": false,
                            "duration": 521,
                            "duration_inMinutes": 8.68,
                            "created_at": "Feb-03-22",
                            "created_at_rawDateFormat": "2022-02-03T07:03:58.835Z",
                            "testCoverage": 51.78
                        }
                    },
                    {
                        "id": 461872958,
                        "gitlabId": 461872958,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728372,
                            "isTestReportAvailable": false,
                            "duration": 585,
                            "duration_inMinutes": 9.75,
                            "created_at": "Feb-02-22",
                            "created_at_rawDateFormat": "2022-02-02T07:03:58.786Z",
                            "testCoverage": 51.78
                        }
                    },
                    {
                        "id": 461869026,
                        "gitlabId": 461869026,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728371,
                            "isTestReportAvailable": false,
                            "duration": 516,
                            "duration_inMinutes": 8.6,
                            "created_at": "Feb-02-22",
                            "created_at_rawDateFormat": "2022-02-02T07:03:58.763Z",
                            "testCoverage": 51.78
                        }
                    },
                    {
                        "id": 460728507,
                        "gitlabId": 460728507,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728373,
                            "isTestReportAvailable": false,
                            "duration": 460,
                            "duration_inMinutes": 7.67,
                            "created_at": "Feb-01-22",
                            "created_at_rawDateFormat": "2022-02-01T07:03:58.813Z",
                            "testCoverage": 51.78
                        }
                    },
                    {
                        "id": 452950942,
                        "gitlabId": 452950942,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728375,
                            "isTestReportAvailable": false,
                            "duration": 563,
                            "duration_inMinutes": 9.38,
                            "created_at": "Jan-20-22",
                            "created_at_rawDateFormat": "2022-01-20T07:03:58.969Z",
                            "testCoverage": 51.78
                        }
                    },
                    {
                        "id": 452933212,
                        "gitlabId": 452933212,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728377,
                            "isTestReportAvailable": false,
                            "duration": 580,
                            "duration_inMinutes": 9.67,
                            "created_at": "Jan-20-22",
                            "created_at_rawDateFormat": "2022-01-20T07:03:59.120Z",
                            "testCoverage": 51.78
                        }
                    },
                    {
                        "id": 452905669,
                        "gitlabId": 452905669,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728376,
                            "isTestReportAvailable": false,
                            "duration": 798,
                            "duration_inMinutes": 13.3,
                            "created_at": "Jan-20-22",
                            "created_at_rawDateFormat": "2022-01-20T07:03:59.047Z",
                            "testCoverage": 51.78
                        }
                    },
                    {
                        "id": 452902120,
                        "gitlabId": 452902120,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728380,
                            "isTestReportAvailable": false,
                            "duration": 304,
                            "duration_inMinutes": 5.07,
                            "created_at": "Jan-20-22",
                            "created_at_rawDateFormat": "2022-01-20T07:03:59.300Z",
                            "testCoverage": 51.78
                        }
                    },
                    {
                        "id": 452738877,
                        "gitlabId": 452738877,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728381,
                            "isTestReportAvailable": false,
                            "duration": 509,
                            "duration_inMinutes": 8.48,
                            "created_at": "Jan-20-22",
                            "created_at_rawDateFormat": "2022-01-20T07:03:59.317Z",
                            "testCoverage": 51.78
                        }
                    },
                    {
                        "id": 452674677,
                        "gitlabId": 452674677,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728379,
                            "isTestReportAvailable": false,
                            "duration": 565,
                            "duration_inMinutes": 9.42,
                            "created_at": "Jan-20-22",
                            "created_at_rawDateFormat": "2022-01-20T07:03:59.243Z",
                            "testCoverage": 51.78
                        }
                    },
                    {
                        "id": 452306517,
                        "gitlabId": 452306517,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728382,
                            "isTestReportAvailable": false,
                            "duration": 580,
                            "duration_inMinutes": 9.67,
                            "created_at": "Jan-20-22",
                            "created_at_rawDateFormat": "2022-01-20T07:03:59.468Z",
                            "testCoverage": 51.78
                        }
                    },
                    {
                        "id": 452302697,
                        "gitlabId": 452302697,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728385,
                            "isTestReportAvailable": false,
                            "duration": 248,
                            "duration_inMinutes": 4.13,
                            "created_at": "Jan-20-22",
                            "created_at_rawDateFormat": "2022-01-20T07:03:59.573Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 430122000,
                        "gitlabId": 430122000,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728387,
                            "isTestReportAvailable": false,
                            "duration": 580,
                            "duration_inMinutes": 9.67,
                            "created_at": "Dec-15-21",
                            "created_at_rawDateFormat": "2021-12-15T07:03:59.628Z",
                            "testCoverage": 51.78
                        }
                    },
                    {
                        "id": 421858253,
                        "gitlabId": 421858253,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728383,
                            "isTestReportAvailable": false,
                            "duration": 21,
                            "duration_inMinutes": 0.35,
                            "created_at": "Dec-03-21",
                            "created_at_rawDateFormat": "2021-12-03T07:03:59.494Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 421846786,
                        "gitlabId": 421846786,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728386,
                            "isTestReportAvailable": false,
                            "duration": 83,
                            "duration_inMinutes": 1.38,
                            "created_at": "Dec-03-21",
                            "created_at_rawDateFormat": "2021-12-03T07:03:59.621Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 421844502,
                        "gitlabId": 421844502,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728384,
                            "isTestReportAvailable": false,
                            "duration": 84,
                            "duration_inMinutes": 1.4,
                            "created_at": "Dec-03-21",
                            "created_at_rawDateFormat": "2021-12-03T07:03:59.572Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 421843649,
                        "gitlabId": 421843649,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728392,
                            "isTestReportAvailable": false,
                            "duration": 41,
                            "duration_inMinutes": 0.68,
                            "created_at": "Dec-03-21",
                            "created_at_rawDateFormat": "2021-12-03T07:03:59.932Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 421842531,
                        "gitlabId": 421842531,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728389,
                            "isTestReportAvailable": false,
                            "duration": 20,
                            "duration_inMinutes": 0.33,
                            "created_at": "Dec-03-21",
                            "created_at_rawDateFormat": "2021-12-03T07:03:59.865Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 421839843,
                        "gitlabId": 421839843,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728393,
                            "isTestReportAvailable": false,
                            "duration": 76,
                            "duration_inMinutes": 1.27,
                            "created_at": "Dec-03-21",
                            "created_at_rawDateFormat": "2021-12-03T07:03:59.999Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 421838375,
                        "gitlabId": 421838375,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728388,
                            "isTestReportAvailable": false,
                            "duration": 15,
                            "duration_inMinutes": 0.25,
                            "created_at": "Dec-03-21",
                            "created_at_rawDateFormat": "2021-12-03T07:03:59.835Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 421836448,
                        "gitlabId": 421836448,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728390,
                            "isTestReportAvailable": false,
                            "duration": 16,
                            "duration_inMinutes": 0.27,
                            "created_at": "Dec-03-21",
                            "created_at_rawDateFormat": "2021-12-03T07:03:59.885Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 421835017,
                        "gitlabId": 421835017,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728391,
                            "isTestReportAvailable": false,
                            "duration": 15,
                            "duration_inMinutes": 0.25,
                            "created_at": "Dec-03-21",
                            "created_at_rawDateFormat": "2021-12-03T07:03:59.889Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 421833290,
                        "gitlabId": 421833290,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728394,
                            "isTestReportAvailable": false,
                            "duration": 10,
                            "duration_inMinutes": 0.17,
                            "created_at": "Dec-03-21",
                            "created_at_rawDateFormat": "2021-12-03T07:04:00.118Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 421832806,
                        "gitlabId": 421832806,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728395,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-03-21",
                            "created_at_rawDateFormat": "2021-12-03T07:04:00.146Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 421831474,
                        "gitlabId": 421831474,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728396,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Dec-03-21",
                            "created_at_rawDateFormat": "2021-12-03T07:04:00.151Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 421823934,
                        "gitlabId": 421823934,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728397,
                            "isTestReportAvailable": false,
                            "duration": 9,
                            "duration_inMinutes": 0.15,
                            "created_at": "Dec-03-21",
                            "created_at_rawDateFormat": "2021-12-03T07:04:00.170Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 421820788,
                        "gitlabId": 421820788,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728398,
                            "isTestReportAvailable": false,
                            "duration": 11,
                            "duration_inMinutes": 0.18,
                            "created_at": "Dec-03-21",
                            "created_at_rawDateFormat": "2021-12-03T07:04:00.196Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 421820177,
                        "gitlabId": 421820177,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728399,
                            "isTestReportAvailable": false,
                            "duration": 9,
                            "duration_inMinutes": 0.15,
                            "created_at": "Dec-03-21",
                            "created_at_rawDateFormat": "2021-12-03T07:04:00.270Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 421818131,
                        "gitlabId": 421818131,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728403,
                            "isTestReportAvailable": false,
                            "duration": 18,
                            "duration_inMinutes": 0.3,
                            "created_at": "Dec-03-21",
                            "created_at_rawDateFormat": "2021-12-03T07:04:00.494Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 421005752,
                        "gitlabId": 421005752,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728409,
                            "isTestReportAvailable": false,
                            "duration": 399,
                            "duration_inMinutes": 6.65,
                            "created_at": "Dec-02-21",
                            "created_at_rawDateFormat": "2021-12-02T07:04:00.957Z",
                            "testCoverage": 51.78
                        }
                    },
                    {
                        "id": 419993097,
                        "gitlabId": 419993097,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728400,
                            "isTestReportAvailable": false,
                            "duration": 429,
                            "duration_inMinutes": 7.15,
                            "created_at": "Dec-01-21",
                            "created_at_rawDateFormat": "2021-12-01T07:04:00.431Z",
                            "testCoverage": 51.78
                        }
                    },
                    {
                        "id": 419992848,
                        "gitlabId": 419992848,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728402,
                            "isTestReportAvailable": false,
                            "duration": 163,
                            "duration_inMinutes": 2.72,
                            "created_at": "Dec-01-21",
                            "created_at_rawDateFormat": "2021-12-01T07:04:00.468Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 419025098,
                        "gitlabId": 419025098,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730001,
                            "isTestReportAvailable": false,
                            "duration": 396,
                            "duration_inMinutes": 6.6,
                            "created_at": "Nov-30-21",
                            "created_at_rawDateFormat": "2021-11-30T07:05:59.256Z",
                            "testCoverage": 51.78
                        }
                    },
                    {
                        "id": 419019465,
                        "gitlabId": 419019465,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730004,
                            "isTestReportAvailable": false,
                            "duration": 395,
                            "duration_inMinutes": 6.58,
                            "created_at": "Nov-30-21",
                            "created_at_rawDateFormat": "2021-11-30T07:05:59.355Z",
                            "testCoverage": 51.78
                        }
                    },
                    {
                        "id": 419008023,
                        "gitlabId": 419008023,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730005,
                            "isTestReportAvailable": false,
                            "duration": 226,
                            "duration_inMinutes": 3.77,
                            "created_at": "Nov-30-21",
                            "created_at_rawDateFormat": "2021-11-30T07:05:59.364Z",
                            "testCoverage": 50.72
                        }
                    },
                    {
                        "id": 418479893,
                        "gitlabId": 418479893,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730003,
                            "isTestReportAvailable": false,
                            "duration": 78,
                            "duration_inMinutes": 1.3,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:05:59.350Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 418471378,
                        "gitlabId": 418471378,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730007,
                            "isTestReportAvailable": false,
                            "duration": 209,
                            "duration_inMinutes": 3.48,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:05:59.522Z",
                            "testCoverage": 51.43
                        }
                    },
                    {
                        "id": 418442027,
                        "gitlabId": 418442027,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730006,
                            "isTestReportAvailable": false,
                            "duration": 363,
                            "duration_inMinutes": 6.05,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:05:59.515Z",
                            "testCoverage": 46.54
                        }
                    },
                    {
                        "id": 418405866,
                        "gitlabId": 418405866,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730008,
                            "isTestReportAvailable": false,
                            "duration": 216,
                            "duration_inMinutes": 3.6,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:05:59.620Z",
                            "testCoverage": 50.72
                        }
                    },
                    {
                        "id": 418397629,
                        "gitlabId": 418397629,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730009,
                            "isTestReportAvailable": false,
                            "duration": 364,
                            "duration_inMinutes": 6.07,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:05:59.628Z",
                            "testCoverage": 51.69
                        }
                    },
                    {
                        "id": 418392745,
                        "gitlabId": 418392745,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730011,
                            "isTestReportAvailable": false,
                            "duration": 218,
                            "duration_inMinutes": 3.63,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:05:59.779Z",
                            "testCoverage": 50.64
                        }
                    },
                    {
                        "id": 418385978,
                        "gitlabId": 418385978,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730010,
                            "isTestReportAvailable": false,
                            "duration": 219,
                            "duration_inMinutes": 3.65,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:05:59.681Z",
                            "testCoverage": 49.82
                        }
                    },
                    {
                        "id": 418361841,
                        "gitlabId": 418361841,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730015,
                            "isTestReportAvailable": false,
                            "duration": 399,
                            "duration_inMinutes": 6.65,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:05:59.927Z",
                            "testCoverage": 64.19
                        }
                    },
                    {
                        "id": 418356227,
                        "gitlabId": 418356227,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730012,
                            "isTestReportAvailable": false,
                            "duration": 394,
                            "duration_inMinutes": 6.57,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:05:59.790Z",
                            "testCoverage": 46.96
                        }
                    },
                    {
                        "id": 418356030,
                        "gitlabId": 418356030,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730013,
                            "isTestReportAvailable": false,
                            "duration": 599,
                            "duration_inMinutes": 9.98,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:05:59.884Z",
                            "testCoverage": 64.19
                        }
                    },
                    {
                        "id": 418355379,
                        "gitlabId": 418355379,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730014,
                            "isTestReportAvailable": false,
                            "duration": 245,
                            "duration_inMinutes": 4.08,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:05:59.895Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 418301053,
                        "gitlabId": 418301053,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730016,
                            "isTestReportAvailable": false,
                            "duration": 332,
                            "duration_inMinutes": 5.53,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:05:59.935Z",
                            "testCoverage": 64.19
                        }
                    },
                    {
                        "id": 418275313,
                        "gitlabId": 418275313,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730018,
                            "isTestReportAvailable": false,
                            "duration": 325,
                            "duration_inMinutes": 5.42,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:00.034Z",
                            "testCoverage": 46.96
                        }
                    },
                    {
                        "id": 418274240,
                        "gitlabId": 418274240,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730017,
                            "isTestReportAvailable": false,
                            "duration": 376,
                            "duration_inMinutes": 6.27,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:00.029Z",
                            "testCoverage": 46.44
                        }
                    },
                    {
                        "id": 418273405,
                        "gitlabId": 418273405,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730020,
                            "isTestReportAvailable": false,
                            "duration": 333,
                            "duration_inMinutes": 5.55,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:00.154Z",
                            "testCoverage": 46.28
                        }
                    },
                    {
                        "id": 418272208,
                        "gitlabId": 418272208,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730019,
                            "isTestReportAvailable": false,
                            "duration": 299,
                            "duration_inMinutes": 4.98,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:00.148Z",
                            "testCoverage": 46.28
                        }
                    },
                    {
                        "id": 418259242,
                        "gitlabId": 418259242,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730021,
                            "isTestReportAvailable": false,
                            "duration": 268,
                            "duration_inMinutes": 4.47,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:00.178Z",
                            "testCoverage": 46.28
                        }
                    },
                    {
                        "id": 418259004,
                        "gitlabId": 418259004,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730022,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:00.224Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 418258358,
                        "gitlabId": 418258358,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730023,
                            "isTestReportAvailable": false,
                            "duration": 473,
                            "duration_inMinutes": 7.88,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:00.293Z",
                            "testCoverage": 64.19
                        }
                    },
                    {
                        "id": 418258347,
                        "gitlabId": 418258347,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730024,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:00.340Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 418258027,
                        "gitlabId": 418258027,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730026,
                            "isTestReportAvailable": false,
                            "duration": 216,
                            "duration_inMinutes": 3.6,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:00.424Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 418257670,
                        "gitlabId": 418257670,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730025,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:00.417Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 418256577,
                        "gitlabId": 418256577,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730027,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:00.464Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 418254834,
                        "gitlabId": 418254834,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730034,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:01.339Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 418246823,
                        "gitlabId": 418246823,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730028,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:00.571Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 418244221,
                        "gitlabId": 418244221,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730029,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:00.594Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 418240462,
                        "gitlabId": 418240462,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730030,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:00.668Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 418239405,
                        "gitlabId": 418239405,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730048,
                            "isTestReportAvailable": false,
                            "duration": 194,
                            "duration_inMinutes": 3.23,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:02.589Z",
                            "testCoverage": 78.1
                        }
                    },
                    {
                        "id": 418239369,
                        "gitlabId": 418239369,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730047,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:02.585Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 418238619,
                        "gitlabId": 418238619,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730054,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:02.939Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 418237391,
                        "gitlabId": 418237391,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730031,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:00.837Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 418220427,
                        "gitlabId": 418220427,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730033,
                            "isTestReportAvailable": false,
                            "duration": 182,
                            "duration_inMinutes": 3.03,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:01.133Z",
                            "testCoverage": 78.1
                        }
                    },
                    {
                        "id": 418215846,
                        "gitlabId": 418215846,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730032,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:01.110Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 418208766,
                        "gitlabId": 418208766,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730035,
                            "isTestReportAvailable": false,
                            "duration": 369,
                            "duration_inMinutes": 6.15,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:01.373Z",
                            "testCoverage": 64.19
                        }
                    },
                    {
                        "id": 418197058,
                        "gitlabId": 418197058,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730036,
                            "isTestReportAvailable": false,
                            "duration": 325,
                            "duration_inMinutes": 5.42,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:01.400Z",
                            "testCoverage": 64.19
                        }
                    },
                    {
                        "id": 418190593,
                        "gitlabId": 418190593,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730037,
                            "isTestReportAvailable": false,
                            "duration": 149,
                            "duration_inMinutes": 2.48,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:01.600Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 418190528,
                        "gitlabId": 418190528,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730038,
                            "isTestReportAvailable": false,
                            "duration": 10,
                            "duration_inMinutes": 0.17,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:01.647Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 418172269,
                        "gitlabId": 418172269,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730039,
                            "isTestReportAvailable": false,
                            "duration": 420,
                            "duration_inMinutes": 7,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:01.786Z",
                            "testCoverage": 63.21
                        }
                    },
                    {
                        "id": 418162702,
                        "gitlabId": 418162702,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730040,
                            "isTestReportAvailable": false,
                            "duration": 179,
                            "duration_inMinutes": 2.98,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:01.850Z",
                            "testCoverage": 64.51
                        }
                    },
                    {
                        "id": 418151773,
                        "gitlabId": 418151773,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730042,
                            "isTestReportAvailable": false,
                            "duration": 156,
                            "duration_inMinutes": 2.6,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:02.075Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 418150055,
                        "gitlabId": 418150055,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730041,
                            "isTestReportAvailable": false,
                            "duration": 116,
                            "duration_inMinutes": 1.93,
                            "created_at": "Nov-29-21",
                            "created_at_rawDateFormat": "2021-11-29T07:06:02.042Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 417145015,
                        "gitlabId": 417145015,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730043,
                            "isTestReportAvailable": false,
                            "duration": 208,
                            "duration_inMinutes": 3.47,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:02.161Z",
                            "testCoverage": 78.1
                        }
                    },
                    {
                        "id": 417142080,
                        "gitlabId": 417142080,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730044,
                            "isTestReportAvailable": false,
                            "duration": 201,
                            "duration_inMinutes": 3.35,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:02.328Z",
                            "testCoverage": 78.1
                        }
                    },
                    {
                        "id": 417136960,
                        "gitlabId": 417136960,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730045,
                            "isTestReportAvailable": false,
                            "duration": 198,
                            "duration_inMinutes": 3.3,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:02.345Z",
                            "testCoverage": 78.1
                        }
                    },
                    {
                        "id": 417133633,
                        "gitlabId": 417133633,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730046,
                            "isTestReportAvailable": false,
                            "duration": 185,
                            "duration_inMinutes": 3.08,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:02.485Z",
                            "testCoverage": 78.1
                        }
                    },
                    {
                        "id": 417047110,
                        "gitlabId": 417047110,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730049,
                            "isTestReportAvailable": false,
                            "duration": 265,
                            "duration_inMinutes": 4.42,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:02.602Z",
                            "testCoverage": 78.1
                        }
                    },
                    {
                        "id": 417046709,
                        "gitlabId": 417046709,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730053,
                            "isTestReportAvailable": false,
                            "duration": 214,
                            "duration_inMinutes": 3.57,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:02.929Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 417045902,
                        "gitlabId": 417045902,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730050,
                            "isTestReportAvailable": false,
                            "duration": 219,
                            "duration_inMinutes": 3.65,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:02.732Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 416958049,
                        "gitlabId": 416958049,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730055,
                            "isTestReportAvailable": false,
                            "duration": 185,
                            "duration_inMinutes": 3.08,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:02.962Z",
                            "testCoverage": 78.1
                        }
                    },
                    {
                        "id": 416948993,
                        "gitlabId": 416948993,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730051,
                            "isTestReportAvailable": false,
                            "duration": 189,
                            "duration_inMinutes": 3.15,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:02.849Z",
                            "testCoverage": 78.1
                        }
                    },
                    {
                        "id": 416943067,
                        "gitlabId": 416943067,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730052,
                            "isTestReportAvailable": false,
                            "duration": 200,
                            "duration_inMinutes": 3.33,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:02.921Z",
                            "testCoverage": 78.1
                        }
                    },
                    {
                        "id": 416936954,
                        "gitlabId": 416936954,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730059,
                            "isTestReportAvailable": false,
                            "duration": 195,
                            "duration_inMinutes": 3.25,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:03.329Z",
                            "testCoverage": 78.1
                        }
                    },
                    {
                        "id": 416929900,
                        "gitlabId": 416929900,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730074,
                            "isTestReportAvailable": false,
                            "duration": 238,
                            "duration_inMinutes": 3.97,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:04.382Z",
                            "testCoverage": 78.1
                        }
                    },
                    {
                        "id": 416928884,
                        "gitlabId": 416928884,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730060,
                            "isTestReportAvailable": false,
                            "duration": 224,
                            "duration_inMinutes": 3.73,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:03.352Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 416928797,
                        "gitlabId": 416928797,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730056,
                            "isTestReportAvailable": false,
                            "duration": 286,
                            "duration_inMinutes": 4.77,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:03.198Z",
                            "testCoverage": 78.1
                        }
                    },
                    {
                        "id": 416906426,
                        "gitlabId": 416906426,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730058,
                            "isTestReportAvailable": false,
                            "duration": 185,
                            "duration_inMinutes": 3.08,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:03.302Z",
                            "testCoverage": 78.1
                        }
                    },
                    {
                        "id": 416886042,
                        "gitlabId": 416886042,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730057,
                            "isTestReportAvailable": false,
                            "duration": 196,
                            "duration_inMinutes": 3.27,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:03.220Z",
                            "testCoverage": 78.1
                        }
                    },
                    {
                        "id": 416885930,
                        "gitlabId": 416885930,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730061,
                            "isTestReportAvailable": false,
                            "duration": 7,
                            "duration_inMinutes": 0.12,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:03.476Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 416883077,
                        "gitlabId": 416883077,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730063,
                            "isTestReportAvailable": false,
                            "duration": 192,
                            "duration_inMinutes": 3.2,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:03.701Z",
                            "testCoverage": 78.1
                        }
                    },
                    {
                        "id": 416870763,
                        "gitlabId": 416870763,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730062,
                            "isTestReportAvailable": false,
                            "duration": 193,
                            "duration_inMinutes": 3.22,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:03.578Z",
                            "testCoverage": 77.88
                        }
                    },
                    {
                        "id": 416867561,
                        "gitlabId": 416867561,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730066,
                            "isTestReportAvailable": false,
                            "duration": 202,
                            "duration_inMinutes": 3.37,
                            "created_at": "Nov-26-21",
                            "created_at_rawDateFormat": "2021-11-26T07:06:03.905Z",
                            "testCoverage": 77.88
                        }
                    },
                    {
                        "id": 416332325,
                        "gitlabId": 416332325,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730065,
                            "isTestReportAvailable": false,
                            "duration": 203,
                            "duration_inMinutes": 3.38,
                            "created_at": "Nov-25-21",
                            "created_at_rawDateFormat": "2021-11-25T07:06:03.791Z",
                            "testCoverage": 77.88
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29725,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 28010331,
                "gitlabId": 28010331,
                "name": "Assembla Backup Viewer",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/assembla-backup-viewer.git",
                "stats": {
                    "id": 29717,
                    "status": "success",
                    "numberOfPipelines": 97,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 105,
                    "averageDurationOfPipelines_inMinutes": 1.75,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 93,
                    "numberOfFailedPipelines": 4,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 95.88,
                    "totalRepoSize": "7098859",
                    "artifactsSize": "136257999"
                },
                "pipelines": [
                    {
                        "id": 458347538,
                        "gitlabId": 458347538,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728198,
                            "isTestReportAvailable": false,
                            "duration": 90,
                            "duration_inMinutes": 1.5,
                            "created_at": "Jan-28-22",
                            "created_at_rawDateFormat": "2022-01-28T07:03:43.556Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 458313434,
                        "gitlabId": 458313434,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728199,
                            "isTestReportAvailable": false,
                            "duration": 170,
                            "duration_inMinutes": 2.83,
                            "created_at": "Jan-28-22",
                            "created_at_rawDateFormat": "2022-01-28T07:03:43.596Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 447167047,
                        "gitlabId": 447167047,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728202,
                            "isTestReportAvailable": false,
                            "duration": 148,
                            "duration_inMinutes": 2.47,
                            "created_at": "Jan-13-22",
                            "created_at_rawDateFormat": "2022-01-13T07:03:43.730Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 447142435,
                        "gitlabId": 447142435,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728212,
                            "isTestReportAvailable": false,
                            "duration": 156,
                            "duration_inMinutes": 2.6,
                            "created_at": "Jan-13-22",
                            "created_at_rawDateFormat": "2022-01-13T07:03:44.471Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 447106116,
                        "gitlabId": 447106116,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728203,
                            "isTestReportAvailable": false,
                            "duration": 315,
                            "duration_inMinutes": 5.25,
                            "created_at": "Jan-13-22",
                            "created_at_rawDateFormat": "2022-01-13T07:03:43.890Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 447105703,
                        "gitlabId": 447105703,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728206,
                            "isTestReportAvailable": false,
                            "duration": 158,
                            "duration_inMinutes": 2.63,
                            "created_at": "Jan-13-22",
                            "created_at_rawDateFormat": "2022-01-13T07:03:44.119Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 447088781,
                        "gitlabId": 447088781,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728205,
                            "isTestReportAvailable": false,
                            "duration": 320,
                            "duration_inMinutes": 5.33,
                            "created_at": "Jan-13-22",
                            "created_at_rawDateFormat": "2022-01-13T07:03:43.904Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 394641168,
                        "gitlabId": 394641168,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728204,
                            "isTestReportAvailable": false,
                            "duration": 114,
                            "duration_inMinutes": 1.9,
                            "created_at": "Oct-25-21",
                            "created_at_rawDateFormat": "2021-10-25T07:03:43.902Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 394638794,
                        "gitlabId": 394638794,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728208,
                            "isTestReportAvailable": false,
                            "duration": 203,
                            "duration_inMinutes": 3.38,
                            "created_at": "Oct-25-21",
                            "created_at_rawDateFormat": "2021-10-25T07:03:44.170Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 394638476,
                        "gitlabId": 394638476,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728207,
                            "isTestReportAvailable": false,
                            "duration": 116,
                            "duration_inMinutes": 1.93,
                            "created_at": "Oct-25-21",
                            "created_at_rawDateFormat": "2021-10-25T07:03:44.163Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 394626532,
                        "gitlabId": 394626532,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728209,
                            "isTestReportAvailable": false,
                            "duration": 111,
                            "duration_inMinutes": 1.85,
                            "created_at": "Oct-25-21",
                            "created_at_rawDateFormat": "2021-10-25T07:03:44.362Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 394623196,
                        "gitlabId": 394623196,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728213,
                            "isTestReportAvailable": false,
                            "duration": 113,
                            "duration_inMinutes": 1.88,
                            "created_at": "Oct-25-21",
                            "created_at_rawDateFormat": "2021-10-25T07:03:44.686Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393659290,
                        "gitlabId": 393659290,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728211,
                            "isTestReportAvailable": false,
                            "duration": 111,
                            "duration_inMinutes": 1.85,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:44.467Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393606778,
                        "gitlabId": 393606778,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728210,
                            "isTestReportAvailable": false,
                            "duration": 107,
                            "duration_inMinutes": 1.78,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:44.422Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393562180,
                        "gitlabId": 393562180,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728218,
                            "isTestReportAvailable": false,
                            "duration": 109,
                            "duration_inMinutes": 1.82,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:45.008Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393554128,
                        "gitlabId": 393554128,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728235,
                            "isTestReportAvailable": false,
                            "duration": 110,
                            "duration_inMinutes": 1.83,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:46.894Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393551165,
                        "gitlabId": 393551165,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728216,
                            "isTestReportAvailable": false,
                            "duration": 108,
                            "duration_inMinutes": 1.8,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:44.786Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393547048,
                        "gitlabId": 393547048,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728214,
                            "isTestReportAvailable": false,
                            "duration": 51,
                            "duration_inMinutes": 0.85,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:44.716Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393538546,
                        "gitlabId": 393538546,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728215,
                            "isTestReportAvailable": false,
                            "duration": 53,
                            "duration_inMinutes": 0.88,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:44.753Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393532193,
                        "gitlabId": 393532193,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728233,
                            "isTestReportAvailable": false,
                            "duration": 106,
                            "duration_inMinutes": 1.77,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:46.808Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393439986,
                        "gitlabId": 393439986,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728217,
                            "isTestReportAvailable": false,
                            "duration": 108,
                            "duration_inMinutes": 1.8,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:44.987Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393420482,
                        "gitlabId": 393420482,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728219,
                            "isTestReportAvailable": false,
                            "duration": 104,
                            "duration_inMinutes": 1.73,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:45.027Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393379578,
                        "gitlabId": 393379578,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728231,
                            "isTestReportAvailable": false,
                            "duration": 104,
                            "duration_inMinutes": 1.73,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:46.633Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393376740,
                        "gitlabId": 393376740,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728220,
                            "isTestReportAvailable": false,
                            "duration": 106,
                            "duration_inMinutes": 1.77,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:45.266Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393364233,
                        "gitlabId": 393364233,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728221,
                            "isTestReportAvailable": false,
                            "duration": 102,
                            "duration_inMinutes": 1.7,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:45.272Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393358345,
                        "gitlabId": 393358345,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728222,
                            "isTestReportAvailable": false,
                            "duration": 103,
                            "duration_inMinutes": 1.72,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:45.277Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393354178,
                        "gitlabId": 393354178,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728223,
                            "isTestReportAvailable": false,
                            "duration": 105,
                            "duration_inMinutes": 1.75,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:45.532Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393334912,
                        "gitlabId": 393334912,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728225,
                            "isTestReportAvailable": false,
                            "duration": 108,
                            "duration_inMinutes": 1.8,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:45.634Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393334293,
                        "gitlabId": 393334293,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728224,
                            "isTestReportAvailable": false,
                            "duration": 133,
                            "duration_inMinutes": 2.22,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:45.570Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393333058,
                        "gitlabId": 393333058,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728229,
                            "isTestReportAvailable": false,
                            "duration": 106,
                            "duration_inMinutes": 1.77,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:46.299Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393321511,
                        "gitlabId": 393321511,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728226,
                            "isTestReportAvailable": false,
                            "duration": 104,
                            "duration_inMinutes": 1.73,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:45.842Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 393315686,
                        "gitlabId": 393315686,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728227,
                            "isTestReportAvailable": false,
                            "duration": 110,
                            "duration_inMinutes": 1.83,
                            "created_at": "Oct-22-21",
                            "created_at_rawDateFormat": "2021-10-22T07:03:45.896Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 392827110,
                        "gitlabId": 392827110,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728228,
                            "isTestReportAvailable": false,
                            "duration": 162,
                            "duration_inMinutes": 2.7,
                            "created_at": "Oct-21-21",
                            "created_at_rawDateFormat": "2021-10-21T07:03:46.117Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 392784784,
                        "gitlabId": 392784784,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728245,
                            "isTestReportAvailable": false,
                            "duration": 184,
                            "duration_inMinutes": 3.07,
                            "created_at": "Oct-21-21",
                            "created_at_rawDateFormat": "2021-10-21T07:03:47.573Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 392731078,
                        "gitlabId": 392731078,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728230,
                            "isTestReportAvailable": false,
                            "duration": 101,
                            "duration_inMinutes": 1.68,
                            "created_at": "Oct-21-21",
                            "created_at_rawDateFormat": "2021-10-21T07:03:46.378Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 392726902,
                        "gitlabId": 392726902,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728232,
                            "isTestReportAvailable": false,
                            "duration": 99,
                            "duration_inMinutes": 1.65,
                            "created_at": "Oct-21-21",
                            "created_at_rawDateFormat": "2021-10-21T07:03:46.650Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 392720331,
                        "gitlabId": 392720331,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728234,
                            "isTestReportAvailable": false,
                            "duration": 101,
                            "duration_inMinutes": 1.68,
                            "created_at": "Oct-21-21",
                            "created_at_rawDateFormat": "2021-10-21T07:03:46.813Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 392635703,
                        "gitlabId": 392635703,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728240,
                            "isTestReportAvailable": false,
                            "duration": 102,
                            "duration_inMinutes": 1.7,
                            "created_at": "Oct-21-21",
                            "created_at_rawDateFormat": "2021-10-21T07:03:47.290Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 392631438,
                        "gitlabId": 392631438,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728236,
                            "isTestReportAvailable": false,
                            "duration": 124,
                            "duration_inMinutes": 2.07,
                            "created_at": "Oct-21-21",
                            "created_at_rawDateFormat": "2021-10-21T07:03:46.930Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 392579742,
                        "gitlabId": 392579742,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728239,
                            "isTestReportAvailable": false,
                            "duration": 94,
                            "duration_inMinutes": 1.57,
                            "created_at": "Oct-21-21",
                            "created_at_rawDateFormat": "2021-10-21T07:03:47.233Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 392527874,
                        "gitlabId": 392527874,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728237,
                            "isTestReportAvailable": false,
                            "duration": 93,
                            "duration_inMinutes": 1.55,
                            "created_at": "Oct-21-21",
                            "created_at_rawDateFormat": "2021-10-21T07:03:47.084Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 392474046,
                        "gitlabId": 392474046,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728238,
                            "isTestReportAvailable": false,
                            "duration": 93,
                            "duration_inMinutes": 1.55,
                            "created_at": "Oct-21-21",
                            "created_at_rawDateFormat": "2021-10-21T07:03:47.176Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 392454319,
                        "gitlabId": 392454319,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728243,
                            "isTestReportAvailable": false,
                            "duration": 93,
                            "duration_inMinutes": 1.55,
                            "created_at": "Oct-21-21",
                            "created_at_rawDateFormat": "2021-10-21T07:03:47.513Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 392445208,
                        "gitlabId": 392445208,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728246,
                            "isTestReportAvailable": false,
                            "duration": 93,
                            "duration_inMinutes": 1.55,
                            "created_at": "Oct-21-21",
                            "created_at_rawDateFormat": "2021-10-21T07:03:47.766Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 392439736,
                        "gitlabId": 392439736,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728241,
                            "isTestReportAvailable": false,
                            "duration": 91,
                            "duration_inMinutes": 1.52,
                            "created_at": "Oct-21-21",
                            "created_at_rawDateFormat": "2021-10-21T07:03:47.472Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 392436760,
                        "gitlabId": 392436760,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728242,
                            "isTestReportAvailable": false,
                            "duration": 94,
                            "duration_inMinutes": 1.57,
                            "created_at": "Oct-21-21",
                            "created_at_rawDateFormat": "2021-10-21T07:03:47.486Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380968670,
                        "gitlabId": 380968670,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728244,
                            "isTestReportAvailable": false,
                            "duration": 96,
                            "duration_inMinutes": 1.6,
                            "created_at": "Oct-01-21",
                            "created_at_rawDateFormat": "2021-10-01T07:03:47.566Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380950407,
                        "gitlabId": 380950407,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728248,
                            "isTestReportAvailable": false,
                            "duration": 93,
                            "duration_inMinutes": 1.55,
                            "created_at": "Oct-01-21",
                            "created_at_rawDateFormat": "2021-10-01T07:03:48.014Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380940678,
                        "gitlabId": 380940678,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728265,
                            "isTestReportAvailable": false,
                            "duration": 93,
                            "duration_inMinutes": 1.55,
                            "created_at": "Oct-01-21",
                            "created_at_rawDateFormat": "2021-10-01T07:03:50.873Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380938690,
                        "gitlabId": 380938690,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728252,
                            "isTestReportAvailable": false,
                            "duration": 95,
                            "duration_inMinutes": 1.58,
                            "created_at": "Oct-01-21",
                            "created_at_rawDateFormat": "2021-10-01T07:03:48.570Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380838519,
                        "gitlabId": 380838519,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728266,
                            "isTestReportAvailable": false,
                            "duration": 95,
                            "duration_inMinutes": 1.58,
                            "created_at": "Oct-01-21",
                            "created_at_rawDateFormat": "2021-10-01T07:03:50.979Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380810595,
                        "gitlabId": 380810595,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728247,
                            "isTestReportAvailable": false,
                            "duration": 142,
                            "duration_inMinutes": 2.37,
                            "created_at": "Oct-01-21",
                            "created_at_rawDateFormat": "2021-10-01T07:03:47.841Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380665088,
                        "gitlabId": 380665088,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728259,
                            "isTestReportAvailable": false,
                            "duration": 90,
                            "duration_inMinutes": 1.5,
                            "created_at": "Oct-01-21",
                            "created_at_rawDateFormat": "2021-10-01T07:03:49.332Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380254934,
                        "gitlabId": 380254934,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728249,
                            "isTestReportAvailable": false,
                            "duration": 110,
                            "duration_inMinutes": 1.83,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:48.105Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380180841,
                        "gitlabId": 380180841,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728250,
                            "isTestReportAvailable": false,
                            "duration": 88,
                            "duration_inMinutes": 1.47,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:48.310Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380127932,
                        "gitlabId": 380127932,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728251,
                            "isTestReportAvailable": false,
                            "duration": 90,
                            "duration_inMinutes": 1.5,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:48.365Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380092299,
                        "gitlabId": 380092299,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728253,
                            "isTestReportAvailable": false,
                            "duration": 90,
                            "duration_inMinutes": 1.5,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:48.590Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380078474,
                        "gitlabId": 380078474,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728257,
                            "isTestReportAvailable": false,
                            "duration": 90,
                            "duration_inMinutes": 1.5,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:49.254Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380076818,
                        "gitlabId": 380076818,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728254,
                            "isTestReportAvailable": false,
                            "duration": 93,
                            "duration_inMinutes": 1.55,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:48.887Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 380025043,
                        "gitlabId": 380025043,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728255,
                            "isTestReportAvailable": false,
                            "duration": 93,
                            "duration_inMinutes": 1.55,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:49.018Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 379915328,
                        "gitlabId": 379915328,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728256,
                            "isTestReportAvailable": false,
                            "duration": 87,
                            "duration_inMinutes": 1.45,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:49.147Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 379901091,
                        "gitlabId": 379901091,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728258,
                            "isTestReportAvailable": false,
                            "duration": 90,
                            "duration_inMinutes": 1.5,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:49.277Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 379900212,
                        "gitlabId": 379900212,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728267,
                            "isTestReportAvailable": false,
                            "duration": 89,
                            "duration_inMinutes": 1.48,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:50.980Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 379889577,
                        "gitlabId": 379889577,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728260,
                            "isTestReportAvailable": false,
                            "duration": 94,
                            "duration_inMinutes": 1.57,
                            "created_at": "Sep-30-21",
                            "created_at_rawDateFormat": "2021-09-30T07:03:49.568Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 379501578,
                        "gitlabId": 379501578,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728303,
                            "isTestReportAvailable": false,
                            "duration": 90,
                            "duration_inMinutes": 1.5,
                            "created_at": "Sep-29-21",
                            "created_at_rawDateFormat": "2021-09-29T07:03:54.484Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 379497115,
                        "gitlabId": 379497115,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728268,
                            "isTestReportAvailable": false,
                            "duration": 92,
                            "duration_inMinutes": 1.53,
                            "created_at": "Sep-29-21",
                            "created_at_rawDateFormat": "2021-09-29T07:03:51.095Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 379460095,
                        "gitlabId": 379460095,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728261,
                            "isTestReportAvailable": false,
                            "duration": 89,
                            "duration_inMinutes": 1.48,
                            "created_at": "Sep-29-21",
                            "created_at_rawDateFormat": "2021-09-29T07:03:49.864Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 379450260,
                        "gitlabId": 379450260,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728262,
                            "isTestReportAvailable": false,
                            "duration": 88,
                            "duration_inMinutes": 1.47,
                            "created_at": "Sep-29-21",
                            "created_at_rawDateFormat": "2021-09-29T07:03:50.130Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 379448589,
                        "gitlabId": 379448589,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728263,
                            "isTestReportAvailable": false,
                            "duration": 88,
                            "duration_inMinutes": 1.47,
                            "created_at": "Sep-29-21",
                            "created_at_rawDateFormat": "2021-09-29T07:03:50.407Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 379440626,
                        "gitlabId": 379440626,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728264,
                            "isTestReportAvailable": false,
                            "duration": 91,
                            "duration_inMinutes": 1.52,
                            "created_at": "Sep-29-21",
                            "created_at_rawDateFormat": "2021-09-29T07:03:50.824Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 379421582,
                        "gitlabId": 379421582,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728271,
                            "isTestReportAvailable": false,
                            "duration": 90,
                            "duration_inMinutes": 1.5,
                            "created_at": "Sep-29-21",
                            "created_at_rawDateFormat": "2021-09-29T07:03:51.432Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 379410466,
                        "gitlabId": 379410466,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728289,
                            "isTestReportAvailable": false,
                            "duration": 88,
                            "duration_inMinutes": 1.47,
                            "created_at": "Sep-29-21",
                            "created_at_rawDateFormat": "2021-09-29T07:03:53.140Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 379318181,
                        "gitlabId": 379318181,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728270,
                            "isTestReportAvailable": false,
                            "duration": 86,
                            "duration_inMinutes": 1.43,
                            "created_at": "Sep-29-21",
                            "created_at_rawDateFormat": "2021-09-29T07:03:51.251Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 379317081,
                        "gitlabId": 379317081,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728269,
                            "isTestReportAvailable": false,
                            "duration": 89,
                            "duration_inMinutes": 1.48,
                            "created_at": "Sep-29-21",
                            "created_at_rawDateFormat": "2021-09-29T07:03:51.238Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 379313677,
                        "gitlabId": 379313677,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728272,
                            "isTestReportAvailable": false,
                            "duration": 111,
                            "duration_inMinutes": 1.85,
                            "created_at": "Sep-29-21",
                            "created_at_rawDateFormat": "2021-09-29T07:03:51.597Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378767452,
                        "gitlabId": 378767452,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728273,
                            "isTestReportAvailable": false,
                            "duration": 92,
                            "duration_inMinutes": 1.53,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:03:51.783Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378763973,
                        "gitlabId": 378763973,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728274,
                            "isTestReportAvailable": false,
                            "duration": 85,
                            "duration_inMinutes": 1.42,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:03:51.799Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378756880,
                        "gitlabId": 378756880,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728277,
                            "isTestReportAvailable": false,
                            "duration": 87,
                            "duration_inMinutes": 1.45,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:03:52.107Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378745144,
                        "gitlabId": 378745144,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728275,
                            "isTestReportAvailable": false,
                            "duration": 85,
                            "duration_inMinutes": 1.42,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:03:51.899Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378732909,
                        "gitlabId": 378732909,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728279,
                            "isTestReportAvailable": false,
                            "duration": 84,
                            "duration_inMinutes": 1.4,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:03:52.210Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378726783,
                        "gitlabId": 378726783,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728276,
                            "isTestReportAvailable": false,
                            "duration": 84,
                            "duration_inMinutes": 1.4,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:03:52.079Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378722439,
                        "gitlabId": 378722439,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730208,
                            "isTestReportAvailable": false,
                            "duration": 87,
                            "duration_inMinutes": 1.45,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:06:13.178Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378704759,
                        "gitlabId": 378704759,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730209,
                            "isTestReportAvailable": false,
                            "duration": 102,
                            "duration_inMinutes": 1.7,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:06:13.200Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378703252,
                        "gitlabId": 378703252,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730210,
                            "isTestReportAvailable": false,
                            "duration": 84,
                            "duration_inMinutes": 1.4,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:06:13.291Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378697654,
                        "gitlabId": 378697654,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730211,
                            "isTestReportAvailable": false,
                            "duration": 86,
                            "duration_inMinutes": 1.43,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:06:13.300Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378696181,
                        "gitlabId": 378696181,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730213,
                            "isTestReportAvailable": false,
                            "duration": 85,
                            "duration_inMinutes": 1.42,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:06:13.360Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378666686,
                        "gitlabId": 378666686,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730212,
                            "isTestReportAvailable": false,
                            "duration": 84,
                            "duration_inMinutes": 1.4,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:06:13.355Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378658341,
                        "gitlabId": 378658341,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730214,
                            "isTestReportAvailable": false,
                            "duration": 84,
                            "duration_inMinutes": 1.4,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:06:13.457Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378637638,
                        "gitlabId": 378637638,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730215,
                            "isTestReportAvailable": false,
                            "duration": 104,
                            "duration_inMinutes": 1.73,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:06:13.488Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378636783,
                        "gitlabId": 378636783,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730216,
                            "isTestReportAvailable": false,
                            "duration": 82,
                            "duration_inMinutes": 1.37,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:06:13.569Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378623794,
                        "gitlabId": 378623794,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730220,
                            "isTestReportAvailable": false,
                            "duration": 84,
                            "duration_inMinutes": 1.4,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:06:13.744Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378593333,
                        "gitlabId": 378593333,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730218,
                            "isTestReportAvailable": false,
                            "duration": 80,
                            "duration_inMinutes": 1.33,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:06:13.647Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378591156,
                        "gitlabId": 378591156,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730217,
                            "isTestReportAvailable": false,
                            "duration": 84,
                            "duration_inMinutes": 1.4,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:06:13.609Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378582028,
                        "gitlabId": 378582028,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730219,
                            "isTestReportAvailable": false,
                            "duration": 85,
                            "duration_inMinutes": 1.42,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:06:13.733Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378526544,
                        "gitlabId": 378526544,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730221,
                            "isTestReportAvailable": false,
                            "duration": 80,
                            "duration_inMinutes": 1.33,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:06:13.760Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378524110,
                        "gitlabId": 378524110,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730223,
                            "isTestReportAvailable": false,
                            "duration": 80,
                            "duration_inMinutes": 1.33,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:06:14.006Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 378518766,
                        "gitlabId": 378518766,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730222,
                            "isTestReportAvailable": false,
                            "duration": 52,
                            "duration_inMinutes": 0.87,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:06:13.920Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29722,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 27247749,
                "gitlabId": 27247749,
                "name": "W11k Angular Nest Starter",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/w11k-angular-nest-starter.git",
                "stats": {
                    "id": 29719,
                    "status": "failed",
                    "numberOfPipelines": 52,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": true,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 887,
                    "averageDurationOfPipelines_inMinutes": 14.78,
                    "testCoverage": 88.16,
                    "numberOfSuccessfulPipelines": 31,
                    "numberOfFailedPipelines": 19,
                    "numberOfCanceledPipelines": 2,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 59.62,
                    "totalRepoSize": "524288",
                    "artifactsSize": "4016397"
                },
                "pipelines": [
                    {
                        "id": 472626447,
                        "gitlabId": 472626447,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730227,
                            "isTestReportAvailable": false,
                            "duration": 206,
                            "duration_inMinutes": 3.43,
                            "created_at": "Feb-16-22",
                            "created_at_rawDateFormat": "2022-02-16T07:06:14.066Z",
                            "testCoverage": 88.16
                        }
                    },
                    {
                        "id": 462671632,
                        "gitlabId": 462671632,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730224,
                            "isTestReportAvailable": false,
                            "duration": 785,
                            "duration_inMinutes": 13.08,
                            "created_at": "Feb-03-22",
                            "created_at_rawDateFormat": "2022-02-03T07:06:14.008Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 461664568,
                        "gitlabId": 461664568,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730225,
                            "isTestReportAvailable": false,
                            "duration": 544,
                            "duration_inMinutes": 9.07,
                            "created_at": "Feb-02-22",
                            "created_at_rawDateFormat": "2022-02-02T07:06:14.014Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 461573067,
                        "gitlabId": 461573067,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730226,
                            "isTestReportAvailable": false,
                            "duration": 493,
                            "duration_inMinutes": 8.22,
                            "created_at": "Feb-02-22",
                            "created_at_rawDateFormat": "2022-02-02T07:06:14.030Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 457805169,
                        "gitlabId": 457805169,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730228,
                            "isTestReportAvailable": false,
                            "duration": 486,
                            "duration_inMinutes": 8.1,
                            "created_at": "Jan-27-22",
                            "created_at_rawDateFormat": "2022-01-27T07:06:14.181Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 454593325,
                        "gitlabId": 454593325,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730230,
                            "isTestReportAvailable": false,
                            "duration": 476,
                            "duration_inMinutes": 7.93,
                            "created_at": "Jan-24-22",
                            "created_at_rawDateFormat": "2022-01-24T07:06:14.281Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 390326223,
                        "gitlabId": 390326223,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730229,
                            "isTestReportAvailable": false,
                            "duration": 452,
                            "duration_inMinutes": 7.53,
                            "created_at": "Oct-18-21",
                            "created_at_rawDateFormat": "2021-10-18T07:06:14.267Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 388876560,
                        "gitlabId": 388876560,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730233,
                            "isTestReportAvailable": false,
                            "duration": 426,
                            "duration_inMinutes": 7.1,
                            "created_at": "Oct-15-21",
                            "created_at_rawDateFormat": "2021-10-15T07:06:14.353Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 387663915,
                        "gitlabId": 387663915,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730231,
                            "isTestReportAvailable": false,
                            "duration": 372,
                            "duration_inMinutes": 6.2,
                            "created_at": "Oct-13-21",
                            "created_at_rawDateFormat": "2021-10-13T07:06:14.295Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 387647354,
                        "gitlabId": 387647354,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730232,
                            "isTestReportAvailable": false,
                            "duration": 413,
                            "duration_inMinutes": 6.88,
                            "created_at": "Oct-13-21",
                            "created_at_rawDateFormat": "2021-10-13T07:06:14.351Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 378597140,
                        "gitlabId": 378597140,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730234,
                            "isTestReportAvailable": false,
                            "duration": 373,
                            "duration_inMinutes": 6.22,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:06:14.456Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 378555720,
                        "gitlabId": 378555720,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730245,
                            "isTestReportAvailable": false,
                            "duration": 395,
                            "duration_inMinutes": 6.58,
                            "created_at": "Sep-28-21",
                            "created_at_rawDateFormat": "2021-09-28T07:06:15.239Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 344027377,
                        "gitlabId": 344027377,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730238,
                            "isTestReportAvailable": false,
                            "duration": 638,
                            "duration_inMinutes": 10.63,
                            "created_at": "Jul-28-21",
                            "created_at_rawDateFormat": "2021-07-28T07:06:14.783Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 344026556,
                        "gitlabId": 344026556,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730237,
                            "isTestReportAvailable": false,
                            "duration": 640,
                            "duration_inMinutes": 10.67,
                            "created_at": "Jul-28-21",
                            "created_at_rawDateFormat": "2021-07-28T07:06:14.686Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 338279832,
                        "gitlabId": 338279832,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730236,
                            "isTestReportAvailable": false,
                            "duration": 750,
                            "duration_inMinutes": 12.5,
                            "created_at": "Jul-16-21",
                            "created_at_rawDateFormat": "2021-07-16T07:06:14.670Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 327203220,
                        "gitlabId": 327203220,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730235,
                            "isTestReportAvailable": false,
                            "duration": 605,
                            "duration_inMinutes": 10.08,
                            "created_at": "Jun-25-21",
                            "created_at_rawDateFormat": "2021-06-25T07:06:14.653Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 327196993,
                        "gitlabId": 327196993,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730239,
                            "isTestReportAvailable": false,
                            "duration": 616,
                            "duration_inMinutes": 10.27,
                            "created_at": "Jun-25-21",
                            "created_at_rawDateFormat": "2021-06-25T07:06:14.897Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 324812181,
                        "gitlabId": 324812181,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730240,
                            "isTestReportAvailable": false,
                            "duration": 723,
                            "duration_inMinutes": 12.05,
                            "created_at": "Jun-22-21",
                            "created_at_rawDateFormat": "2021-06-22T07:06:14.924Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 324796560,
                        "gitlabId": 324796560,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730241,
                            "isTestReportAvailable": false,
                            "duration": 1153,
                            "duration_inMinutes": 19.22,
                            "created_at": "Jun-21-21",
                            "created_at_rawDateFormat": "2021-06-21T07:06:14.938Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 324786943,
                        "gitlabId": 324786943,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730242,
                            "isTestReportAvailable": false,
                            "duration": 1330,
                            "duration_inMinutes": 22.17,
                            "created_at": "Jun-21-21",
                            "created_at_rawDateFormat": "2021-06-21T07:06:14.985Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 324784533,
                        "gitlabId": 324784533,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730243,
                            "isTestReportAvailable": false,
                            "duration": 831,
                            "duration_inMinutes": 13.85,
                            "created_at": "Jun-21-21",
                            "created_at_rawDateFormat": "2021-06-21T07:06:15.064Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 324783016,
                        "gitlabId": 324783016,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 730244,
                            "isTestReportAvailable": false,
                            "duration": 329,
                            "duration_inMinutes": 5.48,
                            "created_at": "Jun-21-21",
                            "created_at_rawDateFormat": "2021-06-21T07:06:15.148Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 324774878,
                        "gitlabId": 324774878,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730248,
                            "isTestReportAvailable": false,
                            "duration": 1114,
                            "duration_inMinutes": 18.57,
                            "created_at": "Jun-21-21",
                            "created_at_rawDateFormat": "2021-06-21T07:06:15.382Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 324770181,
                        "gitlabId": 324770181,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730249,
                            "isTestReportAvailable": false,
                            "duration": 1643,
                            "duration_inMinutes": 27.38,
                            "created_at": "Jun-21-21",
                            "created_at_rawDateFormat": "2021-06-21T07:06:15.424Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 321300313,
                        "gitlabId": 321300313,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730246,
                            "isTestReportAvailable": false,
                            "duration": 1873,
                            "duration_inMinutes": 31.22,
                            "created_at": "Jun-15-21",
                            "created_at_rawDateFormat": "2021-06-15T07:06:15.325Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 320421094,
                        "gitlabId": 320421094,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730247,
                            "isTestReportAvailable": false,
                            "duration": 4629,
                            "duration_inMinutes": 77.15,
                            "created_at": "Jun-14-21",
                            "created_at_rawDateFormat": "2021-06-14T07:06:15.329Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 320331778,
                        "gitlabId": 320331778,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730254,
                            "isTestReportAvailable": false,
                            "duration": 2703,
                            "duration_inMinutes": 45.05,
                            "created_at": "Jun-14-21",
                            "created_at_rawDateFormat": "2021-06-14T07:06:15.726Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 320258482,
                        "gitlabId": 320258482,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730250,
                            "isTestReportAvailable": false,
                            "duration": 4364,
                            "duration_inMinutes": 72.73,
                            "created_at": "Jun-14-21",
                            "created_at_rawDateFormat": "2021-06-14T07:06:15.497Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 319330304,
                        "gitlabId": 319330304,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730252,
                            "isTestReportAvailable": false,
                            "duration": 3007,
                            "duration_inMinutes": 50.12,
                            "created_at": "Jun-11-21",
                            "created_at_rawDateFormat": "2021-06-11T07:06:15.593Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 319166887,
                        "gitlabId": 319166887,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730251,
                            "isTestReportAvailable": false,
                            "duration": 2047,
                            "duration_inMinutes": 34.12,
                            "created_at": "Jun-11-21",
                            "created_at_rawDateFormat": "2021-06-11T07:06:15.591Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 319161525,
                        "gitlabId": 319161525,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730256,
                            "isTestReportAvailable": false,
                            "duration": 365,
                            "duration_inMinutes": 6.08,
                            "created_at": "Jun-11-21",
                            "created_at_rawDateFormat": "2021-06-11T07:06:15.805Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 319149429,
                        "gitlabId": 319149429,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730253,
                            "isTestReportAvailable": false,
                            "duration": 1311,
                            "duration_inMinutes": 21.85,
                            "created_at": "Jun-11-21",
                            "created_at_rawDateFormat": "2021-06-11T07:06:15.695Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 319134764,
                        "gitlabId": 319134764,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 730255,
                            "isTestReportAvailable": false,
                            "duration": 1033,
                            "duration_inMinutes": 17.22,
                            "created_at": "Jun-11-21",
                            "created_at_rawDateFormat": "2021-06-11T07:06:15.767Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 319106605,
                        "gitlabId": 319106605,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730257,
                            "isTestReportAvailable": false,
                            "duration": 838,
                            "duration_inMinutes": 13.97,
                            "created_at": "Jun-11-21",
                            "created_at_rawDateFormat": "2021-06-11T07:06:15.869Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 319092381,
                        "gitlabId": 319092381,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730258,
                            "isTestReportAvailable": false,
                            "duration": 833,
                            "duration_inMinutes": 13.88,
                            "created_at": "Jun-11-21",
                            "created_at_rawDateFormat": "2021-06-11T07:06:15.910Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 319091220,
                        "gitlabId": 319091220,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730261,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-11-21",
                            "created_at_rawDateFormat": "2021-06-11T07:06:16.078Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 319078897,
                        "gitlabId": 319078897,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730259,
                            "isTestReportAvailable": false,
                            "duration": 669,
                            "duration_inMinutes": 11.15,
                            "created_at": "Jun-11-21",
                            "created_at_rawDateFormat": "2021-06-11T07:06:15.997Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 319052044,
                        "gitlabId": 319052044,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730260,
                            "isTestReportAvailable": false,
                            "duration": 762,
                            "duration_inMinutes": 12.7,
                            "created_at": "Jun-11-21",
                            "created_at_rawDateFormat": "2021-06-11T07:06:16.028Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 318520586,
                        "gitlabId": 318520586,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730262,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-10-21",
                            "created_at_rawDateFormat": "2021-06-10T07:06:16.108Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 317154821,
                        "gitlabId": 317154821,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730269,
                            "isTestReportAvailable": false,
                            "duration": 91,
                            "duration_inMinutes": 1.52,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:06:16.449Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 317154455,
                        "gitlabId": 317154455,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730263,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:06:16.178Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 317046043,
                        "gitlabId": 317046043,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730264,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:06:16.297Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 317017637,
                        "gitlabId": 317017637,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730265,
                            "isTestReportAvailable": false,
                            "duration": 1062,
                            "duration_inMinutes": 17.7,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:06:16.320Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316875203,
                        "gitlabId": 316875203,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730266,
                            "isTestReportAvailable": false,
                            "duration": 1019,
                            "duration_inMinutes": 16.98,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:06:16.350Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316868129,
                        "gitlabId": 316868129,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730267,
                            "isTestReportAvailable": false,
                            "duration": 386,
                            "duration_inMinutes": 6.43,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:06:16.412Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316847610,
                        "gitlabId": 316847610,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730268,
                            "isTestReportAvailable": false,
                            "duration": 1620,
                            "duration_inMinutes": 27,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:06:16.445Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316833605,
                        "gitlabId": 316833605,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730271,
                            "isTestReportAvailable": false,
                            "duration": 920,
                            "duration_inMinutes": 15.33,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:06:16.572Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316817111,
                        "gitlabId": 316817111,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730270,
                            "isTestReportAvailable": false,
                            "duration": 630,
                            "duration_inMinutes": 10.5,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:06:16.565Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316814474,
                        "gitlabId": 316814474,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730272,
                            "isTestReportAvailable": false,
                            "duration": 62,
                            "duration_inMinutes": 1.03,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:06:16.627Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316812447,
                        "gitlabId": 316812447,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730273,
                            "isTestReportAvailable": false,
                            "duration": 55,
                            "duration_inMinutes": 0.92,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:06:16.710Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316811005,
                        "gitlabId": 316811005,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730275,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:06:16.810Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316808745,
                        "gitlabId": 316808745,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730274,
                            "isTestReportAvailable": false,
                            "duration": 57,
                            "duration_inMinutes": 0.95,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:06:16.725Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29723,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 25445742,
                "gitlabId": 25445742,
                "name": "csv-file modifier",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/csv-file-modifier.git",
                "stats": {
                    "id": 29736,
                    "status": "skipped",
                    "numberOfPipelines": 25,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 3,
                    "averageDurationOfPipelines_inMinutes": 0.05,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 11,
                    "numberOfFailedPipelines": 10,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 4,
                    "pipelinesSuccessRatio": 44,
                    "totalRepoSize": "2097152",
                    "artifactsSize": "152227530"
                },
                "pipelines": [
                    {
                        "id": 348390233,
                        "gitlabId": 348390233,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 730276,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Aug-05-21",
                            "created_at_rawDateFormat": "2021-08-05T07:06:16.843Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 345394241,
                        "gitlabId": 345394241,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 730282,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jul-30-21",
                            "created_at_rawDateFormat": "2021-07-30T07:06:17.207Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 330711259,
                        "gitlabId": 330711259,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 730277,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jul-02-21",
                            "created_at_rawDateFormat": "2021-07-02T07:06:16.886Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 318251485,
                        "gitlabId": 318251485,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730278,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-10-21",
                            "created_at_rawDateFormat": "2021-06-10T07:06:16.983Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 318219715,
                        "gitlabId": 318219715,
                        "status": "skipped",
                        "testReport": null,
                        "stats": {
                            "id": 730279,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-10-21",
                            "created_at_rawDateFormat": "2021-06-10T07:06:17.001Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 318204329,
                        "gitlabId": 318204329,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730280,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-10-21",
                            "created_at_rawDateFormat": "2021-06-10T07:06:17.120Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316657040,
                        "gitlabId": 316657040,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730281,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:06:17.136Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316652159,
                        "gitlabId": 316652159,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730285,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:06:17.304Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316646810,
                        "gitlabId": 316646810,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730283,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:06:17.251Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316258839,
                        "gitlabId": 316258839,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730284,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-07-21",
                            "created_at_rawDateFormat": "2021-06-07T07:06:17.262Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316245549,
                        "gitlabId": 316245549,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730286,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-07-21",
                            "created_at_rawDateFormat": "2021-06-07T07:06:17.387Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316229928,
                        "gitlabId": 316229928,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730287,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-07-21",
                            "created_at_rawDateFormat": "2021-06-07T07:06:17.409Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316228484,
                        "gitlabId": 316228484,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730288,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-07-21",
                            "created_at_rawDateFormat": "2021-06-07T07:06:17.469Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316219882,
                        "gitlabId": 316219882,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730290,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-07-21",
                            "created_at_rawDateFormat": "2021-06-07T07:06:17.587Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316211073,
                        "gitlabId": 316211073,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730289,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-07-21",
                            "created_at_rawDateFormat": "2021-06-07T07:06:17.527Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316193209,
                        "gitlabId": 316193209,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730293,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-07-21",
                            "created_at_rawDateFormat": "2021-06-07T07:06:17.781Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316192244,
                        "gitlabId": 316192244,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730295,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-07-21",
                            "created_at_rawDateFormat": "2021-06-07T07:06:17.832Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316190797,
                        "gitlabId": 316190797,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730291,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-07-21",
                            "created_at_rawDateFormat": "2021-06-07T07:06:17.760Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316188970,
                        "gitlabId": 316188970,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730292,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-07-21",
                            "created_at_rawDateFormat": "2021-06-07T07:06:17.771Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316187623,
                        "gitlabId": 316187623,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730294,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-07-21",
                            "created_at_rawDateFormat": "2021-06-07T07:06:17.807Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316185505,
                        "gitlabId": 316185505,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730296,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-07-21",
                            "created_at_rawDateFormat": "2021-06-07T07:06:17.844Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316184334,
                        "gitlabId": 316184334,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730299,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-07-21",
                            "created_at_rawDateFormat": "2021-06-07T07:06:18.101Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316180552,
                        "gitlabId": 316180552,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730301,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-07-21",
                            "created_at_rawDateFormat": "2021-06-07T07:06:18.197Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 306389434,
                        "gitlabId": 306389434,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730297,
                            "isTestReportAvailable": false,
                            "duration": 26,
                            "duration_inMinutes": 0.43,
                            "created_at": "May-20-21",
                            "created_at_rawDateFormat": "2021-05-20T07:06:18.057Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 306354388,
                        "gitlabId": 306354388,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730298,
                            "isTestReportAvailable": false,
                            "duration": 42,
                            "duration_inMinutes": 0.7,
                            "created_at": "May-20-21",
                            "created_at_rawDateFormat": "2021-05-20T07:06:18.077Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29724,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 25291707,
                "gitlabId": 25291707,
                "name": "W11K-Termine-Stats",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/w11k-termine-stats.git",
                "stats": {
                    "id": 29737,
                    "status": "success",
                    "numberOfPipelines": 6,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 237,
                    "averageDurationOfPipelines_inMinutes": 3.95,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 3,
                    "numberOfFailedPipelines": 3,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 50,
                    "totalRepoSize": "1866465",
                    "artifactsSize": "7933980"
                },
                "pipelines": [
                    {
                        "id": 491802513,
                        "gitlabId": 491802513,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730064,
                            "isTestReportAvailable": false,
                            "duration": 312,
                            "duration_inMinutes": 5.2,
                            "created_at": "Mar-14-22",
                            "created_at_rawDateFormat": "2022-03-14T07:06:03.757Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 490014520,
                        "gitlabId": 490014520,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730067,
                            "isTestReportAvailable": false,
                            "duration": 641,
                            "duration_inMinutes": 10.68,
                            "created_at": "Mar-11-22",
                            "created_at_rawDateFormat": "2022-03-11T07:06:03.943Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 489991672,
                        "gitlabId": 489991672,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730068,
                            "isTestReportAvailable": false,
                            "duration": 279,
                            "duration_inMinutes": 4.65,
                            "created_at": "Mar-11-22",
                            "created_at_rawDateFormat": "2022-03-11T07:06:04.036Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 489981276,
                        "gitlabId": 489981276,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730075,
                            "isTestReportAvailable": false,
                            "duration": 164,
                            "duration_inMinutes": 2.73,
                            "created_at": "Mar-11-22",
                            "created_at_rawDateFormat": "2022-03-11T07:06:04.401Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 489973858,
                        "gitlabId": 489973858,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730069,
                            "isTestReportAvailable": false,
                            "duration": 12,
                            "duration_inMinutes": 0.2,
                            "created_at": "Mar-11-22",
                            "created_at_rawDateFormat": "2022-03-11T07:06:04.062Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 489968920,
                        "gitlabId": 489968920,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730070,
                            "isTestReportAvailable": false,
                            "duration": 12,
                            "duration_inMinutes": 0.2,
                            "created_at": "Mar-11-22",
                            "created_at_rawDateFormat": "2022-03-11T07:06:04.168Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29726,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 25188286,
                "gitlabId": 25188286,
                "name": "GDrive-Anonymous-Upload",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/gdrive-anonymous-upload.git",
                "stats": {
                    "id": 29716,
                    "status": "success",
                    "numberOfPipelines": 53,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": true,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 194,
                    "averageDurationOfPipelines_inMinutes": 3.23,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 21,
                    "numberOfFailedPipelines": 31,
                    "numberOfCanceledPipelines": 1,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 39.62,
                    "totalRepoSize": "2191523",
                    "artifactsSize": "2077599"
                },
                "pipelines": [
                    {
                        "id": 350060551,
                        "gitlabId": 350060551,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730302,
                            "isTestReportAvailable": false,
                            "duration": 285,
                            "duration_inMinutes": 4.75,
                            "created_at": "Aug-09-21",
                            "created_at_rawDateFormat": "2021-08-09T07:06:18.334Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 348297302,
                        "gitlabId": 348297302,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730300,
                            "isTestReportAvailable": false,
                            "duration": 268,
                            "duration_inMinutes": 4.47,
                            "created_at": "Aug-05-21",
                            "created_at_rawDateFormat": "2021-08-05T07:06:18.130Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 347808252,
                        "gitlabId": 347808252,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730309,
                            "isTestReportAvailable": false,
                            "duration": 300,
                            "duration_inMinutes": 5,
                            "created_at": "Aug-04-21",
                            "created_at_rawDateFormat": "2021-08-04T07:06:18.832Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 347803284,
                        "gitlabId": 347803284,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730308,
                            "isTestReportAvailable": false,
                            "duration": 92,
                            "duration_inMinutes": 1.53,
                            "created_at": "Aug-04-21",
                            "created_at_rawDateFormat": "2021-08-04T07:06:18.734Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 347587411,
                        "gitlabId": 347587411,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730303,
                            "isTestReportAvailable": false,
                            "duration": 269,
                            "duration_inMinutes": 4.48,
                            "created_at": "Aug-04-21",
                            "created_at_rawDateFormat": "2021-08-04T07:06:18.368Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 347224768,
                        "gitlabId": 347224768,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730304,
                            "isTestReportAvailable": false,
                            "duration": 304,
                            "duration_inMinutes": 5.07,
                            "created_at": "Aug-03-21",
                            "created_at_rawDateFormat": "2021-08-03T07:06:18.397Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 346967405,
                        "gitlabId": 346967405,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730314,
                            "isTestReportAvailable": false,
                            "duration": 354,
                            "duration_inMinutes": 5.9,
                            "created_at": "Aug-03-21",
                            "created_at_rawDateFormat": "2021-08-03T07:06:19.131Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 346958851,
                        "gitlabId": 346958851,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730305,
                            "isTestReportAvailable": false,
                            "duration": 297,
                            "duration_inMinutes": 4.95,
                            "created_at": "Aug-03-21",
                            "created_at_rawDateFormat": "2021-08-03T07:06:18.589Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 346653466,
                        "gitlabId": 346653466,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730306,
                            "isTestReportAvailable": false,
                            "duration": 112,
                            "duration_inMinutes": 1.87,
                            "created_at": "Aug-02-21",
                            "created_at_rawDateFormat": "2021-08-02T07:06:18.649Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 346651130,
                        "gitlabId": 346651130,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730307,
                            "isTestReportAvailable": false,
                            "duration": 92,
                            "duration_inMinutes": 1.53,
                            "created_at": "Aug-02-21",
                            "created_at_rawDateFormat": "2021-08-02T07:06:18.706Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 346644410,
                        "gitlabId": 346644410,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730310,
                            "isTestReportAvailable": false,
                            "duration": 91,
                            "duration_inMinutes": 1.52,
                            "created_at": "Aug-02-21",
                            "created_at_rawDateFormat": "2021-08-02T07:06:18.868Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 346389216,
                        "gitlabId": 346389216,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730311,
                            "isTestReportAvailable": false,
                            "duration": 303,
                            "duration_inMinutes": 5.05,
                            "created_at": "Aug-02-21",
                            "created_at_rawDateFormat": "2021-08-02T07:06:18.914Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 346348346,
                        "gitlabId": 346348346,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730312,
                            "isTestReportAvailable": false,
                            "duration": 310,
                            "duration_inMinutes": 5.17,
                            "created_at": "Aug-02-21",
                            "created_at_rawDateFormat": "2021-08-02T07:06:18.997Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 345565053,
                        "gitlabId": 345565053,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730313,
                            "isTestReportAvailable": false,
                            "duration": 307,
                            "duration_inMinutes": 5.12,
                            "created_at": "Jul-30-21",
                            "created_at_rawDateFormat": "2021-07-30T07:06:19.016Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 345562157,
                        "gitlabId": 345562157,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730317,
                            "isTestReportAvailable": false,
                            "duration": 103,
                            "duration_inMinutes": 1.72,
                            "created_at": "Jul-30-21",
                            "created_at_rawDateFormat": "2021-07-30T07:06:19.253Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 344729183,
                        "gitlabId": 344729183,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730315,
                            "isTestReportAvailable": false,
                            "duration": 280,
                            "duration_inMinutes": 4.67,
                            "created_at": "Jul-29-21",
                            "created_at_rawDateFormat": "2021-07-29T07:06:19.154Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 344070757,
                        "gitlabId": 344070757,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730316,
                            "isTestReportAvailable": false,
                            "duration": 273,
                            "duration_inMinutes": 4.55,
                            "created_at": "Jul-28-21",
                            "created_at_rawDateFormat": "2021-07-28T07:06:19.186Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 344056178,
                        "gitlabId": 344056178,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730320,
                            "isTestReportAvailable": false,
                            "duration": 277,
                            "duration_inMinutes": 4.62,
                            "created_at": "Jul-28-21",
                            "created_at_rawDateFormat": "2021-07-28T07:06:19.409Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 344027735,
                        "gitlabId": 344027735,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730318,
                            "isTestReportAvailable": false,
                            "duration": 435,
                            "duration_inMinutes": 7.25,
                            "created_at": "Jul-28-21",
                            "created_at_rawDateFormat": "2021-07-28T07:06:19.270Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 343618940,
                        "gitlabId": 343618940,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730319,
                            "isTestReportAvailable": false,
                            "duration": 315,
                            "duration_inMinutes": 5.25,
                            "created_at": "Jul-27-21",
                            "created_at_rawDateFormat": "2021-07-27T07:06:19.389Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 343616447,
                        "gitlabId": 343616447,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730321,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jul-27-21",
                            "created_at_rawDateFormat": "2021-07-27T07:06:19.428Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 343596590,
                        "gitlabId": 343596590,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730327,
                            "isTestReportAvailable": false,
                            "duration": 223,
                            "duration_inMinutes": 3.72,
                            "created_at": "Jul-27-21",
                            "created_at_rawDateFormat": "2021-07-27T07:06:19.724Z",
                            "testCoverage": 45.29
                        }
                    },
                    {
                        "id": 343579690,
                        "gitlabId": 343579690,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730322,
                            "isTestReportAvailable": false,
                            "duration": 119,
                            "duration_inMinutes": 1.98,
                            "created_at": "Jul-27-21",
                            "created_at_rawDateFormat": "2021-07-27T07:06:19.519Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 343579614,
                        "gitlabId": 343579614,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 730323,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jul-27-21",
                            "created_at_rawDateFormat": "2021-07-27T07:06:19.524Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 343576225,
                        "gitlabId": 343576225,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730324,
                            "isTestReportAvailable": false,
                            "duration": 95,
                            "duration_inMinutes": 1.58,
                            "created_at": "Jul-27-21",
                            "created_at_rawDateFormat": "2021-07-27T07:06:19.652Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 343524858,
                        "gitlabId": 343524858,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730325,
                            "isTestReportAvailable": false,
                            "duration": 73,
                            "duration_inMinutes": 1.22,
                            "created_at": "Jul-27-21",
                            "created_at_rawDateFormat": "2021-07-27T07:06:19.659Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 343366496,
                        "gitlabId": 343366496,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730326,
                            "isTestReportAvailable": false,
                            "duration": 65,
                            "duration_inMinutes": 1.08,
                            "created_at": "Jul-27-21",
                            "created_at_rawDateFormat": "2021-07-27T07:06:19.682Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 343362152,
                        "gitlabId": 343362152,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730328,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jul-27-21",
                            "created_at_rawDateFormat": "2021-07-27T07:06:19.782Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 341259869,
                        "gitlabId": 341259869,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730329,
                            "isTestReportAvailable": false,
                            "duration": 137,
                            "duration_inMinutes": 2.28,
                            "created_at": "Jul-22-21",
                            "created_at_rawDateFormat": "2021-07-22T07:06:19.789Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 340616313,
                        "gitlabId": 340616313,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730335,
                            "isTestReportAvailable": false,
                            "duration": 629,
                            "duration_inMinutes": 10.48,
                            "created_at": "Jul-21-21",
                            "created_at_rawDateFormat": "2021-07-21T07:06:20.073Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 340589090,
                        "gitlabId": 340589090,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730331,
                            "isTestReportAvailable": false,
                            "duration": 393,
                            "duration_inMinutes": 6.55,
                            "created_at": "Jul-21-21",
                            "created_at_rawDateFormat": "2021-07-21T07:06:19.964Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 340584756,
                        "gitlabId": 340584756,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730330,
                            "isTestReportAvailable": false,
                            "duration": 11,
                            "duration_inMinutes": 0.18,
                            "created_at": "Jul-21-21",
                            "created_at_rawDateFormat": "2021-07-21T07:06:19.952Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 340581423,
                        "gitlabId": 340581423,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730332,
                            "isTestReportAvailable": false,
                            "duration": 99,
                            "duration_inMinutes": 1.65,
                            "created_at": "Jul-21-21",
                            "created_at_rawDateFormat": "2021-07-21T07:06:20.008Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 340581219,
                        "gitlabId": 340581219,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730333,
                            "isTestReportAvailable": false,
                            "duration": 37,
                            "duration_inMinutes": 0.62,
                            "created_at": "Jul-21-21",
                            "created_at_rawDateFormat": "2021-07-21T07:06:20.060Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 340578715,
                        "gitlabId": 340578715,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730334,
                            "isTestReportAvailable": false,
                            "duration": 33,
                            "duration_inMinutes": 0.55,
                            "created_at": "Jul-21-21",
                            "created_at_rawDateFormat": "2021-07-21T07:06:20.072Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 340571995,
                        "gitlabId": 340571995,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730336,
                            "isTestReportAvailable": false,
                            "duration": 12,
                            "duration_inMinutes": 0.2,
                            "created_at": "Jul-21-21",
                            "created_at_rawDateFormat": "2021-07-21T07:06:20.220Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 340567486,
                        "gitlabId": 340567486,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730340,
                            "isTestReportAvailable": false,
                            "duration": 18,
                            "duration_inMinutes": 0.3,
                            "created_at": "Jul-21-21",
                            "created_at_rawDateFormat": "2021-07-21T07:06:20.402Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 340477559,
                        "gitlabId": 340477559,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730339,
                            "isTestReportAvailable": false,
                            "duration": 22,
                            "duration_inMinutes": 0.37,
                            "created_at": "Jul-21-21",
                            "created_at_rawDateFormat": "2021-07-21T07:06:20.351Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 339765467,
                        "gitlabId": 339765467,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730341,
                            "isTestReportAvailable": false,
                            "duration": 11,
                            "duration_inMinutes": 0.18,
                            "created_at": "Jul-20-21",
                            "created_at_rawDateFormat": "2021-07-20T07:06:20.565Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 336921294,
                        "gitlabId": 336921294,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730338,
                            "isTestReportAvailable": false,
                            "duration": 15,
                            "duration_inMinutes": 0.25,
                            "created_at": "Jul-14-21",
                            "created_at_rawDateFormat": "2021-07-14T07:06:20.333Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 336186622,
                        "gitlabId": 336186622,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730337,
                            "isTestReportAvailable": false,
                            "duration": 16,
                            "duration_inMinutes": 0.27,
                            "created_at": "Jul-13-21",
                            "created_at_rawDateFormat": "2021-07-13T07:06:20.328Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 336185612,
                        "gitlabId": 336185612,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730344,
                            "isTestReportAvailable": false,
                            "duration": 21,
                            "duration_inMinutes": 0.35,
                            "created_at": "Jul-13-21",
                            "created_at_rawDateFormat": "2021-07-13T07:06:20.632Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 336168365,
                        "gitlabId": 336168365,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730342,
                            "isTestReportAvailable": false,
                            "duration": 17,
                            "duration_inMinutes": 0.28,
                            "created_at": "Jul-13-21",
                            "created_at_rawDateFormat": "2021-07-13T07:06:20.579Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 336167940,
                        "gitlabId": 336167940,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730343,
                            "isTestReportAvailable": false,
                            "duration": 21,
                            "duration_inMinutes": 0.35,
                            "created_at": "Jul-13-21",
                            "created_at_rawDateFormat": "2021-07-13T07:06:20.598Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 336161139,
                        "gitlabId": 336161139,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730360,
                            "isTestReportAvailable": false,
                            "duration": 86,
                            "duration_inMinutes": 1.43,
                            "created_at": "Jul-13-21",
                            "created_at_rawDateFormat": "2021-07-13T07:06:21.629Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 329807215,
                        "gitlabId": 329807215,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730345,
                            "isTestReportAvailable": false,
                            "duration": 161,
                            "duration_inMinutes": 2.68,
                            "created_at": "Jun-30-21",
                            "created_at_rawDateFormat": "2021-06-30T07:06:20.679Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 318245787,
                        "gitlabId": 318245787,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730346,
                            "isTestReportAvailable": false,
                            "duration": 192,
                            "duration_inMinutes": 3.2,
                            "created_at": "Jun-10-21",
                            "created_at_rawDateFormat": "2021-06-10T07:06:20.822Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316982461,
                        "gitlabId": 316982461,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730347,
                            "isTestReportAvailable": false,
                            "duration": 412,
                            "duration_inMinutes": 6.87,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:06:20.847Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 316977735,
                        "gitlabId": 316977735,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730348,
                            "isTestReportAvailable": false,
                            "duration": 220,
                            "duration_inMinutes": 3.67,
                            "created_at": "Jun-08-21",
                            "created_at_rawDateFormat": "2021-06-08T07:06:20.873Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 312804189,
                        "gitlabId": 312804189,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730354,
                            "isTestReportAvailable": false,
                            "duration": 924,
                            "duration_inMinutes": 15.4,
                            "created_at": "Jun-01-21",
                            "created_at_rawDateFormat": "2021-06-01T07:06:21.347Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 312785446,
                        "gitlabId": 312785446,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730349,
                            "isTestReportAvailable": false,
                            "duration": 697,
                            "duration_inMinutes": 11.62,
                            "created_at": "Jun-01-21",
                            "created_at_rawDateFormat": "2021-06-01T07:06:20.933Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 312432860,
                        "gitlabId": 312432860,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730350,
                            "isTestReportAvailable": false,
                            "duration": 217,
                            "duration_inMinutes": 3.62,
                            "created_at": "May-31-21",
                            "created_at_rawDateFormat": "2021-05-31T07:06:21.105Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 312347825,
                        "gitlabId": 312347825,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730351,
                            "isTestReportAvailable": false,
                            "duration": 247,
                            "duration_inMinutes": 4.12,
                            "created_at": "May-31-21",
                            "created_at_rawDateFormat": "2021-05-31T07:06:21.119Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29727,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 21969185,
                "gitlabId": 21969185,
                "name": "angular-gitlab-template",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/angular-gitlab-template.git",
                "stats": {
                    "id": 29747,
                    "status": "success",
                    "numberOfPipelines": 10,
                    "areTestsAvailable": true,
                    "areTestCoveragesAvailable": true,
                    "numberOfTestReports": 1,
                    "averageDurationOfPipelines": 206,
                    "averageDurationOfPipelines_inMinutes": 3.43,
                    "testCoverage": 100,
                    "numberOfSuccessfulPipelines": 5,
                    "numberOfFailedPipelines": 5,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 50,
                    "totalRepoSize": "450887",
                    "artifactsSize": "105950"
                },
                "pipelines": [
                    {
                        "id": 297525994,
                        "gitlabId": 297525994,
                        "status": "success",
                        "testReport": {
                            "id": 46819,
                            "error_count": 0,
                            "failed_count": 0,
                            "skipped_count": 0,
                            "success_count": 3,
                            "total_count": 3,
                            "total_time": 0.19,
                            "test_suites": [
                                {
                                    "id": 54157,
                                    "total_time": 0.19,
                                    "total_count": 3,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "test-angular",
                                    "skipped_count": 0,
                                    "success_count": 3,
                                    "test_cases": [
                                        {
                                            "id": 3566831,
                                            "classname": "AppComponent",
                                            "execution_time": 0.02,
                                            "name": "AppComponent should render title",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3566821,
                                            "classname": "AppComponent",
                                            "execution_time": 0.15,
                                            "name": "AppComponent should have as title 'gitlab-template'",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3566826,
                                            "classname": "AppComponent",
                                            "execution_time": 0.02,
                                            "name": "AppComponent should create the app",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 730352,
                            "isTestReportAvailable": true,
                            "duration": 803,
                            "duration_inMinutes": 13.38,
                            "created_at": "May-05-21",
                            "created_at_rawDateFormat": "2021-05-05T07:06:21.147Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 296800996,
                        "gitlabId": 296800996,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730353,
                            "isTestReportAvailable": false,
                            "duration": 601,
                            "duration_inMinutes": 10.02,
                            "created_at": "May-04-21",
                            "created_at_rawDateFormat": "2021-05-04T07:06:21.206Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 206691171,
                        "gitlabId": 206691171,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730355,
                            "isTestReportAvailable": false,
                            "duration": 161,
                            "duration_inMinutes": 2.68,
                            "created_at": "Oct-23-20",
                            "created_at_rawDateFormat": "2020-10-23T07:06:21.372Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 206689949,
                        "gitlabId": 206689949,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730358,
                            "isTestReportAvailable": false,
                            "duration": 149,
                            "duration_inMinutes": 2.48,
                            "created_at": "Oct-23-20",
                            "created_at_rawDateFormat": "2020-10-23T07:06:21.619Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 206688201,
                        "gitlabId": 206688201,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730356,
                            "isTestReportAvailable": false,
                            "duration": 173,
                            "duration_inMinutes": 2.88,
                            "created_at": "Oct-23-20",
                            "created_at_rawDateFormat": "2020-10-23T07:06:21.452Z",
                            "testCoverage": 100
                        }
                    },
                    {
                        "id": 206684197,
                        "gitlabId": 206684197,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730361,
                            "isTestReportAvailable": false,
                            "duration": 175,
                            "duration_inMinutes": 2.92,
                            "created_at": "Oct-23-20",
                            "created_at_rawDateFormat": "2020-10-23T07:06:21.638Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 206683892,
                        "gitlabId": 206683892,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730357,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Oct-23-20",
                            "created_at_rawDateFormat": "2020-10-23T07:06:21.588Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 206683735,
                        "gitlabId": 206683735,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730359,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Oct-23-20",
                            "created_at_rawDateFormat": "2020-10-23T07:06:21.623Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 206683212,
                        "gitlabId": 206683212,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730362,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Oct-23-20",
                            "created_at_rawDateFormat": "2020-10-23T07:06:21.743Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 206682268,
                        "gitlabId": 206682268,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730367,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Oct-23-20",
                            "created_at_rawDateFormat": "2020-10-23T07:06:22.105Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29728,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 21517690,
                "gitlabId": 21517690,
                "name": "Random Generator",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/random-generator.git",
                "stats": {
                    "id": 29754,
                    "status": "failed",
                    "numberOfPipelines": 56,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 237,
                    "averageDurationOfPipelines_inMinutes": 3.95,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 34,
                    "numberOfFailedPipelines": 22,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 60.71,
                    "totalRepoSize": "786432",
                    "artifactsSize": "19338846"
                },
                "pipelines": [
                    {
                        "id": 431692934,
                        "gitlabId": 431692934,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730363,
                            "isTestReportAvailable": false,
                            "duration": 70,
                            "duration_inMinutes": 1.17,
                            "created_at": "Dec-17-21",
                            "created_at_rawDateFormat": "2021-12-17T07:06:21.877Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 370226712,
                        "gitlabId": 370226712,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730365,
                            "isTestReportAvailable": false,
                            "duration": 171,
                            "duration_inMinutes": 2.85,
                            "created_at": "Sep-14-21",
                            "created_at_rawDateFormat": "2021-09-14T07:06:21.898Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 369540715,
                        "gitlabId": 369540715,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730366,
                            "isTestReportAvailable": false,
                            "duration": 172,
                            "duration_inMinutes": 2.87,
                            "created_at": "Sep-13-21",
                            "created_at_rawDateFormat": "2021-09-13T07:06:21.916Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 339401060,
                        "gitlabId": 339401060,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730364,
                            "isTestReportAvailable": false,
                            "duration": 159,
                            "duration_inMinutes": 2.65,
                            "created_at": "Jul-19-21",
                            "created_at_rawDateFormat": "2021-07-19T07:06:21.893Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 339398861,
                        "gitlabId": 339398861,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730371,
                            "isTestReportAvailable": false,
                            "duration": 169,
                            "duration_inMinutes": 2.82,
                            "created_at": "Jul-19-21",
                            "created_at_rawDateFormat": "2021-07-19T07:06:22.293Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 339395465,
                        "gitlabId": 339395465,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730368,
                            "isTestReportAvailable": false,
                            "duration": 281,
                            "duration_inMinutes": 4.68,
                            "created_at": "Jul-19-21",
                            "created_at_rawDateFormat": "2021-07-19T07:06:22.142Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 330913841,
                        "gitlabId": 330913841,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730369,
                            "isTestReportAvailable": false,
                            "duration": 48,
                            "duration_inMinutes": 0.8,
                            "created_at": "Jul-02-21",
                            "created_at_rawDateFormat": "2021-07-02T07:06:22.163Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 330736214,
                        "gitlabId": 330736214,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730370,
                            "isTestReportAvailable": false,
                            "duration": 79,
                            "duration_inMinutes": 1.32,
                            "created_at": "Jul-02-21",
                            "created_at_rawDateFormat": "2021-07-02T07:06:22.186Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 328869563,
                        "gitlabId": 328869563,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730375,
                            "isTestReportAvailable": false,
                            "duration": 129,
                            "duration_inMinutes": 2.15,
                            "created_at": "Jun-29-21",
                            "created_at_rawDateFormat": "2021-06-29T07:06:22.573Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 291069026,
                        "gitlabId": 291069026,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730374,
                            "isTestReportAvailable": false,
                            "duration": 251,
                            "duration_inMinutes": 4.18,
                            "created_at": "Apr-23-21",
                            "created_at_rawDateFormat": "2021-04-23T07:06:22.541Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 277210406,
                        "gitlabId": 277210406,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730372,
                            "isTestReportAvailable": false,
                            "duration": 111,
                            "duration_inMinutes": 1.85,
                            "created_at": "Mar-26-21",
                            "created_at_rawDateFormat": "2021-03-26T07:06:22.413Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 270758174,
                        "gitlabId": 270758174,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730373,
                            "isTestReportAvailable": false,
                            "duration": 137,
                            "duration_inMinutes": 2.28,
                            "created_at": "Mar-15-21",
                            "created_at_rawDateFormat": "2021-03-15T07:06:22.427Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 259894350,
                        "gitlabId": 259894350,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730376,
                            "isTestReportAvailable": false,
                            "duration": 155,
                            "duration_inMinutes": 2.58,
                            "created_at": "Feb-22-21",
                            "created_at_rawDateFormat": "2021-02-22T07:06:22.596Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 254932472,
                        "gitlabId": 254932472,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730384,
                            "isTestReportAvailable": false,
                            "duration": 135,
                            "duration_inMinutes": 2.25,
                            "created_at": "Feb-11-21",
                            "created_at_rawDateFormat": "2021-02-11T07:06:23.149Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253507655,
                        "gitlabId": 253507655,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730377,
                            "isTestReportAvailable": false,
                            "duration": 214,
                            "duration_inMinutes": 3.57,
                            "created_at": "Feb-09-21",
                            "created_at_rawDateFormat": "2021-02-09T07:06:22.700Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 253499092,
                        "gitlabId": 253499092,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730378,
                            "isTestReportAvailable": false,
                            "duration": 186,
                            "duration_inMinutes": 3.1,
                            "created_at": "Feb-09-21",
                            "created_at_rawDateFormat": "2021-02-09T07:06:22.797Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 248227819,
                        "gitlabId": 248227819,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730382,
                            "isTestReportAvailable": false,
                            "duration": 1756,
                            "duration_inMinutes": 29.27,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:06:22.981Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 248219770,
                        "gitlabId": 248219770,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730379,
                            "isTestReportAvailable": false,
                            "duration": 198,
                            "duration_inMinutes": 3.3,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:06:22.826Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247959436,
                        "gitlabId": 247959436,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730380,
                            "isTestReportAvailable": false,
                            "duration": 274,
                            "duration_inMinutes": 4.57,
                            "created_at": "Jan-28-21",
                            "created_at_rawDateFormat": "2021-01-28T07:06:22.886Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247169780,
                        "gitlabId": 247169780,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730381,
                            "isTestReportAvailable": false,
                            "duration": 311,
                            "duration_inMinutes": 5.18,
                            "created_at": "Jan-26-21",
                            "created_at_rawDateFormat": "2021-01-26T07:06:22.972Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247080231,
                        "gitlabId": 247080231,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730383,
                            "isTestReportAvailable": false,
                            "duration": 633,
                            "duration_inMinutes": 10.55,
                            "created_at": "Jan-26-21",
                            "created_at_rawDateFormat": "2021-01-26T07:06:23.067Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247078786,
                        "gitlabId": 247078786,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730392,
                            "isTestReportAvailable": false,
                            "duration": 376,
                            "duration_inMinutes": 6.27,
                            "created_at": "Jan-26-21",
                            "created_at_rawDateFormat": "2021-01-26T07:06:23.662Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247057271,
                        "gitlabId": 247057271,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730385,
                            "isTestReportAvailable": false,
                            "duration": 161,
                            "duration_inMinutes": 2.68,
                            "created_at": "Jan-26-21",
                            "created_at_rawDateFormat": "2021-01-26T07:06:23.173Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 247001968,
                        "gitlabId": 247001968,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730387,
                            "isTestReportAvailable": false,
                            "duration": 169,
                            "duration_inMinutes": 2.82,
                            "created_at": "Jan-26-21",
                            "created_at_rawDateFormat": "2021-01-26T07:06:23.250Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 246638991,
                        "gitlabId": 246638991,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730386,
                            "isTestReportAvailable": false,
                            "duration": 222,
                            "duration_inMinutes": 3.7,
                            "created_at": "Jan-25-21",
                            "created_at_rawDateFormat": "2021-01-25T07:06:23.232Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 245011284,
                        "gitlabId": 245011284,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730394,
                            "isTestReportAvailable": false,
                            "duration": 219,
                            "duration_inMinutes": 3.65,
                            "created_at": "Jan-21-21",
                            "created_at_rawDateFormat": "2021-01-21T07:06:23.719Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 244247262,
                        "gitlabId": 244247262,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730388,
                            "isTestReportAvailable": false,
                            "duration": 197,
                            "duration_inMinutes": 3.28,
                            "created_at": "Jan-20-21",
                            "created_at_rawDateFormat": "2021-01-20T07:06:23.414Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 241528199,
                        "gitlabId": 241528199,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730389,
                            "isTestReportAvailable": false,
                            "duration": 77,
                            "duration_inMinutes": 1.28,
                            "created_at": "Jan-14-21",
                            "created_at_rawDateFormat": "2021-01-14T07:06:23.478Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 236129593,
                        "gitlabId": 236129593,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730390,
                            "isTestReportAvailable": false,
                            "duration": 112,
                            "duration_inMinutes": 1.87,
                            "created_at": "Dec-31-20",
                            "created_at_rawDateFormat": "2020-12-31T07:06:23.483Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235467980,
                        "gitlabId": 235467980,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730391,
                            "isTestReportAvailable": false,
                            "duration": 139,
                            "duration_inMinutes": 2.32,
                            "created_at": "Dec-29-20",
                            "created_at_rawDateFormat": "2020-12-29T07:06:23.531Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235031518,
                        "gitlabId": 235031518,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730393,
                            "isTestReportAvailable": false,
                            "duration": 174,
                            "duration_inMinutes": 2.9,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:06:23.701Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 235027134,
                        "gitlabId": 235027134,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730395,
                            "isTestReportAvailable": false,
                            "duration": 186,
                            "duration_inMinutes": 3.1,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:06:23.736Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 234967411,
                        "gitlabId": 234967411,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730396,
                            "isTestReportAvailable": false,
                            "duration": 135,
                            "duration_inMinutes": 2.25,
                            "created_at": "Dec-28-20",
                            "created_at_rawDateFormat": "2020-12-28T07:06:23.750Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 228003863,
                        "gitlabId": 228003863,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730397,
                            "isTestReportAvailable": false,
                            "duration": 192,
                            "duration_inMinutes": 3.2,
                            "created_at": "Dec-10-20",
                            "created_at_rawDateFormat": "2020-12-10T07:06:23.792Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 213519609,
                        "gitlabId": 213519609,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730398,
                            "isTestReportAvailable": false,
                            "duration": 638,
                            "duration_inMinutes": 10.63,
                            "created_at": "Nov-09-20",
                            "created_at_rawDateFormat": "2020-11-09T07:06:23.916Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 212603699,
                        "gitlabId": 212603699,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730399,
                            "isTestReportAvailable": false,
                            "duration": 238,
                            "duration_inMinutes": 3.97,
                            "created_at": "Nov-06-20",
                            "created_at_rawDateFormat": "2020-11-06T07:06:23.942Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 212042516,
                        "gitlabId": 212042516,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730400,
                            "isTestReportAvailable": false,
                            "duration": 145,
                            "duration_inMinutes": 2.42,
                            "created_at": "Nov-05-20",
                            "created_at_rawDateFormat": "2020-11-05T07:06:23.986Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 209625709,
                        "gitlabId": 209625709,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730401,
                            "isTestReportAvailable": false,
                            "duration": 179,
                            "duration_inMinutes": 2.98,
                            "created_at": "Oct-30-20",
                            "created_at_rawDateFormat": "2020-10-30T07:06:24.005Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 209309036,
                        "gitlabId": 209309036,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730402,
                            "isTestReportAvailable": false,
                            "duration": 235,
                            "duration_inMinutes": 3.92,
                            "created_at": "Oct-29-20",
                            "created_at_rawDateFormat": "2020-10-29T07:06:24.036Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 209277994,
                        "gitlabId": 209277994,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730403,
                            "isTestReportAvailable": false,
                            "duration": 135,
                            "duration_inMinutes": 2.25,
                            "created_at": "Oct-29-20",
                            "created_at_rawDateFormat": "2020-10-29T07:06:24.048Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 209170752,
                        "gitlabId": 209170752,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730408,
                            "isTestReportAvailable": false,
                            "duration": 136,
                            "duration_inMinutes": 2.27,
                            "created_at": "Oct-29-20",
                            "created_at_rawDateFormat": "2020-10-29T07:06:24.347Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 209108988,
                        "gitlabId": 209108988,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730404,
                            "isTestReportAvailable": false,
                            "duration": 119,
                            "duration_inMinutes": 1.98,
                            "created_at": "Oct-29-20",
                            "created_at_rawDateFormat": "2020-10-29T07:06:24.213Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 209102936,
                        "gitlabId": 209102936,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730405,
                            "isTestReportAvailable": false,
                            "duration": 158,
                            "duration_inMinutes": 2.63,
                            "created_at": "Oct-29-20",
                            "created_at_rawDateFormat": "2020-10-29T07:06:24.272Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 207534130,
                        "gitlabId": 207534130,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730413,
                            "isTestReportAvailable": false,
                            "duration": 669,
                            "duration_inMinutes": 11.15,
                            "created_at": "Oct-26-20",
                            "created_at_rawDateFormat": "2020-10-26T07:06:24.771Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 206745146,
                        "gitlabId": 206745146,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730406,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Oct-23-20",
                            "created_at_rawDateFormat": "2020-10-23T07:06:24.289Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 206744649,
                        "gitlabId": 206744649,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730407,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Oct-23-20",
                            "created_at_rawDateFormat": "2020-10-23T07:06:24.317Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 201436652,
                        "gitlabId": 201436652,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730409,
                            "isTestReportAvailable": false,
                            "duration": 237,
                            "duration_inMinutes": 3.95,
                            "created_at": "Oct-12-20",
                            "created_at_rawDateFormat": "2020-10-12T07:06:24.517Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 201430154,
                        "gitlabId": 201430154,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730410,
                            "isTestReportAvailable": false,
                            "duration": 291,
                            "duration_inMinutes": 4.85,
                            "created_at": "Oct-12-20",
                            "created_at_rawDateFormat": "2020-10-12T07:06:24.561Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 200502712,
                        "gitlabId": 200502712,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730417,
                            "isTestReportAvailable": false,
                            "duration": 252,
                            "duration_inMinutes": 4.2,
                            "created_at": "Oct-09-20",
                            "created_at_rawDateFormat": "2020-10-09T07:06:25.040Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 200463290,
                        "gitlabId": 200463290,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730411,
                            "isTestReportAvailable": false,
                            "duration": 484,
                            "duration_inMinutes": 8.07,
                            "created_at": "Oct-09-20",
                            "created_at_rawDateFormat": "2020-10-09T07:06:24.585Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 199806516,
                        "gitlabId": 199806516,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730412,
                            "isTestReportAvailable": false,
                            "duration": 342,
                            "duration_inMinutes": 5.7,
                            "created_at": "Oct-08-20",
                            "created_at_rawDateFormat": "2020-10-08T07:06:24.636Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 199802408,
                        "gitlabId": 199802408,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730414,
                            "isTestReportAvailable": false,
                            "duration": 228,
                            "duration_inMinutes": 3.8,
                            "created_at": "Oct-08-20",
                            "created_at_rawDateFormat": "2020-10-08T07:06:24.785Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 199788749,
                        "gitlabId": 199788749,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730416,
                            "isTestReportAvailable": false,
                            "duration": 253,
                            "duration_inMinutes": 4.22,
                            "created_at": "Oct-08-20",
                            "created_at_rawDateFormat": "2020-10-08T07:06:24.850Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 199783591,
                        "gitlabId": 199783591,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730415,
                            "isTestReportAvailable": false,
                            "duration": 313,
                            "duration_inMinutes": 5.22,
                            "created_at": "Oct-08-20",
                            "created_at_rawDateFormat": "2020-10-08T07:06:24.848Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 199782139,
                        "gitlabId": 199782139,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730420,
                            "isTestReportAvailable": false,
                            "duration": 120,
                            "duration_inMinutes": 2,
                            "created_at": "Oct-08-20",
                            "created_at_rawDateFormat": "2020-10-08T07:06:25.162Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 199774565,
                        "gitlabId": 199774565,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730421,
                            "isTestReportAvailable": false,
                            "duration": 80,
                            "duration_inMinutes": 1.33,
                            "created_at": "Oct-08-20",
                            "created_at_rawDateFormat": "2020-10-08T07:06:25.249Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29729,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 31130357,
                "gitlabId": 31130357,
                "name": "testing-semantic-release-library",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/testing-semantic-release-library.git",
                "stats": {
                    "id": 29723,
                    "status": "failed",
                    "numberOfPipelines": 6,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 3,
                    "averageDurationOfPipelines_inMinutes": 0.05,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 6,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 0,
                    "totalRepoSize": "1059061",
                    "artifactsSize": "9592"
                },
                "pipelines": [
                    {
                        "id": 404237124,
                        "gitlabId": 404237124,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730428,
                            "isTestReportAvailable": false,
                            "duration": 4,
                            "duration_inMinutes": 0.07,
                            "created_at": "Nov-08-21",
                            "created_at_rawDateFormat": "2021-11-08T07:06:25.806Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 404127686,
                        "gitlabId": 404127686,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730418,
                            "isTestReportAvailable": false,
                            "duration": 4,
                            "duration_inMinutes": 0.07,
                            "created_at": "Nov-08-21",
                            "created_at_rawDateFormat": "2021-11-08T07:06:25.104Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 404124767,
                        "gitlabId": 404124767,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730419,
                            "isTestReportAvailable": false,
                            "duration": 3,
                            "duration_inMinutes": 0.05,
                            "created_at": "Nov-08-21",
                            "created_at_rawDateFormat": "2021-11-08T07:06:25.141Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 404118864,
                        "gitlabId": 404118864,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730425,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Nov-08-21",
                            "created_at_rawDateFormat": "2021-11-08T07:06:25.553Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 404115767,
                        "gitlabId": 404115767,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730424,
                            "isTestReportAvailable": false,
                            "duration": 4,
                            "duration_inMinutes": 0.07,
                            "created_at": "Nov-08-21",
                            "created_at_rawDateFormat": "2021-11-08T07:06:25.513Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 404110989,
                        "gitlabId": 404110989,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730422,
                            "isTestReportAvailable": false,
                            "duration": 4,
                            "duration_inMinutes": 0.07,
                            "created_at": "Nov-08-21",
                            "created_at_rawDateFormat": "2021-11-08T07:06:25.395Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29730,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 14616123,
                "gitlabId": 14616123,
                "name": "logfilter",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/ww-utils.ww-logfilter.git",
                "stats": {
                    "id": 29739,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "0",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29750,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 22891222,
                "gitlabId": 22891222,
                "name": "intellij-settings",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/intellij-settings.git",
                "stats": {
                    "id": 29743,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "429916",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29753,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 15339302,
                "gitlabId": 15339302,
                "name": "Easter Christmas Kalender",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/easter-christmas-kalendar.git",
                "stats": {
                    "id": 29772,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "3554672",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29754,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 30747138,
                "gitlabId": 30747138,
                "name": "Angular-testing-project",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/angular-testing-project.git",
                "stats": {
                    "id": 29770,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "524288",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29783,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 30080432,
                "gitlabId": 30080432,
                "name": "angular-gitlab-template-jest",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/angular-gitlab-template-jest.git",
                "stats": {
                    "id": 29766,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "1090519",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29780,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 17542038,
                "gitlabId": 17542038,
                "name": "graphql",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/graphql.git",
                "stats": {
                    "id": 29790,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "933232",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29774,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 15946201,
                "gitlabId": 15946201,
                "name": "Wasm versus JavaScript",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/wasm-versus-javascript.git",
                "stats": {
                    "id": 29728,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "1258291",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29735,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 16204989,
                "gitlabId": 16204989,
                "name": "ngrx-nest-typeorm-demo-app",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/ngrx-nest-typeorm-demo-app.git",
                "stats": {
                    "id": 29725,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "1310720",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29738,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            },
            {
                "id": 32766782,
                "gitlabId": 32766782,
                "name": "stencil_w11k_components",
                "urlToRepo": "https://gitlab.com/w11k-devs/intern/stencil_w11k_components.git",
                "stats": {
                    "id": 29748,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "4456448",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29737,
                    "gitlabId": 6204426,
                    "name": "W11k Intern"
                }
            }
        ],
        "subGroups": [],
        "stats": {
            "id": 6708,
            "isThereSubgroups": false,
            "numberOfProjects": 26,
            "testCoverageOfAllProjects": 12.68,
            "numberOfPipelines": 756,
            "numberOfTestReports": 2
        }
    },
    {
        "id": 8301072,
        "tempData": false,
        "gitlabId": 8301072,
        "name": "Academic",
        "projects": [
            {
                "id": 17681390,
                "gitlabId": 17681390,
                "name": "diff-patch-sync",
                "urlToRepo": "https://gitlab.com/w11k-devs/academic/diff-patch-sync.git",
                "stats": {
                    "id": 29688,
                    "status": "success",
                    "numberOfPipelines": 65,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 110,
                    "averageDurationOfPipelines_inMinutes": 1.83,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 41,
                    "numberOfFailedPipelines": 21,
                    "numberOfCanceledPipelines": 3,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 63.08,
                    "totalRepoSize": "954204",
                    "artifactsSize": "526149"
                },
                "pipelines": [
                    {
                        "id": 132137523,
                        "gitlabId": 132137523,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728960,
                            "isTestReportAvailable": false,
                            "duration": 144,
                            "duration_inMinutes": 2.4,
                            "created_at": "Apr-02-20",
                            "created_at_rawDateFormat": "2020-04-02T07:04:46.796Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130382466,
                        "gitlabId": 130382466,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728972,
                            "isTestReportAvailable": false,
                            "duration": 146,
                            "duration_inMinutes": 2.43,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:47.669Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129943872,
                        "gitlabId": 129943872,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728961,
                            "isTestReportAvailable": false,
                            "duration": 109,
                            "duration_inMinutes": 1.82,
                            "created_at": "Mar-26-20",
                            "created_at_rawDateFormat": "2020-03-26T07:04:46.910Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129923029,
                        "gitlabId": 129923029,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728963,
                            "isTestReportAvailable": false,
                            "duration": 273,
                            "duration_inMinutes": 4.55,
                            "created_at": "Mar-26-20",
                            "created_at_rawDateFormat": "2020-03-26T07:04:47.098Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129923025,
                        "gitlabId": 129923025,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728962,
                            "isTestReportAvailable": false,
                            "duration": 205,
                            "duration_inMinutes": 3.42,
                            "created_at": "Mar-26-20",
                            "created_at_rawDateFormat": "2020-03-26T07:04:46.973Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129922850,
                        "gitlabId": 129922850,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728964,
                            "isTestReportAvailable": false,
                            "duration": 123,
                            "duration_inMinutes": 2.05,
                            "created_at": "Mar-26-20",
                            "created_at_rawDateFormat": "2020-03-26T07:04:47.153Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129922557,
                        "gitlabId": 129922557,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728967,
                            "isTestReportAvailable": false,
                            "duration": 47,
                            "duration_inMinutes": 0.78,
                            "created_at": "Mar-26-20",
                            "created_at_rawDateFormat": "2020-03-26T07:04:47.331Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129921576,
                        "gitlabId": 129921576,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728965,
                            "isTestReportAvailable": false,
                            "duration": 47,
                            "duration_inMinutes": 0.78,
                            "created_at": "Mar-26-20",
                            "created_at_rawDateFormat": "2020-03-26T07:04:47.172Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129919852,
                        "gitlabId": 129919852,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728966,
                            "isTestReportAvailable": false,
                            "duration": 45,
                            "duration_inMinutes": 0.75,
                            "created_at": "Mar-26-20",
                            "created_at_rawDateFormat": "2020-03-26T07:04:47.245Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129918470,
                        "gitlabId": 129918470,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728970,
                            "isTestReportAvailable": false,
                            "duration": 46,
                            "duration_inMinutes": 0.77,
                            "created_at": "Mar-26-20",
                            "created_at_rawDateFormat": "2020-03-26T07:04:47.592Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129909824,
                        "gitlabId": 129909824,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728968,
                            "isTestReportAvailable": false,
                            "duration": 53,
                            "duration_inMinutes": 0.88,
                            "created_at": "Mar-26-20",
                            "created_at_rawDateFormat": "2020-03-26T07:04:47.428Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129472336,
                        "gitlabId": 129472336,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728969,
                            "isTestReportAvailable": false,
                            "duration": 75,
                            "duration_inMinutes": 1.25,
                            "created_at": "Mar-25-20",
                            "created_at_rawDateFormat": "2020-03-25T07:04:47.430Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129285750,
                        "gitlabId": 129285750,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728973,
                            "isTestReportAvailable": false,
                            "duration": 81,
                            "duration_inMinutes": 1.35,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:47.691Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129285741,
                        "gitlabId": 129285741,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728971,
                            "isTestReportAvailable": false,
                            "duration": 68,
                            "duration_inMinutes": 1.13,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:47.597Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129285593,
                        "gitlabId": 129285593,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728980,
                            "isTestReportAvailable": false,
                            "duration": 52,
                            "duration_inMinutes": 0.87,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:48.067Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129273403,
                        "gitlabId": 129273403,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728974,
                            "isTestReportAvailable": false,
                            "duration": 84,
                            "duration_inMinutes": 1.4,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:47.733Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129273398,
                        "gitlabId": 129273398,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728976,
                            "isTestReportAvailable": false,
                            "duration": 46,
                            "duration_inMinutes": 0.77,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:47.906Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129271101,
                        "gitlabId": 129271101,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728975,
                            "isTestReportAvailable": false,
                            "duration": 70,
                            "duration_inMinutes": 1.17,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:47.889Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129271092,
                        "gitlabId": 129271092,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728977,
                            "isTestReportAvailable": false,
                            "duration": 50,
                            "duration_inMinutes": 0.83,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:47.975Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129271005,
                        "gitlabId": 129271005,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728979,
                            "isTestReportAvailable": false,
                            "duration": 57,
                            "duration_inMinutes": 0.95,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:48.006Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129270114,
                        "gitlabId": 129270114,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728978,
                            "isTestReportAvailable": false,
                            "duration": 81,
                            "duration_inMinutes": 1.35,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:47.995Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129269090,
                        "gitlabId": 129269090,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728982,
                            "isTestReportAvailable": false,
                            "duration": 77,
                            "duration_inMinutes": 1.28,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:48.215Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129266053,
                        "gitlabId": 129266053,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728981,
                            "isTestReportAvailable": false,
                            "duration": 84,
                            "duration_inMinutes": 1.4,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:48.174Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129266050,
                        "gitlabId": 129266050,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728986,
                            "isTestReportAvailable": false,
                            "duration": 48,
                            "duration_inMinutes": 0.8,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:48.406Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129265629,
                        "gitlabId": 129265629,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728985,
                            "isTestReportAvailable": false,
                            "duration": 56,
                            "duration_inMinutes": 0.93,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:48.399Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129250332,
                        "gitlabId": 129250332,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728983,
                            "isTestReportAvailable": false,
                            "duration": 82,
                            "duration_inMinutes": 1.37,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:48.272Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129250328,
                        "gitlabId": 129250328,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728984,
                            "isTestReportAvailable": false,
                            "duration": 47,
                            "duration_inMinutes": 0.78,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:48.369Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129250088,
                        "gitlabId": 129250088,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728987,
                            "isTestReportAvailable": false,
                            "duration": 51,
                            "duration_inMinutes": 0.85,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:48.433Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129248414,
                        "gitlabId": 129248414,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728988,
                            "isTestReportAvailable": false,
                            "duration": 48,
                            "duration_inMinutes": 0.8,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:48.496Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129247577,
                        "gitlabId": 129247577,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728989,
                            "isTestReportAvailable": false,
                            "duration": 81,
                            "duration_inMinutes": 1.35,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:48.522Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129247571,
                        "gitlabId": 129247571,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728990,
                            "isTestReportAvailable": false,
                            "duration": 64,
                            "duration_inMinutes": 1.07,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:48.673Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129231987,
                        "gitlabId": 129231987,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728991,
                            "isTestReportAvailable": false,
                            "duration": 365,
                            "duration_inMinutes": 6.08,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:48.684Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129230365,
                        "gitlabId": 129230365,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728992,
                            "isTestReportAvailable": false,
                            "duration": 202,
                            "duration_inMinutes": 3.37,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:48.896Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129222757,
                        "gitlabId": 129222757,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728993,
                            "isTestReportAvailable": false,
                            "duration": 110,
                            "duration_inMinutes": 1.83,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:48.925Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129213441,
                        "gitlabId": 129213441,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729003,
                            "isTestReportAvailable": false,
                            "duration": 335,
                            "duration_inMinutes": 5.58,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:49.691Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129208060,
                        "gitlabId": 129208060,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729021,
                            "isTestReportAvailable": false,
                            "duration": 312,
                            "duration_inMinutes": 5.2,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:50.944Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129200115,
                        "gitlabId": 129200115,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728995,
                            "isTestReportAvailable": false,
                            "duration": 156,
                            "duration_inMinutes": 2.6,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:48.995Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129197820,
                        "gitlabId": 129197820,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728994,
                            "isTestReportAvailable": false,
                            "duration": 119,
                            "duration_inMinutes": 1.98,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:48.961Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129196265,
                        "gitlabId": 129196265,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728996,
                            "isTestReportAvailable": false,
                            "duration": 163,
                            "duration_inMinutes": 2.72,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:49.172Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129196262,
                        "gitlabId": 129196262,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728997,
                            "isTestReportAvailable": false,
                            "duration": 46,
                            "duration_inMinutes": 0.77,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:49.195Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129193607,
                        "gitlabId": 129193607,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 728999,
                            "isTestReportAvailable": false,
                            "duration": 165,
                            "duration_inMinutes": 2.75,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:49.376Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129193602,
                        "gitlabId": 129193602,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728998,
                            "isTestReportAvailable": false,
                            "duration": 153,
                            "duration_inMinutes": 2.55,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:49.256Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129181462,
                        "gitlabId": 129181462,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729002,
                            "isTestReportAvailable": false,
                            "duration": 211,
                            "duration_inMinutes": 3.52,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:49.614Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129181455,
                        "gitlabId": 129181455,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729000,
                            "isTestReportAvailable": false,
                            "duration": 78,
                            "duration_inMinutes": 1.3,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:49.471Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129178938,
                        "gitlabId": 129178938,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729001,
                            "isTestReportAvailable": false,
                            "duration": 164,
                            "duration_inMinutes": 2.73,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:49.539Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129163395,
                        "gitlabId": 129163395,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729004,
                            "isTestReportAvailable": false,
                            "duration": 206,
                            "duration_inMinutes": 3.43,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:49.692Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129163393,
                        "gitlabId": 129163393,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729007,
                            "isTestReportAvailable": false,
                            "duration": 96,
                            "duration_inMinutes": 1.6,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:49.900Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129162810,
                        "gitlabId": 129162810,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729005,
                            "isTestReportAvailable": false,
                            "duration": 147,
                            "duration_inMinutes": 2.45,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:49.800Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129160334,
                        "gitlabId": 129160334,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729006,
                            "isTestReportAvailable": false,
                            "duration": 81,
                            "duration_inMinutes": 1.35,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:49.891Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129160332,
                        "gitlabId": 129160332,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729008,
                            "isTestReportAvailable": false,
                            "duration": 75,
                            "duration_inMinutes": 1.25,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:49.972Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129156269,
                        "gitlabId": 129156269,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729009,
                            "isTestReportAvailable": false,
                            "duration": 129,
                            "duration_inMinutes": 2.15,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:50.083Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129156267,
                        "gitlabId": 129156267,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729011,
                            "isTestReportAvailable": false,
                            "duration": 92,
                            "duration_inMinutes": 1.53,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:50.295Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129151478,
                        "gitlabId": 129151478,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729012,
                            "isTestReportAvailable": false,
                            "duration": 147,
                            "duration_inMinutes": 2.45,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:50.328Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129149599,
                        "gitlabId": 129149599,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 729014,
                            "isTestReportAvailable": false,
                            "duration": 44,
                            "duration_inMinutes": 0.73,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:50.344Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129149595,
                        "gitlabId": 129149595,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729010,
                            "isTestReportAvailable": false,
                            "duration": 265,
                            "duration_inMinutes": 4.42,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:50.252Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129149509,
                        "gitlabId": 129149509,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 729013,
                            "isTestReportAvailable": false,
                            "duration": 9,
                            "duration_inMinutes": 0.15,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:50.340Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129148209,
                        "gitlabId": 129148209,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729015,
                            "isTestReportAvailable": false,
                            "duration": 105,
                            "duration_inMinutes": 1.75,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:50.552Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129148201,
                        "gitlabId": 129148201,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729016,
                            "isTestReportAvailable": false,
                            "duration": 105,
                            "duration_inMinutes": 1.75,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:50.565Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129142753,
                        "gitlabId": 129142753,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 729017,
                            "isTestReportAvailable": false,
                            "duration": 133,
                            "duration_inMinutes": 2.22,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:50.616Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129142748,
                        "gitlabId": 129142748,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729023,
                            "isTestReportAvailable": false,
                            "duration": 91,
                            "duration_inMinutes": 1.52,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:51.121Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129142390,
                        "gitlabId": 129142390,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729020,
                            "isTestReportAvailable": false,
                            "duration": 104,
                            "duration_inMinutes": 1.73,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:50.940Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129141588,
                        "gitlabId": 129141588,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729035,
                            "isTestReportAvailable": false,
                            "duration": 7,
                            "duration_inMinutes": 0.12,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:52.389Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129141585,
                        "gitlabId": 129141585,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729018,
                            "isTestReportAvailable": false,
                            "duration": 14,
                            "duration_inMinutes": 0.23,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:50.830Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129141518,
                        "gitlabId": 129141518,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729019,
                            "isTestReportAvailable": false,
                            "duration": 13,
                            "duration_inMinutes": 0.22,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:50.887Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 129139996,
                        "gitlabId": 129139996,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729022,
                            "isTestReportAvailable": false,
                            "duration": 154,
                            "duration_inMinutes": 2.57,
                            "created_at": "Mar-24-20",
                            "created_at_rawDateFormat": "2020-03-24T07:04:51.086Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29684,
                    "gitlabId": 8301072,
                    "name": "Academic"
                }
            },
            {
                "id": 17748850,
                "gitlabId": 17748850,
                "name": "diff-patch-sync-demo",
                "urlToRepo": "https://gitlab.com/w11k-devs/academic/diff-patch-sync-demo.git",
                "stats": {
                    "id": 29694,
                    "status": "success",
                    "numberOfPipelines": 40,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 448,
                    "averageDurationOfPipelines_inMinutes": 7.47,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 26,
                    "numberOfFailedPipelines": 13,
                    "numberOfCanceledPipelines": 1,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 65,
                    "totalRepoSize": "1101004",
                    "artifactsSize": "3811266"
                },
                "pipelines": [
                    {
                        "id": 231188265,
                        "gitlabId": 231188265,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729024,
                            "isTestReportAvailable": false,
                            "duration": 502,
                            "duration_inMinutes": 8.37,
                            "created_at": "Dec-17-20",
                            "created_at_rawDateFormat": "2020-12-17T07:04:51.160Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 231178000,
                        "gitlabId": 231178000,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729025,
                            "isTestReportAvailable": false,
                            "duration": 571,
                            "duration_inMinutes": 9.52,
                            "created_at": "Dec-17-20",
                            "created_at_rawDateFormat": "2020-12-17T07:04:51.197Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 230820563,
                        "gitlabId": 230820563,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729026,
                            "isTestReportAvailable": false,
                            "duration": 784,
                            "duration_inMinutes": 13.07,
                            "created_at": "Dec-16-20",
                            "created_at_rawDateFormat": "2020-12-16T07:04:51.220Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 230758155,
                        "gitlabId": 230758155,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729040,
                            "isTestReportAvailable": false,
                            "duration": 880,
                            "duration_inMinutes": 14.67,
                            "created_at": "Dec-16-20",
                            "created_at_rawDateFormat": "2020-12-16T07:04:52.804Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 230747007,
                        "gitlabId": 230747007,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729029,
                            "isTestReportAvailable": false,
                            "duration": 440,
                            "duration_inMinutes": 7.33,
                            "created_at": "Dec-16-20",
                            "created_at_rawDateFormat": "2020-12-16T07:04:51.481Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 230736918,
                        "gitlabId": 230736918,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729027,
                            "isTestReportAvailable": false,
                            "duration": 451,
                            "duration_inMinutes": 7.52,
                            "created_at": "Dec-16-20",
                            "created_at_rawDateFormat": "2020-12-16T07:04:51.417Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 230716891,
                        "gitlabId": 230716891,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729028,
                            "isTestReportAvailable": false,
                            "duration": 499,
                            "duration_inMinutes": 8.32,
                            "created_at": "Dec-16-20",
                            "created_at_rawDateFormat": "2020-12-16T07:04:51.478Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 230709068,
                        "gitlabId": 230709068,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729030,
                            "isTestReportAvailable": false,
                            "duration": 478,
                            "duration_inMinutes": 7.97,
                            "created_at": "Dec-16-20",
                            "created_at_rawDateFormat": "2020-12-16T07:04:51.488Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 230654849,
                        "gitlabId": 230654849,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729031,
                            "isTestReportAvailable": false,
                            "duration": 445,
                            "duration_inMinutes": 7.42,
                            "created_at": "Dec-16-20",
                            "created_at_rawDateFormat": "2020-12-16T07:04:51.713Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 230571840,
                        "gitlabId": 230571840,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729037,
                            "isTestReportAvailable": false,
                            "duration": 675,
                            "duration_inMinutes": 11.25,
                            "created_at": "Dec-16-20",
                            "created_at_rawDateFormat": "2020-12-16T07:04:52.632Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 136636451,
                        "gitlabId": 136636451,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729033,
                            "isTestReportAvailable": false,
                            "duration": 563,
                            "duration_inMinutes": 9.38,
                            "created_at": "Apr-16-20",
                            "created_at_rawDateFormat": "2020-04-16T07:04:51.926Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 135824993,
                        "gitlabId": 135824993,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729032,
                            "isTestReportAvailable": false,
                            "duration": 383,
                            "duration_inMinutes": 6.38,
                            "created_at": "Apr-14-20",
                            "created_at_rawDateFormat": "2020-04-14T07:04:51.804Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 135824844,
                        "gitlabId": 135824844,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729039,
                            "isTestReportAvailable": false,
                            "duration": 970,
                            "duration_inMinutes": 16.17,
                            "created_at": "Apr-14-20",
                            "created_at_rawDateFormat": "2020-04-14T07:04:52.786Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 133143698,
                        "gitlabId": 133143698,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729034,
                            "isTestReportAvailable": false,
                            "duration": 484,
                            "duration_inMinutes": 8.07,
                            "created_at": "Apr-06-20",
                            "created_at_rawDateFormat": "2020-04-06T07:04:52.154Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 132137505,
                        "gitlabId": 132137505,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729038,
                            "isTestReportAvailable": false,
                            "duration": 1085,
                            "duration_inMinutes": 18.08,
                            "created_at": "Apr-02-20",
                            "created_at_rawDateFormat": "2020-04-02T07:04:52.694Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130786016,
                        "gitlabId": 130786016,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729036,
                            "isTestReportAvailable": false,
                            "duration": 486,
                            "duration_inMinutes": 8.1,
                            "created_at": "Mar-29-20",
                            "created_at_rawDateFormat": "2020-03-29T07:04:52.405Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130441074,
                        "gitlabId": 130441074,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729064,
                            "isTestReportAvailable": false,
                            "duration": 323,
                            "duration_inMinutes": 5.38,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:54.622Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130439051,
                        "gitlabId": 130439051,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729041,
                            "isTestReportAvailable": false,
                            "duration": 304,
                            "duration_inMinutes": 5.07,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:52.853Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130435759,
                        "gitlabId": 130435759,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729042,
                            "isTestReportAvailable": false,
                            "duration": 386,
                            "duration_inMinutes": 6.43,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:52.922Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130433244,
                        "gitlabId": 130433244,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729070,
                            "isTestReportAvailable": false,
                            "duration": 378,
                            "duration_inMinutes": 6.3,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:54.929Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130432607,
                        "gitlabId": 130432607,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729043,
                            "isTestReportAvailable": false,
                            "duration": 165,
                            "duration_inMinutes": 2.75,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:53.043Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130431907,
                        "gitlabId": 130431907,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729044,
                            "isTestReportAvailable": false,
                            "duration": 92,
                            "duration_inMinutes": 1.53,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:53.095Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130429608,
                        "gitlabId": 130429608,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729045,
                            "isTestReportAvailable": false,
                            "duration": 91,
                            "duration_inMinutes": 1.52,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:53.114Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130425763,
                        "gitlabId": 130425763,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729046,
                            "isTestReportAvailable": false,
                            "duration": 438,
                            "duration_inMinutes": 7.3,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:53.337Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130422899,
                        "gitlabId": 130422899,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729047,
                            "isTestReportAvailable": false,
                            "duration": 485,
                            "duration_inMinutes": 8.08,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:53.367Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130419520,
                        "gitlabId": 130419520,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729048,
                            "isTestReportAvailable": false,
                            "duration": 316,
                            "duration_inMinutes": 5.27,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:53.399Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130418728,
                        "gitlabId": 130418728,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729049,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:53.551Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130415865,
                        "gitlabId": 130415865,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729050,
                            "isTestReportAvailable": false,
                            "duration": 357,
                            "duration_inMinutes": 5.95,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:53.591Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130412626,
                        "gitlabId": 130412626,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729051,
                            "isTestReportAvailable": false,
                            "duration": 369,
                            "duration_inMinutes": 6.15,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:53.626Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130411913,
                        "gitlabId": 130411913,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729052,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:53.717Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130409305,
                        "gitlabId": 130409305,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 729053,
                            "isTestReportAvailable": false,
                            "duration": 359,
                            "duration_inMinutes": 5.98,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:53.792Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130405649,
                        "gitlabId": 130405649,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729054,
                            "isTestReportAvailable": false,
                            "duration": 535,
                            "duration_inMinutes": 8.92,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:53.841Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130397086,
                        "gitlabId": 130397086,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729055,
                            "isTestReportAvailable": false,
                            "duration": 663,
                            "duration_inMinutes": 11.05,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:53.908Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130395092,
                        "gitlabId": 130395092,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729056,
                            "isTestReportAvailable": false,
                            "duration": 612,
                            "duration_inMinutes": 10.2,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:54.034Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130394002,
                        "gitlabId": 130394002,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729058,
                            "isTestReportAvailable": false,
                            "duration": 210,
                            "duration_inMinutes": 3.5,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:54.226Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130385295,
                        "gitlabId": 130385295,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729057,
                            "isTestReportAvailable": false,
                            "duration": 426,
                            "duration_inMinutes": 7.1,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:54.099Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130382440,
                        "gitlabId": 130382440,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729059,
                            "isTestReportAvailable": false,
                            "duration": 397,
                            "duration_inMinutes": 6.62,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:54.231Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130319406,
                        "gitlabId": 130319406,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729060,
                            "isTestReportAvailable": false,
                            "duration": 654,
                            "duration_inMinutes": 10.9,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:54.324Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130313412,
                        "gitlabId": 130313412,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729061,
                            "isTestReportAvailable": false,
                            "duration": 602,
                            "duration_inMinutes": 10.03,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:54.476Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 130312356,
                        "gitlabId": 130312356,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729065,
                            "isTestReportAvailable": false,
                            "duration": 61,
                            "duration_inMinutes": 1.02,
                            "created_at": "Mar-27-20",
                            "created_at_rawDateFormat": "2020-03-27T07:04:54.649Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29689,
                    "gitlabId": 8301072,
                    "name": "Academic"
                }
            }
        ],
        "subGroups": [],
        "stats": {
            "id": 6716,
            "isThereSubgroups": false,
            "numberOfProjects": 2,
            "testCoverageOfAllProjects": null,
            "numberOfPipelines": 105,
            "numberOfTestReports": 0
        }
    },
    {
        "id": 15960600,
        "tempData": false,
        "gitlabId": 15960600,
        "name": "workshops",
        "projects": [
            {
                "id": 33291480,
                "gitlabId": 33291480,
                "name": "java-and-angular",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/workshops/java-and-angular.git",
                "stats": {
                    "id": 29687,
                    "status": "success",
                    "numberOfPipelines": 6,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 8,
                    "averageDurationOfPipelines_inMinutes": 0.13,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 6,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 100,
                    "totalRepoSize": "1845493",
                    "artifactsSize": "42940"
                },
                "pipelines": [
                    {
                        "id": 460171297,
                        "gitlabId": 460171297,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728935,
                            "isTestReportAvailable": false,
                            "duration": 7,
                            "duration_inMinutes": 0.12,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:04:45.370Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 460170636,
                        "gitlabId": 460170636,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728938,
                            "isTestReportAvailable": false,
                            "duration": 7,
                            "duration_inMinutes": 0.12,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:04:45.531Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 460170401,
                        "gitlabId": 460170401,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728937,
                            "isTestReportAvailable": false,
                            "duration": 10,
                            "duration_inMinutes": 0.17,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:04:45.472Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 460169995,
                        "gitlabId": 460169995,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728939,
                            "isTestReportAvailable": false,
                            "duration": 7,
                            "duration_inMinutes": 0.12,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:04:45.637Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 460168272,
                        "gitlabId": 460168272,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728942,
                            "isTestReportAvailable": false,
                            "duration": 7,
                            "duration_inMinutes": 0.12,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:04:45.924Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 460167505,
                        "gitlabId": 460167505,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 728941,
                            "isTestReportAvailable": false,
                            "duration": 8,
                            "duration_inMinutes": 0.13,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:04:45.742Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29692,
                    "gitlabId": 15960600,
                    "name": "workshops"
                }
            },
            {
                "id": 33290467,
                "gitlabId": 33290467,
                "name": "organisation-angular-projects",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/workshops/organisation-angular-projects.git",
                "stats": {
                    "id": 29691,
                    "status": "success",
                    "numberOfPipelines": 4,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 99,
                    "averageDurationOfPipelines_inMinutes": 1.65,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 4,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 100,
                    "totalRepoSize": "2904555",
                    "artifactsSize": "5182646"
                },
                "pipelines": [
                    {
                        "id": 460150617,
                        "gitlabId": 460150617,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729062,
                            "isTestReportAvailable": false,
                            "duration": 233,
                            "duration_inMinutes": 3.88,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:04:54.491Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 460150556,
                        "gitlabId": 460150556,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729063,
                            "isTestReportAvailable": false,
                            "duration": 67,
                            "duration_inMinutes": 1.12,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:04:54.610Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 460150555,
                        "gitlabId": 460150555,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729076,
                            "isTestReportAvailable": false,
                            "duration": 67,
                            "duration_inMinutes": 1.12,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:04:55.452Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 460150513,
                        "gitlabId": 460150513,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729066,
                            "isTestReportAvailable": false,
                            "duration": 28,
                            "duration_inMinutes": 0.47,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:04:54.746Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29695,
                    "gitlabId": 15960600,
                    "name": "workshops"
                }
            },
            {
                "id": 33286262,
                "gitlabId": 33286262,
                "name": "rib-nx-prototype",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/workshops/rib-nx-prototype.git",
                "stats": {
                    "id": 29696,
                    "status": "success",
                    "numberOfPipelines": 1,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 67,
                    "averageDurationOfPipelines_inMinutes": 1.12,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 1,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 100,
                    "totalRepoSize": "293601",
                    "artifactsSize": "18470"
                },
                "pipelines": [
                    {
                        "id": 460024863,
                        "gitlabId": 460024863,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729352,
                            "isTestReportAvailable": false,
                            "duration": 67,
                            "duration_inMinutes": 1.12,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:05:15.997Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29697,
                    "gitlabId": 15960600,
                    "name": "workshops"
                }
            },
            {
                "id": 33286005,
                "gitlabId": 33286005,
                "name": "rib-angular-prototype",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/workshops/rib-angular-prototype.git",
                "stats": {
                    "id": 29689,
                    "status": "success",
                    "numberOfPipelines": 1,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 65,
                    "averageDurationOfPipelines_inMinutes": 1.08,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 1,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 100,
                    "totalRepoSize": "943718",
                    "artifactsSize": "10634"
                },
                "pipelines": [
                    {
                        "id": 460021242,
                        "gitlabId": 460021242,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729351,
                            "isTestReportAvailable": false,
                            "duration": 65,
                            "duration_inMinutes": 1.08,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:05:15.878Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29698,
                    "gitlabId": 15960600,
                    "name": "workshops"
                }
            },
            {
                "id": 33290391,
                "gitlabId": 33290391,
                "name": "smap-one-micro-frontends",
                "urlToRepo": "https://gitlab.com/w11k-devs/thecodecampus/workshops/smap-one-micro-frontends.git",
                "stats": {
                    "id": 29699,
                    "status": "success",
                    "numberOfPipelines": 1,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 63,
                    "averageDurationOfPipelines_inMinutes": 1.05,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 1,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 100,
                    "totalRepoSize": "807403",
                    "artifactsSize": "10687"
                },
                "pipelines": [
                    {
                        "id": 460127863,
                        "gitlabId": 460127863,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729068,
                            "isTestReportAvailable": false,
                            "duration": 63,
                            "duration_inMinutes": 1.05,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:04:54.905Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29700,
                    "gitlabId": 15960600,
                    "name": "workshops"
                }
            }
        ],
        "subGroups": [],
        "stats": {
            "id": 6717,
            "isThereSubgroups": false,
            "numberOfProjects": 5,
            "testCoverageOfAllProjects": null,
            "numberOfPipelines": 13,
            "numberOfTestReports": 0
        }
    },
    {
        "id": 8197589,
        "tempData": false,
        "gitlabId": 8197589,
        "name": "W11k TCC Websites",
        "projects": [
            {
                "id": 13789262,
                "gitlabId": 13789262,
                "name": "w11k-websites",
                "urlToRepo": "https://gitlab.com/w11k-devs/websites/w11k-websites.git",
                "stats": {
                    "id": 29693,
                    "status": "success",
                    "numberOfPipelines": 97,
                    "areTestsAvailable": true,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 71,
                    "averageDurationOfPipelines": 2350,
                    "averageDurationOfPipelines_inMinutes": 39.17,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 75,
                    "numberOfFailedPipelines": 14,
                    "numberOfCanceledPipelines": 8,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 77.32,
                    "totalRepoSize": "448087982",
                    "artifactsSize": "232744251060"
                },
                "pipelines": [
                    {
                        "id": 491730733,
                        "gitlabId": 491730733,
                        "status": "success",
                        "testReport": {
                            "id": 46621,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 110.1,
                            "test_suites": [
                                {
                                    "id": 53899,
                                    "total_time": 75.29,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554300,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.64,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554305,
                                            "classname": "click nothing",
                                            "execution_time": 0.61,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554244,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3554250,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.51,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554254,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.65,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554260,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 7.98,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554264,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.35,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554270,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.1,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554274,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.83,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554280,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.36,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554284,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.25,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554290,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.16,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554295,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.85,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53892,
                                    "total_time": 34.81,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554239,
                                            "classname": "click allow selection",
                                            "execution_time": 5.89,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554233,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.63,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554229,
                                            "classname": "click nothing",
                                            "execution_time": 7.14,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554223,
                                            "classname": "click allow necessary",
                                            "execution_time": 15.15,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 728948,
                            "isTestReportAvailable": true,
                            "duration": 2471,
                            "duration_inMinutes": 41.18,
                            "created_at": "Mar-14-22",
                            "created_at_rawDateFormat": "2022-03-14T07:04:46.226Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 491677769,
                        "gitlabId": 491677769,
                        "status": "success",
                        "testReport": {
                            "id": 46622,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 102.25,
                            "test_suites": [
                                {
                                    "id": 53891,
                                    "total_time": 23.74,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553661,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.74,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553656,
                                            "classname": "click nothing",
                                            "execution_time": 6.84,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553671,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.52,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553666,
                                            "classname": "click allow selection",
                                            "execution_time": 5.64,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53896,
                                    "total_time": 78.52,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553727,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.31,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553734,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.54,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553740,
                                            "classname": "click allow only necessary",
                                            "execution_time": 3.39,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553745,
                                            "classname": "click nothing",
                                            "execution_time": 0.85,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553708,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.44,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553717,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.34,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553700,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.74,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553692,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.54,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553688,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 7.65,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553682,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 8.14,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553678,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 10.37,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553672,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.2,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553668,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 728944,
                            "isTestReportAvailable": true,
                            "duration": 2663,
                            "duration_inMinutes": 44.38,
                            "created_at": "Mar-14-22",
                            "created_at_rawDateFormat": "2022-03-14T07:04:45.991Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 491629961,
                        "gitlabId": 491629961,
                        "status": "success",
                        "testReport": {
                            "id": 46623,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.75,
                            "test_suites": [
                                {
                                    "id": 53897,
                                    "total_time": 73.96,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553236,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 7.61,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553295,
                                            "classname": "click nothing",
                                            "execution_time": 0.61,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553285,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.67,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553275,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.82,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553268,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.27,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553264,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.3,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553258,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.34,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553252,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 6.66,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553222,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553226,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.05,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553232,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.78,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553246,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.88,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553242,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 6.97,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53890,
                                    "total_time": 24.79,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553231,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.61,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553225,
                                            "classname": "click allow selection",
                                            "execution_time": 5.6,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553221,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.27,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553215,
                                            "classname": "click nothing",
                                            "execution_time": 7.31,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 728943,
                            "isTestReportAvailable": true,
                            "duration": 2507,
                            "duration_inMinutes": 41.78,
                            "created_at": "Mar-14-22",
                            "created_at_rawDateFormat": "2022-03-14T07:04:45.973Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 491625079,
                        "gitlabId": 491625079,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 728947,
                            "isTestReportAvailable": false,
                            "duration": 369,
                            "duration_inMinutes": 6.15,
                            "created_at": "Mar-14-22",
                            "created_at_rawDateFormat": "2022-03-14T07:04:46.224Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 491199259,
                        "gitlabId": 491199259,
                        "status": "success",
                        "testReport": {
                            "id": 46627,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 99.25,
                            "test_suites": [
                                {
                                    "id": 53893,
                                    "total_time": 23.84,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554568,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.53,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554563,
                                            "classname": "click allow selection",
                                            "execution_time": 5.56,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554558,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.72,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554553,
                                            "classname": "click nothing",
                                            "execution_time": 7.04,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53902,
                                    "total_time": 75.4,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554612,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.32,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554618,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.26,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554583,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.69,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554578,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.81,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554573,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3554608,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.34,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554632,
                                            "classname": "click nothing",
                                            "execution_time": 0.57,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554628,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.67,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554622,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.8,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554588,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 7.43,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554593,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.28,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554598,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.2,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554602,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.03,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 728946,
                            "isTestReportAvailable": true,
                            "duration": 2361,
                            "duration_inMinutes": 39.35,
                            "created_at": "Mar-14-22",
                            "created_at_rawDateFormat": "2022-03-14T07:04:46.187Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 490215479,
                        "gitlabId": 490215479,
                        "status": "success",
                        "testReport": {
                            "id": 46624,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 99.95,
                            "test_suites": [
                                {
                                    "id": 53895,
                                    "total_time": 24.89,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3558163,
                                            "classname": "click allow selection",
                                            "execution_time": 5.66,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558158,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.23,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558153,
                                            "classname": "click nothing",
                                            "execution_time": 7.37,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558168,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.63,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53905,
                                    "total_time": 75.06,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3558230,
                                            "classname": "click nothing",
                                            "execution_time": 0.55,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558226,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.82,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558200,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.89,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558196,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.01,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558190,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.38,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558186,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 7.58,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558180,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 10.07,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558177,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.4,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558171,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3558220,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.46,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558216,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.25,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558210,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.29,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558206,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.36,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 728950,
                            "isTestReportAvailable": true,
                            "duration": 2358,
                            "duration_inMinutes": 39.3,
                            "created_at": "Mar-11-22",
                            "created_at_rawDateFormat": "2022-03-11T07:04:46.371Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 490012622,
                        "gitlabId": 490012622,
                        "status": "success",
                        "testReport": {
                            "id": 46625,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 105.35,
                            "test_suites": [
                                {
                                    "id": 53894,
                                    "total_time": 76.69,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3552573,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.95,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552567,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3552577,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.66,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552582,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 7.88,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552586,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.44,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552592,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.06,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552596,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.67,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552602,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.33,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552606,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.27,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552612,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.27,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552616,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.79,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552622,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.75,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552626,
                                            "classname": "click nothing",
                                            "execution_time": 0.63,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53889,
                                    "total_time": 28.67,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3552566,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 9.38,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552572,
                                            "classname": "click nothing",
                                            "execution_time": 8.07,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552576,
                                            "classname": "click allow selection",
                                            "execution_time": 6.17,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552581,
                                            "classname": "click allow necessary",
                                            "execution_time": 5.05,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 728949,
                            "isTestReportAvailable": true,
                            "duration": 2914,
                            "duration_inMinutes": 48.57,
                            "created_at": "Mar-11-22",
                            "created_at_rawDateFormat": "2022-03-11T07:04:46.275Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 490012414,
                        "gitlabId": 490012414,
                        "status": "success",
                        "testReport": {
                            "id": 46626,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 99.98,
                            "test_suites": [
                                {
                                    "id": 53903,
                                    "total_time": 74.78,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3552687,
                                            "classname": "click nothing",
                                            "execution_time": 0.56,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552569,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3552578,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.69,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552588,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.63,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552597,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 7.68,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552607,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.16,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552617,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 6.96,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552627,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.84,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552637,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.34,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552647,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.28,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552657,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.25,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552667,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.63,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552677,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.75,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53898,
                                    "total_time": 25.19,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3552587,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.73,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552583,
                                            "classname": "click allow selection",
                                            "execution_time": 5.62,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552574,
                                            "classname": "click nothing",
                                            "execution_time": 7.28,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552568,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.57,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 728951,
                            "isTestReportAvailable": true,
                            "duration": 3108,
                            "duration_inMinutes": 51.8,
                            "created_at": "Mar-11-22",
                            "created_at_rawDateFormat": "2022-03-11T07:04:46.406Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 489803070,
                        "gitlabId": 489803070,
                        "status": "success",
                        "testReport": {
                            "id": 46629,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 101.73,
                            "test_suites": [
                                {
                                    "id": 53906,
                                    "total_time": 75.29,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553723,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.64,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553755,
                                            "classname": "click allow only necessary",
                                            "execution_time": 3.06,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553760,
                                            "classname": "click nothing",
                                            "execution_time": 0.54,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553733,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.29,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553739,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.25,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553744,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.22,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553750,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.46,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553729,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.64,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553696,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553701,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.61,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553706,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.67,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553711,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.89,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553719,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.02,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53900,
                                    "total_time": 26.44,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553686,
                                            "classname": "click allow selection",
                                            "execution_time": 6.2,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553676,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.58,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553681,
                                            "classname": "click nothing",
                                            "execution_time": 7.48,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553691,
                                            "classname": "click allow necessary",
                                            "execution_time": 5.17,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 728952,
                            "isTestReportAvailable": true,
                            "duration": 3106,
                            "duration_inMinutes": 51.77,
                            "created_at": "Mar-11-22",
                            "created_at_rawDateFormat": "2022-03-11T07:04:46.439Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 489802951,
                        "gitlabId": 489802951,
                        "status": "success",
                        "testReport": {
                            "id": 46628,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 104.37,
                            "test_suites": [
                                {
                                    "id": 53901,
                                    "total_time": 28.09,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553238,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.94,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553234,
                                            "classname": "click allow selection",
                                            "execution_time": 6.04,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553228,
                                            "classname": "click nothing",
                                            "execution_time": 7.19,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553224,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 9.92,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53907,
                                    "total_time": 76.28,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553263,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.98,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553257,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.48,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553302,
                                            "classname": "click nothing",
                                            "execution_time": 0.75,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553292,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.89,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553288,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.42,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553267,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 6.95,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553282,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.33,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553277,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.34,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553273,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.41,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553235,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553241,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.54,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553245,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.68,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553251,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 7.51,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 728953,
                            "isTestReportAvailable": true,
                            "duration": 3039,
                            "duration_inMinutes": 50.65,
                            "created_at": "Mar-11-22",
                            "created_at_rawDateFormat": "2022-03-11T07:04:46.496Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 489795122,
                        "gitlabId": 489795122,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 729167,
                            "isTestReportAvailable": false,
                            "duration": 973,
                            "duration_inMinutes": 16.22,
                            "created_at": "Mar-11-22",
                            "created_at_rawDateFormat": "2022-03-11T07:05:00.444Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 489792989,
                        "gitlabId": 489792989,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 729174,
                            "isTestReportAvailable": false,
                            "duration": 1150,
                            "duration_inMinutes": 19.17,
                            "created_at": "Mar-11-22",
                            "created_at_rawDateFormat": "2022-03-11T07:05:00.926Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 489135415,
                        "gitlabId": 489135415,
                        "status": "success",
                        "testReport": {
                            "id": 46631,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 102.65,
                            "test_suites": [
                                {
                                    "id": 53909,
                                    "total_time": 75.94,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554322,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.95,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554309,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.33,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554304,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 8.07,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554326,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.36,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554332,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.26,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554342,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.8,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554289,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3554294,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.3,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554316,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.2,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554299,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 10.04,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554352,
                                            "classname": "click nothing",
                                            "execution_time": 0.64,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554336,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.25,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554346,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.74,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53904,
                                    "total_time": 26.71,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554298,
                                            "classname": "click allow necessary",
                                            "execution_time": 5.07,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554293,
                                            "classname": "click allow selection",
                                            "execution_time": 6.09,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554288,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.39,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554282,
                                            "classname": "click nothing",
                                            "execution_time": 8.15,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729168,
                            "isTestReportAvailable": true,
                            "duration": 2875,
                            "duration_inMinutes": 47.92,
                            "created_at": "Mar-10-22",
                            "created_at_rawDateFormat": "2022-03-10T07:05:00.497Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 489133381,
                        "gitlabId": 489133381,
                        "status": "success",
                        "testReport": {
                            "id": 46630,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 104.33,
                            "test_suites": [
                                {
                                    "id": 53908,
                                    "total_time": 29.47,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3552570,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 9.77,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552579,
                                            "classname": "click nothing",
                                            "execution_time": 8.74,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552589,
                                            "classname": "click allow selection",
                                            "execution_time": 5.93,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552599,
                                            "classname": "click allow necessary",
                                            "execution_time": 5.03,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53913,
                                    "total_time": 74.86,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3552614,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.28,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552610,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.31,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552620,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.74,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552624,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.78,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552571,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3552575,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.8,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552580,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.91,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552584,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.25,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552590,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.07,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552594,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.95,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552600,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.81,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552604,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.36,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552630,
                                            "classname": "click nothing",
                                            "execution_time": 0.59,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729170,
                            "isTestReportAvailable": true,
                            "duration": 3015,
                            "duration_inMinutes": 50.25,
                            "created_at": "Mar-10-22",
                            "created_at_rawDateFormat": "2022-03-10T07:05:00.645Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 489055396,
                        "gitlabId": 489055396,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 729171,
                            "isTestReportAvailable": false,
                            "duration": 20,
                            "duration_inMinutes": 0.33,
                            "created_at": "Mar-10-22",
                            "created_at_rawDateFormat": "2022-03-10T07:05:00.673Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 489047665,
                        "gitlabId": 489047665,
                        "status": "success",
                        "testReport": {
                            "id": 46632,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 100.48,
                            "test_suites": [
                                {
                                    "id": 53916,
                                    "total_time": 75.8,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553793,
                                            "classname": "click nothing",
                                            "execution_time": 0.84,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553788,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.76,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553783,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.72,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553778,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.18,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553759,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 6.98,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553764,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.96,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553769,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.31,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553754,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.02,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553749,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 7.58,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553773,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.29,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553743,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.76,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553738,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.4,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553732,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        }
                                    ]
                                },
                                {
                                    "id": 53910,
                                    "total_time": 24.68,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553715,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.31,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553724,
                                            "classname": "click nothing",
                                            "execution_time": 7.19,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553735,
                                            "classname": "click allow selection",
                                            "execution_time": 5.59,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553746,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.58,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729172,
                            "isTestReportAvailable": true,
                            "duration": 2389,
                            "duration_inMinutes": 39.82,
                            "created_at": "Mar-10-22",
                            "created_at_rawDateFormat": "2022-03-10T07:05:00.777Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 488999537,
                        "gitlabId": 488999537,
                        "status": "success",
                        "testReport": {
                            "id": 46633,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.9,
                            "test_suites": [
                                {
                                    "id": 53922,
                                    "total_time": 74.37,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554675,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.77,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554685,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.42,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554695,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.29,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554705,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.2,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554715,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.48,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554725,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.83,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554735,
                                            "classname": "click nothing",
                                            "execution_time": 0.55,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554631,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3554637,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.63,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554640,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.78,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554650,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.34,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554660,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.08,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554670,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.01,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53912,
                                    "total_time": 24.53,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554621,
                                            "classname": "click allow selection",
                                            "execution_time": 5.61,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554627,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.56,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554611,
                                            "classname": "click nothing",
                                            "execution_time": 7.29,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554617,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.07,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729180,
                            "isTestReportAvailable": true,
                            "duration": 3008,
                            "duration_inMinutes": 50.13,
                            "created_at": "Mar-10-22",
                            "created_at_rawDateFormat": "2022-03-10T07:05:01.229Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 488997937,
                        "gitlabId": 488997937,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729173,
                            "isTestReportAvailable": false,
                            "duration": 1620,
                            "duration_inMinutes": 27,
                            "created_at": "Mar-10-22",
                            "created_at_rawDateFormat": "2022-03-10T07:05:00.867Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 488967148,
                        "gitlabId": 488967148,
                        "status": "success",
                        "testReport": {
                            "id": 46635,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 151.09,
                            "test_suites": [
                                {
                                    "id": 53917,
                                    "total_time": 127.12,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553320,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 6.57,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553310,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.98,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553316,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.95,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553326,
                                            "classname": "click nothing",
                                            "execution_time": 2.46,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553265,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553306,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 7.39,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553300,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.54,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553293,
                                            "classname": "click allow only necessary",
                                            "execution_time": 8.46,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553289,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 8.68,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553283,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 10.24,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553278,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 18.52,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553274,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 21.66,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553269,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 21.67,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53911,
                                    "total_time": 23.97,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553259,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.54,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553255,
                                            "classname": "click allow selection",
                                            "execution_time": 5.61,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553248,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.76,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553244,
                                            "classname": "click nothing",
                                            "execution_time": 7.06,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729176,
                            "isTestReportAvailable": true,
                            "duration": 3144,
                            "duration_inMinutes": 52.4,
                            "created_at": "Mar-10-22",
                            "created_at_rawDateFormat": "2022-03-10T07:05:01.098Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 488921883,
                        "gitlabId": 488921883,
                        "status": "success",
                        "testReport": {
                            "id": 46634,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 99.35,
                            "test_suites": [
                                {
                                    "id": 53925,
                                    "total_time": 74.01,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3558245,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.79,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558255,
                                            "classname": "click nothing",
                                            "execution_time": 0.53,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558249,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.63,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558239,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.23,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558235,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.25,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558229,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.31,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558225,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.73,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558219,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.95,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558215,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 6.99,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558209,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.27,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558205,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.68,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558198,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.64,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558193,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        }
                                    ]
                                },
                                {
                                    "id": 53915,
                                    "total_time": 25.34,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3558188,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.58,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558183,
                                            "classname": "click allow selection",
                                            "execution_time": 6.12,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558178,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.14,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558173,
                                            "classname": "click nothing",
                                            "execution_time": 7.49,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729175,
                            "isTestReportAvailable": true,
                            "duration": 2426,
                            "duration_inMinutes": 40.43,
                            "created_at": "Mar-10-22",
                            "created_at_rawDateFormat": "2022-03-10T07:05:00.974Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 488349672,
                        "gitlabId": 488349672,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729179,
                            "isTestReportAvailable": false,
                            "duration": 694,
                            "duration_inMinutes": 11.57,
                            "created_at": "Mar-09-22",
                            "created_at_rawDateFormat": "2022-03-09T07:05:01.213Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 488195012,
                        "gitlabId": 488195012,
                        "status": "success",
                        "testReport": {
                            "id": 46636,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 99.63,
                            "test_suites": [
                                {
                                    "id": 53919,
                                    "total_time": 75.1,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554337,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.27,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554343,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.24,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554347,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.89,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554353,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.71,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554323,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.83,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554355,
                                            "classname": "click nothing",
                                            "execution_time": 0.55,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554296,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3554301,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.95,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554306,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 10.05,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554317,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.12,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554311,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.43,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554327,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.77,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554333,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.3,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53914,
                                    "total_time": 24.53,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554314,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.6,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554312,
                                            "classname": "click allow selection",
                                            "execution_time": 5.52,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554302,
                                            "classname": "click nothing",
                                            "execution_time": 7.15,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554292,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.26,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729177,
                            "isTestReportAvailable": true,
                            "duration": 3380,
                            "duration_inMinutes": 56.33,
                            "created_at": "Mar-09-22",
                            "created_at_rawDateFormat": "2022-03-09T07:05:01.122Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 488121876,
                        "gitlabId": 488121876,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729178,
                            "isTestReportAvailable": false,
                            "duration": 2043,
                            "duration_inMinutes": 34.05,
                            "created_at": "Mar-09-22",
                            "created_at_rawDateFormat": "2022-03-09T07:05:01.191Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 488072490,
                        "gitlabId": 488072490,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729185,
                            "isTestReportAvailable": false,
                            "duration": 3215,
                            "duration_inMinutes": 53.58,
                            "created_at": "Mar-09-22",
                            "created_at_rawDateFormat": "2022-03-09T07:05:01.633Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 488059509,
                        "gitlabId": 488059509,
                        "status": "success",
                        "testReport": {
                            "id": 46637,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 156.48,
                            "test_suites": [
                                {
                                    "id": 53923,
                                    "total_time": 121.98,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3552619,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 11.74,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552593,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3552598,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 21.71,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552603,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 18.82,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552608,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 15.07,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552613,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 12.08,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552623,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 7.31,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552629,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.21,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552633,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 7.19,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552639,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.65,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552646,
                                            "classname": "click allow only necessary",
                                            "execution_time": 6.49,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552652,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 4.86,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552656,
                                            "classname": "click nothing",
                                            "execution_time": 2.85,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53918,
                                    "total_time": 34.5,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3552585,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 13.95,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552591,
                                            "classname": "click nothing",
                                            "execution_time": 8.73,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552595,
                                            "classname": "click allow selection",
                                            "execution_time": 6.41,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552601,
                                            "classname": "click allow necessary",
                                            "execution_time": 5.4,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729186,
                            "isTestReportAvailable": true,
                            "duration": 4901,
                            "duration_inMinutes": 81.68,
                            "created_at": "Mar-09-22",
                            "created_at_rawDateFormat": "2022-03-09T07:05:01.675Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 488040773,
                        "gitlabId": 488040773,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729183,
                            "isTestReportAvailable": false,
                            "duration": 3372,
                            "duration_inMinutes": 56.2,
                            "created_at": "Mar-09-22",
                            "created_at_rawDateFormat": "2022-03-09T07:05:01.619Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 488038067,
                        "gitlabId": 488038067,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729181,
                            "isTestReportAvailable": false,
                            "duration": 3867,
                            "duration_inMinutes": 64.45,
                            "created_at": "Mar-09-22",
                            "created_at_rawDateFormat": "2022-03-09T07:05:01.467Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 488030974,
                        "gitlabId": 488030974,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729182,
                            "isTestReportAvailable": false,
                            "duration": 3675,
                            "duration_inMinutes": 61.25,
                            "created_at": "Mar-09-22",
                            "created_at_rawDateFormat": "2022-03-09T07:05:01.561Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 487851021,
                        "gitlabId": 487851021,
                        "status": "success",
                        "testReport": {
                            "id": 46638,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 97.99,
                            "test_suites": [
                                {
                                    "id": 53926,
                                    "total_time": 74.21,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553753,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553800,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.32,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553758,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.78,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553763,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.79,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553768,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 6.95,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553775,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 6.91,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553785,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.78,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553815,
                                            "classname": "click nothing",
                                            "execution_time": 0.56,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553810,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.76,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553790,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.4,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553795,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.35,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553780,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.78,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553805,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.84,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53920,
                                    "total_time": 23.77,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553781,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.6,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553771,
                                            "classname": "click allow selection",
                                            "execution_time": 5.55,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553761,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.65,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553751,
                                            "classname": "click nothing",
                                            "execution_time": 6.97,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729184,
                            "isTestReportAvailable": true,
                            "duration": 2338,
                            "duration_inMinutes": 38.97,
                            "created_at": "Mar-09-22",
                            "created_at_rawDateFormat": "2022-03-09T07:05:01.624Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 487400682,
                        "gitlabId": 487400682,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729191,
                            "isTestReportAvailable": false,
                            "duration": 1790,
                            "duration_inMinutes": 29.83,
                            "created_at": "Mar-08-22",
                            "created_at_rawDateFormat": "2022-03-08T07:05:02.086Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 487379885,
                        "gitlabId": 487379885,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729187,
                            "isTestReportAvailable": false,
                            "duration": 2101,
                            "duration_inMinutes": 35.02,
                            "created_at": "Mar-08-22",
                            "created_at_rawDateFormat": "2022-03-08T07:05:01.855Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 487373411,
                        "gitlabId": 487373411,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729189,
                            "isTestReportAvailable": false,
                            "duration": 1143,
                            "duration_inMinutes": 19.05,
                            "created_at": "Mar-08-22",
                            "created_at_rawDateFormat": "2022-03-08T07:05:01.932Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 487343177,
                        "gitlabId": 487343177,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729192,
                            "isTestReportAvailable": false,
                            "duration": 1736,
                            "duration_inMinutes": 28.93,
                            "created_at": "Mar-08-22",
                            "created_at_rawDateFormat": "2022-03-08T07:05:02.124Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 487213924,
                        "gitlabId": 487213924,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729188,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Mar-08-22",
                            "created_at_rawDateFormat": "2022-03-08T07:05:01.919Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 487135614,
                        "gitlabId": 487135614,
                        "status": "success",
                        "testReport": {
                            "id": 46639,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 100.47,
                            "test_suites": [
                                {
                                    "id": 53927,
                                    "total_time": 76.16,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553334,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.26,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553299,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.84,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553305,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 8.88,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553315,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.04,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553319,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.52,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553325,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.41,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553344,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.68,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553296,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.13,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553286,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553350,
                                            "classname": "click nothing",
                                            "execution_time": 0.54,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553309,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.13,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553329,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.28,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553339,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.46,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53921,
                                    "total_time": 24.31,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553281,
                                            "classname": "click nothing",
                                            "execution_time": 7.18,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553287,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.02,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553291,
                                            "classname": "click allow selection",
                                            "execution_time": 5.57,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553297,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.54,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729190,
                            "isTestReportAvailable": true,
                            "duration": 2545,
                            "duration_inMinutes": 42.42,
                            "created_at": "Mar-08-22",
                            "created_at_rawDateFormat": "2022-03-08T07:05:01.974Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 487091688,
                        "gitlabId": 487091688,
                        "status": "success",
                        "testReport": {
                            "id": 46640,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 99.02,
                            "test_suites": [
                                {
                                    "id": 53929,
                                    "total_time": 74.96,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554416,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.65,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554419,
                                            "classname": "click nothing",
                                            "execution_time": 0.52,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554310,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3554319,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.73,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554329,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.91,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554339,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.26,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554349,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.07,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554359,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.93,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554367,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.75,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554387,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.48,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554397,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.27,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554406,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.81,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554377,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.57,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53924,
                                    "total_time": 24.06,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554328,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.57,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554308,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.94,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554303,
                                            "classname": "click nothing",
                                            "execution_time": 6.95,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554318,
                                            "classname": "click allow selection",
                                            "execution_time": 5.61,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729196,
                            "isTestReportAvailable": true,
                            "duration": 2793,
                            "duration_inMinutes": 46.55,
                            "created_at": "Mar-08-22",
                            "created_at_rawDateFormat": "2022-03-08T07:05:02.271Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 487004075,
                        "gitlabId": 487004075,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729193,
                            "isTestReportAvailable": false,
                            "duration": 1329,
                            "duration_inMinutes": 22.15,
                            "created_at": "Mar-08-22",
                            "created_at_rawDateFormat": "2022-03-08T07:05:02.188Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 486220718,
                        "gitlabId": 486220718,
                        "status": "success",
                        "testReport": {
                            "id": 46641,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.19,
                            "test_suites": [
                                {
                                    "id": 53933,
                                    "total_time": 73.88,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3552609,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3552698,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.13,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552688,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.27,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552678,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.3,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552668,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.91,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552658,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552648,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.07,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552728,
                                            "classname": "click nothing",
                                            "execution_time": 0.53,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552638,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.29,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552628,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.61,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552718,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.86,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552708,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.48,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552618,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.43,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53928,
                                    "total_time": 24.3,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3552605,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.12,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552611,
                                            "classname": "click nothing",
                                            "execution_time": 7.01,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552615,
                                            "classname": "click allow selection",
                                            "execution_time": 5.58,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552621,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.59,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729194,
                            "isTestReportAvailable": true,
                            "duration": 2387,
                            "duration_inMinutes": 39.78,
                            "created_at": "Mar-07-22",
                            "created_at_rawDateFormat": "2022-03-07T07:05:02.197Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 486177334,
                        "gitlabId": 486177334,
                        "status": "success",
                        "testReport": {
                            "id": 46642,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 99.65,
                            "test_suites": [
                                {
                                    "id": 53936,
                                    "total_time": 75.45,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553777,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.42,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553782,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.02,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553787,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.72,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553792,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.64,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553822,
                                            "classname": "click nothing",
                                            "execution_time": 0.53,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553817,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.66,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553812,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.91,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553807,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.2,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553802,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.28,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553797,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.32,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553762,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553767,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 12.1,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553772,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.65,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53930,
                                    "total_time": 24.2,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553756,
                                            "classname": "click nothing",
                                            "execution_time": 7.1,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553766,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.92,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553776,
                                            "classname": "click allow selection",
                                            "execution_time": 5.61,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553786,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.58,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729195,
                            "isTestReportAvailable": true,
                            "duration": 2454,
                            "duration_inMinutes": 40.9,
                            "created_at": "Mar-07-22",
                            "created_at_rawDateFormat": "2022-03-07T07:05:02.251Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 486137447,
                        "gitlabId": 486137447,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729197,
                            "isTestReportAvailable": false,
                            "duration": 2104,
                            "duration_inMinutes": 35.07,
                            "created_at": "Mar-07-22",
                            "created_at_rawDateFormat": "2022-03-07T07:05:02.485Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 486111810,
                        "gitlabId": 486111810,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729206,
                            "isTestReportAvailable": false,
                            "duration": 2313,
                            "duration_inMinutes": 38.55,
                            "created_at": "Mar-07-22",
                            "created_at_rawDateFormat": "2022-03-07T07:05:03.073Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 486098412,
                        "gitlabId": 486098412,
                        "status": "success",
                        "testReport": {
                            "id": 46643,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 118.72,
                            "test_suites": [
                                {
                                    "id": 53942,
                                    "total_time": 94.24,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554680,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 9.94,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554690,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 8.67,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554700,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 8.54,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554750,
                                            "classname": "click allow only necessary",
                                            "execution_time": 3.63,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554730,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.69,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554720,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 7.81,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554710,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 8.29,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554740,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.83,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554639,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3554649,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 12.77,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554659,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 12.02,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554669,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 10.2,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554760,
                                            "classname": "click nothing",
                                            "execution_time": 0.85,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53932,
                                    "total_time": 24.48,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554638,
                                            "classname": "click nothing",
                                            "execution_time": 7.2,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554641,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.83,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554645,
                                            "classname": "click allow selection",
                                            "execution_time": 5.66,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554651,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.8,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729198,
                            "isTestReportAvailable": true,
                            "duration": 3421,
                            "duration_inMinutes": 57.02,
                            "created_at": "Mar-07-22",
                            "created_at_rawDateFormat": "2022-03-07T07:05:02.569Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 486087001,
                        "gitlabId": 486087001,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729200,
                            "isTestReportAvailable": false,
                            "duration": 1590,
                            "duration_inMinutes": 26.5,
                            "created_at": "Mar-07-22",
                            "created_at_rawDateFormat": "2022-03-07T07:05:02.741Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 486054070,
                        "gitlabId": 486054070,
                        "status": "success",
                        "testReport": {
                            "id": 46644,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 104.92,
                            "test_suites": [
                                {
                                    "id": 53937,
                                    "total_time": 80.78,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553336,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.65,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553380,
                                            "classname": "click nothing",
                                            "execution_time": 0.74,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553375,
                                            "classname": "click allow only necessary",
                                            "execution_time": 3.32,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553370,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 4.13,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553365,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.25,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553357,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.3,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553303,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553313,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 11.95,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553322,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.09,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553331,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 8.84,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553341,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.33,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553346,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.77,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553351,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.43,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53931,
                                    "total_time": 24.14,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553314,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.51,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553308,
                                            "classname": "click allow selection",
                                            "execution_time": 5.59,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553304,
                                            "classname": "click nothing",
                                            "execution_time": 6.82,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553298,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.21,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729201,
                            "isTestReportAvailable": true,
                            "duration": 2489,
                            "duration_inMinutes": 41.48,
                            "created_at": "Mar-07-22",
                            "created_at_rawDateFormat": "2022-03-07T07:05:02.764Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 486021843,
                        "gitlabId": 486021843,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 729199,
                            "isTestReportAvailable": false,
                            "duration": 2621,
                            "duration_inMinutes": 43.68,
                            "created_at": "Mar-07-22",
                            "created_at_rawDateFormat": "2022-03-07T07:05:02.599Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 484508758,
                        "gitlabId": 484508758,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729202,
                            "isTestReportAvailable": false,
                            "duration": 1343,
                            "duration_inMinutes": 22.38,
                            "created_at": "Mar-04-22",
                            "created_at_rawDateFormat": "2022-03-04T07:05:02.866Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 484327835,
                        "gitlabId": 484327835,
                        "status": "success",
                        "testReport": {
                            "id": 46645,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.39,
                            "test_suites": [
                                {
                                    "id": 53945,
                                    "total_time": 74.03,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3558267,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.65,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558297,
                                            "classname": "click nothing",
                                            "execution_time": 0.55,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558237,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3558242,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.48,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558247,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.95,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558252,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.12,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558292,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.67,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558282,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.28,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558277,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.31,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558272,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.35,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558287,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.81,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558262,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 6.86,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558257,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.01,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53935,
                                    "total_time": 24.36,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3558236,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.33,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558240,
                                            "classname": "click nothing",
                                            "execution_time": 6.76,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558246,
                                            "classname": "click allow selection",
                                            "execution_time": 5.61,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558250,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.67,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729204,
                            "isTestReportAvailable": true,
                            "duration": 2426,
                            "duration_inMinutes": 40.43,
                            "created_at": "Mar-04-22",
                            "created_at_rawDateFormat": "2022-03-04T07:05:03.025Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 483818631,
                        "gitlabId": 483818631,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729203,
                            "isTestReportAvailable": false,
                            "duration": 1333,
                            "duration_inMinutes": 22.22,
                            "created_at": "Mar-03-22",
                            "created_at_rawDateFormat": "2022-03-03T07:05:02.871Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 482760184,
                        "gitlabId": 482760184,
                        "status": "success",
                        "testReport": {
                            "id": 46646,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.29,
                            "test_suites": [
                                {
                                    "id": 53939,
                                    "total_time": 74.07,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554391,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.29,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554396,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.68,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554401,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.78,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554365,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.19,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554358,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.22,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554407,
                                            "classname": "click nothing",
                                            "execution_time": 0.57,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554375,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 6.54,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554354,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.8,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554348,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.47,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554338,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3554371,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.66,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554381,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.53,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554385,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.35,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53934,
                                    "total_time": 24.22,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554330,
                                            "classname": "click allow selection",
                                            "execution_time": 5.52,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554324,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.73,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554320,
                                            "classname": "click nothing",
                                            "execution_time": 7.4,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554334,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.58,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729205,
                            "isTestReportAvailable": true,
                            "duration": 2443,
                            "duration_inMinutes": 40.72,
                            "created_at": "Mar-02-22",
                            "created_at_rawDateFormat": "2022-03-02T07:05:03.030Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 482725381,
                        "gitlabId": 482725381,
                        "status": "success",
                        "testReport": {
                            "id": 46648,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 103.69,
                            "test_suites": [
                                {
                                    "id": 53938,
                                    "total_time": 24.6,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3552635,
                                            "classname": "click allow selection",
                                            "execution_time": 5.63,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552625,
                                            "classname": "click nothing",
                                            "execution_time": 7.29,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552631,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.98,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552641,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.7,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53943,
                                    "total_time": 79.09,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3552632,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3552636,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.64,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552665,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.82,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552645,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 8.09,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552671,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.47,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552642,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.93,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552675,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.44,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552681,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.78,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552685,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.81,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552691,
                                            "classname": "click nothing",
                                            "execution_time": 0.71,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552661,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552655,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.54,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552651,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 7.85,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729207,
                            "isTestReportAvailable": true,
                            "duration": 2565,
                            "duration_inMinutes": 42.75,
                            "created_at": "Mar-02-22",
                            "created_at_rawDateFormat": "2022-03-02T07:05:03.092Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 482715646,
                        "gitlabId": 482715646,
                        "status": "success",
                        "testReport": {
                            "id": 46647,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 99.54,
                            "test_suites": [
                                {
                                    "id": 53946,
                                    "total_time": 74.58,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553834,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.46,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553799,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 7.88,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553804,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.11,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553809,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.03,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553839,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.85,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553844,
                                            "classname": "click nothing",
                                            "execution_time": 0.62,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553794,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.73,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553789,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 9.98,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553784,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553814,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 6.84,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553819,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.4,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553824,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.37,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553829,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.29,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53940,
                                    "total_time": 24.96,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553779,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.79,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553774,
                                            "classname": "click allow selection",
                                            "execution_time": 5.71,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553770,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.1,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553765,
                                            "classname": "click nothing",
                                            "execution_time": 7.37,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729210,
                            "isTestReportAvailable": true,
                            "duration": 2579,
                            "duration_inMinutes": 42.98,
                            "created_at": "Mar-02-22",
                            "created_at_rawDateFormat": "2022-03-02T07:05:03.367Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 482671262,
                        "gitlabId": 482671262,
                        "status": "success",
                        "testReport": {
                            "id": 46651,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.76,
                            "test_suites": [
                                {
                                    "id": 53947,
                                    "total_time": 74.47,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553396,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.25,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553356,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.79,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553366,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.53,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553376,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.42,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553386,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.36,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553406,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.41,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553416,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.72,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553426,
                                            "classname": "click nothing",
                                            "execution_time": 0.53,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553317,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553347,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.09,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553321,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.03,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553327,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.73,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553337,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.6,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53941,
                                    "total_time": 24.28,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553312,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.2,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553323,
                                            "classname": "click nothing",
                                            "execution_time": 6.95,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553342,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.56,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553332,
                                            "classname": "click allow selection",
                                            "execution_time": 5.57,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729208,
                            "isTestReportAvailable": true,
                            "duration": 2487,
                            "duration_inMinutes": 41.45,
                            "created_at": "Mar-02-22",
                            "created_at_rawDateFormat": "2022-03-02T07:05:03.198Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 482664532,
                        "gitlabId": 482664532,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 729213,
                            "isTestReportAvailable": false,
                            "duration": 600,
                            "duration_inMinutes": 10,
                            "created_at": "Mar-02-22",
                            "created_at_rawDateFormat": "2022-03-02T07:05:03.476Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 480997510,
                        "gitlabId": 480997510,
                        "status": "success",
                        "testReport": {
                            "id": 46649,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.33,
                            "test_suites": [
                                {
                                    "id": 53949,
                                    "total_time": 73.5,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554382,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.85,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554388,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.37,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554392,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.25,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554398,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.23,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554402,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.49,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554408,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.73,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554412,
                                            "classname": "click nothing",
                                            "execution_time": 0.66,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554351,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3554357,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.18,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554362,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.88,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554368,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.11,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554372,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 6.88,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554378,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.87,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53944,
                                    "total_time": 24.83,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554344,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.22,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554340,
                                            "classname": "click nothing",
                                            "execution_time": 7.26,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554360,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.66,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554350,
                                            "classname": "click allow selection",
                                            "execution_time": 5.7,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729220,
                            "isTestReportAvailable": true,
                            "duration": 2467,
                            "duration_inMinutes": 41.12,
                            "created_at": "Feb-28-22",
                            "created_at_rawDateFormat": "2022-02-28T07:05:04.014Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 480881441,
                        "gitlabId": 480881441,
                        "status": "success",
                        "testReport": {
                            "id": 46650,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.88,
                            "test_suites": [
                                {
                                    "id": 53953,
                                    "total_time": 74.94,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3552690,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.11,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552644,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3552650,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.99,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552654,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.77,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552660,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 7.52,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552664,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.47,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552670,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 6.9,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552674,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.79,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552680,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.29,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552684,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.21,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552694,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.51,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552700,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.74,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552704,
                                            "classname": "click nothing",
                                            "execution_time": 0.64,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53948,
                                    "total_time": 23.94,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3552634,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.95,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552640,
                                            "classname": "click nothing",
                                            "execution_time": 6.64,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552643,
                                            "classname": "click allow selection",
                                            "execution_time": 5.64,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552649,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.72,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729211,
                            "isTestReportAvailable": true,
                            "duration": 2466,
                            "duration_inMinutes": 41.1,
                            "created_at": "Feb-28-22",
                            "created_at_rawDateFormat": "2022-02-28T07:05:03.447Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 480847235,
                        "gitlabId": 480847235,
                        "status": "success",
                        "testReport": {
                            "id": 46652,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 100.04,
                            "test_suites": [
                                {
                                    "id": 53950,
                                    "total_time": 23.96,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553791,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.92,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553801,
                                            "classname": "click nothing",
                                            "execution_time": 6.92,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553811,
                                            "classname": "click allow selection",
                                            "execution_time": 5.57,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553821,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.55,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53956,
                                    "total_time": 76.08,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553816,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.66,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553796,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553826,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 7.82,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553836,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.47,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553846,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.04,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553856,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.85,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553806,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.44,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553866,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.31,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553876,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.27,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553886,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.2,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553896,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.76,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553916,
                                            "classname": "click nothing",
                                            "execution_time": 0.54,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553906,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.73,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729209,
                            "isTestReportAvailable": true,
                            "duration": 2558,
                            "duration_inMinutes": 42.63,
                            "created_at": "Feb-28-22",
                            "created_at_rawDateFormat": "2022-02-28T07:05:03.353Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 480841639,
                        "gitlabId": 480841639,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 729212,
                            "isTestReportAvailable": false,
                            "duration": 953,
                            "duration_inMinutes": 15.88,
                            "created_at": "Feb-28-22",
                            "created_at_rawDateFormat": "2022-02-28T07:05:03.472Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 480808043,
                        "gitlabId": 480808043,
                        "status": "canceled",
                        "testReport": {
                            "id": 46655,
                            "error_count": 0,
                            "failed_count": 0,
                            "skipped_count": 0,
                            "success_count": 4,
                            "total_count": 4,
                            "total_time": 24.1,
                            "test_suites": [
                                {
                                    "id": 53952,
                                    "total_time": 24.1,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554655,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554665,
                                            "classname": "click allow selection",
                                            "execution_time": 5.76,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554671,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.55,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554661,
                                            "classname": "click nothing",
                                            "execution_time": 6.79,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729217,
                            "isTestReportAvailable": true,
                            "duration": 1772,
                            "duration_inMinutes": 29.53,
                            "created_at": "Feb-28-22",
                            "created_at_rawDateFormat": "2022-02-28T07:05:03.772Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 480716649,
                        "gitlabId": 480716649,
                        "status": "success",
                        "testReport": {
                            "id": 46653,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 97.9,
                            "test_suites": [
                                {
                                    "id": 53957,
                                    "total_time": 73.72,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553384,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.73,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553330,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553335,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.2,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553340,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.78,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553345,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.91,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553349,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 6.84,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553355,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 6.82,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553360,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.63,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553364,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.28,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553369,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.28,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553374,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.24,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553379,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.46,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553389,
                                            "classname": "click nothing",
                                            "execution_time": 0.57,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53951,
                                    "total_time": 24.18,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553318,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.1,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553324,
                                            "classname": "click nothing",
                                            "execution_time": 7.07,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553328,
                                            "classname": "click allow selection",
                                            "execution_time": 5.51,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553333,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.51,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729214,
                            "isTestReportAvailable": true,
                            "duration": 2358,
                            "duration_inMinutes": 39.3,
                            "created_at": "Feb-28-22",
                            "created_at_rawDateFormat": "2022-02-28T07:05:03.647Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 477682722,
                        "gitlabId": 477682722,
                        "status": "success",
                        "testReport": {
                            "id": 46654,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 100.78,
                            "test_suites": [
                                {
                                    "id": 53961,
                                    "total_time": 75.74,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3558339,
                                            "classname": "click nothing",
                                            "execution_time": 0.53,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558329,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.89,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558319,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.42,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558289,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.95,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558295,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.85,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558285,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.06,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558259,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3558265,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.89,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558269,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.79,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558275,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 7.53,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558279,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.39,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558299,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.27,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558309,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.17,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53955,
                                    "total_time": 25.04,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3558256,
                                            "classname": "click nothing",
                                            "execution_time": 7.38,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558260,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.27,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558266,
                                            "classname": "click allow selection",
                                            "execution_time": 5.69,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558270,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.71,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729216,
                            "isTestReportAvailable": true,
                            "duration": 2509,
                            "duration_inMinutes": 41.82,
                            "created_at": "Feb-23-22",
                            "created_at_rawDateFormat": "2022-02-23T07:05:03.764Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 477654266,
                        "gitlabId": 477654266,
                        "status": "success",
                        "testReport": {
                            "id": 46657,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 100.32,
                            "test_suites": [
                                {
                                    "id": 53954,
                                    "total_time": 24.23,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554356,
                                            "classname": "click nothing",
                                            "execution_time": 7.34,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554386,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.61,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554376,
                                            "classname": "click allow selection",
                                            "execution_time": 5.52,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554366,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.77,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53959,
                                    "total_time": 76.09,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554420,
                                            "classname": "click nothing",
                                            "execution_time": 0.54,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554414,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.77,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554410,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.52,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554404,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.31,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554400,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.34,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554394,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.47,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554390,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.57,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554384,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.13,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554380,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.37,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554374,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.46,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554370,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 10.05,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554364,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.56,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554361,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729218,
                            "isTestReportAvailable": true,
                            "duration": 2645,
                            "duration_inMinutes": 44.08,
                            "created_at": "Feb-23-22",
                            "created_at_rawDateFormat": "2022-02-23T07:05:03.779Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 477445408,
                        "gitlabId": 477445408,
                        "status": "success",
                        "testReport": {
                            "id": 46668,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 104.14,
                            "test_suites": [
                                {
                                    "id": 53964,
                                    "total_time": 79,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3552722,
                                            "classname": "click nothing",
                                            "execution_time": 0.48,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552716,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.79,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552712,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 4.02,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552706,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.36,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552702,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.6,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552696,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.65,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552692,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.84,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552686,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.39,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552682,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.54,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552676,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 8.74,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552672,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.96,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552666,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.63,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552662,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        }
                                    ]
                                },
                                {
                                    "id": 53958,
                                    "total_time": 25.14,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3552653,
                                            "classname": "click nothing",
                                            "execution_time": 7.59,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552669,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.56,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552663,
                                            "classname": "click allow selection",
                                            "execution_time": 5.69,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552659,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.29,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729215,
                            "isTestReportAvailable": true,
                            "duration": 2450,
                            "duration_inMinutes": 40.83,
                            "created_at": "Feb-23-22",
                            "created_at_rawDateFormat": "2022-02-23T07:05:03.762Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 476809719,
                        "gitlabId": 476809719,
                        "status": "success",
                        "testReport": {
                            "id": 46656,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 97.38,
                            "test_suites": [
                                {
                                    "id": 53966,
                                    "total_time": 73.17,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553843,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.77,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553838,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.83,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553833,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.03,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553863,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.23,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553858,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.27,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553853,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.3,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553848,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 6.66,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553868,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.45,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553873,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.7,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553878,
                                            "classname": "click nothing",
                                            "execution_time": 0.5,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553828,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.69,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553823,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.74,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553818,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        }
                                    ]
                                },
                                {
                                    "id": 53960,
                                    "total_time": 24.21,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553813,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.56,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553808,
                                            "classname": "click allow selection",
                                            "execution_time": 5.55,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553798,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.08,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553803,
                                            "classname": "click nothing",
                                            "execution_time": 7.03,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729219,
                            "isTestReportAvailable": true,
                            "duration": 2347,
                            "duration_inMinutes": 39.12,
                            "created_at": "Feb-22-22",
                            "created_at_rawDateFormat": "2022-02-22T07:05:03.950Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 476730868,
                        "gitlabId": 476730868,
                        "status": "success",
                        "testReport": {
                            "id": 46659,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 99.11,
                            "test_suites": [
                                {
                                    "id": 53963,
                                    "total_time": 24.36,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554681,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.81,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554691,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.53,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554676,
                                            "classname": "click nothing",
                                            "execution_time": 7.44,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554686,
                                            "classname": "click allow selection",
                                            "execution_time": 5.58,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53973,
                                    "total_time": 74.75,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554739,
                                            "classname": "click nothing",
                                            "execution_time": 0.54,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554679,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3554684,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.79,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554689,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.84,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554694,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.41,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554699,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.26,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554704,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 6.99,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554709,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.74,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554734,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.78,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554729,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.45,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554724,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.31,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554719,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.32,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554714,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.34,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729225,
                            "isTestReportAvailable": true,
                            "duration": 2439,
                            "duration_inMinutes": 40.65,
                            "created_at": "Feb-22-22",
                            "created_at_rawDateFormat": "2022-02-22T07:05:04.261Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 476431242,
                        "gitlabId": 476431242,
                        "status": "success",
                        "testReport": {
                            "id": 46658,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 97.99,
                            "test_suites": [
                                {
                                    "id": 53967,
                                    "total_time": 74.06,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553411,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.47,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553471,
                                            "classname": "click nothing",
                                            "execution_time": 0.65,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553461,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.65,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553451,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.47,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553441,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.21,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553431,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.3,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553421,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.3,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553401,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.02,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553391,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.18,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553381,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.8,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553371,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.77,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553361,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.23,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553352,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        }
                                    ]
                                },
                                {
                                    "id": 53962,
                                    "total_time": 23.92,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553338,
                                            "classname": "click nothing",
                                            "execution_time": 7.08,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553343,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.71,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553348,
                                            "classname": "click allow selection",
                                            "execution_time": 5.59,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553353,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.54,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729221,
                            "isTestReportAvailable": true,
                            "duration": 2699,
                            "duration_inMinutes": 44.98,
                            "created_at": "Feb-22-22",
                            "created_at_rawDateFormat": "2022-02-22T07:05:04.056Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 476426388,
                        "gitlabId": 476426388,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729222,
                            "isTestReportAvailable": false,
                            "duration": 1768,
                            "duration_inMinutes": 29.47,
                            "created_at": "Feb-22-22",
                            "created_at_rawDateFormat": "2022-02-22T07:05:04.175Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 475961218,
                        "gitlabId": 475961218,
                        "status": "success",
                        "testReport": {
                            "id": 46660,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.39,
                            "test_suites": [
                                {
                                    "id": 53969,
                                    "total_time": 74.01,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554409,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.95,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554438,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.73,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554389,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.79,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554393,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.85,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554399,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.51,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554403,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.02,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554413,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.41,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554444,
                                            "classname": "click nothing",
                                            "execution_time": 0.51,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554434,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.49,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554428,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.22,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554424,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.24,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554418,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.29,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554383,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        }
                                    ]
                                },
                                {
                                    "id": 53965,
                                    "total_time": 24.38,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554363,
                                            "classname": "click nothing",
                                            "execution_time": 7.12,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554369,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.97,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554373,
                                            "classname": "click allow selection",
                                            "execution_time": 5.72,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554379,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.58,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729223,
                            "isTestReportAvailable": true,
                            "duration": 2410,
                            "duration_inMinutes": 40.17,
                            "created_at": "Feb-21-22",
                            "created_at_rawDateFormat": "2022-02-21T07:05:04.213Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 475806041,
                        "gitlabId": 475806041,
                        "status": "success",
                        "testReport": {
                            "id": 46661,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 99.67,
                            "test_suites": [
                                {
                                    "id": 53968,
                                    "total_time": 24.42,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3552679,
                                            "classname": "click nothing",
                                            "execution_time": 7,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552689,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.52,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552683,
                                            "classname": "click allow selection",
                                            "execution_time": 5.57,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552673,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.33,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53974,
                                    "total_time": 75.25,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3552707,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.64,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552717,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 10.04,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552727,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 8.01,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552737,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.08,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552747,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.07,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552757,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 6.47,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552767,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.33,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552777,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.25,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552786,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.22,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552791,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.74,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552697,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3552796,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.75,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552801,
                                            "classname": "click nothing",
                                            "execution_time": 0.66,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729224,
                            "isTestReportAvailable": true,
                            "duration": 2373,
                            "duration_inMinutes": 39.55,
                            "created_at": "Feb-21-22",
                            "created_at_rawDateFormat": "2022-02-21T07:05:04.225Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 474427697,
                        "gitlabId": 474427697,
                        "status": "success",
                        "testReport": {
                            "id": 46667,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 99.27,
                            "test_suites": [
                                {
                                    "id": 53981,
                                    "total_time": 74.48,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3558326,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.58,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558312,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.54,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558316,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.88,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558322,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 6.84,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558342,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.27,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558332,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.35,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558336,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.32,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558296,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3558346,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.85,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558300,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.85,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558306,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.65,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558356,
                                            "classname": "click nothing",
                                            "execution_time": 0.53,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558352,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.82,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53971,
                                    "total_time": 24.79,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3558276,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.36,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558280,
                                            "classname": "click nothing",
                                            "execution_time": 7.33,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558286,
                                            "classname": "click allow selection",
                                            "execution_time": 5.53,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558290,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.58,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729226,
                            "isTestReportAvailable": true,
                            "duration": 2477,
                            "duration_inMinutes": 41.28,
                            "created_at": "Feb-18-22",
                            "created_at_rawDateFormat": "2022-02-18T07:05:04.417Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 474325729,
                        "gitlabId": 474325729,
                        "status": "success",
                        "testReport": {
                            "id": 46662,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 97.56,
                            "test_suites": [
                                {
                                    "id": 53976,
                                    "total_time": 72.43,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553872,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.23,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553867,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.31,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553862,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.38,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553887,
                                            "classname": "click nothing",
                                            "execution_time": 0.5,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553882,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.74,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553857,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 6.57,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553852,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.67,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553847,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.83,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553842,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.02,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553837,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.75,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553832,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.02,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553827,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553877,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.42,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53970,
                                    "total_time": 25.13,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553835,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.7,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553830,
                                            "classname": "click allow selection",
                                            "execution_time": 5.78,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553825,
                                            "classname": "click nothing",
                                            "execution_time": 7.13,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553820,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.52,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729228,
                            "isTestReportAvailable": true,
                            "duration": 2709,
                            "duration_inMinutes": 45.15,
                            "created_at": "Feb-18-22",
                            "created_at_rawDateFormat": "2022-02-18T07:05:04.491Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 474311450,
                        "gitlabId": 474311450,
                        "status": "success",
                        "testReport": {
                            "id": 46663,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 100.6,
                            "test_suites": [
                                {
                                    "id": 53972,
                                    "total_time": 25.04,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553368,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.75,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553354,
                                            "classname": "click nothing",
                                            "execution_time": 7.33,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553359,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.24,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553363,
                                            "classname": "click allow selection",
                                            "execution_time": 5.72,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53977,
                                    "total_time": 75.56,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553392,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.34,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553412,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.91,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553407,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.51,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553417,
                                            "classname": "click nothing",
                                            "execution_time": 0.59,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553358,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553362,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.99,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553367,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 10.16,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553372,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.26,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553377,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.23,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553382,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.16,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553402,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.32,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553397,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.33,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553387,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.77,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729227,
                            "isTestReportAvailable": true,
                            "duration": 2809,
                            "duration_inMinutes": 46.82,
                            "created_at": "Feb-18-22",
                            "created_at_rawDateFormat": "2022-02-18T07:05:04.473Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 474203870,
                        "gitlabId": 474203870,
                        "status": "success",
                        "testReport": {
                            "id": 46665,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.75,
                            "test_suites": [
                                {
                                    "id": 53975,
                                    "total_time": 24.7,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554415,
                                            "classname": "click allow selection",
                                            "execution_time": 5.57,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554422,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.59,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554405,
                                            "classname": "click nothing",
                                            "execution_time": 7.22,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554395,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.32,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53979,
                                    "total_time": 74.05,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554513,
                                            "classname": "click nothing",
                                            "execution_time": 0.52,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554507,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.86,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554506,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.48,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554500,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.2,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554490,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.25,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554480,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.36,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554470,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.53,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554460,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.85,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554450,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.06,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554441,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.39,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554431,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.72,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554421,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.84,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554411,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729230,
                            "isTestReportAvailable": true,
                            "duration": 2450,
                            "duration_inMinutes": 40.83,
                            "created_at": "Feb-18-22",
                            "created_at_rawDateFormat": "2022-02-18T07:05:04.538Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 471576820,
                        "gitlabId": 471576820,
                        "status": "success",
                        "testReport": {
                            "id": 46664,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.96,
                            "test_suites": [
                                {
                                    "id": 53984,
                                    "total_time": 74.5,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3552745,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.52,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552741,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.31,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552735,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.33,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552731,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.34,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552725,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.73,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552721,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.84,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552695,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3552715,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 6.94,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552711,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.36,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552705,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.86,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552701,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.88,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552755,
                                            "classname": "click nothing",
                                            "execution_time": 0.54,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552751,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.85,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53978,
                                    "total_time": 24.46,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3552699,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552703,
                                            "classname": "click allow selection",
                                            "execution_time": 5.58,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552693,
                                            "classname": "click nothing",
                                            "execution_time": 7.28,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552709,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.59,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729229,
                            "isTestReportAvailable": true,
                            "duration": 2443,
                            "duration_inMinutes": 40.72,
                            "created_at": "Feb-15-22",
                            "created_at_rawDateFormat": "2022-02-15T07:05:04.510Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 471431773,
                        "gitlabId": 471431773,
                        "status": "success",
                        "testReport": {
                            "id": 46666,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.88,
                            "test_suites": [
                                {
                                    "id": 53986,
                                    "total_time": 74.67,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553855,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.71,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553865,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.03,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553870,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.74,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553875,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.29,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553900,
                                            "classname": "click nothing",
                                            "execution_time": 0.52,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553895,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.76,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553890,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.48,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553885,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.28,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553880,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.29,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553840,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553845,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.7,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553850,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.79,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553860,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.07,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53980,
                                    "total_time": 24.22,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553861,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.54,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553851,
                                            "classname": "click allow selection",
                                            "execution_time": 5.63,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553841,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.88,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553831,
                                            "classname": "click nothing",
                                            "execution_time": 7.16,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729231,
                            "isTestReportAvailable": true,
                            "duration": 2406,
                            "duration_inMinutes": 40.1,
                            "created_at": "Feb-15-22",
                            "created_at_rawDateFormat": "2022-02-15T07:05:04.566Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 471225038,
                        "gitlabId": 471225038,
                        "status": "success",
                        "testReport": {
                            "id": 46674,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 97.07,
                            "test_suites": [
                                {
                                    "id": 53993,
                                    "total_time": 73.07,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554757,
                                            "classname": "click nothing",
                                            "execution_time": 0.53,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554752,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.65,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554747,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.84,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554697,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3554727,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 6.79,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554722,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.9,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554717,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 6.97,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554712,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.05,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554702,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 9.96,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554707,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.68,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554732,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.25,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554737,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.24,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554742,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.22,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53983,
                                    "total_time": 23.99,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554696,
                                            "classname": "click nothing",
                                            "execution_time": 7.06,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554701,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.76,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554706,
                                            "classname": "click allow selection",
                                            "execution_time": 5.56,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554711,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.62,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729232,
                            "isTestReportAvailable": true,
                            "duration": 2288,
                            "duration_inMinutes": 38.13,
                            "created_at": "Feb-15-22",
                            "created_at_rawDateFormat": "2022-02-15T07:05:04.685Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 470583210,
                        "gitlabId": 470583210,
                        "status": "success",
                        "testReport": {
                            "id": 46671,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.64,
                            "test_suites": [
                                {
                                    "id": 53987,
                                    "total_time": 74.24,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553435,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.47,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553390,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.04,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553395,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.64,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553400,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.1,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553405,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.02,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553410,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.88,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553415,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.83,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553420,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.44,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553425,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.3,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553385,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553430,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.26,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553440,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.69,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553445,
                                            "classname": "click nothing",
                                            "execution_time": 0.56,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53982,
                                    "total_time": 24.4,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553373,
                                            "classname": "click nothing",
                                            "execution_time": 7.29,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553378,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.02,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553383,
                                            "classname": "click allow selection",
                                            "execution_time": 5.49,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553388,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.6,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729233,
                            "isTestReportAvailable": true,
                            "duration": 2439,
                            "duration_inMinutes": 40.65,
                            "created_at": "Feb-14-22",
                            "created_at_rawDateFormat": "2022-02-14T07:05:04.764Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 468793585,
                        "gitlabId": 468793585,
                        "status": "success",
                        "testReport": {
                            "id": 46669,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.93,
                            "test_suites": [
                                {
                                    "id": 53989,
                                    "total_time": 74.2,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554445,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.23,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554484,
                                            "classname": "click nothing",
                                            "execution_time": 0.54,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554425,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3554439,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.4,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554429,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.09,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554475,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.49,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554478,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.68,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554455,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.51,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554435,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.67,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554459,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.39,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554465,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.27,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554469,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.24,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554449,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.7,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53985,
                                    "total_time": 24.73,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554423,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.72,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554417,
                                            "classname": "click nothing",
                                            "execution_time": 7.85,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554427,
                                            "classname": "click allow selection",
                                            "execution_time": 5.59,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554433,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.57,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729237,
                            "isTestReportAvailable": true,
                            "duration": 2428,
                            "duration_inMinutes": 40.47,
                            "created_at": "Feb-11-22",
                            "created_at_rawDateFormat": "2022-02-11T07:05:04.948Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 467172894,
                        "gitlabId": 467172894,
                        "status": "success",
                        "testReport": {
                            "id": 46673,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 99.56,
                            "test_suites": [
                                {
                                    "id": 53994,
                                    "total_time": 75.22,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3552759,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.27,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552749,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.3,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552743,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.44,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552739,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.45,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552713,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3552719,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 12.38,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552723,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.65,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552729,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.26,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552733,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.15,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552773,
                                            "classname": "click nothing",
                                            "execution_time": 0.53,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552769,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.91,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552763,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.61,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552753,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.27,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53988,
                                    "total_time": 24.34,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3552710,
                                            "classname": "click nothing",
                                            "execution_time": 7.44,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552714,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.7,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552720,
                                            "classname": "click allow selection",
                                            "execution_time": 5.6,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552724,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.61,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729234,
                            "isTestReportAvailable": true,
                            "duration": 2635,
                            "duration_inMinutes": 43.92,
                            "created_at": "Feb-09-22",
                            "created_at_rawDateFormat": "2022-02-09T07:05:04.788Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 467152571,
                        "gitlabId": 467152571,
                        "status": "success",
                        "testReport": {
                            "id": 46670,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 107.24,
                            "test_suites": [
                                {
                                    "id": 53991,
                                    "total_time": 75.77,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3558335,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.39,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558311,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 10.04,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558331,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.94,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558315,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 7.67,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558321,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.27,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558325,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.14,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558345,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.27,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558341,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.31,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558302,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3558305,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.74,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558361,
                                            "classname": "click nothing",
                                            "execution_time": 0.55,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558351,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.58,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558355,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.86,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 54001,
                                    "total_time": 31.47,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3558349,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 10.15,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558359,
                                            "classname": "click nothing",
                                            "execution_time": 9.61,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558368,
                                            "classname": "click allow selection",
                                            "execution_time": 6.17,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558378,
                                            "classname": "click allow necessary",
                                            "execution_time": 5.55,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729236,
                            "isTestReportAvailable": true,
                            "duration": 2546,
                            "duration_inMinutes": 42.43,
                            "created_at": "Feb-09-22",
                            "created_at_rawDateFormat": "2022-02-09T07:05:04.881Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 465215341,
                        "gitlabId": 465215341,
                        "status": "success",
                        "testReport": {
                            "id": 46672,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.08,
                            "test_suites": [
                                {
                                    "id": 53996,
                                    "total_time": 74.07,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553884,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.12,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553889,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.05,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553894,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.87,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553899,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.67,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553904,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.35,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553924,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.71,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553919,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 4.04,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553914,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.18,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553929,
                                            "classname": "click nothing",
                                            "execution_time": 0.55,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553909,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.22,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553869,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553874,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.44,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553879,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.87,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53990,
                                    "total_time": 24,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553849,
                                            "classname": "click nothing",
                                            "execution_time": 7.01,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553854,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.7,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553859,
                                            "classname": "click allow selection",
                                            "execution_time": 5.58,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553864,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.71,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729235,
                            "isTestReportAvailable": true,
                            "duration": 2474,
                            "duration_inMinutes": 41.23,
                            "created_at": "Feb-07-22",
                            "created_at_rawDateFormat": "2022-02-07T07:05:04.813Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 465158128,
                        "gitlabId": 465158128,
                        "status": "success",
                        "testReport": {
                            "id": 46675,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 99.23,
                            "test_suites": [
                                {
                                    "id": 53997,
                                    "total_time": 74.91,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553414,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 6.98,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553449,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.87,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553444,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.65,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553439,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.27,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553434,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.35,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553429,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.36,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553424,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 6.76,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553454,
                                            "classname": "click nothing",
                                            "execution_time": 0.52,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553394,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553399,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.4,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553404,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.7,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553409,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 8.22,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553419,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.84,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53992,
                                    "total_time": 24.31,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553408,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.65,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553403,
                                            "classname": "click allow selection",
                                            "execution_time": 5.58,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553398,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.82,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553393,
                                            "classname": "click nothing",
                                            "execution_time": 7.27,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729270,
                            "isTestReportAvailable": true,
                            "duration": 2316,
                            "duration_inMinutes": 38.6,
                            "created_at": "Feb-07-22",
                            "created_at_rawDateFormat": "2022-02-07T07:05:09.089Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 464955480,
                        "gitlabId": 464955480,
                        "status": "success",
                        "testReport": {
                            "id": 46678,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.48,
                            "test_suites": [
                                {
                                    "id": 53999,
                                    "total_time": 74.44,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554442,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.35,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554452,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.69,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554471,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 6.98,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554462,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.24,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554536,
                                            "classname": "click nothing",
                                            "execution_time": 0.55,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554531,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.74,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554526,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.62,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554521,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.22,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554511,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.25,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554501,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.27,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554491,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.54,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554481,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.98,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554432,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        }
                                    ]
                                },
                                {
                                    "id": 53995,
                                    "total_time": 24.05,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554426,
                                            "classname": "click nothing",
                                            "execution_time": 7.05,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554440,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.6,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554436,
                                            "classname": "click allow selection",
                                            "execution_time": 5.59,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554430,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.81,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729240,
                            "isTestReportAvailable": true,
                            "duration": 2636,
                            "duration_inMinutes": 43.93,
                            "created_at": "Feb-07-22",
                            "created_at_rawDateFormat": "2022-02-07T07:05:05.184Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 463409189,
                        "gitlabId": 463409189,
                        "status": "success",
                        "testReport": {
                            "id": 46676,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.65,
                            "test_suites": [
                                {
                                    "id": 54004,
                                    "total_time": 74.67,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3552730,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3552734,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.55,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552740,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 10.15,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552744,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.13,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552750,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.05,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552754,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.99,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552760,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 6.92,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552764,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.29,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552770,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.27,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552774,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.21,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552780,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.66,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552784,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.87,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552789,
                                            "classname": "click nothing",
                                            "execution_time": 0.58,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 53998,
                                    "total_time": 23.97,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3552726,
                                            "classname": "click nothing",
                                            "execution_time": 7.08,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552732,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.75,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552736,
                                            "classname": "click allow selection",
                                            "execution_time": 5.62,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552742,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.53,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729239,
                            "isTestReportAvailable": true,
                            "duration": 2428,
                            "duration_inMinutes": 40.47,
                            "created_at": "Feb-04-22",
                            "created_at_rawDateFormat": "2022-02-04T07:05:05.111Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 462752214,
                        "gitlabId": 462752214,
                        "status": "success",
                        "testReport": {
                            "id": 46677,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.06,
                            "test_suites": [
                                {
                                    "id": 54006,
                                    "total_time": 73.91,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553941,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.77,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553918,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.35,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553913,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.69,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553908,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.04,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553903,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.07,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553898,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.28,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553893,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.78,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553888,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.54,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553883,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553951,
                                            "classname": "click nothing",
                                            "execution_time": 0.47,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553923,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.29,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553928,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.22,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553933,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.42,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 54000,
                                    "total_time": 24.15,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553901,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.64,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553891,
                                            "classname": "click allow selection",
                                            "execution_time": 5.6,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553881,
                                            "classname": "click nothing",
                                            "execution_time": 6.89,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553871,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.02,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729238,
                            "isTestReportAvailable": true,
                            "duration": 2314,
                            "duration_inMinutes": 38.57,
                            "created_at": "Feb-03-22",
                            "created_at_rawDateFormat": "2022-02-03T07:05:05.087Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 462712054,
                        "gitlabId": 462712054,
                        "status": "success",
                        "testReport": {
                            "id": 46681,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 97.37,
                            "test_suites": [
                                {
                                    "id": 54013,
                                    "total_time": 72.95,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554758,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.22,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554770,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.79,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554774,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.78,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554780,
                                            "classname": "click nothing",
                                            "execution_time": 0.57,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554718,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3554723,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.77,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554728,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 9.7,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554733,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.19,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554738,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554743,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.79,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554748,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.56,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554753,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.37,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554764,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.2,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 54003,
                                    "total_time": 24.42,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554726,
                                            "classname": "click allow selection",
                                            "execution_time": 5.66,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554731,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.73,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554716,
                                            "classname": "click nothing",
                                            "execution_time": 7.18,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554721,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.86,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729242,
                            "isTestReportAvailable": true,
                            "duration": 2526,
                            "duration_inMinutes": 42.1,
                            "created_at": "Feb-03-22",
                            "created_at_rawDateFormat": "2022-02-03T07:05:05.213Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 462668739,
                        "gitlabId": 462668739,
                        "status": "success",
                        "testReport": {
                            "id": 46680,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 100.24,
                            "test_suites": [
                                {
                                    "id": 54002,
                                    "total_time": 24.77,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553413,
                                            "classname": "click nothing",
                                            "execution_time": 7.32,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553418,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.28,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553423,
                                            "classname": "click allow selection",
                                            "execution_time": 5.61,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553428,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.56,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 54007,
                                    "total_time": 75.48,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553476,
                                            "classname": "click allow only necessary",
                                            "execution_time": 3.22,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553472,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.59,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553466,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.29,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553462,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.36,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553457,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.48,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553452,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 6.76,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553447,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.13,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553442,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.32,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553437,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 8.28,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553432,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.74,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553427,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 9.87,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553422,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553482,
                                            "classname": "click nothing",
                                            "execution_time": 0.43,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729241,
                            "isTestReportAvailable": true,
                            "duration": 2832,
                            "duration_inMinutes": 47.2,
                            "created_at": "Feb-03-22",
                            "created_at_rawDateFormat": "2022-02-03T07:05:05.204Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 462543214,
                        "gitlabId": 462543214,
                        "status": "success",
                        "testReport": {
                            "id": 46679,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 97.18,
                            "test_suites": [
                                {
                                    "id": 54009,
                                    "total_time": 72.92,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554466,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.07,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554461,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.25,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554456,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.58,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554472,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 6.73,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554479,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.61,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554485,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.37,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554489,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.33,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554495,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.24,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554499,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.45,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554505,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.68,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554510,
                                            "classname": "click nothing",
                                            "execution_time": 0.56,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554451,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.04,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554446,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        }
                                    ]
                                },
                                {
                                    "id": 54005,
                                    "total_time": 24.26,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554453,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.58,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554447,
                                            "classname": "click allow selection",
                                            "execution_time": 5.55,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554443,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.92,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554437,
                                            "classname": "click nothing",
                                            "execution_time": 7.21,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729247,
                            "isTestReportAvailable": true,
                            "duration": 2493,
                            "duration_inMinutes": 41.55,
                            "created_at": "Feb-03-22",
                            "created_at_rawDateFormat": "2022-02-03T07:05:05.568Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 461886952,
                        "gitlabId": 461886952,
                        "status": "success",
                        "testReport": {
                            "id": 46682,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 100.59,
                            "test_suites": [
                                {
                                    "id": 54014,
                                    "total_time": 76.48,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3552746,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3552790,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.23,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552785,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.28,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552781,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.35,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552776,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.98,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552772,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.12,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552766,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.4,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552762,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 8.12,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552756,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.69,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552800,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.69,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552805,
                                            "classname": "click nothing",
                                            "execution_time": 0.51,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552795,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.76,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552752,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.35,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 54008,
                                    "total_time": 24.11,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3552768,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.59,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552758,
                                            "classname": "click allow selection",
                                            "execution_time": 5.68,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552748,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.9,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552738,
                                            "classname": "click nothing",
                                            "execution_time": 6.95,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729243,
                            "isTestReportAvailable": true,
                            "duration": 2445,
                            "duration_inMinutes": 40.75,
                            "created_at": "Feb-02-22",
                            "created_at_rawDateFormat": "2022-02-02T07:05:05.387Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 461643064,
                        "gitlabId": 461643064,
                        "status": "success",
                        "testReport": {
                            "id": 46683,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 101.39,
                            "test_suites": [
                                {
                                    "id": 54021,
                                    "total_time": 73.16,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3558390,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.83,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558424,
                                            "classname": "click nothing",
                                            "execution_time": 0.54,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558420,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.83,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558414,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.55,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558410,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.2,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558404,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.29,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558400,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.33,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558394,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.45,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558384,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.08,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558380,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.64,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558374,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.66,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558371,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 9.76,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558365,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        }
                                    ]
                                },
                                {
                                    "id": 54011,
                                    "total_time": 28.22,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3558375,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.82,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558372,
                                            "classname": "click allow selection",
                                            "execution_time": 5.64,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558366,
                                            "classname": "click nothing",
                                            "execution_time": 7.84,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3558362,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 9.92,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729244,
                            "isTestReportAvailable": true,
                            "duration": 2440,
                            "duration_inMinutes": 40.67,
                            "created_at": "Feb-02-22",
                            "created_at_rawDateFormat": "2022-02-02T07:05:05.477Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 461618236,
                        "gitlabId": 461618236,
                        "status": "success",
                        "testReport": {
                            "id": 46684,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 106.87,
                            "test_suites": [
                                {
                                    "id": 54016,
                                    "total_time": 77.26,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553965,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.71,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553905,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553910,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.2,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553915,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.99,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553920,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 8.12,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553925,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.64,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553930,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 7.03,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553938,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.85,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553943,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.41,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553948,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.38,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553956,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.27,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553969,
                                            "classname": "click allow only necessary",
                                            "execution_time": 3.04,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553975,
                                            "classname": "click nothing",
                                            "execution_time": 0.61,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 54010,
                                    "total_time": 29.61,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553892,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 10.11,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553897,
                                            "classname": "click nothing",
                                            "execution_time": 7.8,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553902,
                                            "classname": "click allow selection",
                                            "execution_time": 6.19,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553907,
                                            "classname": "click allow necessary",
                                            "execution_time": 5.5,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729246,
                            "isTestReportAvailable": true,
                            "duration": 2658,
                            "duration_inMinutes": 44.3,
                            "created_at": "Feb-02-22",
                            "created_at_rawDateFormat": "2022-02-02T07:05:05.503Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 461566156,
                        "gitlabId": 461566156,
                        "status": "success",
                        "testReport": {
                            "id": 46685,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.06,
                            "test_suites": [
                                {
                                    "id": 54017,
                                    "total_time": 73.91,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553498,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.68,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553485,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.34,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553479,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.58,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553494,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.2,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553489,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.22,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553475,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 6.99,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553469,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.05,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553465,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 8.01,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553456,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.75,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553446,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 9.92,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553436,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553508,
                                            "classname": "click nothing",
                                            "execution_time": 0.5,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553502,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.67,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 54012,
                                    "total_time": 24.16,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553443,
                                            "classname": "click allow selection",
                                            "execution_time": 5.59,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553438,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.6,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553433,
                                            "classname": "click nothing",
                                            "execution_time": 7.29,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553448,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.67,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729245,
                            "isTestReportAvailable": true,
                            "duration": 2452,
                            "duration_inMinutes": 40.87,
                            "created_at": "Feb-02-22",
                            "created_at_rawDateFormat": "2022-02-02T07:05:05.502Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 460655181,
                        "gitlabId": 460655181,
                        "status": "success",
                        "testReport": {
                            "id": 46686,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98.45,
                            "test_suites": [
                                {
                                    "id": 54019,
                                    "total_time": 74.09,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554532,
                                            "classname": "click nothing",
                                            "execution_time": 0.53,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554473,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.55,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554476,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.15,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554457,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://www.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3554463,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.53,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554467,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.79,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554482,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 6.94,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554486,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.39,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554492,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.37,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554496,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.25,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554502,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.21,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554512,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.68,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554522,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.7,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 54015,
                                    "total_time": 24.36,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554454,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.86,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554458,
                                            "classname": "click allow selection",
                                            "execution_time": 5.64,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554464,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.62,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554448,
                                            "classname": "click nothing",
                                            "execution_time": 7.24,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729248,
                            "isTestReportAvailable": true,
                            "duration": 2475,
                            "duration_inMinutes": 41.25,
                            "created_at": "Feb-01-22",
                            "created_at_rawDateFormat": "2022-02-01T07:05:05.680Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 460620952,
                        "gitlabId": 460620952,
                        "status": "success",
                        "testReport": {
                            "id": 46689,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 96.63,
                            "test_suites": [
                                {
                                    "id": 54018,
                                    "total_time": 23.92,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3552765,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.71,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552775,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.72,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552771,
                                            "classname": "click allow selection",
                                            "execution_time": 5.64,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552761,
                                            "classname": "click nothing",
                                            "execution_time": 6.85,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 54024,
                                    "total_time": 72.71,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3552851,
                                            "classname": "click nothing",
                                            "execution_time": 0.53,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552846,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.79,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552841,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.45,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552836,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.2,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552831,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.24,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552826,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.25,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552821,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 6.69,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552816,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.84,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552812,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.94,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552807,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.03,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552797,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.7,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552787,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.04,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3552778,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729254,
                            "isTestReportAvailable": true,
                            "duration": 2368,
                            "duration_inMinutes": 39.47,
                            "created_at": "Feb-01-22",
                            "created_at_rawDateFormat": "2022-02-01T07:05:06.797Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 459865063,
                        "gitlabId": 459865063,
                        "status": "success",
                        "testReport": {
                            "id": 46687,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 101.54,
                            "test_suites": [
                                {
                                    "id": 54020,
                                    "total_time": 24.42,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553911,
                                            "classname": "click nothing",
                                            "execution_time": 7.3,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553935,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.59,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553931,
                                            "classname": "click allow selection",
                                            "execution_time": 5.58,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553921,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.94,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 54026,
                                    "total_time": 77.12,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553950,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.45,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553955,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.3,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553962,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.26,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553967,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.77,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553971,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.84,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553977,
                                            "classname": "click nothing",
                                            "execution_time": 0.49,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553912,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553917,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.48,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553922,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.79,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553927,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 7.93,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553932,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.66,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553939,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 7.15,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553944,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729252,
                            "isTestReportAvailable": true,
                            "duration": 2305,
                            "duration_inMinutes": 38.42,
                            "created_at": "Jan-31-22",
                            "created_at_rawDateFormat": "2022-01-31T07:05:06.177Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 458605260,
                        "gitlabId": 458605260,
                        "status": "success",
                        "testReport": {
                            "id": 46690,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 98,
                            "test_suites": [
                                {
                                    "id": 54033,
                                    "total_time": 74.06,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554783,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.28,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554793,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.46,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554799,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.65,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554803,
                                            "classname": "click nothing",
                                            "execution_time": 0.53,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554744,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3554749,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.18,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554754,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 10.03,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554759,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.12,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554763,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.86,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554769,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.7,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554773,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 6.61,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554779,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.4,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554789,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.25,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 54023,
                                    "total_time": 23.94,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554736,
                                            "classname": "click nothing",
                                            "execution_time": 7.08,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554751,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.58,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554746,
                                            "classname": "click allow selection",
                                            "execution_time": 5.56,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554741,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.72,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729277,
                            "isTestReportAvailable": true,
                            "duration": 2331,
                            "duration_inMinutes": 38.85,
                            "created_at": "Jan-28-22",
                            "created_at_rawDateFormat": "2022-01-28T07:05:10.100Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 458460048,
                        "gitlabId": 458460048,
                        "status": "success",
                        "testReport": {
                            "id": 46688,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 97.43,
                            "test_suites": [
                                {
                                    "id": 54027,
                                    "total_time": 73.24,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3553492,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.28,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553525,
                                            "classname": "click nothing",
                                            "execution_time": 0.49,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553453,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3553458,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 11.22,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553463,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 9.65,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553467,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.04,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553473,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.85,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553477,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 6.48,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553483,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 6.44,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553486,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.29,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553496,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.21,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553506,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.55,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553516,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.75,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 54022,
                                    "total_time": 24.18,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3553450,
                                            "classname": "click nothing",
                                            "execution_time": 7.22,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553455,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 6.78,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553460,
                                            "classname": "click allow selection",
                                            "execution_time": 5.59,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3553464,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.59,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729249,
                            "isTestReportAvailable": true,
                            "duration": 2349,
                            "duration_inMinutes": 39.15,
                            "created_at": "Jan-28-22",
                            "created_at_rawDateFormat": "2022-01-28T07:05:05.854Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 458433684,
                        "gitlabId": 458433684,
                        "status": "success",
                        "testReport": {
                            "id": 46692,
                            "error_count": 0,
                            "failed_count": 1,
                            "skipped_count": 0,
                            "success_count": 16,
                            "total_count": 17,
                            "total_time": 100.98,
                            "test_suites": [
                                {
                                    "id": 54029,
                                    "total_time": 76.33,
                                    "total_count": 13,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "name": "e2e-tests-www.thecodecampus.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 12,
                                    "test_cases": [
                                        {
                                            "id": 3554515,
                                            "classname": "Weitere Fragen Formular - Angular",
                                            "execution_time": 7.12,
                                            "name": "formular-test Weitere Fragen Formular - Angular",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554509,
                                            "classname": "Route sollte geschützt sein (prod)",
                                            "execution_time": 7.72,
                                            "name": "admin-test Route sollte geschützt sein (prod)",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554538,
                                            "classname": "click allow selected cookies",
                                            "execution_time": 3.57,
                                            "name": "cookies click allow selected cookies",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554548,
                                            "classname": "click nothing",
                                            "execution_time": 0.74,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554544,
                                            "classname": "click allow only necessary",
                                            "execution_time": 2.8,
                                            "name": "cookies click allow only necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554487,
                                            "classname": "Route sollte ungeschützt sein (dev)",
                                            "execution_time": 0,
                                            "name": "admin-test Route sollte ungeschützt sein (dev)",
                                            "status": "failed",
                                            "system_output": "Error: done() invoked with non-Error: {\"message\":\"async skip; aborting execution\",\"stack\":\"[object Object]\\n\",\"sourceMappedStack\":\"[object Object]\\n\",\"parsedStack\":[{\"message\":\"[object Object]\",\"whitespace\":\"\"},{\"message\":\"\",\"whitespace\":\"\"}]} (and Mocha's done() called multiple times)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105134:13\n    at done (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171800:15)\n    at finish (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171311:16)\n    at fail (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171350:12)\n    at Context.runnable.fn (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:171874:18)\n    at callFnAsync (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105127:21)\n    at Test.../driver/node_modules/mocha/lib/runnable.js.Runnable.run (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:105067:7)\n    at https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:177607:28\n    at PassThroughHandlerContext.finallyHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:7319:23)\n    at PassThroughHandlerContext.tryCatcher (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:10765:23)\n    at Promise._settlePromiseFromHandler (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8700:31)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8757:18)\n    at Promise._settlePromise0 (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8802:10)\n    at Promise._settlePromises (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8882:18)\n    at Promise._fulfill (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8826:18)\n    at Promise._settlePromise (https://test.thecodecampus.de/__cypress/runner/cypress_runner.js:8770:21)"
                                        },
                                        {
                                            "id": 3554493,
                                            "classname": "unverbindlich Anfragen",
                                            "execution_time": 10.63,
                                            "name": "formular-test unverbindlich Anfragen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554497,
                                            "classname": "verbindlich Buchen",
                                            "execution_time": 10.31,
                                            "name": "formular-test verbindlich Buchen",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554534,
                                            "classname": "Weitere Fragen Formular - AngularJS 1.x",
                                            "execution_time": 6.23,
                                            "name": "formular-test Weitere Fragen Formular - AngularJS 1.x",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554528,
                                            "classname": "Weitere Fragen Formular - TypeScript",
                                            "execution_time": 6.25,
                                            "name": "formular-test Weitere Fragen Formular - TypeScript",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554524,
                                            "classname": "Weitere Fragen Formular - NestJS",
                                            "execution_time": 6.35,
                                            "name": "formular-test Weitere Fragen Formular - NestJS",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554519,
                                            "classname": "Weitere Fragen Formular - Angular-Advanced",
                                            "execution_time": 6.74,
                                            "name": "formular-test Weitere Fragen Formular - Angular-Advanced",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554503,
                                            "classname": "eine Inhouse Schulung",
                                            "execution_time": 7.86,
                                            "name": "formular-test eine Inhouse Schulung",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                },
                                {
                                    "id": 54025,
                                    "total_time": 24.65,
                                    "total_count": 4,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "name": "e2e-tests-www.w11k.de-staging",
                                    "skipped_count": 0,
                                    "success_count": 4,
                                    "test_cases": [
                                        {
                                            "id": 3554468,
                                            "classname": "NestJS landing-page",
                                            "execution_time": 7.24,
                                            "name": "landing-pages-test NestJS landing-page",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554477,
                                            "classname": "click allow selection",
                                            "execution_time": 5.67,
                                            "name": "cookies click allow selection",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554483,
                                            "classname": "click allow necessary",
                                            "execution_time": 4.64,
                                            "name": "cookies click allow necessary",
                                            "status": "success",
                                            "system_output": null
                                        },
                                        {
                                            "id": 3554474,
                                            "classname": "click nothing",
                                            "execution_time": 7.1,
                                            "name": "cookies click nothing",
                                            "status": "success",
                                            "system_output": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "stats": {
                            "id": 729250,
                            "isTestReportAvailable": true,
                            "duration": 2633,
                            "duration_inMinutes": 43.88,
                            "created_at": "Jan-28-22",
                            "created_at_rawDateFormat": "2022-01-28T07:05:05.959Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29694,
                    "gitlabId": 8197589,
                    "name": "W11k TCC Websites"
                }
            }
        ],
        "subGroups": [],
        "stats": {
            "id": 6715,
            "isThereSubgroups": false,
            "numberOfProjects": 1,
            "testCoverageOfAllProjects": null,
            "numberOfPipelines": 97,
            "numberOfTestReports": 71
        }
    },
    {
        "id": 8363318,
        "tempData": false,
        "gitlabId": 8363318,
        "name": "Open Source",
        "projects": [
            {
                "id": 14988969,
                "gitlabId": 14988969,
                "name": "ng-sticky-things",
                "urlToRepo": "https://gitlab.com/w11k-devs/open-source/ng-sticky-things.git",
                "stats": {
                    "id": 29695,
                    "status": "success",
                    "numberOfPipelines": 29,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 541,
                    "averageDurationOfPipelines_inMinutes": 9.02,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 14,
                    "numberOfFailedPipelines": 15,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 48.28,
                    "totalRepoSize": "12635340",
                    "artifactsSize": "48233447"
                },
                "pipelines": [
                    {
                        "id": 377954285,
                        "gitlabId": 377954285,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729354,
                            "isTestReportAvailable": false,
                            "duration": 234,
                            "duration_inMinutes": 3.9,
                            "created_at": "Sep-27-21",
                            "created_at_rawDateFormat": "2021-09-27T07:05:16.019Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 377907309,
                        "gitlabId": 377907309,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729355,
                            "isTestReportAvailable": false,
                            "duration": 405,
                            "duration_inMinutes": 6.75,
                            "created_at": "Sep-27-21",
                            "created_at_rawDateFormat": "2021-09-27T07:05:16.083Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 377894814,
                        "gitlabId": 377894814,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729353,
                            "isTestReportAvailable": false,
                            "duration": 621,
                            "duration_inMinutes": 10.35,
                            "created_at": "Sep-27-21",
                            "created_at_rawDateFormat": "2021-09-27T07:05:16.017Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 377888407,
                        "gitlabId": 377888407,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729366,
                            "isTestReportAvailable": false,
                            "duration": 87,
                            "duration_inMinutes": 1.45,
                            "created_at": "Sep-27-21",
                            "created_at_rawDateFormat": "2021-09-27T07:05:17.471Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 338278102,
                        "gitlabId": 338278102,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729356,
                            "isTestReportAvailable": false,
                            "duration": 280,
                            "duration_inMinutes": 4.67,
                            "created_at": "Jul-16-21",
                            "created_at_rawDateFormat": "2021-07-16T07:05:16.256Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 338276820,
                        "gitlabId": 338276820,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729376,
                            "isTestReportAvailable": false,
                            "duration": 275,
                            "duration_inMinutes": 4.58,
                            "created_at": "Jul-16-21",
                            "created_at_rawDateFormat": "2021-07-16T07:05:18.258Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 174009994,
                        "gitlabId": 174009994,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729357,
                            "isTestReportAvailable": false,
                            "duration": 1276,
                            "duration_inMinutes": 21.27,
                            "created_at": "Aug-04-20",
                            "created_at_rawDateFormat": "2020-08-04T07:05:16.287Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 174009769,
                        "gitlabId": 174009769,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729358,
                            "isTestReportAvailable": false,
                            "duration": 718,
                            "duration_inMinutes": 11.97,
                            "created_at": "Aug-04-20",
                            "created_at_rawDateFormat": "2020-08-04T07:05:16.340Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 172509300,
                        "gitlabId": 172509300,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729360,
                            "isTestReportAvailable": false,
                            "duration": 901,
                            "duration_inMinutes": 15.02,
                            "created_at": "Jul-30-20",
                            "created_at_rawDateFormat": "2020-07-30T07:05:16.701Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 172483416,
                        "gitlabId": 172483416,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729359,
                            "isTestReportAvailable": false,
                            "duration": 1219,
                            "duration_inMinutes": 20.32,
                            "created_at": "Jul-30-20",
                            "created_at_rawDateFormat": "2020-07-30T07:05:16.562Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 172482321,
                        "gitlabId": 172482321,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729375,
                            "isTestReportAvailable": false,
                            "duration": 1334,
                            "duration_inMinutes": 22.23,
                            "created_at": "Jul-30-20",
                            "created_at_rawDateFormat": "2020-07-30T07:05:18.244Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 127200663,
                        "gitlabId": 127200663,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729361,
                            "isTestReportAvailable": false,
                            "duration": 775,
                            "duration_inMinutes": 12.92,
                            "created_at": "Mar-17-20",
                            "created_at_rawDateFormat": "2020-03-17T07:05:16.821Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 102148577,
                        "gitlabId": 102148577,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729362,
                            "isTestReportAvailable": false,
                            "duration": 420,
                            "duration_inMinutes": 7,
                            "created_at": "Dec-10-19",
                            "created_at_rawDateFormat": "2019-12-10T07:05:17.072Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 95145155,
                        "gitlabId": 95145155,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729363,
                            "isTestReportAvailable": false,
                            "duration": 157,
                            "duration_inMinutes": 2.62,
                            "created_at": "Nov-11-19",
                            "created_at_rawDateFormat": "2019-11-11T07:05:17.086Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 93591431,
                        "gitlabId": 93591431,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729364,
                            "isTestReportAvailable": false,
                            "duration": 353,
                            "duration_inMinutes": 5.88,
                            "created_at": "Nov-04-19",
                            "created_at_rawDateFormat": "2019-11-04T07:05:17.345Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 92561657,
                        "gitlabId": 92561657,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729365,
                            "isTestReportAvailable": false,
                            "duration": 768,
                            "duration_inMinutes": 12.8,
                            "created_at": "Oct-30-19",
                            "created_at_rawDateFormat": "2019-10-30T07:05:17.440Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 92551843,
                        "gitlabId": 92551843,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729367,
                            "isTestReportAvailable": false,
                            "duration": 202,
                            "duration_inMinutes": 3.37,
                            "created_at": "Oct-30-19",
                            "created_at_rawDateFormat": "2019-10-30T07:05:17.642Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 91396866,
                        "gitlabId": 91396866,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729368,
                            "isTestReportAvailable": false,
                            "duration": 627,
                            "duration_inMinutes": 10.45,
                            "created_at": "Oct-24-19",
                            "created_at_rawDateFormat": "2019-10-24T07:05:17.727Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 91306314,
                        "gitlabId": 91306314,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729369,
                            "isTestReportAvailable": false,
                            "duration": 558,
                            "duration_inMinutes": 9.3,
                            "created_at": "Oct-24-19",
                            "created_at_rawDateFormat": "2019-10-24T07:05:17.732Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 91301816,
                        "gitlabId": 91301816,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729370,
                            "isTestReportAvailable": false,
                            "duration": 345,
                            "duration_inMinutes": 5.75,
                            "created_at": "Oct-24-19",
                            "created_at_rawDateFormat": "2019-10-24T07:05:17.967Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 91287416,
                        "gitlabId": 91287416,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729371,
                            "isTestReportAvailable": false,
                            "duration": 1017,
                            "duration_inMinutes": 16.95,
                            "created_at": "Oct-24-19",
                            "created_at_rawDateFormat": "2019-10-24T07:05:17.978Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 91273034,
                        "gitlabId": 91273034,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729372,
                            "isTestReportAvailable": false,
                            "duration": 1021,
                            "duration_inMinutes": 17.02,
                            "created_at": "Oct-24-19",
                            "created_at_rawDateFormat": "2019-10-24T07:05:18.043Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 91261618,
                        "gitlabId": 91261618,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729374,
                            "isTestReportAvailable": false,
                            "duration": 581,
                            "duration_inMinutes": 9.68,
                            "created_at": "Oct-24-19",
                            "created_at_rawDateFormat": "2019-10-24T07:05:18.236Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 91256537,
                        "gitlabId": 91256537,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729377,
                            "isTestReportAvailable": false,
                            "duration": 385,
                            "duration_inMinutes": 6.42,
                            "created_at": "Oct-24-19",
                            "created_at_rawDateFormat": "2019-10-24T07:05:18.269Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 91245817,
                        "gitlabId": 91245817,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729378,
                            "isTestReportAvailable": false,
                            "duration": 659,
                            "duration_inMinutes": 10.98,
                            "created_at": "Oct-24-19",
                            "created_at_rawDateFormat": "2019-10-24T07:05:18.348Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 91239861,
                        "gitlabId": 91239861,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729379,
                            "isTestReportAvailable": false,
                            "duration": 215,
                            "duration_inMinutes": 3.58,
                            "created_at": "Oct-24-19",
                            "created_at_rawDateFormat": "2019-10-24T07:05:18.387Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 91223578,
                        "gitlabId": 91223578,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729380,
                            "isTestReportAvailable": false,
                            "duration": 262,
                            "duration_inMinutes": 4.37,
                            "created_at": "Oct-24-19",
                            "created_at_rawDateFormat": "2019-10-24T07:05:18.500Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 91220429,
                        "gitlabId": 91220429,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729405,
                            "isTestReportAvailable": false,
                            "duration": 4,
                            "duration_inMinutes": 0.07,
                            "created_at": "Oct-24-19",
                            "created_at_rawDateFormat": "2019-10-24T07:05:20.409Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 91217243,
                        "gitlabId": 91217243,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729381,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Oct-24-19",
                            "created_at_rawDateFormat": "2019-10-24T07:05:18.565Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29699,
                    "gitlabId": 8363318,
                    "name": "Open Source"
                }
            },
            {
                "id": 8381768,
                "gitlabId": 8381768,
                "name": "ngx-select",
                "urlToRepo": "https://gitlab.com/w11k-devs/open-source/ngx-select.git",
                "stats": {
                    "id": 29698,
                    "status": "success",
                    "numberOfPipelines": 49,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 150,
                    "averageDurationOfPipelines_inMinutes": 2.5,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 39,
                    "numberOfFailedPipelines": 7,
                    "numberOfCanceledPipelines": 3,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 79.59,
                    "totalRepoSize": "2390753",
                    "artifactsSize": "414074"
                },
                "pipelines": [
                    {
                        "id": 123106263,
                        "gitlabId": 123106263,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729382,
                            "isTestReportAvailable": false,
                            "duration": 163,
                            "duration_inMinutes": 2.72,
                            "created_at": "Mar-04-20",
                            "created_at_rawDateFormat": "2020-03-04T07:05:18.568Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 123105057,
                        "gitlabId": 123105057,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729383,
                            "isTestReportAvailable": false,
                            "duration": 120,
                            "duration_inMinutes": 2,
                            "created_at": "Mar-04-20",
                            "created_at_rawDateFormat": "2020-03-04T07:05:18.638Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 123100482,
                        "gitlabId": 123100482,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729403,
                            "isTestReportAvailable": false,
                            "duration": 122,
                            "duration_inMinutes": 2.03,
                            "created_at": "Mar-04-20",
                            "created_at_rawDateFormat": "2020-03-04T07:05:20.305Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 105755665,
                        "gitlabId": 105755665,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729384,
                            "isTestReportAvailable": false,
                            "duration": 113,
                            "duration_inMinutes": 1.88,
                            "created_at": "Dec-27-19",
                            "created_at_rawDateFormat": "2019-12-27T07:05:18.770Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 93231580,
                        "gitlabId": 93231580,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729386,
                            "isTestReportAvailable": false,
                            "duration": 116,
                            "duration_inMinutes": 1.93,
                            "created_at": "Nov-02-19",
                            "created_at_rawDateFormat": "2019-11-02T07:05:18.829Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78838617,
                        "gitlabId": 78838617,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729385,
                            "isTestReportAvailable": false,
                            "duration": 128,
                            "duration_inMinutes": 2.13,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:05:18.817Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 78838612,
                        "gitlabId": 78838612,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729387,
                            "isTestReportAvailable": false,
                            "duration": 260,
                            "duration_inMinutes": 4.33,
                            "created_at": "Aug-28-19",
                            "created_at_rawDateFormat": "2019-08-28T07:05:18.929Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77805455,
                        "gitlabId": 77805455,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729388,
                            "isTestReportAvailable": false,
                            "duration": 126,
                            "duration_inMinutes": 2.1,
                            "created_at": "Aug-22-19",
                            "created_at_rawDateFormat": "2019-08-22T07:05:19.037Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77805444,
                        "gitlabId": 77805444,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729389,
                            "isTestReportAvailable": false,
                            "duration": 179,
                            "duration_inMinutes": 2.98,
                            "created_at": "Aug-22-19",
                            "created_at_rawDateFormat": "2019-08-22T07:05:19.085Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77797777,
                        "gitlabId": 77797777,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729392,
                            "isTestReportAvailable": false,
                            "duration": 132,
                            "duration_inMinutes": 2.2,
                            "created_at": "Aug-22-19",
                            "created_at_rawDateFormat": "2019-08-22T07:05:19.374Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77535849,
                        "gitlabId": 77535849,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729390,
                            "isTestReportAvailable": false,
                            "duration": 130,
                            "duration_inMinutes": 2.17,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:05:19.236Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77535838,
                        "gitlabId": 77535838,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729391,
                            "isTestReportAvailable": false,
                            "duration": 220,
                            "duration_inMinutes": 3.67,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:05:19.314Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77535193,
                        "gitlabId": 77535193,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 729394,
                            "isTestReportAvailable": false,
                            "duration": 34,
                            "duration_inMinutes": 0.57,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:05:19.592Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 77534654,
                        "gitlabId": 77534654,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729393,
                            "isTestReportAvailable": false,
                            "duration": 155,
                            "duration_inMinutes": 2.58,
                            "created_at": "Aug-21-19",
                            "created_at_rawDateFormat": "2019-08-21T07:05:19.554Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 74779247,
                        "gitlabId": 74779247,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729395,
                            "isTestReportAvailable": false,
                            "duration": 254,
                            "duration_inMinutes": 4.23,
                            "created_at": "Aug-05-19",
                            "created_at_rawDateFormat": "2019-08-05T07:05:19.597Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 74779232,
                        "gitlabId": 74779232,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729396,
                            "isTestReportAvailable": false,
                            "duration": 177,
                            "duration_inMinutes": 2.95,
                            "created_at": "Aug-05-19",
                            "created_at_rawDateFormat": "2019-08-05T07:05:19.709Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 74184800,
                        "gitlabId": 74184800,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729397,
                            "isTestReportAvailable": false,
                            "duration": 176,
                            "duration_inMinutes": 2.93,
                            "created_at": "Aug-01-19",
                            "created_at_rawDateFormat": "2019-08-01T07:05:19.820Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 74181178,
                        "gitlabId": 74181178,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729399,
                            "isTestReportAvailable": false,
                            "duration": 167,
                            "duration_inMinutes": 2.78,
                            "created_at": "Aug-01-19",
                            "created_at_rawDateFormat": "2019-08-01T07:05:19.890Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 65024223,
                        "gitlabId": 65024223,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729398,
                            "isTestReportAvailable": false,
                            "duration": 170,
                            "duration_inMinutes": 2.83,
                            "created_at": "Jun-06-19",
                            "created_at_rawDateFormat": "2019-06-06T07:05:19.877Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 65011067,
                        "gitlabId": 65011067,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729400,
                            "isTestReportAvailable": false,
                            "duration": 125,
                            "duration_inMinutes": 2.08,
                            "created_at": "Jun-06-19",
                            "created_at_rawDateFormat": "2019-06-06T07:05:20.122Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 65005126,
                        "gitlabId": 65005126,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729402,
                            "isTestReportAvailable": false,
                            "duration": 89,
                            "duration_inMinutes": 1.48,
                            "created_at": "Jun-06-19",
                            "created_at_rawDateFormat": "2019-06-06T07:05:20.251Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 65004353,
                        "gitlabId": 65004353,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729401,
                            "isTestReportAvailable": false,
                            "duration": 101,
                            "duration_inMinutes": 1.68,
                            "created_at": "Jun-06-19",
                            "created_at_rawDateFormat": "2019-06-06T07:05:20.170Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 34157251,
                        "gitlabId": 34157251,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 729407,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Oct-24-18",
                            "created_at_rawDateFormat": "2018-10-24T07:05:20.617Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 34157248,
                        "gitlabId": 34157248,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729404,
                            "isTestReportAvailable": false,
                            "duration": 215,
                            "duration_inMinutes": 3.58,
                            "created_at": "Oct-24-18",
                            "created_at_rawDateFormat": "2018-10-24T07:05:20.387Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32416535,
                        "gitlabId": 32416535,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729409,
                            "isTestReportAvailable": false,
                            "duration": 110,
                            "duration_inMinutes": 1.83,
                            "created_at": "Oct-09-18",
                            "created_at_rawDateFormat": "2018-10-09T07:05:20.692Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32416531,
                        "gitlabId": 32416531,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729406,
                            "isTestReportAvailable": false,
                            "duration": 151,
                            "duration_inMinutes": 2.52,
                            "created_at": "Oct-09-18",
                            "created_at_rawDateFormat": "2018-10-09T07:05:20.576Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32402202,
                        "gitlabId": 32402202,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729410,
                            "isTestReportAvailable": false,
                            "duration": 119,
                            "duration_inMinutes": 1.98,
                            "created_at": "Oct-09-18",
                            "created_at_rawDateFormat": "2018-10-09T07:05:20.816Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32402194,
                        "gitlabId": 32402194,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729408,
                            "isTestReportAvailable": false,
                            "duration": 131,
                            "duration_inMinutes": 2.18,
                            "created_at": "Oct-09-18",
                            "created_at_rawDateFormat": "2018-10-09T07:05:20.646Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32377160,
                        "gitlabId": 32377160,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729413,
                            "isTestReportAvailable": false,
                            "duration": 110,
                            "duration_inMinutes": 1.83,
                            "created_at": "Oct-09-18",
                            "created_at_rawDateFormat": "2018-10-09T07:05:20.964Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32377155,
                        "gitlabId": 32377155,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729411,
                            "isTestReportAvailable": false,
                            "duration": 133,
                            "duration_inMinutes": 2.22,
                            "created_at": "Oct-09-18",
                            "created_at_rawDateFormat": "2018-10-09T07:05:20.869Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32370801,
                        "gitlabId": 32370801,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729415,
                            "isTestReportAvailable": false,
                            "duration": 134,
                            "duration_inMinutes": 2.23,
                            "created_at": "Oct-09-18",
                            "created_at_rawDateFormat": "2018-10-09T07:05:20.981Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32315220,
                        "gitlabId": 32315220,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729412,
                            "isTestReportAvailable": false,
                            "duration": 112,
                            "duration_inMinutes": 1.87,
                            "created_at": "Oct-08-18",
                            "created_at_rawDateFormat": "2018-10-08T07:05:20.932Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32110583,
                        "gitlabId": 32110583,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729414,
                            "isTestReportAvailable": false,
                            "duration": 111,
                            "duration_inMinutes": 1.85,
                            "created_at": "Oct-05-18",
                            "created_at_rawDateFormat": "2018-10-05T07:05:20.964Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32110580,
                        "gitlabId": 32110580,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729418,
                            "isTestReportAvailable": false,
                            "duration": 339,
                            "duration_inMinutes": 5.65,
                            "created_at": "Oct-05-18",
                            "created_at_rawDateFormat": "2018-10-05T07:05:21.229Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32107908,
                        "gitlabId": 32107908,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729416,
                            "isTestReportAvailable": false,
                            "duration": 173,
                            "duration_inMinutes": 2.88,
                            "created_at": "Oct-05-18",
                            "created_at_rawDateFormat": "2018-10-05T07:05:21.145Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32107906,
                        "gitlabId": 32107906,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729424,
                            "isTestReportAvailable": false,
                            "duration": 250,
                            "duration_inMinutes": 4.17,
                            "created_at": "Oct-05-18",
                            "created_at_rawDateFormat": "2018-10-05T07:05:21.546Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32107905,
                        "gitlabId": 32107905,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 729419,
                            "isTestReportAvailable": false,
                            "duration": 28,
                            "duration_inMinutes": 0.47,
                            "created_at": "Oct-05-18",
                            "created_at_rawDateFormat": "2018-10-05T07:05:21.238Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32105933,
                        "gitlabId": 32105933,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729420,
                            "isTestReportAvailable": false,
                            "duration": 127,
                            "duration_inMinutes": 2.12,
                            "created_at": "Oct-05-18",
                            "created_at_rawDateFormat": "2018-10-05T07:05:21.284Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32087756,
                        "gitlabId": 32087756,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729417,
                            "isTestReportAvailable": false,
                            "duration": 202,
                            "duration_inMinutes": 3.37,
                            "created_at": "Oct-05-18",
                            "created_at_rawDateFormat": "2018-10-05T07:05:21.226Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32073866,
                        "gitlabId": 32073866,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729421,
                            "isTestReportAvailable": false,
                            "duration": 157,
                            "duration_inMinutes": 2.62,
                            "created_at": "Oct-05-18",
                            "created_at_rawDateFormat": "2018-10-05T07:05:21.421Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32030739,
                        "gitlabId": 32030739,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729425,
                            "isTestReportAvailable": false,
                            "duration": 175,
                            "duration_inMinutes": 2.92,
                            "created_at": "Oct-04-18",
                            "created_at_rawDateFormat": "2018-10-04T07:05:21.619Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32030275,
                        "gitlabId": 32030275,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729422,
                            "isTestReportAvailable": false,
                            "duration": 118,
                            "duration_inMinutes": 1.97,
                            "created_at": "Oct-04-18",
                            "created_at_rawDateFormat": "2018-10-04T07:05:21.497Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 32030272,
                        "gitlabId": 32030272,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729427,
                            "isTestReportAvailable": false,
                            "duration": 227,
                            "duration_inMinutes": 3.78,
                            "created_at": "Oct-04-18",
                            "created_at_rawDateFormat": "2018-10-04T07:05:21.711Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 30210424,
                        "gitlabId": 30210424,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729423,
                            "isTestReportAvailable": false,
                            "duration": 122,
                            "duration_inMinutes": 2.03,
                            "created_at": "Sep-14-18",
                            "created_at_rawDateFormat": "2018-09-14T07:05:21.536Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 30210423,
                        "gitlabId": 30210423,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729426,
                            "isTestReportAvailable": false,
                            "duration": 255,
                            "duration_inMinutes": 4.25,
                            "created_at": "Sep-14-18",
                            "created_at_rawDateFormat": "2018-09-14T07:05:21.676Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 30207012,
                        "gitlabId": 30207012,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729428,
                            "isTestReportAvailable": false,
                            "duration": 93,
                            "duration_inMinutes": 1.55,
                            "created_at": "Sep-14-18",
                            "created_at_rawDateFormat": "2018-09-14T07:05:21.755Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 30207009,
                        "gitlabId": 30207009,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729432,
                            "isTestReportAvailable": false,
                            "duration": 89,
                            "duration_inMinutes": 1.48,
                            "created_at": "Sep-14-18",
                            "created_at_rawDateFormat": "2018-09-14T07:05:21.986Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 30205167,
                        "gitlabId": 30205167,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729429,
                            "isTestReportAvailable": false,
                            "duration": 194,
                            "duration_inMinutes": 3.23,
                            "created_at": "Sep-14-18",
                            "created_at_rawDateFormat": "2018-09-14T07:05:21.811Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 30204002,
                        "gitlabId": 30204002,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729430,
                            "isTestReportAvailable": false,
                            "duration": 194,
                            "duration_inMinutes": 3.23,
                            "created_at": "Sep-14-18",
                            "created_at_rawDateFormat": "2018-09-14T07:05:21.883Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29701,
                    "gitlabId": 8363318,
                    "name": "Open Source"
                }
            },
            {
                "id": 15655595,
                "gitlabId": 15655595,
                "name": "Foss Transformer",
                "urlToRepo": "https://gitlab.com/w11k-devs/open-source/foss-transformer.git",
                "stats": {
                    "id": 29712,
                    "status": "success",
                    "numberOfPipelines": 9,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 61,
                    "averageDurationOfPipelines_inMinutes": 1.02,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 7,
                    "numberOfFailedPipelines": 2,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 77.78,
                    "totalRepoSize": "807403",
                    "artifactsSize": "27851"
                },
                "pipelines": [
                    {
                        "id": 100566783,
                        "gitlabId": 100566783,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729069,
                            "isTestReportAvailable": false,
                            "duration": 26,
                            "duration_inMinutes": 0.43,
                            "created_at": "Dec-04-19",
                            "created_at_rawDateFormat": "2019-12-04T07:04:54.906Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 100566775,
                        "gitlabId": 100566775,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729067,
                            "isTestReportAvailable": false,
                            "duration": 95,
                            "duration_inMinutes": 1.58,
                            "created_at": "Dec-04-19",
                            "created_at_rawDateFormat": "2019-12-04T07:04:54.903Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 100258590,
                        "gitlabId": 100258590,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729071,
                            "isTestReportAvailable": false,
                            "duration": 19,
                            "duration_inMinutes": 0.32,
                            "created_at": "Dec-03-19",
                            "created_at_rawDateFormat": "2019-12-03T07:04:55.001Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 100258584,
                        "gitlabId": 100258584,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729073,
                            "isTestReportAvailable": false,
                            "duration": 96,
                            "duration_inMinutes": 1.6,
                            "created_at": "Dec-03-19",
                            "created_at_rawDateFormat": "2019-12-03T07:04:55.199Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 100257868,
                        "gitlabId": 100257868,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729072,
                            "isTestReportAvailable": false,
                            "duration": 58,
                            "duration_inMinutes": 0.97,
                            "created_at": "Dec-03-19",
                            "created_at_rawDateFormat": "2019-12-03T07:04:55.180Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 100253382,
                        "gitlabId": 100253382,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729074,
                            "isTestReportAvailable": false,
                            "duration": 2,
                            "duration_inMinutes": 0.03,
                            "created_at": "Dec-03-19",
                            "created_at_rawDateFormat": "2019-12-03T07:04:55.361Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 100244709,
                        "gitlabId": 100244709,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729075,
                            "isTestReportAvailable": false,
                            "duration": 57,
                            "duration_inMinutes": 0.95,
                            "created_at": "Dec-03-19",
                            "created_at_rawDateFormat": "2019-12-03T07:04:55.366Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 100244697,
                        "gitlabId": 100244697,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729085,
                            "isTestReportAvailable": false,
                            "duration": 90,
                            "duration_inMinutes": 1.5,
                            "created_at": "Dec-03-19",
                            "created_at_rawDateFormat": "2019-12-03T07:04:55.988Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 100242659,
                        "gitlabId": 100242659,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 729077,
                            "isTestReportAvailable": false,
                            "duration": 105,
                            "duration_inMinutes": 1.75,
                            "created_at": "Dec-03-19",
                            "created_at_rawDateFormat": "2019-12-03T07:04:55.497Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29702,
                    "gitlabId": 8363318,
                    "name": "Open Source"
                }
            }
        ],
        "subGroups": [],
        "stats": {
            "id": 6718,
            "isThereSubgroups": false,
            "numberOfProjects": 3,
            "testCoverageOfAllProjects": null,
            "numberOfPipelines": 87,
            "numberOfTestReports": 0
        }
    },
    {
        "id": 8197599,
        "tempData": false,
        "gitlabId": 8197599,
        "name": "Playground",
        "projects": [
            {
                "id": 7677090,
                "gitlabId": 7677090,
                "name": "tcc-test",
                "urlToRepo": "https://gitlab.com/w11k-devs/sandbox/tcc-test.git",
                "stats": {
                    "id": 29697,
                    "status": "failed",
                    "numberOfPipelines": 7,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 163,
                    "averageDurationOfPipelines_inMinutes": 2.72,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 7,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 0,
                    "totalRepoSize": "192392724",
                    "artifactsSize": "339334"
                },
                "pipelines": [
                    {
                        "id": 26725493,
                        "gitlabId": 26725493,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729548,
                            "isTestReportAvailable": false,
                            "duration": 786,
                            "duration_inMinutes": 13.1,
                            "created_at": "Jul-29-18",
                            "created_at_rawDateFormat": "2018-07-29T07:05:30.420Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 26725382,
                        "gitlabId": 26725382,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729549,
                            "isTestReportAvailable": false,
                            "duration": 96,
                            "duration_inMinutes": 1.6,
                            "created_at": "Jul-29-18",
                            "created_at_rawDateFormat": "2018-07-29T07:05:30.438Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 26724678,
                        "gitlabId": 26724678,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729550,
                            "isTestReportAvailable": false,
                            "duration": 114,
                            "duration_inMinutes": 1.9,
                            "created_at": "Jul-29-18",
                            "created_at_rawDateFormat": "2018-07-29T07:05:30.473Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 26724486,
                        "gitlabId": 26724486,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729576,
                            "isTestReportAvailable": false,
                            "duration": 69,
                            "duration_inMinutes": 1.15,
                            "created_at": "Jul-29-18",
                            "created_at_rawDateFormat": "2018-07-29T07:05:33.115Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 26724446,
                        "gitlabId": 26724446,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729552,
                            "isTestReportAvailable": false,
                            "duration": 73,
                            "duration_inMinutes": 1.22,
                            "created_at": "Jul-29-18",
                            "created_at_rawDateFormat": "2018-07-29T07:05:30.671Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 26724392,
                        "gitlabId": 26724392,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729555,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jul-29-18",
                            "created_at_rawDateFormat": "2018-07-29T07:05:30.859Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 26724371,
                        "gitlabId": 26724371,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 729553,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jul-29-18",
                            "created_at_rawDateFormat": "2018-07-29T07:05:30.731Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29704,
                    "gitlabId": 8197599,
                    "name": "Playground"
                }
            },
            {
                "id": 16742501,
                "gitlabId": 16742501,
                "name": "Web Components",
                "urlToRepo": "https://gitlab.com/w11k-devs/sandbox/web-components.git",
                "stats": {
                    "id": 29792,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "2883584",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29790,
                    "gitlabId": 8197599,
                    "name": "Playground"
                }
            },
            {
                "id": 14216321,
                "gitlabId": 14216321,
                "name": "oidc-playground",
                "urlToRepo": "https://gitlab.com/w11k-devs/sandbox/oidc-playground.git",
                "stats": {
                    "id": 29775,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "943718",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29786,
                    "gitlabId": 8197599,
                    "name": "Playground"
                }
            },
            {
                "id": 19718365,
                "gitlabId": 19718365,
                "name": "Firebase Performance",
                "urlToRepo": "https://gitlab.com/w11k-devs/sandbox/firebase-performance.git",
                "stats": {
                    "id": 29755,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "1321205",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29770,
                    "gitlabId": 8197599,
                    "name": "Playground"
                }
            }
        ],
        "subGroups": [],
        "stats": {
            "id": 6723,
            "isThereSubgroups": false,
            "numberOfProjects": 4,
            "testCoverageOfAllProjects": null,
            "numberOfPipelines": 7,
            "numberOfTestReports": 0
        }
    },
    {
        "id": 8197602,
        "tempData": false,
        "gitlabId": 8197602,
        "name": "Techday",
        "projects": [
            {
                "id": 18974481,
                "gitlabId": 18974481,
                "name": "gitlab_child_pipeline_test",
                "urlToRepo": "https://gitlab.com/w11k-devs/techday/gitlab_child_pipeline_test.git",
                "stats": {
                    "id": 29706,
                    "status": "success",
                    "numberOfPipelines": 33,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 56,
                    "averageDurationOfPipelines_inMinutes": 0.93,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 10,
                    "numberOfFailedPipelines": 17,
                    "numberOfCanceledPipelines": 5,
                    "numberOfRunningPipelines": 1,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 30.3,
                    "totalRepoSize": "283115",
                    "artifactsSize": "256903"
                },
                "pipelines": [
                    {
                        "id": 154307676,
                        "gitlabId": 154307676,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730172,
                            "isTestReportAvailable": false,
                            "duration": 105,
                            "duration_inMinutes": 1.75,
                            "created_at": "Jun-09-20",
                            "created_at_rawDateFormat": "2020-06-09T07:06:11.188Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 154306874,
                        "gitlabId": 154306874,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 730178,
                            "isTestReportAvailable": false,
                            "duration": 127,
                            "duration_inMinutes": 2.12,
                            "created_at": "Jun-09-20",
                            "created_at_rawDateFormat": "2020-06-09T07:06:11.546Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 154304857,
                        "gitlabId": 154304857,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730174,
                            "isTestReportAvailable": false,
                            "duration": 168,
                            "duration_inMinutes": 2.8,
                            "created_at": "Jun-09-20",
                            "created_at_rawDateFormat": "2020-06-09T07:06:11.247Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 154267337,
                        "gitlabId": 154267337,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 730179,
                            "isTestReportAvailable": false,
                            "duration": 6,
                            "duration_inMinutes": 0.1,
                            "created_at": "Jun-09-20",
                            "created_at_rawDateFormat": "2020-06-09T07:06:11.549Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 154266895,
                        "gitlabId": 154266895,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730177,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-09-20",
                            "created_at_rawDateFormat": "2020-06-09T07:06:11.484Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 153969058,
                        "gitlabId": 153969058,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 730185,
                            "isTestReportAvailable": false,
                            "duration": 15,
                            "duration_inMinutes": 0.25,
                            "created_at": "Jun-08-20",
                            "created_at_rawDateFormat": "2020-06-08T07:06:11.927Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 153968691,
                        "gitlabId": 153968691,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730182,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-08-20",
                            "created_at_rawDateFormat": "2020-06-08T07:06:11.775Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 153967937,
                        "gitlabId": 153967937,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730180,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-08-20",
                            "created_at_rawDateFormat": "2020-06-08T07:06:11.625Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 153967638,
                        "gitlabId": 153967638,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730181,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-08-20",
                            "created_at_rawDateFormat": "2020-06-08T07:06:11.753Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 153943998,
                        "gitlabId": 153943998,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730184,
                            "isTestReportAvailable": false,
                            "duration": 157,
                            "duration_inMinutes": 2.62,
                            "created_at": "Jun-08-20",
                            "created_at_rawDateFormat": "2020-06-08T07:06:11.863Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 153943664,
                        "gitlabId": 153943664,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730183,
                            "isTestReportAvailable": false,
                            "duration": 168,
                            "duration_inMinutes": 2.8,
                            "created_at": "Jun-08-20",
                            "created_at_rawDateFormat": "2020-06-08T07:06:11.813Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 153942550,
                        "gitlabId": 153942550,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730187,
                            "isTestReportAvailable": false,
                            "duration": 153,
                            "duration_inMinutes": 2.55,
                            "created_at": "Jun-08-20",
                            "created_at_rawDateFormat": "2020-06-08T07:06:12.095Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 153907072,
                        "gitlabId": 153907072,
                        "status": "running",
                        "testReport": null,
                        "stats": {
                            "id": 730186,
                            "isTestReportAvailable": false,
                            "duration": 3,
                            "duration_inMinutes": 0.05,
                            "created_at": "Jun-08-20",
                            "created_at_rawDateFormat": "2020-06-08T07:06:12.022Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 153899853,
                        "gitlabId": 153899853,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730190,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-08-20",
                            "created_at_rawDateFormat": "2020-06-08T07:06:12.301Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 153899024,
                        "gitlabId": 153899024,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730189,
                            "isTestReportAvailable": false,
                            "duration": 159,
                            "duration_inMinutes": 2.65,
                            "created_at": "Jun-08-20",
                            "created_at_rawDateFormat": "2020-06-08T07:06:12.200Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 153890261,
                        "gitlabId": 153890261,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730188,
                            "isTestReportAvailable": false,
                            "duration": 171,
                            "duration_inMinutes": 2.85,
                            "created_at": "Jun-08-20",
                            "created_at_rawDateFormat": "2020-06-08T07:06:12.127Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 153890209,
                        "gitlabId": 153890209,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730191,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-08-20",
                            "created_at_rawDateFormat": "2020-06-08T07:06:12.376Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 153889959,
                        "gitlabId": 153889959,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730195,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-08-20",
                            "created_at_rawDateFormat": "2020-06-08T07:06:12.507Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 153889257,
                        "gitlabId": 153889257,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730192,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Jun-08-20",
                            "created_at_rawDateFormat": "2020-06-08T07:06:12.383Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 149231844,
                        "gitlabId": 149231844,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730193,
                            "isTestReportAvailable": false,
                            "duration": 107,
                            "duration_inMinutes": 1.78,
                            "created_at": "May-25-20",
                            "created_at_rawDateFormat": "2020-05-25T07:06:12.393Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 149229767,
                        "gitlabId": 149229767,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730194,
                            "isTestReportAvailable": false,
                            "duration": 55,
                            "duration_inMinutes": 0.92,
                            "created_at": "May-25-20",
                            "created_at_rawDateFormat": "2020-05-25T07:06:12.450Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 149229416,
                        "gitlabId": 149229416,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730196,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "May-25-20",
                            "created_at_rawDateFormat": "2020-05-25T07:06:12.548Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 149229012,
                        "gitlabId": 149229012,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730198,
                            "isTestReportAvailable": false,
                            "duration": 52,
                            "duration_inMinutes": 0.87,
                            "created_at": "May-25-20",
                            "created_at_rawDateFormat": "2020-05-25T07:06:12.662Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 149227899,
                        "gitlabId": 149227899,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730197,
                            "isTestReportAvailable": false,
                            "duration": 54,
                            "duration_inMinutes": 0.9,
                            "created_at": "May-25-20",
                            "created_at_rawDateFormat": "2020-05-25T07:06:12.657Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 149227372,
                        "gitlabId": 149227372,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730199,
                            "isTestReportAvailable": false,
                            "duration": 52,
                            "duration_inMinutes": 0.87,
                            "created_at": "May-25-20",
                            "created_at_rawDateFormat": "2020-05-25T07:06:12.665Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 149227297,
                        "gitlabId": 149227297,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 730200,
                            "isTestReportAvailable": false,
                            "duration": 48,
                            "duration_inMinutes": 0.8,
                            "created_at": "May-25-20",
                            "created_at_rawDateFormat": "2020-05-25T07:06:12.772Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 149226746,
                        "gitlabId": 149226746,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730201,
                            "isTestReportAvailable": false,
                            "duration": 54,
                            "duration_inMinutes": 0.9,
                            "created_at": "May-25-20",
                            "created_at_rawDateFormat": "2020-05-25T07:06:12.813Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 149225659,
                        "gitlabId": 149225659,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730202,
                            "isTestReportAvailable": false,
                            "duration": 55,
                            "duration_inMinutes": 0.92,
                            "created_at": "May-25-20",
                            "created_at_rawDateFormat": "2020-05-25T07:06:12.893Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 149225579,
                        "gitlabId": 149225579,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 730207,
                            "isTestReportAvailable": false,
                            "duration": 19,
                            "duration_inMinutes": 0.32,
                            "created_at": "May-25-20",
                            "created_at_rawDateFormat": "2020-05-25T07:06:13.101Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 149225343,
                        "gitlabId": 149225343,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730203,
                            "isTestReportAvailable": false,
                            "duration": 54,
                            "duration_inMinutes": 0.9,
                            "created_at": "May-25-20",
                            "created_at_rawDateFormat": "2020-05-25T07:06:12.940Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 149223526,
                        "gitlabId": 149223526,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730204,
                            "isTestReportAvailable": false,
                            "duration": 55,
                            "duration_inMinutes": 0.92,
                            "created_at": "May-25-20",
                            "created_at_rawDateFormat": "2020-05-25T07:06:12.989Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 149223409,
                        "gitlabId": 149223409,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730205,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "May-25-20",
                            "created_at_rawDateFormat": "2020-05-25T07:06:13.031Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 149222365,
                        "gitlabId": 149222365,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730206,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "May-25-20",
                            "created_at_rawDateFormat": "2020-05-25T07:06:13.092Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29716,
                    "gitlabId": 8197602,
                    "name": "Techday"
                }
            },
            {
                "id": 25863941,
                "gitlabId": 25863941,
                "name": "Docker Deploy Example",
                "urlToRepo": "https://gitlab.com/w11k-devs/techday/docker-deploy-example.git",
                "stats": {
                    "id": 29721,
                    "status": "success",
                    "numberOfPipelines": 14,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 418,
                    "averageDurationOfPipelines_inMinutes": 6.97,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 6,
                    "numberOfFailedPipelines": 7,
                    "numberOfCanceledPipelines": 1,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": 42.86,
                    "totalRepoSize": "534773",
                    "artifactsSize": "195722"
                },
                "pipelines": [
                    {
                        "id": 286994022,
                        "gitlabId": 286994022,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730423,
                            "isTestReportAvailable": false,
                            "duration": 363,
                            "duration_inMinutes": 6.05,
                            "created_at": "Apr-15-21",
                            "created_at_rawDateFormat": "2021-04-15T07:06:25.459Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 286301665,
                        "gitlabId": 286301665,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730426,
                            "isTestReportAvailable": false,
                            "duration": 428,
                            "duration_inMinutes": 7.13,
                            "created_at": "Apr-14-21",
                            "created_at_rawDateFormat": "2021-04-14T07:06:25.556Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 285844170,
                        "gitlabId": 285844170,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730427,
                            "isTestReportAvailable": false,
                            "duration": 405,
                            "duration_inMinutes": 6.75,
                            "created_at": "Apr-13-21",
                            "created_at_rawDateFormat": "2021-04-13T07:06:25.675Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 285839310,
                        "gitlabId": 285839310,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730429,
                            "isTestReportAvailable": false,
                            "duration": 418,
                            "duration_inMinutes": 6.97,
                            "created_at": "Apr-13-21",
                            "created_at_rawDateFormat": "2021-04-13T07:06:25.810Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 285832000,
                        "gitlabId": 285832000,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730433,
                            "isTestReportAvailable": false,
                            "duration": 840,
                            "duration_inMinutes": 14,
                            "created_at": "Apr-13-21",
                            "created_at_rawDateFormat": "2021-04-13T07:06:25.962Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 285831578,
                        "gitlabId": 285831578,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730430,
                            "isTestReportAvailable": false,
                            "duration": null,
                            "duration_inMinutes": 0,
                            "created_at": "Apr-13-21",
                            "created_at_rawDateFormat": "2021-04-13T07:06:25.811Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 285814218,
                        "gitlabId": 285814218,
                        "status": "success",
                        "testReport": null,
                        "stats": {
                            "id": 730431,
                            "isTestReportAvailable": false,
                            "duration": 571,
                            "duration_inMinutes": 9.52,
                            "created_at": "Apr-13-21",
                            "created_at_rawDateFormat": "2021-04-13T07:06:25.823Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 285809699,
                        "gitlabId": 285809699,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730432,
                            "isTestReportAvailable": false,
                            "duration": 329,
                            "duration_inMinutes": 5.48,
                            "created_at": "Apr-13-21",
                            "created_at_rawDateFormat": "2021-04-13T07:06:25.926Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 285802889,
                        "gitlabId": 285802889,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730435,
                            "isTestReportAvailable": false,
                            "duration": 524,
                            "duration_inMinutes": 8.73,
                            "created_at": "Apr-13-21",
                            "created_at_rawDateFormat": "2021-04-13T07:06:26.091Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 285800023,
                        "gitlabId": 285800023,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730434,
                            "isTestReportAvailable": false,
                            "duration": 655,
                            "duration_inMinutes": 10.92,
                            "created_at": "Apr-13-21",
                            "created_at_rawDateFormat": "2021-04-13T07:06:26.090Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 285799626,
                        "gitlabId": 285799626,
                        "status": "canceled",
                        "testReport": null,
                        "stats": {
                            "id": 730436,
                            "isTestReportAvailable": false,
                            "duration": 176,
                            "duration_inMinutes": 2.93,
                            "created_at": "Apr-13-21",
                            "created_at_rawDateFormat": "2021-04-13T07:06:26.098Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 285798709,
                        "gitlabId": 285798709,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730437,
                            "isTestReportAvailable": false,
                            "duration": 266,
                            "duration_inMinutes": 4.43,
                            "created_at": "Apr-13-21",
                            "created_at_rawDateFormat": "2021-04-13T07:06:26.095Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 285793678,
                        "gitlabId": 285793678,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730438,
                            "isTestReportAvailable": false,
                            "duration": 547,
                            "duration_inMinutes": 9.12,
                            "created_at": "Apr-13-21",
                            "created_at_rawDateFormat": "2021-04-13T07:06:26.202Z",
                            "testCoverage": null
                        }
                    },
                    {
                        "id": 285792906,
                        "gitlabId": 285792906,
                        "status": "failed",
                        "testReport": null,
                        "stats": {
                            "id": 730439,
                            "isTestReportAvailable": false,
                            "duration": 323,
                            "duration_inMinutes": 5.38,
                            "created_at": "Apr-13-21",
                            "created_at_rawDateFormat": "2021-04-13T07:06:26.223Z",
                            "testCoverage": null
                        }
                    }
                ],
                "groupInfo": {
                    "id": 29731,
                    "gitlabId": 8197602,
                    "name": "Techday"
                }
            },
            {
                "id": 12437311,
                "gitlabId": 12437311,
                "name": "testing day",
                "urlToRepo": "https://gitlab.com/w11k-devs/techday/testing-day.git",
                "stats": {
                    "id": 29745,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "1205862",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29747,
                    "gitlabId": 8197602,
                    "name": "Techday"
                }
            },
            {
                "id": 31994900,
                "gitlabId": 31994900,
                "name": "testing-tydux",
                "urlToRepo": "https://gitlab.com/w11k-devs/techday/testing-tydux.git",
                "stats": {
                    "id": 29742,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "933232",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29749,
                    "gitlabId": 8197602,
                    "name": "Techday"
                }
            },
            {
                "id": 12914302,
                "gitlabId": 12914302,
                "name": "react-techday",
                "urlToRepo": "https://gitlab.com/w11k-devs/techday/react-techday.git",
                "stats": {
                    "id": 29746,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "891289",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29751,
                    "gitlabId": 8197602,
                    "name": "Techday"
                }
            },
            {
                "id": 24871226,
                "gitlabId": 24871226,
                "name": "optional-chaining",
                "urlToRepo": "https://gitlab.com/w11k-devs/techday/optional-chaining.git",
                "stats": {
                    "id": 29777,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "650117",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29789,
                    "gitlabId": 8197602,
                    "name": "Techday"
                }
            },
            {
                "id": 17106200,
                "gitlabId": 17106200,
                "name": "SQL Workshop",
                "urlToRepo": "https://gitlab.com/w11k-devs/techday/sql-workshop.git",
                "stats": {
                    "id": 29781,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "2673868",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29781,
                    "gitlabId": 8197602,
                    "name": "Techday"
                }
            },
            {
                "id": 27251043,
                "gitlabId": 27251043,
                "name": "react-snapshot-testing",
                "urlToRepo": "https://gitlab.com/w11k-devs/techday/react-snapshot-testing.git",
                "stats": {
                    "id": 29760,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "2474639",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29778,
                    "gitlabId": 8197602,
                    "name": "Techday"
                }
            },
            {
                "id": 14968092,
                "gitlabId": 14968092,
                "name": "angular-array-operators",
                "urlToRepo": "https://gitlab.com/w11k-devs/techday/angular-array-operators.git",
                "stats": {
                    "id": 29756,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "618659",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29768,
                    "gitlabId": 8197602,
                    "name": "Techday"
                }
            },
            {
                "id": 33415504,
                "gitlabId": 33415504,
                "name": "tailwind-css",
                "urlToRepo": "https://gitlab.com/w11k-devs/techday/tailwind-css.git",
                "stats": {
                    "id": 29752,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "639631",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29763,
                    "gitlabId": 8197602,
                    "name": "Techday"
                }
            },
            {
                "id": 19429105,
                "gitlabId": 19429105,
                "name": "Css Grids",
                "urlToRepo": "https://gitlab.com/w11k-devs/techday/css-grids.git",
                "stats": {
                    "id": 29768,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "922746",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29762,
                    "gitlabId": 8197602,
                    "name": "Techday"
                }
            },
            {
                "id": 17120406,
                "gitlabId": 17120406,
                "name": "cypress",
                "urlToRepo": "https://gitlab.com/w11k-devs/techday/cypress.git",
                "stats": {
                    "id": 29732,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "76420218",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29740,
                    "gitlabId": 8197602,
                    "name": "Techday"
                }
            },
            {
                "id": 26266274,
                "gitlabId": 26266274,
                "name": "ngx-ivy-debugging",
                "urlToRepo": "https://gitlab.com/w11k-devs/techday/ngx-ivy-debugging.git",
                "stats": {
                    "id": 29735,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "1163919",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29745,
                    "gitlabId": 8197602,
                    "name": "Techday"
                }
            }
        ],
        "subGroups": [],
        "stats": {
            "id": 6713,
            "isThereSubgroups": false,
            "numberOfProjects": 13,
            "testCoverageOfAllProjects": null,
            "numberOfPipelines": 47,
            "numberOfTestReports": 0
        }
    },
    {
        "id": 7457490,
        "tempData": false,
        "gitlabId": 7457490,
        "name": "Customers",
        "projects": [
            {
                "id": 28250728,
                "gitlabId": 28250728,
                "name": "rib-angularjs-migration",
                "urlToRepo": "https://gitlab.com/w11k-devs/customers/rib-angularjs-migration.git",
                "stats": {
                    "id": 29741,
                    "status": null,
                    "numberOfPipelines": 0,
                    "areTestsAvailable": false,
                    "areTestCoveragesAvailable": false,
                    "numberOfTestReports": 0,
                    "averageDurationOfPipelines": 0,
                    "averageDurationOfPipelines_inMinutes": 0,
                    "testCoverage": null,
                    "numberOfSuccessfulPipelines": 0,
                    "numberOfFailedPipelines": 0,
                    "numberOfCanceledPipelines": 0,
                    "numberOfRunningPipelines": 0,
                    "numberOfSkippedPipelines": 0,
                    "pipelinesSuccessRatio": null,
                    "totalRepoSize": "0",
                    "artifactsSize": "0"
                },
                "pipelines": [],
                "groupInfo": {
                    "id": 29746,
                    "gitlabId": 7457490,
                    "name": "Customers"
                }
            }
        ],
        "subGroups": [
            {
                "id": 10791484,
                "tempData": false,
                "gitlabId": 10791484,
                "name": "Boyle-Hauck",
                "projects": [
                    {
                        "id": 24986466,
                        "gitlabId": 24986466,
                        "name": "Boyle-Hauck Legal App",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Boyle-Hauck.git",
                        "stats": {
                            "id": 29678,
                            "status": "success",
                            "numberOfPipelines": 97,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": true,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 355,
                            "averageDurationOfPipelines_inMinutes": 5.92,
                            "testCoverage": 28.29,
                            "numberOfSuccessfulPipelines": 66,
                            "numberOfFailedPipelines": 30,
                            "numberOfCanceledPipelines": 1,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": 68.04,
                            "totalRepoSize": "16829644",
                            "artifactsSize": "1996363031"
                        },
                        "pipelines": [
                            {
                                "id": 488000359,
                                "gitlabId": 488000359,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728434,
                                    "isTestReportAvailable": false,
                                    "duration": 367,
                                    "duration_inMinutes": 6.12,
                                    "created_at": "Mar-09-22",
                                    "created_at_rawDateFormat": "2022-03-09T07:04:02.554Z",
                                    "testCoverage": 28.29
                                }
                            },
                            {
                                "id": 487347674,
                                "gitlabId": 487347674,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728432,
                                    "isTestReportAvailable": false,
                                    "duration": 652,
                                    "duration_inMinutes": 10.87,
                                    "created_at": "Mar-08-22",
                                    "created_at_rawDateFormat": "2022-03-08T07:04:02.522Z",
                                    "testCoverage": 28.29
                                }
                            },
                            {
                                "id": 487293191,
                                "gitlabId": 487293191,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728455,
                                    "isTestReportAvailable": false,
                                    "duration": 112,
                                    "duration_inMinutes": 1.87,
                                    "created_at": "Mar-08-22",
                                    "created_at_rawDateFormat": "2022-03-08T07:04:05.734Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 486319895,
                                "gitlabId": 486319895,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728457,
                                    "isTestReportAvailable": false,
                                    "duration": 473,
                                    "duration_inMinutes": 7.88,
                                    "created_at": "Mar-07-22",
                                    "created_at_rawDateFormat": "2022-03-07T07:04:05.825Z",
                                    "testCoverage": 28.29
                                }
                            },
                            {
                                "id": 486308708,
                                "gitlabId": 486308708,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728435,
                                    "isTestReportAvailable": false,
                                    "duration": 475,
                                    "duration_inMinutes": 7.92,
                                    "created_at": "Mar-07-22",
                                    "created_at_rawDateFormat": "2022-03-07T07:04:02.800Z",
                                    "testCoverage": 28.44
                                }
                            },
                            {
                                "id": 484558071,
                                "gitlabId": 484558071,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728437,
                                    "isTestReportAvailable": false,
                                    "duration": 112,
                                    "duration_inMinutes": 1.87,
                                    "created_at": "Mar-04-22",
                                    "created_at_rawDateFormat": "2022-03-04T07:04:02.969Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 484534730,
                                "gitlabId": 484534730,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728436,
                                    "isTestReportAvailable": false,
                                    "duration": 212,
                                    "duration_inMinutes": 3.53,
                                    "created_at": "Mar-04-22",
                                    "created_at_rawDateFormat": "2022-03-04T07:04:02.826Z",
                                    "testCoverage": 27.79
                                }
                            },
                            {
                                "id": 484464822,
                                "gitlabId": 484464822,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728439,
                                    "isTestReportAvailable": false,
                                    "duration": 422,
                                    "duration_inMinutes": 7.03,
                                    "created_at": "Mar-04-22",
                                    "created_at_rawDateFormat": "2022-03-04T07:04:03.080Z",
                                    "testCoverage": 28.22
                                }
                            },
                            {
                                "id": 484453864,
                                "gitlabId": 484453864,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728438,
                                    "isTestReportAvailable": false,
                                    "duration": 417,
                                    "duration_inMinutes": 6.95,
                                    "created_at": "Mar-04-22",
                                    "created_at_rawDateFormat": "2022-03-04T07:04:03.078Z",
                                    "testCoverage": 28.22
                                }
                            },
                            {
                                "id": 484443660,
                                "gitlabId": 484443660,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728456,
                                    "isTestReportAvailable": false,
                                    "duration": 438,
                                    "duration_inMinutes": 7.3,
                                    "created_at": "Mar-04-22",
                                    "created_at_rawDateFormat": "2022-03-04T07:04:05.750Z",
                                    "testCoverage": 28.1
                                }
                            },
                            {
                                "id": 484370935,
                                "gitlabId": 484370935,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728440,
                                    "isTestReportAvailable": false,
                                    "duration": 442,
                                    "duration_inMinutes": 7.37,
                                    "created_at": "Mar-04-22",
                                    "created_at_rawDateFormat": "2022-03-04T07:04:03.357Z",
                                    "testCoverage": 28.1
                                }
                            },
                            {
                                "id": 483525474,
                                "gitlabId": 483525474,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728441,
                                    "isTestReportAvailable": false,
                                    "duration": 178,
                                    "duration_inMinutes": 2.97,
                                    "created_at": "Mar-03-22",
                                    "created_at_rawDateFormat": "2022-03-03T07:04:03.401Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 481663166,
                                "gitlabId": 481663166,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728442,
                                    "isTestReportAvailable": false,
                                    "duration": 476,
                                    "duration_inMinutes": 7.93,
                                    "created_at": "Mar-01-22",
                                    "created_at_rawDateFormat": "2022-03-01T07:04:03.635Z",
                                    "testCoverage": 28.5
                                }
                            },
                            {
                                "id": 481647993,
                                "gitlabId": 481647993,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728443,
                                    "isTestReportAvailable": false,
                                    "duration": 519,
                                    "duration_inMinutes": 8.65,
                                    "created_at": "Mar-01-22",
                                    "created_at_rawDateFormat": "2022-03-01T07:04:03.672Z",
                                    "testCoverage": 28.46
                                }
                            },
                            {
                                "id": 481627660,
                                "gitlabId": 481627660,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728445,
                                    "isTestReportAvailable": false,
                                    "duration": 438,
                                    "duration_inMinutes": 7.3,
                                    "created_at": "Mar-01-22",
                                    "created_at_rawDateFormat": "2022-03-01T07:04:04.126Z",
                                    "testCoverage": 28.5
                                }
                            },
                            {
                                "id": 481579102,
                                "gitlabId": 481579102,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728444,
                                    "isTestReportAvailable": false,
                                    "duration": 424,
                                    "duration_inMinutes": 7.07,
                                    "created_at": "Mar-01-22",
                                    "created_at_rawDateFormat": "2022-03-01T07:04:03.988Z",
                                    "testCoverage": 28.52
                                }
                            },
                            {
                                "id": 481552167,
                                "gitlabId": 481552167,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728446,
                                    "isTestReportAvailable": false,
                                    "duration": 492,
                                    "duration_inMinutes": 8.2,
                                    "created_at": "Mar-01-22",
                                    "created_at_rawDateFormat": "2022-03-01T07:04:04.236Z",
                                    "testCoverage": 28.52
                                }
                            },
                            {
                                "id": 481172617,
                                "gitlabId": 481172617,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728447,
                                    "isTestReportAvailable": false,
                                    "duration": 427,
                                    "duration_inMinutes": 7.12,
                                    "created_at": "Feb-28-22",
                                    "created_at_rawDateFormat": "2022-02-28T07:04:04.400Z",
                                    "testCoverage": 28.52
                                }
                            },
                            {
                                "id": 481161624,
                                "gitlabId": 481161624,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728448,
                                    "isTestReportAvailable": false,
                                    "duration": 425,
                                    "duration_inMinutes": 7.08,
                                    "created_at": "Feb-28-22",
                                    "created_at_rawDateFormat": "2022-02-28T07:04:04.510Z",
                                    "testCoverage": 28.52
                                }
                            },
                            {
                                "id": 481154298,
                                "gitlabId": 481154298,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728449,
                                    "isTestReportAvailable": false,
                                    "duration": 426,
                                    "duration_inMinutes": 7.1,
                                    "created_at": "Feb-28-22",
                                    "created_at_rawDateFormat": "2022-02-28T07:04:04.658Z",
                                    "testCoverage": 28.54
                                }
                            },
                            {
                                "id": 481149872,
                                "gitlabId": 481149872,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728450,
                                    "isTestReportAvailable": false,
                                    "duration": 439,
                                    "duration_inMinutes": 7.32,
                                    "created_at": "Feb-28-22",
                                    "created_at_rawDateFormat": "2022-02-28T07:04:04.790Z",
                                    "testCoverage": 28.54
                                }
                            },
                            {
                                "id": 481136018,
                                "gitlabId": 481136018,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728451,
                                    "isTestReportAvailable": false,
                                    "duration": 462,
                                    "duration_inMinutes": 7.7,
                                    "created_at": "Feb-28-22",
                                    "created_at_rawDateFormat": "2022-02-28T07:04:04.928Z",
                                    "testCoverage": 28.54
                                }
                            },
                            {
                                "id": 481118252,
                                "gitlabId": 481118252,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728452,
                                    "isTestReportAvailable": false,
                                    "duration": 414,
                                    "duration_inMinutes": 6.9,
                                    "created_at": "Feb-28-22",
                                    "created_at_rawDateFormat": "2022-02-28T07:04:05.061Z",
                                    "testCoverage": 28.54
                                }
                            },
                            {
                                "id": 481093946,
                                "gitlabId": 481093946,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728453,
                                    "isTestReportAvailable": false,
                                    "duration": 455,
                                    "duration_inMinutes": 7.58,
                                    "created_at": "Feb-28-22",
                                    "created_at_rawDateFormat": "2022-02-28T07:04:05.202Z",
                                    "testCoverage": 28.5
                                }
                            },
                            {
                                "id": 481028013,
                                "gitlabId": 481028013,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728454,
                                    "isTestReportAvailable": false,
                                    "duration": 411,
                                    "duration_inMinutes": 6.85,
                                    "created_at": "Feb-28-22",
                                    "created_at_rawDateFormat": "2022-02-28T07:04:05.319Z",
                                    "testCoverage": 28.54
                                }
                            },
                            {
                                "id": 480835653,
                                "gitlabId": 480835653,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728470,
                                    "isTestReportAvailable": false,
                                    "duration": 438,
                                    "duration_inMinutes": 7.3,
                                    "created_at": "Feb-28-22",
                                    "created_at_rawDateFormat": "2022-02-28T07:04:07.211Z",
                                    "testCoverage": 28.56
                                }
                            },
                            {
                                "id": 480813398,
                                "gitlabId": 480813398,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728475,
                                    "isTestReportAvailable": false,
                                    "duration": 605,
                                    "duration_inMinutes": 10.08,
                                    "created_at": "Feb-28-22",
                                    "created_at_rawDateFormat": "2022-02-28T07:04:07.597Z",
                                    "testCoverage": 28.54
                                }
                            },
                            {
                                "id": 480811222,
                                "gitlabId": 480811222,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728458,
                                    "isTestReportAvailable": false,
                                    "duration": 508,
                                    "duration_inMinutes": 8.47,
                                    "created_at": "Feb-28-22",
                                    "created_at_rawDateFormat": "2022-02-28T07:04:06.002Z",
                                    "testCoverage": 28.38
                                }
                            },
                            {
                                "id": 479725169,
                                "gitlabId": 479725169,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728459,
                                    "isTestReportAvailable": false,
                                    "duration": 426,
                                    "duration_inMinutes": 7.1,
                                    "created_at": "Feb-25-22",
                                    "created_at_rawDateFormat": "2022-02-25T07:04:06.043Z",
                                    "testCoverage": 28.38
                                }
                            },
                            {
                                "id": 479690467,
                                "gitlabId": 479690467,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728460,
                                    "isTestReportAvailable": false,
                                    "duration": 428,
                                    "duration_inMinutes": 7.13,
                                    "created_at": "Feb-25-22",
                                    "created_at_rawDateFormat": "2022-02-25T07:04:06.078Z",
                                    "testCoverage": 28.38
                                }
                            },
                            {
                                "id": 479314289,
                                "gitlabId": 479314289,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728461,
                                    "isTestReportAvailable": false,
                                    "duration": 399,
                                    "duration_inMinutes": 6.65,
                                    "created_at": "Feb-25-22",
                                    "created_at_rawDateFormat": "2022-02-25T07:04:06.273Z",
                                    "testCoverage": 28.54
                                }
                            },
                            {
                                "id": 479281898,
                                "gitlabId": 479281898,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728462,
                                    "isTestReportAvailable": false,
                                    "duration": 395,
                                    "duration_inMinutes": 6.58,
                                    "created_at": "Feb-25-22",
                                    "created_at_rawDateFormat": "2022-02-25T07:04:06.312Z",
                                    "testCoverage": 28.54
                                }
                            },
                            {
                                "id": 479268104,
                                "gitlabId": 479268104,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728463,
                                    "isTestReportAvailable": false,
                                    "duration": 226,
                                    "duration_inMinutes": 3.77,
                                    "created_at": "Feb-25-22",
                                    "created_at_rawDateFormat": "2022-02-25T07:04:06.377Z",
                                    "testCoverage": 28.18
                                }
                            },
                            {
                                "id": 479267601,
                                "gitlabId": 479267601,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 728464,
                                    "isTestReportAvailable": false,
                                    "duration": 211,
                                    "duration_inMinutes": 3.52,
                                    "created_at": "Feb-25-22",
                                    "created_at_rawDateFormat": "2022-02-25T07:04:06.564Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 478404926,
                                "gitlabId": 478404926,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728465,
                                    "isTestReportAvailable": false,
                                    "duration": 219,
                                    "duration_inMinutes": 3.65,
                                    "created_at": "Feb-24-22",
                                    "created_at_rawDateFormat": "2022-02-24T07:04:06.747Z",
                                    "testCoverage": 28.78
                                }
                            },
                            {
                                "id": 476976876,
                                "gitlabId": 476976876,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728471,
                                    "isTestReportAvailable": false,
                                    "duration": 437,
                                    "duration_inMinutes": 7.28,
                                    "created_at": "Feb-22-22",
                                    "created_at_rawDateFormat": "2022-02-22T07:04:07.220Z",
                                    "testCoverage": 28.95
                                }
                            },
                            {
                                "id": 476966716,
                                "gitlabId": 476966716,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728467,
                                    "isTestReportAvailable": false,
                                    "duration": 187,
                                    "duration_inMinutes": 3.12,
                                    "created_at": "Feb-22-22",
                                    "created_at_rawDateFormat": "2022-02-22T07:04:06.855Z",
                                    "testCoverage": 25.12
                                }
                            },
                            {
                                "id": 476057145,
                                "gitlabId": 476057145,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728469,
                                    "isTestReportAvailable": false,
                                    "duration": 182,
                                    "duration_inMinutes": 3.03,
                                    "created_at": "Feb-21-22",
                                    "created_at_rawDateFormat": "2022-02-21T07:04:07.154Z",
                                    "testCoverage": 24.33
                                }
                            },
                            {
                                "id": 476050371,
                                "gitlabId": 476050371,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728468,
                                    "isTestReportAvailable": false,
                                    "duration": 183,
                                    "duration_inMinutes": 3.05,
                                    "created_at": "Feb-21-22",
                                    "created_at_rawDateFormat": "2022-02-21T07:04:07.111Z",
                                    "testCoverage": 25.12
                                }
                            },
                            {
                                "id": 476048300,
                                "gitlabId": 476048300,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728483,
                                    "isTestReportAvailable": false,
                                    "duration": 218,
                                    "duration_inMinutes": 3.63,
                                    "created_at": "Feb-21-22",
                                    "created_at_rawDateFormat": "2022-02-21T07:04:08.231Z",
                                    "testCoverage": 25.12
                                }
                            },
                            {
                                "id": 476047122,
                                "gitlabId": 476047122,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728472,
                                    "isTestReportAvailable": false,
                                    "duration": 59,
                                    "duration_inMinutes": 0.98,
                                    "created_at": "Feb-21-22",
                                    "created_at_rawDateFormat": "2022-02-21T07:04:07.366Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 475885420,
                                "gitlabId": 475885420,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728478,
                                    "isTestReportAvailable": false,
                                    "duration": 99,
                                    "duration_inMinutes": 1.65,
                                    "created_at": "Feb-21-22",
                                    "created_at_rawDateFormat": "2022-02-21T07:04:07.811Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 475883895,
                                "gitlabId": 475883895,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728473,
                                    "isTestReportAvailable": false,
                                    "duration": 12,
                                    "duration_inMinutes": 0.2,
                                    "created_at": "Feb-21-22",
                                    "created_at_rawDateFormat": "2022-02-21T07:04:07.490Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 475858843,
                                "gitlabId": 475858843,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728474,
                                    "isTestReportAvailable": false,
                                    "duration": 102,
                                    "duration_inMinutes": 1.7,
                                    "created_at": "Feb-21-22",
                                    "created_at_rawDateFormat": "2022-02-21T07:04:07.545Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 475843809,
                                "gitlabId": 475843809,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728476,
                                    "isTestReportAvailable": false,
                                    "duration": 106,
                                    "duration_inMinutes": 1.77,
                                    "created_at": "Feb-21-22",
                                    "created_at_rawDateFormat": "2022-02-21T07:04:07.639Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 475821971,
                                "gitlabId": 475821971,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728477,
                                    "isTestReportAvailable": false,
                                    "duration": 16,
                                    "duration_inMinutes": 0.27,
                                    "created_at": "Feb-21-22",
                                    "created_at_rawDateFormat": "2022-02-21T07:04:07.763Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 475785622,
                                "gitlabId": 475785622,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728481,
                                    "isTestReportAvailable": false,
                                    "duration": 56,
                                    "duration_inMinutes": 0.93,
                                    "created_at": "Feb-21-22",
                                    "created_at_rawDateFormat": "2022-02-21T07:04:08.135Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 475681128,
                                "gitlabId": 475681128,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728482,
                                    "isTestReportAvailable": false,
                                    "duration": 48,
                                    "duration_inMinutes": 0.8,
                                    "created_at": "Feb-21-22",
                                    "created_at_rawDateFormat": "2022-02-21T07:04:08.161Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 474365192,
                                "gitlabId": 474365192,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728479,
                                    "isTestReportAvailable": false,
                                    "duration": 46,
                                    "duration_inMinutes": 0.77,
                                    "created_at": "Feb-18-22",
                                    "created_at_rawDateFormat": "2022-02-18T07:04:07.926Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 472545556,
                                "gitlabId": 472545556,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728485,
                                    "isTestReportAvailable": false,
                                    "duration": 59,
                                    "duration_inMinutes": 0.98,
                                    "created_at": "Feb-16-22",
                                    "created_at_rawDateFormat": "2022-02-16T07:04:08.356Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 472528998,
                                "gitlabId": 472528998,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728480,
                                    "isTestReportAvailable": false,
                                    "duration": 172,
                                    "duration_inMinutes": 2.87,
                                    "created_at": "Feb-16-22",
                                    "created_at_rawDateFormat": "2022-02-16T07:04:08.084Z",
                                    "testCoverage": 21.26
                                }
                            },
                            {
                                "id": 472528709,
                                "gitlabId": 472528709,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728484,
                                    "isTestReportAvailable": false,
                                    "duration": 50,
                                    "duration_inMinutes": 0.83,
                                    "created_at": "Feb-16-22",
                                    "created_at_rawDateFormat": "2022-02-16T07:04:08.280Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 472399469,
                                "gitlabId": 472399469,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728487,
                                    "isTestReportAvailable": false,
                                    "duration": 174,
                                    "duration_inMinutes": 2.9,
                                    "created_at": "Feb-16-22",
                                    "created_at_rawDateFormat": "2022-02-16T07:04:08.500Z",
                                    "testCoverage": 28.13
                                }
                            },
                            {
                                "id": 472318761,
                                "gitlabId": 472318761,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728494,
                                    "isTestReportAvailable": false,
                                    "duration": 48,
                                    "duration_inMinutes": 0.8,
                                    "created_at": "Feb-16-22",
                                    "created_at_rawDateFormat": "2022-02-16T07:04:09.088Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 472316388,
                                "gitlabId": 472316388,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728486,
                                    "isTestReportAvailable": false,
                                    "duration": 181,
                                    "duration_inMinutes": 3.02,
                                    "created_at": "Feb-16-22",
                                    "created_at_rawDateFormat": "2022-02-16T07:04:08.432Z",
                                    "testCoverage": 28.08
                                }
                            },
                            {
                                "id": 467324253,
                                "gitlabId": 467324253,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728490,
                                    "isTestReportAvailable": false,
                                    "duration": 379,
                                    "duration_inMinutes": 6.32,
                                    "created_at": "Feb-09-22",
                                    "created_at_rawDateFormat": "2022-02-09T07:04:08.682Z",
                                    "testCoverage": 28.08
                                }
                            },
                            {
                                "id": 466116694,
                                "gitlabId": 466116694,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728488,
                                    "isTestReportAvailable": false,
                                    "duration": 802,
                                    "duration_inMinutes": 13.37,
                                    "created_at": "Feb-08-22",
                                    "created_at_rawDateFormat": "2022-02-08T07:04:08.572Z",
                                    "testCoverage": 28.1
                                }
                            },
                            {
                                "id": 466097926,
                                "gitlabId": 466097926,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728489,
                                    "isTestReportAvailable": false,
                                    "duration": 180,
                                    "duration_inMinutes": 3,
                                    "created_at": "Feb-08-22",
                                    "created_at_rawDateFormat": "2022-02-08T07:04:08.608Z",
                                    "testCoverage": 27.94
                                }
                            },
                            {
                                "id": 463778959,
                                "gitlabId": 463778959,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728491,
                                    "isTestReportAvailable": false,
                                    "duration": 419,
                                    "duration_inMinutes": 6.98,
                                    "created_at": "Feb-04-22",
                                    "created_at_rawDateFormat": "2022-02-04T07:04:08.704Z",
                                    "testCoverage": 28
                                }
                            },
                            {
                                "id": 463601149,
                                "gitlabId": 463601149,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728492,
                                    "isTestReportAvailable": false,
                                    "duration": 408,
                                    "duration_inMinutes": 6.8,
                                    "created_at": "Feb-04-22",
                                    "created_at_rawDateFormat": "2022-02-04T07:04:08.830Z",
                                    "testCoverage": 28.68
                                }
                            },
                            {
                                "id": 463529774,
                                "gitlabId": 463529774,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728493,
                                    "isTestReportAvailable": false,
                                    "duration": 397,
                                    "duration_inMinutes": 6.62,
                                    "created_at": "Feb-04-22",
                                    "created_at_rawDateFormat": "2022-02-04T07:04:08.840Z",
                                    "testCoverage": 28.34
                                }
                            },
                            {
                                "id": 463502852,
                                "gitlabId": 463502852,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728499,
                                    "isTestReportAvailable": false,
                                    "duration": 483,
                                    "duration_inMinutes": 8.05,
                                    "created_at": "Feb-04-22",
                                    "created_at_rawDateFormat": "2022-02-04T07:04:10.036Z",
                                    "testCoverage": 28.34
                                }
                            },
                            {
                                "id": 463497342,
                                "gitlabId": 463497342,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728497,
                                    "isTestReportAvailable": false,
                                    "duration": 469,
                                    "duration_inMinutes": 7.82,
                                    "created_at": "Feb-04-22",
                                    "created_at_rawDateFormat": "2022-02-04T07:04:09.436Z",
                                    "testCoverage": 28.35
                                }
                            },
                            {
                                "id": 463451216,
                                "gitlabId": 463451216,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728498,
                                    "isTestReportAvailable": false,
                                    "duration": 380,
                                    "duration_inMinutes": 6.33,
                                    "created_at": "Feb-04-22",
                                    "created_at_rawDateFormat": "2022-02-04T07:04:09.487Z",
                                    "testCoverage": 28.32
                                }
                            },
                            {
                                "id": 463411736,
                                "gitlabId": 463411736,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728503,
                                    "isTestReportAvailable": false,
                                    "duration": 642,
                                    "duration_inMinutes": 10.7,
                                    "created_at": "Feb-04-22",
                                    "created_at_rawDateFormat": "2022-02-04T07:04:10.970Z",
                                    "testCoverage": 28.6
                                }
                            },
                            {
                                "id": 463373828,
                                "gitlabId": 463373828,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728495,
                                    "isTestReportAvailable": false,
                                    "duration": 388,
                                    "duration_inMinutes": 6.47,
                                    "created_at": "Feb-04-22",
                                    "created_at_rawDateFormat": "2022-02-04T07:04:09.369Z",
                                    "testCoverage": 28.86
                                }
                            },
                            {
                                "id": 457882596,
                                "gitlabId": 457882596,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728496,
                                    "isTestReportAvailable": false,
                                    "duration": 171,
                                    "duration_inMinutes": 2.85,
                                    "created_at": "Jan-27-22",
                                    "created_at_rawDateFormat": "2022-01-27T07:04:09.416Z",
                                    "testCoverage": 29.2
                                }
                            },
                            {
                                "id": 457841089,
                                "gitlabId": 457841089,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728501,
                                    "isTestReportAvailable": false,
                                    "duration": 410,
                                    "duration_inMinutes": 6.83,
                                    "created_at": "Jan-27-22",
                                    "created_at_rawDateFormat": "2022-01-27T07:04:10.173Z",
                                    "testCoverage": 29.2
                                }
                            },
                            {
                                "id": 457817054,
                                "gitlabId": 457817054,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728505,
                                    "isTestReportAvailable": false,
                                    "duration": 250,
                                    "duration_inMinutes": 4.17,
                                    "created_at": "Jan-27-22",
                                    "created_at_rawDateFormat": "2022-01-27T07:04:11.302Z",
                                    "testCoverage": 27.4
                                }
                            },
                            {
                                "id": 457813931,
                                "gitlabId": 457813931,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728500,
                                    "isTestReportAvailable": false,
                                    "duration": 440,
                                    "duration_inMinutes": 7.33,
                                    "created_at": "Jan-27-22",
                                    "created_at_rawDateFormat": "2022-01-27T07:04:10.120Z",
                                    "testCoverage": 27.4
                                }
                            },
                            {
                                "id": 457730845,
                                "gitlabId": 457730845,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728504,
                                    "isTestReportAvailable": false,
                                    "duration": 398,
                                    "duration_inMinutes": 6.63,
                                    "created_at": "Jan-27-22",
                                    "created_at_rawDateFormat": "2022-01-27T07:04:11.044Z",
                                    "testCoverage": 27.35
                                }
                            },
                            {
                                "id": 457713722,
                                "gitlabId": 457713722,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728507,
                                    "isTestReportAvailable": false,
                                    "duration": 498,
                                    "duration_inMinutes": 8.3,
                                    "created_at": "Jan-27-22",
                                    "created_at_rawDateFormat": "2022-01-27T07:04:11.459Z",
                                    "testCoverage": 27.35
                                }
                            },
                            {
                                "id": 457712198,
                                "gitlabId": 457712198,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728502,
                                    "isTestReportAvailable": false,
                                    "duration": 328,
                                    "duration_inMinutes": 5.47,
                                    "created_at": "Jan-27-22",
                                    "created_at_rawDateFormat": "2022-01-27T07:04:10.363Z",
                                    "testCoverage": 27.35
                                }
                            },
                            {
                                "id": 457712081,
                                "gitlabId": 457712081,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728506,
                                    "isTestReportAvailable": false,
                                    "duration": 529,
                                    "duration_inMinutes": 8.82,
                                    "created_at": "Jan-27-22",
                                    "created_at_rawDateFormat": "2022-01-27T07:04:11.355Z",
                                    "testCoverage": 27.35
                                }
                            },
                            {
                                "id": 457700597,
                                "gitlabId": 457700597,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728510,
                                    "isTestReportAvailable": false,
                                    "duration": 417,
                                    "duration_inMinutes": 6.95,
                                    "created_at": "Jan-27-22",
                                    "created_at_rawDateFormat": "2022-01-27T07:04:11.904Z",
                                    "testCoverage": 27.35
                                }
                            },
                            {
                                "id": 457663306,
                                "gitlabId": 457663306,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728508,
                                    "isTestReportAvailable": false,
                                    "duration": 175,
                                    "duration_inMinutes": 2.92,
                                    "created_at": "Jan-27-22",
                                    "created_at_rawDateFormat": "2022-01-27T07:04:11.581Z",
                                    "testCoverage": 27.12
                                }
                            },
                            {
                                "id": 456946922,
                                "gitlabId": 456946922,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728509,
                                    "isTestReportAvailable": false,
                                    "duration": 400,
                                    "duration_inMinutes": 6.67,
                                    "created_at": "Jan-26-22",
                                    "created_at_rawDateFormat": "2022-01-26T07:04:11.744Z",
                                    "testCoverage": 27.16
                                }
                            },
                            {
                                "id": 456894353,
                                "gitlabId": 456894353,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728512,
                                    "isTestReportAvailable": false,
                                    "duration": 428,
                                    "duration_inMinutes": 7.13,
                                    "created_at": "Jan-26-22",
                                    "created_at_rawDateFormat": "2022-01-26T07:04:12.021Z",
                                    "testCoverage": 27.22
                                }
                            },
                            {
                                "id": 456865105,
                                "gitlabId": 456865105,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728513,
                                    "isTestReportAvailable": false,
                                    "duration": 448,
                                    "duration_inMinutes": 7.47,
                                    "created_at": "Jan-26-22",
                                    "created_at_rawDateFormat": "2022-01-26T07:04:12.164Z",
                                    "testCoverage": 27.22
                                }
                            },
                            {
                                "id": 456827028,
                                "gitlabId": 456827028,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728517,
                                    "isTestReportAvailable": false,
                                    "duration": 185,
                                    "duration_inMinutes": 3.08,
                                    "created_at": "Jan-26-22",
                                    "created_at_rawDateFormat": "2022-01-26T07:04:12.491Z",
                                    "testCoverage": 24.65
                                }
                            },
                            {
                                "id": 456734911,
                                "gitlabId": 456734911,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728520,
                                    "isTestReportAvailable": false,
                                    "duration": 414,
                                    "duration_inMinutes": 6.9,
                                    "created_at": "Jan-26-22",
                                    "created_at_rawDateFormat": "2022-01-26T07:04:12.754Z",
                                    "testCoverage": 26.91
                                }
                            },
                            {
                                "id": 456654073,
                                "gitlabId": 456654073,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728511,
                                    "isTestReportAvailable": false,
                                    "duration": 486,
                                    "duration_inMinutes": 8.1,
                                    "created_at": "Jan-26-22",
                                    "created_at_rawDateFormat": "2022-01-26T07:04:11.993Z",
                                    "testCoverage": 26.44
                                }
                            },
                            {
                                "id": 456075689,
                                "gitlabId": 456075689,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728514,
                                    "isTestReportAvailable": false,
                                    "duration": 445,
                                    "duration_inMinutes": 7.42,
                                    "created_at": "Jan-25-22",
                                    "created_at_rawDateFormat": "2022-01-25T07:04:12.225Z",
                                    "testCoverage": 26.28
                                }
                            },
                            {
                                "id": 456057273,
                                "gitlabId": 456057273,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728521,
                                    "isTestReportAvailable": false,
                                    "duration": 447,
                                    "duration_inMinutes": 7.45,
                                    "created_at": "Jan-25-22",
                                    "created_at_rawDateFormat": "2022-01-25T07:04:12.765Z",
                                    "testCoverage": 26.28
                                }
                            },
                            {
                                "id": 451393135,
                                "gitlabId": 451393135,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728515,
                                    "isTestReportAvailable": false,
                                    "duration": 395,
                                    "duration_inMinutes": 6.58,
                                    "created_at": "Jan-19-22",
                                    "created_at_rawDateFormat": "2022-01-19T07:04:12.342Z",
                                    "testCoverage": 26.26
                                }
                            },
                            {
                                "id": 451379833,
                                "gitlabId": 451379833,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728516,
                                    "isTestReportAvailable": false,
                                    "duration": 407,
                                    "duration_inMinutes": 6.78,
                                    "created_at": "Jan-19-22",
                                    "created_at_rawDateFormat": "2022-01-19T07:04:12.439Z",
                                    "testCoverage": 26.26
                                }
                            },
                            {
                                "id": 451365605,
                                "gitlabId": 451365605,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728518,
                                    "isTestReportAvailable": false,
                                    "duration": 586,
                                    "duration_inMinutes": 9.77,
                                    "created_at": "Jan-19-22",
                                    "created_at_rawDateFormat": "2022-01-19T07:04:12.527Z",
                                    "testCoverage": 26.26
                                }
                            },
                            {
                                "id": 451343077,
                                "gitlabId": 451343077,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728550,
                                    "isTestReportAvailable": false,
                                    "duration": 252,
                                    "duration_inMinutes": 4.2,
                                    "created_at": "Jan-19-22",
                                    "created_at_rawDateFormat": "2022-01-19T07:04:16.091Z",
                                    "testCoverage": 25.44
                                }
                            },
                            {
                                "id": 447168862,
                                "gitlabId": 447168862,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728519,
                                    "isTestReportAvailable": false,
                                    "duration": 520,
                                    "duration_inMinutes": 8.67,
                                    "created_at": "Jan-13-22",
                                    "created_at_rawDateFormat": "2022-01-13T07:04:12.696Z",
                                    "testCoverage": 26.26
                                }
                            },
                            {
                                "id": 444521410,
                                "gitlabId": 444521410,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728522,
                                    "isTestReportAvailable": false,
                                    "duration": 885,
                                    "duration_inMinutes": 14.75,
                                    "created_at": "Jan-10-22",
                                    "created_at_rawDateFormat": "2022-01-10T07:04:12.775Z",
                                    "testCoverage": 26.26
                                }
                            },
                            {
                                "id": 444521032,
                                "gitlabId": 444521032,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728528,
                                    "isTestReportAvailable": false,
                                    "duration": 353,
                                    "duration_inMinutes": 5.88,
                                    "created_at": "Jan-10-22",
                                    "created_at_rawDateFormat": "2022-01-10T07:04:13.442Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 444520972,
                                "gitlabId": 444520972,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728523,
                                    "isTestReportAvailable": false,
                                    "duration": 592,
                                    "duration_inMinutes": 9.87,
                                    "created_at": "Jan-10-22",
                                    "created_at_rawDateFormat": "2022-01-10T07:04:13.003Z",
                                    "testCoverage": 26.26
                                }
                            },
                            {
                                "id": 441153329,
                                "gitlabId": 441153329,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728527,
                                    "isTestReportAvailable": false,
                                    "duration": 272,
                                    "duration_inMinutes": 4.53,
                                    "created_at": "Jan-04-22",
                                    "created_at_rawDateFormat": "2022-01-04T07:04:13.389Z",
                                    "testCoverage": 26
                                }
                            },
                            {
                                "id": 440409575,
                                "gitlabId": 440409575,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728525,
                                    "isTestReportAvailable": false,
                                    "duration": 533,
                                    "duration_inMinutes": 8.88,
                                    "created_at": "Jan-03-22",
                                    "created_at_rawDateFormat": "2022-01-03T07:04:13.053Z",
                                    "testCoverage": 26.16
                                }
                            },
                            {
                                "id": 440406412,
                                "gitlabId": 440406412,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728524,
                                    "isTestReportAvailable": false,
                                    "duration": 572,
                                    "duration_inMinutes": 9.53,
                                    "created_at": "Jan-03-22",
                                    "created_at_rawDateFormat": "2022-01-03T07:04:13.041Z",
                                    "testCoverage": 26.15
                                }
                            },
                            {
                                "id": 440402987,
                                "gitlabId": 440402987,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728534,
                                    "isTestReportAvailable": false,
                                    "duration": 321,
                                    "duration_inMinutes": 5.35,
                                    "created_at": "Jan-03-22",
                                    "created_at_rawDateFormat": "2022-01-03T07:04:14.487Z",
                                    "testCoverage": 23.39
                                }
                            },
                            {
                                "id": 439519349,
                                "gitlabId": 439519349,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728526,
                                    "isTestReportAvailable": false,
                                    "duration": 531,
                                    "duration_inMinutes": 8.85,
                                    "created_at": "Dec-31-21",
                                    "created_at_rawDateFormat": "2021-12-31T07:04:13.338Z",
                                    "testCoverage": 26.18
                                }
                            }
                        ],
                        "groupInfo": {
                            "id": 29686,
                            "gitlabId": 10791484,
                            "name": "Boyle-Hauck"
                        }
                    }
                ],
                "subGroups": [],
                "stats": {
                    "id": 6712,
                    "isThereSubgroups": false,
                    "numberOfProjects": 1,
                    "testCoverageOfAllProjects": 28.29,
                    "numberOfPipelines": 97,
                    "numberOfTestReports": 0
                }
            },
            {
                "id": 8198034,
                "tempData": false,
                "gitlabId": 8198034,
                "name": "Schamberger-PLC",
                "projects": [
                    {
                        "id": 11261976,
                        "gitlabId": 11261976,
                        "name": "Schamberger-PLC-1",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Schamberger-PLC.git",
                        "stats": {
                            "id": 29700,
                            "status": "failed",
                            "numberOfPipelines": 97,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 500,
                            "averageDurationOfPipelines_inMinutes": 8.33,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 77,
                            "numberOfFailedPipelines": 20,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": 79.38,
                            "totalRepoSize": "622812200",
                            "artifactsSize": "18421690913"
                        },
                        "pipelines": [
                            {
                                "id": 491789908,
                                "gitlabId": 491789908,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728801,
                                    "isTestReportAvailable": false,
                                    "duration": 170,
                                    "duration_inMinutes": 2.83,
                                    "created_at": "Mar-14-22",
                                    "created_at_rawDateFormat": "2022-03-14T07:04:35.172Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 491694580,
                                "gitlabId": 491694580,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728802,
                                    "isTestReportAvailable": false,
                                    "duration": 301,
                                    "duration_inMinutes": 5.02,
                                    "created_at": "Mar-14-22",
                                    "created_at_rawDateFormat": "2022-03-14T07:04:35.352Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 491693576,
                                "gitlabId": 491693576,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728807,
                                    "isTestReportAvailable": false,
                                    "duration": 596,
                                    "duration_inMinutes": 9.93,
                                    "created_at": "Mar-14-22",
                                    "created_at_rawDateFormat": "2022-03-14T07:04:35.533Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 491692887,
                                "gitlabId": 491692887,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728803,
                                    "isTestReportAvailable": false,
                                    "duration": 614,
                                    "duration_inMinutes": 10.23,
                                    "created_at": "Mar-14-22",
                                    "created_at_rawDateFormat": "2022-03-14T07:04:35.404Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 491677272,
                                "gitlabId": 491677272,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728805,
                                    "isTestReportAvailable": false,
                                    "duration": 667,
                                    "duration_inMinutes": 11.12,
                                    "created_at": "Mar-14-22",
                                    "created_at_rawDateFormat": "2022-03-14T07:04:35.487Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 491643300,
                                "gitlabId": 491643300,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728804,
                                    "isTestReportAvailable": false,
                                    "duration": 400,
                                    "duration_inMinutes": 6.67,
                                    "created_at": "Mar-14-22",
                                    "created_at_rawDateFormat": "2022-03-14T07:04:35.454Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 491451703,
                                "gitlabId": 491451703,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728808,
                                    "isTestReportAvailable": false,
                                    "duration": 420,
                                    "duration_inMinutes": 7,
                                    "created_at": "Mar-14-22",
                                    "created_at_rawDateFormat": "2022-03-14T07:04:35.701Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 490088843,
                                "gitlabId": 490088843,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728813,
                                    "isTestReportAvailable": false,
                                    "duration": 171,
                                    "duration_inMinutes": 2.85,
                                    "created_at": "Mar-11-22",
                                    "created_at_rawDateFormat": "2022-03-11T07:04:35.822Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 488348624,
                                "gitlabId": 488348624,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728809,
                                    "isTestReportAvailable": false,
                                    "duration": 577,
                                    "duration_inMinutes": 9.62,
                                    "created_at": "Mar-09-22",
                                    "created_at_rawDateFormat": "2022-03-09T07:04:35.702Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 488328709,
                                "gitlabId": 488328709,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728811,
                                    "isTestReportAvailable": false,
                                    "duration": 379,
                                    "duration_inMinutes": 6.32,
                                    "created_at": "Mar-09-22",
                                    "created_at_rawDateFormat": "2022-03-09T07:04:35.782Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 488323163,
                                "gitlabId": 488323163,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728810,
                                    "isTestReportAvailable": false,
                                    "duration": 385,
                                    "duration_inMinutes": 6.42,
                                    "created_at": "Mar-09-22",
                                    "created_at_rawDateFormat": "2022-03-09T07:04:35.774Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 488113895,
                                "gitlabId": 488113895,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728812,
                                    "isTestReportAvailable": false,
                                    "duration": 649,
                                    "duration_inMinutes": 10.82,
                                    "created_at": "Mar-09-22",
                                    "created_at_rawDateFormat": "2022-03-09T07:04:35.809Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 488104545,
                                "gitlabId": 488104545,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728814,
                                    "isTestReportAvailable": false,
                                    "duration": 695,
                                    "duration_inMinutes": 11.58,
                                    "created_at": "Mar-09-22",
                                    "created_at_rawDateFormat": "2022-03-09T07:04:35.972Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 488099621,
                                "gitlabId": 488099621,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728827,
                                    "isTestReportAvailable": false,
                                    "duration": 949,
                                    "duration_inMinutes": 15.82,
                                    "created_at": "Mar-09-22",
                                    "created_at_rawDateFormat": "2022-03-09T07:04:37.068Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 488096149,
                                "gitlabId": 488096149,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728818,
                                    "isTestReportAvailable": false,
                                    "duration": 959,
                                    "duration_inMinutes": 15.98,
                                    "created_at": "Mar-09-22",
                                    "created_at_rawDateFormat": "2022-03-09T07:04:36.285Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 488055352,
                                "gitlabId": 488055352,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728816,
                                    "isTestReportAvailable": false,
                                    "duration": 1230,
                                    "duration_inMinutes": 20.5,
                                    "created_at": "Mar-09-22",
                                    "created_at_rawDateFormat": "2022-03-09T07:04:36.065Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 487282918,
                                "gitlabId": 487282918,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728817,
                                    "isTestReportAvailable": false,
                                    "duration": 346,
                                    "duration_inMinutes": 5.77,
                                    "created_at": "Mar-08-22",
                                    "created_at_rawDateFormat": "2022-03-08T07:04:36.069Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 481619449,
                                "gitlabId": 481619449,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728815,
                                    "isTestReportAvailable": false,
                                    "duration": 377,
                                    "duration_inMinutes": 6.28,
                                    "created_at": "Mar-01-22",
                                    "created_at_rawDateFormat": "2022-03-01T07:04:36.062Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 477478250,
                                "gitlabId": 477478250,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728826,
                                    "isTestReportAvailable": false,
                                    "duration": 375,
                                    "duration_inMinutes": 6.25,
                                    "created_at": "Feb-23-22",
                                    "created_at_rawDateFormat": "2022-02-23T07:04:37.049Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 477472468,
                                "gitlabId": 477472468,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728840,
                                    "isTestReportAvailable": false,
                                    "duration": 366,
                                    "duration_inMinutes": 6.1,
                                    "created_at": "Feb-23-22",
                                    "created_at_rawDateFormat": "2022-02-23T07:04:38.222Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 476974763,
                                "gitlabId": 476974763,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728819,
                                    "isTestReportAvailable": false,
                                    "duration": 377,
                                    "duration_inMinutes": 6.28,
                                    "created_at": "Feb-22-22",
                                    "created_at_rawDateFormat": "2022-02-22T07:04:36.338Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 467005384,
                                "gitlabId": 467005384,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728820,
                                    "isTestReportAvailable": false,
                                    "duration": 378,
                                    "duration_inMinutes": 6.3,
                                    "created_at": "Feb-09-22",
                                    "created_at_rawDateFormat": "2022-02-09T07:04:36.373Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 466271037,
                                "gitlabId": 466271037,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728821,
                                    "isTestReportAvailable": false,
                                    "duration": 397,
                                    "duration_inMinutes": 6.62,
                                    "created_at": "Feb-08-22",
                                    "created_at_rawDateFormat": "2022-02-08T07:04:36.573Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 466132863,
                                "gitlabId": 466132863,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728822,
                                    "isTestReportAvailable": false,
                                    "duration": 382,
                                    "duration_inMinutes": 6.37,
                                    "created_at": "Feb-08-22",
                                    "created_at_rawDateFormat": "2022-02-08T07:04:36.581Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 466131541,
                                "gitlabId": 466131541,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728823,
                                    "isTestReportAvailable": false,
                                    "duration": 421,
                                    "duration_inMinutes": 7.02,
                                    "created_at": "Feb-08-22",
                                    "created_at_rawDateFormat": "2022-02-08T07:04:36.682Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 466125238,
                                "gitlabId": 466125238,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728824,
                                    "isTestReportAvailable": false,
                                    "duration": 386,
                                    "duration_inMinutes": 6.43,
                                    "created_at": "Feb-08-22",
                                    "created_at_rawDateFormat": "2022-02-08T07:04:36.854Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 466121344,
                                "gitlabId": 466121344,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728830,
                                    "isTestReportAvailable": false,
                                    "duration": 370,
                                    "duration_inMinutes": 6.17,
                                    "created_at": "Feb-08-22",
                                    "created_at_rawDateFormat": "2022-02-08T07:04:37.338Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 466105293,
                                "gitlabId": 466105293,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728825,
                                    "isTestReportAvailable": false,
                                    "duration": 399,
                                    "duration_inMinutes": 6.65,
                                    "created_at": "Feb-08-22",
                                    "created_at_rawDateFormat": "2022-02-08T07:04:36.948Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 465278589,
                                "gitlabId": 465278589,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728854,
                                    "isTestReportAvailable": false,
                                    "duration": 390,
                                    "duration_inMinutes": 6.5,
                                    "created_at": "Feb-07-22",
                                    "created_at_rawDateFormat": "2022-02-07T07:04:39.298Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 462950871,
                                "gitlabId": 462950871,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728828,
                                    "isTestReportAvailable": false,
                                    "duration": 401,
                                    "duration_inMinutes": 6.68,
                                    "created_at": "Feb-03-22",
                                    "created_at_rawDateFormat": "2022-02-03T07:04:37.202Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 462543017,
                                "gitlabId": 462543017,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728831,
                                    "isTestReportAvailable": false,
                                    "duration": 773,
                                    "duration_inMinutes": 12.88,
                                    "created_at": "Feb-03-22",
                                    "created_at_rawDateFormat": "2022-02-03T07:04:37.475Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 462542348,
                                "gitlabId": 462542348,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728829,
                                    "isTestReportAvailable": false,
                                    "duration": 732,
                                    "duration_inMinutes": 12.2,
                                    "created_at": "Feb-03-22",
                                    "created_at_rawDateFormat": "2022-02-03T07:04:37.335Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 462449663,
                                "gitlabId": 462449663,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728832,
                                    "isTestReportAvailable": false,
                                    "duration": 372,
                                    "duration_inMinutes": 6.2,
                                    "created_at": "Feb-03-22",
                                    "created_at_rawDateFormat": "2022-02-03T07:04:37.478Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 462431704,
                                "gitlabId": 462431704,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728834,
                                    "isTestReportAvailable": false,
                                    "duration": 375,
                                    "duration_inMinutes": 6.25,
                                    "created_at": "Feb-03-22",
                                    "created_at_rawDateFormat": "2022-02-03T07:04:37.648Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 462425664,
                                "gitlabId": 462425664,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728833,
                                    "isTestReportAvailable": false,
                                    "duration": 377,
                                    "duration_inMinutes": 6.28,
                                    "created_at": "Feb-03-22",
                                    "created_at_rawDateFormat": "2022-02-03T07:04:37.586Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 461973159,
                                "gitlabId": 461973159,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728835,
                                    "isTestReportAvailable": false,
                                    "duration": 3935,
                                    "duration_inMinutes": 65.58,
                                    "created_at": "Feb-02-22",
                                    "created_at_rawDateFormat": "2022-02-02T07:04:37.902Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 461856119,
                                "gitlabId": 461856119,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728837,
                                    "isTestReportAvailable": false,
                                    "duration": 379,
                                    "duration_inMinutes": 6.32,
                                    "created_at": "Feb-02-22",
                                    "created_at_rawDateFormat": "2022-02-02T07:04:38.029Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 461615339,
                                "gitlabId": 461615339,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728838,
                                    "isTestReportAvailable": false,
                                    "duration": 433,
                                    "duration_inMinutes": 7.22,
                                    "created_at": "Feb-02-22",
                                    "created_at_rawDateFormat": "2022-02-02T07:04:38.041Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 461606875,
                                "gitlabId": 461606875,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728836,
                                    "isTestReportAvailable": false,
                                    "duration": 380,
                                    "duration_inMinutes": 6.33,
                                    "created_at": "Feb-02-22",
                                    "created_at_rawDateFormat": "2022-02-02T07:04:37.956Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 460964722,
                                "gitlabId": 460964722,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728841,
                                    "isTestReportAvailable": false,
                                    "duration": 381,
                                    "duration_inMinutes": 6.35,
                                    "created_at": "Feb-01-22",
                                    "created_at_rawDateFormat": "2022-02-01T07:04:38.225Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 460740435,
                                "gitlabId": 460740435,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728839,
                                    "isTestReportAvailable": false,
                                    "duration": 356,
                                    "duration_inMinutes": 5.93,
                                    "created_at": "Feb-01-22",
                                    "created_at_rawDateFormat": "2022-02-01T07:04:38.202Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 460153833,
                                "gitlabId": 460153833,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728845,
                                    "isTestReportAvailable": false,
                                    "duration": 405,
                                    "duration_inMinutes": 6.75,
                                    "created_at": "Jan-31-22",
                                    "created_at_rawDateFormat": "2022-01-31T07:04:38.572Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 460152279,
                                "gitlabId": 460152279,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728842,
                                    "isTestReportAvailable": false,
                                    "duration": 382,
                                    "duration_inMinutes": 6.37,
                                    "created_at": "Jan-31-22",
                                    "created_at_rawDateFormat": "2022-01-31T07:04:38.305Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 460088712,
                                "gitlabId": 460088712,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728843,
                                    "isTestReportAvailable": false,
                                    "duration": 380,
                                    "duration_inMinutes": 6.33,
                                    "created_at": "Jan-31-22",
                                    "created_at_rawDateFormat": "2022-01-31T07:04:38.454Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 460035547,
                                "gitlabId": 460035547,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728855,
                                    "isTestReportAvailable": false,
                                    "duration": 412,
                                    "duration_inMinutes": 6.87,
                                    "created_at": "Jan-31-22",
                                    "created_at_rawDateFormat": "2022-01-31T07:04:39.488Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 460033038,
                                "gitlabId": 460033038,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728844,
                                    "isTestReportAvailable": false,
                                    "duration": 397,
                                    "duration_inMinutes": 6.62,
                                    "created_at": "Jan-31-22",
                                    "created_at_rawDateFormat": "2022-01-31T07:04:38.483Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 460018079,
                                "gitlabId": 460018079,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728853,
                                    "isTestReportAvailable": false,
                                    "duration": 385,
                                    "duration_inMinutes": 6.42,
                                    "created_at": "Jan-31-22",
                                    "created_at_rawDateFormat": "2022-01-31T07:04:39.279Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 459746263,
                                "gitlabId": 459746263,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728846,
                                    "isTestReportAvailable": false,
                                    "duration": 374,
                                    "duration_inMinutes": 6.23,
                                    "created_at": "Jan-31-22",
                                    "created_at_rawDateFormat": "2022-01-31T07:04:38.705Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 459738988,
                                "gitlabId": 459738988,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728847,
                                    "isTestReportAvailable": false,
                                    "duration": 377,
                                    "duration_inMinutes": 6.28,
                                    "created_at": "Jan-31-22",
                                    "created_at_rawDateFormat": "2022-01-31T07:04:38.766Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 459731086,
                                "gitlabId": 459731086,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728848,
                                    "isTestReportAvailable": false,
                                    "duration": 421,
                                    "duration_inMinutes": 7.02,
                                    "created_at": "Jan-31-22",
                                    "created_at_rawDateFormat": "2022-01-31T07:04:38.833Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 455846272,
                                "gitlabId": 455846272,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728849,
                                    "isTestReportAvailable": false,
                                    "duration": 421,
                                    "duration_inMinutes": 7.02,
                                    "created_at": "Jan-25-22",
                                    "created_at_rawDateFormat": "2022-01-25T07:04:38.981Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 455741505,
                                "gitlabId": 455741505,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728850,
                                    "isTestReportAvailable": false,
                                    "duration": 375,
                                    "duration_inMinutes": 6.25,
                                    "created_at": "Jan-25-22",
                                    "created_at_rawDateFormat": "2022-01-25T07:04:39.027Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 455733398,
                                "gitlabId": 455733398,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728851,
                                    "isTestReportAvailable": false,
                                    "duration": 373,
                                    "duration_inMinutes": 6.22,
                                    "created_at": "Jan-25-22",
                                    "created_at_rawDateFormat": "2022-01-25T07:04:39.140Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 455723654,
                                "gitlabId": 455723654,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728852,
                                    "isTestReportAvailable": false,
                                    "duration": 421,
                                    "duration_inMinutes": 7.02,
                                    "created_at": "Jan-25-22",
                                    "created_at_rawDateFormat": "2022-01-25T07:04:39.266Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 455722113,
                                "gitlabId": 455722113,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728857,
                                    "isTestReportAvailable": false,
                                    "duration": 393,
                                    "duration_inMinutes": 6.55,
                                    "created_at": "Jan-25-22",
                                    "created_at_rawDateFormat": "2022-01-25T07:04:39.575Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 455713778,
                                "gitlabId": 455713778,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728858,
                                    "isTestReportAvailable": false,
                                    "duration": 374,
                                    "duration_inMinutes": 6.23,
                                    "created_at": "Jan-25-22",
                                    "created_at_rawDateFormat": "2022-01-25T07:04:39.679Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 455701001,
                                "gitlabId": 455701001,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728856,
                                    "isTestReportAvailable": false,
                                    "duration": 378,
                                    "duration_inMinutes": 6.3,
                                    "created_at": "Jan-25-22",
                                    "created_at_rawDateFormat": "2022-01-25T07:04:39.513Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 455689962,
                                "gitlabId": 455689962,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728859,
                                    "isTestReportAvailable": false,
                                    "duration": 377,
                                    "duration_inMinutes": 6.28,
                                    "created_at": "Jan-25-22",
                                    "created_at_rawDateFormat": "2022-01-25T07:04:39.697Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 455034655,
                                "gitlabId": 455034655,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728861,
                                    "isTestReportAvailable": false,
                                    "duration": 394,
                                    "duration_inMinutes": 6.57,
                                    "created_at": "Jan-24-22",
                                    "created_at_rawDateFormat": "2022-01-24T07:04:39.785Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 453529752,
                                "gitlabId": 453529752,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728860,
                                    "isTestReportAvailable": false,
                                    "duration": 376,
                                    "duration_inMinutes": 6.27,
                                    "created_at": "Jan-21-22",
                                    "created_at_rawDateFormat": "2022-01-21T07:04:39.779Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 453518146,
                                "gitlabId": 453518146,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728862,
                                    "isTestReportAvailable": false,
                                    "duration": 365,
                                    "duration_inMinutes": 6.08,
                                    "created_at": "Jan-21-22",
                                    "created_at_rawDateFormat": "2022-01-21T07:04:39.810Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 453492960,
                                "gitlabId": 453492960,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728865,
                                    "isTestReportAvailable": false,
                                    "duration": 376,
                                    "duration_inMinutes": 6.27,
                                    "created_at": "Jan-21-22",
                                    "created_at_rawDateFormat": "2022-01-21T07:04:40.066Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 453421738,
                                "gitlabId": 453421738,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728863,
                                    "isTestReportAvailable": false,
                                    "duration": 373,
                                    "duration_inMinutes": 6.22,
                                    "created_at": "Jan-21-22",
                                    "created_at_rawDateFormat": "2022-01-21T07:04:39.946Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 453363273,
                                "gitlabId": 453363273,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728864,
                                    "isTestReportAvailable": false,
                                    "duration": 390,
                                    "duration_inMinutes": 6.5,
                                    "created_at": "Jan-21-22",
                                    "created_at_rawDateFormat": "2022-01-21T07:04:39.971Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 453350409,
                                "gitlabId": 453350409,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728867,
                                    "isTestReportAvailable": false,
                                    "duration": 408,
                                    "duration_inMinutes": 6.8,
                                    "created_at": "Jan-21-22",
                                    "created_at_rawDateFormat": "2022-01-21T07:04:40.155Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 453318876,
                                "gitlabId": 453318876,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728866,
                                    "isTestReportAvailable": false,
                                    "duration": 381,
                                    "duration_inMinutes": 6.35,
                                    "created_at": "Jan-21-22",
                                    "created_at_rawDateFormat": "2022-01-21T07:04:40.106Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 453313260,
                                "gitlabId": 453313260,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728868,
                                    "isTestReportAvailable": false,
                                    "duration": 168,
                                    "duration_inMinutes": 2.8,
                                    "created_at": "Jan-21-22",
                                    "created_at_rawDateFormat": "2022-01-21T07:04:40.258Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 453296423,
                                "gitlabId": 453296423,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728877,
                                    "isTestReportAvailable": false,
                                    "duration": 171,
                                    "duration_inMinutes": 2.85,
                                    "created_at": "Jan-21-22",
                                    "created_at_rawDateFormat": "2022-01-21T07:04:40.714Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 453251569,
                                "gitlabId": 453251569,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728869,
                                    "isTestReportAvailable": false,
                                    "duration": 171,
                                    "duration_inMinutes": 2.85,
                                    "created_at": "Jan-21-22",
                                    "created_at_rawDateFormat": "2022-01-21T07:04:40.280Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 452237349,
                                "gitlabId": 452237349,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728870,
                                    "isTestReportAvailable": false,
                                    "duration": 92,
                                    "duration_inMinutes": 1.53,
                                    "created_at": "Jan-20-22",
                                    "created_at_rawDateFormat": "2022-01-20T07:04:40.312Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 451723325,
                                "gitlabId": 451723325,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728871,
                                    "isTestReportAvailable": false,
                                    "duration": 400,
                                    "duration_inMinutes": 6.67,
                                    "created_at": "Jan-19-22",
                                    "created_at_rawDateFormat": "2022-01-19T07:04:40.365Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 451718780,
                                "gitlabId": 451718780,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728872,
                                    "isTestReportAvailable": false,
                                    "duration": 527,
                                    "duration_inMinutes": 8.78,
                                    "created_at": "Jan-19-22",
                                    "created_at_rawDateFormat": "2022-01-19T07:04:40.425Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 451529362,
                                "gitlabId": 451529362,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728876,
                                    "isTestReportAvailable": false,
                                    "duration": 178,
                                    "duration_inMinutes": 2.97,
                                    "created_at": "Jan-19-22",
                                    "created_at_rawDateFormat": "2022-01-19T07:04:40.713Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 451429715,
                                "gitlabId": 451429715,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728878,
                                    "isTestReportAvailable": false,
                                    "duration": 182,
                                    "duration_inMinutes": 3.03,
                                    "created_at": "Jan-19-22",
                                    "created_at_rawDateFormat": "2022-01-19T07:04:40.785Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 450553787,
                                "gitlabId": 450553787,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728873,
                                    "isTestReportAvailable": false,
                                    "duration": 270,
                                    "duration_inMinutes": 4.5,
                                    "created_at": "Jan-18-22",
                                    "created_at_rawDateFormat": "2022-01-18T07:04:40.589Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 450415697,
                                "gitlabId": 450415697,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728874,
                                    "isTestReportAvailable": false,
                                    "duration": 564,
                                    "duration_inMinutes": 9.4,
                                    "created_at": "Jan-18-22",
                                    "created_at_rawDateFormat": "2022-01-18T07:04:40.662Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 450406057,
                                "gitlabId": 450406057,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728875,
                                    "isTestReportAvailable": false,
                                    "duration": 623,
                                    "duration_inMinutes": 10.38,
                                    "created_at": "Jan-18-22",
                                    "created_at_rawDateFormat": "2022-01-18T07:04:40.708Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 450401756,
                                "gitlabId": 450401756,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728880,
                                    "isTestReportAvailable": false,
                                    "duration": 625,
                                    "duration_inMinutes": 10.42,
                                    "created_at": "Jan-18-22",
                                    "created_at_rawDateFormat": "2022-01-18T07:04:40.992Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 450259222,
                                "gitlabId": 450259222,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728879,
                                    "isTestReportAvailable": false,
                                    "duration": 1062,
                                    "duration_inMinutes": 17.7,
                                    "created_at": "Jan-18-22",
                                    "created_at_rawDateFormat": "2022-01-18T07:04:40.915Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 449732968,
                                "gitlabId": 449732968,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728883,
                                    "isTestReportAvailable": false,
                                    "duration": 59,
                                    "duration_inMinutes": 0.98,
                                    "created_at": "Jan-17-22",
                                    "created_at_rawDateFormat": "2022-01-17T07:04:41.115Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 449729477,
                                "gitlabId": 449729477,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728884,
                                    "isTestReportAvailable": false,
                                    "duration": 79,
                                    "duration_inMinutes": 1.32,
                                    "created_at": "Jan-17-22",
                                    "created_at_rawDateFormat": "2022-01-17T07:04:41.129Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 446338659,
                                "gitlabId": 446338659,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728881,
                                    "isTestReportAvailable": false,
                                    "duration": 691,
                                    "duration_inMinutes": 11.52,
                                    "created_at": "Jan-12-22",
                                    "created_at_rawDateFormat": "2022-01-12T07:04:41.051Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 446333452,
                                "gitlabId": 446333452,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728882,
                                    "isTestReportAvailable": false,
                                    "duration": 707,
                                    "duration_inMinutes": 11.78,
                                    "created_at": "Jan-12-22",
                                    "created_at_rawDateFormat": "2022-01-12T07:04:41.085Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 446311897,
                                "gitlabId": 446311897,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728885,
                                    "isTestReportAvailable": false,
                                    "duration": 664,
                                    "duration_inMinutes": 11.07,
                                    "created_at": "Jan-12-22",
                                    "created_at_rawDateFormat": "2022-01-12T07:04:41.184Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 446283053,
                                "gitlabId": 446283053,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728886,
                                    "isTestReportAvailable": false,
                                    "duration": 668,
                                    "duration_inMinutes": 11.13,
                                    "created_at": "Jan-12-22",
                                    "created_at_rawDateFormat": "2022-01-12T07:04:41.251Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 446259329,
                                "gitlabId": 446259329,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728887,
                                    "isTestReportAvailable": false,
                                    "duration": 710,
                                    "duration_inMinutes": 11.83,
                                    "created_at": "Jan-12-22",
                                    "created_at_rawDateFormat": "2022-01-12T07:04:41.317Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 446253455,
                                "gitlabId": 446253455,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728888,
                                    "isTestReportAvailable": false,
                                    "duration": 720,
                                    "duration_inMinutes": 12,
                                    "created_at": "Jan-12-22",
                                    "created_at_rawDateFormat": "2022-01-12T07:04:41.347Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 446251622,
                                "gitlabId": 446251622,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728889,
                                    "isTestReportAvailable": false,
                                    "duration": 326,
                                    "duration_inMinutes": 5.43,
                                    "created_at": "Jan-12-22",
                                    "created_at_rawDateFormat": "2022-01-12T07:04:41.401Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 446246115,
                                "gitlabId": 446246115,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728904,
                                    "isTestReportAvailable": false,
                                    "duration": 334,
                                    "duration_inMinutes": 5.57,
                                    "created_at": "Jan-12-22",
                                    "created_at_rawDateFormat": "2022-01-12T07:04:42.769Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 446244856,
                                "gitlabId": 446244856,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728890,
                                    "isTestReportAvailable": false,
                                    "duration": 339,
                                    "duration_inMinutes": 5.65,
                                    "created_at": "Jan-12-22",
                                    "created_at_rawDateFormat": "2022-01-12T07:04:41.492Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 446237975,
                                "gitlabId": 446237975,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728893,
                                    "isTestReportAvailable": false,
                                    "duration": 378,
                                    "duration_inMinutes": 6.3,
                                    "created_at": "Jan-12-22",
                                    "created_at_rawDateFormat": "2022-01-12T07:04:41.843Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 446234975,
                                "gitlabId": 446234975,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728955,
                                    "isTestReportAvailable": false,
                                    "duration": 324,
                                    "duration_inMinutes": 5.4,
                                    "created_at": "Jan-12-22",
                                    "created_at_rawDateFormat": "2022-01-12T07:04:46.575Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 446218741,
                                "gitlabId": 446218741,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728954,
                                    "isTestReportAvailable": false,
                                    "duration": 333,
                                    "duration_inMinutes": 5.55,
                                    "created_at": "Jan-12-22",
                                    "created_at_rawDateFormat": "2022-01-12T07:04:46.527Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 445685454,
                                "gitlabId": 445685454,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728956,
                                    "isTestReportAvailable": false,
                                    "duration": 603,
                                    "duration_inMinutes": 10.05,
                                    "created_at": "Jan-11-22",
                                    "created_at_rawDateFormat": "2022-01-11T07:04:46.633Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 444812277,
                                "gitlabId": 444812277,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728957,
                                    "isTestReportAvailable": false,
                                    "duration": 1447,
                                    "duration_inMinutes": 24.12,
                                    "created_at": "Jan-10-22",
                                    "created_at_rawDateFormat": "2022-01-10T07:04:46.657Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 444790971,
                                "gitlabId": 444790971,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728958,
                                    "isTestReportAvailable": false,
                                    "duration": 1133,
                                    "duration_inMinutes": 18.88,
                                    "created_at": "Jan-10-22",
                                    "created_at_rawDateFormat": "2022-01-10T07:04:46.719Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 444787739,
                                "gitlabId": 444787739,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728959,
                                    "isTestReportAvailable": false,
                                    "duration": 1228,
                                    "duration_inMinutes": 20.47,
                                    "created_at": "Jan-10-22",
                                    "created_at_rawDateFormat": "2022-01-10T07:04:46.749Z",
                                    "testCoverage": null
                                }
                            }
                        ],
                        "groupInfo": {
                            "id": 29682,
                            "gitlabId": 8198034,
                            "name": "Schamberger-PLC"
                        }
                    },
                    {
                        "id": 21282140,
                        "gitlabId": 21282140,
                        "name": "Schamberger-PLC-2",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/sas/ecm-intern.git",
                        "stats": {
                            "id": 29727,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "0",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29734,
                            "gitlabId": 8198034,
                            "name": "Schamberger-PLC"
                        }
                    }
                ],
                "subGroups": [],
                "stats": {
                    "id": 6714,
                    "isThereSubgroups": false,
                    "numberOfProjects": 2,
                    "testCoverageOfAllProjects": null,
                    "numberOfPipelines": 97,
                    "numberOfTestReports": 0
                }
            },
            {
                "id": 10351636,
                "tempData": false,
                "gitlabId": 10351636,
                "name": "Hermann-Group",
                "projects": [
                    {
                        "id": 22993053,
                        "gitlabId": 22993053,
                        "name": "Hermann-Group Web",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Hermann-Group.git",
                        "stats": {
                            "id": 29692,
                            "status": "success",
                            "numberOfPipelines": 97,
                            "areTestsAvailable": true,
                            "areTestCoveragesAvailable": true,
                            "numberOfTestReports": 68,
                            "averageDurationOfPipelines": 135,
                            "averageDurationOfPipelines_inMinutes": 2.25,
                            "testCoverage": 96.7,
                            "numberOfSuccessfulPipelines": 65,
                            "numberOfFailedPipelines": 32,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": 67.01,
                            "totalRepoSize": "14008975",
                            "artifactsSize": "4600058"
                        },
                        "pipelines": [
                            {
                                "id": 491250066,
                                "gitlabId": 491250066,
                                "status": "success",
                                "testReport": {
                                    "id": 46691,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.11,
                                    "test_suites": [
                                        {
                                            "id": 54028,
                                            "total_time": 0.11,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3552843,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552779,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552783,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552788,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552877,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552881,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552887,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552891,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552897,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552871,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552867,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552861,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552858,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552853,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552793,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552798,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552848,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552803,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552808,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552813,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552818,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552823,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552828,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552833,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552838,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729251,
                                    "isTestReportAvailable": true,
                                    "duration": 166,
                                    "duration_inMinutes": 2.77,
                                    "created_at": "Mar-14-22",
                                    "created_at_rawDateFormat": "2022-03-14T07:05:06.135Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 491248153,
                                "gitlabId": 491248153,
                                "status": "success",
                                "testReport": {
                                    "id": 46703,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.12,
                                    "test_suites": [
                                        {
                                            "id": 54031,
                                            "total_time": 0.12,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3558439,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558444,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558484,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558489,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558381,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558385,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558474,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558391,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558395,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558401,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558405,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558411,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558415,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558469,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558464,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558459,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558454,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558421,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558425,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558449,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558499,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558494,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558431,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558479,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558434,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729257,
                                    "isTestReportAvailable": true,
                                    "duration": 177,
                                    "duration_inMinutes": 2.95,
                                    "created_at": "Mar-14-22",
                                    "created_at_rawDateFormat": "2022-03-14T07:05:07.209Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 491240518,
                                "gitlabId": 491240518,
                                "status": "failed",
                                "testReport": {
                                    "id": 46694,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 25,
                                    "total_time": 0.16,
                                    "test_suites": [
                                        {
                                            "id": 54030,
                                            "total_time": 0.16,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 1,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3554087,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554137,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554097,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554107,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553998,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554117,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554147,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553926,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.07,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(received).toEqual(expected) // deep equality\n\n- Expected  -  70\n+ Received  + 707\n\n@@ -1,571 +1,1208 @@\n  Array [\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Page Subtitle\",\n+       \"text\": undefined,\n        \"title\": \"Page Title\",\n        \"topic\": \"Blog\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 1\",\n+           \"text\": undefined,\n            \"title\": \"Title 1\",\n            \"topic\": \"Blog 1\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Blog 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Blog 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 4\",\n+           \"text\": undefined,\n            \"title\": \"Title 4\",\n            \"topic\": \"Blog 4\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 4\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 5\",\n+           \"text\": undefined,\n            \"title\": \"Title 5\",\n            \"topic\": \"Blog 5\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 5\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 6\",\n+           \"text\": undefined,\n            \"title\": \"Title 6\",\n            \"topic\": \"Blog 6\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 6\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Blog\",\n+     \"sorting\": undefined,\n+     \"type\": undefined,\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"subTitle News\",\n+       \"text\": undefined,\n        \"title\": \"Title News\",\n        \"topic\": \"News\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": undefined,\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n+           \"lead\": undefined,\n+           \"linkText\": undefined,\n+           \"subTitle\": undefined,\n+           \"text\": undefined,\n+           \"title\": undefined,\n+           \"topic\": undefined,\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"Title 1\",\n-           \"topic\": \"Item 1\",\n+               \"topic\": \"Hallo \",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n-         \"level\": \"Level2Topic\",\n+             \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n+             \"slug\": \"Hallo \",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n+           },\n+         ],\n          \"slug\": \"Item 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Item 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Item 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"News\",\n      \"sorting\": 1,\n      \"type\": \"carousel\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n+       \"lead\": undefined,\n+       \"linkText\": undefined,\n        \"subTitle\": \"Was wir für Sie tun können.\",\n+       \"text\": undefined,\n        \"title\": \"Yes we can\",\n        \"topic\": \"Expertise\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5210d5bebbe_123%20programmer%20looking%20at%20data%20screens%201600x390.jpg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b536455bec37_simcorp_normal.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Ex 1\",\n            \"topic\": \"Branche/Kunden\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n+               \"lead\": undefined,\n+               \"linkText\": undefined,\n+               \"subTitle\": undefined,\n+               \"text\": undefined,\n+               \"title\": undefined,\n+               \"topic\": undefined,\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 1\",\n                    \"topic\": \"Topic 1\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 1\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 2\",\n                    \"topic\": \"Topic 2\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 2\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 3\",\n                    \"topic\": \"Topic 3\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 3\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n              ],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 2\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 3\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Branche/Kunden\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b52fbd5bebc1_AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b50ade5beba9_ico_SystemConsulting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Lösungen/Services\",\n            \"topic\": \"Lösungen/Services\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Lösungen/Services\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f21f5bebc2_AdobeStock_302181481_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a77c5beba2_ico_Tools_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Das Preyer Team\",\n            \"topic\": \"Das Preyer Team\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Das Preyer Team\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0fa5bebc9_AdobeStock_312736469_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b540875beb9e_ico_Reporting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Schulungen\",\n            \"topic\": \"Schulungen\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"SFTR Webinar\",\n                \"topic\": \"topic 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 2\",\n+               \"text\": undefined,\n                \"title\": \"Course 1\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 3\",\n+               \"text\": undefined,\n                \"title\": \"Course 2\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Schulungen\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Expertise\",\n      \"sorting\": 2,\n      \"type\": \"cards\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n        \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+       \"imageMobile\": undefined,\n        \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n        \"lead\": \"Preyer ist eine Strategie- und IT-Beratung für Finanzunternehmen mit Fokus auf Prozessberatung und IT-Systemlösungen. Wir überprüfen vorhandene IT-Architekturen und implementieren neue Lösungen nur dort, wo es notwendig ist. (mehr…)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Wachstum durch digitale Neuausrichtung.\",\n+       \"text\": undefined,\n        \"title\": \"Connecting Business with IT.\",\n        \"topic\": \"Unternehmen\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Verschärfte Vorgaben der Aufsichtsbehörden, niedrige Zinsen, disruptive Wettbewerber, neue Technologien und massiver Margendruck revolutionieren die Geschäftsmodelle von Banken, Vermögensverwaltern, Fondsgesellschaften, Asset Managern und anderen Finanzdienstleistern. \n  Die dadurch entstehenden strategischen Herausforderungen erfordern mutige Entscheidungen und schnelle Umsetzung. Gleiches gilt für die Einführung effektiver Prozesse und differenzierter Reportings. \n  Das Modernisieren von Geschäftsprozessen und das Implementieren innovativer Systemarchitekturen gehören in der Finanzbranche zu den größten Herausforderungen auf der Reise in eine hochdigitalisierte Welt. \n  Ob Finanz- und Risikomanagement im Treasury, Wertpapierhandel, Fondsbuchhaltung oder die Gesamtbanksteuerung: Das Optimieren von Geschäftsprozessen oder deren Neuausrichtung sind unverzichtbar für die Zukunftsfähigkeit der Finanzindustrie. \n  Innovative Systemarchitekturen sowie transformierte Prozesse und Geschäftsmodelle sind die zentralen Schlüssel für Wettbewerbsfähigkeit und künftiges Wachstum der Branche.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Banken und Finanzinstitute befinden sich an einem Wendepunkt. Nur Unternehmen, die heute ihre digitale Transformation vorantreiben und ihre Systeme modernisieren, stellen die Weichen für eine erfolgreiche Zukunft. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Ineffizienzen sind nicht länger tragbar. \",\n+           \"text\": undefined,\n            \"title\": \"Die Finanzwelt verändert sich.\",\n            \"topic\": \"Markt\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Markt\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Preyer bietet ganzheitliche Fach- und Systemberatung für Banken, Investmentgesellschaften, Versicherungen, Sparkassen und die Öffentliche Hand. \n  Stabile IT-Landschaften und effektive Systemarchitekturen verkörpern die neue Grundausstattung, wenn es um Themen wie Regulierung, Datensicherheit, Automatisierung, neue Wettbewerber oder erhöhten Kostendruck geht. \n  Gemeinsam gehen wir jedem Kundenanliegen auf den Grund und entwickeln schlagkräftige, effiziente IT-Lösungen für unterschiedlichste Projekte und Anforderungen. Pragmatisch, schnell und effektiv. Dabei bilden unsere Expertenteams die Kommunikationsbrücke zwischen den Fachbereichen und der IT. \n  Unsere Kunden profitieren von unserem ganzheitlichen Blick auf die fachlichen Anforderungen ihrer Digitalisierungs- und IT-Projekte, unserer langjährigen Praxiserfahrung als Fach- und Systemberatung im Finanzbereich und dem technologischen Know-how unserer Kompetenz-Teams. \n  Unser Ziel: Schlanke, effiziente und passgenaue Anwendungen und Prozesse, die schnell, digital und zukunftsfähig sind. Deshalb gehen wir bei jedem Projekt inhaltlich in die Tiefe und liefern Statusanalysen, Konzeption und Umsetzung aus einer Hand.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Preyer arbeitet seit Jahren erfolgreich an der technologischen Zukunftsfähigkeit von Finanzunternehmen. Gemeinsam mit unseren Kunden schaffen wir Grundlagen für digitale Geschäftsanwendungen und effiziente IT-Systemlösungen. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Fach- und Systemberatung mit echtem Mehrwert.\",\n+           \"text\": undefined,\n            \"title\": \"IT-Herausforderungen lösen.\",\n            \"topic\": \"Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n+       },\n+       Object {\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+           \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"linkText\": undefined,\n+           \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+           \"text\": undefined,\n+           \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+           \"topic\": \"Referenzen\",\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n+             \"content\": Object {\n+               \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+               \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+               \"linkText\": undefined,\n+               \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+               \"text\": undefined,\n+               \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+               \"topic\": \"Referenzen-Section\",\n+             },\n+             \"isContentOnly\": true,\n+             \"isPrimeTopic\": false,\n+             \"level\": \"Level3Topic\",\n+             \"sections\": Array [\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Addiko-Bank_Ulrich_Kissing.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Addiko-Bank_color.svg\",\n+                   \"lead\": \"Im Rahmen der Privatisierung der Hypo Group Alpe Adria, jetzt Addiko Bank AG, wurde Preyer beauragt, die eingesetzten Methoden und Konzepte im Bereich Marktpreisrisiko zu analysieren und deren Angemessenheit im Hinblick auf das neue Geschäsmodell zu validieren. Weiterer Schwerpunkt bildete die Überprüfung des Transferpricings zwischen der Holding und den Ausländischen Tochtergesellschaen. Wir beauragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen. Diese Expertise war auch vor dem Hintergrund des sehr ambitionierten Zeitplanes eine zwingende Voraussetzung. Die Ergebnisse der Untersuchung und die empfohlenen Maßnahmen werden nun in unseren kurz- und mittelfristigen Aktionsplan einfließen.\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der Addiko Bank AG\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Addiko-Bank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Addiko-Bank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"SparkassenFinanzgruppe_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Sparkassen Finanzgruppe\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Sparkassen Finanzgruppe\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": undefined,\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"DekaBank_kowallik_spk.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"DekaBank_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.<a href=\\\"https://www.deka.com/\\\">www.deka.com</a>\",\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"DekaBank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"DekaBank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"EdmondDeRothschild_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Edmond De Rothschild\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Edmond De Rothschild\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": undefined,\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Bayern-LB_Matthias_Fischer.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"BayernLB_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.<a href=\\\"https://www.deka.com/\\\">www.deka.com</a>\",\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Bayern LB\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Bayern LB\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n                    },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"MEAG_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"MEAG\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"MEAG\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": undefined,\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Natixis_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.<a href=\\\"https://www.deka.com/\\\">www.deka.com</a>\",\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Natixis\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Natixis\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n              ],\n+             \"slug\": \"Referenzen-Section\",\n+             \"sorting\": 1,\n+             \"type\": \"accordion\",\n+           },\n+         ],\n+         \"slug\": \"Referenzen\",\n+         \"sorting\": 1,\n+         \"type\": undefined,\n+       },\n+     ],\n      \"slug\": \"Unternehmen\",\n      \"sorting\": 3,\n      \"type\": \"textLeftImageRight\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Work for us, you know it makes sense\",\n+       \"text\": undefined,\n        \"title\": \"Yes You Can\",\n        \"topic\": \"Karriere\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f9535bebd2_064406_150708_5170.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Karriere bei Preyer\",\n            \"topic\": \"Karriere bei Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Senior Blah\",\n                \"topic\": \"Job 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Junior Blah\",\n                \"topic\": \"Job 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"workstudent\",\n+               \"text\": undefined,\n                \"title\": \"Slave\",\n                \"topic\": \"Job 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Karriere bei Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0d95bebca_vega%2Bbuerotisch.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Über Preyer\",\n            \"topic\": \"Über Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Über Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Karriere\",\n      \"sorting\": 4,\n      \"type\": \"cards\",\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:18:29\n    at Generator.next (<anonymous>)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:8:71\n    at new Promise (<anonymous>)\n    at Object.<anonymous>.__awaiter (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:4:12)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:14:41)\n    at Object.asyncJestTest (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:106:37)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:45:12\n    at new Promise (<anonymous>)\n    at mapper (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:28:19)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:75:41\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3553936,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553946,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554008,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554127,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553953,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554027,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554037,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554047,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554057,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554018,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553988,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553983,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553974,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553964,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554067,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554077,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553958,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729253,
                                    "isTestReportAvailable": true,
                                    "duration": 162,
                                    "duration_inMinutes": 2.7,
                                    "created_at": "Mar-14-22",
                                    "created_at_rawDateFormat": "2022-03-14T07:05:06.630Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 491230962,
                                "gitlabId": 491230962,
                                "status": "failed",
                                "testReport": {
                                    "id": 46698,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 25,
                                    "total_time": 0.19,
                                    "test_suites": [
                                        {
                                            "id": 54032,
                                            "total_time": 0.19,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 1,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3553643,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553633,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553623,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553613,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553603,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553593,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553584,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553574,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553564,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553554,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553544,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553536,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553530,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553526,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553520,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553515,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553505,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553495,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553490,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553480,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.02,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553470,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.04,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553459,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.07,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(received).toEqual(expected) // deep equality\n\n- Expected  -  70\n+ Received  + 707\n\n@@ -1,571 +1,1208 @@\n  Array [\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Page Subtitle\",\n+       \"text\": undefined,\n        \"title\": \"Page Title\",\n        \"topic\": \"Blog\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 1\",\n+           \"text\": undefined,\n            \"title\": \"Title 1\",\n            \"topic\": \"Blog 1\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Blog 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Blog 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 4\",\n+           \"text\": undefined,\n            \"title\": \"Title 4\",\n            \"topic\": \"Blog 4\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 4\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 5\",\n+           \"text\": undefined,\n            \"title\": \"Title 5\",\n            \"topic\": \"Blog 5\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 5\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 6\",\n+           \"text\": undefined,\n            \"title\": \"Title 6\",\n            \"topic\": \"Blog 6\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 6\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Blog\",\n+     \"sorting\": undefined,\n+     \"type\": undefined,\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"subTitle News\",\n+       \"text\": undefined,\n        \"title\": \"Title News\",\n        \"topic\": \"News\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": undefined,\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n+           \"lead\": undefined,\n+           \"linkText\": undefined,\n+           \"subTitle\": undefined,\n+           \"text\": undefined,\n+           \"title\": undefined,\n+           \"topic\": undefined,\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"Title 1\",\n-           \"topic\": \"Item 1\",\n+               \"topic\": \"Hallo \",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n-         \"level\": \"Level2Topic\",\n+             \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n+             \"slug\": \"Hallo \",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n+           },\n+         ],\n          \"slug\": \"Item 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Item 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Item 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"News\",\n      \"sorting\": 1,\n      \"type\": \"carousel\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n+       \"lead\": undefined,\n+       \"linkText\": undefined,\n        \"subTitle\": \"Was wir für Sie tun können.\",\n+       \"text\": undefined,\n        \"title\": \"Yes we can\",\n        \"topic\": \"Expertise\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5210d5bebbe_123%20programmer%20looking%20at%20data%20screens%201600x390.jpg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b536455bec37_simcorp_normal.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Ex 1\",\n            \"topic\": \"Branche/Kunden\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n+               \"lead\": undefined,\n+               \"linkText\": undefined,\n+               \"subTitle\": undefined,\n+               \"text\": undefined,\n+               \"title\": undefined,\n+               \"topic\": undefined,\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 1\",\n                    \"topic\": \"Topic 1\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 1\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 2\",\n                    \"topic\": \"Topic 2\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 2\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 3\",\n                    \"topic\": \"Topic 3\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 3\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n              ],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 2\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 3\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Branche/Kunden\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b52fbd5bebc1_AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b50ade5beba9_ico_SystemConsulting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Lösungen/Services\",\n            \"topic\": \"Lösungen/Services\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Lösungen/Services\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f21f5bebc2_AdobeStock_302181481_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a77c5beba2_ico_Tools_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Das Preyer Team\",\n            \"topic\": \"Das Preyer Team\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Das Preyer Team\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0fa5bebc9_AdobeStock_312736469_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b540875beb9e_ico_Reporting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Schulungen\",\n            \"topic\": \"Schulungen\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"SFTR Webinar\",\n                \"topic\": \"topic 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 2\",\n+               \"text\": undefined,\n                \"title\": \"Course 1\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 3\",\n+               \"text\": undefined,\n                \"title\": \"Course 2\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Schulungen\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Expertise\",\n      \"sorting\": 2,\n      \"type\": \"cards\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n        \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+       \"imageMobile\": undefined,\n        \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n        \"lead\": \"Preyer ist eine Strategie- und IT-Beratung für Finanzunternehmen mit Fokus auf Prozessberatung und IT-Systemlösungen. Wir überprüfen vorhandene IT-Architekturen und implementieren neue Lösungen nur dort, wo es notwendig ist. (mehr…)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Wachstum durch digitale Neuausrichtung.\",\n+       \"text\": undefined,\n        \"title\": \"Connecting Business with IT.\",\n        \"topic\": \"Unternehmen\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Verschärfte Vorgaben der Aufsichtsbehörden, niedrige Zinsen, disruptive Wettbewerber, neue Technologien und massiver Margendruck revolutionieren die Geschäftsmodelle von Banken, Vermögensverwaltern, Fondsgesellschaften, Asset Managern und anderen Finanzdienstleistern. \n  Die dadurch entstehenden strategischen Herausforderungen erfordern mutige Entscheidungen und schnelle Umsetzung. Gleiches gilt für die Einführung effektiver Prozesse und differenzierter Reportings. \n  Das Modernisieren von Geschäftsprozessen und das Implementieren innovativer Systemarchitekturen gehören in der Finanzbranche zu den größten Herausforderungen auf der Reise in eine hochdigitalisierte Welt. \n  Ob Finanz- und Risikomanagement im Treasury, Wertpapierhandel, Fondsbuchhaltung oder die Gesamtbanksteuerung: Das Optimieren von Geschäftsprozessen oder deren Neuausrichtung sind unverzichtbar für die Zukunftsfähigkeit der Finanzindustrie. \n  Innovative Systemarchitekturen sowie transformierte Prozesse und Geschäftsmodelle sind die zentralen Schlüssel für Wettbewerbsfähigkeit und künftiges Wachstum der Branche.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Banken und Finanzinstitute befinden sich an einem Wendepunkt. Nur Unternehmen, die heute ihre digitale Transformation vorantreiben und ihre Systeme modernisieren, stellen die Weichen für eine erfolgreiche Zukunft. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Ineffizienzen sind nicht länger tragbar. \",\n+           \"text\": undefined,\n            \"title\": \"Die Finanzwelt verändert sich.\",\n            \"topic\": \"Markt\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Markt\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Preyer bietet ganzheitliche Fach- und Systemberatung für Banken, Investmentgesellschaften, Versicherungen, Sparkassen und die Öffentliche Hand. \n  Stabile IT-Landschaften und effektive Systemarchitekturen verkörpern die neue Grundausstattung, wenn es um Themen wie Regulierung, Datensicherheit, Automatisierung, neue Wettbewerber oder erhöhten Kostendruck geht. \n  Gemeinsam gehen wir jedem Kundenanliegen auf den Grund und entwickeln schlagkräftige, effiziente IT-Lösungen für unterschiedlichste Projekte und Anforderungen. Pragmatisch, schnell und effektiv. Dabei bilden unsere Expertenteams die Kommunikationsbrücke zwischen den Fachbereichen und der IT. \n  Unsere Kunden profitieren von unserem ganzheitlichen Blick auf die fachlichen Anforderungen ihrer Digitalisierungs- und IT-Projekte, unserer langjährigen Praxiserfahrung als Fach- und Systemberatung im Finanzbereich und dem technologischen Know-how unserer Kompetenz-Teams. \n  Unser Ziel: Schlanke, effiziente und passgenaue Anwendungen und Prozesse, die schnell, digital und zukunftsfähig sind. Deshalb gehen wir bei jedem Projekt inhaltlich in die Tiefe und liefern Statusanalysen, Konzeption und Umsetzung aus einer Hand.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Preyer arbeitet seit Jahren erfolgreich an der technologischen Zukunftsfähigkeit von Finanzunternehmen. Gemeinsam mit unseren Kunden schaffen wir Grundlagen für digitale Geschäftsanwendungen und effiziente IT-Systemlösungen. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Fach- und Systemberatung mit echtem Mehrwert.\",\n+           \"text\": undefined,\n            \"title\": \"IT-Herausforderungen lösen.\",\n            \"topic\": \"Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n+       },\n+       Object {\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+           \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"linkText\": undefined,\n+           \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+           \"text\": undefined,\n+           \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+           \"topic\": \"Referenzen\",\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n+             \"content\": Object {\n+               \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+               \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+               \"linkText\": undefined,\n+               \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+               \"text\": undefined,\n+               \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+               \"topic\": \"Referenzen-Section\",\n+             },\n+             \"isContentOnly\": true,\n+             \"isPrimeTopic\": false,\n+             \"level\": \"Level3Topic\",\n+             \"sections\": Array [\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Addiko-Bank_Ulrich_Kissing.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Addiko-Bank_color.svg\",\n+                   \"lead\": \"Im Rahmen der Privatisierung der Hypo Group Alpe Adria, jetzt Addiko Bank AG, wurde Preyer beauragt, die eingesetzten Methoden und Konzepte im Bereich Marktpreisrisiko zu analysieren und deren Angemessenheit im Hinblick auf das neue Geschäsmodell zu validieren. Weiterer Schwerpunkt bildete die Überprüfung des Transferpricings zwischen der Holding und den Ausländischen Tochtergesellschaen. Wir beauragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen. Diese Expertise war auch vor dem Hintergrund des sehr ambitionierten Zeitplanes eine zwingende Voraussetzung. Die Ergebnisse der Untersuchung und die empfohlenen Maßnahmen werden nun in unseren kurz- und mittelfristigen Aktionsplan einfließen.\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der Addiko Bank AG\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Addiko-Bank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Addiko-Bank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"SparkassenFinanzgruppe_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Sparkassen Finanzgruppe\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Sparkassen Finanzgruppe\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": undefined,\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"DekaBank_kowallik_spk.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"DekaBank_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.<a href=\\\"https://www.deka.com/\\\">www.deka.com</a>\",\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"DekaBank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"DekaBank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"EdmondDeRothschild_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Edmond De Rothschild\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Edmond De Rothschild\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": undefined,\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Bayern-LB_Matthias_Fischer.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"BayernLB_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.<a href=\\\"https://www.deka.com/\\\">www.deka.com</a>\",\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Bayern LB\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Bayern LB\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n                    },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"MEAG_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"MEAG\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"MEAG\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": undefined,\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Natixis_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.<a href=\\\"https://www.deka.com/\\\">www.deka.com</a>\",\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Natixis\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Natixis\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n              ],\n+             \"slug\": \"Referenzen-Section\",\n+             \"sorting\": 1,\n+             \"type\": \"accordion\",\n+           },\n+         ],\n+         \"slug\": \"Referenzen\",\n+         \"sorting\": 1,\n+         \"type\": undefined,\n+       },\n+     ],\n      \"slug\": \"Unternehmen\",\n      \"sorting\": 3,\n      \"type\": \"textLeftImageRight\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Work for us, you know it makes sense\",\n+       \"text\": undefined,\n        \"title\": \"Yes You Can\",\n        \"topic\": \"Karriere\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f9535bebd2_064406_150708_5170.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Karriere bei Preyer\",\n            \"topic\": \"Karriere bei Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Senior Blah\",\n                \"topic\": \"Job 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Junior Blah\",\n                \"topic\": \"Job 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"workstudent\",\n+               \"text\": undefined,\n                \"title\": \"Slave\",\n                \"topic\": \"Job 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Karriere bei Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0d95bebca_vega%2Bbuerotisch.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Über Preyer\",\n            \"topic\": \"Über Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Über Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Karriere\",\n      \"sorting\": 4,\n      \"type\": \"cards\",\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:18:29\n    at Generator.next (<anonymous>)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:8:71\n    at new Promise (<anonymous>)\n    at Object.<anonymous>.__awaiter (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:4:12)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:14:41)\n    at Object.asyncJestTest (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:106:37)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:45:12\n    at new Promise (<anonymous>)\n    at mapper (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:28:19)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:75:41\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3553652,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553658,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553662,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729259,
                                    "isTestReportAvailable": true,
                                    "duration": 165,
                                    "duration_inMinutes": 2.75,
                                    "created_at": "Mar-14-22",
                                    "created_at_rawDateFormat": "2022-03-14T07:05:07.340Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 491228566,
                                "gitlabId": 491228566,
                                "status": "failed",
                                "testReport": {
                                    "id": 46693,
                                    "error_count": 0,
                                    "failed_count": 1,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 25,
                                    "total_time": 0.16,
                                    "test_suites": [
                                        {
                                            "id": 54034,
                                            "total_time": 0.16,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 1,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3552913,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552909,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552903,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552837,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552832,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552817,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552811,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552802,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552792,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552782,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.06,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(received).toEqual(expected) // deep equality\n\n- Expected  -  70\n+ Received  + 707\n\n@@ -1,571 +1,1208 @@\n  Array [\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Page Subtitle\",\n+       \"text\": undefined,\n        \"title\": \"Page Title\",\n        \"topic\": \"Blog\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 1\",\n+           \"text\": undefined,\n            \"title\": \"Title 1\",\n            \"topic\": \"Blog 1\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Blog 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Blog 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 4\",\n+           \"text\": undefined,\n            \"title\": \"Title 4\",\n            \"topic\": \"Blog 4\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 4\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 5\",\n+           \"text\": undefined,\n            \"title\": \"Title 5\",\n            \"topic\": \"Blog 5\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 5\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 6\",\n+           \"text\": undefined,\n            \"title\": \"Title 6\",\n            \"topic\": \"Blog 6\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 6\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Blog\",\n+     \"sorting\": undefined,\n+     \"type\": undefined,\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"subTitle News\",\n+       \"text\": undefined,\n        \"title\": \"Title News\",\n        \"topic\": \"News\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": undefined,\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n+           \"lead\": undefined,\n+           \"linkText\": undefined,\n+           \"subTitle\": undefined,\n+           \"text\": undefined,\n+           \"title\": undefined,\n+           \"topic\": undefined,\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"Title 1\",\n-           \"topic\": \"Item 1\",\n+               \"topic\": \"Hallo \",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n-         \"level\": \"Level2Topic\",\n+             \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n+             \"slug\": \"Hallo \",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n+           },\n+         ],\n          \"slug\": \"Item 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Item 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Item 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"News\",\n      \"sorting\": 1,\n      \"type\": \"carousel\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n+       \"lead\": undefined,\n+       \"linkText\": undefined,\n        \"subTitle\": \"Was wir für Sie tun können.\",\n+       \"text\": undefined,\n        \"title\": \"Yes we can\",\n        \"topic\": \"Expertise\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5210d5bebbe_123%20programmer%20looking%20at%20data%20screens%201600x390.jpg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b536455bec37_simcorp_normal.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Ex 1\",\n            \"topic\": \"Branche/Kunden\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n+               \"lead\": undefined,\n+               \"linkText\": undefined,\n+               \"subTitle\": undefined,\n+               \"text\": undefined,\n+               \"title\": undefined,\n+               \"topic\": undefined,\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 1\",\n                    \"topic\": \"Topic 1\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 1\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 2\",\n                    \"topic\": \"Topic 2\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 2\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 3\",\n                    \"topic\": \"Topic 3\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 3\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n              ],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 2\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 3\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Branche/Kunden\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b52fbd5bebc1_AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b50ade5beba9_ico_SystemConsulting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Lösungen/Services\",\n            \"topic\": \"Lösungen/Services\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Lösungen/Services\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f21f5bebc2_AdobeStock_302181481_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a77c5beba2_ico_Tools_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Das Preyer Team\",\n            \"topic\": \"Das Preyer Team\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Das Preyer Team\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0fa5bebc9_AdobeStock_312736469_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b540875beb9e_ico_Reporting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Schulungen\",\n            \"topic\": \"Schulungen\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"SFTR Webinar\",\n                \"topic\": \"topic 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 2\",\n+               \"text\": undefined,\n                \"title\": \"Course 1\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 3\",\n+               \"text\": undefined,\n                \"title\": \"Course 2\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Schulungen\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Expertise\",\n      \"sorting\": 2,\n      \"type\": \"cards\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n        \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+       \"imageMobile\": undefined,\n        \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n        \"lead\": \"Preyer ist eine Strategie- und IT-Beratung für Finanzunternehmen mit Fokus auf Prozessberatung und IT-Systemlösungen. Wir überprüfen vorhandene IT-Architekturen und implementieren neue Lösungen nur dort, wo es notwendig ist. (mehr…)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Wachstum durch digitale Neuausrichtung.\",\n+       \"text\": undefined,\n        \"title\": \"Connecting Business with IT.\",\n        \"topic\": \"Unternehmen\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Verschärfte Vorgaben der Aufsichtsbehörden, niedrige Zinsen, disruptive Wettbewerber, neue Technologien und massiver Margendruck revolutionieren die Geschäftsmodelle von Banken, Vermögensverwaltern, Fondsgesellschaften, Asset Managern und anderen Finanzdienstleistern. \n  Die dadurch entstehenden strategischen Herausforderungen erfordern mutige Entscheidungen und schnelle Umsetzung. Gleiches gilt für die Einführung effektiver Prozesse und differenzierter Reportings. \n  Das Modernisieren von Geschäftsprozessen und das Implementieren innovativer Systemarchitekturen gehören in der Finanzbranche zu den größten Herausforderungen auf der Reise in eine hochdigitalisierte Welt. \n  Ob Finanz- und Risikomanagement im Treasury, Wertpapierhandel, Fondsbuchhaltung oder die Gesamtbanksteuerung: Das Optimieren von Geschäftsprozessen oder deren Neuausrichtung sind unverzichtbar für die Zukunftsfähigkeit der Finanzindustrie. \n  Innovative Systemarchitekturen sowie transformierte Prozesse und Geschäftsmodelle sind die zentralen Schlüssel für Wettbewerbsfähigkeit und künftiges Wachstum der Branche.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Banken und Finanzinstitute befinden sich an einem Wendepunkt. Nur Unternehmen, die heute ihre digitale Transformation vorantreiben und ihre Systeme modernisieren, stellen die Weichen für eine erfolgreiche Zukunft. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Ineffizienzen sind nicht länger tragbar. \",\n+           \"text\": undefined,\n            \"title\": \"Die Finanzwelt verändert sich.\",\n            \"topic\": \"Markt\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Markt\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Preyer bietet ganzheitliche Fach- und Systemberatung für Banken, Investmentgesellschaften, Versicherungen, Sparkassen und die Öffentliche Hand. \n  Stabile IT-Landschaften und effektive Systemarchitekturen verkörpern die neue Grundausstattung, wenn es um Themen wie Regulierung, Datensicherheit, Automatisierung, neue Wettbewerber oder erhöhten Kostendruck geht. \n  Gemeinsam gehen wir jedem Kundenanliegen auf den Grund und entwickeln schlagkräftige, effiziente IT-Lösungen für unterschiedlichste Projekte und Anforderungen. Pragmatisch, schnell und effektiv. Dabei bilden unsere Expertenteams die Kommunikationsbrücke zwischen den Fachbereichen und der IT. \n  Unsere Kunden profitieren von unserem ganzheitlichen Blick auf die fachlichen Anforderungen ihrer Digitalisierungs- und IT-Projekte, unserer langjährigen Praxiserfahrung als Fach- und Systemberatung im Finanzbereich und dem technologischen Know-how unserer Kompetenz-Teams. \n  Unser Ziel: Schlanke, effiziente und passgenaue Anwendungen und Prozesse, die schnell, digital und zukunftsfähig sind. Deshalb gehen wir bei jedem Projekt inhaltlich in die Tiefe und liefern Statusanalysen, Konzeption und Umsetzung aus einer Hand.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Preyer arbeitet seit Jahren erfolgreich an der technologischen Zukunftsfähigkeit von Finanzunternehmen. Gemeinsam mit unseren Kunden schaffen wir Grundlagen für digitale Geschäftsanwendungen und effiziente IT-Systemlösungen. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Fach- und Systemberatung mit echtem Mehrwert.\",\n+           \"text\": undefined,\n            \"title\": \"IT-Herausforderungen lösen.\",\n            \"topic\": \"Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n+       },\n+       Object {\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+           \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"linkText\": undefined,\n+           \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+           \"text\": undefined,\n+           \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+           \"topic\": \"Referenzen\",\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n+             \"content\": Object {\n+               \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+               \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+               \"linkText\": undefined,\n+               \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+               \"text\": undefined,\n+               \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+               \"topic\": \"Referenzen-Section\",\n+             },\n+             \"isContentOnly\": true,\n+             \"isPrimeTopic\": false,\n+             \"level\": \"Level3Topic\",\n+             \"sections\": Array [\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Addiko-Bank_Ulrich_Kissing.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Addiko-Bank_color.svg\",\n+                   \"lead\": \"Im Rahmen der Privatisierung der Hypo Group Alpe Adria, jetzt Addiko Bank AG, wurde Preyer beauragt, die eingesetzten Methoden und Konzepte im Bereich Marktpreisrisiko zu analysieren und deren Angemessenheit im Hinblick auf das neue Geschäsmodell zu validieren. Weiterer Schwerpunkt bildete die Überprüfung des Transferpricings zwischen der Holding und den Ausländischen Tochtergesellschaen. Wir beauragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen. Diese Expertise war auch vor dem Hintergrund des sehr ambitionierten Zeitplanes eine zwingende Voraussetzung. Die Ergebnisse der Untersuchung und die empfohlenen Maßnahmen werden nun in unseren kurz- und mittelfristigen Aktionsplan einfließen.\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der Addiko Bank AG\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Addiko-Bank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Addiko-Bank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"SparkassenFinanzgruppe_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Sparkassen Finanzgruppe\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Sparkassen Finanzgruppe\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": undefined,\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"DekaBank_kowallik_spk.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"DekaBank_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.<a href=\\\"https://www.deka.com/\\\">www.deka.com</a>\",\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"DekaBank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"DekaBank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"EdmondDeRothschild_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Edmond De Rothschild\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Edmond De Rothschild\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": undefined,\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Bayern-LB_Matthias_Fischer.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"BayernLB_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.<a href=\\\"https://www.deka.com/\\\">www.deka.com</a>\",\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Bayern LB\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Bayern LB\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n                    },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"MEAG_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"MEAG\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"MEAG\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": undefined,\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Natixis_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.<a href=\\\"https://www.deka.com/\\\">www.deka.com</a>\",\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Natixis\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Natixis\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n              ],\n+             \"slug\": \"Referenzen-Section\",\n+             \"sorting\": 1,\n+             \"type\": \"accordion\",\n+           },\n+         ],\n+         \"slug\": \"Referenzen\",\n+         \"sorting\": 1,\n+         \"type\": undefined,\n+       },\n+     ],\n      \"slug\": \"Unternehmen\",\n      \"sorting\": 3,\n      \"type\": \"textLeftImageRight\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Work for us, you know it makes sense\",\n+       \"text\": undefined,\n        \"title\": \"Yes You Can\",\n        \"topic\": \"Karriere\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f9535bebd2_064406_150708_5170.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Karriere bei Preyer\",\n            \"topic\": \"Karriere bei Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Senior Blah\",\n                \"topic\": \"Job 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Junior Blah\",\n                \"topic\": \"Job 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"workstudent\",\n+               \"text\": undefined,\n                \"title\": \"Slave\",\n                \"topic\": \"Job 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Karriere bei Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0d95bebca_vega%2Bbuerotisch.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Über Preyer\",\n            \"topic\": \"Über Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Über Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Karriere\",\n      \"sorting\": 4,\n      \"type\": \"cards\",\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:18:29\n    at Generator.next (<anonymous>)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:8:71\n    at new Promise (<anonymous>)\n    at Object.<anonymous>.__awaiter (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:4:12)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:14:41)\n    at Object.asyncJestTest (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:106:37)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:45:12\n    at new Promise (<anonymous>)\n    at mapper (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:28:19)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:75:41\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3552827,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552822,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552899,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552893,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552889,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552919,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552883,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552879,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552873,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552869,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552863,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552856,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552852,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552847,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552842,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729255,
                                    "isTestReportAvailable": true,
                                    "duration": 174,
                                    "duration_inMinutes": 2.9,
                                    "created_at": "Mar-14-22",
                                    "created_at_rawDateFormat": "2022-03-14T07:05:06.902Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 491204850,
                                "gitlabId": 491204850,
                                "status": "success",
                                "testReport": {
                                    "id": 46695,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.16,
                                    "test_suites": [
                                        {
                                            "id": 54035,
                                            "total_time": 0.16,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3554508,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554533,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554527,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554543,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554523,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554517,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554514,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554537,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554504,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554498,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554494,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554488,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.04,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554547,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554552,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554557,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554562,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554567,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554572,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554577,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554597,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554601,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554607,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554582,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554587,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554592,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729256,
                                    "isTestReportAvailable": true,
                                    "duration": 199,
                                    "duration_inMinutes": 3.32,
                                    "created_at": "Mar-14-22",
                                    "created_at_rawDateFormat": "2022-03-14T07:05:07.081Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 490034869,
                                "gitlabId": 490034869,
                                "status": "success",
                                "testReport": {
                                    "id": 46697,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.17,
                                    "test_suites": [
                                        {
                                            "id": 54036,
                                            "total_time": 0.17,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3554053,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553980,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553985,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554005,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554001,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553995,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553991,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553957,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553961,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554023,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554011,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553966,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553970,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554028,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554038,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554033,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553976,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554043,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553937,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.02,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553934,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.04,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554017,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553942,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553947,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553952,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554048,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729258,
                                    "isTestReportAvailable": true,
                                    "duration": 139,
                                    "duration_inMinutes": 2.32,
                                    "created_at": "Mar-11-22",
                                    "created_at_rawDateFormat": "2022-03-11T07:05:07.230Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 489747506,
                                "gitlabId": 489747506,
                                "status": "success",
                                "testReport": {
                                    "id": 46699,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.09,
                                    "test_suites": [
                                        {
                                            "id": 54037,
                                            "total_time": 0.09,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3553478,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553488,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553493,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553497,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553503,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553509,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553512,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553518,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553522,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553528,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553532,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553538,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553542,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553547,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553551,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553557,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553561,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553567,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553571,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553577,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553581,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553587,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553484,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553468,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553474,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729260,
                                    "isTestReportAvailable": true,
                                    "duration": 104,
                                    "duration_inMinutes": 1.73,
                                    "created_at": "Mar-11-22",
                                    "created_at_rawDateFormat": "2022-03-11T07:05:07.418Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 489741251,
                                "gitlabId": 489741251,
                                "status": "success",
                                "testReport": {
                                    "id": 46696,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.1,
                                    "test_suites": [
                                        {
                                            "id": 54038,
                                            "total_time": 0.1,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3552908,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552902,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552898,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552824,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552829,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552834,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552839,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552814,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552844,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552849,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552854,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552819,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552859,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552862,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552868,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552872,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552809,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552804,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552799,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552794,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552892,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552878,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552888,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552882,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552912,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729261,
                                    "isTestReportAvailable": true,
                                    "duration": 106,
                                    "duration_inMinutes": 1.77,
                                    "created_at": "Mar-11-22",
                                    "created_at_rawDateFormat": "2022-03-11T07:05:07.489Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 489731428,
                                "gitlabId": 489731428,
                                "status": "success",
                                "testReport": {
                                    "id": 46701,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.15,
                                    "test_suites": [
                                        {
                                            "id": 54041,
                                            "total_time": 0.15,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3558507,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558398,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558408,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558418,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558428,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558437,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558447,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558457,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558467,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558477,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558517,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558625,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558615,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558605,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558596,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558587,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558577,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558567,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558557,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558547,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558537,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558527,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558487,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558497,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558388,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729262,
                                    "isTestReportAvailable": true,
                                    "duration": 121,
                                    "duration_inMinutes": 2.02,
                                    "created_at": "Mar-11-22",
                                    "created_at_rawDateFormat": "2022-03-11T07:05:07.495Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 489299297,
                                "gitlabId": 489299297,
                                "status": "failed",
                                "testReport": {
                                    "id": 46700,
                                    "error_count": 0,
                                    "failed_count": 2,
                                    "skipped_count": 0,
                                    "success_count": 23,
                                    "total_count": 25,
                                    "total_time": 0.22,
                                    "test_suites": [
                                        {
                                            "id": 54039,
                                            "total_time": 0.22,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 2,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 23,
                                            "test_cases": [
                                                {
                                                    "id": 3554565,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554635,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554629,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554625,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554619,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554615,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554609,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554605,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554599,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554595,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554589,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554585,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554579,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554575,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554569,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554559,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554555,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554549,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554545,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554539,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554535,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554529,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554525,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554520,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "failed",
                                                    "system_output": "Error: Failed: \"token is invalid\"\n    at Env.it (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:95:24)\n    at it (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmine/jasmineLight.js:100:21)\n    at Suite.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:27:5)\n    at addSpecsToSuite (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmine/Env.js:444:51)\n    at Env.describe (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmine/Env.js:414:11)\n    at describe (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmine/jasmineLight.js:88:18)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:6:1)\n    at Runtime._execModule (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-runtime/build/index.js:1299:24)\n    at Runtime._loadModule (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-runtime/build/index.js:898:12)\n    at Runtime.requireModule (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-runtime/build/index.js:746:10)"
                                                },
                                                {
                                                    "id": 3554516,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.11,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "failed",
                                                    "system_output": "Error: Failed: \"token is invalid\"\n    at Env.it (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:95:24)\n    at it (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmine/jasmineLight.js:100:21)\n    at Suite.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:15:5)\n    at addSpecsToSuite (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmine/Env.js:444:51)\n    at Env.describe (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmine/Env.js:414:11)\n    at describe (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmine/jasmineLight.js:88:18)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:6:1)\n    at Runtime._execModule (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-runtime/build/index.js:1299:24)\n    at Runtime._loadModule (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-runtime/build/index.js:898:12)\n    at Runtime.requireModule (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-runtime/build/index.js:746:10)"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729299,
                                    "isTestReportAvailable": true,
                                    "duration": 105,
                                    "duration_inMinutes": 1.75,
                                    "created_at": "Mar-10-22",
                                    "created_at_rawDateFormat": "2022-03-10T07:05:12.425Z",
                                    "testCoverage": 90.65
                                }
                            },
                            {
                                "id": 489274246,
                                "gitlabId": 489274246,
                                "status": "success",
                                "testReport": {
                                    "id": 46702,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.1,
                                    "test_suites": [
                                        {
                                            "id": 54040,
                                            "total_time": 0.1,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3553963,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553968,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553973,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553978,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553984,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553986,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553992,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553996,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554002,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554006,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554012,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554015,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554021,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554025,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554031,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553940,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553945,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553949,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553954,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554035,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554041,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554045,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554051,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554055,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553959,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729286,
                                    "isTestReportAvailable": true,
                                    "duration": 134,
                                    "duration_inMinutes": 2.23,
                                    "created_at": "Mar-10-22",
                                    "created_at_rawDateFormat": "2022-03-10T07:05:11.226Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 485843995,
                                "gitlabId": 485843995,
                                "status": "success",
                                "testReport": {
                                    "id": 46704,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.11,
                                    "test_suites": [
                                        {
                                            "id": 54043,
                                            "total_time": 0.11,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3554781,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554871,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554745,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554755,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554761,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554767,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554771,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554777,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554787,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554791,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554797,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554801,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554807,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554811,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554817,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554821,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554827,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554831,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554837,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554841,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554847,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554851,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554857,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554861,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554867,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729263,
                                    "isTestReportAvailable": true,
                                    "duration": 128,
                                    "duration_inMinutes": 2.13,
                                    "created_at": "Mar-07-22",
                                    "created_at_rawDateFormat": "2022-03-07T07:05:07.747Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 455568133,
                                "gitlabId": 455568133,
                                "status": "success",
                                "testReport": {
                                    "id": 46705,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.1,
                                    "test_suites": [
                                        {
                                            "id": 54042,
                                            "total_time": 0.1,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3553590,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553521,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553527,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553531,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553537,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553507,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553501,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553500,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553491,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553481,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553541,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553546,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553550,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553556,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553560,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553566,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553570,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553576,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553580,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553586,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553517,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553596,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553599,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553605,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553511,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729264,
                                    "isTestReportAvailable": true,
                                    "duration": 135,
                                    "duration_inMinutes": 2.25,
                                    "created_at": "Jan-25-22",
                                    "created_at_rawDateFormat": "2022-01-25T07:05:07.775Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 444764675,
                                "gitlabId": 444764675,
                                "status": "failed",
                                "testReport": {
                                    "id": 46709,
                                    "error_count": 0,
                                    "failed_count": 3,
                                    "skipped_count": 0,
                                    "success_count": 22,
                                    "total_count": 25,
                                    "total_time": 0.31,
                                    "test_suites": [
                                        {
                                            "id": 54044,
                                            "total_time": 0.31,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 3,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 22,
                                            "test_cases": [
                                                {
                                                    "id": 3552965,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552960,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552954,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552806,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.11,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(received).toEqual(expected) // deep equality\n\n- Expected  -  70\n+ Received  + 707\n\n@@ -1,571 +1,1208 @@\n  Array [\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Page Subtitle\",\n+       \"text\": undefined,\n        \"title\": \"Page Title\",\n        \"topic\": \"Blog\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 1\",\n+           \"text\": undefined,\n            \"title\": \"Title 1\",\n            \"topic\": \"Blog 1\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Blog 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Blog 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 4\",\n+           \"text\": undefined,\n            \"title\": \"Title 4\",\n            \"topic\": \"Blog 4\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 4\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 5\",\n+           \"text\": undefined,\n            \"title\": \"Title 5\",\n            \"topic\": \"Blog 5\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 5\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 6\",\n+           \"text\": undefined,\n            \"title\": \"Title 6\",\n            \"topic\": \"Blog 6\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 6\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Blog\",\n+     \"sorting\": undefined,\n+     \"type\": undefined,\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"subTitle News\",\n+       \"text\": undefined,\n        \"title\": \"Title News\",\n        \"topic\": \"News\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": undefined,\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n+           \"lead\": undefined,\n+           \"linkText\": undefined,\n+           \"subTitle\": undefined,\n+           \"text\": undefined,\n+           \"title\": undefined,\n+           \"topic\": undefined,\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"Title 1\",\n-           \"topic\": \"Item 1\",\n+               \"topic\": \"Hallo \",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n-         \"level\": \"Level2Topic\",\n+             \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n+             \"slug\": \"Hallo \",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n+           },\n+         ],\n          \"slug\": \"Item 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Item 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Item 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"News\",\n      \"sorting\": 1,\n      \"type\": \"carousel\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n+       \"lead\": undefined,\n+       \"linkText\": undefined,\n        \"subTitle\": \"Was wir für Sie tun können.\",\n+       \"text\": undefined,\n        \"title\": \"Yes we can\",\n        \"topic\": \"Expertise\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5210d5bebbe_123%20programmer%20looking%20at%20data%20screens%201600x390.jpg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b536455bec37_simcorp_normal.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Ex 1\",\n            \"topic\": \"Branche/Kunden\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n+               \"lead\": undefined,\n+               \"linkText\": undefined,\n+               \"subTitle\": undefined,\n+               \"text\": undefined,\n+               \"title\": undefined,\n+               \"topic\": undefined,\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 1\",\n                    \"topic\": \"Topic 1\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 1\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 2\",\n                    \"topic\": \"Topic 2\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 2\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 3\",\n                    \"topic\": \"Topic 3\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 3\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n              ],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 2\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 3\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Branche/Kunden\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b52fbd5bebc1_AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b50ade5beba9_ico_SystemConsulting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Lösungen/Services\",\n            \"topic\": \"Lösungen/Services\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Lösungen/Services\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f21f5bebc2_AdobeStock_302181481_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a77c5beba2_ico_Tools_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Das Preyer Team\",\n            \"topic\": \"Das Preyer Team\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Das Preyer Team\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0fa5bebc9_AdobeStock_312736469_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b540875beb9e_ico_Reporting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Schulungen\",\n            \"topic\": \"Schulungen\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"SFTR Webinar\",\n                \"topic\": \"topic 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 2\",\n+               \"text\": undefined,\n                \"title\": \"Course 1\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 3\",\n+               \"text\": undefined,\n                \"title\": \"Course 2\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Schulungen\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Expertise\",\n      \"sorting\": 2,\n      \"type\": \"cards\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n        \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+       \"imageMobile\": undefined,\n        \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n        \"lead\": \"Preyer ist eine Strategie- und IT-Beratung für Finanzunternehmen mit Fokus auf Prozessberatung und IT-Systemlösungen. Wir überprüfen vorhandene IT-Architekturen und implementieren neue Lösungen nur dort, wo es notwendig ist. (mehr…)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Wachstum durch digitale Neuausrichtung.\",\n+       \"text\": undefined,\n        \"title\": \"Connecting Business with IT.\",\n        \"topic\": \"Unternehmen\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Verschärfte Vorgaben der Aufsichtsbehörden, niedrige Zinsen, disruptive Wettbewerber, neue Technologien und massiver Margendruck revolutionieren die Geschäftsmodelle von Banken, Vermögensverwaltern, Fondsgesellschaften, Asset Managern und anderen Finanzdienstleistern. \n  Die dadurch entstehenden strategischen Herausforderungen erfordern mutige Entscheidungen und schnelle Umsetzung. Gleiches gilt für die Einführung effektiver Prozesse und differenzierter Reportings. \n  Das Modernisieren von Geschäftsprozessen und das Implementieren innovativer Systemarchitekturen gehören in der Finanzbranche zu den größten Herausforderungen auf der Reise in eine hochdigitalisierte Welt. \n  Ob Finanz- und Risikomanagement im Treasury, Wertpapierhandel, Fondsbuchhaltung oder die Gesamtbanksteuerung: Das Optimieren von Geschäftsprozessen oder deren Neuausrichtung sind unverzichtbar für die Zukunftsfähigkeit der Finanzindustrie. \n  Innovative Systemarchitekturen sowie transformierte Prozesse und Geschäftsmodelle sind die zentralen Schlüssel für Wettbewerbsfähigkeit und künftiges Wachstum der Branche.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Banken und Finanzinstitute befinden sich an einem Wendepunkt. Nur Unternehmen, die heute ihre digitale Transformation vorantreiben und ihre Systeme modernisieren, stellen die Weichen für eine erfolgreiche Zukunft. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Ineffizienzen sind nicht länger tragbar. \",\n+           \"text\": undefined,\n            \"title\": \"Die Finanzwelt verändert sich.\",\n            \"topic\": \"Markt\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Markt\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Preyer bietet ganzheitliche Fach- und Systemberatung für Banken, Investmentgesellschaften, Versicherungen, Sparkassen und die Öffentliche Hand. \n  Stabile IT-Landschaften und effektive Systemarchitekturen verkörpern die neue Grundausstattung, wenn es um Themen wie Regulierung, Datensicherheit, Automatisierung, neue Wettbewerber oder erhöhten Kostendruck geht. \n  Gemeinsam gehen wir jedem Kundenanliegen auf den Grund und entwickeln schlagkräftige, effiziente IT-Lösungen für unterschiedlichste Projekte und Anforderungen. Pragmatisch, schnell und effektiv. Dabei bilden unsere Expertenteams die Kommunikationsbrücke zwischen den Fachbereichen und der IT. \n  Unsere Kunden profitieren von unserem ganzheitlichen Blick auf die fachlichen Anforderungen ihrer Digitalisierungs- und IT-Projekte, unserer langjährigen Praxiserfahrung als Fach- und Systemberatung im Finanzbereich und dem technologischen Know-how unserer Kompetenz-Teams. \n  Unser Ziel: Schlanke, effiziente und passgenaue Anwendungen und Prozesse, die schnell, digital und zukunftsfähig sind. Deshalb gehen wir bei jedem Projekt inhaltlich in die Tiefe und liefern Statusanalysen, Konzeption und Umsetzung aus einer Hand.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Preyer arbeitet seit Jahren erfolgreich an der technologischen Zukunftsfähigkeit von Finanzunternehmen. Gemeinsam mit unseren Kunden schaffen wir Grundlagen für digitale Geschäftsanwendungen und effiziente IT-Systemlösungen. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Fach- und Systemberatung mit echtem Mehrwert.\",\n+           \"text\": undefined,\n            \"title\": \"IT-Herausforderungen lösen.\",\n            \"topic\": \"Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n+       },\n+       Object {\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+           \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"linkText\": undefined,\n+           \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+           \"text\": undefined,\n+           \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+           \"topic\": \"Referenzen\",\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n+             \"content\": Object {\n+               \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+               \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+               \"linkText\": undefined,\n+               \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+               \"text\": undefined,\n+               \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+               \"topic\": \"Referenzen-Section\",\n+             },\n+             \"isContentOnly\": true,\n+             \"isPrimeTopic\": false,\n+             \"level\": \"Level3Topic\",\n+             \"sections\": Array [\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Addiko-Bank_Ulrich_Kissing.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Addiko-Bank_color.svg\",\n+                   \"lead\": \"Im Rahmen der Privatisierung der Hypo Group Alpe Adria, jetzt Addiko Bank AG, wurde Preyer beauragt, die eingesetzten Methoden und Konzepte im Bereich Marktpreisrisiko zu analysieren und deren Angemessenheit im Hinblick auf das neue Geschäsmodell zu validieren. Weiterer Schwerpunkt bildete die Überprüfung des Transferpricings zwischen der Holding und den Ausländischen Tochtergesellschaen. Wir beauragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen. Diese Expertise war auch vor dem Hintergrund des sehr ambitionierten Zeitplanes eine zwingende Voraussetzung. Die Ergebnisse der Untersuchung und die empfohlenen Maßnahmen werden nun in unseren kurz- und mittelfristigen Aktionsplan einfließen.\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der Addiko Bank AG\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Addiko-Bank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Addiko-Bank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"SparkassenFinanzgruppe_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Sparkassen Finanzgruppe\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Sparkassen Finanzgruppe\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": undefined,\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"DekaBank_kowallik_spk.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"DekaBank_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.<a href=\\\"https://www.deka.com/\\\">www.deka.com</a>\",\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"DekaBank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"DekaBank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"EdmondDeRothschild_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Edmond De Rothschild\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Edmond De Rothschild\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": undefined,\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Bayern-LB_Matthias_Fischer.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"BayernLB_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.<a href=\\\"https://www.deka.com/\\\">www.deka.com</a>\",\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Bayern LB\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Bayern LB\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n                    },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"MEAG_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"MEAG\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"MEAG\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": undefined,\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Natixis_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.<a href=\\\"https://www.deka.com/\\\">www.deka.com</a>\",\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Natixis\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Natixis\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n              ],\n+             \"slug\": \"Referenzen-Section\",\n+             \"sorting\": 1,\n+             \"type\": \"accordion\",\n+           },\n+         ],\n+         \"slug\": \"Referenzen\",\n+         \"sorting\": 1,\n+         \"type\": undefined,\n+       },\n+     ],\n      \"slug\": \"Unternehmen\",\n      \"sorting\": 3,\n      \"type\": \"textLeftImageRight\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Work for us, you know it makes sense\",\n+       \"text\": undefined,\n        \"title\": \"Yes You Can\",\n        \"topic\": \"Karriere\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f9535bebd2_064406_150708_5170.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Karriere bei Preyer\",\n            \"topic\": \"Karriere bei Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Senior Blah\",\n                \"topic\": \"Job 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Junior Blah\",\n                \"topic\": \"Job 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"workstudent\",\n+               \"text\": undefined,\n                \"title\": \"Slave\",\n                \"topic\": \"Job 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Karriere bei Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0d95bebca_vega%2Bbuerotisch.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Über Preyer\",\n            \"topic\": \"Über Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Über Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Karriere\",\n      \"sorting\": 4,\n      \"type\": \"cards\",\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:18:29\n    at Generator.next (<anonymous>)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:8:71\n    at new Promise (<anonymous>)\n    at Object.<anonymous>.__awaiter (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:4:12)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:14:41)\n    at Object.asyncJestTest (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:106:37)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:45:12\n    at new Promise (<anonymous>)\n    at mapper (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:28:19)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:75:41\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3552937,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552986,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552944,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552845,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552835,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.04,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552825,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:32:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3552815,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:19:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3552981,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552976,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552971,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552905,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552915,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552855,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552950,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552865,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.02,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552875,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552885,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552895,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552991,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552925,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552934,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729265,
                                    "isTestReportAvailable": true,
                                    "duration": 270,
                                    "duration_inMinutes": 4.5,
                                    "created_at": "Jan-10-22",
                                    "created_at_rawDateFormat": "2022-01-10T07:05:08.022Z",
                                    "testCoverage": 94.5
                                }
                            },
                            {
                                "id": 434273033,
                                "gitlabId": 434273033,
                                "status": "failed",
                                "testReport": {
                                    "id": 46706,
                                    "error_count": 0,
                                    "failed_count": 3,
                                    "skipped_count": 0,
                                    "success_count": 22,
                                    "total_count": 25,
                                    "total_time": 0.14,
                                    "test_suites": [
                                        {
                                            "id": 54045,
                                            "total_time": 0.14,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 3,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 22,
                                            "test_cases": [
                                                {
                                                    "id": 3554566,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554518,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.04,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(received).toEqual(expected) // deep equality\n\n- Expected  -  70\n+ Received  + 707\n\n@@ -1,571 +1,1208 @@\n  Array [\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Page Subtitle\",\n+       \"text\": undefined,\n        \"title\": \"Page Title\",\n        \"topic\": \"Blog\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 1\",\n+           \"text\": undefined,\n            \"title\": \"Title 1\",\n            \"topic\": \"Blog 1\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Blog 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Blog 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 4\",\n+           \"text\": undefined,\n            \"title\": \"Title 4\",\n            \"topic\": \"Blog 4\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 4\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 5\",\n+           \"text\": undefined,\n            \"title\": \"Title 5\",\n            \"topic\": \"Blog 5\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 5\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 6\",\n+           \"text\": undefined,\n            \"title\": \"Title 6\",\n            \"topic\": \"Blog 6\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 6\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Blog\",\n+     \"sorting\": undefined,\n+     \"type\": undefined,\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"subTitle News\",\n+       \"text\": undefined,\n        \"title\": \"Title News\",\n        \"topic\": \"News\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": undefined,\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n+           \"lead\": undefined,\n+           \"linkText\": undefined,\n+           \"subTitle\": undefined,\n+           \"text\": undefined,\n+           \"title\": undefined,\n+           \"topic\": undefined,\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"Title 1\",\n-           \"topic\": \"Item 1\",\n+               \"topic\": \"Hallo \",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n-         \"level\": \"Level2Topic\",\n+             \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n+             \"slug\": \"Hallo \",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n+           },\n+         ],\n          \"slug\": \"Item 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Item 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Item 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"News\",\n      \"sorting\": 1,\n      \"type\": \"carousel\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n+       \"lead\": undefined,\n+       \"linkText\": undefined,\n        \"subTitle\": \"Was wir für Sie tun können.\",\n+       \"text\": undefined,\n        \"title\": \"Yes we can\",\n        \"topic\": \"Expertise\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5210d5bebbe_123%20programmer%20looking%20at%20data%20screens%201600x390.jpg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b536455bec37_simcorp_normal.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Ex 1\",\n            \"topic\": \"Branche/Kunden\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n+               \"lead\": undefined,\n+               \"linkText\": undefined,\n+               \"subTitle\": undefined,\n+               \"text\": undefined,\n+               \"title\": undefined,\n+               \"topic\": undefined,\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 1\",\n                    \"topic\": \"Topic 1\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 1\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 2\",\n                    \"topic\": \"Topic 2\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 2\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 3\",\n                    \"topic\": \"Topic 3\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 3\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n              ],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 2\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 3\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Branche/Kunden\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b52fbd5bebc1_AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b50ade5beba9_ico_SystemConsulting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Lösungen/Services\",\n            \"topic\": \"Lösungen/Services\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Lösungen/Services\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f21f5bebc2_AdobeStock_302181481_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a77c5beba2_ico_Tools_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Das Preyer Team\",\n            \"topic\": \"Das Preyer Team\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Das Preyer Team\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0fa5bebc9_AdobeStock_312736469_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b540875beb9e_ico_Reporting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Schulungen\",\n            \"topic\": \"Schulungen\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"SFTR Webinar\",\n                \"topic\": \"topic 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 2\",\n+               \"text\": undefined,\n                \"title\": \"Course 1\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 3\",\n+               \"text\": undefined,\n                \"title\": \"Course 2\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Schulungen\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Expertise\",\n      \"sorting\": 2,\n      \"type\": \"cards\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n        \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+       \"imageMobile\": undefined,\n        \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n        \"lead\": \"Preyer ist eine Strategie- und IT-Beratung für Finanzunternehmen mit Fokus auf Prozessberatung und IT-Systemlösungen. Wir überprüfen vorhandene IT-Architekturen und implementieren neue Lösungen nur dort, wo es notwendig ist. (mehr…)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Wachstum durch digitale Neuausrichtung.\",\n+       \"text\": undefined,\n        \"title\": \"Connecting Business with IT.\",\n        \"topic\": \"Unternehmen\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Verschärfte Vorgaben der Aufsichtsbehörden, niedrige Zinsen, disruptive Wettbewerber, neue Technologien und massiver Margendruck revolutionieren die Geschäftsmodelle von Banken, Vermögensverwaltern, Fondsgesellschaften, Asset Managern und anderen Finanzdienstleistern. \n  Die dadurch entstehenden strategischen Herausforderungen erfordern mutige Entscheidungen und schnelle Umsetzung. Gleiches gilt für die Einführung effektiver Prozesse und differenzierter Reportings. \n  Das Modernisieren von Geschäftsprozessen und das Implementieren innovativer Systemarchitekturen gehören in der Finanzbranche zu den größten Herausforderungen auf der Reise in eine hochdigitalisierte Welt. \n  Ob Finanz- und Risikomanagement im Treasury, Wertpapierhandel, Fondsbuchhaltung oder die Gesamtbanksteuerung: Das Optimieren von Geschäftsprozessen oder deren Neuausrichtung sind unverzichtbar für die Zukunftsfähigkeit der Finanzindustrie. \n  Innovative Systemarchitekturen sowie transformierte Prozesse und Geschäftsmodelle sind die zentralen Schlüssel für Wettbewerbsfähigkeit und künftiges Wachstum der Branche.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Banken und Finanzinstitute befinden sich an einem Wendepunkt. Nur Unternehmen, die heute ihre digitale Transformation vorantreiben und ihre Systeme modernisieren, stellen die Weichen für eine erfolgreiche Zukunft. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Ineffizienzen sind nicht länger tragbar. \",\n+           \"text\": undefined,\n            \"title\": \"Die Finanzwelt verändert sich.\",\n            \"topic\": \"Markt\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Markt\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Preyer bietet ganzheitliche Fach- und Systemberatung für Banken, Investmentgesellschaften, Versicherungen, Sparkassen und die Öffentliche Hand. \n  Stabile IT-Landschaften und effektive Systemarchitekturen verkörpern die neue Grundausstattung, wenn es um Themen wie Regulierung, Datensicherheit, Automatisierung, neue Wettbewerber oder erhöhten Kostendruck geht. \n  Gemeinsam gehen wir jedem Kundenanliegen auf den Grund und entwickeln schlagkräftige, effiziente IT-Lösungen für unterschiedlichste Projekte und Anforderungen. Pragmatisch, schnell und effektiv. Dabei bilden unsere Expertenteams die Kommunikationsbrücke zwischen den Fachbereichen und der IT. \n  Unsere Kunden profitieren von unserem ganzheitlichen Blick auf die fachlichen Anforderungen ihrer Digitalisierungs- und IT-Projekte, unserer langjährigen Praxiserfahrung als Fach- und Systemberatung im Finanzbereich und dem technologischen Know-how unserer Kompetenz-Teams. \n  Unser Ziel: Schlanke, effiziente und passgenaue Anwendungen und Prozesse, die schnell, digital und zukunftsfähig sind. Deshalb gehen wir bei jedem Projekt inhaltlich in die Tiefe und liefern Statusanalysen, Konzeption und Umsetzung aus einer Hand.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Preyer arbeitet seit Jahren erfolgreich an der technologischen Zukunftsfähigkeit von Finanzunternehmen. Gemeinsam mit unseren Kunden schaffen wir Grundlagen für digitale Geschäftsanwendungen und effiziente IT-Systemlösungen. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Fach- und Systemberatung mit echtem Mehrwert.\",\n+           \"text\": undefined,\n            \"title\": \"IT-Herausforderungen lösen.\",\n            \"topic\": \"Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n+       },\n+       Object {\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+           \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"linkText\": undefined,\n+           \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+           \"text\": undefined,\n+           \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+           \"topic\": \"Referenzen\",\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n+             \"content\": Object {\n+               \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+               \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+               \"linkText\": undefined,\n+               \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+               \"text\": undefined,\n+               \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+               \"topic\": \"Referenzen-Section\",\n+             },\n+             \"isContentOnly\": true,\n+             \"isPrimeTopic\": false,\n+             \"level\": \"Level3Topic\",\n+             \"sections\": Array [\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Addiko-Bank_Ulrich_Kissing.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Addiko-Bank_color.svg\",\n+                   \"lead\": \"Im Rahmen der Privatisierung der Hypo Group Alpe Adria, jetzt Addiko Bank AG, wurde Preyer beauragt, die eingesetzten Methoden und Konzepte im Bereich Marktpreisrisiko zu analysieren und deren Angemessenheit im Hinblick auf das neue Geschäsmodell zu validieren. Weiterer Schwerpunkt bildete die Überprüfung des Transferpricings zwischen der Holding und den Ausländischen Tochtergesellschaen. Wir beauragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen. Diese Expertise war auch vor dem Hintergrund des sehr ambitionierten Zeitplanes eine zwingende Voraussetzung. Die Ergebnisse der Untersuchung und die empfohlenen Maßnahmen werden nun in unseren kurz- und mittelfristigen Aktionsplan einfließen.\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der Addiko Bank AG\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Addiko-Bank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Addiko-Bank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"SparkassenFinanzgruppe_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Sparkassen Finanzgruppe\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Sparkassen Finanzgruppe\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": undefined,\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"DekaBank_kowallik_spk.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"DekaBank_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.<a href=\\\"https://www.deka.com/\\\">www.deka.com</a>\",\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"DekaBank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"DekaBank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"EdmondDeRothschild_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Edmond De Rothschild\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Edmond De Rothschild\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": undefined,\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Bayern-LB_Matthias_Fischer.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"BayernLB_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.<a href=\\\"https://www.deka.com/\\\">www.deka.com</a>\",\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Bayern LB\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Bayern LB\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n                    },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"MEAG_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"MEAG\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"MEAG\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": undefined,\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Natixis_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.<a href=\\\"https://www.deka.com/\\\">www.deka.com</a>\",\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Natixis\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Natixis\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n              ],\n+             \"slug\": \"Referenzen-Section\",\n+             \"sorting\": 1,\n+             \"type\": \"accordion\",\n+           },\n+         ],\n+         \"slug\": \"Referenzen\",\n+         \"sorting\": 1,\n+         \"type\": undefined,\n+       },\n+     ],\n      \"slug\": \"Unternehmen\",\n      \"sorting\": 3,\n      \"type\": \"textLeftImageRight\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Work for us, you know it makes sense\",\n+       \"text\": undefined,\n        \"title\": \"Yes You Can\",\n        \"topic\": \"Karriere\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f9535bebd2_064406_150708_5170.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Karriere bei Preyer\",\n            \"topic\": \"Karriere bei Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Senior Blah\",\n                \"topic\": \"Job 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Junior Blah\",\n                \"topic\": \"Job 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"workstudent\",\n+               \"text\": undefined,\n                \"title\": \"Slave\",\n                \"topic\": \"Job 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Karriere bei Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0d95bebca_vega%2Bbuerotisch.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Über Preyer\",\n            \"topic\": \"Über Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Über Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Karriere\",\n      \"sorting\": 4,\n      \"type\": \"cards\",\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:18:29\n    at Generator.next (<anonymous>)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:8:71\n    at new Promise (<anonymous>)\n    at Object.<anonymous>.__awaiter (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:4:12)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:14:41)\n    at Object.asyncJestTest (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:106:37)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:45:12\n    at new Promise (<anonymous>)\n    at mapper (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:28:19)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:75:41\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3554530,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:19:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3554540,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:32:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3554546,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554550,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554556,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554560,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554668,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554674,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554664,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554658,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554654,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554648,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554644,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554634,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554624,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554614,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554604,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554596,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554590,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554586,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554580,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554576,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554570,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729266,
                                    "isTestReportAvailable": true,
                                    "duration": 121,
                                    "duration_inMinutes": 2.02,
                                    "created_at": "Dec-21-21",
                                    "created_at_rawDateFormat": "2021-12-21T07:05:08.035Z",
                                    "testCoverage": 94.5
                                }
                            },
                            {
                                "id": 434261908,
                                "gitlabId": 434261908,
                                "status": "failed",
                                "testReport": {
                                    "id": 46713,
                                    "error_count": 0,
                                    "failed_count": 3,
                                    "skipped_count": 0,
                                    "success_count": 22,
                                    "total_count": 25,
                                    "total_time": 0.14,
                                    "test_suites": [
                                        {
                                            "id": 54046,
                                            "total_time": 0.14,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 3,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 22,
                                            "test_cases": [
                                                {
                                                    "id": 3553990,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554000,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554010,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554020,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554029,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554039,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554182,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554178,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554172,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554169,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554159,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554149,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554139,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554129,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554119,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554109,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554099,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554089,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554079,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554069,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553972,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:19:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3553960,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.04,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(received).toEqual(expected) // deep equality\n\n- Expected  -  70\n+ Received  + 599\n\n@@ -1,571 +1,1100 @@\n  Array [\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Page Subtitle\",\n+       \"text\": undefined,\n        \"title\": \"Page Title\",\n        \"topic\": \"Blog\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 1\",\n+           \"text\": undefined,\n            \"title\": \"Title 1\",\n            \"topic\": \"Blog 1\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Blog 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Blog 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 4\",\n+           \"text\": undefined,\n            \"title\": \"Title 4\",\n            \"topic\": \"Blog 4\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 4\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 5\",\n+           \"text\": undefined,\n            \"title\": \"Title 5\",\n            \"topic\": \"Blog 5\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 5\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 6\",\n+           \"text\": undefined,\n            \"title\": \"Title 6\",\n            \"topic\": \"Blog 6\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 6\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Blog\",\n+     \"sorting\": undefined,\n+     \"type\": undefined,\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"subTitle News\",\n+       \"text\": undefined,\n        \"title\": \"Title News\",\n        \"topic\": \"News\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": undefined,\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n+           \"lead\": undefined,\n+           \"linkText\": undefined,\n+           \"subTitle\": undefined,\n+           \"text\": undefined,\n+           \"title\": undefined,\n+           \"topic\": undefined,\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"Title 1\",\n-           \"topic\": \"Item 1\",\n+               \"topic\": \"Hallo \",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n-         \"level\": \"Level2Topic\",\n+             \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n+             \"slug\": \"Hallo \",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n+           },\n+         ],\n          \"slug\": \"Item 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Item 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Item 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"News\",\n      \"sorting\": 1,\n      \"type\": \"carousel\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n+       \"lead\": undefined,\n+       \"linkText\": undefined,\n        \"subTitle\": \"Was wir für Sie tun können.\",\n+       \"text\": undefined,\n        \"title\": \"Yes we can\",\n        \"topic\": \"Expertise\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5210d5bebbe_123%20programmer%20looking%20at%20data%20screens%201600x390.jpg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b536455bec37_simcorp_normal.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Ex 1\",\n            \"topic\": \"Branche/Kunden\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n+               \"lead\": undefined,\n+               \"linkText\": undefined,\n+               \"subTitle\": undefined,\n+               \"text\": undefined,\n+               \"title\": undefined,\n+               \"topic\": undefined,\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 1\",\n                    \"topic\": \"Topic 1\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 1\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 2\",\n                    \"topic\": \"Topic 2\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 2\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 3\",\n                    \"topic\": \"Topic 3\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 3\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n              ],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 2\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 3\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Branche/Kunden\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b52fbd5bebc1_AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b50ade5beba9_ico_SystemConsulting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Lösungen/Services\",\n            \"topic\": \"Lösungen/Services\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Lösungen/Services\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f21f5bebc2_AdobeStock_302181481_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a77c5beba2_ico_Tools_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Das Preyer Team\",\n            \"topic\": \"Das Preyer Team\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Das Preyer Team\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0fa5bebc9_AdobeStock_312736469_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b540875beb9e_ico_Reporting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Schulungen\",\n            \"topic\": \"Schulungen\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"SFTR Webinar\",\n                \"topic\": \"topic 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 2\",\n+               \"text\": undefined,\n                \"title\": \"Course 1\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 3\",\n+               \"text\": undefined,\n                \"title\": \"Course 2\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Schulungen\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Expertise\",\n      \"sorting\": 2,\n      \"type\": \"cards\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n        \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+       \"imageMobile\": undefined,\n        \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n        \"lead\": \"Preyer ist eine Strategie- und IT-Beratung für Finanzunternehmen mit Fokus auf Prozessberatung und IT-Systemlösungen. Wir überprüfen vorhandene IT-Architekturen und implementieren neue Lösungen nur dort, wo es notwendig ist. (mehr…)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Wachstum durch digitale Neuausrichtung.\",\n+       \"text\": undefined,\n        \"title\": \"Connecting Business with IT.\",\n        \"topic\": \"Unternehmen\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Verschärfte Vorgaben der Aufsichtsbehörden, niedrige Zinsen, disruptive Wettbewerber, neue Technologien und massiver Margendruck revolutionieren die Geschäftsmodelle von Banken, Vermögensverwaltern, Fondsgesellschaften, Asset Managern und anderen Finanzdienstleistern. \n  Die dadurch entstehenden strategischen Herausforderungen erfordern mutige Entscheidungen und schnelle Umsetzung. Gleiches gilt für die Einführung effektiver Prozesse und differenzierter Reportings. \n  Das Modernisieren von Geschäftsprozessen und das Implementieren innovativer Systemarchitekturen gehören in der Finanzbranche zu den größten Herausforderungen auf der Reise in eine hochdigitalisierte Welt. \n  Ob Finanz- und Risikomanagement im Treasury, Wertpapierhandel, Fondsbuchhaltung oder die Gesamtbanksteuerung: Das Optimieren von Geschäftsprozessen oder deren Neuausrichtung sind unverzichtbar für die Zukunftsfähigkeit der Finanzindustrie. \n  Innovative Systemarchitekturen sowie transformierte Prozesse und Geschäftsmodelle sind die zentralen Schlüssel für Wettbewerbsfähigkeit und künftiges Wachstum der Branche.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Banken und Finanzinstitute befinden sich an einem Wendepunkt. Nur Unternehmen, die heute ihre digitale Transformation vorantreiben und ihre Systeme modernisieren, stellen die Weichen für eine erfolgreiche Zukunft. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Ineffizienzen sind nicht länger tragbar. \",\n+           \"text\": undefined,\n            \"title\": \"Die Finanzwelt verändert sich.\",\n            \"topic\": \"Markt\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Markt\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Preyer bietet ganzheitliche Fach- und Systemberatung für Banken, Investmentgesellschaften, Versicherungen, Sparkassen und die Öffentliche Hand. \n  Stabile IT-Landschaften und effektive Systemarchitekturen verkörpern die neue Grundausstattung, wenn es um Themen wie Regulierung, Datensicherheit, Automatisierung, neue Wettbewerber oder erhöhten Kostendruck geht. \n  Gemeinsam gehen wir jedem Kundenanliegen auf den Grund und entwickeln schlagkräftige, effiziente IT-Lösungen für unterschiedlichste Projekte und Anforderungen. Pragmatisch, schnell und effektiv. Dabei bilden unsere Expertenteams die Kommunikationsbrücke zwischen den Fachbereichen und der IT. \n  Unsere Kunden profitieren von unserem ganzheitlichen Blick auf die fachlichen Anforderungen ihrer Digitalisierungs- und IT-Projekte, unserer langjährigen Praxiserfahrung als Fach- und Systemberatung im Finanzbereich und dem technologischen Know-how unserer Kompetenz-Teams. \n  Unser Ziel: Schlanke, effiziente und passgenaue Anwendungen und Prozesse, die schnell, digital und zukunftsfähig sind. Deshalb gehen wir bei jedem Projekt inhaltlich in die Tiefe und liefern Statusanalysen, Konzeption und Umsetzung aus einer Hand.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Preyer arbeitet seit Jahren erfolgreich an der technologischen Zukunftsfähigkeit von Finanzunternehmen. Gemeinsam mit unseren Kunden schaffen wir Grundlagen für digitale Geschäftsanwendungen und effiziente IT-Systemlösungen. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Fach- und Systemberatung mit echtem Mehrwert.\",\n+           \"text\": undefined,\n            \"title\": \"IT-Herausforderungen lösen.\",\n            \"topic\": \"Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n+       },\n+       Object {\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+           \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"linkText\": undefined,\n+           \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+           \"text\": undefined,\n+           \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+           \"topic\": \"Referenzen\",\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n+             \"content\": Object {\n+               \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+               \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+               \"linkText\": undefined,\n+               \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+               \"text\": undefined,\n+               \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+               \"topic\": \"Referenzen-Section\",\n+             },\n+             \"isContentOnly\": true,\n+             \"isPrimeTopic\": false,\n+             \"level\": \"Level3Topic\",\n+             \"sections\": Array [\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Addiko-Bank_Ulrich_Kissing.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Addiko-Bank_color.svg\",\n+                   \"lead\": \"Im Rahmen der Privatisierung der Hypo Group Alpe Adria, jetzt Addiko Bank AG, wurde Preyer beauragt, die eingesetzten Methoden und Konzepte im Bereich Marktpreisrisiko zu analysieren und deren Angemessenheit im Hinblick auf das neue Geschäsmodell zu validieren. Weiterer Schwerpunkt bildete die Überprüfung des Transferpricings zwischen der Holding und den Ausländischen Tochtergesellschaen. Wir beauragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen. Diese Expertise war auch vor dem Hintergrund des sehr ambitionierten Zeitplanes eine zwingende Voraussetzung. Die Ergebnisse der Untersuchung und die empfohlenen Maßnahmen werden nun in unseren kurz- und mittelfristigen Aktionsplan einfließen.\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der Addiko Bank AG\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Addiko-Bank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Addiko-Bank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n                },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"SparkassenFinanzgruppe_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Sparkassen Finanzgruppe\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Sparkassen Finanzgruppe\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": undefined,\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"DekaBank_kowallik_spk.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"DekaBank_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.<a href=\\\"https://www.deka.com/\\\">www.deka.com</a>\",\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"DekaBank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"DekaBank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+             ],\n+             \"slug\": \"Referenzen-Section\",\n+             \"sorting\": 1,\n+             \"type\": \"accordion\",\n+           },\n+         ],\n+         \"slug\": \"Referenzen\",\n+         \"sorting\": 1,\n+         \"type\": undefined,\n+       },\n      ],\n      \"slug\": \"Unternehmen\",\n      \"sorting\": 3,\n      \"type\": \"textLeftImageRight\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Work for us, you know it makes sense\",\n+       \"text\": undefined,\n        \"title\": \"Yes You Can\",\n        \"topic\": \"Karriere\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f9535bebd2_064406_150708_5170.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Karriere bei Preyer\",\n            \"topic\": \"Karriere bei Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Senior Blah\",\n                \"topic\": \"Job 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Junior Blah\",\n                \"topic\": \"Job 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"workstudent\",\n+               \"text\": undefined,\n                \"title\": \"Slave\",\n                \"topic\": \"Job 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Karriere bei Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0d95bebca_vega%2Bbuerotisch.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Über Preyer\",\n            \"topic\": \"Über Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Über Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Karriere\",\n      \"sorting\": 4,\n      \"type\": \"cards\",\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:18:29\n    at Generator.next (<anonymous>)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:8:71\n    at new Promise (<anonymous>)\n    at Object.<anonymous>.__awaiter (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:4:12)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:14:41)\n    at Object.asyncJestTest (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:106:37)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:45:12\n    at new Promise (<anonymous>)\n    at mapper (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:28:19)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:75:41\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3554059,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554049,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553982,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:32:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729267,
                                    "isTestReportAvailable": true,
                                    "duration": 131,
                                    "duration_inMinutes": 2.18,
                                    "created_at": "Dec-21-21",
                                    "created_at_rawDateFormat": "2021-12-21T07:05:08.321Z",
                                    "testCoverage": 94.5
                                }
                            },
                            {
                                "id": 433953211,
                                "gitlabId": 433953211,
                                "status": "failed",
                                "testReport": {
                                    "id": 46707,
                                    "error_count": 0,
                                    "failed_count": 3,
                                    "skipped_count": 0,
                                    "success_count": 22,
                                    "total_count": 25,
                                    "total_time": 0.15,
                                    "test_suites": [
                                        {
                                            "id": 54047,
                                            "total_time": 0.15,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 3,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 22,
                                            "test_cases": [
                                                {
                                                    "id": 3553582,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553578,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553572,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553568,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553562,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553558,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553607,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553504,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:32:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3553552,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553548,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553543,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553539,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553533,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553529,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553523,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553519,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553514,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553510,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.02,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553487,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.04,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(received).toEqual(expected) // deep equality\n\n- Expected  -  70\n+ Received  + 599\n\n@@ -1,571 +1,1100 @@\n  Array [\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Page Subtitle\",\n+       \"text\": undefined,\n        \"title\": \"Page Title\",\n        \"topic\": \"Blog\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 1\",\n+           \"text\": undefined,\n            \"title\": \"Title 1\",\n            \"topic\": \"Blog 1\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Blog 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Blog 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 4\",\n+           \"text\": undefined,\n            \"title\": \"Title 4\",\n            \"topic\": \"Blog 4\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 4\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 5\",\n+           \"text\": undefined,\n            \"title\": \"Title 5\",\n            \"topic\": \"Blog 5\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 5\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 6\",\n+           \"text\": undefined,\n            \"title\": \"Title 6\",\n            \"topic\": \"Blog 6\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 6\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Blog\",\n+     \"sorting\": undefined,\n+     \"type\": undefined,\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"subTitle News\",\n+       \"text\": undefined,\n        \"title\": \"Title News\",\n        \"topic\": \"News\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": undefined,\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n+           \"lead\": undefined,\n+           \"linkText\": undefined,\n+           \"subTitle\": undefined,\n+           \"text\": undefined,\n+           \"title\": undefined,\n+           \"topic\": undefined,\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"Title 1\",\n-           \"topic\": \"Item 1\",\n+               \"topic\": \"Hallo \",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n-         \"level\": \"Level2Topic\",\n+             \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n+             \"slug\": \"Hallo \",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n+           },\n+         ],\n          \"slug\": \"Item 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Item 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Item 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"News\",\n      \"sorting\": 1,\n      \"type\": \"carousel\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n+       \"lead\": undefined,\n+       \"linkText\": undefined,\n        \"subTitle\": \"Was wir für Sie tun können.\",\n+       \"text\": undefined,\n        \"title\": \"Yes we can\",\n        \"topic\": \"Expertise\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5210d5bebbe_123%20programmer%20looking%20at%20data%20screens%201600x390.jpg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b536455bec37_simcorp_normal.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Ex 1\",\n            \"topic\": \"Branche/Kunden\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n+               \"lead\": undefined,\n+               \"linkText\": undefined,\n+               \"subTitle\": undefined,\n+               \"text\": undefined,\n+               \"title\": undefined,\n+               \"topic\": undefined,\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 1\",\n                    \"topic\": \"Topic 1\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 1\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 2\",\n                    \"topic\": \"Topic 2\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 2\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 3\",\n                    \"topic\": \"Topic 3\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 3\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n              ],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 2\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 3\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Branche/Kunden\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b52fbd5bebc1_AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b50ade5beba9_ico_SystemConsulting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Lösungen/Services\",\n            \"topic\": \"Lösungen/Services\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Lösungen/Services\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f21f5bebc2_AdobeStock_302181481_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a77c5beba2_ico_Tools_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Das Preyer Team\",\n            \"topic\": \"Das Preyer Team\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Das Preyer Team\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0fa5bebc9_AdobeStock_312736469_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b540875beb9e_ico_Reporting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Schulungen\",\n            \"topic\": \"Schulungen\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"SFTR Webinar\",\n                \"topic\": \"topic 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 2\",\n+               \"text\": undefined,\n                \"title\": \"Course 1\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 3\",\n+               \"text\": undefined,\n                \"title\": \"Course 2\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Schulungen\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Expertise\",\n      \"sorting\": 2,\n      \"type\": \"cards\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n        \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+       \"imageMobile\": undefined,\n        \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n        \"lead\": \"Preyer ist eine Strategie- und IT-Beratung für Finanzunternehmen mit Fokus auf Prozessberatung und IT-Systemlösungen. Wir überprüfen vorhandene IT-Architekturen und implementieren neue Lösungen nur dort, wo es notwendig ist. (mehr…)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Wachstum durch digitale Neuausrichtung.\",\n+       \"text\": undefined,\n        \"title\": \"Connecting Business with IT.\",\n        \"topic\": \"Unternehmen\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Verschärfte Vorgaben der Aufsichtsbehörden, niedrige Zinsen, disruptive Wettbewerber, neue Technologien und massiver Margendruck revolutionieren die Geschäftsmodelle von Banken, Vermögensverwaltern, Fondsgesellschaften, Asset Managern und anderen Finanzdienstleistern. \n  Die dadurch entstehenden strategischen Herausforderungen erfordern mutige Entscheidungen und schnelle Umsetzung. Gleiches gilt für die Einführung effektiver Prozesse und differenzierter Reportings. \n  Das Modernisieren von Geschäftsprozessen und das Implementieren innovativer Systemarchitekturen gehören in der Finanzbranche zu den größten Herausforderungen auf der Reise in eine hochdigitalisierte Welt. \n  Ob Finanz- und Risikomanagement im Treasury, Wertpapierhandel, Fondsbuchhaltung oder die Gesamtbanksteuerung: Das Optimieren von Geschäftsprozessen oder deren Neuausrichtung sind unverzichtbar für die Zukunftsfähigkeit der Finanzindustrie. \n  Innovative Systemarchitekturen sowie transformierte Prozesse und Geschäftsmodelle sind die zentralen Schlüssel für Wettbewerbsfähigkeit und künftiges Wachstum der Branche.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Banken und Finanzinstitute befinden sich an einem Wendepunkt. Nur Unternehmen, die heute ihre digitale Transformation vorantreiben und ihre Systeme modernisieren, stellen die Weichen für eine erfolgreiche Zukunft. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Ineffizienzen sind nicht länger tragbar. \",\n+           \"text\": undefined,\n            \"title\": \"Die Finanzwelt verändert sich.\",\n            \"topic\": \"Markt\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Markt\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Preyer bietet ganzheitliche Fach- und Systemberatung für Banken, Investmentgesellschaften, Versicherungen, Sparkassen und die Öffentliche Hand. \n  Stabile IT-Landschaften und effektive Systemarchitekturen verkörpern die neue Grundausstattung, wenn es um Themen wie Regulierung, Datensicherheit, Automatisierung, neue Wettbewerber oder erhöhten Kostendruck geht. \n  Gemeinsam gehen wir jedem Kundenanliegen auf den Grund und entwickeln schlagkräftige, effiziente IT-Lösungen für unterschiedlichste Projekte und Anforderungen. Pragmatisch, schnell und effektiv. Dabei bilden unsere Expertenteams die Kommunikationsbrücke zwischen den Fachbereichen und der IT. \n  Unsere Kunden profitieren von unserem ganzheitlichen Blick auf die fachlichen Anforderungen ihrer Digitalisierungs- und IT-Projekte, unserer langjährigen Praxiserfahrung als Fach- und Systemberatung im Finanzbereich und dem technologischen Know-how unserer Kompetenz-Teams. \n  Unser Ziel: Schlanke, effiziente und passgenaue Anwendungen und Prozesse, die schnell, digital und zukunftsfähig sind. Deshalb gehen wir bei jedem Projekt inhaltlich in die Tiefe und liefern Statusanalysen, Konzeption und Umsetzung aus einer Hand.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Preyer arbeitet seit Jahren erfolgreich an der technologischen Zukunftsfähigkeit von Finanzunternehmen. Gemeinsam mit unseren Kunden schaffen wir Grundlagen für digitale Geschäftsanwendungen und effiziente IT-Systemlösungen. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Fach- und Systemberatung mit echtem Mehrwert.\",\n+           \"text\": undefined,\n            \"title\": \"IT-Herausforderungen lösen.\",\n            \"topic\": \"Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n+       },\n+       Object {\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+           \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"linkText\": undefined,\n+           \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+           \"text\": undefined,\n+           \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+           \"topic\": \"Referenzen\",\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n+             \"content\": Object {\n+               \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+               \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+               \"linkText\": undefined,\n+               \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+               \"text\": undefined,\n+               \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+               \"topic\": \"Referenzen-Section\",\n+             },\n+             \"isContentOnly\": true,\n+             \"isPrimeTopic\": false,\n+             \"level\": \"Level3Topic\",\n+             \"sections\": Array [\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Addiko-Bank_Ulrich_Kissing.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Addiko-Bank_color.svg\",\n+                   \"lead\": \"Im Rahmen der Privatisierung der Hypo Group Alpe Adria, jetzt Addiko Bank AG, wurde Preyer beauragt, die eingesetzten Methoden und Konzepte im Bereich Marktpreisrisiko zu analysieren und deren Angemessenheit im Hinblick auf das neue Geschäsmodell zu validieren. Weiterer Schwerpunkt bildete die Überprüfung des Transferpricings zwischen der Holding und den Ausländischen Tochtergesellschaen. Wir beauragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen. Diese Expertise war auch vor dem Hintergrund des sehr ambitionierten Zeitplanes eine zwingende Voraussetzung. Die Ergebnisse der Untersuchung und die empfohlenen Maßnahmen werden nun in unseren kurz- und mittelfristigen Aktionsplan einfließen.\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der Addiko Bank AG\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Addiko-Bank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Addiko-Bank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n                },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"SparkassenFinanzgruppe_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Sparkassen Finanzgruppe\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Sparkassen Finanzgruppe\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": undefined,\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"DekaBank_kowallik_spk.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"DekaBank_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.<a href=\\\"https://www.deka.com/\\\">www.deka.com</a>\",\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"DekaBank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"DekaBank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+             ],\n+             \"slug\": \"Referenzen-Section\",\n+             \"sorting\": 1,\n+             \"type\": \"accordion\",\n+           },\n+         ],\n+         \"slug\": \"Referenzen\",\n+         \"sorting\": 1,\n+         \"type\": undefined,\n+       },\n      ],\n      \"slug\": \"Unternehmen\",\n      \"sorting\": 3,\n      \"type\": \"textLeftImageRight\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Work for us, you know it makes sense\",\n+       \"text\": undefined,\n        \"title\": \"Yes You Can\",\n        \"topic\": \"Karriere\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f9535bebd2_064406_150708_5170.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Karriere bei Preyer\",\n            \"topic\": \"Karriere bei Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Senior Blah\",\n                \"topic\": \"Job 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Junior Blah\",\n                \"topic\": \"Job 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"workstudent\",\n+               \"text\": undefined,\n                \"title\": \"Slave\",\n                \"topic\": \"Job 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Karriere bei Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0d95bebca_vega%2Bbuerotisch.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Über Preyer\",\n            \"topic\": \"Über Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Über Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Karriere\",\n      \"sorting\": 4,\n      \"type\": \"cards\",\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:18:29\n    at Generator.next (<anonymous>)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:8:71\n    at new Promise (<anonymous>)\n    at Object.<anonymous>.__awaiter (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:4:12)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:14:41)\n    at Object.asyncJestTest (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:106:37)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:45:12\n    at new Promise (<anonymous>)\n    at mapper (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:28:19)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:75:41\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3553601,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553598,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553592,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553588,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553611,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553499,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:19:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729300,
                                    "isTestReportAvailable": true,
                                    "duration": 122,
                                    "duration_inMinutes": 2.03,
                                    "created_at": "Dec-21-21",
                                    "created_at_rawDateFormat": "2021-12-21T07:05:12.449Z",
                                    "testCoverage": 94.5
                                }
                            },
                            {
                                "id": 433937812,
                                "gitlabId": 433937812,
                                "status": "failed",
                                "testReport": {
                                    "id": 46708,
                                    "error_count": 0,
                                    "failed_count": 3,
                                    "skipped_count": 0,
                                    "success_count": 22,
                                    "total_count": 25,
                                    "total_time": 0.15,
                                    "test_suites": [
                                        {
                                            "id": 54048,
                                            "total_time": 0.15,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 3,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 22,
                                            "test_cases": [
                                                {
                                                    "id": 3552920,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552924,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552930,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552943,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552949,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552953,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552820,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:19:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3552830,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:32:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3552840,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552810,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.04,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(received).toEqual(expected) // deep equality\n\n- Expected  -  70\n+ Received  + 599\n\n@@ -1,571 +1,1100 @@\n  Array [\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Page Subtitle\",\n+       \"text\": undefined,\n        \"title\": \"Page Title\",\n        \"topic\": \"Blog\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 1\",\n+           \"text\": undefined,\n            \"title\": \"Title 1\",\n            \"topic\": \"Blog 1\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Blog 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Blog 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 4\",\n+           \"text\": undefined,\n            \"title\": \"Title 4\",\n            \"topic\": \"Blog 4\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 4\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 5\",\n+           \"text\": undefined,\n            \"title\": \"Title 5\",\n            \"topic\": \"Blog 5\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 5\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 6\",\n+           \"text\": undefined,\n            \"title\": \"Title 6\",\n            \"topic\": \"Blog 6\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 6\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Blog\",\n+     \"sorting\": undefined,\n+     \"type\": undefined,\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"subTitle News\",\n+       \"text\": undefined,\n        \"title\": \"Title News\",\n        \"topic\": \"News\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": undefined,\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n+           \"lead\": undefined,\n+           \"linkText\": undefined,\n+           \"subTitle\": undefined,\n+           \"text\": undefined,\n+           \"title\": undefined,\n+           \"topic\": undefined,\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"Title 1\",\n-           \"topic\": \"Item 1\",\n+               \"topic\": \"Hallo \",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n-         \"level\": \"Level2Topic\",\n+             \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n+             \"slug\": \"Hallo \",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n+           },\n+         ],\n          \"slug\": \"Item 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Item 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Item 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"News\",\n      \"sorting\": 1,\n      \"type\": \"carousel\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n+       \"lead\": undefined,\n+       \"linkText\": undefined,\n        \"subTitle\": \"Was wir für Sie tun können.\",\n+       \"text\": undefined,\n        \"title\": \"Yes we can\",\n        \"topic\": \"Expertise\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5210d5bebbe_123%20programmer%20looking%20at%20data%20screens%201600x390.jpg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b536455bec37_simcorp_normal.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Ex 1\",\n            \"topic\": \"Branche/Kunden\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n+               \"lead\": undefined,\n+               \"linkText\": undefined,\n+               \"subTitle\": undefined,\n+               \"text\": undefined,\n+               \"title\": undefined,\n+               \"topic\": undefined,\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 1\",\n                    \"topic\": \"Topic 1\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 1\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 2\",\n                    \"topic\": \"Topic 2\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 2\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 3\",\n                    \"topic\": \"Topic 3\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 3\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n              ],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 2\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 3\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Branche/Kunden\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b52fbd5bebc1_AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b50ade5beba9_ico_SystemConsulting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Lösungen/Services\",\n            \"topic\": \"Lösungen/Services\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Lösungen/Services\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f21f5bebc2_AdobeStock_302181481_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a77c5beba2_ico_Tools_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Das Preyer Team\",\n            \"topic\": \"Das Preyer Team\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Das Preyer Team\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0fa5bebc9_AdobeStock_312736469_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b540875beb9e_ico_Reporting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Schulungen\",\n            \"topic\": \"Schulungen\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"SFTR Webinar\",\n                \"topic\": \"topic 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 2\",\n+               \"text\": undefined,\n                \"title\": \"Course 1\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 3\",\n+               \"text\": undefined,\n                \"title\": \"Course 2\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Schulungen\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Expertise\",\n      \"sorting\": 2,\n      \"type\": \"cards\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n        \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+       \"imageMobile\": undefined,\n        \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n        \"lead\": \"Preyer ist eine Strategie- und IT-Beratung für Finanzunternehmen mit Fokus auf Prozessberatung und IT-Systemlösungen. Wir überprüfen vorhandene IT-Architekturen und implementieren neue Lösungen nur dort, wo es notwendig ist. (mehr…)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Wachstum durch digitale Neuausrichtung.\",\n+       \"text\": undefined,\n        \"title\": \"Connecting Business with IT.\",\n        \"topic\": \"Unternehmen\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Verschärfte Vorgaben der Aufsichtsbehörden, niedrige Zinsen, disruptive Wettbewerber, neue Technologien und massiver Margendruck revolutionieren die Geschäftsmodelle von Banken, Vermögensverwaltern, Fondsgesellschaften, Asset Managern und anderen Finanzdienstleistern. \n  Die dadurch entstehenden strategischen Herausforderungen erfordern mutige Entscheidungen und schnelle Umsetzung. Gleiches gilt für die Einführung effektiver Prozesse und differenzierter Reportings. \n  Das Modernisieren von Geschäftsprozessen und das Implementieren innovativer Systemarchitekturen gehören in der Finanzbranche zu den größten Herausforderungen auf der Reise in eine hochdigitalisierte Welt. \n  Ob Finanz- und Risikomanagement im Treasury, Wertpapierhandel, Fondsbuchhaltung oder die Gesamtbanksteuerung: Das Optimieren von Geschäftsprozessen oder deren Neuausrichtung sind unverzichtbar für die Zukunftsfähigkeit der Finanzindustrie. \n  Innovative Systemarchitekturen sowie transformierte Prozesse und Geschäftsmodelle sind die zentralen Schlüssel für Wettbewerbsfähigkeit und künftiges Wachstum der Branche.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Banken und Finanzinstitute befinden sich an einem Wendepunkt. Nur Unternehmen, die heute ihre digitale Transformation vorantreiben und ihre Systeme modernisieren, stellen die Weichen für eine erfolgreiche Zukunft. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Ineffizienzen sind nicht länger tragbar. \",\n+           \"text\": undefined,\n            \"title\": \"Die Finanzwelt verändert sich.\",\n            \"topic\": \"Markt\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Markt\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Preyer bietet ganzheitliche Fach- und Systemberatung für Banken, Investmentgesellschaften, Versicherungen, Sparkassen und die Öffentliche Hand. \n  Stabile IT-Landschaften und effektive Systemarchitekturen verkörpern die neue Grundausstattung, wenn es um Themen wie Regulierung, Datensicherheit, Automatisierung, neue Wettbewerber oder erhöhten Kostendruck geht. \n  Gemeinsam gehen wir jedem Kundenanliegen auf den Grund und entwickeln schlagkräftige, effiziente IT-Lösungen für unterschiedlichste Projekte und Anforderungen. Pragmatisch, schnell und effektiv. Dabei bilden unsere Expertenteams die Kommunikationsbrücke zwischen den Fachbereichen und der IT. \n  Unsere Kunden profitieren von unserem ganzheitlichen Blick auf die fachlichen Anforderungen ihrer Digitalisierungs- und IT-Projekte, unserer langjährigen Praxiserfahrung als Fach- und Systemberatung im Finanzbereich und dem technologischen Know-how unserer Kompetenz-Teams. \n  Unser Ziel: Schlanke, effiziente und passgenaue Anwendungen und Prozesse, die schnell, digital und zukunftsfähig sind. Deshalb gehen wir bei jedem Projekt inhaltlich in die Tiefe und liefern Statusanalysen, Konzeption und Umsetzung aus einer Hand.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Preyer arbeitet seit Jahren erfolgreich an der technologischen Zukunftsfähigkeit von Finanzunternehmen. Gemeinsam mit unseren Kunden schaffen wir Grundlagen für digitale Geschäftsanwendungen und effiziente IT-Systemlösungen. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Fach- und Systemberatung mit echtem Mehrwert.\",\n+           \"text\": undefined,\n            \"title\": \"IT-Herausforderungen lösen.\",\n            \"topic\": \"Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n+       },\n+       Object {\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+           \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"linkText\": undefined,\n+           \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+           \"text\": undefined,\n+           \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+           \"topic\": \"Referenzen\",\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n+             \"content\": Object {\n+               \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+               \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+               \"linkText\": undefined,\n+               \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+               \"text\": undefined,\n+               \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+               \"topic\": \"Referenzen-Section\",\n+             },\n+             \"isContentOnly\": true,\n+             \"isPrimeTopic\": false,\n+             \"level\": \"Level3Topic\",\n+             \"sections\": Array [\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Addiko-Bank_Ulrich_Kissing.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Addiko-Bank_color.svg\",\n+                   \"lead\": \"Im Rahmen der Privatisierung der Hypo Group Alpe Adria, jetzt Addiko Bank AG, wurde Preyer beauragt, die eingesetzten Methoden und Konzepte im Bereich Marktpreisrisiko zu analysieren und deren Angemessenheit im Hinblick auf das neue Geschäsmodell zu validieren. Weiterer Schwerpunkt bildete die Überprüfung des Transferpricings zwischen der Holding und den Ausländischen Tochtergesellschaen. Wir beauragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen. Diese Expertise war auch vor dem Hintergrund des sehr ambitionierten Zeitplanes eine zwingende Voraussetzung. Die Ergebnisse der Untersuchung und die empfohlenen Maßnahmen werden nun in unseren kurz- und mittelfristigen Aktionsplan einfließen.\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der Addiko Bank AG\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Addiko-Bank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Addiko-Bank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n                },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"SparkassenFinanzgruppe_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Sparkassen Finanzgruppe\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Sparkassen Finanzgruppe\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"DekaBank_kowallik_spk.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"DekaBank_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": \"<a href=\\\"https://www.deka.com/\\\">www.deka.com</a>\",\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"DekaBank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"DekaBank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+             ],\n+             \"slug\": \"Referenzen-Section\",\n+             \"sorting\": 1,\n+             \"type\": \"accordion\",\n+           },\n+         ],\n+         \"slug\": \"Referenzen\",\n+         \"sorting\": 1,\n+         \"type\": undefined,\n+       },\n      ],\n      \"slug\": \"Unternehmen\",\n      \"sorting\": 3,\n      \"type\": \"textLeftImageRight\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Work for us, you know it makes sense\",\n+       \"text\": undefined,\n        \"title\": \"Yes You Can\",\n        \"topic\": \"Karriere\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f9535bebd2_064406_150708_5170.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Karriere bei Preyer\",\n            \"topic\": \"Karriere bei Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Senior Blah\",\n                \"topic\": \"Job 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Junior Blah\",\n                \"topic\": \"Job 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"workstudent\",\n+               \"text\": undefined,\n                \"title\": \"Slave\",\n                \"topic\": \"Job 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Karriere bei Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0d95bebca_vega%2Bbuerotisch.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Über Preyer\",\n            \"topic\": \"Über Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Über Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Karriere\",\n      \"sorting\": 4,\n      \"type\": \"cards\",\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:18:29\n    at Generator.next (<anonymous>)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:8:71\n    at new Promise (<anonymous>)\n    at Object.<anonymous>.__awaiter (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:4:12)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:14:41)\n    at Object.asyncJestTest (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:106:37)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:45:12\n    at new Promise (<anonymous>)\n    at mapper (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:28:19)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:75:41\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3552850,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552860,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552864,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552870,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552874,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552880,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552884,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552890,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552894,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552900,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552904,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552940,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552959,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552910,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552914,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729268,
                                    "isTestReportAvailable": true,
                                    "duration": 146,
                                    "duration_inMinutes": 2.43,
                                    "created_at": "Dec-21-21",
                                    "created_at_rawDateFormat": "2021-12-21T07:05:08.585Z",
                                    "testCoverage": 94.5
                                }
                            },
                            {
                                "id": 433434413,
                                "gitlabId": 433434413,
                                "status": "failed",
                                "testReport": {
                                    "id": 46710,
                                    "error_count": 0,
                                    "failed_count": 3,
                                    "skipped_count": 0,
                                    "success_count": 22,
                                    "total_count": 25,
                                    "total_time": 0.14,
                                    "test_suites": [
                                        {
                                            "id": 54051,
                                            "total_time": 0.14,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 3,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 22,
                                            "test_cases": [
                                                {
                                                    "id": 3558472,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558492,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558502,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558512,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558522,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558532,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558542,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558552,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558562,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558572,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558582,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558591,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558597,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558603,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558609,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558613,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558619,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558623,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558629,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558633,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558430,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.04,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(received).toEqual(expected) // deep equality\n\n- Expected  -  70\n+ Received  + 599\n\n@@ -1,571 +1,1100 @@\n  Array [\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Page Subtitle\",\n+       \"text\": undefined,\n        \"title\": \"Page Title\",\n        \"topic\": \"Blog\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 1\",\n+           \"text\": undefined,\n            \"title\": \"Title 1\",\n            \"topic\": \"Blog 1\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Blog 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Blog 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 4\",\n+           \"text\": undefined,\n            \"title\": \"Title 4\",\n            \"topic\": \"Blog 4\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 4\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 5\",\n+           \"text\": undefined,\n            \"title\": \"Title 5\",\n            \"topic\": \"Blog 5\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 5\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 6\",\n+           \"text\": undefined,\n            \"title\": \"Title 6\",\n            \"topic\": \"Blog 6\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 6\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Blog\",\n+     \"sorting\": undefined,\n+     \"type\": undefined,\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"subTitle News\",\n+       \"text\": undefined,\n        \"title\": \"Title News\",\n        \"topic\": \"News\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": undefined,\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n+           \"lead\": undefined,\n+           \"linkText\": undefined,\n+           \"subTitle\": undefined,\n+           \"text\": undefined,\n+           \"title\": undefined,\n+           \"topic\": undefined,\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"Title 1\",\n-           \"topic\": \"Item 1\",\n+               \"topic\": \"Hallo \",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n-         \"level\": \"Level2Topic\",\n+             \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n+             \"slug\": \"Hallo \",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n+           },\n+         ],\n          \"slug\": \"Item 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Item 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Item 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"News\",\n      \"sorting\": 1,\n      \"type\": \"carousel\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n+       \"lead\": undefined,\n+       \"linkText\": undefined,\n        \"subTitle\": \"Was wir für Sie tun können.\",\n+       \"text\": undefined,\n        \"title\": \"Yes we can\",\n        \"topic\": \"Expertise\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5210d5bebbe_123%20programmer%20looking%20at%20data%20screens%201600x390.jpg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b536455bec37_simcorp_normal.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Ex 1\",\n            \"topic\": \"Branche/Kunden\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n+               \"lead\": undefined,\n+               \"linkText\": undefined,\n+               \"subTitle\": undefined,\n+               \"text\": undefined,\n+               \"title\": undefined,\n+               \"topic\": undefined,\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 1\",\n                    \"topic\": \"Topic 1\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 1\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 2\",\n                    \"topic\": \"Topic 2\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 2\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 3\",\n                    \"topic\": \"Topic 3\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 3\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n              ],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 2\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 3\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Branche/Kunden\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b52fbd5bebc1_AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b50ade5beba9_ico_SystemConsulting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Lösungen/Services\",\n            \"topic\": \"Lösungen/Services\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Lösungen/Services\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f21f5bebc2_AdobeStock_302181481_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a77c5beba2_ico_Tools_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Das Preyer Team\",\n            \"topic\": \"Das Preyer Team\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Das Preyer Team\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0fa5bebc9_AdobeStock_312736469_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b540875beb9e_ico_Reporting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Schulungen\",\n            \"topic\": \"Schulungen\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"SFTR Webinar\",\n                \"topic\": \"topic 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 2\",\n+               \"text\": undefined,\n                \"title\": \"Course 1\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 3\",\n+               \"text\": undefined,\n                \"title\": \"Course 2\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Schulungen\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Expertise\",\n      \"sorting\": 2,\n      \"type\": \"cards\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n        \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+       \"imageMobile\": undefined,\n        \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n        \"lead\": \"Preyer ist eine Strategie- und IT-Beratung für Finanzunternehmen mit Fokus auf Prozessberatung und IT-Systemlösungen. Wir überprüfen vorhandene IT-Architekturen und implementieren neue Lösungen nur dort, wo es notwendig ist. (mehr…)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Wachstum durch digitale Neuausrichtung.\",\n+       \"text\": undefined,\n        \"title\": \"Connecting Business with IT.\",\n        \"topic\": \"Unternehmen\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Verschärfte Vorgaben der Aufsichtsbehörden, niedrige Zinsen, disruptive Wettbewerber, neue Technologien und massiver Margendruck revolutionieren die Geschäftsmodelle von Banken, Vermögensverwaltern, Fondsgesellschaften, Asset Managern und anderen Finanzdienstleistern. \n  Die dadurch entstehenden strategischen Herausforderungen erfordern mutige Entscheidungen und schnelle Umsetzung. Gleiches gilt für die Einführung effektiver Prozesse und differenzierter Reportings. \n  Das Modernisieren von Geschäftsprozessen und das Implementieren innovativer Systemarchitekturen gehören in der Finanzbranche zu den größten Herausforderungen auf der Reise in eine hochdigitalisierte Welt. \n  Ob Finanz- und Risikomanagement im Treasury, Wertpapierhandel, Fondsbuchhaltung oder die Gesamtbanksteuerung: Das Optimieren von Geschäftsprozessen oder deren Neuausrichtung sind unverzichtbar für die Zukunftsfähigkeit der Finanzindustrie. \n  Innovative Systemarchitekturen sowie transformierte Prozesse und Geschäftsmodelle sind die zentralen Schlüssel für Wettbewerbsfähigkeit und künftiges Wachstum der Branche.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Banken und Finanzinstitute befinden sich an einem Wendepunkt. Nur Unternehmen, die heute ihre digitale Transformation vorantreiben und ihre Systeme modernisieren, stellen die Weichen für eine erfolgreiche Zukunft. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Ineffizienzen sind nicht länger tragbar. \",\n+           \"text\": undefined,\n            \"title\": \"Die Finanzwelt verändert sich.\",\n            \"topic\": \"Markt\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Markt\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Preyer bietet ganzheitliche Fach- und Systemberatung für Banken, Investmentgesellschaften, Versicherungen, Sparkassen und die Öffentliche Hand. \n  Stabile IT-Landschaften und effektive Systemarchitekturen verkörpern die neue Grundausstattung, wenn es um Themen wie Regulierung, Datensicherheit, Automatisierung, neue Wettbewerber oder erhöhten Kostendruck geht. \n  Gemeinsam gehen wir jedem Kundenanliegen auf den Grund und entwickeln schlagkräftige, effiziente IT-Lösungen für unterschiedlichste Projekte und Anforderungen. Pragmatisch, schnell und effektiv. Dabei bilden unsere Expertenteams die Kommunikationsbrücke zwischen den Fachbereichen und der IT. \n  Unsere Kunden profitieren von unserem ganzheitlichen Blick auf die fachlichen Anforderungen ihrer Digitalisierungs- und IT-Projekte, unserer langjährigen Praxiserfahrung als Fach- und Systemberatung im Finanzbereich und dem technologischen Know-how unserer Kompetenz-Teams. \n  Unser Ziel: Schlanke, effiziente und passgenaue Anwendungen und Prozesse, die schnell, digital und zukunftsfähig sind. Deshalb gehen wir bei jedem Projekt inhaltlich in die Tiefe und liefern Statusanalysen, Konzeption und Umsetzung aus einer Hand.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Preyer arbeitet seit Jahren erfolgreich an der technologischen Zukunftsfähigkeit von Finanzunternehmen. Gemeinsam mit unseren Kunden schaffen wir Grundlagen für digitale Geschäftsanwendungen und effiziente IT-Systemlösungen. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Fach- und Systemberatung mit echtem Mehrwert.\",\n+           \"text\": undefined,\n            \"title\": \"IT-Herausforderungen lösen.\",\n            \"topic\": \"Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n+       },\n+       Object {\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+           \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"linkText\": undefined,\n+           \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+           \"text\": undefined,\n+           \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+           \"topic\": \"Referenzen\",\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n+             \"content\": Object {\n+               \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+               \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+               \"linkText\": undefined,\n+               \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+               \"text\": undefined,\n+               \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+               \"topic\": \"Referenzen-Section\",\n+             },\n+             \"isContentOnly\": true,\n+             \"isPrimeTopic\": false,\n+             \"level\": \"Level3Topic\",\n+             \"sections\": Array [\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Addiko-Bank_Ulrich_Kissing.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Addiko-Bank_color.svg\",\n+                   \"lead\": \"Im Rahmen der Privatisierung der Hypo Group Alpe Adria, jetzt Addiko Bank AG, wurde Preyer beauragt, die eingesetzten Methoden und Konzepte im Bereich Marktpreisrisiko zu analysieren und deren Angemessenheit im Hinblick auf das neue Geschäsmodell zu validieren. Weiterer Schwerpunkt bildete die Überprüfung des Transferpricings zwischen der Holding und den Ausländischen Tochtergesellschaen. Wir beauragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen. Diese Expertise war auch vor dem Hintergrund des sehr ambitionierten Zeitplanes eine zwingende Voraussetzung. Die Ergebnisse der Untersuchung und die empfohlenen Maßnahmen werden nun in unseren kurz- und mittelfristigen Aktionsplan einfließen.\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der Addiko Bank AG\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Addiko-Bank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Addiko-Bank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n                },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"SparkassenFinanzgruppe_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Sparkassen Finanzgruppe\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Sparkassen Finanzgruppe\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"DekaBank_kowallik_spk.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"DekaBank_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"DekaBank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"DekaBank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+             ],\n+             \"slug\": \"Referenzen-Section\",\n+             \"sorting\": 1,\n+             \"type\": \"accordion\",\n+           },\n+         ],\n+         \"slug\": \"Referenzen\",\n+         \"sorting\": 1,\n+         \"type\": undefined,\n+       },\n      ],\n      \"slug\": \"Unternehmen\",\n      \"sorting\": 3,\n      \"type\": \"textLeftImageRight\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Work for us, you know it makes sense\",\n+       \"text\": undefined,\n        \"title\": \"Yes You Can\",\n        \"topic\": \"Karriere\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f9535bebd2_064406_150708_5170.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Karriere bei Preyer\",\n            \"topic\": \"Karriere bei Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Senior Blah\",\n                \"topic\": \"Job 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Junior Blah\",\n                \"topic\": \"Job 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"workstudent\",\n+               \"text\": undefined,\n                \"title\": \"Slave\",\n                \"topic\": \"Job 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Karriere bei Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0d95bebca_vega%2Bbuerotisch.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Über Preyer\",\n            \"topic\": \"Über Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Über Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Karriere\",\n      \"sorting\": 4,\n      \"type\": \"cards\",\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:18:29\n    at Generator.next (<anonymous>)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:8:71\n    at new Promise (<anonymous>)\n    at Object.<anonymous>.__awaiter (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:4:12)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:14:41)\n    at Object.asyncJestTest (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:106:37)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:45:12\n    at new Promise (<anonymous>)\n    at mapper (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:28:19)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:75:41\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3558442,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:19:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3558452,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:32:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3558462,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558482,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729269,
                                    "isTestReportAvailable": true,
                                    "duration": 127,
                                    "duration_inMinutes": 2.12,
                                    "created_at": "Dec-20-21",
                                    "created_at_rawDateFormat": "2021-12-20T07:05:08.854Z",
                                    "testCoverage": 94.5
                                }
                            },
                            {
                                "id": 433415391,
                                "gitlabId": 433415391,
                                "status": "failed",
                                "testReport": {
                                    "id": 46712,
                                    "error_count": 0,
                                    "failed_count": 3,
                                    "skipped_count": 0,
                                    "success_count": 22,
                                    "total_count": 25,
                                    "total_time": 0.14,
                                    "test_suites": [
                                        {
                                            "id": 54049,
                                            "total_time": 0.14,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 3,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 22,
                                            "test_cases": [
                                                {
                                                    "id": 3554692,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554551,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:19:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3554561,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:32:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3554571,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554541,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.04,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(received).toEqual(expected) // deep equality\n\n- Expected  -  70\n+ Received  + 599\n\n@@ -1,571 +1,1100 @@\n  Array [\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Page Subtitle\",\n+       \"text\": undefined,\n        \"title\": \"Page Title\",\n        \"topic\": \"Blog\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 1\",\n+           \"text\": undefined,\n            \"title\": \"Title 1\",\n            \"topic\": \"Blog 1\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Blog 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Blog 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 4\",\n+           \"text\": undefined,\n            \"title\": \"Title 4\",\n            \"topic\": \"Blog 4\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 4\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 5\",\n+           \"text\": undefined,\n            \"title\": \"Title 5\",\n            \"topic\": \"Blog 5\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 5\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 6\",\n+           \"text\": undefined,\n            \"title\": \"Title 6\",\n            \"topic\": \"Blog 6\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 6\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Blog\",\n+     \"sorting\": undefined,\n+     \"type\": undefined,\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"subTitle News\",\n+       \"text\": undefined,\n        \"title\": \"Title News\",\n        \"topic\": \"News\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": undefined,\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n+           \"lead\": undefined,\n+           \"linkText\": undefined,\n+           \"subTitle\": undefined,\n+           \"text\": undefined,\n+           \"title\": undefined,\n+           \"topic\": undefined,\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"Title 1\",\n-           \"topic\": \"Item 1\",\n+               \"topic\": \"Hallo \",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n-         \"level\": \"Level2Topic\",\n+             \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n+             \"slug\": \"Hallo \",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n+           },\n+         ],\n          \"slug\": \"Item 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Item 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Item 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"News\",\n      \"sorting\": 1,\n      \"type\": \"carousel\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n+       \"lead\": undefined,\n+       \"linkText\": undefined,\n        \"subTitle\": \"Was wir für Sie tun können.\",\n+       \"text\": undefined,\n        \"title\": \"Yes we can\",\n        \"topic\": \"Expertise\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5210d5bebbe_123%20programmer%20looking%20at%20data%20screens%201600x390.jpg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b536455bec37_simcorp_normal.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Ex 1\",\n            \"topic\": \"Branche/Kunden\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n+               \"lead\": undefined,\n+               \"linkText\": undefined,\n+               \"subTitle\": undefined,\n+               \"text\": undefined,\n+               \"title\": undefined,\n+               \"topic\": undefined,\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 1\",\n                    \"topic\": \"Topic 1\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 1\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 2\",\n                    \"topic\": \"Topic 2\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 2\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 3\",\n                    \"topic\": \"Topic 3\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 3\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n              ],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 2\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 3\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Branche/Kunden\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b52fbd5bebc1_AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b50ade5beba9_ico_SystemConsulting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Lösungen/Services\",\n            \"topic\": \"Lösungen/Services\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Lösungen/Services\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f21f5bebc2_AdobeStock_302181481_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a77c5beba2_ico_Tools_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Das Preyer Team\",\n            \"topic\": \"Das Preyer Team\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Das Preyer Team\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0fa5bebc9_AdobeStock_312736469_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b540875beb9e_ico_Reporting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Schulungen\",\n            \"topic\": \"Schulungen\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"SFTR Webinar\",\n                \"topic\": \"topic 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 2\",\n+               \"text\": undefined,\n                \"title\": \"Course 1\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 3\",\n+               \"text\": undefined,\n                \"title\": \"Course 2\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Schulungen\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Expertise\",\n      \"sorting\": 2,\n      \"type\": \"cards\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n        \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+       \"imageMobile\": undefined,\n        \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n        \"lead\": \"Preyer ist eine Strategie- und IT-Beratung für Finanzunternehmen mit Fokus auf Prozessberatung und IT-Systemlösungen. Wir überprüfen vorhandene IT-Architekturen und implementieren neue Lösungen nur dort, wo es notwendig ist. (mehr…)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Wachstum durch digitale Neuausrichtung.\",\n+       \"text\": undefined,\n        \"title\": \"Connecting Business with IT.\",\n        \"topic\": \"Unternehmen\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Verschärfte Vorgaben der Aufsichtsbehörden, niedrige Zinsen, disruptive Wettbewerber, neue Technologien und massiver Margendruck revolutionieren die Geschäftsmodelle von Banken, Vermögensverwaltern, Fondsgesellschaften, Asset Managern und anderen Finanzdienstleistern. \n  Die dadurch entstehenden strategischen Herausforderungen erfordern mutige Entscheidungen und schnelle Umsetzung. Gleiches gilt für die Einführung effektiver Prozesse und differenzierter Reportings. \n  Das Modernisieren von Geschäftsprozessen und das Implementieren innovativer Systemarchitekturen gehören in der Finanzbranche zu den größten Herausforderungen auf der Reise in eine hochdigitalisierte Welt. \n  Ob Finanz- und Risikomanagement im Treasury, Wertpapierhandel, Fondsbuchhaltung oder die Gesamtbanksteuerung: Das Optimieren von Geschäftsprozessen oder deren Neuausrichtung sind unverzichtbar für die Zukunftsfähigkeit der Finanzindustrie. \n  Innovative Systemarchitekturen sowie transformierte Prozesse und Geschäftsmodelle sind die zentralen Schlüssel für Wettbewerbsfähigkeit und künftiges Wachstum der Branche.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Banken und Finanzinstitute befinden sich an einem Wendepunkt. Nur Unternehmen, die heute ihre digitale Transformation vorantreiben und ihre Systeme modernisieren, stellen die Weichen für eine erfolgreiche Zukunft. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Ineffizienzen sind nicht länger tragbar. \",\n+           \"text\": undefined,\n            \"title\": \"Die Finanzwelt verändert sich.\",\n            \"topic\": \"Markt\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Markt\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Preyer bietet ganzheitliche Fach- und Systemberatung für Banken, Investmentgesellschaften, Versicherungen, Sparkassen und die Öffentliche Hand. \n  Stabile IT-Landschaften und effektive Systemarchitekturen verkörpern die neue Grundausstattung, wenn es um Themen wie Regulierung, Datensicherheit, Automatisierung, neue Wettbewerber oder erhöhten Kostendruck geht. \n  Gemeinsam gehen wir jedem Kundenanliegen auf den Grund und entwickeln schlagkräftige, effiziente IT-Lösungen für unterschiedlichste Projekte und Anforderungen. Pragmatisch, schnell und effektiv. Dabei bilden unsere Expertenteams die Kommunikationsbrücke zwischen den Fachbereichen und der IT. \n  Unsere Kunden profitieren von unserem ganzheitlichen Blick auf die fachlichen Anforderungen ihrer Digitalisierungs- und IT-Projekte, unserer langjährigen Praxiserfahrung als Fach- und Systemberatung im Finanzbereich und dem technologischen Know-how unserer Kompetenz-Teams. \n  Unser Ziel: Schlanke, effiziente und passgenaue Anwendungen und Prozesse, die schnell, digital und zukunftsfähig sind. Deshalb gehen wir bei jedem Projekt inhaltlich in die Tiefe und liefern Statusanalysen, Konzeption und Umsetzung aus einer Hand.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Preyer arbeitet seit Jahren erfolgreich an der technologischen Zukunftsfähigkeit von Finanzunternehmen. Gemeinsam mit unseren Kunden schaffen wir Grundlagen für digitale Geschäftsanwendungen und effiziente IT-Systemlösungen. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Fach- und Systemberatung mit echtem Mehrwert.\",\n+           \"text\": undefined,\n            \"title\": \"IT-Herausforderungen lösen.\",\n            \"topic\": \"Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n+       },\n+       Object {\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+           \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"linkText\": undefined,\n+           \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+           \"text\": undefined,\n+           \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+           \"topic\": \"Referenzen\",\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n+             \"content\": Object {\n+               \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+               \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+               \"linkText\": undefined,\n+               \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+               \"text\": undefined,\n+               \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+               \"topic\": \"Referenzen-Section\",\n+             },\n+             \"isContentOnly\": true,\n+             \"isPrimeTopic\": false,\n+             \"level\": \"Level3Topic\",\n+             \"sections\": Array [\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Addiko-Bank_Ulrich_Kissing.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Addiko-Bank_color.svg\",\n+                   \"lead\": \"Im Rahmen der Privatisierung der Hypo Group Alpe Adria, jetzt Addiko Bank AG, wurde Preyer beauragt, die eingesetzten Methoden und Konzepte im Bereich Marktpreisrisiko zu analysieren und deren Angemessenheit im Hinblick auf das neue Geschäsmodell zu validieren. Weiterer Schwerpunkt bildete die Überprüfung des Transferpricings zwischen der Holding und den Ausländischen Tochtergesellschaen. Wir beauragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen. Diese Expertise war auch vor dem Hintergrund des sehr ambitionierten Zeitplanes eine zwingende Voraussetzung. Die Ergebnisse der Untersuchung und die empfohlenen Maßnahmen werden nun in unseren kurz- und mittelfristigen Aktionsplan einfließen.\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der Addiko Bank AG\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Addiko-Bank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Addiko-Bank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n                },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"SparkassenFinanzgruppe_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Sparkassen Finanzgruppe\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Sparkassen Finanzgruppe\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"DekaBank_kowallik_spk.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"DekaBank_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"DekaBank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"DekaBank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+             ],\n+             \"slug\": \"Referenzen-Section\",\n+             \"sorting\": 1,\n+             \"type\": \"accordion\",\n+           },\n+         ],\n+         \"slug\": \"Referenzen\",\n+         \"sorting\": 1,\n+         \"type\": undefined,\n+       },\n      ],\n      \"slug\": \"Unternehmen\",\n      \"sorting\": 3,\n      \"type\": \"textLeftImageRight\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Work for us, you know it makes sense\",\n+       \"text\": undefined,\n        \"title\": \"Yes You Can\",\n        \"topic\": \"Karriere\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f9535bebd2_064406_150708_5170.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Karriere bei Preyer\",\n            \"topic\": \"Karriere bei Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Senior Blah\",\n                \"topic\": \"Job 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Junior Blah\",\n                \"topic\": \"Job 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"workstudent\",\n+               \"text\": undefined,\n                \"title\": \"Slave\",\n                \"topic\": \"Job 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Karriere bei Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0d95bebca_vega%2Bbuerotisch.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Über Preyer\",\n            \"topic\": \"Über Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Über Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Karriere\",\n      \"sorting\": 4,\n      \"type\": \"cards\",\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:18:29\n    at Generator.next (<anonymous>)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:8:71\n    at new Promise (<anonymous>)\n    at Object.<anonymous>.__awaiter (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:4:12)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:14:41)\n    at Object.asyncJestTest (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:106:37)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:45:12\n    at new Promise (<anonymous>)\n    at mapper (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:28:19)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:75:41\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3554581,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554672,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554666,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554662,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554656,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554652,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554646,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554642,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554636,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554630,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554626,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554620,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554616,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554610,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554606,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554600,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554591,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554677,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554682,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554687,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729271,
                                    "isTestReportAvailable": true,
                                    "duration": 130,
                                    "duration_inMinutes": 2.17,
                                    "created_at": "Dec-20-21",
                                    "created_at_rawDateFormat": "2021-12-20T07:05:09.206Z",
                                    "testCoverage": 94.5
                                }
                            },
                            {
                                "id": 433272495,
                                "gitlabId": 433272495,
                                "status": "failed",
                                "testReport": {
                                    "id": 46711,
                                    "error_count": 0,
                                    "failed_count": 3,
                                    "skipped_count": 0,
                                    "success_count": 22,
                                    "total_count": 25,
                                    "total_time": 0.15,
                                    "test_suites": [
                                        {
                                            "id": 54050,
                                            "total_time": 0.15,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 3,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 22,
                                            "test_cases": [
                                                {
                                                    "id": 3554046,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554075,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554081,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554085,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554052,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554056,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554062,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554091,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554101,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554095,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553979,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.04,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(received).toEqual(expected) // deep equality\n\n- Expected  -  70\n+ Received  + 599\n\n@@ -1,571 +1,1100 @@\n  Array [\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Page Subtitle\",\n+       \"text\": undefined,\n        \"title\": \"Page Title\",\n        \"topic\": \"Blog\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 1\",\n+           \"text\": undefined,\n            \"title\": \"Title 1\",\n            \"topic\": \"Blog 1\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Blog 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Blog 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 4\",\n+           \"text\": undefined,\n            \"title\": \"Title 4\",\n            \"topic\": \"Blog 4\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 4\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 5\",\n+           \"text\": undefined,\n            \"title\": \"Title 5\",\n            \"topic\": \"Blog 5\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 5\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 6\",\n+           \"text\": undefined,\n            \"title\": \"Title 6\",\n            \"topic\": \"Blog 6\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 6\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Blog\",\n+     \"sorting\": undefined,\n+     \"type\": undefined,\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"subTitle News\",\n+       \"text\": undefined,\n        \"title\": \"Title News\",\n        \"topic\": \"News\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": undefined,\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n+           \"lead\": undefined,\n+           \"linkText\": undefined,\n+           \"subTitle\": undefined,\n+           \"text\": undefined,\n+           \"title\": undefined,\n+           \"topic\": undefined,\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"Title 1\",\n-           \"topic\": \"Item 1\",\n+               \"topic\": \"Hallo \",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n-         \"level\": \"Level2Topic\",\n+             \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n+             \"slug\": \"Hallo \",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n+           },\n+         ],\n          \"slug\": \"Item 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Item 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Item 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"News\",\n      \"sorting\": 1,\n      \"type\": \"carousel\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n+       \"lead\": undefined,\n+       \"linkText\": undefined,\n        \"subTitle\": \"Was wir für Sie tun können.\",\n+       \"text\": undefined,\n        \"title\": \"Yes we can\",\n        \"topic\": \"Expertise\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5210d5bebbe_123%20programmer%20looking%20at%20data%20screens%201600x390.jpg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b536455bec37_simcorp_normal.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Ex 1\",\n            \"topic\": \"Branche/Kunden\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n+               \"lead\": undefined,\n+               \"linkText\": undefined,\n+               \"subTitle\": undefined,\n+               \"text\": undefined,\n+               \"title\": undefined,\n+               \"topic\": undefined,\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 1\",\n                    \"topic\": \"Topic 1\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 1\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 2\",\n                    \"topic\": \"Topic 2\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 2\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 3\",\n                    \"topic\": \"Topic 3\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 3\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n              ],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 2\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 3\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Branche/Kunden\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b52fbd5bebc1_AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b50ade5beba9_ico_SystemConsulting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Lösungen/Services\",\n            \"topic\": \"Lösungen/Services\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Lösungen/Services\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f21f5bebc2_AdobeStock_302181481_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a77c5beba2_ico_Tools_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Das Preyer Team\",\n            \"topic\": \"Das Preyer Team\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Das Preyer Team\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0fa5bebc9_AdobeStock_312736469_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b540875beb9e_ico_Reporting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Schulungen\",\n            \"topic\": \"Schulungen\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"SFTR Webinar\",\n                \"topic\": \"topic 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 2\",\n+               \"text\": undefined,\n                \"title\": \"Course 1\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 3\",\n+               \"text\": undefined,\n                \"title\": \"Course 2\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Schulungen\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Expertise\",\n      \"sorting\": 2,\n      \"type\": \"cards\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n        \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+       \"imageMobile\": undefined,\n        \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n        \"lead\": \"Preyer ist eine Strategie- und IT-Beratung für Finanzunternehmen mit Fokus auf Prozessberatung und IT-Systemlösungen. Wir überprüfen vorhandene IT-Architekturen und implementieren neue Lösungen nur dort, wo es notwendig ist. (mehr…)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Wachstum durch digitale Neuausrichtung.\",\n+       \"text\": undefined,\n        \"title\": \"Connecting Business with IT.\",\n        \"topic\": \"Unternehmen\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Verschärfte Vorgaben der Aufsichtsbehörden, niedrige Zinsen, disruptive Wettbewerber, neue Technologien und massiver Margendruck revolutionieren die Geschäftsmodelle von Banken, Vermögensverwaltern, Fondsgesellschaften, Asset Managern und anderen Finanzdienstleistern. \n  Die dadurch entstehenden strategischen Herausforderungen erfordern mutige Entscheidungen und schnelle Umsetzung. Gleiches gilt für die Einführung effektiver Prozesse und differenzierter Reportings. \n  Das Modernisieren von Geschäftsprozessen und das Implementieren innovativer Systemarchitekturen gehören in der Finanzbranche zu den größten Herausforderungen auf der Reise in eine hochdigitalisierte Welt. \n  Ob Finanz- und Risikomanagement im Treasury, Wertpapierhandel, Fondsbuchhaltung oder die Gesamtbanksteuerung: Das Optimieren von Geschäftsprozessen oder deren Neuausrichtung sind unverzichtbar für die Zukunftsfähigkeit der Finanzindustrie. \n  Innovative Systemarchitekturen sowie transformierte Prozesse und Geschäftsmodelle sind die zentralen Schlüssel für Wettbewerbsfähigkeit und künftiges Wachstum der Branche.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Banken und Finanzinstitute befinden sich an einem Wendepunkt. Nur Unternehmen, die heute ihre digitale Transformation vorantreiben und ihre Systeme modernisieren, stellen die Weichen für eine erfolgreiche Zukunft. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Ineffizienzen sind nicht länger tragbar. \",\n+           \"text\": undefined,\n            \"title\": \"Die Finanzwelt verändert sich.\",\n            \"topic\": \"Markt\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Markt\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Preyer bietet ganzheitliche Fach- und Systemberatung für Banken, Investmentgesellschaften, Versicherungen, Sparkassen und die Öffentliche Hand. \n  Stabile IT-Landschaften und effektive Systemarchitekturen verkörpern die neue Grundausstattung, wenn es um Themen wie Regulierung, Datensicherheit, Automatisierung, neue Wettbewerber oder erhöhten Kostendruck geht. \n  Gemeinsam gehen wir jedem Kundenanliegen auf den Grund und entwickeln schlagkräftige, effiziente IT-Lösungen für unterschiedlichste Projekte und Anforderungen. Pragmatisch, schnell und effektiv. Dabei bilden unsere Expertenteams die Kommunikationsbrücke zwischen den Fachbereichen und der IT. \n  Unsere Kunden profitieren von unserem ganzheitlichen Blick auf die fachlichen Anforderungen ihrer Digitalisierungs- und IT-Projekte, unserer langjährigen Praxiserfahrung als Fach- und Systemberatung im Finanzbereich und dem technologischen Know-how unserer Kompetenz-Teams. \n  Unser Ziel: Schlanke, effiziente und passgenaue Anwendungen und Prozesse, die schnell, digital und zukunftsfähig sind. Deshalb gehen wir bei jedem Projekt inhaltlich in die Tiefe und liefern Statusanalysen, Konzeption und Umsetzung aus einer Hand.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Preyer arbeitet seit Jahren erfolgreich an der technologischen Zukunftsfähigkeit von Finanzunternehmen. Gemeinsam mit unseren Kunden schaffen wir Grundlagen für digitale Geschäftsanwendungen und effiziente IT-Systemlösungen. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Fach- und Systemberatung mit echtem Mehrwert.\",\n+           \"text\": undefined,\n            \"title\": \"IT-Herausforderungen lösen.\",\n            \"topic\": \"Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n+       },\n+       Object {\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+           \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"linkText\": undefined,\n+           \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+           \"text\": undefined,\n+           \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+           \"topic\": \"Referenzen\",\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n+             \"content\": Object {\n+               \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+               \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+               \"linkText\": undefined,\n+               \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+               \"text\": undefined,\n+               \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+               \"topic\": \"Referenzen-Section\",\n+             },\n+             \"isContentOnly\": true,\n+             \"isPrimeTopic\": false,\n+             \"level\": \"Level3Topic\",\n+             \"sections\": Array [\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Addiko-Bank_Ulrich_Kissing.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Addiko-Bank_color.svg\",\n+                   \"lead\": \"Im Rahmen der Privatisierung der Hypo Group Alpe Adria, jetzt Addiko Bank AG, wurde Preyer beauragt, die eingesetzten Methoden und Konzepte im Bereich Marktpreisrisiko zu analysieren und deren Angemessenheit im Hinblick auf das neue Geschäsmodell zu validieren. Weiterer Schwerpunkt bildete die Überprüfung des Transferpricings zwischen der Holding und den Ausländischen Tochtergesellschaen. Wir beauragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen. Diese Expertise war auch vor dem Hintergrund des sehr ambitionierten Zeitplanes eine zwingende Voraussetzung. Die Ergebnisse der Untersuchung und die empfohlenen Maßnahmen werden nun in unseren kurz- und mittelfristigen Aktionsplan einfließen.\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der Addiko Bank AG\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Addiko-Bank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Addiko-Bank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n                },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"SparkassenFinanzgruppe_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Sparkassen Finanzgruppe\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Sparkassen Finanzgruppe\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"DekaBank_kowallik_spk.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"DekaBank_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"DekaBank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"DekaBank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+             ],\n+             \"slug\": \"Referenzen-Section\",\n+             \"sorting\": 1,\n+             \"type\": \"accordion\",\n+           },\n+         ],\n+         \"slug\": \"Referenzen\",\n+         \"sorting\": 1,\n+         \"type\": undefined,\n+       },\n      ],\n      \"slug\": \"Unternehmen\",\n      \"sorting\": 3,\n      \"type\": \"textLeftImageRight\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Work for us, you know it makes sense\",\n+       \"text\": undefined,\n        \"title\": \"Yes You Can\",\n        \"topic\": \"Karriere\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f9535bebd2_064406_150708_5170.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Karriere bei Preyer\",\n            \"topic\": \"Karriere bei Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Senior Blah\",\n                \"topic\": \"Job 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Junior Blah\",\n                \"topic\": \"Job 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"workstudent\",\n+               \"text\": undefined,\n                \"title\": \"Slave\",\n                \"topic\": \"Job 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Karriere bei Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0d95bebca_vega%2Bbuerotisch.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Über Preyer\",\n            \"topic\": \"Über Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Über Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Karriere\",\n      \"sorting\": 4,\n      \"type\": \"cards\",\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:18:29\n    at Generator.next (<anonymous>)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:8:71\n    at new Promise (<anonymous>)\n    at Object.<anonymous>.__awaiter (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:4:12)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:14:41)\n    at Object.asyncJestTest (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:106:37)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:45:12\n    at new Promise (<anonymous>)\n    at mapper (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:28:19)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:75:41\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3553987,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:19:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3553993,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:32:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3554066,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554072,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553997,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554003,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554007,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554013,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554016,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554022,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554026,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554032,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554036,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554042,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729272,
                                    "isTestReportAvailable": true,
                                    "duration": 124,
                                    "duration_inMinutes": 2.07,
                                    "created_at": "Dec-20-21",
                                    "created_at_rawDateFormat": "2021-12-20T07:05:09.360Z",
                                    "testCoverage": 94.5
                                }
                            },
                            {
                                "id": 433050744,
                                "gitlabId": 433050744,
                                "status": "failed",
                                "testReport": {
                                    "id": 46714,
                                    "error_count": 0,
                                    "failed_count": 3,
                                    "skipped_count": 0,
                                    "success_count": 22,
                                    "total_count": 25,
                                    "total_time": 0.15,
                                    "test_suites": [
                                        {
                                            "id": 54053,
                                            "total_time": 0.15,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 3,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 22,
                                            "test_cases": [
                                                {
                                                    "id": 3554907,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554886,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554895,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554923,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554927,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554904,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554933,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554856,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554846,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554836,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554826,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554816,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554806,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554796,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554786,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.02,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554776,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:32:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3554766,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:19:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3554756,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.04,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(received).toEqual(expected) // deep equality\n\n- Expected  -  70\n+ Received  + 599\n\n@@ -1,571 +1,1100 @@\n  Array [\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Page Subtitle\",\n+       \"text\": undefined,\n        \"title\": \"Page Title\",\n        \"topic\": \"Blog\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 1\",\n+           \"text\": undefined,\n            \"title\": \"Title 1\",\n            \"topic\": \"Blog 1\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Blog 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Blog 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 4\",\n+           \"text\": undefined,\n            \"title\": \"Title 4\",\n            \"topic\": \"Blog 4\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 4\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 5\",\n+           \"text\": undefined,\n            \"title\": \"Title 5\",\n            \"topic\": \"Blog 5\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 5\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 6\",\n+           \"text\": undefined,\n            \"title\": \"Title 6\",\n            \"topic\": \"Blog 6\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 6\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Blog\",\n+     \"sorting\": undefined,\n+     \"type\": undefined,\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"subTitle News\",\n+       \"text\": undefined,\n        \"title\": \"Title News\",\n        \"topic\": \"News\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": undefined,\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n+           \"lead\": undefined,\n+           \"linkText\": undefined,\n+           \"subTitle\": undefined,\n+           \"text\": undefined,\n+           \"title\": undefined,\n+           \"topic\": undefined,\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"Title 1\",\n-           \"topic\": \"Item 1\",\n+               \"topic\": \"Hallo \",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n-         \"level\": \"Level2Topic\",\n+             \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n+             \"slug\": \"Hallo \",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n+           },\n+         ],\n          \"slug\": \"Item 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Item 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Item 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"News\",\n      \"sorting\": 1,\n      \"type\": \"carousel\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n+       \"lead\": undefined,\n+       \"linkText\": undefined,\n        \"subTitle\": \"Was wir für Sie tun können.\",\n+       \"text\": undefined,\n        \"title\": \"Yes we can\",\n        \"topic\": \"Expertise\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5210d5bebbe_123%20programmer%20looking%20at%20data%20screens%201600x390.jpg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b536455bec37_simcorp_normal.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Ex 1\",\n            \"topic\": \"Branche/Kunden\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n+               \"lead\": undefined,\n+               \"linkText\": undefined,\n+               \"subTitle\": undefined,\n+               \"text\": undefined,\n+               \"title\": undefined,\n+               \"topic\": undefined,\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 1\",\n                    \"topic\": \"Topic 1\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 1\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 2\",\n                    \"topic\": \"Topic 2\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 2\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 3\",\n                    \"topic\": \"Topic 3\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 3\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n              ],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 2\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 3\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Branche/Kunden\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b52fbd5bebc1_AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b50ade5beba9_ico_SystemConsulting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Lösungen/Services\",\n            \"topic\": \"Lösungen/Services\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Lösungen/Services\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f21f5bebc2_AdobeStock_302181481_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a77c5beba2_ico_Tools_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Das Preyer Team\",\n            \"topic\": \"Das Preyer Team\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Das Preyer Team\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0fa5bebc9_AdobeStock_312736469_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b540875beb9e_ico_Reporting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Schulungen\",\n            \"topic\": \"Schulungen\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"SFTR Webinar\",\n                \"topic\": \"topic 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 2\",\n+               \"text\": undefined,\n                \"title\": \"Course 1\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 3\",\n+               \"text\": undefined,\n                \"title\": \"Course 2\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Schulungen\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Expertise\",\n      \"sorting\": 2,\n      \"type\": \"cards\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n        \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+       \"imageMobile\": undefined,\n        \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n        \"lead\": \"Preyer ist eine Strategie- und IT-Beratung für Finanzunternehmen mit Fokus auf Prozessberatung und IT-Systemlösungen. Wir überprüfen vorhandene IT-Architekturen und implementieren neue Lösungen nur dort, wo es notwendig ist. (mehr…)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Wachstum durch digitale Neuausrichtung.\",\n+       \"text\": undefined,\n        \"title\": \"Connecting Business with IT.\",\n        \"topic\": \"Unternehmen\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Verschärfte Vorgaben der Aufsichtsbehörden, niedrige Zinsen, disruptive Wettbewerber, neue Technologien und massiver Margendruck revolutionieren die Geschäftsmodelle von Banken, Vermögensverwaltern, Fondsgesellschaften, Asset Managern und anderen Finanzdienstleistern. \n  Die dadurch entstehenden strategischen Herausforderungen erfordern mutige Entscheidungen und schnelle Umsetzung. Gleiches gilt für die Einführung effektiver Prozesse und differenzierter Reportings. \n  Das Modernisieren von Geschäftsprozessen und das Implementieren innovativer Systemarchitekturen gehören in der Finanzbranche zu den größten Herausforderungen auf der Reise in eine hochdigitalisierte Welt. \n  Ob Finanz- und Risikomanagement im Treasury, Wertpapierhandel, Fondsbuchhaltung oder die Gesamtbanksteuerung: Das Optimieren von Geschäftsprozessen oder deren Neuausrichtung sind unverzichtbar für die Zukunftsfähigkeit der Finanzindustrie. \n  Innovative Systemarchitekturen sowie transformierte Prozesse und Geschäftsmodelle sind die zentralen Schlüssel für Wettbewerbsfähigkeit und künftiges Wachstum der Branche.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Banken und Finanzinstitute befinden sich an einem Wendepunkt. Nur Unternehmen, die heute ihre digitale Transformation vorantreiben und ihre Systeme modernisieren, stellen die Weichen für eine erfolgreiche Zukunft. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Ineffizienzen sind nicht länger tragbar. \",\n+           \"text\": undefined,\n            \"title\": \"Die Finanzwelt verändert sich.\",\n            \"topic\": \"Markt\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Markt\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Preyer bietet ganzheitliche Fach- und Systemberatung für Banken, Investmentgesellschaften, Versicherungen, Sparkassen und die Öffentliche Hand. \n  Stabile IT-Landschaften und effektive Systemarchitekturen verkörpern die neue Grundausstattung, wenn es um Themen wie Regulierung, Datensicherheit, Automatisierung, neue Wettbewerber oder erhöhten Kostendruck geht. \n  Gemeinsam gehen wir jedem Kundenanliegen auf den Grund und entwickeln schlagkräftige, effiziente IT-Lösungen für unterschiedlichste Projekte und Anforderungen. Pragmatisch, schnell und effektiv. Dabei bilden unsere Expertenteams die Kommunikationsbrücke zwischen den Fachbereichen und der IT. \n  Unsere Kunden profitieren von unserem ganzheitlichen Blick auf die fachlichen Anforderungen ihrer Digitalisierungs- und IT-Projekte, unserer langjährigen Praxiserfahrung als Fach- und Systemberatung im Finanzbereich und dem technologischen Know-how unserer Kompetenz-Teams. \n  Unser Ziel: Schlanke, effiziente und passgenaue Anwendungen und Prozesse, die schnell, digital und zukunftsfähig sind. Deshalb gehen wir bei jedem Projekt inhaltlich in die Tiefe und liefern Statusanalysen, Konzeption und Umsetzung aus einer Hand.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Preyer arbeitet seit Jahren erfolgreich an der technologischen Zukunftsfähigkeit von Finanzunternehmen. Gemeinsam mit unseren Kunden schaffen wir Grundlagen für digitale Geschäftsanwendungen und effiziente IT-Systemlösungen. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Fach- und Systemberatung mit echtem Mehrwert.\",\n+           \"text\": undefined,\n            \"title\": \"IT-Herausforderungen lösen.\",\n            \"topic\": \"Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n+       },\n+       Object {\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+           \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"linkText\": undefined,\n+           \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+           \"text\": undefined,\n+           \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+           \"topic\": \"Referenzen\",\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n+             \"content\": Object {\n+               \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+               \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+               \"linkText\": undefined,\n+               \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+               \"text\": undefined,\n+               \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+               \"topic\": \"Referenzen-Section\",\n+             },\n+             \"isContentOnly\": true,\n+             \"isPrimeTopic\": false,\n+             \"level\": \"Level3Topic\",\n+             \"sections\": Array [\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Addiko-Bank_Ulrich_Kissing.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Addiko-Bank_color.svg\",\n+                   \"lead\": \"Im Rahmen der Privatisierung der Hypo Group Alpe Adria, jetzt Addiko Bank AG, wurde Preyer beauragt, die eingesetzten Methoden und Konzepte im Bereich Marktpreisrisiko zu analysieren und deren Angemessenheit im Hinblick auf das neue Geschäsmodell zu validieren. Weiterer Schwerpunkt bildete die Überprüfung des Transferpricings zwischen der Holding und den Ausländischen Tochtergesellschaen. Wir beauragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen. Diese Expertise war auch vor dem Hintergrund des sehr ambitionierten Zeitplanes eine zwingende Voraussetzung. Die Ergebnisse der Untersuchung und die empfohlenen Maßnahmen werden nun in unseren kurz- und mittelfristigen Aktionsplan einfließen.\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der Addiko Bank AG\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Addiko-Bank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Addiko-Bank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n                },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"SparkassenFinanzgruppe_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Sparkassen Finanzgruppe\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Sparkassen Finanzgruppe\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"DekaBank_kowallik_spk.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"DekaBank_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"DekaBank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"DekaBank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+             ],\n+             \"slug\": \"Referenzen-Section\",\n+             \"sorting\": 1,\n+             \"type\": \"accordion\",\n+           },\n+         ],\n+         \"slug\": \"Referenzen\",\n+         \"sorting\": 1,\n+         \"type\": undefined,\n+       },\n      ],\n      \"slug\": \"Unternehmen\",\n      \"sorting\": 3,\n      \"type\": \"textLeftImageRight\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Work for us, you know it makes sense\",\n+       \"text\": undefined,\n        \"title\": \"Yes You Can\",\n        \"topic\": \"Karriere\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f9535bebd2_064406_150708_5170.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Karriere bei Preyer\",\n            \"topic\": \"Karriere bei Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Senior Blah\",\n                \"topic\": \"Job 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Junior Blah\",\n                \"topic\": \"Job 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"workstudent\",\n+               \"text\": undefined,\n                \"title\": \"Slave\",\n                \"topic\": \"Job 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Karriere bei Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0d95bebca_vega%2Bbuerotisch.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Über Preyer\",\n            \"topic\": \"Über Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Über Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Karriere\",\n      \"sorting\": 4,\n      \"type\": \"cards\",\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:18:29\n    at Generator.next (<anonymous>)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:8:71\n    at new Promise (<anonymous>)\n    at Object.<anonymous>.__awaiter (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:4:12)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:14:41)\n    at Object.asyncJestTest (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:106:37)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:45:12\n    at new Promise (<anonymous>)\n    at mapper (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:28:19)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:75:41\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3554947,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554937,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554943,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554876,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554866,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554917,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554913,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729273,
                                    "isTestReportAvailable": true,
                                    "duration": 134,
                                    "duration_inMinutes": 2.23,
                                    "created_at": "Dec-20-21",
                                    "created_at_rawDateFormat": "2021-12-20T07:05:09.472Z",
                                    "testCoverage": 94.5
                                }
                            },
                            {
                                "id": 432031181,
                                "gitlabId": 432031181,
                                "status": "failed",
                                "testReport": {
                                    "id": 46716,
                                    "error_count": 0,
                                    "failed_count": 3,
                                    "skipped_count": 0,
                                    "success_count": 22,
                                    "total_count": 25,
                                    "total_time": 0.15,
                                    "test_suites": [
                                        {
                                            "id": 54052,
                                            "total_time": 0.15,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 3,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 22,
                                            "test_cases": [
                                                {
                                                    "id": 3553534,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:32:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3553524,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:19:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3553513,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.04,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(received).toEqual(expected) // deep equality\n\n- Expected  -  70\n+ Received  + 599\n\n@@ -1,571 +1,1100 @@\n  Array [\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Page Subtitle\",\n+       \"text\": undefined,\n        \"title\": \"Page Title\",\n        \"topic\": \"Blog\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 1\",\n+           \"text\": undefined,\n            \"title\": \"Title 1\",\n            \"topic\": \"Blog 1\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Blog 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Blog 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 4\",\n+           \"text\": undefined,\n            \"title\": \"Title 4\",\n            \"topic\": \"Blog 4\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 4\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 5\",\n+           \"text\": undefined,\n            \"title\": \"Title 5\",\n            \"topic\": \"Blog 5\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 5\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 6\",\n+           \"text\": undefined,\n            \"title\": \"Title 6\",\n            \"topic\": \"Blog 6\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 6\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Blog\",\n+     \"sorting\": undefined,\n+     \"type\": undefined,\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"subTitle News\",\n+       \"text\": undefined,\n        \"title\": \"Title News\",\n        \"topic\": \"News\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": undefined,\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n+           \"lead\": undefined,\n+           \"linkText\": undefined,\n+           \"subTitle\": undefined,\n+           \"text\": undefined,\n+           \"title\": undefined,\n+           \"topic\": undefined,\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"Title 1\",\n-           \"topic\": \"Item 1\",\n+               \"topic\": \"Hallo \",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n-         \"level\": \"Level2Topic\",\n+             \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n+             \"slug\": \"Hallo \",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n+           },\n+         ],\n          \"slug\": \"Item 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Item 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Item 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"News\",\n      \"sorting\": 1,\n      \"type\": \"carousel\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n+       \"lead\": undefined,\n+       \"linkText\": undefined,\n        \"subTitle\": \"Was wir für Sie tun können.\",\n+       \"text\": undefined,\n        \"title\": \"Yes we can\",\n        \"topic\": \"Expertise\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5210d5bebbe_123%20programmer%20looking%20at%20data%20screens%201600x390.jpg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b536455bec37_simcorp_normal.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Ex 1\",\n            \"topic\": \"Branche/Kunden\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n+               \"lead\": undefined,\n+               \"linkText\": undefined,\n+               \"subTitle\": undefined,\n+               \"text\": undefined,\n+               \"title\": undefined,\n+               \"topic\": undefined,\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 1\",\n                    \"topic\": \"Topic 1\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 1\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 2\",\n                    \"topic\": \"Topic 2\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 2\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 3\",\n                    \"topic\": \"Topic 3\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 3\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n              ],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 2\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 3\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Branche/Kunden\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b52fbd5bebc1_AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b50ade5beba9_ico_SystemConsulting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Lösungen/Services\",\n            \"topic\": \"Lösungen/Services\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Lösungen/Services\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f21f5bebc2_AdobeStock_302181481_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a77c5beba2_ico_Tools_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Das Preyer Team\",\n            \"topic\": \"Das Preyer Team\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Das Preyer Team\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0fa5bebc9_AdobeStock_312736469_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b540875beb9e_ico_Reporting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Schulungen\",\n            \"topic\": \"Schulungen\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"SFTR Webinar\",\n                \"topic\": \"topic 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 2\",\n+               \"text\": undefined,\n                \"title\": \"Course 1\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 3\",\n+               \"text\": undefined,\n                \"title\": \"Course 2\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Schulungen\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Expertise\",\n      \"sorting\": 2,\n      \"type\": \"cards\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n        \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+       \"imageMobile\": undefined,\n        \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n        \"lead\": \"Preyer ist eine Strategie- und IT-Beratung für Finanzunternehmen mit Fokus auf Prozessberatung und IT-Systemlösungen. Wir überprüfen vorhandene IT-Architekturen und implementieren neue Lösungen nur dort, wo es notwendig ist. (mehr…)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Wachstum durch digitale Neuausrichtung.\",\n+       \"text\": undefined,\n        \"title\": \"Connecting Business with IT.\",\n        \"topic\": \"Unternehmen\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Verschärfte Vorgaben der Aufsichtsbehörden, niedrige Zinsen, disruptive Wettbewerber, neue Technologien und massiver Margendruck revolutionieren die Geschäftsmodelle von Banken, Vermögensverwaltern, Fondsgesellschaften, Asset Managern und anderen Finanzdienstleistern. \n  Die dadurch entstehenden strategischen Herausforderungen erfordern mutige Entscheidungen und schnelle Umsetzung. Gleiches gilt für die Einführung effektiver Prozesse und differenzierter Reportings. \n  Das Modernisieren von Geschäftsprozessen und das Implementieren innovativer Systemarchitekturen gehören in der Finanzbranche zu den größten Herausforderungen auf der Reise in eine hochdigitalisierte Welt. \n  Ob Finanz- und Risikomanagement im Treasury, Wertpapierhandel, Fondsbuchhaltung oder die Gesamtbanksteuerung: Das Optimieren von Geschäftsprozessen oder deren Neuausrichtung sind unverzichtbar für die Zukunftsfähigkeit der Finanzindustrie. \n  Innovative Systemarchitekturen sowie transformierte Prozesse und Geschäftsmodelle sind die zentralen Schlüssel für Wettbewerbsfähigkeit und künftiges Wachstum der Branche.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Banken und Finanzinstitute befinden sich an einem Wendepunkt. Nur Unternehmen, die heute ihre digitale Transformation vorantreiben und ihre Systeme modernisieren, stellen die Weichen für eine erfolgreiche Zukunft. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Ineffizienzen sind nicht länger tragbar. \",\n+           \"text\": undefined,\n            \"title\": \"Die Finanzwelt verändert sich.\",\n            \"topic\": \"Markt\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Markt\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Preyer bietet ganzheitliche Fach- und Systemberatung für Banken, Investmentgesellschaften, Versicherungen, Sparkassen und die Öffentliche Hand. \n  Stabile IT-Landschaften und effektive Systemarchitekturen verkörpern die neue Grundausstattung, wenn es um Themen wie Regulierung, Datensicherheit, Automatisierung, neue Wettbewerber oder erhöhten Kostendruck geht. \n  Gemeinsam gehen wir jedem Kundenanliegen auf den Grund und entwickeln schlagkräftige, effiziente IT-Lösungen für unterschiedlichste Projekte und Anforderungen. Pragmatisch, schnell und effektiv. Dabei bilden unsere Expertenteams die Kommunikationsbrücke zwischen den Fachbereichen und der IT. \n  Unsere Kunden profitieren von unserem ganzheitlichen Blick auf die fachlichen Anforderungen ihrer Digitalisierungs- und IT-Projekte, unserer langjährigen Praxiserfahrung als Fach- und Systemberatung im Finanzbereich und dem technologischen Know-how unserer Kompetenz-Teams. \n  Unser Ziel: Schlanke, effiziente und passgenaue Anwendungen und Prozesse, die schnell, digital und zukunftsfähig sind. Deshalb gehen wir bei jedem Projekt inhaltlich in die Tiefe und liefern Statusanalysen, Konzeption und Umsetzung aus einer Hand.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Preyer arbeitet seit Jahren erfolgreich an der technologischen Zukunftsfähigkeit von Finanzunternehmen. Gemeinsam mit unseren Kunden schaffen wir Grundlagen für digitale Geschäftsanwendungen und effiziente IT-Systemlösungen. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Fach- und Systemberatung mit echtem Mehrwert.\",\n+           \"text\": undefined,\n            \"title\": \"IT-Herausforderungen lösen.\",\n            \"topic\": \"Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n+       },\n+       Object {\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+           \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"linkText\": undefined,\n+           \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+           \"text\": undefined,\n+           \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+           \"topic\": \"Referenzen\",\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n+             \"content\": Object {\n+               \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+               \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+               \"linkText\": undefined,\n+               \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+               \"text\": undefined,\n+               \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+               \"topic\": \"Referenzen-Section\",\n+             },\n+             \"isContentOnly\": true,\n+             \"isPrimeTopic\": false,\n+             \"level\": \"Level3Topic\",\n+             \"sections\": Array [\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Addiko-Bank_Ulrich_Kissing.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Addiko-Bank_color.svg\",\n+                   \"lead\": \"Im Rahmen der Privatisierung der Hypo Group Alpe Adria, jetzt Addiko Bank AG, wurde Preyer beauragt, die eingesetzten Methoden und Konzepte im Bereich Marktpreisrisiko zu analysieren und deren Angemessenheit im Hinblick auf das neue Geschäsmodell zu validieren. Weiterer Schwerpunkt bildete die Überprüfung des Transferpricings zwischen der Holding und den Ausländischen Tochtergesellschaen. Wir beauragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen. Diese Expertise war auch vor dem Hintergrund des sehr ambitionierten Zeitplanes eine zwingende Voraussetzung. Die Ergebnisse der Untersuchung und die empfohlenen Maßnahmen werden nun in unseren kurz- und mittelfristigen Aktionsplan einfließen.\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der Addiko Bank AG\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Addiko-Bank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Addiko-Bank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n                },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"SparkassenFinanzgruppe_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Sparkassen Finanzgruppe\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Sparkassen Finanzgruppe\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"DekaBank_kowallik_spk.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"DekaBank_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"DekaBank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"DekaBank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+             ],\n+             \"slug\": \"Referenzen-Section\",\n+             \"sorting\": 1,\n+             \"type\": \"accordion\",\n+           },\n+         ],\n+         \"slug\": \"Referenzen\",\n+         \"sorting\": 1,\n+         \"type\": undefined,\n+       },\n      ],\n      \"slug\": \"Unternehmen\",\n      \"sorting\": 3,\n      \"type\": \"textLeftImageRight\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Work for us, you know it makes sense\",\n+       \"text\": undefined,\n        \"title\": \"Yes You Can\",\n        \"topic\": \"Karriere\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f9535bebd2_064406_150708_5170.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Karriere bei Preyer\",\n            \"topic\": \"Karriere bei Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Senior Blah\",\n                \"topic\": \"Job 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Junior Blah\",\n                \"topic\": \"Job 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"workstudent\",\n+               \"text\": undefined,\n                \"title\": \"Slave\",\n                \"topic\": \"Job 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Karriere bei Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0d95bebca_vega%2Bbuerotisch.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Über Preyer\",\n            \"topic\": \"Über Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Über Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Karriere\",\n      \"sorting\": 4,\n      \"type\": \"cards\",\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:18:29\n    at Generator.next (<anonymous>)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:8:71\n    at new Promise (<anonymous>)\n    at Object.<anonymous>.__awaiter (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:4:12)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:14:41)\n    at Object.asyncJestTest (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:106:37)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:45:12\n    at new Promise (<anonymous>)\n    at mapper (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:28:19)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:75:41\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3553594,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553589,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553583,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553602,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553579,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553573,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553608,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553612,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553618,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553621,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553627,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553631,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553637,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553641,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553647,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553651,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553569,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553563,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553559,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553553,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553549,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.02,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553540,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729274,
                                    "isTestReportAvailable": true,
                                    "duration": 150,
                                    "duration_inMinutes": 2.5,
                                    "created_at": "Dec-17-21",
                                    "created_at_rawDateFormat": "2021-12-17T07:05:09.614Z",
                                    "testCoverage": 94.5
                                }
                            },
                            {
                                "id": 431285217,
                                "gitlabId": 431285217,
                                "status": "failed",
                                "testReport": {
                                    "id": 46715,
                                    "error_count": 0,
                                    "failed_count": 3,
                                    "skipped_count": 0,
                                    "success_count": 22,
                                    "total_count": 25,
                                    "total_time": 0.13,
                                    "test_suites": [
                                        {
                                            "id": 54054,
                                            "total_time": 0.13,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 3,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 22,
                                            "test_cases": [
                                                {
                                                    "id": 3552926,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552935,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552945,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552857,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.04,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(received).toEqual(expected) // deep equality\n\n- Expected  -  70\n+ Received  + 599\n\n@@ -1,571 +1,1100 @@\n  Array [\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Page Subtitle\",\n+       \"text\": undefined,\n        \"title\": \"Page Title\",\n        \"topic\": \"Blog\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 1\",\n+           \"text\": undefined,\n            \"title\": \"Title 1\",\n            \"topic\": \"Blog 1\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Blog 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Blog 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 4\",\n+           \"text\": undefined,\n            \"title\": \"Title 4\",\n            \"topic\": \"Blog 4\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 4\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 5\",\n+           \"text\": undefined,\n            \"title\": \"Title 5\",\n            \"topic\": \"Blog 5\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 5\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 6\",\n+           \"text\": undefined,\n            \"title\": \"Title 6\",\n            \"topic\": \"Blog 6\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 6\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Blog\",\n+     \"sorting\": undefined,\n+     \"type\": undefined,\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"subTitle News\",\n+       \"text\": undefined,\n        \"title\": \"Title News\",\n        \"topic\": \"News\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": undefined,\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n+           \"lead\": undefined,\n+           \"linkText\": undefined,\n+           \"subTitle\": undefined,\n+           \"text\": undefined,\n+           \"title\": undefined,\n+           \"topic\": undefined,\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"Title 1\",\n-           \"topic\": \"Item 1\",\n+               \"topic\": \"Hallo \",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n-         \"level\": \"Level2Topic\",\n+             \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n+             \"slug\": \"Hallo \",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n+           },\n+         ],\n          \"slug\": \"Item 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Item 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Item 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"News\",\n      \"sorting\": 1,\n      \"type\": \"carousel\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n+       \"lead\": undefined,\n+       \"linkText\": undefined,\n        \"subTitle\": \"Was wir für Sie tun können.\",\n+       \"text\": undefined,\n        \"title\": \"Yes we can\",\n        \"topic\": \"Expertise\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5210d5bebbe_123%20programmer%20looking%20at%20data%20screens%201600x390.jpg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b536455bec37_simcorp_normal.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Ex 1\",\n            \"topic\": \"Branche/Kunden\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n+               \"lead\": undefined,\n+               \"linkText\": undefined,\n+               \"subTitle\": undefined,\n+               \"text\": undefined,\n+               \"title\": undefined,\n+               \"topic\": undefined,\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 1\",\n                    \"topic\": \"Topic 1\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 1\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 2\",\n                    \"topic\": \"Topic 2\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 2\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 3\",\n                    \"topic\": \"Topic 3\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 3\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n              ],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 2\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 3\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Branche/Kunden\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b52fbd5bebc1_AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b50ade5beba9_ico_SystemConsulting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Lösungen/Services\",\n            \"topic\": \"Lösungen/Services\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Lösungen/Services\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f21f5bebc2_AdobeStock_302181481_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a77c5beba2_ico_Tools_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Das Preyer Team\",\n            \"topic\": \"Das Preyer Team\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Das Preyer Team\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0fa5bebc9_AdobeStock_312736469_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b540875beb9e_ico_Reporting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Schulungen\",\n            \"topic\": \"Schulungen\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"SFTR Webinar\",\n                \"topic\": \"topic 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 2\",\n+               \"text\": undefined,\n                \"title\": \"Course 1\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 3\",\n+               \"text\": undefined,\n                \"title\": \"Course 2\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Schulungen\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Expertise\",\n      \"sorting\": 2,\n      \"type\": \"cards\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n        \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+       \"imageMobile\": undefined,\n        \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n        \"lead\": \"Preyer ist eine Strategie- und IT-Beratung für Finanzunternehmen mit Fokus auf Prozessberatung und IT-Systemlösungen. Wir überprüfen vorhandene IT-Architekturen und implementieren neue Lösungen nur dort, wo es notwendig ist. (mehr…)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Wachstum durch digitale Neuausrichtung.\",\n+       \"text\": undefined,\n        \"title\": \"Connecting Business with IT.\",\n        \"topic\": \"Unternehmen\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Verschärfte Vorgaben der Aufsichtsbehörden, niedrige Zinsen, disruptive Wettbewerber, neue Technologien und massiver Margendruck revolutionieren die Geschäftsmodelle von Banken, Vermögensverwaltern, Fondsgesellschaften, Asset Managern und anderen Finanzdienstleistern. \n  Die dadurch entstehenden strategischen Herausforderungen erfordern mutige Entscheidungen und schnelle Umsetzung. Gleiches gilt für die Einführung effektiver Prozesse und differenzierter Reportings. \n  Das Modernisieren von Geschäftsprozessen und das Implementieren innovativer Systemarchitekturen gehören in der Finanzbranche zu den größten Herausforderungen auf der Reise in eine hochdigitalisierte Welt. \n  Ob Finanz- und Risikomanagement im Treasury, Wertpapierhandel, Fondsbuchhaltung oder die Gesamtbanksteuerung: Das Optimieren von Geschäftsprozessen oder deren Neuausrichtung sind unverzichtbar für die Zukunftsfähigkeit der Finanzindustrie. \n  Innovative Systemarchitekturen sowie transformierte Prozesse und Geschäftsmodelle sind die zentralen Schlüssel für Wettbewerbsfähigkeit und künftiges Wachstum der Branche.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Banken und Finanzinstitute befinden sich an einem Wendepunkt. Nur Unternehmen, die heute ihre digitale Transformation vorantreiben und ihre Systeme modernisieren, stellen die Weichen für eine erfolgreiche Zukunft. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Ineffizienzen sind nicht länger tragbar. \",\n+           \"text\": undefined,\n            \"title\": \"Die Finanzwelt verändert sich.\",\n            \"topic\": \"Markt\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Markt\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Preyer bietet ganzheitliche Fach- und Systemberatung für Banken, Investmentgesellschaften, Versicherungen, Sparkassen und die Öffentliche Hand. \n  Stabile IT-Landschaften und effektive Systemarchitekturen verkörpern die neue Grundausstattung, wenn es um Themen wie Regulierung, Datensicherheit, Automatisierung, neue Wettbewerber oder erhöhten Kostendruck geht. \n  Gemeinsam gehen wir jedem Kundenanliegen auf den Grund und entwickeln schlagkräftige, effiziente IT-Lösungen für unterschiedlichste Projekte und Anforderungen. Pragmatisch, schnell und effektiv. Dabei bilden unsere Expertenteams die Kommunikationsbrücke zwischen den Fachbereichen und der IT. \n  Unsere Kunden profitieren von unserem ganzheitlichen Blick auf die fachlichen Anforderungen ihrer Digitalisierungs- und IT-Projekte, unserer langjährigen Praxiserfahrung als Fach- und Systemberatung im Finanzbereich und dem technologischen Know-how unserer Kompetenz-Teams. \n  Unser Ziel: Schlanke, effiziente und passgenaue Anwendungen und Prozesse, die schnell, digital und zukunftsfähig sind. Deshalb gehen wir bei jedem Projekt inhaltlich in die Tiefe und liefern Statusanalysen, Konzeption und Umsetzung aus einer Hand.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Preyer arbeitet seit Jahren erfolgreich an der technologischen Zukunftsfähigkeit von Finanzunternehmen. Gemeinsam mit unseren Kunden schaffen wir Grundlagen für digitale Geschäftsanwendungen und effiziente IT-Systemlösungen. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Fach- und Systemberatung mit echtem Mehrwert.\",\n+           \"text\": undefined,\n            \"title\": \"IT-Herausforderungen lösen.\",\n            \"topic\": \"Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n+       },\n+       Object {\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+           \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"linkText\": undefined,\n+           \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+           \"text\": undefined,\n+           \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+           \"topic\": \"Referenzen\",\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n+             \"content\": Object {\n+               \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+               \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+               \"linkText\": undefined,\n+               \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+               \"text\": undefined,\n+               \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+               \"topic\": \"Referenzen-Section\",\n+             },\n+             \"isContentOnly\": true,\n+             \"isPrimeTopic\": false,\n+             \"level\": \"Level3Topic\",\n+             \"sections\": Array [\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"Addiko-Bank_Ulrich_Kissing.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"Addiko-Bank_color.svg\",\n+                   \"lead\": \"Im Rahmen der Privatisierung der Hypo Group Alpe Adria, jetzt Addiko Bank AG, wurde Preyer beauragt, die eingesetzten Methoden und Konzepte im Bereich Marktpreisrisiko zu analysieren und deren Angemessenheit im Hinblick auf das neue Geschäsmodell zu validieren. Weiterer Schwerpunkt bildete die Überprüfung des Transferpricings zwischen der Holding und den Ausländischen Tochtergesellschaen. Wir beauragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen. Diese Expertise war auch vor dem Hintergrund des sehr ambitionierten Zeitplanes eine zwingende Voraussetzung. Die Ergebnisse der Untersuchung und die empfohlenen Maßnahmen werden nun in unseren kurz- und mittelfristigen Aktionsplan einfließen.\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der Addiko Bank AG\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"Addiko-Bank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Addiko-Bank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n                },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"SparkassenFinanzgruppe_color.svg\",\n+                   \"lead\": \"Neue regulatorische Anforderungen müssen in den bestehenden Systemen der Sparkassen Finanzgruppe umgesetzt werden. Preyer hat für uns eine Soware entwickelt, die basierend auf den Daten und Ergebnissen der Standard Systeme der Sparkassen Finanzgruppe Szenariosimulationen ermöglichte. Hierdurch konnten umfangreiche, aufwendige Nebenrechnungen in Tabellenkalkulationssystemen abgelöst und operationelle Risiken vermieden werden. Preyer entwickelte das Fachkonzept und die Soware. Beides wurde im Rahmen eines internen Prozesses nach OPDV von uns abgenommen. Mehr als 100 Sparkassen bundesweiten nutzen diese Anwendung. Die für regulatorische Zwecke erstellte Soware entspricht in vollem Umfang unseren Erwartungen und wurde internen und externen Prüfungen bei den Sparkassen gerecht. Die Basis unserer langjährigen partnerschalichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Knowhow. Die Mitarbeiter von Preyer sind für uns immer erreichbar und Fragen und Anregungen werden zeitnah beantwortet und bearbeitet\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": undefined,\n+                   \"text\": undefined,\n+                   \"title\": \"Die Basis unserer langjährigen partnerschaftlichen Zusammenarbeit ist Vertrauen, begleitet von Professionalität und Know-how.\",\n+                   \"topic\": \"Sparkassen Finanzgruppe\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Sparkassen Finanzgruppe\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"DekaBank_kowallik_spk.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"DekaBank_color.svg\",\n+                   \"lead\": undefined,\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"Dipl.-Kfm. Ulrich Kissing, Vorsitzender des Vorstandes der DekaBank\",\n+                   \"text\": undefined,\n+                   \"title\": \"Wir beauftragten die Firma Preyer, weil wir wissen, dass sie über die notwendige Expertise und langjährige Erfahrung im Bereich Marktpreisrisiko verfügen.\",\n+                   \"topic\": \"DekaBank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"DekaBank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+             ],\n+             \"slug\": \"Referenzen-Section\",\n+             \"sorting\": 1,\n+             \"type\": \"accordion\",\n+           },\n+         ],\n+         \"slug\": \"Referenzen\",\n+         \"sorting\": 1,\n+         \"type\": undefined,\n+       },\n      ],\n      \"slug\": \"Unternehmen\",\n      \"sorting\": 3,\n      \"type\": \"textLeftImageRight\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Work for us, you know it makes sense\",\n+       \"text\": undefined,\n        \"title\": \"Yes You Can\",\n        \"topic\": \"Karriere\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f9535bebd2_064406_150708_5170.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Karriere bei Preyer\",\n            \"topic\": \"Karriere bei Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Senior Blah\",\n                \"topic\": \"Job 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Junior Blah\",\n                \"topic\": \"Job 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"workstudent\",\n+               \"text\": undefined,\n                \"title\": \"Slave\",\n                \"topic\": \"Job 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Karriere bei Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0d95bebca_vega%2Bbuerotisch.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Über Preyer\",\n            \"topic\": \"Über Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Über Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Karriere\",\n      \"sorting\": 4,\n      \"type\": \"cards\",\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:18:29\n    at Generator.next (<anonymous>)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:8:71\n    at new Promise (<anonymous>)\n    at Object.<anonymous>.__awaiter (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:4:12)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:14:41)\n    at Object.asyncJestTest (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:106:37)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:45:12\n    at new Promise (<anonymous>)\n    at mapper (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:28:19)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:75:41\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3552951,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552961,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552964,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552990,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552985,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552980,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552975,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552970,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552955,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552941,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553015,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553010,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553005,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553000,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552995,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552866,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:19:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3552876,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:32:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3552886,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552896,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552906,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552916,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729275,
                                    "isTestReportAvailable": true,
                                    "duration": 175,
                                    "duration_inMinutes": 2.92,
                                    "created_at": "Dec-16-21",
                                    "created_at_rawDateFormat": "2021-12-16T07:05:09.759Z",
                                    "testCoverage": 94.5
                                }
                            },
                            {
                                "id": 431071729,
                                "gitlabId": 431071729,
                                "status": "failed",
                                "testReport": {
                                    "id": 46720,
                                    "error_count": 0,
                                    "failed_count": 3,
                                    "skipped_count": 0,
                                    "success_count": 22,
                                    "total_count": 25,
                                    "total_time": 0.2,
                                    "test_suites": [
                                        {
                                            "id": 54055,
                                            "total_time": 0.2,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 3,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 22,
                                            "test_cases": [
                                                {
                                                    "id": 3554647,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554643,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554633,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554623,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554613,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.02,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554603,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554594,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554584,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554574,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.03,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554564,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:32:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3554554,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:19:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3554667,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554708,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554713,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554703,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554693,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554688,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554683,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554698,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554678,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554673,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554542,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.06,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(received).toEqual(expected) // deep equality\n\n- Expected  -  70\n+ Received  + 599\n\n@@ -1,571 +1,1100 @@\n  Array [\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Page Subtitle\",\n+       \"text\": undefined,\n        \"title\": \"Page Title\",\n        \"topic\": \"Blog\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 1\",\n+           \"text\": undefined,\n            \"title\": \"Title 1\",\n            \"topic\": \"Blog 1\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Blog 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Blog 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 4\",\n+           \"text\": undefined,\n            \"title\": \"Title 4\",\n            \"topic\": \"Blog 4\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 4\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 5\",\n+           \"text\": undefined,\n            \"title\": \"Title 5\",\n            \"topic\": \"Blog 5\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 5\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 6\",\n+           \"text\": undefined,\n            \"title\": \"Title 6\",\n            \"topic\": \"Blog 6\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 6\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Blog\",\n+     \"sorting\": undefined,\n+     \"type\": undefined,\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"subTitle News\",\n+       \"text\": undefined,\n        \"title\": \"Title News\",\n        \"topic\": \"News\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": undefined,\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n+           \"lead\": undefined,\n+           \"linkText\": undefined,\n+           \"subTitle\": undefined,\n+           \"text\": undefined,\n+           \"title\": undefined,\n+           \"topic\": undefined,\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"Title 1\",\n-           \"topic\": \"Item 1\",\n+               \"topic\": \"Hallo \",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n-         \"level\": \"Level2Topic\",\n+             \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n+             \"slug\": \"Hallo \",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n+           },\n+         ],\n          \"slug\": \"Item 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Item 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Item 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"News\",\n      \"sorting\": 1,\n      \"type\": \"carousel\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n+       \"lead\": undefined,\n+       \"linkText\": undefined,\n        \"subTitle\": \"Was wir für Sie tun können.\",\n+       \"text\": undefined,\n        \"title\": \"Yes we can\",\n        \"topic\": \"Expertise\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5210d5bebbe_123%20programmer%20looking%20at%20data%20screens%201600x390.jpg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b536455bec37_simcorp_normal.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Ex 1\",\n            \"topic\": \"Branche/Kunden\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n+               \"lead\": undefined,\n+               \"linkText\": undefined,\n+               \"subTitle\": undefined,\n+               \"text\": undefined,\n+               \"title\": undefined,\n+               \"topic\": undefined,\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 1\",\n                    \"topic\": \"Topic 1\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 1\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 2\",\n                    \"topic\": \"Topic 2\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 2\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 3\",\n                    \"topic\": \"Topic 3\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 3\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n              ],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 2\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 3\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Branche/Kunden\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b52fbd5bebc1_AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b50ade5beba9_ico_SystemConsulting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Lösungen/Services\",\n            \"topic\": \"Lösungen/Services\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Lösungen/Services\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f21f5bebc2_AdobeStock_302181481_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a77c5beba2_ico_Tools_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Das Preyer Team\",\n            \"topic\": \"Das Preyer Team\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Das Preyer Team\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0fa5bebc9_AdobeStock_312736469_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b540875beb9e_ico_Reporting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Schulungen\",\n            \"topic\": \"Schulungen\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"SFTR Webinar\",\n                \"topic\": \"topic 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 2\",\n+               \"text\": undefined,\n                \"title\": \"Course 1\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 3\",\n+               \"text\": undefined,\n                \"title\": \"Course 2\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Schulungen\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Expertise\",\n      \"sorting\": 2,\n      \"type\": \"cards\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n        \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+       \"imageMobile\": undefined,\n        \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n        \"lead\": \"Preyer ist eine Strategie- und IT-Beratung für Finanzunternehmen mit Fokus auf Prozessberatung und IT-Systemlösungen. Wir überprüfen vorhandene IT-Architekturen und implementieren neue Lösungen nur dort, wo es notwendig ist. (mehr…)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Wachstum durch digitale Neuausrichtung.\",\n+       \"text\": undefined,\n        \"title\": \"Connecting Business with IT.\",\n        \"topic\": \"Unternehmen\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Verschärfte Vorgaben der Aufsichtsbehörden, niedrige Zinsen, disruptive Wettbewerber, neue Technologien und massiver Margendruck revolutionieren die Geschäftsmodelle von Banken, Vermögensverwaltern, Fondsgesellschaften, Asset Managern und anderen Finanzdienstleistern. \n  Die dadurch entstehenden strategischen Herausforderungen erfordern mutige Entscheidungen und schnelle Umsetzung. Gleiches gilt für die Einführung effektiver Prozesse und differenzierter Reportings. \n  Das Modernisieren von Geschäftsprozessen und das Implementieren innovativer Systemarchitekturen gehören in der Finanzbranche zu den größten Herausforderungen auf der Reise in eine hochdigitalisierte Welt. \n  Ob Finanz- und Risikomanagement im Treasury, Wertpapierhandel, Fondsbuchhaltung oder die Gesamtbanksteuerung: Das Optimieren von Geschäftsprozessen oder deren Neuausrichtung sind unverzichtbar für die Zukunftsfähigkeit der Finanzindustrie. \n  Innovative Systemarchitekturen sowie transformierte Prozesse und Geschäftsmodelle sind die zentralen Schlüssel für Wettbewerbsfähigkeit und künftiges Wachstum der Branche.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Banken und Finanzinstitute befinden sich an einem Wendepunkt. Nur Unternehmen, die heute ihre digitale Transformation vorantreiben und ihre Systeme modernisieren, stellen die Weichen für eine erfolgreiche Zukunft. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Ineffizienzen sind nicht länger tragbar. \",\n+           \"text\": undefined,\n            \"title\": \"Die Finanzwelt verändert sich.\",\n            \"topic\": \"Markt\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Markt\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Preyer bietet ganzheitliche Fach- und Systemberatung für Banken, Investmentgesellschaften, Versicherungen, Sparkassen und die Öffentliche Hand. \n  Stabile IT-Landschaften und effektive Systemarchitekturen verkörpern die neue Grundausstattung, wenn es um Themen wie Regulierung, Datensicherheit, Automatisierung, neue Wettbewerber oder erhöhten Kostendruck geht. \n  Gemeinsam gehen wir jedem Kundenanliegen auf den Grund und entwickeln schlagkräftige, effiziente IT-Lösungen für unterschiedlichste Projekte und Anforderungen. Pragmatisch, schnell und effektiv. Dabei bilden unsere Expertenteams die Kommunikationsbrücke zwischen den Fachbereichen und der IT. \n  Unsere Kunden profitieren von unserem ganzheitlichen Blick auf die fachlichen Anforderungen ihrer Digitalisierungs- und IT-Projekte, unserer langjährigen Praxiserfahrung als Fach- und Systemberatung im Finanzbereich und dem technologischen Know-how unserer Kompetenz-Teams. \n  Unser Ziel: Schlanke, effiziente und passgenaue Anwendungen und Prozesse, die schnell, digital und zukunftsfähig sind. Deshalb gehen wir bei jedem Projekt inhaltlich in die Tiefe und liefern Statusanalysen, Konzeption und Umsetzung aus einer Hand.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Preyer arbeitet seit Jahren erfolgreich an der technologischen Zukunftsfähigkeit von Finanzunternehmen. Gemeinsam mit unseren Kunden schaffen wir Grundlagen für digitale Geschäftsanwendungen und effiziente IT-Systemlösungen. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Fach- und Systemberatung mit echtem Mehrwert.\",\n+           \"text\": undefined,\n            \"title\": \"IT-Herausforderungen lösen.\",\n            \"topic\": \"Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n+       },\n+       Object {\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+           \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"linkText\": undefined,\n+           \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+           \"text\": undefined,\n+           \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+           \"topic\": \"Referenzen\",\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n+             \"content\": Object {\n+               \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+               \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+               \"linkText\": undefined,\n+               \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+               \"text\": undefined,\n+               \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+               \"topic\": \"Referenzen-Section\",\n+             },\n+             \"isContentOnly\": true,\n+             \"isPrimeTopic\": false,\n+             \"level\": \"Level3Topic\",\n+             \"sections\": Array [\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+                   \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"subTitle\",\n+                   \"text\": undefined,\n+                   \"title\": \"Addiko Bank Title\",\n+                   \"topic\": \"Addiko-Bank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Addiko-Bank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n                },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+                   \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"subTitle News\",\n+                   \"text\": undefined,\n+                   \"title\": \"Natixis Title\",\n+                   \"topic\": \"Natixis\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Natixis\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+                   \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"subTitle News\",\n+                   \"text\": undefined,\n+                   \"title\": \"Scotiabank Title\",\n+                   \"topic\": \"Scotiabank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Scotiabank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+             ],\n+             \"slug\": \"Referenzen-Section\",\n+             \"sorting\": 1,\n+             \"type\": \"accordion\",\n+           },\n+         ],\n+         \"slug\": \"Referenzen\",\n+         \"sorting\": 1,\n+         \"type\": undefined,\n+       },\n      ],\n      \"slug\": \"Unternehmen\",\n      \"sorting\": 3,\n      \"type\": \"textLeftImageRight\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Work for us, you know it makes sense\",\n+       \"text\": undefined,\n        \"title\": \"Yes You Can\",\n        \"topic\": \"Karriere\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f9535bebd2_064406_150708_5170.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Karriere bei Preyer\",\n            \"topic\": \"Karriere bei Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Senior Blah\",\n                \"topic\": \"Job 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Junior Blah\",\n                \"topic\": \"Job 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"workstudent\",\n+               \"text\": undefined,\n                \"title\": \"Slave\",\n                \"topic\": \"Job 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Karriere bei Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0d95bebca_vega%2Bbuerotisch.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Über Preyer\",\n            \"topic\": \"Über Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Über Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Karriere\",\n      \"sorting\": 4,\n      \"type\": \"cards\",\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:18:29\n    at Generator.next (<anonymous>)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:8:71\n    at new Promise (<anonymous>)\n    at Object.<anonymous>.__awaiter (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:4:12)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:14:41)\n    at Object.asyncJestTest (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:106:37)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:45:12\n    at new Promise (<anonymous>)\n    at mapper (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:28:19)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:75:41\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3554663,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554657,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554653,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729276,
                                    "isTestReportAvailable": true,
                                    "duration": 130,
                                    "duration_inMinutes": 2.17,
                                    "created_at": "Dec-16-21",
                                    "created_at_rawDateFormat": "2021-12-16T07:05:09.876Z",
                                    "testCoverage": 94.53
                                }
                            },
                            {
                                "id": 430852002,
                                "gitlabId": 430852002,
                                "status": "failed",
                                "testReport": {
                                    "id": 46737,
                                    "error_count": 0,
                                    "failed_count": 3,
                                    "skipped_count": 0,
                                    "success_count": 22,
                                    "total_count": 25,
                                    "total_time": 0.15,
                                    "test_suites": [
                                        {
                                            "id": 54056,
                                            "total_time": 0.15,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 3,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 22,
                                            "test_cases": [
                                                {
                                                    "id": 3553981,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.04,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(received).toEqual(expected) // deep equality\n\n- Expected  -  70\n+ Received  + 599\n\n@@ -1,571 +1,1100 @@\n  Array [\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Page Subtitle\",\n+       \"text\": undefined,\n        \"title\": \"Page Title\",\n        \"topic\": \"Blog\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 1\",\n+           \"text\": undefined,\n            \"title\": \"Title 1\",\n            \"topic\": \"Blog 1\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Blog 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Blog 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 4\",\n+           \"text\": undefined,\n            \"title\": \"Title 4\",\n            \"topic\": \"Blog 4\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 4\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 5\",\n+           \"text\": undefined,\n            \"title\": \"Title 5\",\n            \"topic\": \"Blog 5\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 5\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 6\",\n+           \"text\": undefined,\n            \"title\": \"Title 6\",\n            \"topic\": \"Blog 6\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 6\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Blog\",\n+     \"sorting\": undefined,\n+     \"type\": undefined,\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"subTitle News\",\n+       \"text\": undefined,\n        \"title\": \"Title News\",\n        \"topic\": \"News\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": undefined,\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n+           \"lead\": undefined,\n+           \"linkText\": undefined,\n+           \"subTitle\": undefined,\n+           \"text\": undefined,\n+           \"title\": undefined,\n+           \"topic\": undefined,\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"Title 1\",\n-           \"topic\": \"Item 1\",\n+               \"topic\": \"Hallo \",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n-         \"level\": \"Level2Topic\",\n+             \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n+             \"slug\": \"Hallo \",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n+           },\n+         ],\n          \"slug\": \"Item 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Item 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Item 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"News\",\n      \"sorting\": 1,\n      \"type\": \"carousel\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n+       \"lead\": undefined,\n+       \"linkText\": undefined,\n        \"subTitle\": \"Was wir für Sie tun können.\",\n+       \"text\": undefined,\n        \"title\": \"Yes we can\",\n        \"topic\": \"Expertise\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5210d5bebbe_123%20programmer%20looking%20at%20data%20screens%201600x390.jpg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b536455bec37_simcorp_normal.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Ex 1\",\n            \"topic\": \"Branche/Kunden\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n+               \"lead\": undefined,\n+               \"linkText\": undefined,\n+               \"subTitle\": undefined,\n+               \"text\": undefined,\n+               \"title\": undefined,\n+               \"topic\": undefined,\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 1\",\n                    \"topic\": \"Topic 1\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 1\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 2\",\n                    \"topic\": \"Topic 2\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 2\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 3\",\n                    \"topic\": \"Topic 3\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 3\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n              ],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 2\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 3\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Branche/Kunden\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b52fbd5bebc1_AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b50ade5beba9_ico_SystemConsulting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Lösungen/Services\",\n            \"topic\": \"Lösungen/Services\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Lösungen/Services\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f21f5bebc2_AdobeStock_302181481_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a77c5beba2_ico_Tools_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Das Preyer Team\",\n            \"topic\": \"Das Preyer Team\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Das Preyer Team\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0fa5bebc9_AdobeStock_312736469_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b540875beb9e_ico_Reporting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Schulungen\",\n            \"topic\": \"Schulungen\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"SFTR Webinar\",\n                \"topic\": \"topic 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 2\",\n+               \"text\": undefined,\n                \"title\": \"Course 1\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 3\",\n+               \"text\": undefined,\n                \"title\": \"Course 2\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Schulungen\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Expertise\",\n      \"sorting\": 2,\n      \"type\": \"cards\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n        \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+       \"imageMobile\": undefined,\n        \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n        \"lead\": \"Preyer ist eine Strategie- und IT-Beratung für Finanzunternehmen mit Fokus auf Prozessberatung und IT-Systemlösungen. Wir überprüfen vorhandene IT-Architekturen und implementieren neue Lösungen nur dort, wo es notwendig ist. (mehr…)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Wachstum durch digitale Neuausrichtung.\",\n+       \"text\": undefined,\n        \"title\": \"Connecting Business with IT.\",\n        \"topic\": \"Unternehmen\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Verschärfte Vorgaben der Aufsichtsbehörden, niedrige Zinsen, disruptive Wettbewerber, neue Technologien und massiver Margendruck revolutionieren die Geschäftsmodelle von Banken, Vermögensverwaltern, Fondsgesellschaften, Asset Managern und anderen Finanzdienstleistern. \n  Die dadurch entstehenden strategischen Herausforderungen erfordern mutige Entscheidungen und schnelle Umsetzung. Gleiches gilt für die Einführung effektiver Prozesse und differenzierter Reportings. \n  Das Modernisieren von Geschäftsprozessen und das Implementieren innovativer Systemarchitekturen gehören in der Finanzbranche zu den größten Herausforderungen auf der Reise in eine hochdigitalisierte Welt. \n  Ob Finanz- und Risikomanagement im Treasury, Wertpapierhandel, Fondsbuchhaltung oder die Gesamtbanksteuerung: Das Optimieren von Geschäftsprozessen oder deren Neuausrichtung sind unverzichtbar für die Zukunftsfähigkeit der Finanzindustrie. \n  Innovative Systemarchitekturen sowie transformierte Prozesse und Geschäftsmodelle sind die zentralen Schlüssel für Wettbewerbsfähigkeit und künftiges Wachstum der Branche.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Banken und Finanzinstitute befinden sich an einem Wendepunkt. Nur Unternehmen, die heute ihre digitale Transformation vorantreiben und ihre Systeme modernisieren, stellen die Weichen für eine erfolgreiche Zukunft. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Ineffizienzen sind nicht länger tragbar. \",\n+           \"text\": undefined,\n            \"title\": \"Die Finanzwelt verändert sich.\",\n            \"topic\": \"Markt\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Markt\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Preyer bietet ganzheitliche Fach- und Systemberatung für Banken, Investmentgesellschaften, Versicherungen, Sparkassen und die Öffentliche Hand. \n  Stabile IT-Landschaften und effektive Systemarchitekturen verkörpern die neue Grundausstattung, wenn es um Themen wie Regulierung, Datensicherheit, Automatisierung, neue Wettbewerber oder erhöhten Kostendruck geht. \n  Gemeinsam gehen wir jedem Kundenanliegen auf den Grund und entwickeln schlagkräftige, effiziente IT-Lösungen für unterschiedlichste Projekte und Anforderungen. Pragmatisch, schnell und effektiv. Dabei bilden unsere Expertenteams die Kommunikationsbrücke zwischen den Fachbereichen und der IT. \n  Unsere Kunden profitieren von unserem ganzheitlichen Blick auf die fachlichen Anforderungen ihrer Digitalisierungs- und IT-Projekte, unserer langjährigen Praxiserfahrung als Fach- und Systemberatung im Finanzbereich und dem technologischen Know-how unserer Kompetenz-Teams. \n  Unser Ziel: Schlanke, effiziente und passgenaue Anwendungen und Prozesse, die schnell, digital und zukunftsfähig sind. Deshalb gehen wir bei jedem Projekt inhaltlich in die Tiefe und liefern Statusanalysen, Konzeption und Umsetzung aus einer Hand.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Preyer arbeitet seit Jahren erfolgreich an der technologischen Zukunftsfähigkeit von Finanzunternehmen. Gemeinsam mit unseren Kunden schaffen wir Grundlagen für digitale Geschäftsanwendungen und effiziente IT-Systemlösungen. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Fach- und Systemberatung mit echtem Mehrwert.\",\n+           \"text\": undefined,\n            \"title\": \"IT-Herausforderungen lösen.\",\n            \"topic\": \"Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n+       },\n+       Object {\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+           \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"linkText\": undefined,\n+           \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+           \"text\": undefined,\n+           \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+           \"topic\": \"Referenzen\",\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n+             \"content\": Object {\n+               \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+               \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+               \"linkText\": undefined,\n+               \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+               \"text\": undefined,\n+               \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+               \"topic\": \"Referenzen-Section\",\n+             },\n+             \"isContentOnly\": true,\n+             \"isPrimeTopic\": false,\n+             \"level\": \"Level3Topic\",\n+             \"sections\": Array [\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+                   \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"subTitle\",\n+                   \"text\": undefined,\n+                   \"title\": \"Addiko Bank Title\",\n+                   \"topic\": \"Addiko-Bank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Addiko-Bank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n                },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+                   \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"subTitle News\",\n+                   \"text\": undefined,\n+                   \"title\": \"Natixis Title\",\n+                   \"topic\": \"Natixis\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Natixis\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+                   \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"subTitle News\",\n+                   \"text\": undefined,\n+                   \"title\": \"Scotiabank Title\",\n+                   \"topic\": \"Scotiabank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Scotiabank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+             ],\n+             \"slug\": \"Referenzen-Section\",\n+             \"sorting\": 1,\n+             \"type\": \"accordion\",\n+           },\n+         ],\n+         \"slug\": \"Referenzen\",\n+         \"sorting\": 1,\n+         \"type\": undefined,\n+       },\n      ],\n      \"slug\": \"Unternehmen\",\n      \"sorting\": 3,\n      \"type\": \"textLeftImageRight\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Work for us, you know it makes sense\",\n+       \"text\": undefined,\n        \"title\": \"Yes You Can\",\n        \"topic\": \"Karriere\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f9535bebd2_064406_150708_5170.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Karriere bei Preyer\",\n            \"topic\": \"Karriere bei Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Senior Blah\",\n                \"topic\": \"Job 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Junior Blah\",\n                \"topic\": \"Job 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"workstudent\",\n+               \"text\": undefined,\n                \"title\": \"Slave\",\n                \"topic\": \"Job 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Karriere bei Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0d95bebca_vega%2Bbuerotisch.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Über Preyer\",\n            \"topic\": \"Über Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Über Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Karriere\",\n      \"sorting\": 4,\n      \"type\": \"cards\",\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:18:29\n    at Generator.next (<anonymous>)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:8:71\n    at new Promise (<anonymous>)\n    at Object.<anonymous>.__awaiter (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:4:12)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:14:41)\n    at Object.asyncJestTest (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:106:37)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:45:12\n    at new Promise (<anonymous>)\n    at mapper (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:28:19)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:75:41\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3554064,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554070,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554076,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554082,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554086,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554004,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554092,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553999,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553994,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:32:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3553989,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:19:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3554096,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554102,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554106,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554040,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554044,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554050,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554054,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554060,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554034,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554030,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554024,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554019,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554014,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554009,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729279,
                                    "isTestReportAvailable": true,
                                    "duration": 116,
                                    "duration_inMinutes": 1.93,
                                    "created_at": "Dec-16-21",
                                    "created_at_rawDateFormat": "2021-12-16T07:05:10.364Z",
                                    "testCoverage": 94.5
                                }
                            },
                            {
                                "id": 429433806,
                                "gitlabId": 429433806,
                                "status": "failed",
                                "testReport": {
                                    "id": 46740,
                                    "error_count": 0,
                                    "failed_count": 3,
                                    "skipped_count": 0,
                                    "success_count": 22,
                                    "total_count": 25,
                                    "total_time": 0.13,
                                    "test_suites": [
                                        {
                                            "id": 54057,
                                            "total_time": 0.13,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 3,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 22,
                                            "test_cases": [
                                                {
                                                    "id": 3553604,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553614,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553703,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553714,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553721,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553726,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553545,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:19:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3553731,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553535,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.05,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(received).toEqual(expected) // deep equality\n\n- Expected  -  70\n+ Received  + 599\n\n@@ -1,571 +1,1100 @@\n  Array [\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Page Subtitle\",\n+       \"text\": undefined,\n        \"title\": \"Page Title\",\n        \"topic\": \"Blog\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 1\",\n+           \"text\": undefined,\n            \"title\": \"Title 1\",\n            \"topic\": \"Blog 1\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Blog 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Blog 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 4\",\n+           \"text\": undefined,\n            \"title\": \"Title 4\",\n            \"topic\": \"Blog 4\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 4\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 5\",\n+           \"text\": undefined,\n            \"title\": \"Title 5\",\n            \"topic\": \"Blog 5\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 5\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 6\",\n+           \"text\": undefined,\n            \"title\": \"Title 6\",\n            \"topic\": \"Blog 6\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Blog 6\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Blog\",\n+     \"sorting\": undefined,\n+     \"type\": undefined,\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"subTitle News\",\n+       \"text\": undefined,\n        \"title\": \"Title News\",\n        \"topic\": \"News\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": false,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": undefined,\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n+           \"lead\": undefined,\n+           \"linkText\": undefined,\n+           \"subTitle\": undefined,\n+           \"text\": undefined,\n+           \"title\": undefined,\n+           \"topic\": undefined,\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"Title 1\",\n-           \"topic\": \"Item 1\",\n+               \"topic\": \"Hallo \",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n-         \"level\": \"Level2Topic\",\n+             \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n+             \"slug\": \"Hallo \",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n+           },\n+         ],\n          \"slug\": \"Item 1\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 2\",\n+           \"text\": undefined,\n            \"title\": \"Title 2\",\n            \"topic\": \"Item 2\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 2\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"subTitle 3\",\n+           \"text\": undefined,\n            \"title\": \"Title 3\",\n            \"topic\": \"Item 3\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Item 3\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"News\",\n      \"sorting\": 1,\n      \"type\": \"carousel\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n+       \"lead\": undefined,\n+       \"linkText\": undefined,\n        \"subTitle\": \"Was wir für Sie tun können.\",\n+       \"text\": undefined,\n        \"title\": \"Yes we can\",\n        \"topic\": \"Expertise\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5210d5bebbe_123%20programmer%20looking%20at%20data%20screens%201600x390.jpg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b536455bec37_simcorp_normal.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Ex 1\",\n            \"topic\": \"Branche/Kunden\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n+               \"lead\": undefined,\n+               \"linkText\": undefined,\n+               \"subTitle\": undefined,\n+               \"text\": undefined,\n+               \"title\": undefined,\n+               \"topic\": undefined,\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 1\",\n                    \"topic\": \"Topic 1\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 1\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 2\",\n                    \"topic\": \"Topic 2\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 2\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n                Object {\n-                 \"contact\": Object {},\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n                  \"content\": Object {\n                    \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-                   \"contact\": Object {},\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": undefined,\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": undefined,\n                    \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n                    \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+                   \"text\": undefined,\n                    \"title\": \"Title Ex 3\",\n                    \"topic\": \"Topic 3\",\n                  },\n                  \"isContentOnly\": false,\n                  \"isPrimeTopic\": false,\n                  \"level\": \"Level4Topic\",\n                  \"sections\": Array [],\n                  \"slug\": \"Topic 3\",\n+                 \"sorting\": undefined,\n+                 \"type\": undefined,\n                },\n              ],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 2\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Title Ex 3\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Branche/Kunden\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b52fbd5bebc1_AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b50ade5beba9_ico_SystemConsulting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Lösungen/Services\",\n            \"topic\": \"Lösungen/Services\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Lösungen/Services\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f21f5bebc2_AdobeStock_302181481_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a77c5beba2_ico_Tools_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Das Preyer Team\",\n            \"topic\": \"Das Preyer Team\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Das Preyer Team\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0fa5bebc9_AdobeStock_312736469_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n            \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b540875beb9e_ico_Reporting_%23ffffff.svg\",\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Schulungen\",\n            \"topic\": \"Schulungen\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 1\",\n+               \"text\": undefined,\n                \"title\": \"SFTR Webinar\",\n                \"topic\": \"topic 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 2\",\n+               \"text\": undefined,\n                \"title\": \"Course 1\",\n                \"topic\": \"topic 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n                \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-               \"contact\": Object {},\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"subTitle 3\",\n+               \"text\": undefined,\n                \"title\": \"Course 2\",\n                \"topic\": \"topic 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"topic 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Schulungen\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Expertise\",\n      \"sorting\": 2,\n      \"type\": \"cards\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n-       \"contact\": Object {},\n+       \"body\": undefined,\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n        \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+       \"imageMobile\": undefined,\n        \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n        \"lead\": \"Preyer ist eine Strategie- und IT-Beratung für Finanzunternehmen mit Fokus auf Prozessberatung und IT-Systemlösungen. Wir überprüfen vorhandene IT-Architekturen und implementieren neue Lösungen nur dort, wo es notwendig ist. (mehr…)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Wachstum durch digitale Neuausrichtung.\",\n+       \"text\": undefined,\n        \"title\": \"Connecting Business with IT.\",\n        \"topic\": \"Unternehmen\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Verschärfte Vorgaben der Aufsichtsbehörden, niedrige Zinsen, disruptive Wettbewerber, neue Technologien und massiver Margendruck revolutionieren die Geschäftsmodelle von Banken, Vermögensverwaltern, Fondsgesellschaften, Asset Managern und anderen Finanzdienstleistern. \n  Die dadurch entstehenden strategischen Herausforderungen erfordern mutige Entscheidungen und schnelle Umsetzung. Gleiches gilt für die Einführung effektiver Prozesse und differenzierter Reportings. \n  Das Modernisieren von Geschäftsprozessen und das Implementieren innovativer Systemarchitekturen gehören in der Finanzbranche zu den größten Herausforderungen auf der Reise in eine hochdigitalisierte Welt. \n  Ob Finanz- und Risikomanagement im Treasury, Wertpapierhandel, Fondsbuchhaltung oder die Gesamtbanksteuerung: Das Optimieren von Geschäftsprozessen oder deren Neuausrichtung sind unverzichtbar für die Zukunftsfähigkeit der Finanzindustrie. \n  Innovative Systemarchitekturen sowie transformierte Prozesse und Geschäftsmodelle sind die zentralen Schlüssel für Wettbewerbsfähigkeit und künftiges Wachstum der Branche.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"AdobeStock_349044023_Preview.jpeg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Banken und Finanzinstitute befinden sich an einem Wendepunkt. Nur Unternehmen, die heute ihre digitale Transformation vorantreiben und ihre Systeme modernisieren, stellen die Weichen für eine erfolgreiche Zukunft. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Ineffizienzen sind nicht länger tragbar. \",\n+           \"text\": undefined,\n            \"title\": \"Die Finanzwelt verändert sich.\",\n            \"topic\": \"Markt\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Markt\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Preyer bietet ganzheitliche Fach- und Systemberatung für Banken, Investmentgesellschaften, Versicherungen, Sparkassen und die Öffentliche Hand. \n  Stabile IT-Landschaften und effektive Systemarchitekturen verkörpern die neue Grundausstattung, wenn es um Themen wie Regulierung, Datensicherheit, Automatisierung, neue Wettbewerber oder erhöhten Kostendruck geht. \n  Gemeinsam gehen wir jedem Kundenanliegen auf den Grund und entwickeln schlagkräftige, effiziente IT-Lösungen für unterschiedlichste Projekte und Anforderungen. Pragmatisch, schnell und effektiv. Dabei bilden unsere Expertenteams die Kommunikationsbrücke zwischen den Fachbereichen und der IT. \n  Unsere Kunden profitieren von unserem ganzheitlichen Blick auf die fachlichen Anforderungen ihrer Digitalisierungs- und IT-Projekte, unserer langjährigen Praxiserfahrung als Fach- und Systemberatung im Finanzbereich und dem technologischen Know-how unserer Kompetenz-Teams. \n  Unser Ziel: Schlanke, effiziente und passgenaue Anwendungen und Prozesse, die schnell, digital und zukunftsfähig sind. Deshalb gehen wir bei jedem Projekt inhaltlich in die Tiefe und liefern Statusanalysen, Konzeption und Umsetzung aus einer Hand.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": undefined,\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Preyer arbeitet seit Jahren erfolgreich an der technologischen Zukunftsfähigkeit von Finanzunternehmen. Gemeinsam mit unseren Kunden schaffen wir Grundlagen für digitale Geschäftsanwendungen und effiziente IT-Systemlösungen. (mehr…)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Fach- und Systemberatung mit echtem Mehrwert.\",\n+           \"text\": undefined,\n            \"title\": \"IT-Herausforderungen lösen.\",\n            \"topic\": \"Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n+       },\n+       Object {\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n+         \"content\": Object {\n+           \"body\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n+           \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+           \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+           \"linkText\": undefined,\n+           \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+           \"text\": undefined,\n+           \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+           \"topic\": \"Referenzen\",\n+         },\n+         \"isContentOnly\": false,\n+         \"isPrimeTopic\": false,\n+         \"level\": \"Level2Topic\",\n+         \"sections\": Array [\n+           Object {\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n+             \"content\": Object {\n+               \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+               \"lead\": \"Seit der Gründung von Preyer vor über 15 Jahren haben wir Projekte für mehr als 200 Kunden realisiert - zur Zufriedenheit unserer Auftraggeber. Darauf sind wir auch ein bisschen stolz. Und wir freuen uns, wenn unsere Kunden unsere Arbeit positiv bewerten.\",\n+               \"linkText\": undefined,\n+               \"subTitle\": \"Zufriedene Kunden sind die Basis unseres Erfolges\",\n+               \"text\": undefined,\n+               \"title\": \"Auf Preyer können Sie sich verlassen:\",\n+               \"topic\": \"Referenzen-Section\",\n+             },\n+             \"isContentOnly\": true,\n+             \"isPrimeTopic\": false,\n+             \"level\": \"Level3Topic\",\n+             \"sections\": Array [\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+                   \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"subTitle\",\n+                   \"text\": undefined,\n+                   \"title\": \"Addiko Bank Title\",\n+                   \"topic\": \"Addiko-Bank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Addiko-Bank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n                },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+                   \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"subTitle News\",\n+                   \"text\": undefined,\n+                   \"title\": \"Natixis Title\",\n+                   \"topic\": \"Natixis\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Natixis\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+               Object {\n+                 \"contact\": Object {\n+                   \"mail\": undefined,\n+                 },\n+                 \"content\": Object {\n+                   \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n+                   \"contact\": Object {\n+                     \"mail\": undefined,\n+                   },\n+                   \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b534315bebf6_064406_150708_5275.jpg\",\n+                   \"imageMobile\": undefined,\n+                   \"imageOverlay\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b547a35beba1_ico_CompetenceTeams_%23ffffff.svg\",\n+                   \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+                   \"linkText\": undefined,\n+                   \"subTitle\": \"subTitle News\",\n+                   \"text\": undefined,\n+                   \"title\": \"Scotiabank Title\",\n+                   \"topic\": \"Scotiabank\",\n+                 },\n+                 \"isContentOnly\": false,\n+                 \"isPrimeTopic\": false,\n+                 \"level\": \"Level4Topic\",\n+                 \"sections\": Array [],\n+                 \"slug\": \"Scotiabank\",\n+                 \"sorting\": 1,\n+                 \"type\": undefined,\n+               },\n+             ],\n+             \"slug\": \"Referenzen-Section\",\n+             \"sorting\": 1,\n+             \"type\": \"accordion\",\n+           },\n+         ],\n+         \"slug\": \"Referenzen\",\n+         \"sorting\": 1,\n+         \"type\": undefined,\n+       },\n      ],\n      \"slug\": \"Unternehmen\",\n      \"sorting\": 3,\n      \"type\": \"textLeftImageRight\",\n    },\n    Object {\n-     \"contact\": Object {},\n+     \"contact\": Object {\n+       \"mail\": undefined,\n+     },\n      \"content\": Object {\n        \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-       \"contact\": Object {},\n+       \"contact\": Object {\n+         \"mail\": undefined,\n+       },\n+       \"image\": undefined,\n+       \"imageMobile\": undefined,\n+       \"imageOverlay\": undefined,\n        \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+       \"linkText\": undefined,\n        \"subTitle\": \"Work for us, you know it makes sense\",\n+       \"text\": undefined,\n        \"title\": \"Yes You Can\",\n        \"topic\": \"Karriere\",\n      },\n      \"isContentOnly\": false,\n      \"isPrimeTopic\": true,\n      \"level\": \"Level1Topic\",\n      \"sections\": Array [\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5f9535bebd2_064406_150708_5170.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Karriere bei Preyer\",\n            \"topic\": \"Karriere bei Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Senior Blah\",\n                \"topic\": \"Job 1\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 1\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+               \"text\": undefined,\n                \"title\": \"Junior Blah\",\n                \"topic\": \"Job 2\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 2\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n            Object {\n-             \"contact\": Object {},\n+             \"contact\": Object {\n+               \"mail\": undefined,\n+             },\n              \"content\": Object {\n-               \"contact\": Object {},\n+               \"body\": undefined,\n+               \"contact\": Object {\n+                 \"mail\": undefined,\n+               },\n+               \"image\": undefined,\n+               \"imageMobile\": undefined,\n+               \"imageOverlay\": undefined,\n                \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+               \"linkText\": undefined,\n                \"subTitle\": \"workstudent\",\n+               \"text\": undefined,\n                \"title\": \"Slave\",\n                \"topic\": \"Job 3\",\n              },\n              \"isContentOnly\": false,\n              \"isPrimeTopic\": false,\n              \"level\": \"Level3Topic\",\n              \"sections\": Array [],\n              \"slug\": \"Job 3\",\n+             \"sorting\": undefined,\n+             \"type\": undefined,\n            },\n          ],\n          \"slug\": \"Karriere bei Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n        Object {\n-         \"contact\": Object {},\n+         \"contact\": Object {\n+           \"mail\": undefined,\n+         },\n          \"content\": Object {\n            \"body\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\",\n-           \"contact\": Object {},\n+           \"contact\": Object {\n+             \"mail\": undefined,\n+           },\n            \"image\": \"https://assets.website-files.com/602b97b2e594b50a615beb68/602b97b2e594b5a0d95bebca_vega%2Bbuerotisch.jpg\",\n+           \"imageMobile\": undefined,\n+           \"imageOverlay\": undefined,\n            \"lead\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et (mehr...)\",\n+           \"linkText\": undefined,\n            \"subTitle\": \"Lorem ipsum dolor sit amet, consetetur sadipscing elitr\",\n+           \"text\": undefined,\n            \"title\": \"Title Über Preyer\",\n            \"topic\": \"Über Preyer\",\n          },\n          \"isContentOnly\": false,\n          \"isPrimeTopic\": false,\n          \"level\": \"Level2Topic\",\n          \"sections\": Array [],\n          \"slug\": \"Über Preyer\",\n+         \"sorting\": undefined,\n+         \"type\": undefined,\n        },\n      ],\n      \"slug\": \"Karriere\",\n      \"sorting\": 4,\n      \"type\": \"cards\",\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:18:29\n    at Generator.next (<anonymous>)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:8:71\n    at new Promise (<anonymous>)\n    at Object.<anonymous>.__awaiter (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:4:12)\n    at Object.<anonymous> (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/utils/sharepoint-website-mapper.spec.ts:14:41)\n    at Object.asyncJestTest (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/jasmineAsyncInstall.js:106:37)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:45:12\n    at new Promise (<anonymous>)\n    at mapper (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:28:19)\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/node_modules/jest-jasmine2/build/queueRunner.js:75:41\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3553565,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553575,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553585,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553595,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553555,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "failed",
                                                    "system_output": "Error: expect(jest.fn()).toHaveBeenCalledTimes(expected)\n\nExpected number of calls: 1\nReceived number of calls: 0\n    at /builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:32:23\n    at Generator.next (<anonymous>)\n    at fulfilled (/builds/w11k-devs/customers/preyer/preyer-web/gatsby-app/src/common/api/token-api.spec.ts:5:58)\n    at processTicksAndRejections (node:internal/process/task_queues:96:5)"
                                                },
                                                {
                                                    "id": 3553693,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553683,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553673,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553663,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553653,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553646,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553634,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553624,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553737,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553742,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553748,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729278,
                                    "isTestReportAvailable": true,
                                    "duration": 115,
                                    "duration_inMinutes": 1.92,
                                    "created_at": "Dec-14-21",
                                    "created_at_rawDateFormat": "2021-12-14T07:05:10.269Z",
                                    "testCoverage": 94.5
                                }
                            },
                            {
                                "id": 421746765,
                                "gitlabId": 421746765,
                                "status": "success",
                                "testReport": {
                                    "id": 46717,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.11,
                                    "test_suites": [
                                        {
                                            "id": 54058,
                                            "total_time": 0.11,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3552942,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552911,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552907,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552901,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553024,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553019,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553014,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553009,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553004,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552999,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552994,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552989,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552984,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552979,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552974,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552969,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552963,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552958,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552952,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552948,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552939,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552931,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552927,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552921,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552917,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729280,
                                    "isTestReportAvailable": true,
                                    "duration": 97,
                                    "duration_inMinutes": 1.62,
                                    "created_at": "Dec-03-21",
                                    "created_at_rawDateFormat": "2021-12-03T07:05:10.556Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 421746574,
                                "gitlabId": 421746574,
                                "status": "success",
                                "testReport": {
                                    "id": 46718,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.16,
                                    "test_suites": [
                                        {
                                            "id": 54061,
                                            "total_time": 0.16,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3558515,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558570,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558565,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558560,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558555,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558550,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558545,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558540,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558535,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558530,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558525,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558520,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558575,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558490,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0.03,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558495,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558500,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558505,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.02,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558510,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558616,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558606,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558600,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558594,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558590,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558585,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558580,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729282,
                                    "isTestReportAvailable": true,
                                    "duration": 100,
                                    "duration_inMinutes": 1.67,
                                    "created_at": "Dec-03-21",
                                    "created_at_rawDateFormat": "2021-12-03T07:05:10.809Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 421723986,
                                "gitlabId": 421723986,
                                "status": "success",
                                "testReport": {
                                    "id": 46719,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.12,
                                    "test_suites": [
                                        {
                                            "id": 54059,
                                            "total_time": 0.12,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3562161,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562171,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562231,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562241,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562250,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562260,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562270,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562280,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562181,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562191,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562201,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562211,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562221,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562289,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562299,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562067,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562073,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562083,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562093,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562102,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562112,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562122,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562131,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562141,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562151,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729281,
                                    "isTestReportAvailable": true,
                                    "duration": 102,
                                    "duration_inMinutes": 1.7,
                                    "created_at": "Dec-03-21",
                                    "created_at_rawDateFormat": "2021-12-03T07:05:10.674Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 421694645,
                                "gitlabId": 421694645,
                                "status": "success",
                                "testReport": {
                                    "id": 46721,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.11,
                                    "test_suites": [
                                        {
                                            "id": 54060,
                                            "total_time": 0.11,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3554098,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554103,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554108,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554063,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554180,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554113,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554118,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554123,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554073,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554078,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554128,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554133,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554138,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554093,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554088,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554083,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554168,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554163,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554158,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554153,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554148,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554143,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554068,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554174,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554058,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.02,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729284,
                                    "isTestReportAvailable": true,
                                    "duration": 92,
                                    "duration_inMinutes": 1.53,
                                    "created_at": "Dec-03-21",
                                    "created_at_rawDateFormat": "2021-12-03T07:05:10.997Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 418083966,
                                "gitlabId": 418083966,
                                "status": "success",
                                "testReport": {
                                    "id": 46724,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.09,
                                    "test_suites": [
                                        {
                                            "id": 54063,
                                            "total_time": 0.09,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3554825,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554845,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554855,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554865,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554874,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554951,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554961,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554971,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554981,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554884,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554894,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554903,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554909,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554915,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554919,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554925,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554931,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554805,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554795,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554785,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554775,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554765,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554941,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554815,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554835,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729283,
                                    "isTestReportAvailable": true,
                                    "duration": 112,
                                    "duration_inMinutes": 1.87,
                                    "created_at": "Nov-29-21",
                                    "created_at_rawDateFormat": "2021-11-29T07:05:10.964Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 402062728,
                                "gitlabId": 402062728,
                                "status": "success",
                                "testReport": {
                                    "id": 46722,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.12,
                                    "test_suites": [
                                        {
                                            "id": 54062,
                                            "total_time": 0.12,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3553655,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553650,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553645,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553640,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553636,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553630,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553626,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553620,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553616,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553610,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553606,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553600,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553597,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553670,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553675,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553680,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553685,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553690,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553695,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553710,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553698,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553705,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553665,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553660,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553591,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729285,
                                    "isTestReportAvailable": true,
                                    "duration": 102,
                                    "duration_inMinutes": 1.7,
                                    "created_at": "Nov-04-21",
                                    "created_at_rawDateFormat": "2021-11-04T07:05:11.123Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 401873346,
                                "gitlabId": 401873346,
                                "status": "success",
                                "testReport": {
                                    "id": 46723,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.16,
                                    "test_suites": [
                                        {
                                            "id": 54064,
                                            "total_time": 0.16,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3553069,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553057,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553047,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553037,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553027,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553018,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553008,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552998,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552988,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552978,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552967,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552957,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552947,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552938,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552932,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552928,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.02,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552922,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552918,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553099,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553094,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553089,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553085,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553079,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553075,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553067,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729287,
                                    "isTestReportAvailable": true,
                                    "duration": 133,
                                    "duration_inMinutes": 2.22,
                                    "created_at": "Nov-04-21",
                                    "created_at_rawDateFormat": "2021-11-04T07:05:11.248Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 401865469,
                                "gitlabId": 401865469,
                                "status": "success",
                                "testReport": {
                                    "id": 46725,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.12,
                                    "test_suites": [
                                        {
                                            "id": 54065,
                                            "total_time": 0.12,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3562423,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562324,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562320,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562314,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562310,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.02,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562304,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562379,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562373,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562369,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562363,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562360,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562354,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562350,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562383,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562389,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562393,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562399,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562403,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562344,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562340,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562334,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562330,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562409,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562413,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562419,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729288,
                                    "isTestReportAvailable": true,
                                    "duration": 99,
                                    "duration_inMinutes": 1.65,
                                    "created_at": "Nov-04-21",
                                    "created_at_rawDateFormat": "2021-11-04T07:05:11.285Z",
                                    "testCoverage": 96.7
                                }
                            },
                            {
                                "id": 401750929,
                                "gitlabId": 401750929,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729291,
                                    "isTestReportAvailable": false,
                                    "duration": 215,
                                    "duration_inMinutes": 3.58,
                                    "created_at": "Nov-04-21",
                                    "created_at_rawDateFormat": "2021-11-04T07:05:11.674Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 401744483,
                                "gitlabId": 401744483,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729309,
                                    "isTestReportAvailable": false,
                                    "duration": 204,
                                    "duration_inMinutes": 3.4,
                                    "created_at": "Nov-04-21",
                                    "created_at_rawDateFormat": "2021-11-04T07:05:12.958Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 401743418,
                                "gitlabId": 401743418,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729290,
                                    "isTestReportAvailable": false,
                                    "duration": 7,
                                    "duration_inMinutes": 0.12,
                                    "created_at": "Nov-04-21",
                                    "created_at_rawDateFormat": "2021-11-04T07:05:11.578Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 401704763,
                                "gitlabId": 401704763,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729289,
                                    "isTestReportAvailable": false,
                                    "duration": 197,
                                    "duration_inMinutes": 3.28,
                                    "created_at": "Nov-04-21",
                                    "created_at_rawDateFormat": "2021-11-04T07:05:11.537Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 401694667,
                                "gitlabId": 401694667,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729292,
                                    "isTestReportAvailable": false,
                                    "duration": 241,
                                    "duration_inMinutes": 4.02,
                                    "created_at": "Nov-04-21",
                                    "created_at_rawDateFormat": "2021-11-04T07:05:11.787Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 401224685,
                                "gitlabId": 401224685,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729293,
                                    "isTestReportAvailable": false,
                                    "duration": 195,
                                    "duration_inMinutes": 3.25,
                                    "created_at": "Nov-03-21",
                                    "created_at_rawDateFormat": "2021-11-03T07:05:11.828Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 401223839,
                                "gitlabId": 401223839,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729294,
                                    "isTestReportAvailable": false,
                                    "duration": 7,
                                    "duration_inMinutes": 0.12,
                                    "created_at": "Nov-03-21",
                                    "created_at_rawDateFormat": "2021-11-03T07:05:12.042Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 401203847,
                                "gitlabId": 401203847,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729295,
                                    "isTestReportAvailable": false,
                                    "duration": 196,
                                    "duration_inMinutes": 3.27,
                                    "created_at": "Nov-03-21",
                                    "created_at_rawDateFormat": "2021-11-03T07:05:12.054Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 401193452,
                                "gitlabId": 401193452,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729296,
                                    "isTestReportAvailable": false,
                                    "duration": 198,
                                    "duration_inMinutes": 3.3,
                                    "created_at": "Nov-03-21",
                                    "created_at_rawDateFormat": "2021-11-03T07:05:12.089Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 401191657,
                                "gitlabId": 401191657,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729301,
                                    "isTestReportAvailable": false,
                                    "duration": 201,
                                    "duration_inMinutes": 3.35,
                                    "created_at": "Nov-03-21",
                                    "created_at_rawDateFormat": "2021-11-03T07:05:12.479Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 398466988,
                                "gitlabId": 398466988,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729297,
                                    "isTestReportAvailable": false,
                                    "duration": 186,
                                    "duration_inMinutes": 3.1,
                                    "created_at": "Oct-29-21",
                                    "created_at_rawDateFormat": "2021-10-29T07:05:12.338Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 379522317,
                                "gitlabId": 379522317,
                                "status": "success",
                                "testReport": {
                                    "id": 46726,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.09,
                                    "test_suites": [
                                        {
                                            "id": 54066,
                                            "total_time": 0.09,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3554094,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554187,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554177,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554171,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554164,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554160,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554154,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554150,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554144,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554140,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554134,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554110,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554114,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554104,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554130,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554100,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554120,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554124,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554080,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554074,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554071,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554065,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554061,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554084,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554090,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729298,
                                    "isTestReportAvailable": true,
                                    "duration": 89,
                                    "duration_inMinutes": 1.48,
                                    "created_at": "Sep-29-21",
                                    "created_at_rawDateFormat": "2021-09-29T07:05:12.373Z",
                                    "testCoverage": 96.61
                                }
                            },
                            {
                                "id": 362415287,
                                "gitlabId": 362415287,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729302,
                                    "isTestReportAvailable": false,
                                    "duration": 237,
                                    "duration_inMinutes": 3.95,
                                    "created_at": "Aug-31-21",
                                    "created_at_rawDateFormat": "2021-08-31T07:05:12.590Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 362255692,
                                "gitlabId": 362255692,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729303,
                                    "isTestReportAvailable": false,
                                    "duration": 65,
                                    "duration_inMinutes": 1.08,
                                    "created_at": "Aug-31-21",
                                    "created_at_rawDateFormat": "2021-08-31T07:05:12.615Z",
                                    "testCoverage": 96.61
                                }
                            },
                            {
                                "id": 362225924,
                                "gitlabId": 362225924,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729304,
                                    "isTestReportAvailable": false,
                                    "duration": 50,
                                    "duration_inMinutes": 0.83,
                                    "created_at": "Aug-31-21",
                                    "created_at_rawDateFormat": "2021-08-31T07:05:12.729Z",
                                    "testCoverage": 96.63
                                }
                            },
                            {
                                "id": 361612009,
                                "gitlabId": 361612009,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729308,
                                    "isTestReportAvailable": false,
                                    "duration": 56,
                                    "duration_inMinutes": 0.93,
                                    "created_at": "Aug-30-21",
                                    "created_at_rawDateFormat": "2021-08-30T07:05:12.889Z",
                                    "testCoverage": 96.63
                                }
                            },
                            {
                                "id": 361572851,
                                "gitlabId": 361572851,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729305,
                                    "isTestReportAvailable": false,
                                    "duration": 79,
                                    "duration_inMinutes": 1.32,
                                    "created_at": "Aug-30-21",
                                    "created_at_rawDateFormat": "2021-08-30T07:05:12.737Z",
                                    "testCoverage": 96.63
                                }
                            },
                            {
                                "id": 360736253,
                                "gitlabId": 360736253,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729306,
                                    "isTestReportAvailable": false,
                                    "duration": 83,
                                    "duration_inMinutes": 1.38,
                                    "created_at": "Aug-27-21",
                                    "created_at_rawDateFormat": "2021-08-27T07:05:12.835Z",
                                    "testCoverage": 96.63
                                }
                            },
                            {
                                "id": 360600906,
                                "gitlabId": 360600906,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729307,
                                    "isTestReportAvailable": false,
                                    "duration": 51,
                                    "duration_inMinutes": 0.85,
                                    "created_at": "Aug-27-21",
                                    "created_at_rawDateFormat": "2021-08-27T07:05:12.885Z",
                                    "testCoverage": 96.63
                                }
                            },
                            {
                                "id": 360600354,
                                "gitlabId": 360600354,
                                "status": "success",
                                "testReport": {
                                    "id": 46727,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.1,
                                    "test_suites": [
                                        {
                                            "id": 54067,
                                            "total_time": 0.1,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3553659,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553684,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553689,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553694,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553699,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553704,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553679,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553709,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553713,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553718,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553722,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553728,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553615,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.02,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553619,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553625,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553629,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553635,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553639,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553644,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553649,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553654,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553674,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553669,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553664,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553609,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729311,
                                    "isTestReportAvailable": true,
                                    "duration": 86,
                                    "duration_inMinutes": 1.43,
                                    "created_at": "Aug-27-21",
                                    "created_at_rawDateFormat": "2021-08-27T07:05:13.019Z",
                                    "testCoverage": 96.61
                                }
                            },
                            {
                                "id": 345385243,
                                "gitlabId": 345385243,
                                "status": "success",
                                "testReport": {
                                    "id": 46729,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 25,
                                    "total_count": 25,
                                    "total_time": 0.11,
                                    "test_suites": [
                                        {
                                            "id": 54068,
                                            "total_time": 0.11,
                                            "total_count": 25,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 25,
                                            "test_cases": [
                                                {
                                                    "id": 3552993,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553100,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553095,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553090,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553086,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553080,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553076,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553070,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553063,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553053,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553043,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553033,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553023,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553013,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553003,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552983,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552973,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552968,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552962,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552956,
                                                    "classname": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-api saveJobApplicationToSharepoint() uploads files and posts the form",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552946,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552936,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552933,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552929,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552923,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729310,
                                    "isTestReportAvailable": true,
                                    "duration": 48,
                                    "duration_inMinutes": 0.8,
                                    "created_at": "Jul-30-21",
                                    "created_at_rawDateFormat": "2021-07-30T07:05:13.015Z",
                                    "testCoverage": 96.51
                                }
                            },
                            {
                                "id": 339804254,
                                "gitlabId": 339804254,
                                "status": "success",
                                "testReport": {
                                    "id": 46728,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 24,
                                    "total_time": 0.18,
                                    "test_suites": [
                                        {
                                            "id": 54071,
                                            "total_time": 0.18,
                                            "total_count": 24,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3558569,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558524,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0.02,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558529,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558534,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558539,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558564,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558559,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558554,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558549,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558544,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558514,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558519,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558618,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558612,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558608,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558504,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558509,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558602,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558599,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558593,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558589,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558584,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558579,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558574,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729315,
                                    "isTestReportAvailable": true,
                                    "duration": 64,
                                    "duration_inMinutes": 1.07,
                                    "created_at": "Jul-20-21",
                                    "created_at_rawDateFormat": "2021-07-20T07:05:13.355Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 339199810,
                                "gitlabId": 339199810,
                                "status": "success",
                                "testReport": {
                                    "id": 46730,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 24,
                                    "total_time": 0.08,
                                    "test_suites": [
                                        {
                                            "id": 54069,
                                            "total_time": 0.08,
                                            "total_count": 24,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3562437,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562456,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562466,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562476,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562485,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562339,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562329,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562319,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562309,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562495,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562504,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562514,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562524,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562534,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562398,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562388,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562378,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562368,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562359,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562349,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562418,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562408,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562428,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562447,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729313,
                                    "isTestReportAvailable": true,
                                    "duration": 46,
                                    "duration_inMinutes": 0.77,
                                    "created_at": "Jul-19-21",
                                    "created_at_rawDateFormat": "2021-07-19T07:05:13.312Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 337708675,
                                "gitlabId": 337708675,
                                "status": "success",
                                "testReport": {
                                    "id": 46731,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 24,
                                    "total_time": 0.16,
                                    "test_suites": [
                                        {
                                            "id": 54070,
                                            "total_time": 0.16,
                                            "total_count": 24,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3554193,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554219,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554213,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554131,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554189,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554183,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554179,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554173,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554170,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554165,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554161,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554155,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554151,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554209,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554145,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554135,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554141,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554125,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554203,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554199,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554105,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554111,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.02,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554115,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554121,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729314,
                                    "isTestReportAvailable": true,
                                    "duration": 64,
                                    "duration_inMinutes": 1.07,
                                    "created_at": "Jul-15-21",
                                    "created_at_rawDateFormat": "2021-07-15T07:05:13.340Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 336133993,
                                "gitlabId": 336133993,
                                "status": "success",
                                "testReport": {
                                    "id": 46732,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 24,
                                    "total_time": 0.16,
                                    "test_suites": [
                                        {
                                            "id": 54073,
                                            "total_time": 0.16,
                                            "total_count": 24,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3554772,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554872,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554868,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554862,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554858,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554852,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554848,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554842,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554838,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554832,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554828,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554822,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554818,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554812,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554808,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554802,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554798,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554792,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554878,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554788,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554782,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554778,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554768,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554762,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729316,
                                    "isTestReportAvailable": true,
                                    "duration": 70,
                                    "duration_inMinutes": 1.17,
                                    "created_at": "Jul-13-21",
                                    "created_at_rawDateFormat": "2021-07-13T07:05:13.361Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 330063679,
                                "gitlabId": 330063679,
                                "status": "success",
                                "testReport": {
                                    "id": 46733,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 24,
                                    "total_time": 0.14,
                                    "test_suites": [
                                        {
                                            "id": 54072,
                                            "total_time": 0.14,
                                            "total_count": 24,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3553752,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553741,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553736,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553730,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553617,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553720,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553716,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553622,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553628,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553632,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553638,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553642,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553648,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553657,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553667,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553677,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553687,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553697,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553702,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553707,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553712,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553725,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553757,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553747,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729317,
                                    "isTestReportAvailable": true,
                                    "duration": 54,
                                    "duration_inMinutes": 0.9,
                                    "created_at": "Jul-01-21",
                                    "created_at_rawDateFormat": "2021-07-01T07:05:13.386Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 330049825,
                                "gitlabId": 330049825,
                                "status": "success",
                                "testReport": {
                                    "id": 46734,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 24,
                                    "total_time": 0.16,
                                    "test_suites": [
                                        {
                                            "id": 54074,
                                            "total_time": 0.16,
                                            "total_count": 24,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3553032,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553028,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553022,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553017,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553048,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553042,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553038,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553012,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553007,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553002,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553052,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553058,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552997,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553062,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552992,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552987,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553072,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553082,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553091,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553101,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552982,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552977,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552972,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552966,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729312,
                                    "isTestReportAvailable": true,
                                    "duration": 54,
                                    "duration_inMinutes": 0.9,
                                    "created_at": "Jul-01-21",
                                    "created_at_rawDateFormat": "2021-07-01T07:05:13.308Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 330049248,
                                "gitlabId": 330049248,
                                "status": "success",
                                "testReport": {
                                    "id": 46736,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 24,
                                    "total_time": 0.16,
                                    "test_suites": [
                                        {
                                            "id": 54075,
                                            "total_time": 0.16,
                                            "total_count": 24,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3562496,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562505,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562448,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562519,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562525,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562529,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562486,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562480,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562477,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562471,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562538,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562535,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562451,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562457,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562438,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562432,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562429,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562490,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562467,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562461,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562509,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562515,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562442,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562500,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729318,
                                    "isTestReportAvailable": true,
                                    "duration": 63,
                                    "duration_inMinutes": 1.05,
                                    "created_at": "Jul-01-21",
                                    "created_at_rawDateFormat": "2021-07-01T07:05:13.589Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 329478672,
                                "gitlabId": 329478672,
                                "status": "success",
                                "testReport": {
                                    "id": 46739,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 24,
                                    "total_time": 0.15,
                                    "test_suites": [
                                        {
                                            "id": 54076,
                                            "total_time": 0.15,
                                            "total_count": 24,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3554256,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554112,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554116,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554122,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554126,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554132,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554136,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554142,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554146,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554152,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554156,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554162,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554166,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554176,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554186,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554196,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554206,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554216,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554226,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554236,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554246,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554266,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554276,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554286,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729319,
                                    "isTestReportAvailable": true,
                                    "duration": 58,
                                    "duration_inMinutes": 0.97,
                                    "created_at": "Jun-30-21",
                                    "created_at_rawDateFormat": "2021-06-30T07:05:13.625Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 328986632,
                                "gitlabId": 328986632,
                                "status": "success",
                                "testReport": {
                                    "id": 46735,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 24,
                                    "total_time": 0.18,
                                    "test_suites": [
                                        {
                                            "id": 54077,
                                            "total_time": 0.18,
                                            "total_count": 24,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3553031,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553026,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553021,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553016,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553097,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553092,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553087,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553081,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553077,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553071,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553066,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553061,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553056,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553051,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553046,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553041,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553036,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3552996,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553001,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.02,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553006,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553011,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553112,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553107,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553102,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729321,
                                    "isTestReportAvailable": true,
                                    "duration": 62,
                                    "duration_inMinutes": 1.03,
                                    "created_at": "Jun-29-21",
                                    "created_at_rawDateFormat": "2021-06-29T07:05:13.637Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 328968395,
                                "gitlabId": 328968395,
                                "status": "success",
                                "testReport": {
                                    "id": 46738,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 24,
                                    "total_time": 0.15,
                                    "test_suites": [
                                        {
                                            "id": 54078,
                                            "total_time": 0.15,
                                            "total_count": 24,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3553173,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553020,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553025,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553030,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553035,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553040,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553045,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553050,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553055,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553060,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553065,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553073,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553083,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553096,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553106,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553116,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553126,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553136,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553144,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553150,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553157,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553163,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553167,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553177,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729346,
                                    "isTestReportAvailable": true,
                                    "duration": 62,
                                    "duration_inMinutes": 1.03,
                                    "created_at": "Jun-29-21",
                                    "created_at_rawDateFormat": "2021-06-29T07:05:15.542Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 328924783,
                                "gitlabId": 328924783,
                                "status": "success",
                                "testReport": {
                                    "id": 46743,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 24,
                                    "total_time": 0.18,
                                    "test_suites": [
                                        {
                                            "id": 54082,
                                            "total_time": 0.18,
                                            "total_count": 24,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3558687,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558727,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558731,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558737,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558647,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558681,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558677,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558671,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558667,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558661,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558657,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558651,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558721,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558717,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558711,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558707,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558701,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558697,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558691,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558622,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.04,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558628,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558632,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558638,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558641,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729320,
                                    "isTestReportAvailable": true,
                                    "duration": 70,
                                    "duration_inMinutes": 1.17,
                                    "created_at": "Jun-29-21",
                                    "created_at_rawDateFormat": "2021-06-29T07:05:13.626Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 328804155,
                                "gitlabId": 328804155,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729322,
                                    "isTestReportAvailable": false,
                                    "duration": 15,
                                    "duration_inMinutes": 0.25,
                                    "created_at": "Jun-29-21",
                                    "created_at_rawDateFormat": "2021-06-29T07:05:13.648Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 328345877,
                                "gitlabId": 328345877,
                                "status": "success",
                                "testReport": {
                                    "id": 46741,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 24,
                                    "total_time": 0.16,
                                    "test_suites": [
                                        {
                                            "id": 54079,
                                            "total_time": 0.16,
                                            "total_count": 24,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3562498,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562552,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562559,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562565,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562569,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562575,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562595,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562599,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562605,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562488,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562492,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562579,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562585,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562589,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562547,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562541,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562537,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562531,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562527,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562521,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562517,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562511,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562507,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562502,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729323,
                                    "isTestReportAvailable": true,
                                    "duration": 56,
                                    "duration_inMinutes": 0.93,
                                    "created_at": "Jun-28-21",
                                    "created_at_rawDateFormat": "2021-06-28T07:05:13.841Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 328180217,
                                "gitlabId": 328180217,
                                "status": "success",
                                "testReport": {
                                    "id": 46744,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 24,
                                    "total_time": 0.15,
                                    "test_suites": [
                                        {
                                            "id": 54080,
                                            "total_time": 0.15,
                                            "total_count": 24,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3554262,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554268,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554272,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554278,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554258,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554252,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554248,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554242,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554241,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554235,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554231,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554225,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554221,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554215,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554211,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554205,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554201,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554195,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0.01,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554191,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554157,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554185,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554181,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554175,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554167,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729324,
                                    "isTestReportAvailable": true,
                                    "duration": 55,
                                    "duration_inMinutes": 0.92,
                                    "created_at": "Jun-28-21",
                                    "created_at_rawDateFormat": "2021-06-28T07:05:13.895Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 328155309,
                                "gitlabId": 328155309,
                                "status": "success",
                                "testReport": {
                                    "id": 46742,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 24,
                                    "total_time": 0.16,
                                    "test_suites": [
                                        {
                                            "id": 54081,
                                            "total_time": 0.16,
                                            "total_count": 24,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3554870,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554896,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554890,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554885,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554820,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554824,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554830,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554834,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554880,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554840,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554844,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554850,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554854,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554860,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554864,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554784,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554875,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554902,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554814,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554810,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554804,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554800,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554794,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554790,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729327,
                                    "isTestReportAvailable": true,
                                    "duration": 56,
                                    "duration_inMinutes": 0.93,
                                    "created_at": "Jun-28-21",
                                    "created_at_rawDateFormat": "2021-06-28T07:05:13.974Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 328089398,
                                "gitlabId": 328089398,
                                "status": "success",
                                "testReport": {
                                    "id": 46745,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 24,
                                    "total_time": 0.15,
                                    "test_suites": [
                                        {
                                            "id": 54083,
                                            "total_time": 0.15,
                                            "total_count": 24,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3553059,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553142,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553138,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553133,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553128,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553123,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553118,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553113,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553108,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553103,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553098,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553093,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553088,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553084,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553078,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553074,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553068,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553064,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553054,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553049,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553044,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553039,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.02,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553034,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553029,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729325,
                                    "isTestReportAvailable": true,
                                    "duration": 57,
                                    "duration_inMinutes": 0.95,
                                    "created_at": "Jun-28-21",
                                    "created_at_rawDateFormat": "2021-06-28T07:05:13.918Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 328089014,
                                "gitlabId": 328089014,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729326,
                                    "isTestReportAvailable": false,
                                    "duration": 58,
                                    "duration_inMinutes": 0.97,
                                    "created_at": "Jun-28-21",
                                    "created_at_rawDateFormat": "2021-06-28T07:05:13.957Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 328087434,
                                "gitlabId": 328087434,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729329,
                                    "isTestReportAvailable": false,
                                    "duration": 56,
                                    "duration_inMinutes": 0.93,
                                    "created_at": "Jun-28-21",
                                    "created_at_rawDateFormat": "2021-06-28T07:05:14.156Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 328085827,
                                "gitlabId": 328085827,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729328,
                                    "isTestReportAvailable": false,
                                    "duration": 56,
                                    "duration_inMinutes": 0.93,
                                    "created_at": "Jun-28-21",
                                    "created_at_rawDateFormat": "2021-06-28T07:05:14.151Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 328082357,
                                "gitlabId": 328082357,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729330,
                                    "isTestReportAvailable": false,
                                    "duration": 57,
                                    "duration_inMinutes": 0.95,
                                    "created_at": "Jun-28-21",
                                    "created_at_rawDateFormat": "2021-06-28T07:05:14.228Z",
                                    "testCoverage": 95.86
                                }
                            },
                            {
                                "id": 328081875,
                                "gitlabId": 328081875,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729331,
                                    "isTestReportAvailable": false,
                                    "duration": 54,
                                    "duration_inMinutes": 0.9,
                                    "created_at": "Jun-28-21",
                                    "created_at_rawDateFormat": "2021-06-28T07:05:14.232Z",
                                    "testCoverage": 95.86
                                }
                            },
                            {
                                "id": 327192174,
                                "gitlabId": 327192174,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729332,
                                    "isTestReportAvailable": false,
                                    "duration": 85,
                                    "duration_inMinutes": 1.42,
                                    "created_at": "Jun-25-21",
                                    "created_at_rawDateFormat": "2021-06-25T07:05:14.244Z",
                                    "testCoverage": 95.86
                                }
                            },
                            {
                                "id": 327188454,
                                "gitlabId": 327188454,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729334,
                                    "isTestReportAvailable": false,
                                    "duration": 95,
                                    "duration_inMinutes": 1.58,
                                    "created_at": "Jun-25-21",
                                    "created_at_rawDateFormat": "2021-06-25T07:05:14.419Z",
                                    "testCoverage": 95.86
                                }
                            },
                            {
                                "id": 327109450,
                                "gitlabId": 327109450,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729333,
                                    "isTestReportAvailable": false,
                                    "duration": 84,
                                    "duration_inMinutes": 1.4,
                                    "created_at": "Jun-25-21",
                                    "created_at_rawDateFormat": "2021-06-25T07:05:14.417Z",
                                    "testCoverage": 95.86
                                }
                            },
                            {
                                "id": 327055650,
                                "gitlabId": 327055650,
                                "status": "success",
                                "testReport": {
                                    "id": 46747,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 24,
                                    "total_time": 0.17,
                                    "test_suites": [
                                        {
                                            "id": 54084,
                                            "total_time": 0.17,
                                            "total_count": 24,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3553199,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553209,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553219,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553229,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553239,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553109,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553114,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553104,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553119,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553124,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553249,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553254,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553129,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553134,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553139,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553146,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553149,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553159,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553169,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553280,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553271,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553261,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553179,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553189,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729337,
                                    "isTestReportAvailable": true,
                                    "duration": 84,
                                    "duration_inMinutes": 1.4,
                                    "created_at": "Jun-25-21",
                                    "created_at_rawDateFormat": "2021-06-25T07:05:14.636Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 326432823,
                                "gitlabId": 326432823,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729336,
                                    "isTestReportAvailable": false,
                                    "duration": 144,
                                    "duration_inMinutes": 2.4,
                                    "created_at": "Jun-24-21",
                                    "created_at_rawDateFormat": "2021-06-24T07:05:14.528Z",
                                    "testCoverage": 95.86
                                }
                            },
                            {
                                "id": 326431826,
                                "gitlabId": 326431826,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729335,
                                    "isTestReportAvailable": false,
                                    "duration": 77,
                                    "duration_inMinutes": 1.28,
                                    "created_at": "Jun-24-21",
                                    "created_at_rawDateFormat": "2021-06-24T07:05:14.484Z",
                                    "testCoverage": 95.86
                                }
                            },
                            {
                                "id": 325937329,
                                "gitlabId": 325937329,
                                "status": "success",
                                "testReport": {
                                    "id": 46746,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 24,
                                    "total_count": 24,
                                    "total_time": 0.17,
                                    "test_suites": [
                                        {
                                            "id": 54085,
                                            "total_time": 0.17,
                                            "total_count": 24,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 24,
                                            "test_cases": [
                                                {
                                                    "id": 3562709,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562769,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562759,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562611,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562602,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562592,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562739,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562749,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562699,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562620,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562630,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562639,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562649,
                                                    "classname": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() uses mobile pic for smaller screens with local url",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562659,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562669,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562679,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562689,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562729,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562719,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562543,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562553,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562562,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562572,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562582,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729349,
                                    "isTestReportAvailable": true,
                                    "duration": 287,
                                    "duration_inMinutes": 4.78,
                                    "created_at": "Jun-23-21",
                                    "created_at_rawDateFormat": "2021-06-23T07:05:15.742Z",
                                    "testCoverage": 95.95
                                }
                            },
                            {
                                "id": 325927891,
                                "gitlabId": 325927891,
                                "status": "success",
                                "testReport": {
                                    "id": 46750,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 22,
                                    "total_count": 22,
                                    "total_time": 0.2,
                                    "test_suites": [
                                        {
                                            "id": 54086,
                                            "total_time": 0.2,
                                            "total_count": 22,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 22,
                                            "test_cases": [
                                                {
                                                    "id": 3554220,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554210,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554204,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554200,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554194,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554190,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554224,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554291,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554285,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554281,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554275,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554271,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554265,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554261,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554255,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554251,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554245,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554240,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554230,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554184,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.06,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554234,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554214,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729339,
                                    "isTestReportAvailable": true,
                                    "duration": 296,
                                    "duration_inMinutes": 4.93,
                                    "created_at": "Jun-23-21",
                                    "created_at_rawDateFormat": "2021-06-23T07:05:14.862Z",
                                    "testCoverage": 95.86
                                }
                            },
                            {
                                "id": 325922150,
                                "gitlabId": 325922150,
                                "status": "success",
                                "testReport": {
                                    "id": 46748,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 22,
                                    "total_count": 22,
                                    "total_time": 0.15,
                                    "test_suites": [
                                        {
                                            "id": 54087,
                                            "total_time": 0.15,
                                            "total_count": 22,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 22,
                                            "test_cases": [
                                                {
                                                    "id": 3553162,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553105,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553216,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553212,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553206,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553202,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553196,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553192,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553186,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553182,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553176,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553172,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553166,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553156,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553151,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553145,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553135,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553130,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553125,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553120,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553115,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553110,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729373,
                                    "isTestReportAvailable": true,
                                    "duration": 295,
                                    "duration_inMinutes": 4.92,
                                    "created_at": "Jun-23-21",
                                    "created_at_rawDateFormat": "2021-06-23T07:05:18.123Z",
                                    "testCoverage": 95.86
                                }
                            },
                            {
                                "id": 325855716,
                                "gitlabId": 325855716,
                                "status": "success",
                                "testReport": {
                                    "id": 46749,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 22,
                                    "total_count": 22,
                                    "total_time": 0.16,
                                    "test_suites": [
                                        {
                                            "id": 54089,
                                            "total_time": 0.16,
                                            "total_count": 22,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 22,
                                            "test_cases": [
                                                {
                                                    "id": 3554849,
                                                    "classname": "useAssetUrl() rewrites local url to assets folder",
                                                    "execution_time": 0,
                                                    "name": "useAssetUrl() rewrites local url to assets folder",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554813,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554819,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554823,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554829,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554833,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554839,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554843,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554853,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554859,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554863,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554869,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554873,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554879,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554883,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554889,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554893,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554899,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554905,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554906,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554912,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554809,
                                                    "classname": "useAssetUrl() does not manipulate absolute urls",
                                                    "execution_time": 0.03,
                                                    "name": "useAssetUrl() does not manipulate absolute urls",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729338,
                                    "isTestReportAvailable": true,
                                    "duration": 285,
                                    "duration_inMinutes": 4.75,
                                    "created_at": "Jun-23-21",
                                    "created_at_rawDateFormat": "2021-06-23T07:05:14.797Z",
                                    "testCoverage": 95.86
                                }
                            },
                            {
                                "id": 325853058,
                                "gitlabId": 325853058,
                                "status": "success",
                                "testReport": {
                                    "id": 46751,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 20,
                                    "total_count": 20,
                                    "total_time": 0.11,
                                    "test_suites": [
                                        {
                                            "id": 54088,
                                            "total_time": 0.11,
                                            "total_count": 20,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 20,
                                            "test_cases": [
                                                {
                                                    "id": 3553205,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553171,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553165,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553161,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553155,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553154,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553111,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553181,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553175,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553211,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553201,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553195,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553191,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553185,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553148,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553147,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553141,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553140,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553131,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553121,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729340,
                                    "isTestReportAvailable": true,
                                    "duration": 317,
                                    "duration_inMinutes": 5.28,
                                    "created_at": "Jun-23-21",
                                    "created_at_rawDateFormat": "2021-06-23T07:05:15.052Z",
                                    "testCoverage": 95.59
                                }
                            },
                            {
                                "id": 325827809,
                                "gitlabId": 325827809,
                                "status": "success",
                                "testReport": {
                                    "id": 46753,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 20,
                                    "total_count": 20,
                                    "total_time": 0.14,
                                    "test_suites": [
                                        {
                                            "id": 54092,
                                            "total_time": 0.14,
                                            "total_count": 20,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 20,
                                            "test_cases": [
                                                {
                                                    "id": 3558649,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558689,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558683,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558679,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558729,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558626,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558636,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.03,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558653,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558699,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558703,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558709,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558723,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558719,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558643,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558713,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558659,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558663,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558669,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558673,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558693,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729341,
                                    "isTestReportAvailable": true,
                                    "duration": 329,
                                    "duration_inMinutes": 5.48,
                                    "created_at": "Jun-23-21",
                                    "created_at_rawDateFormat": "2021-06-23T07:05:15.059Z",
                                    "testCoverage": 95.59
                                }
                            },
                            {
                                "id": 325699119,
                                "gitlabId": 325699119,
                                "status": "success",
                                "testReport": {
                                    "id": 46752,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 20,
                                    "total_count": 20,
                                    "total_time": 0.11,
                                    "test_suites": [
                                        {
                                            "id": 54090,
                                            "total_time": 0.11,
                                            "total_count": 20,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 20,
                                            "test_cases": [
                                                {
                                                    "id": 3562583,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562626,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562554,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562573,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562567,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562563,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562557,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562621,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562616,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562612,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562606,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562603,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562597,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562593,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562587,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562577,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562544,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562548,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562636,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562631,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729342,
                                    "isTestReportAvailable": true,
                                    "duration": 292,
                                    "duration_inMinutes": 4.87,
                                    "created_at": "Jun-23-21",
                                    "created_at_rawDateFormat": "2021-06-23T07:05:15.130Z",
                                    "testCoverage": 95.59
                                }
                            },
                            {
                                "id": 325276641,
                                "gitlabId": 325276641,
                                "status": "success",
                                "testReport": {
                                    "id": 46754,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 20,
                                    "total_count": 20,
                                    "total_time": 0.1,
                                    "test_suites": [
                                        {
                                            "id": 54091,
                                            "total_time": 0.1,
                                            "total_count": 20,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 20,
                                            "test_cases": [
                                                {
                                                    "id": 3554269,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554188,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554192,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554198,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554202,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554208,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554212,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554218,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554222,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554228,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554232,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554238,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554243,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554249,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554253,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554259,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554263,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554273,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554279,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554283,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729343,
                                    "isTestReportAvailable": true,
                                    "duration": 293,
                                    "duration_inMinutes": 4.88,
                                    "created_at": "Jun-22-21",
                                    "created_at_rawDateFormat": "2021-06-22T07:05:15.325Z",
                                    "testCoverage": 95.59
                                }
                            },
                            {
                                "id": 325197759,
                                "gitlabId": 325197759,
                                "status": "success",
                                "testReport": {
                                    "id": 46755,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 20,
                                    "total_count": 20,
                                    "total_time": 0.11,
                                    "test_suites": [
                                        {
                                            "id": 54093,
                                            "total_time": 0.11,
                                            "total_count": 20,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 20,
                                            "test_cases": [
                                                {
                                                    "id": 3553194,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553188,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553184,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553132,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553127,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553122,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553117,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553178,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553174,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553168,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553164,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553158,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553153,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553143,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553137,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553204,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553208,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553214,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553218,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553198,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729344,
                                    "isTestReportAvailable": true,
                                    "duration": 287,
                                    "duration_inMinutes": 4.78,
                                    "created_at": "Jun-22-21",
                                    "created_at_rawDateFormat": "2021-06-22T07:05:15.329Z",
                                    "testCoverage": 95.56
                                }
                            },
                            {
                                "id": 325185882,
                                "gitlabId": 325185882,
                                "status": "success",
                                "testReport": {
                                    "id": 46756,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 20,
                                    "total_count": 20,
                                    "total_time": 0.1,
                                    "test_suites": [
                                        {
                                            "id": 54094,
                                            "total_time": 0.1,
                                            "total_count": 20,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 20,
                                            "test_cases": [
                                                {
                                                    "id": 3553230,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553311,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553307,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553301,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553294,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553290,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553284,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553279,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553270,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553260,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553250,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553240,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553220,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553210,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553170,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553200,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553190,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553180,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553152,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553160,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729345,
                                    "isTestReportAvailable": true,
                                    "duration": 285,
                                    "duration_inMinutes": 4.75,
                                    "created_at": "Jun-22-21",
                                    "created_at_rawDateFormat": "2021-06-22T07:05:15.417Z",
                                    "testCoverage": 95.56
                                }
                            },
                            {
                                "id": 325015216,
                                "gitlabId": 325015216,
                                "status": "success",
                                "testReport": {
                                    "id": 46758,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 20,
                                    "total_count": 20,
                                    "total_time": 0.12,
                                    "test_suites": [
                                        {
                                            "id": 54095,
                                            "total_time": 0.12,
                                            "total_count": 20,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 20,
                                            "test_cases": [
                                                {
                                                    "id": 3562607,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562613,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562681,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562651,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562656,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562676,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562617,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562661,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562594,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562588,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562666,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562622,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562627,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562632,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562671,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562637,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562641,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562598,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562646,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562604,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729350,
                                    "isTestReportAvailable": true,
                                    "duration": 290,
                                    "duration_inMinutes": 4.83,
                                    "created_at": "Jun-22-21",
                                    "created_at_rawDateFormat": "2021-06-22T07:05:15.773Z",
                                    "testCoverage": 95.56
                                }
                            },
                            {
                                "id": 324932644,
                                "gitlabId": 324932644,
                                "status": "success",
                                "testReport": {
                                    "id": 46757,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 20,
                                    "total_count": 20,
                                    "total_time": 0.11,
                                    "test_suites": [
                                        {
                                            "id": 54096,
                                            "total_time": 0.11,
                                            "total_count": 20,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 20,
                                            "test_cases": [
                                                {
                                                    "id": 3554287,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554267,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554257,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554247,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554237,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554341,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554335,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554331,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554313,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554315,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554197,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554227,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554217,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554207,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554345,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554321,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554325,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554307,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554297,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554277,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729347,
                                    "isTestReportAvailable": true,
                                    "duration": 288,
                                    "duration_inMinutes": 4.8,
                                    "created_at": "Jun-22-21",
                                    "created_at_rawDateFormat": "2021-06-22T07:05:15.576Z",
                                    "testCoverage": 95.56
                                }
                            },
                            {
                                "id": 324919974,
                                "gitlabId": 324919974,
                                "status": "success",
                                "testReport": {
                                    "id": 46759,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 0,
                                    "success_count": 20,
                                    "total_count": 20,
                                    "total_time": 0.15,
                                    "test_suites": [
                                        {
                                            "id": 54097,
                                            "total_time": 0.15,
                                            "total_count": 20,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test frontend",
                                            "skipped_count": 0,
                                            "success_count": 20,
                                            "test_cases": [
                                                {
                                                    "id": 3553217,
                                                    "classname": "JWT initBearerToken()",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553213,
                                                    "classname": "JWT initBearerToken() invalid token",
                                                    "execution_time": 0.01,
                                                    "name": "JWT initBearerToken() invalid token",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553207,
                                                    "classname": "FlagComponent renders correctly (fr)",
                                                    "execution_time": 0.01,
                                                    "name": "FlagComponent renders correctly (fr)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553276,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level4)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553272,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level3)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553256,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level1)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553266,
                                                    "classname": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper groupSectionsByLevel()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553262,
                                                    "classname": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper filterAndGroupSectionsByLevel() (level2)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553183,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "execution_time": 0.03,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xs)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553187,
                                                    "classname": "FlagComponent renders correctly (de)",
                                                    "execution_time": 0.02,
                                                    "name": "FlagComponent renders correctly (de)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553227,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (lg)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553193,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (sm)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553197,
                                                    "classname": "sharepoint-website-mapper useGraphClient()",
                                                    "execution_time": 0.02,
                                                    "name": "sharepoint-website-mapper useGraphClient()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553203,
                                                    "classname": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper buildWebsiteTree()",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553233,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553237,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (xxl)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553243,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "execution_time": 0,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (infinite)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553247,
                                                    "classname": "FlagComponent renders correctly (en)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (en)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553253,
                                                    "classname": "FlagComponent renders correctly (es)",
                                                    "execution_time": 0,
                                                    "name": "FlagComponent renders correctly (es)",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3553223,
                                                    "classname": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "execution_time": 0.01,
                                                    "name": "sharepoint-website-mapper useBreakpoint() (md)",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729348,
                                    "isTestReportAvailable": true,
                                    "duration": 288,
                                    "duration_inMinutes": 4.8,
                                    "created_at": "Jun-22-21",
                                    "created_at_rawDateFormat": "2021-06-22T07:05:15.737Z",
                                    "testCoverage": 95.56
                                }
                            }
                        ],
                        "groupInfo": {
                            "id": 29696,
                            "gitlabId": 10351636,
                            "name": "Hermann-Group"
                        }
                    }
                ],
                "subGroups": [],
                "stats": {
                    "id": 6720,
                    "isThereSubgroups": false,
                    "numberOfProjects": 1,
                    "testCoverageOfAllProjects": 96.7,
                    "numberOfPipelines": 97,
                    "numberOfTestReports": 68
                }
            },
            {
                "id": 8198021,
                "tempData": false,
                "gitlabId": 8198021,
                "name": "Mayert-Hirthe",
                "projects": [
                    {
                        "id": 14231295,
                        "gitlabId": 14231295,
                        "name": "Mayert-Hirthe",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Mayert-Hirthe.git",
                        "stats": {
                            "id": 29705,
                            "status": "success",
                            "numberOfPipelines": 97,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 286,
                            "averageDurationOfPipelines_inMinutes": 4.77,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 44,
                            "numberOfFailedPipelines": 1,
                            "numberOfCanceledPipelines": 3,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 49,
                            "pipelinesSuccessRatio": 45.36,
                            "totalRepoSize": "55259955",
                            "artifactsSize": "4583934997"
                        },
                        "pipelines": [
                            {
                                "id": 421983158,
                                "gitlabId": 421983158,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729078,
                                    "isTestReportAvailable": false,
                                    "duration": 439,
                                    "duration_inMinutes": 7.32,
                                    "created_at": "Dec-03-21",
                                    "created_at_rawDateFormat": "2021-12-03T07:04:55.568Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 421205296,
                                "gitlabId": 421205296,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729079,
                                    "isTestReportAvailable": false,
                                    "duration": 458,
                                    "duration_inMinutes": 7.63,
                                    "created_at": "Dec-02-21",
                                    "created_at_rawDateFormat": "2021-12-02T07:04:55.697Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 420046384,
                                "gitlabId": 420046384,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729082,
                                    "isTestReportAvailable": false,
                                    "duration": 429,
                                    "duration_inMinutes": 7.15,
                                    "created_at": "Dec-01-21",
                                    "created_at_rawDateFormat": "2021-12-01T07:04:55.766Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 419285879,
                                "gitlabId": 419285879,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729080,
                                    "isTestReportAvailable": false,
                                    "duration": 448,
                                    "duration_inMinutes": 7.47,
                                    "created_at": "Nov-30-21",
                                    "created_at_rawDateFormat": "2021-11-30T07:04:55.724Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 419243788,
                                "gitlabId": 419243788,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729081,
                                    "isTestReportAvailable": false,
                                    "duration": 478,
                                    "duration_inMinutes": 7.97,
                                    "created_at": "Nov-30-21",
                                    "created_at_rawDateFormat": "2021-11-30T07:04:55.756Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 417021701,
                                "gitlabId": 417021701,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729083,
                                    "isTestReportAvailable": false,
                                    "duration": 458,
                                    "duration_inMinutes": 7.63,
                                    "created_at": "Nov-26-21",
                                    "created_at_rawDateFormat": "2021-11-26T07:04:55.966Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 410517070,
                                "gitlabId": 410517070,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729086,
                                    "isTestReportAvailable": false,
                                    "duration": 465,
                                    "duration_inMinutes": 7.75,
                                    "created_at": "Nov-17-21",
                                    "created_at_rawDateFormat": "2021-11-17T07:04:55.989Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 398020322,
                                "gitlabId": 398020322,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729084,
                                    "isTestReportAvailable": false,
                                    "duration": 535,
                                    "duration_inMinutes": 8.92,
                                    "created_at": "Oct-29-21",
                                    "created_at_rawDateFormat": "2021-10-29T07:04:55.973Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 396397703,
                                "gitlabId": 396397703,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729088,
                                    "isTestReportAvailable": false,
                                    "duration": 530,
                                    "duration_inMinutes": 8.83,
                                    "created_at": "Oct-27-21",
                                    "created_at_rawDateFormat": "2021-10-27T07:04:56.153Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 396397407,
                                "gitlabId": 396397407,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729087,
                                    "isTestReportAvailable": false,
                                    "duration": 560,
                                    "duration_inMinutes": 9.33,
                                    "created_at": "Oct-27-21",
                                    "created_at_rawDateFormat": "2021-10-27T07:04:56.076Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 390330534,
                                "gitlabId": 390330534,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729089,
                                    "isTestReportAvailable": false,
                                    "duration": 564,
                                    "duration_inMinutes": 9.4,
                                    "created_at": "Oct-18-21",
                                    "created_at_rawDateFormat": "2021-10-18T07:04:56.230Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 384276435,
                                "gitlabId": 384276435,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729090,
                                    "isTestReportAvailable": false,
                                    "duration": 512,
                                    "duration_inMinutes": 8.53,
                                    "created_at": "Oct-07-21",
                                    "created_at_rawDateFormat": "2021-10-07T07:04:56.246Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 384273299,
                                "gitlabId": 384273299,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729092,
                                    "isTestReportAvailable": false,
                                    "duration": 129,
                                    "duration_inMinutes": 2.15,
                                    "created_at": "Oct-07-21",
                                    "created_at_rawDateFormat": "2021-10-07T07:04:56.284Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 347904289,
                                "gitlabId": 347904289,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729091,
                                    "isTestReportAvailable": false,
                                    "duration": 530,
                                    "duration_inMinutes": 8.83,
                                    "created_at": "Aug-04-21",
                                    "created_at_rawDateFormat": "2021-08-04T07:04:56.250Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 347252249,
                                "gitlabId": 347252249,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729093,
                                    "isTestReportAvailable": false,
                                    "duration": 658,
                                    "duration_inMinutes": 10.97,
                                    "created_at": "Aug-03-21",
                                    "created_at_rawDateFormat": "2021-08-03T07:04:56.355Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 275042014,
                                "gitlabId": 275042014,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729094,
                                    "isTestReportAvailable": false,
                                    "duration": 387,
                                    "duration_inMinutes": 6.45,
                                    "created_at": "Mar-23-21",
                                    "created_at_rawDateFormat": "2021-03-23T07:04:56.411Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 274998515,
                                "gitlabId": 274998515,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729095,
                                    "isTestReportAvailable": false,
                                    "duration": 407,
                                    "duration_inMinutes": 6.78,
                                    "created_at": "Mar-23-21",
                                    "created_at_rawDateFormat": "2021-03-23T07:04:56.494Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 274421206,
                                "gitlabId": 274421206,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729097,
                                    "isTestReportAvailable": false,
                                    "duration": 847,
                                    "duration_inMinutes": 14.12,
                                    "created_at": "Mar-22-21",
                                    "created_at_rawDateFormat": "2021-03-22T07:04:56.508Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 274234836,
                                "gitlabId": 274234836,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729096,
                                    "isTestReportAvailable": false,
                                    "duration": 850,
                                    "duration_inMinutes": 14.17,
                                    "created_at": "Mar-22-21",
                                    "created_at_rawDateFormat": "2021-03-22T07:04:56.503Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 274211180,
                                "gitlabId": 274211180,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729098,
                                    "isTestReportAvailable": false,
                                    "duration": 900,
                                    "duration_inMinutes": 15,
                                    "created_at": "Mar-22-21",
                                    "created_at_rawDateFormat": "2021-03-22T07:04:56.559Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 273398457,
                                "gitlabId": 273398457,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729099,
                                    "isTestReportAvailable": false,
                                    "duration": 590,
                                    "duration_inMinutes": 9.83,
                                    "created_at": "Mar-19-21",
                                    "created_at_rawDateFormat": "2021-03-19T07:04:56.644Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 273373963,
                                "gitlabId": 273373963,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729100,
                                    "isTestReportAvailable": false,
                                    "duration": 593,
                                    "duration_inMinutes": 9.88,
                                    "created_at": "Mar-19-21",
                                    "created_at_rawDateFormat": "2021-03-19T07:04:56.672Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 273166641,
                                "gitlabId": 273166641,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729101,
                                    "isTestReportAvailable": false,
                                    "duration": 861,
                                    "duration_inMinutes": 14.35,
                                    "created_at": "Mar-19-21",
                                    "created_at_rawDateFormat": "2021-03-19T07:04:56.755Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 261923212,
                                "gitlabId": 261923212,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729103,
                                    "isTestReportAvailable": false,
                                    "duration": 691,
                                    "duration_inMinutes": 11.52,
                                    "created_at": "Feb-25-21",
                                    "created_at_rawDateFormat": "2021-02-25T07:04:56.782Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 258041568,
                                "gitlabId": 258041568,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729102,
                                    "isTestReportAvailable": false,
                                    "duration": 11,
                                    "duration_inMinutes": 0.18,
                                    "created_at": "Feb-18-21",
                                    "created_at_rawDateFormat": "2021-02-18T07:04:56.764Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 258041489,
                                "gitlabId": 258041489,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729104,
                                    "isTestReportAvailable": false,
                                    "duration": 1332,
                                    "duration_inMinutes": 22.2,
                                    "created_at": "Feb-18-21",
                                    "created_at_rawDateFormat": "2021-02-18T07:04:56.861Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 256305779,
                                "gitlabId": 256305779,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729105,
                                    "isTestReportAvailable": false,
                                    "duration": 373,
                                    "duration_inMinutes": 6.22,
                                    "created_at": "Feb-15-21",
                                    "created_at_rawDateFormat": "2021-02-15T07:04:56.900Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 256300398,
                                "gitlabId": 256300398,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729106,
                                    "isTestReportAvailable": false,
                                    "duration": 381,
                                    "duration_inMinutes": 6.35,
                                    "created_at": "Feb-15-21",
                                    "created_at_rawDateFormat": "2021-02-15T07:04:56.946Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 256233748,
                                "gitlabId": 256233748,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729107,
                                    "isTestReportAvailable": false,
                                    "duration": 514,
                                    "duration_inMinutes": 8.57,
                                    "created_at": "Feb-15-21",
                                    "created_at_rawDateFormat": "2021-02-15T07:04:57.006Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 255445557,
                                "gitlabId": 255445557,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729123,
                                    "isTestReportAvailable": false,
                                    "duration": 536,
                                    "duration_inMinutes": 8.93,
                                    "created_at": "Feb-12-21",
                                    "created_at_rawDateFormat": "2021-02-12T07:04:57.870Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 255445491,
                                "gitlabId": 255445491,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729108,
                                    "isTestReportAvailable": false,
                                    "duration": 705,
                                    "duration_inMinutes": 11.75,
                                    "created_at": "Feb-12-21",
                                    "created_at_rawDateFormat": "2021-02-12T07:04:57.044Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 255269472,
                                "gitlabId": 255269472,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729109,
                                    "isTestReportAvailable": false,
                                    "duration": 942,
                                    "duration_inMinutes": 15.7,
                                    "created_at": "Feb-12-21",
                                    "created_at_rawDateFormat": "2021-02-12T07:04:57.163Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 255269353,
                                "gitlabId": 255269353,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729110,
                                    "isTestReportAvailable": false,
                                    "duration": 974,
                                    "duration_inMinutes": 16.23,
                                    "created_at": "Feb-12-21",
                                    "created_at_rawDateFormat": "2021-02-12T07:04:57.185Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 236114158,
                                "gitlabId": 236114158,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729111,
                                    "isTestReportAvailable": false,
                                    "duration": 637,
                                    "duration_inMinutes": 10.62,
                                    "created_at": "Dec-31-20",
                                    "created_at_rawDateFormat": "2020-12-31T07:04:57.296Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 231359418,
                                "gitlabId": 231359418,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729112,
                                    "isTestReportAvailable": false,
                                    "duration": 635,
                                    "duration_inMinutes": 10.58,
                                    "created_at": "Dec-17-20",
                                    "created_at_rawDateFormat": "2020-12-17T07:04:57.305Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 230810100,
                                "gitlabId": 230810100,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729113,
                                    "isTestReportAvailable": false,
                                    "duration": 1122,
                                    "duration_inMinutes": 18.7,
                                    "created_at": "Dec-16-20",
                                    "created_at_rawDateFormat": "2020-12-16T07:04:57.322Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 230771127,
                                "gitlabId": 230771127,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729115,
                                    "isTestReportAvailable": false,
                                    "duration": 779,
                                    "duration_inMinutes": 12.98,
                                    "created_at": "Dec-16-20",
                                    "created_at_rawDateFormat": "2020-12-16T07:04:57.484Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 230769895,
                                "gitlabId": 230769895,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729114,
                                    "isTestReportAvailable": false,
                                    "duration": 682,
                                    "duration_inMinutes": 11.37,
                                    "created_at": "Dec-16-20",
                                    "created_at_rawDateFormat": "2020-12-16T07:04:57.484Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 230760538,
                                "gitlabId": 230760538,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729116,
                                    "isTestReportAvailable": false,
                                    "duration": 750,
                                    "duration_inMinutes": 12.5,
                                    "created_at": "Dec-16-20",
                                    "created_at_rawDateFormat": "2020-12-16T07:04:57.553Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 219900041,
                                "gitlabId": 219900041,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729117,
                                    "isTestReportAvailable": false,
                                    "duration": 839,
                                    "duration_inMinutes": 13.98,
                                    "created_at": "Nov-23-20",
                                    "created_at_rawDateFormat": "2020-11-23T07:04:57.592Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 219874102,
                                "gitlabId": 219874102,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729118,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-23-20",
                                    "created_at_rawDateFormat": "2020-11-23T07:04:57.609Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 219871520,
                                "gitlabId": 219871520,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729119,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-23-20",
                                    "created_at_rawDateFormat": "2020-11-23T07:04:57.761Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 219849493,
                                "gitlabId": 219849493,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729120,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-23-20",
                                    "created_at_rawDateFormat": "2020-11-23T07:04:57.790Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 218532995,
                                "gitlabId": 218532995,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729121,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-19-20",
                                    "created_at_rawDateFormat": "2020-11-19T07:04:57.822Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 218531246,
                                "gitlabId": 218531246,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729122,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-19-20",
                                    "created_at_rawDateFormat": "2020-11-19T07:04:57.865Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 217951629,
                                "gitlabId": 217951629,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729124,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-18-20",
                                    "created_at_rawDateFormat": "2020-11-18T07:04:57.954Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 217944352,
                                "gitlabId": 217944352,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729125,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-18-20",
                                    "created_at_rawDateFormat": "2020-11-18T07:04:58.026Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 217926364,
                                "gitlabId": 217926364,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729129,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-18-20",
                                    "created_at_rawDateFormat": "2020-11-18T07:04:58.216Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 217807409,
                                "gitlabId": 217807409,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729127,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-18-20",
                                    "created_at_rawDateFormat": "2020-11-18T07:04:58.116Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 217336926,
                                "gitlabId": 217336926,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729126,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-17-20",
                                    "created_at_rawDateFormat": "2020-11-17T07:04:58.113Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 217297668,
                                "gitlabId": 217297668,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729128,
                                    "isTestReportAvailable": false,
                                    "duration": 410,
                                    "duration_inMinutes": 6.83,
                                    "created_at": "Nov-17-20",
                                    "created_at_rawDateFormat": "2020-11-17T07:04:58.147Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 217291806,
                                "gitlabId": 217291806,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729134,
                                    "isTestReportAvailable": false,
                                    "duration": 205,
                                    "duration_inMinutes": 3.42,
                                    "created_at": "Nov-17-20",
                                    "created_at_rawDateFormat": "2020-11-17T07:04:58.497Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 217284819,
                                "gitlabId": 217284819,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729132,
                                    "isTestReportAvailable": false,
                                    "duration": 338,
                                    "duration_inMinutes": 5.63,
                                    "created_at": "Nov-17-20",
                                    "created_at_rawDateFormat": "2020-11-17T07:04:58.415Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 217282572,
                                "gitlabId": 217282572,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729131,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-17-20",
                                    "created_at_rawDateFormat": "2020-11-17T07:04:58.400Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 217232440,
                                "gitlabId": 217232440,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729136,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-17-20",
                                    "created_at_rawDateFormat": "2020-11-17T07:04:58.663Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 217232166,
                                "gitlabId": 217232166,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729130,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-17-20",
                                    "created_at_rawDateFormat": "2020-11-17T07:04:58.395Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 217231389,
                                "gitlabId": 217231389,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729133,
                                    "isTestReportAvailable": false,
                                    "duration": 349,
                                    "duration_inMinutes": 5.82,
                                    "created_at": "Nov-17-20",
                                    "created_at_rawDateFormat": "2020-11-17T07:04:58.487Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 216696274,
                                "gitlabId": 216696274,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729135,
                                    "isTestReportAvailable": false,
                                    "duration": 558,
                                    "duration_inMinutes": 9.3,
                                    "created_at": "Nov-16-20",
                                    "created_at_rawDateFormat": "2020-11-16T07:04:58.657Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 216577365,
                                "gitlabId": 216577365,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729138,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-16-20",
                                    "created_at_rawDateFormat": "2020-11-16T07:04:58.678Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 216548322,
                                "gitlabId": 216548322,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729137,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-16-20",
                                    "created_at_rawDateFormat": "2020-11-16T07:04:58.666Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 216506299,
                                "gitlabId": 216506299,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729140,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-16-20",
                                    "created_at_rawDateFormat": "2020-11-16T07:04:58.781Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 216483083,
                                "gitlabId": 216483083,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729139,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-16-20",
                                    "created_at_rawDateFormat": "2020-11-16T07:04:58.770Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 215824402,
                                "gitlabId": 215824402,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729141,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-13-20",
                                    "created_at_rawDateFormat": "2020-11-13T07:04:58.914Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 215823952,
                                "gitlabId": 215823952,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729142,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-13-20",
                                    "created_at_rawDateFormat": "2020-11-13T07:04:58.941Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 215800765,
                                "gitlabId": 215800765,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729143,
                                    "isTestReportAvailable": false,
                                    "duration": 577,
                                    "duration_inMinutes": 9.62,
                                    "created_at": "Nov-13-20",
                                    "created_at_rawDateFormat": "2020-11-13T07:04:58.974Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 215787998,
                                "gitlabId": 215787998,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729152,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-13-20",
                                    "created_at_rawDateFormat": "2020-11-13T07:04:59.585Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 215781188,
                                "gitlabId": 215781188,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729148,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-13-20",
                                    "created_at_rawDateFormat": "2020-11-13T07:04:59.303Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 215669280,
                                "gitlabId": 215669280,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729144,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-13-20",
                                    "created_at_rawDateFormat": "2020-11-13T07:04:59.086Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 215668164,
                                "gitlabId": 215668164,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729145,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-13-20",
                                    "created_at_rawDateFormat": "2020-11-13T07:04:59.182Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 215659617,
                                "gitlabId": 215659617,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729147,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-13-20",
                                    "created_at_rawDateFormat": "2020-11-13T07:04:59.239Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 215644346,
                                "gitlabId": 215644346,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729146,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-13-20",
                                    "created_at_rawDateFormat": "2020-11-13T07:04:59.221Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 215330327,
                                "gitlabId": 215330327,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729149,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-12-20",
                                    "created_at_rawDateFormat": "2020-11-12T07:04:59.340Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 215329575,
                                "gitlabId": 215329575,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729151,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-12-20",
                                    "created_at_rawDateFormat": "2020-11-12T07:04:59.514Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 215291416,
                                "gitlabId": 215291416,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729150,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-12-20",
                                    "created_at_rawDateFormat": "2020-11-12T07:04:59.474Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 215273847,
                                "gitlabId": 215273847,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729155,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-12-20",
                                    "created_at_rawDateFormat": "2020-11-12T07:04:59.673Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 215260762,
                                "gitlabId": 215260762,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729153,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-12-20",
                                    "created_at_rawDateFormat": "2020-11-12T07:04:59.592Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 215225887,
                                "gitlabId": 215225887,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729154,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-12-20",
                                    "created_at_rawDateFormat": "2020-11-12T07:04:59.645Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 215221553,
                                "gitlabId": 215221553,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729156,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-12-20",
                                    "created_at_rawDateFormat": "2020-11-12T07:04:59.757Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 214259756,
                                "gitlabId": 214259756,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729157,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-10-20",
                                    "created_at_rawDateFormat": "2020-11-10T07:04:59.811Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 214258017,
                                "gitlabId": 214258017,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729159,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-10-20",
                                    "created_at_rawDateFormat": "2020-11-10T07:04:59.871Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 214232620,
                                "gitlabId": 214232620,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729158,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-10-20",
                                    "created_at_rawDateFormat": "2020-11-10T07:04:59.853Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 214230251,
                                "gitlabId": 214230251,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729160,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-10-20",
                                    "created_at_rawDateFormat": "2020-11-10T07:04:59.889Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 214120955,
                                "gitlabId": 214120955,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729161,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-10-20",
                                    "created_at_rawDateFormat": "2020-11-10T07:04:59.909Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 214116678,
                                "gitlabId": 214116678,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729163,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-10-20",
                                    "created_at_rawDateFormat": "2020-11-10T07:05:00.178Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 212260814,
                                "gitlabId": 212260814,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729165,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-05-20",
                                    "created_at_rawDateFormat": "2020-11-05T07:05:00.235Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 212254111,
                                "gitlabId": 212254111,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729169,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-05-20",
                                    "created_at_rawDateFormat": "2020-11-05T07:05:00.564Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 212170888,
                                "gitlabId": 212170888,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729162,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-05-20",
                                    "created_at_rawDateFormat": "2020-11-05T07:05:00.120Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 212110374,
                                "gitlabId": 212110374,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729166,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-05-20",
                                    "created_at_rawDateFormat": "2020-11-05T07:05:00.325Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 211563729,
                                "gitlabId": 211563729,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729164,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-04-20",
                                    "created_at_rawDateFormat": "2020-11-04T07:05:00.182Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 211563277,
                                "gitlabId": 211563277,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729538,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-04-20",
                                    "created_at_rawDateFormat": "2020-11-04T07:05:29.809Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 211562587,
                                "gitlabId": 211562587,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729542,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-04-20",
                                    "created_at_rawDateFormat": "2020-11-04T07:05:30.094Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 209318180,
                                "gitlabId": 209318180,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729544,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Oct-29-20",
                                    "created_at_rawDateFormat": "2020-10-29T07:05:30.154Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 209309094,
                                "gitlabId": 209309094,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729541,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Oct-29-20",
                                    "created_at_rawDateFormat": "2020-10-29T07:05:30.076Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 209308177,
                                "gitlabId": 209308177,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729543,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Oct-29-20",
                                    "created_at_rawDateFormat": "2020-10-29T07:05:30.124Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 207741662,
                                "gitlabId": 207741662,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729545,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Oct-26-20",
                                    "created_at_rawDateFormat": "2020-10-26T07:05:30.224Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 206264829,
                                "gitlabId": 206264829,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729547,
                                    "isTestReportAvailable": false,
                                    "duration": 363,
                                    "duration_inMinutes": 6.05,
                                    "created_at": "Oct-22-20",
                                    "created_at_rawDateFormat": "2020-10-22T07:05:30.364Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 206259235,
                                "gitlabId": 206259235,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729546,
                                    "isTestReportAvailable": false,
                                    "duration": 370,
                                    "duration_inMinutes": 6.17,
                                    "created_at": "Oct-22-20",
                                    "created_at_rawDateFormat": "2020-10-22T07:05:30.350Z",
                                    "testCoverage": null
                                }
                            }
                        ],
                        "groupInfo": {
                            "id": 29703,
                            "gitlabId": 8198021,
                            "name": "Mayert-Hirthe"
                        }
                    }
                ],
                "subGroups": [],
                "stats": {
                    "id": 6719,
                    "isThereSubgroups": false,
                    "numberOfProjects": 1,
                    "testCoverageOfAllProjects": null,
                    "numberOfPipelines": 97,
                    "numberOfTestReports": 0
                }
            },
            {
                "id": 8473724,
                "tempData": false,
                "gitlabId": 8473724,
                "name": "Moen-Fahey",
                "projects": [
                    {
                        "id": 23650422,
                        "gitlabId": 23650422,
                        "name": "web-push-demo",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Moen-Fahey/web-push-demo.git",
                        "stats": {
                            "id": 29787,
                            "status": "success",
                            "numberOfPipelines": 30,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 309,
                            "averageDurationOfPipelines_inMinutes": 5.15,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 26,
                            "numberOfFailedPipelines": 4,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": 86.67,
                            "totalRepoSize": "429916",
                            "artifactsSize": "1223238"
                        },
                        "pipelines": [
                            {
                                "id": 478443685,
                                "gitlabId": 478443685,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729431,
                                    "isTestReportAvailable": false,
                                    "duration": 174,
                                    "duration_inMinutes": 2.9,
                                    "created_at": "Feb-24-22",
                                    "created_at_rawDateFormat": "2022-02-24T07:05:21.963Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 257646763,
                                "gitlabId": 257646763,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729433,
                                    "isTestReportAvailable": false,
                                    "duration": 1033,
                                    "duration_inMinutes": 17.22,
                                    "created_at": "Feb-17-21",
                                    "created_at_rawDateFormat": "2021-02-17T07:05:21.998Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 256370519,
                                "gitlabId": 256370519,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729434,
                                    "isTestReportAvailable": false,
                                    "duration": 205,
                                    "duration_inMinutes": 3.42,
                                    "created_at": "Feb-15-21",
                                    "created_at_rawDateFormat": "2021-02-15T07:05:22.034Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 256347412,
                                "gitlabId": 256347412,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729435,
                                    "isTestReportAvailable": false,
                                    "duration": 250,
                                    "duration_inMinutes": 4.17,
                                    "created_at": "Feb-15-21",
                                    "created_at_rawDateFormat": "2021-02-15T07:05:22.195Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 252655360,
                                "gitlabId": 252655360,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729439,
                                    "isTestReportAvailable": false,
                                    "duration": 394,
                                    "duration_inMinutes": 6.57,
                                    "created_at": "Feb-07-21",
                                    "created_at_rawDateFormat": "2021-02-07T07:05:22.309Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 252645300,
                                "gitlabId": 252645300,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729438,
                                    "isTestReportAvailable": false,
                                    "duration": 335,
                                    "duration_inMinutes": 5.58,
                                    "created_at": "Feb-07-21",
                                    "created_at_rawDateFormat": "2021-02-07T07:05:22.286Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 252511996,
                                "gitlabId": 252511996,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729436,
                                    "isTestReportAvailable": false,
                                    "duration": 291,
                                    "duration_inMinutes": 4.85,
                                    "created_at": "Feb-06-21",
                                    "created_at_rawDateFormat": "2021-02-06T07:05:22.252Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 252494998,
                                "gitlabId": 252494998,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729437,
                                    "isTestReportAvailable": false,
                                    "duration": 306,
                                    "duration_inMinutes": 5.1,
                                    "created_at": "Feb-06-21",
                                    "created_at_rawDateFormat": "2021-02-06T07:05:22.263Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 252486248,
                                "gitlabId": 252486248,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729440,
                                    "isTestReportAvailable": false,
                                    "duration": 279,
                                    "duration_inMinutes": 4.65,
                                    "created_at": "Feb-06-21",
                                    "created_at_rawDateFormat": "2021-02-06T07:05:22.330Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 252006030,
                                "gitlabId": 252006030,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729441,
                                    "isTestReportAvailable": false,
                                    "duration": 475,
                                    "duration_inMinutes": 7.92,
                                    "created_at": "Feb-05-21",
                                    "created_at_rawDateFormat": "2021-02-05T07:05:22.472Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 251973840,
                                "gitlabId": 251973840,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729458,
                                    "isTestReportAvailable": false,
                                    "duration": 182,
                                    "duration_inMinutes": 3.03,
                                    "created_at": "Feb-05-21",
                                    "created_at_rawDateFormat": "2021-02-05T07:05:23.477Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 251944110,
                                "gitlabId": 251944110,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729442,
                                    "isTestReportAvailable": false,
                                    "duration": 318,
                                    "duration_inMinutes": 5.3,
                                    "created_at": "Feb-05-21",
                                    "created_at_rawDateFormat": "2021-02-05T07:05:22.538Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 251638375,
                                "gitlabId": 251638375,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729443,
                                    "isTestReportAvailable": false,
                                    "duration": 276,
                                    "duration_inMinutes": 4.6,
                                    "created_at": "Feb-04-21",
                                    "created_at_rawDateFormat": "2021-02-04T07:05:22.549Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 251632221,
                                "gitlabId": 251632221,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729444,
                                    "isTestReportAvailable": false,
                                    "duration": 300,
                                    "duration_inMinutes": 5,
                                    "created_at": "Feb-04-21",
                                    "created_at_rawDateFormat": "2021-02-04T07:05:22.615Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 251630221,
                                "gitlabId": 251630221,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729449,
                                    "isTestReportAvailable": false,
                                    "duration": 221,
                                    "duration_inMinutes": 3.68,
                                    "created_at": "Feb-04-21",
                                    "created_at_rawDateFormat": "2021-02-04T07:05:22.940Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 251628353,
                                "gitlabId": 251628353,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729445,
                                    "isTestReportAvailable": false,
                                    "duration": 297,
                                    "duration_inMinutes": 4.95,
                                    "created_at": "Feb-04-21",
                                    "created_at_rawDateFormat": "2021-02-04T07:05:22.797Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 251564423,
                                "gitlabId": 251564423,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729446,
                                    "isTestReportAvailable": false,
                                    "duration": 189,
                                    "duration_inMinutes": 3.15,
                                    "created_at": "Feb-04-21",
                                    "created_at_rawDateFormat": "2021-02-04T07:05:22.800Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 242021585,
                                "gitlabId": 242021585,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729447,
                                    "isTestReportAvailable": false,
                                    "duration": 294,
                                    "duration_inMinutes": 4.9,
                                    "created_at": "Jan-15-21",
                                    "created_at_rawDateFormat": "2021-01-15T07:05:22.833Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 242018373,
                                "gitlabId": 242018373,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729448,
                                    "isTestReportAvailable": false,
                                    "duration": 456,
                                    "duration_inMinutes": 7.6,
                                    "created_at": "Jan-15-21",
                                    "created_at_rawDateFormat": "2021-01-15T07:05:22.883Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 241859763,
                                "gitlabId": 241859763,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729453,
                                    "isTestReportAvailable": false,
                                    "duration": 356,
                                    "duration_inMinutes": 5.93,
                                    "created_at": "Jan-14-21",
                                    "created_at_rawDateFormat": "2021-01-14T07:05:23.182Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 241854482,
                                "gitlabId": 241854482,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729450,
                                    "isTestReportAvailable": false,
                                    "duration": 293,
                                    "duration_inMinutes": 4.88,
                                    "created_at": "Jan-14-21",
                                    "created_at_rawDateFormat": "2021-01-14T07:05:23.087Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 241849809,
                                "gitlabId": 241849809,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729452,
                                    "isTestReportAvailable": false,
                                    "duration": 389,
                                    "duration_inMinutes": 6.48,
                                    "created_at": "Jan-14-21",
                                    "created_at_rawDateFormat": "2021-01-14T07:05:23.144Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 241653553,
                                "gitlabId": 241653553,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729451,
                                    "isTestReportAvailable": false,
                                    "duration": 365,
                                    "duration_inMinutes": 6.08,
                                    "created_at": "Jan-14-21",
                                    "created_at_rawDateFormat": "2021-01-14T07:05:23.133Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 241630553,
                                "gitlabId": 241630553,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729454,
                                    "isTestReportAvailable": false,
                                    "duration": 309,
                                    "duration_inMinutes": 5.15,
                                    "created_at": "Jan-14-21",
                                    "created_at_rawDateFormat": "2021-01-14T07:05:23.254Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 241623849,
                                "gitlabId": 241623849,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729455,
                                    "isTestReportAvailable": false,
                                    "duration": 310,
                                    "duration_inMinutes": 5.17,
                                    "created_at": "Jan-14-21",
                                    "created_at_rawDateFormat": "2021-01-14T07:05:23.381Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 241609629,
                                "gitlabId": 241609629,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729481,
                                    "isTestReportAvailable": false,
                                    "duration": 298,
                                    "duration_inMinutes": 4.97,
                                    "created_at": "Jan-14-21",
                                    "created_at_rawDateFormat": "2021-01-14T07:05:25.329Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 241605284,
                                "gitlabId": 241605284,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729456,
                                    "isTestReportAvailable": false,
                                    "duration": 427,
                                    "duration_inMinutes": 7.12,
                                    "created_at": "Jan-14-21",
                                    "created_at_rawDateFormat": "2021-01-14T07:05:23.417Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 241603382,
                                "gitlabId": 241603382,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729457,
                                    "isTestReportAvailable": false,
                                    "duration": 108,
                                    "duration_inMinutes": 1.8,
                                    "created_at": "Jan-14-21",
                                    "created_at_rawDateFormat": "2021-01-14T07:05:23.440Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 241594929,
                                "gitlabId": 241594929,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729461,
                                    "isTestReportAvailable": false,
                                    "duration": 86,
                                    "duration_inMinutes": 1.43,
                                    "created_at": "Jan-14-21",
                                    "created_at_rawDateFormat": "2021-01-14T07:05:23.743Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 241593617,
                                "gitlabId": 241593617,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729462,
                                    "isTestReportAvailable": false,
                                    "duration": 58,
                                    "duration_inMinutes": 0.97,
                                    "created_at": "Jan-14-21",
                                    "created_at_rawDateFormat": "2021-01-14T07:05:23.745Z",
                                    "testCoverage": null
                                }
                            }
                        ],
                        "groupInfo": {
                            "id": 29707,
                            "gitlabId": 8473724,
                            "name": "Moen-Fahey"
                        }
                    },
                    {
                        "id": 12855455,
                        "gitlabId": 12855455,
                        "name": "Moen-Fahey",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Moen-Fahey/cutclient.git",
                        "stats": {
                            "id": 29704,
                            "status": "failed",
                            "numberOfPipelines": 97,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 1628,
                            "averageDurationOfPipelines_inMinutes": 27.13,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 24,
                            "numberOfFailedPipelines": 61,
                            "numberOfCanceledPipelines": 12,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": 24.74,
                            "totalRepoSize": "3795845",
                            "artifactsSize": "12458023499"
                        },
                        "pipelines": [
                            {
                                "id": 482894581,
                                "gitlabId": 482894581,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729554,
                                    "isTestReportAvailable": false,
                                    "duration": 506,
                                    "duration_inMinutes": 8.43,
                                    "created_at": "Mar-02-22",
                                    "created_at_rawDateFormat": "2022-03-02T07:05:30.732Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 482891865,
                                "gitlabId": 482891865,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729556,
                                    "isTestReportAvailable": false,
                                    "duration": 515,
                                    "duration_inMinutes": 8.58,
                                    "created_at": "Mar-02-22",
                                    "created_at_rawDateFormat": "2022-03-02T07:05:30.931Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 482784915,
                                "gitlabId": 482784915,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729557,
                                    "isTestReportAvailable": false,
                                    "duration": 524,
                                    "duration_inMinutes": 8.73,
                                    "created_at": "Mar-02-22",
                                    "created_at_rawDateFormat": "2022-03-02T07:05:30.945Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 470469797,
                                "gitlabId": 470469797,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729558,
                                    "isTestReportAvailable": false,
                                    "duration": 68,
                                    "duration_inMinutes": 1.13,
                                    "created_at": "Feb-14-22",
                                    "created_at_rawDateFormat": "2022-02-14T07:05:30.991Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 358783266,
                                "gitlabId": 358783266,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729575,
                                    "isTestReportAvailable": false,
                                    "duration": 5936,
                                    "duration_inMinutes": 98.93,
                                    "created_at": "Aug-24-21",
                                    "created_at_rawDateFormat": "2021-08-24T07:05:33.045Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 344646875,
                                "gitlabId": 344646875,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729559,
                                    "isTestReportAvailable": false,
                                    "duration": 4199,
                                    "duration_inMinutes": 69.98,
                                    "created_at": "Jul-29-21",
                                    "created_at_rawDateFormat": "2021-07-29T07:05:31.162Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 340418861,
                                "gitlabId": 340418861,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729560,
                                    "isTestReportAvailable": false,
                                    "duration": 4135,
                                    "duration_inMinutes": 68.92,
                                    "created_at": "Jul-21-21",
                                    "created_at_rawDateFormat": "2021-07-21T07:05:31.196Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 339962341,
                                "gitlabId": 339962341,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729561,
                                    "isTestReportAvailable": false,
                                    "duration": 4201,
                                    "duration_inMinutes": 70.02,
                                    "created_at": "Jul-20-21",
                                    "created_at_rawDateFormat": "2021-07-20T07:05:31.208Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 322546606,
                                "gitlabId": 322546606,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729581,
                                    "isTestReportAvailable": false,
                                    "duration": 4697,
                                    "duration_inMinutes": 78.28,
                                    "created_at": "Jun-17-21",
                                    "created_at_rawDateFormat": "2021-06-17T07:05:33.487Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 322508116,
                                "gitlabId": 322508116,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729562,
                                    "isTestReportAvailable": false,
                                    "duration": 1883,
                                    "duration_inMinutes": 31.38,
                                    "created_at": "Jun-17-21",
                                    "created_at_rawDateFormat": "2021-06-17T07:05:31.405Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 322466488,
                                "gitlabId": 322466488,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729564,
                                    "isTestReportAvailable": false,
                                    "duration": 942,
                                    "duration_inMinutes": 15.7,
                                    "created_at": "Jun-17-21",
                                    "created_at_rawDateFormat": "2021-06-17T07:05:31.563Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 322272023,
                                "gitlabId": 322272023,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729563,
                                    "isTestReportAvailable": false,
                                    "duration": 4305,
                                    "duration_inMinutes": 71.75,
                                    "created_at": "Jun-16-21",
                                    "created_at_rawDateFormat": "2021-06-16T07:05:31.481Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 309312317,
                                "gitlabId": 309312317,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729565,
                                    "isTestReportAvailable": false,
                                    "duration": 4766,
                                    "duration_inMinutes": 79.43,
                                    "created_at": "May-25-21",
                                    "created_at_rawDateFormat": "2021-05-25T07:05:31.673Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 309050049,
                                "gitlabId": 309050049,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729567,
                                    "isTestReportAvailable": false,
                                    "duration": 641,
                                    "duration_inMinutes": 10.68,
                                    "created_at": "May-25-21",
                                    "created_at_rawDateFormat": "2021-05-25T07:05:31.879Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 307198063,
                                "gitlabId": 307198063,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729566,
                                    "isTestReportAvailable": false,
                                    "duration": 585,
                                    "duration_inMinutes": 9.75,
                                    "created_at": "May-21-21",
                                    "created_at_rawDateFormat": "2021-05-21T07:05:31.850Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 306450985,
                                "gitlabId": 306450985,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729568,
                                    "isTestReportAvailable": false,
                                    "duration": 18147,
                                    "duration_inMinutes": 302.45,
                                    "created_at": "May-20-21",
                                    "created_at_rawDateFormat": "2021-05-20T07:05:31.987Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 306315602,
                                "gitlabId": 306315602,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729583,
                                    "isTestReportAvailable": false,
                                    "duration": 562,
                                    "duration_inMinutes": 9.37,
                                    "created_at": "May-20-21",
                                    "created_at_rawDateFormat": "2021-05-20T07:05:33.600Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 305843533,
                                "gitlabId": 305843533,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729569,
                                    "isTestReportAvailable": false,
                                    "duration": 559,
                                    "duration_inMinutes": 9.32,
                                    "created_at": "May-19-21",
                                    "created_at_rawDateFormat": "2021-05-19T07:05:32.158Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 305835938,
                                "gitlabId": 305835938,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729570,
                                    "isTestReportAvailable": false,
                                    "duration": 154,
                                    "duration_inMinutes": 2.57,
                                    "created_at": "May-19-21",
                                    "created_at_rawDateFormat": "2021-05-19T07:05:32.242Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 303861377,
                                "gitlabId": 303861377,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729571,
                                    "isTestReportAvailable": false,
                                    "duration": 4379,
                                    "duration_inMinutes": 72.98,
                                    "created_at": "May-17-21",
                                    "created_at_rawDateFormat": "2021-05-17T07:05:32.596Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 303367081,
                                "gitlabId": 303367081,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729572,
                                    "isTestReportAvailable": false,
                                    "duration": 4428,
                                    "duration_inMinutes": 73.8,
                                    "created_at": "May-15-21",
                                    "created_at_rawDateFormat": "2021-05-15T07:05:32.672Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 301002977,
                                "gitlabId": 301002977,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729573,
                                    "isTestReportAvailable": false,
                                    "duration": 6210,
                                    "duration_inMinutes": 103.5,
                                    "created_at": "May-11-21",
                                    "created_at_rawDateFormat": "2021-05-11T07:05:32.876Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 300987113,
                                "gitlabId": 300987113,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729574,
                                    "isTestReportAvailable": false,
                                    "duration": 7564,
                                    "duration_inMinutes": 126.07,
                                    "created_at": "May-11-21",
                                    "created_at_rawDateFormat": "2021-05-11T07:05:33.021Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 299060206,
                                "gitlabId": 299060206,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729577,
                                    "isTestReportAvailable": false,
                                    "duration": 4194,
                                    "duration_inMinutes": 69.9,
                                    "created_at": "May-07-21",
                                    "created_at_rawDateFormat": "2021-05-07T07:05:33.167Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 296238864,
                                "gitlabId": 296238864,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729578,
                                    "isTestReportAvailable": false,
                                    "duration": 5231,
                                    "duration_inMinutes": 87.18,
                                    "created_at": "May-03-21",
                                    "created_at_rawDateFormat": "2021-05-03T07:05:33.278Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 277121480,
                                "gitlabId": 277121480,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729579,
                                    "isTestReportAvailable": false,
                                    "duration": 4061,
                                    "duration_inMinutes": 67.68,
                                    "created_at": "Mar-26-21",
                                    "created_at_rawDateFormat": "2021-03-26T07:05:33.313Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 274376449,
                                "gitlabId": 274376449,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729597,
                                    "isTestReportAvailable": false,
                                    "duration": 4312,
                                    "duration_inMinutes": 71.87,
                                    "created_at": "Mar-22-21",
                                    "created_at_rawDateFormat": "2021-03-22T07:05:34.687Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 274374359,
                                "gitlabId": 274374359,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729580,
                                    "isTestReportAvailable": false,
                                    "duration": 64,
                                    "duration_inMinutes": 1.07,
                                    "created_at": "Mar-22-21",
                                    "created_at_rawDateFormat": "2021-03-22T07:05:33.439Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 274371257,
                                "gitlabId": 274371257,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729582,
                                    "isTestReportAvailable": false,
                                    "duration": 244,
                                    "duration_inMinutes": 4.07,
                                    "created_at": "Mar-22-21",
                                    "created_at_rawDateFormat": "2021-03-22T07:05:33.533Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 274361205,
                                "gitlabId": 274361205,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729584,
                                    "isTestReportAvailable": false,
                                    "duration": 768,
                                    "duration_inMinutes": 12.8,
                                    "created_at": "Mar-22-21",
                                    "created_at_rawDateFormat": "2021-03-22T07:05:33.608Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 271902201,
                                "gitlabId": 271902201,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729586,
                                    "isTestReportAvailable": false,
                                    "duration": 1020,
                                    "duration_inMinutes": 17,
                                    "created_at": "Mar-17-21",
                                    "created_at_rawDateFormat": "2021-03-17T07:05:33.769Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 271897171,
                                "gitlabId": 271897171,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729585,
                                    "isTestReportAvailable": false,
                                    "duration": 77,
                                    "duration_inMinutes": 1.28,
                                    "created_at": "Mar-17-21",
                                    "created_at_rawDateFormat": "2021-03-17T07:05:33.759Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 271215317,
                                "gitlabId": 271215317,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729587,
                                    "isTestReportAvailable": false,
                                    "duration": 520,
                                    "duration_inMinutes": 8.67,
                                    "created_at": "Mar-16-21",
                                    "created_at_rawDateFormat": "2021-03-16T07:05:33.847Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 270771268,
                                "gitlabId": 270771268,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729593,
                                    "isTestReportAvailable": false,
                                    "duration": 354,
                                    "duration_inMinutes": 5.9,
                                    "created_at": "Mar-15-21",
                                    "created_at_rawDateFormat": "2021-03-15T07:05:34.478Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 270710391,
                                "gitlabId": 270710391,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729588,
                                    "isTestReportAvailable": false,
                                    "duration": 268,
                                    "duration_inMinutes": 4.47,
                                    "created_at": "Mar-15-21",
                                    "created_at_rawDateFormat": "2021-03-15T07:05:33.874Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 270708229,
                                "gitlabId": 270708229,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729591,
                                    "isTestReportAvailable": false,
                                    "duration": 23,
                                    "duration_inMinutes": 0.38,
                                    "created_at": "Mar-15-21",
                                    "created_at_rawDateFormat": "2021-03-15T07:05:34.237Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 270706638,
                                "gitlabId": 270706638,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729599,
                                    "isTestReportAvailable": false,
                                    "duration": 20,
                                    "duration_inMinutes": 0.33,
                                    "created_at": "Mar-15-21",
                                    "created_at_rawDateFormat": "2021-03-15T07:05:34.825Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 270657277,
                                "gitlabId": 270657277,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729589,
                                    "isTestReportAvailable": false,
                                    "duration": 45,
                                    "duration_inMinutes": 0.75,
                                    "created_at": "Mar-15-21",
                                    "created_at_rawDateFormat": "2021-03-15T07:05:34.099Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 270656034,
                                "gitlabId": 270656034,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729590,
                                    "isTestReportAvailable": false,
                                    "duration": 197,
                                    "duration_inMinutes": 3.28,
                                    "created_at": "Mar-15-21",
                                    "created_at_rawDateFormat": "2021-03-15T07:05:34.137Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 270650869,
                                "gitlabId": 270650869,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729592,
                                    "isTestReportAvailable": false,
                                    "duration": 313,
                                    "duration_inMinutes": 5.22,
                                    "created_at": "Mar-15-21",
                                    "created_at_rawDateFormat": "2021-03-15T07:05:34.354Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 270645746,
                                "gitlabId": 270645746,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729595,
                                    "isTestReportAvailable": false,
                                    "duration": 35,
                                    "duration_inMinutes": 0.58,
                                    "created_at": "Mar-15-21",
                                    "created_at_rawDateFormat": "2021-03-15T07:05:34.624Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 270627382,
                                "gitlabId": 270627382,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729594,
                                    "isTestReportAvailable": false,
                                    "duration": 144,
                                    "duration_inMinutes": 2.4,
                                    "created_at": "Mar-15-21",
                                    "created_at_rawDateFormat": "2021-03-15T07:05:34.501Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 240909568,
                                "gitlabId": 240909568,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729596,
                                    "isTestReportAvailable": false,
                                    "duration": 60,
                                    "duration_inMinutes": 1,
                                    "created_at": "Jan-13-21",
                                    "created_at_rawDateFormat": "2021-01-13T07:05:34.650Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 226712490,
                                "gitlabId": 226712490,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729598,
                                    "isTestReportAvailable": false,
                                    "duration": 3304,
                                    "duration_inMinutes": 55.07,
                                    "created_at": "Dec-08-20",
                                    "created_at_rawDateFormat": "2020-12-08T07:05:34.753Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 219909028,
                                "gitlabId": 219909028,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729600,
                                    "isTestReportAvailable": false,
                                    "duration": 5489,
                                    "duration_inMinutes": 91.48,
                                    "created_at": "Nov-23-20",
                                    "created_at_rawDateFormat": "2020-11-23T07:05:34.885Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 219159554,
                                "gitlabId": 219159554,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729603,
                                    "isTestReportAvailable": false,
                                    "duration": 2760,
                                    "duration_inMinutes": 46,
                                    "created_at": "Nov-20-20",
                                    "created_at_rawDateFormat": "2020-11-20T07:05:34.967Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 214278610,
                                "gitlabId": 214278610,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729601,
                                    "isTestReportAvailable": false,
                                    "duration": 3065,
                                    "duration_inMinutes": 51.08,
                                    "created_at": "Nov-10-20",
                                    "created_at_rawDateFormat": "2020-11-10T07:05:34.921Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 200534094,
                                "gitlabId": 200534094,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729602,
                                    "isTestReportAvailable": false,
                                    "duration": 475,
                                    "duration_inMinutes": 7.92,
                                    "created_at": "Oct-09-20",
                                    "created_at_rawDateFormat": "2020-10-09T07:05:34.940Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 200520068,
                                "gitlabId": 200520068,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729604,
                                    "isTestReportAvailable": false,
                                    "duration": 567,
                                    "duration_inMinutes": 9.45,
                                    "created_at": "Oct-09-20",
                                    "created_at_rawDateFormat": "2020-10-09T07:05:35.014Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 200519796,
                                "gitlabId": 200519796,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729605,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Oct-09-20",
                                    "created_at_rawDateFormat": "2020-10-09T07:05:35.111Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 200518676,
                                "gitlabId": 200518676,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729609,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Oct-09-20",
                                    "created_at_rawDateFormat": "2020-10-09T07:05:35.338Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 200492431,
                                "gitlabId": 200492431,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729610,
                                    "isTestReportAvailable": false,
                                    "duration": 1411,
                                    "duration_inMinutes": 23.52,
                                    "created_at": "Oct-09-20",
                                    "created_at_rawDateFormat": "2020-10-09T07:05:35.369Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 136091222,
                                "gitlabId": 136091222,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729606,
                                    "isTestReportAvailable": false,
                                    "duration": 1258,
                                    "duration_inMinutes": 20.97,
                                    "created_at": "Apr-15-20",
                                    "created_at_rawDateFormat": "2020-04-15T07:05:35.210Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 135850177,
                                "gitlabId": 135850177,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729607,
                                    "isTestReportAvailable": false,
                                    "duration": 508,
                                    "duration_inMinutes": 8.47,
                                    "created_at": "Apr-14-20",
                                    "created_at_rawDateFormat": "2020-04-14T07:05:35.243Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 135824851,
                                "gitlabId": 135824851,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729608,
                                    "isTestReportAvailable": false,
                                    "duration": 3072,
                                    "duration_inMinutes": 51.2,
                                    "created_at": "Apr-14-20",
                                    "created_at_rawDateFormat": "2020-04-14T07:05:35.316Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 135812104,
                                "gitlabId": 135812104,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729611,
                                    "isTestReportAvailable": false,
                                    "duration": 1142,
                                    "duration_inMinutes": 19.03,
                                    "created_at": "Apr-14-20",
                                    "created_at_rawDateFormat": "2020-04-14T07:05:35.385Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 135782559,
                                "gitlabId": 135782559,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729612,
                                    "isTestReportAvailable": false,
                                    "duration": 1459,
                                    "duration_inMinutes": 24.32,
                                    "created_at": "Apr-14-20",
                                    "created_at_rawDateFormat": "2020-04-14T07:05:35.461Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 135769216,
                                "gitlabId": 135769216,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729617,
                                    "isTestReportAvailable": false,
                                    "duration": 730,
                                    "duration_inMinutes": 12.17,
                                    "created_at": "Apr-14-20",
                                    "created_at_rawDateFormat": "2020-04-14T07:05:35.701Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 135763706,
                                "gitlabId": 135763706,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729613,
                                    "isTestReportAvailable": false,
                                    "duration": 492,
                                    "duration_inMinutes": 8.2,
                                    "created_at": "Apr-14-20",
                                    "created_at_rawDateFormat": "2020-04-14T07:05:35.579Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 132715064,
                                "gitlabId": 132715064,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729614,
                                    "isTestReportAvailable": false,
                                    "duration": 1467,
                                    "duration_inMinutes": 24.45,
                                    "created_at": "Apr-03-20",
                                    "created_at_rawDateFormat": "2020-04-03T07:05:35.651Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 132637731,
                                "gitlabId": 132637731,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729616,
                                    "isTestReportAvailable": false,
                                    "duration": 794,
                                    "duration_inMinutes": 13.23,
                                    "created_at": "Apr-03-20",
                                    "created_at_rawDateFormat": "2020-04-03T07:05:35.695Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 132620622,
                                "gitlabId": 132620622,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729615,
                                    "isTestReportAvailable": false,
                                    "duration": 1994,
                                    "duration_inMinutes": 33.23,
                                    "created_at": "Apr-03-20",
                                    "created_at_rawDateFormat": "2020-04-03T07:05:35.692Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 132612733,
                                "gitlabId": 132612733,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729618,
                                    "isTestReportAvailable": false,
                                    "duration": 1569,
                                    "duration_inMinutes": 26.15,
                                    "created_at": "Apr-03-20",
                                    "created_at_rawDateFormat": "2020-04-03T07:05:35.710Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 132610916,
                                "gitlabId": 132610916,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729619,
                                    "isTestReportAvailable": false,
                                    "duration": 38,
                                    "duration_inMinutes": 0.63,
                                    "created_at": "Apr-03-20",
                                    "created_at_rawDateFormat": "2020-04-03T07:05:35.835Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 132603879,
                                "gitlabId": 132603879,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729620,
                                    "isTestReportAvailable": false,
                                    "duration": 140,
                                    "duration_inMinutes": 2.33,
                                    "created_at": "Apr-03-20",
                                    "created_at_rawDateFormat": "2020-04-03T07:05:35.945Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 132603804,
                                "gitlabId": 132603804,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729621,
                                    "isTestReportAvailable": false,
                                    "duration": 121,
                                    "duration_inMinutes": 2.02,
                                    "created_at": "Apr-03-20",
                                    "created_at_rawDateFormat": "2020-04-03T07:05:35.959Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 131821275,
                                "gitlabId": 131821275,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729624,
                                    "isTestReportAvailable": false,
                                    "duration": 2429,
                                    "duration_inMinutes": 40.48,
                                    "created_at": "Apr-01-20",
                                    "created_at_rawDateFormat": "2020-04-01T07:05:36.139Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 131097832,
                                "gitlabId": 131097832,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729626,
                                    "isTestReportAvailable": false,
                                    "duration": 2684,
                                    "duration_inMinutes": 44.73,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:36.242Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 131074425,
                                "gitlabId": 131074425,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729622,
                                    "isTestReportAvailable": false,
                                    "duration": 1209,
                                    "duration_inMinutes": 20.15,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:36.001Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 130963876,
                                "gitlabId": 130963876,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729623,
                                    "isTestReportAvailable": false,
                                    "duration": 1188,
                                    "duration_inMinutes": 19.8,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:36.112Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 130946810,
                                "gitlabId": 130946810,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729628,
                                    "isTestReportAvailable": false,
                                    "duration": 1432,
                                    "duration_inMinutes": 23.87,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:36.389Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 130941519,
                                "gitlabId": 130941519,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729625,
                                    "isTestReportAvailable": false,
                                    "duration": 1680,
                                    "duration_inMinutes": 28,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:36.211Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 130925288,
                                "gitlabId": 130925288,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729627,
                                    "isTestReportAvailable": false,
                                    "duration": 1404,
                                    "duration_inMinutes": 23.4,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:36.284Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 128726573,
                                "gitlabId": 128726573,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729630,
                                    "isTestReportAvailable": false,
                                    "duration": 522,
                                    "duration_inMinutes": 8.7,
                                    "created_at": "Mar-23-20",
                                    "created_at_rawDateFormat": "2020-03-23T07:05:36.429Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 115854047,
                                "gitlabId": 115854047,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729629,
                                    "isTestReportAvailable": false,
                                    "duration": 1038,
                                    "duration_inMinutes": 17.3,
                                    "created_at": "Feb-07-20",
                                    "created_at_rawDateFormat": "2020-02-07T07:05:36.411Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 115846395,
                                "gitlabId": 115846395,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729631,
                                    "isTestReportAvailable": false,
                                    "duration": 853,
                                    "duration_inMinutes": 14.22,
                                    "created_at": "Feb-07-20",
                                    "created_at_rawDateFormat": "2020-02-07T07:05:36.474Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 115832875,
                                "gitlabId": 115832875,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729636,
                                    "isTestReportAvailable": false,
                                    "duration": 957,
                                    "duration_inMinutes": 15.95,
                                    "created_at": "Feb-07-20",
                                    "created_at_rawDateFormat": "2020-02-07T07:05:36.779Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 115831663,
                                "gitlabId": 115831663,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729632,
                                    "isTestReportAvailable": false,
                                    "duration": 266,
                                    "duration_inMinutes": 4.43,
                                    "created_at": "Feb-07-20",
                                    "created_at_rawDateFormat": "2020-02-07T07:05:36.547Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 115800593,
                                "gitlabId": 115800593,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729633,
                                    "isTestReportAvailable": false,
                                    "duration": 1349,
                                    "duration_inMinutes": 22.48,
                                    "created_at": "Feb-07-20",
                                    "created_at_rawDateFormat": "2020-02-07T07:05:36.639Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 115794582,
                                "gitlabId": 115794582,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729634,
                                    "isTestReportAvailable": false,
                                    "duration": 455,
                                    "duration_inMinutes": 7.58,
                                    "created_at": "Feb-07-20",
                                    "created_at_rawDateFormat": "2020-02-07T07:05:36.672Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 115792786,
                                "gitlabId": 115792786,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729635,
                                    "isTestReportAvailable": false,
                                    "duration": 1496,
                                    "duration_inMinutes": 24.93,
                                    "created_at": "Feb-07-20",
                                    "created_at_rawDateFormat": "2020-02-07T07:05:36.732Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 115791523,
                                "gitlabId": 115791523,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729647,
                                    "isTestReportAvailable": false,
                                    "duration": 376,
                                    "duration_inMinutes": 6.27,
                                    "created_at": "Feb-07-20",
                                    "created_at_rawDateFormat": "2020-02-07T07:05:37.398Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 115790614,
                                "gitlabId": 115790614,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729637,
                                    "isTestReportAvailable": false,
                                    "duration": 32,
                                    "duration_inMinutes": 0.53,
                                    "created_at": "Feb-07-20",
                                    "created_at_rawDateFormat": "2020-02-07T07:05:36.803Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 115790012,
                                "gitlabId": 115790012,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729638,
                                    "isTestReportAvailable": false,
                                    "duration": 35,
                                    "duration_inMinutes": 0.58,
                                    "created_at": "Feb-07-20",
                                    "created_at_rawDateFormat": "2020-02-07T07:05:36.903Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 115577708,
                                "gitlabId": 115577708,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729640,
                                    "isTestReportAvailable": false,
                                    "duration": 795,
                                    "duration_inMinutes": 13.25,
                                    "created_at": "Feb-06-20",
                                    "created_at_rawDateFormat": "2020-02-06T07:05:37.001Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 115103616,
                                "gitlabId": 115103616,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729639,
                                    "isTestReportAvailable": false,
                                    "duration": 474,
                                    "duration_inMinutes": 7.9,
                                    "created_at": "Feb-05-20",
                                    "created_at_rawDateFormat": "2020-02-05T07:05:36.996Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 113314746,
                                "gitlabId": 113314746,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729641,
                                    "isTestReportAvailable": false,
                                    "duration": 1279,
                                    "duration_inMinutes": 21.32,
                                    "created_at": "Jan-29-20",
                                    "created_at_rawDateFormat": "2020-01-29T07:05:37.037Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 113313815,
                                "gitlabId": 113313815,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729646,
                                    "isTestReportAvailable": false,
                                    "duration": 118,
                                    "duration_inMinutes": 1.97,
                                    "created_at": "Jan-29-20",
                                    "created_at_rawDateFormat": "2020-01-29T07:05:37.344Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 113313382,
                                "gitlabId": 113313382,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729642,
                                    "isTestReportAvailable": false,
                                    "duration": 204,
                                    "duration_inMinutes": 3.4,
                                    "created_at": "Jan-29-20",
                                    "created_at_rawDateFormat": "2020-01-29T07:05:37.195Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 113311921,
                                "gitlabId": 113311921,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729643,
                                    "isTestReportAvailable": false,
                                    "duration": 451,
                                    "duration_inMinutes": 7.52,
                                    "created_at": "Jan-29-20",
                                    "created_at_rawDateFormat": "2020-01-29T07:05:37.283Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 113305078,
                                "gitlabId": 113305078,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729644,
                                    "isTestReportAvailable": false,
                                    "duration": 272,
                                    "duration_inMinutes": 4.53,
                                    "created_at": "Jan-29-20",
                                    "created_at_rawDateFormat": "2020-01-29T07:05:37.306Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 113298843,
                                "gitlabId": 113298843,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729645,
                                    "isTestReportAvailable": false,
                                    "duration": 160,
                                    "duration_inMinutes": 2.67,
                                    "created_at": "Jan-29-20",
                                    "created_at_rawDateFormat": "2020-01-29T07:05:37.308Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 113297686,
                                "gitlabId": 113297686,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729648,
                                    "isTestReportAvailable": false,
                                    "duration": 179,
                                    "duration_inMinutes": 2.98,
                                    "created_at": "Jan-29-20",
                                    "created_at_rawDateFormat": "2020-01-29T07:05:37.457Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 113253431,
                                "gitlabId": 113253431,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729658,
                                    "isTestReportAvailable": false,
                                    "duration": 144,
                                    "duration_inMinutes": 2.4,
                                    "created_at": "Jan-29-20",
                                    "created_at_rawDateFormat": "2020-01-29T07:05:38.335Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 113252471,
                                "gitlabId": 113252471,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729649,
                                    "isTestReportAvailable": false,
                                    "duration": 167,
                                    "duration_inMinutes": 2.78,
                                    "created_at": "Jan-29-20",
                                    "created_at_rawDateFormat": "2020-01-29T07:05:37.568Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 113250549,
                                "gitlabId": 113250549,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729655,
                                    "isTestReportAvailable": false,
                                    "duration": 394,
                                    "duration_inMinutes": 6.57,
                                    "created_at": "Jan-29-20",
                                    "created_at_rawDateFormat": "2020-01-29T07:05:38.072Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 113249989,
                                "gitlabId": 113249989,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729652,
                                    "isTestReportAvailable": false,
                                    "duration": 135,
                                    "duration_inMinutes": 2.25,
                                    "created_at": "Jan-29-20",
                                    "created_at_rawDateFormat": "2020-01-29T07:05:37.841Z",
                                    "testCoverage": null
                                }
                            }
                        ],
                        "groupInfo": {
                            "id": 29705,
                            "gitlabId": 8473724,
                            "name": "Moen-Fahey"
                        }
                    },
                    {
                        "id": 17171209,
                        "gitlabId": 17171209,
                        "name": "delivery-platform",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Moen-Fahey/delivery-platform.git",
                        "stats": {
                            "id": 29751,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "24085790",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29764,
                            "gitlabId": 8473724,
                            "name": "Moen-Fahey"
                        }
                    },
                    {
                        "id": 16465285,
                        "gitlabId": 16465285,
                        "name": "dropkick",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Moen-Fahey/dropkick.git",
                        "stats": {
                            "id": 29780,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "244087521",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29739,
                            "gitlabId": 8473724,
                            "name": "Moen-Fahey"
                        }
                    }
                ],
                "subGroups": [],
                "stats": {
                    "id": 6721,
                    "isThereSubgroups": false,
                    "numberOfProjects": 4,
                    "testCoverageOfAllProjects": null,
                    "numberOfPipelines": 127,
                    "numberOfTestReports": 0
                }
            },
            {
                "id": 6265245,
                "tempData": false,
                "gitlabId": 6265245,
                "name": "Stark-Ryan",
                "projects": [
                    {
                        "id": 15772349,
                        "gitlabId": 15772349,
                        "name": "openitng",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Stark-Ryan/openitng.git",
                        "stats": {
                            "id": 29701,
                            "status": "success",
                            "numberOfPipelines": 10,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 171,
                            "averageDurationOfPipelines_inMinutes": 2.85,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 4,
                            "numberOfFailedPipelines": 4,
                            "numberOfCanceledPipelines": 1,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 1,
                            "pipelinesSuccessRatio": 40,
                            "totalRepoSize": "925578035",
                            "artifactsSize": "242783119"
                        },
                        "pipelines": [
                            {
                                "id": 201487823,
                                "gitlabId": 201487823,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729650,
                                    "isTestReportAvailable": false,
                                    "duration": 306,
                                    "duration_inMinutes": 5.1,
                                    "created_at": "Oct-12-20",
                                    "created_at_rawDateFormat": "2020-10-12T07:05:37.678Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 200524549,
                                "gitlabId": 200524549,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729651,
                                    "isTestReportAvailable": false,
                                    "duration": 151,
                                    "duration_inMinutes": 2.52,
                                    "created_at": "Oct-09-20",
                                    "created_at_rawDateFormat": "2020-10-09T07:05:37.730Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 200459256,
                                "gitlabId": 200459256,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729653,
                                    "isTestReportAvailable": false,
                                    "duration": 208,
                                    "duration_inMinutes": 3.47,
                                    "created_at": "Oct-09-20",
                                    "created_at_rawDateFormat": "2020-10-09T07:05:37.844Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 200261036,
                                "gitlabId": 200261036,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729654,
                                    "isTestReportAvailable": false,
                                    "duration": 202,
                                    "duration_inMinutes": 3.37,
                                    "created_at": "Oct-09-20",
                                    "created_at_rawDateFormat": "2020-10-09T07:05:37.954Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 200260954,
                                "gitlabId": 200260954,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729656,
                                    "isTestReportAvailable": false,
                                    "duration": 63,
                                    "duration_inMinutes": 1.05,
                                    "created_at": "Oct-09-20",
                                    "created_at_rawDateFormat": "2020-10-09T07:05:38.113Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 199877641,
                                "gitlabId": 199877641,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729657,
                                    "isTestReportAvailable": false,
                                    "duration": 286,
                                    "duration_inMinutes": 4.77,
                                    "created_at": "Oct-08-20",
                                    "created_at_rawDateFormat": "2020-10-08T07:05:38.217Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 199862374,
                                "gitlabId": 199862374,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729675,
                                    "isTestReportAvailable": false,
                                    "duration": 305,
                                    "duration_inMinutes": 5.08,
                                    "created_at": "Oct-08-20",
                                    "created_at_rawDateFormat": "2020-10-08T07:05:39.308Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 199857574,
                                "gitlabId": 199857574,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729662,
                                    "isTestReportAvailable": false,
                                    "duration": 75,
                                    "duration_inMinutes": 1.25,
                                    "created_at": "Oct-08-20",
                                    "created_at_rawDateFormat": "2020-10-08T07:05:38.536Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 199855195,
                                "gitlabId": 199855195,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729660,
                                    "isTestReportAvailable": false,
                                    "duration": 118,
                                    "duration_inMinutes": 1.97,
                                    "created_at": "Oct-08-20",
                                    "created_at_rawDateFormat": "2020-10-08T07:05:38.399Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 199679989,
                                "gitlabId": 199679989,
                                "status": "skipped",
                                "testReport": null,
                                "stats": {
                                    "id": 729659,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Oct-08-20",
                                    "created_at_rawDateFormat": "2020-10-08T07:05:38.383Z",
                                    "testCoverage": null
                                }
                            }
                        ],
                        "groupInfo": {
                            "id": 29706,
                            "gitlabId": 6265245,
                            "name": "Stark-Ryan"
                        }
                    },
                    {
                        "id": 14231550,
                        "gitlabId": 14231550,
                        "name": "Stark-Ryan-1",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Stark-Ryan.git",
                        "stats": {
                            "id": 29718,
                            "status": "success",
                            "numberOfPipelines": 97,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 357,
                            "averageDurationOfPipelines_inMinutes": 5.95,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 63,
                            "numberOfFailedPipelines": 24,
                            "numberOfCanceledPipelines": 10,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": 64.95,
                            "totalRepoSize": "1051826585",
                            "artifactsSize": "5039975420"
                        },
                        "pipelines": [
                            {
                                "id": 431744675,
                                "gitlabId": 431744675,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729661,
                                    "isTestReportAvailable": false,
                                    "duration": 216,
                                    "duration_inMinutes": 3.6,
                                    "created_at": "Dec-17-21",
                                    "created_at_rawDateFormat": "2021-12-17T07:05:38.511Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 431744464,
                                "gitlabId": 431744464,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729663,
                                    "isTestReportAvailable": false,
                                    "duration": 207,
                                    "duration_inMinutes": 3.45,
                                    "created_at": "Dec-17-21",
                                    "created_at_rawDateFormat": "2021-12-17T07:05:38.615Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 431689417,
                                "gitlabId": 431689417,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729669,
                                    "isTestReportAvailable": false,
                                    "duration": 480,
                                    "duration_inMinutes": 8,
                                    "created_at": "Dec-17-21",
                                    "created_at_rawDateFormat": "2021-12-17T07:05:38.962Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 431689282,
                                "gitlabId": 431689282,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729664,
                                    "isTestReportAvailable": false,
                                    "duration": 425,
                                    "duration_inMinutes": 7.08,
                                    "created_at": "Dec-17-21",
                                    "created_at_rawDateFormat": "2021-12-17T07:05:38.688Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 428975563,
                                "gitlabId": 428975563,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729666,
                                    "isTestReportAvailable": false,
                                    "duration": 722,
                                    "duration_inMinutes": 12.03,
                                    "created_at": "Dec-14-21",
                                    "created_at_rawDateFormat": "2021-12-14T07:05:38.848Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 428972037,
                                "gitlabId": 428972037,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729665,
                                    "isTestReportAvailable": false,
                                    "duration": 629,
                                    "duration_inMinutes": 10.48,
                                    "created_at": "Dec-14-21",
                                    "created_at_rawDateFormat": "2021-12-14T07:05:38.793Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 395680411,
                                "gitlabId": 395680411,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729667,
                                    "isTestReportAvailable": false,
                                    "duration": 187,
                                    "duration_inMinutes": 3.12,
                                    "created_at": "Oct-26-21",
                                    "created_at_rawDateFormat": "2021-10-26T07:05:38.928Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 395670616,
                                "gitlabId": 395670616,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729668,
                                    "isTestReportAvailable": false,
                                    "duration": 174,
                                    "duration_inMinutes": 2.9,
                                    "created_at": "Oct-26-21",
                                    "created_at_rawDateFormat": "2021-10-26T07:05:38.941Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 395659200,
                                "gitlabId": 395659200,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729670,
                                    "isTestReportAvailable": false,
                                    "duration": 491,
                                    "duration_inMinutes": 8.18,
                                    "created_at": "Oct-26-21",
                                    "created_at_rawDateFormat": "2021-10-26T07:05:39.112Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 391136819,
                                "gitlabId": 391136819,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729674,
                                    "isTestReportAvailable": false,
                                    "duration": 233,
                                    "duration_inMinutes": 3.88,
                                    "created_at": "Oct-19-21",
                                    "created_at_rawDateFormat": "2021-10-19T07:05:39.299Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 390271380,
                                "gitlabId": 390271380,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729671,
                                    "isTestReportAvailable": false,
                                    "duration": 168,
                                    "duration_inMinutes": 2.8,
                                    "created_at": "Oct-18-21",
                                    "created_at_rawDateFormat": "2021-10-18T07:05:39.212Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 385027677,
                                "gitlabId": 385027677,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729673,
                                    "isTestReportAvailable": false,
                                    "duration": 193,
                                    "duration_inMinutes": 3.22,
                                    "created_at": "Oct-08-21",
                                    "created_at_rawDateFormat": "2021-10-08T07:05:39.266Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 385026701,
                                "gitlabId": 385026701,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729672,
                                    "isTestReportAvailable": false,
                                    "duration": 146,
                                    "duration_inMinutes": 2.43,
                                    "created_at": "Oct-08-21",
                                    "created_at_rawDateFormat": "2021-10-08T07:05:39.249Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 380036452,
                                "gitlabId": 380036452,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729676,
                                    "isTestReportAvailable": false,
                                    "duration": 165,
                                    "duration_inMinutes": 2.75,
                                    "created_at": "Sep-30-21",
                                    "created_at_rawDateFormat": "2021-09-30T07:05:39.431Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 380032321,
                                "gitlabId": 380032321,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729677,
                                    "isTestReportAvailable": false,
                                    "duration": 252,
                                    "duration_inMinutes": 4.2,
                                    "created_at": "Sep-30-21",
                                    "created_at_rawDateFormat": "2021-09-30T07:05:39.475Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 380030985,
                                "gitlabId": 380030985,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729678,
                                    "isTestReportAvailable": false,
                                    "duration": 316,
                                    "duration_inMinutes": 5.27,
                                    "created_at": "Sep-30-21",
                                    "created_at_rawDateFormat": "2021-09-30T07:05:39.496Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 380029972,
                                "gitlabId": 380029972,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729679,
                                    "isTestReportAvailable": false,
                                    "duration": 41,
                                    "duration_inMinutes": 0.68,
                                    "created_at": "Sep-30-21",
                                    "created_at_rawDateFormat": "2021-09-30T07:05:39.551Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 375844890,
                                "gitlabId": 375844890,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729681,
                                    "isTestReportAvailable": false,
                                    "duration": 126,
                                    "duration_inMinutes": 2.1,
                                    "created_at": "Sep-23-21",
                                    "created_at_rawDateFormat": "2021-09-23T07:05:39.573Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 375758950,
                                "gitlabId": 375758950,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729680,
                                    "isTestReportAvailable": false,
                                    "duration": 146,
                                    "duration_inMinutes": 2.43,
                                    "created_at": "Sep-23-21",
                                    "created_at_rawDateFormat": "2021-09-23T07:05:39.572Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 364804162,
                                "gitlabId": 364804162,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729682,
                                    "isTestReportAvailable": false,
                                    "duration": 337,
                                    "duration_inMinutes": 5.62,
                                    "created_at": "Sep-03-21",
                                    "created_at_rawDateFormat": "2021-09-03T07:05:39.682Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 364779425,
                                "gitlabId": 364779425,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729683,
                                    "isTestReportAvailable": false,
                                    "duration": 180,
                                    "duration_inMinutes": 3,
                                    "created_at": "Sep-03-21",
                                    "created_at_rawDateFormat": "2021-09-03T07:05:39.744Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 364779090,
                                "gitlabId": 364779090,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729687,
                                    "isTestReportAvailable": false,
                                    "duration": 88,
                                    "duration_inMinutes": 1.47,
                                    "created_at": "Sep-03-21",
                                    "created_at_rawDateFormat": "2021-09-03T07:05:39.928Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 362535380,
                                "gitlabId": 362535380,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729686,
                                    "isTestReportAvailable": false,
                                    "duration": 176,
                                    "duration_inMinutes": 2.93,
                                    "created_at": "Aug-31-21",
                                    "created_at_rawDateFormat": "2021-08-31T07:05:39.882Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 360719721,
                                "gitlabId": 360719721,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729685,
                                    "isTestReportAvailable": false,
                                    "duration": 132,
                                    "duration_inMinutes": 2.2,
                                    "created_at": "Aug-27-21",
                                    "created_at_rawDateFormat": "2021-08-27T07:05:39.862Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 360117904,
                                "gitlabId": 360117904,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729684,
                                    "isTestReportAvailable": false,
                                    "duration": 328,
                                    "duration_inMinutes": 5.47,
                                    "created_at": "Aug-26-21",
                                    "created_at_rawDateFormat": "2021-08-26T07:05:39.829Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 360107245,
                                "gitlabId": 360107245,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729688,
                                    "isTestReportAvailable": false,
                                    "duration": 199,
                                    "duration_inMinutes": 3.32,
                                    "created_at": "Aug-26-21",
                                    "created_at_rawDateFormat": "2021-08-26T07:05:39.937Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 348946611,
                                "gitlabId": 348946611,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729689,
                                    "isTestReportAvailable": false,
                                    "duration": 156,
                                    "duration_inMinutes": 2.6,
                                    "created_at": "Aug-06-21",
                                    "created_at_rawDateFormat": "2021-08-06T07:05:40.091Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 339316207,
                                "gitlabId": 339316207,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729691,
                                    "isTestReportAvailable": false,
                                    "duration": 146,
                                    "duration_inMinutes": 2.43,
                                    "created_at": "Jul-19-21",
                                    "created_at_rawDateFormat": "2021-07-19T07:05:40.167Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 337705416,
                                "gitlabId": 337705416,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729693,
                                    "isTestReportAvailable": false,
                                    "duration": 25,
                                    "duration_inMinutes": 0.42,
                                    "created_at": "Jul-15-21",
                                    "created_at_rawDateFormat": "2021-07-15T07:05:40.334Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 336887521,
                                "gitlabId": 336887521,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729690,
                                    "isTestReportAvailable": false,
                                    "duration": 276,
                                    "duration_inMinutes": 4.6,
                                    "created_at": "Jul-14-21",
                                    "created_at_rawDateFormat": "2021-07-14T07:05:40.138Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 336003416,
                                "gitlabId": 336003416,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729694,
                                    "isTestReportAvailable": false,
                                    "duration": 217,
                                    "duration_inMinutes": 3.62,
                                    "created_at": "Jul-13-21",
                                    "created_at_rawDateFormat": "2021-07-13T07:05:40.347Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 333619378,
                                "gitlabId": 333619378,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729692,
                                    "isTestReportAvailable": false,
                                    "duration": 34,
                                    "duration_inMinutes": 0.57,
                                    "created_at": "Jul-08-21",
                                    "created_at_rawDateFormat": "2021-07-08T07:05:40.229Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 333619227,
                                "gitlabId": 333619227,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729696,
                                    "isTestReportAvailable": false,
                                    "duration": 240,
                                    "duration_inMinutes": 4,
                                    "created_at": "Jul-08-21",
                                    "created_at_rawDateFormat": "2021-07-08T07:05:40.504Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 327292005,
                                "gitlabId": 327292005,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729697,
                                    "isTestReportAvailable": false,
                                    "duration": 239,
                                    "duration_inMinutes": 3.98,
                                    "created_at": "Jun-25-21",
                                    "created_at_rawDateFormat": "2021-06-25T07:05:40.583Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 327283774,
                                "gitlabId": 327283774,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729695,
                                    "isTestReportAvailable": false,
                                    "duration": 309,
                                    "duration_inMinutes": 5.15,
                                    "created_at": "Jun-25-21",
                                    "created_at_rawDateFormat": "2021-06-25T07:05:40.434Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 327279732,
                                "gitlabId": 327279732,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729707,
                                    "isTestReportAvailable": false,
                                    "duration": 106,
                                    "duration_inMinutes": 1.77,
                                    "created_at": "Jun-25-21",
                                    "created_at_rawDateFormat": "2021-06-25T07:05:41.322Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 327275105,
                                "gitlabId": 327275105,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729703,
                                    "isTestReportAvailable": false,
                                    "duration": 114,
                                    "duration_inMinutes": 1.9,
                                    "created_at": "Jun-25-21",
                                    "created_at_rawDateFormat": "2021-06-25T07:05:41.051Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 327268006,
                                "gitlabId": 327268006,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729699,
                                    "isTestReportAvailable": false,
                                    "duration": 124,
                                    "duration_inMinutes": 2.07,
                                    "created_at": "Jun-25-21",
                                    "created_at_rawDateFormat": "2021-06-25T07:05:40.762Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 327259758,
                                "gitlabId": 327259758,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729698,
                                    "isTestReportAvailable": false,
                                    "duration": 188,
                                    "duration_inMinutes": 3.13,
                                    "created_at": "Jun-25-21",
                                    "created_at_rawDateFormat": "2021-06-25T07:05:40.745Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 327255247,
                                "gitlabId": 327255247,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729700,
                                    "isTestReportAvailable": false,
                                    "duration": 398,
                                    "duration_inMinutes": 6.63,
                                    "created_at": "Jun-25-21",
                                    "created_at_rawDateFormat": "2021-06-25T07:05:40.781Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 327099795,
                                "gitlabId": 327099795,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729701,
                                    "isTestReportAvailable": false,
                                    "duration": 591,
                                    "duration_inMinutes": 9.85,
                                    "created_at": "Jun-25-21",
                                    "created_at_rawDateFormat": "2021-06-25T07:05:40.841Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 326590329,
                                "gitlabId": 326590329,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729702,
                                    "isTestReportAvailable": false,
                                    "duration": 337,
                                    "duration_inMinutes": 5.62,
                                    "created_at": "Jun-24-21",
                                    "created_at_rawDateFormat": "2021-06-24T07:05:41.013Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 326477747,
                                "gitlabId": 326477747,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729704,
                                    "isTestReportAvailable": false,
                                    "duration": 373,
                                    "duration_inMinutes": 6.22,
                                    "created_at": "Jun-24-21",
                                    "created_at_rawDateFormat": "2021-06-24T07:05:41.061Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 325929951,
                                "gitlabId": 325929951,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729719,
                                    "isTestReportAvailable": false,
                                    "duration": 486,
                                    "duration_inMinutes": 8.1,
                                    "created_at": "Jun-23-21",
                                    "created_at_rawDateFormat": "2021-06-23T07:05:42.162Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 325124114,
                                "gitlabId": 325124114,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729705,
                                    "isTestReportAvailable": false,
                                    "duration": 457,
                                    "duration_inMinutes": 7.62,
                                    "created_at": "Jun-22-21",
                                    "created_at_rawDateFormat": "2021-06-22T07:05:41.087Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 323157996,
                                "gitlabId": 323157996,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729706,
                                    "isTestReportAvailable": false,
                                    "duration": 479,
                                    "duration_inMinutes": 7.98,
                                    "created_at": "Jun-18-21",
                                    "created_at_rawDateFormat": "2021-06-18T07:05:41.288Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 276467669,
                                "gitlabId": 276467669,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729709,
                                    "isTestReportAvailable": false,
                                    "duration": 721,
                                    "duration_inMinutes": 12.02,
                                    "created_at": "Mar-25-21",
                                    "created_at_rawDateFormat": "2021-03-25T07:05:41.473Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 276467551,
                                "gitlabId": 276467551,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729710,
                                    "isTestReportAvailable": false,
                                    "duration": 742,
                                    "duration_inMinutes": 12.37,
                                    "created_at": "Mar-25-21",
                                    "created_at_rawDateFormat": "2021-03-25T07:05:41.488Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 251322802,
                                "gitlabId": 251322802,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729708,
                                    "isTestReportAvailable": false,
                                    "duration": 425,
                                    "duration_inMinutes": 7.08,
                                    "created_at": "Feb-04-21",
                                    "created_at_rawDateFormat": "2021-02-04T07:05:41.402Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 251322491,
                                "gitlabId": 251322491,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729711,
                                    "isTestReportAvailable": false,
                                    "duration": 499,
                                    "duration_inMinutes": 8.32,
                                    "created_at": "Feb-04-21",
                                    "created_at_rawDateFormat": "2021-02-04T07:05:41.628Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 249792458,
                                "gitlabId": 249792458,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729713,
                                    "isTestReportAvailable": false,
                                    "duration": 299,
                                    "duration_inMinutes": 4.98,
                                    "created_at": "Feb-01-21",
                                    "created_at_rawDateFormat": "2021-02-01T07:05:41.740Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 249791591,
                                "gitlabId": 249791591,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729724,
                                    "isTestReportAvailable": false,
                                    "duration": 660,
                                    "duration_inMinutes": 11,
                                    "created_at": "Feb-01-21",
                                    "created_at_rawDateFormat": "2021-02-01T07:05:42.454Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 249737856,
                                "gitlabId": 249737856,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729712,
                                    "isTestReportAvailable": false,
                                    "duration": 995,
                                    "duration_inMinutes": 16.58,
                                    "created_at": "Feb-01-21",
                                    "created_at_rawDateFormat": "2021-02-01T07:05:41.725Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 249735249,
                                "gitlabId": 249735249,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729714,
                                    "isTestReportAvailable": false,
                                    "duration": 1410,
                                    "duration_inMinutes": 23.5,
                                    "created_at": "Feb-01-21",
                                    "created_at_rawDateFormat": "2021-02-01T07:05:41.760Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 249733252,
                                "gitlabId": 249733252,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729715,
                                    "isTestReportAvailable": false,
                                    "duration": 1478,
                                    "duration_inMinutes": 24.63,
                                    "created_at": "Feb-01-21",
                                    "created_at_rawDateFormat": "2021-02-01T07:05:41.890Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 248780923,
                                "gitlabId": 248780923,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729721,
                                    "isTestReportAvailable": false,
                                    "duration": 552,
                                    "duration_inMinutes": 9.2,
                                    "created_at": "Jan-29-21",
                                    "created_at_rawDateFormat": "2021-01-29T07:05:42.306Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 247593814,
                                "gitlabId": 247593814,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729716,
                                    "isTestReportAvailable": false,
                                    "duration": 336,
                                    "duration_inMinutes": 5.6,
                                    "created_at": "Jan-27-21",
                                    "created_at_rawDateFormat": "2021-01-27T07:05:41.994Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 247083778,
                                "gitlabId": 247083778,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729717,
                                    "isTestReportAvailable": false,
                                    "duration": 411,
                                    "duration_inMinutes": 6.85,
                                    "created_at": "Jan-26-21",
                                    "created_at_rawDateFormat": "2021-01-26T07:05:42.018Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 247083508,
                                "gitlabId": 247083508,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729718,
                                    "isTestReportAvailable": false,
                                    "duration": 38,
                                    "duration_inMinutes": 0.63,
                                    "created_at": "Jan-26-21",
                                    "created_at_rawDateFormat": "2021-01-26T07:05:42.152Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 247078403,
                                "gitlabId": 247078403,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729720,
                                    "isTestReportAvailable": false,
                                    "duration": 477,
                                    "duration_inMinutes": 7.95,
                                    "created_at": "Jan-26-21",
                                    "created_at_rawDateFormat": "2021-01-26T07:05:42.246Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 247078198,
                                "gitlabId": 247078198,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729725,
                                    "isTestReportAvailable": false,
                                    "duration": 506,
                                    "duration_inMinutes": 8.43,
                                    "created_at": "Jan-26-21",
                                    "created_at_rawDateFormat": "2021-01-26T07:05:42.572Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 246525078,
                                "gitlabId": 246525078,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729722,
                                    "isTestReportAvailable": false,
                                    "duration": 502,
                                    "duration_inMinutes": 8.37,
                                    "created_at": "Jan-25-21",
                                    "created_at_rawDateFormat": "2021-01-25T07:05:42.430Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 246398058,
                                "gitlabId": 246398058,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729723,
                                    "isTestReportAvailable": false,
                                    "duration": 698,
                                    "duration_inMinutes": 11.63,
                                    "created_at": "Jan-25-21",
                                    "created_at_rawDateFormat": "2021-01-25T07:05:42.437Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 246385211,
                                "gitlabId": 246385211,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729747,
                                    "isTestReportAvailable": false,
                                    "duration": 677,
                                    "duration_inMinutes": 11.28,
                                    "created_at": "Jan-25-21",
                                    "created_at_rawDateFormat": "2021-01-25T07:05:44.368Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 246344196,
                                "gitlabId": 246344196,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729726,
                                    "isTestReportAvailable": false,
                                    "duration": 572,
                                    "duration_inMinutes": 9.53,
                                    "created_at": "Jan-25-21",
                                    "created_at_rawDateFormat": "2021-01-25T07:05:42.577Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 246341568,
                                "gitlabId": 246341568,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729727,
                                    "isTestReportAvailable": false,
                                    "duration": 340,
                                    "duration_inMinutes": 5.67,
                                    "created_at": "Jan-25-21",
                                    "created_at_rawDateFormat": "2021-01-25T07:05:42.687Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 246338192,
                                "gitlabId": 246338192,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729737,
                                    "isTestReportAvailable": false,
                                    "duration": 730,
                                    "duration_inMinutes": 12.17,
                                    "created_at": "Jan-25-21",
                                    "created_at_rawDateFormat": "2021-01-25T07:05:43.537Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 245572344,
                                "gitlabId": 245572344,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729728,
                                    "isTestReportAvailable": false,
                                    "duration": 460,
                                    "duration_inMinutes": 7.67,
                                    "created_at": "Jan-22-21",
                                    "created_at_rawDateFormat": "2021-01-22T07:05:42.862Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 243290320,
                                "gitlabId": 243290320,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729730,
                                    "isTestReportAvailable": false,
                                    "duration": 434,
                                    "duration_inMinutes": 7.23,
                                    "created_at": "Jan-18-21",
                                    "created_at_rawDateFormat": "2021-01-18T07:05:43.037Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 224757328,
                                "gitlabId": 224757328,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729729,
                                    "isTestReportAvailable": false,
                                    "duration": 335,
                                    "duration_inMinutes": 5.58,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:42.863Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 224706099,
                                "gitlabId": 224706099,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729734,
                                    "isTestReportAvailable": false,
                                    "duration": 595,
                                    "duration_inMinutes": 9.92,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:43.321Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 224705726,
                                "gitlabId": 224705726,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729731,
                                    "isTestReportAvailable": false,
                                    "duration": 639,
                                    "duration_inMinutes": 10.65,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:43.109Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 209196944,
                                "gitlabId": 209196944,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729732,
                                    "isTestReportAvailable": false,
                                    "duration": 346,
                                    "duration_inMinutes": 5.77,
                                    "created_at": "Oct-29-20",
                                    "created_at_rawDateFormat": "2020-10-29T07:05:43.139Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 206906745,
                                "gitlabId": 206906745,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729733,
                                    "isTestReportAvailable": false,
                                    "duration": 355,
                                    "duration_inMinutes": 5.92,
                                    "created_at": "Oct-23-20",
                                    "created_at_rawDateFormat": "2020-10-23T07:05:43.303Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 206303568,
                                "gitlabId": 206303568,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729735,
                                    "isTestReportAvailable": false,
                                    "duration": 235,
                                    "duration_inMinutes": 3.92,
                                    "created_at": "Oct-22-20",
                                    "created_at_rawDateFormat": "2020-10-22T07:05:43.371Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 206289806,
                                "gitlabId": 206289806,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729736,
                                    "isTestReportAvailable": false,
                                    "duration": 339,
                                    "duration_inMinutes": 5.65,
                                    "created_at": "Oct-22-20",
                                    "created_at_rawDateFormat": "2020-10-22T07:05:43.407Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 202923465,
                                "gitlabId": 202923465,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729738,
                                    "isTestReportAvailable": false,
                                    "duration": 367,
                                    "duration_inMinutes": 6.12,
                                    "created_at": "Oct-15-20",
                                    "created_at_rawDateFormat": "2020-10-15T07:05:43.566Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 191698568,
                                "gitlabId": 191698568,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729740,
                                    "isTestReportAvailable": false,
                                    "duration": 44,
                                    "duration_inMinutes": 0.73,
                                    "created_at": "Sep-18-20",
                                    "created_at_rawDateFormat": "2020-09-18T07:05:43.819Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 191698494,
                                "gitlabId": 191698494,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729739,
                                    "isTestReportAvailable": false,
                                    "duration": 1038,
                                    "duration_inMinutes": 17.3,
                                    "created_at": "Sep-18-20",
                                    "created_at_rawDateFormat": "2020-09-18T07:05:43.783Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 191681112,
                                "gitlabId": 191681112,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729742,
                                    "isTestReportAvailable": false,
                                    "duration": 298,
                                    "duration_inMinutes": 4.97,
                                    "created_at": "Sep-18-20",
                                    "created_at_rawDateFormat": "2020-09-18T07:05:43.928Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 191677989,
                                "gitlabId": 191677989,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729741,
                                    "isTestReportAvailable": false,
                                    "duration": 282,
                                    "duration_inMinutes": 4.7,
                                    "created_at": "Sep-18-20",
                                    "created_at_rawDateFormat": "2020-09-18T07:05:43.844Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 191677160,
                                "gitlabId": 191677160,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729743,
                                    "isTestReportAvailable": false,
                                    "duration": 61,
                                    "duration_inMinutes": 1.02,
                                    "created_at": "Sep-18-20",
                                    "created_at_rawDateFormat": "2020-09-18T07:05:44.080Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 191641612,
                                "gitlabId": 191641612,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729744,
                                    "isTestReportAvailable": false,
                                    "duration": 185,
                                    "duration_inMinutes": 3.08,
                                    "created_at": "Sep-18-20",
                                    "created_at_rawDateFormat": "2020-09-18T07:05:44.184Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 191632135,
                                "gitlabId": 191632135,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729746,
                                    "isTestReportAvailable": false,
                                    "duration": 147,
                                    "duration_inMinutes": 2.45,
                                    "created_at": "Sep-18-20",
                                    "created_at_rawDateFormat": "2020-09-18T07:05:44.258Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 191630189,
                                "gitlabId": 191630189,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729745,
                                    "isTestReportAvailable": false,
                                    "duration": 166,
                                    "duration_inMinutes": 2.77,
                                    "created_at": "Sep-18-20",
                                    "created_at_rawDateFormat": "2020-09-18T07:05:44.228Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 168451686,
                                "gitlabId": 168451686,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729748,
                                    "isTestReportAvailable": false,
                                    "duration": 384,
                                    "duration_inMinutes": 6.4,
                                    "created_at": "Jul-20-20",
                                    "created_at_rawDateFormat": "2020-07-20T07:05:44.601Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 168451386,
                                "gitlabId": 168451386,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729749,
                                    "isTestReportAvailable": false,
                                    "duration": 304,
                                    "duration_inMinutes": 5.07,
                                    "created_at": "Jul-20-20",
                                    "created_at_rawDateFormat": "2020-07-20T07:05:44.633Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 167826980,
                                "gitlabId": 167826980,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729752,
                                    "isTestReportAvailable": false,
                                    "duration": 74,
                                    "duration_inMinutes": 1.23,
                                    "created_at": "Jul-17-20",
                                    "created_at_rawDateFormat": "2020-07-17T07:05:44.686Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 167297219,
                                "gitlabId": 167297219,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729750,
                                    "isTestReportAvailable": false,
                                    "duration": 572,
                                    "duration_inMinutes": 9.53,
                                    "created_at": "Jul-16-20",
                                    "created_at_rawDateFormat": "2020-07-16T07:05:44.657Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 166884927,
                                "gitlabId": 166884927,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729753,
                                    "isTestReportAvailable": false,
                                    "duration": 389,
                                    "duration_inMinutes": 6.48,
                                    "created_at": "Jul-15-20",
                                    "created_at_rawDateFormat": "2020-07-15T07:05:44.824Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 165964043,
                                "gitlabId": 165964043,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729751,
                                    "isTestReportAvailable": false,
                                    "duration": 371,
                                    "duration_inMinutes": 6.18,
                                    "created_at": "Jul-13-20",
                                    "created_at_rawDateFormat": "2020-07-13T07:05:44.666Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 159680804,
                                "gitlabId": 159680804,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729754,
                                    "isTestReportAvailable": false,
                                    "duration": 136,
                                    "duration_inMinutes": 2.27,
                                    "created_at": "Jun-24-20",
                                    "created_at_rawDateFormat": "2020-06-24T07:05:44.919Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 159678749,
                                "gitlabId": 159678749,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729755,
                                    "isTestReportAvailable": false,
                                    "duration": 121,
                                    "duration_inMinutes": 2.02,
                                    "created_at": "Jun-24-20",
                                    "created_at_rawDateFormat": "2020-06-24T07:05:45.009Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 159672634,
                                "gitlabId": 159672634,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729756,
                                    "isTestReportAvailable": false,
                                    "duration": 121,
                                    "duration_inMinutes": 2.02,
                                    "created_at": "Jun-24-20",
                                    "created_at_rawDateFormat": "2020-06-24T07:05:45.037Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 159669790,
                                "gitlabId": 159669790,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729757,
                                    "isTestReportAvailable": false,
                                    "duration": 132,
                                    "duration_inMinutes": 2.2,
                                    "created_at": "Jun-24-20",
                                    "created_at_rawDateFormat": "2020-06-24T07:05:45.113Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 159666140,
                                "gitlabId": 159666140,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729760,
                                    "isTestReportAvailable": false,
                                    "duration": 398,
                                    "duration_inMinutes": 6.63,
                                    "created_at": "Jun-24-20",
                                    "created_at_rawDateFormat": "2020-06-24T07:05:45.356Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 157925035,
                                "gitlabId": 157925035,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729758,
                                    "isTestReportAvailable": false,
                                    "duration": 181,
                                    "duration_inMinutes": 3.02,
                                    "created_at": "Jun-19-20",
                                    "created_at_rawDateFormat": "2020-06-19T07:05:45.156Z",
                                    "testCoverage": null
                                }
                            }
                        ],
                        "groupInfo": {
                            "id": 29710,
                            "gitlabId": 6265245,
                            "name": "Stark-Ryan"
                        }
                    },
                    {
                        "id": 14231530,
                        "gitlabId": 14231530,
                        "name": "Stark-Ryan-2",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Stark-Ryan.git",
                        "stats": {
                            "id": 29713,
                            "status": "success",
                            "numberOfPipelines": 97,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 409,
                            "averageDurationOfPipelines_inMinutes": 6.82,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 70,
                            "numberOfFailedPipelines": 23,
                            "numberOfCanceledPipelines": 4,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": 72.16,
                            "totalRepoSize": "804310220",
                            "artifactsSize": "5392660287"
                        },
                        "pipelines": [
                            {
                                "id": 489816999,
                                "gitlabId": 489816999,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729460,
                                    "isTestReportAvailable": false,
                                    "duration": 308,
                                    "duration_inMinutes": 5.13,
                                    "created_at": "Mar-11-22",
                                    "created_at_rawDateFormat": "2022-03-11T07:05:23.693Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 484486726,
                                "gitlabId": 484486726,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729459,
                                    "isTestReportAvailable": false,
                                    "duration": 264,
                                    "duration_inMinutes": 4.4,
                                    "created_at": "Mar-04-22",
                                    "created_at_rawDateFormat": "2022-03-04T07:05:23.691Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 481839895,
                                "gitlabId": 481839895,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729463,
                                    "isTestReportAvailable": false,
                                    "duration": 356,
                                    "duration_inMinutes": 5.93,
                                    "created_at": "Mar-01-22",
                                    "created_at_rawDateFormat": "2022-03-01T07:05:23.761Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 481837671,
                                "gitlabId": 481837671,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729464,
                                    "isTestReportAvailable": false,
                                    "duration": 329,
                                    "duration_inMinutes": 5.48,
                                    "created_at": "Mar-01-22",
                                    "created_at_rawDateFormat": "2022-03-01T07:05:23.958Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 473473409,
                                "gitlabId": 473473409,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729467,
                                    "isTestReportAvailable": false,
                                    "duration": 154,
                                    "duration_inMinutes": 2.57,
                                    "created_at": "Feb-17-22",
                                    "created_at_rawDateFormat": "2022-02-17T07:05:24.074Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 473460877,
                                "gitlabId": 473460877,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729468,
                                    "isTestReportAvailable": false,
                                    "duration": 158,
                                    "duration_inMinutes": 2.63,
                                    "created_at": "Feb-17-22",
                                    "created_at_rawDateFormat": "2022-02-17T07:05:24.112Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 473442616,
                                "gitlabId": 473442616,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729466,
                                    "isTestReportAvailable": false,
                                    "duration": 30,
                                    "duration_inMinutes": 0.5,
                                    "created_at": "Feb-17-22",
                                    "created_at_rawDateFormat": "2022-02-17T07:05:24.029Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 473439604,
                                "gitlabId": 473439604,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729465,
                                    "isTestReportAvailable": false,
                                    "duration": 148,
                                    "duration_inMinutes": 2.47,
                                    "created_at": "Feb-17-22",
                                    "created_at_rawDateFormat": "2022-02-17T07:05:24.010Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 473437434,
                                "gitlabId": 473437434,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729469,
                                    "isTestReportAvailable": false,
                                    "duration": 275,
                                    "duration_inMinutes": 4.58,
                                    "created_at": "Feb-17-22",
                                    "created_at_rawDateFormat": "2022-02-17T07:05:24.273Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 458544912,
                                "gitlabId": 458544912,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729471,
                                    "isTestReportAvailable": false,
                                    "duration": 246,
                                    "duration_inMinutes": 4.1,
                                    "created_at": "Jan-28-22",
                                    "created_at_rawDateFormat": "2022-01-28T07:05:24.352Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 451452406,
                                "gitlabId": 451452406,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729484,
                                    "isTestReportAvailable": false,
                                    "duration": 30,
                                    "duration_inMinutes": 0.5,
                                    "created_at": "Jan-19-22",
                                    "created_at_rawDateFormat": "2022-01-19T07:05:25.592Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 451452236,
                                "gitlabId": 451452236,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729470,
                                    "isTestReportAvailable": false,
                                    "duration": 37,
                                    "duration_inMinutes": 0.62,
                                    "created_at": "Jan-19-22",
                                    "created_at_rawDateFormat": "2022-01-19T07:05:24.324Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 447142423,
                                "gitlabId": 447142423,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729472,
                                    "isTestReportAvailable": false,
                                    "duration": 11,
                                    "duration_inMinutes": 0.18,
                                    "created_at": "Jan-13-22",
                                    "created_at_rawDateFormat": "2022-01-13T07:05:24.376Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 447135947,
                                "gitlabId": 447135947,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729478,
                                    "isTestReportAvailable": false,
                                    "duration": 12,
                                    "duration_inMinutes": 0.2,
                                    "created_at": "Jan-13-22",
                                    "created_at_rawDateFormat": "2022-01-13T07:05:25.124Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 447125188,
                                "gitlabId": 447125188,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729475,
                                    "isTestReportAvailable": false,
                                    "duration": 198,
                                    "duration_inMinutes": 3.3,
                                    "created_at": "Jan-13-22",
                                    "created_at_rawDateFormat": "2022-01-13T07:05:24.856Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 447112267,
                                "gitlabId": 447112267,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729474,
                                    "isTestReportAvailable": false,
                                    "duration": 209,
                                    "duration_inMinutes": 3.48,
                                    "created_at": "Jan-13-22",
                                    "created_at_rawDateFormat": "2022-01-13T07:05:24.762Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 446637013,
                                "gitlabId": 446637013,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729473,
                                    "isTestReportAvailable": false,
                                    "duration": 17,
                                    "duration_inMinutes": 0.28,
                                    "created_at": "Jan-12-22",
                                    "created_at_rawDateFormat": "2022-01-12T07:05:24.639Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 446631731,
                                "gitlabId": 446631731,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729476,
                                    "isTestReportAvailable": false,
                                    "duration": 177,
                                    "duration_inMinutes": 2.95,
                                    "created_at": "Jan-12-22",
                                    "created_at_rawDateFormat": "2022-01-12T07:05:24.977Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 446439090,
                                "gitlabId": 446439090,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729477,
                                    "isTestReportAvailable": false,
                                    "duration": 420,
                                    "duration_inMinutes": 7,
                                    "created_at": "Jan-12-22",
                                    "created_at_rawDateFormat": "2022-01-12T07:05:25.038Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 445653908,
                                "gitlabId": 445653908,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729482,
                                    "isTestReportAvailable": false,
                                    "duration": 285,
                                    "duration_inMinutes": 4.75,
                                    "created_at": "Jan-11-22",
                                    "created_at_rawDateFormat": "2022-01-11T07:05:25.557Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 433418866,
                                "gitlabId": 433418866,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729479,
                                    "isTestReportAvailable": false,
                                    "duration": 152,
                                    "duration_inMinutes": 2.53,
                                    "created_at": "Dec-20-21",
                                    "created_at_rawDateFormat": "2021-12-20T07:05:25.253Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 433405401,
                                "gitlabId": 433405401,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729480,
                                    "isTestReportAvailable": false,
                                    "duration": 212,
                                    "duration_inMinutes": 3.53,
                                    "created_at": "Dec-20-21",
                                    "created_at_rawDateFormat": "2021-12-20T07:05:25.296Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 433154633,
                                "gitlabId": 433154633,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729485,
                                    "isTestReportAvailable": false,
                                    "duration": 142,
                                    "duration_inMinutes": 2.37,
                                    "created_at": "Dec-20-21",
                                    "created_at_rawDateFormat": "2021-12-20T07:05:25.701Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 433096659,
                                "gitlabId": 433096659,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729493,
                                    "isTestReportAvailable": false,
                                    "duration": 295,
                                    "duration_inMinutes": 4.92,
                                    "created_at": "Dec-20-21",
                                    "created_at_rawDateFormat": "2021-12-20T07:05:26.186Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 429082489,
                                "gitlabId": 429082489,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729486,
                                    "isTestReportAvailable": false,
                                    "duration": 243,
                                    "duration_inMinutes": 4.05,
                                    "created_at": "Dec-14-21",
                                    "created_at_rawDateFormat": "2021-12-14T07:05:25.776Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 412342926,
                                "gitlabId": 412342926,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729483,
                                    "isTestReportAvailable": false,
                                    "duration": 152,
                                    "duration_inMinutes": 2.53,
                                    "created_at": "Nov-19-21",
                                    "created_at_rawDateFormat": "2021-11-19T07:05:25.571Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 412317792,
                                "gitlabId": 412317792,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729488,
                                    "isTestReportAvailable": false,
                                    "duration": 168,
                                    "duration_inMinutes": 2.8,
                                    "created_at": "Nov-19-21",
                                    "created_at_rawDateFormat": "2021-11-19T07:05:25.828Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 408557085,
                                "gitlabId": 408557085,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729487,
                                    "isTestReportAvailable": false,
                                    "duration": 245,
                                    "duration_inMinutes": 4.08,
                                    "created_at": "Nov-14-21",
                                    "created_at_rawDateFormat": "2021-11-14T07:05:25.826Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 407122663,
                                "gitlabId": 407122663,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729489,
                                    "isTestReportAvailable": false,
                                    "duration": 152,
                                    "duration_inMinutes": 2.53,
                                    "created_at": "Nov-11-21",
                                    "created_at_rawDateFormat": "2021-11-11T07:05:25.887Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 405271420,
                                "gitlabId": 405271420,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729490,
                                    "isTestReportAvailable": false,
                                    "duration": 283,
                                    "duration_inMinutes": 4.72,
                                    "created_at": "Nov-09-21",
                                    "created_at_rawDateFormat": "2021-11-09T07:05:25.952Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 395647718,
                                "gitlabId": 395647718,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729491,
                                    "isTestReportAvailable": false,
                                    "duration": 181,
                                    "duration_inMinutes": 3.02,
                                    "created_at": "Oct-26-21",
                                    "created_at_rawDateFormat": "2021-10-26T07:05:26.127Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 367254277,
                                "gitlabId": 367254277,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729495,
                                    "isTestReportAvailable": false,
                                    "duration": 105,
                                    "duration_inMinutes": 1.75,
                                    "created_at": "Sep-08-21",
                                    "created_at_rawDateFormat": "2021-09-08T07:05:26.315Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 367253786,
                                "gitlabId": 367253786,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729504,
                                    "isTestReportAvailable": false,
                                    "duration": 231,
                                    "duration_inMinutes": 3.85,
                                    "created_at": "Sep-08-21",
                                    "created_at_rawDateFormat": "2021-09-08T07:05:27.095Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 367252063,
                                "gitlabId": 367252063,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729492,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Sep-08-21",
                                    "created_at_rawDateFormat": "2021-09-08T07:05:26.185Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 365973404,
                                "gitlabId": 365973404,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729494,
                                    "isTestReportAvailable": false,
                                    "duration": 301,
                                    "duration_inMinutes": 5.02,
                                    "created_at": "Sep-06-21",
                                    "created_at_rawDateFormat": "2021-09-06T07:05:26.202Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 360047658,
                                "gitlabId": 360047658,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729501,
                                    "isTestReportAvailable": false,
                                    "duration": 476,
                                    "duration_inMinutes": 7.93,
                                    "created_at": "Aug-26-21",
                                    "created_at_rawDateFormat": "2021-08-26T07:05:26.828Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 359834346,
                                "gitlabId": 359834346,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729496,
                                    "isTestReportAvailable": false,
                                    "duration": 257,
                                    "duration_inMinutes": 4.28,
                                    "created_at": "Aug-26-21",
                                    "created_at_rawDateFormat": "2021-08-26T07:05:26.449Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 325929862,
                                "gitlabId": 325929862,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729497,
                                    "isTestReportAvailable": false,
                                    "duration": 289,
                                    "duration_inMinutes": 4.82,
                                    "created_at": "Jun-23-21",
                                    "created_at_rawDateFormat": "2021-06-23T07:05:26.472Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 318548405,
                                "gitlabId": 318548405,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729498,
                                    "isTestReportAvailable": false,
                                    "duration": 1101,
                                    "duration_inMinutes": 18.35,
                                    "created_at": "Jun-10-21",
                                    "created_at_rawDateFormat": "2021-06-10T07:05:26.604Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 318544062,
                                "gitlabId": 318544062,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729500,
                                    "isTestReportAvailable": false,
                                    "duration": 468,
                                    "duration_inMinutes": 7.8,
                                    "created_at": "Jun-10-21",
                                    "created_at_rawDateFormat": "2021-06-10T07:05:26.758Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 318238900,
                                "gitlabId": 318238900,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729499,
                                    "isTestReportAvailable": false,
                                    "duration": 305,
                                    "duration_inMinutes": 5.08,
                                    "created_at": "Jun-10-21",
                                    "created_at_rawDateFormat": "2021-06-10T07:05:26.699Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317919536,
                                "gitlabId": 317919536,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729551,
                                    "isTestReportAvailable": false,
                                    "duration": 363,
                                    "duration_inMinutes": 6.05,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:30.666Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317846213,
                                "gitlabId": 317846213,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729502,
                                    "isTestReportAvailable": false,
                                    "duration": 1408,
                                    "duration_inMinutes": 23.47,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:26.876Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317824154,
                                "gitlabId": 317824154,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729506,
                                    "isTestReportAvailable": false,
                                    "duration": 931,
                                    "duration_inMinutes": 15.52,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:27.145Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317689503,
                                "gitlabId": 317689503,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729503,
                                    "isTestReportAvailable": false,
                                    "duration": 1198,
                                    "duration_inMinutes": 19.97,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:27.021Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317680351,
                                "gitlabId": 317680351,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729507,
                                    "isTestReportAvailable": false,
                                    "duration": 307,
                                    "duration_inMinutes": 5.12,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:27.248Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317662112,
                                "gitlabId": 317662112,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729505,
                                    "isTestReportAvailable": false,
                                    "duration": 743,
                                    "duration_inMinutes": 12.38,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:27.138Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317641864,
                                "gitlabId": 317641864,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729508,
                                    "isTestReportAvailable": false,
                                    "duration": 1640,
                                    "duration_inMinutes": 27.33,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:27.299Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317641253,
                                "gitlabId": 317641253,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729518,
                                    "isTestReportAvailable": false,
                                    "duration": 1385,
                                    "duration_inMinutes": 23.08,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:28.172Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317637307,
                                "gitlabId": 317637307,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729510,
                                    "isTestReportAvailable": false,
                                    "duration": 1238,
                                    "duration_inMinutes": 20.63,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:27.550Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317619057,
                                "gitlabId": 317619057,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729509,
                                    "isTestReportAvailable": false,
                                    "duration": 764,
                                    "duration_inMinutes": 12.73,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:27.413Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317610574,
                                "gitlabId": 317610574,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729511,
                                    "isTestReportAvailable": false,
                                    "duration": 873,
                                    "duration_inMinutes": 14.55,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:27.681Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317590852,
                                "gitlabId": 317590852,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729512,
                                    "isTestReportAvailable": false,
                                    "duration": 698,
                                    "duration_inMinutes": 11.63,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:27.744Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317572959,
                                "gitlabId": 317572959,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729514,
                                    "isTestReportAvailable": false,
                                    "duration": 695,
                                    "duration_inMinutes": 11.58,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:27.922Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317535093,
                                "gitlabId": 317535093,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729513,
                                    "isTestReportAvailable": false,
                                    "duration": 714,
                                    "duration_inMinutes": 11.9,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:27.831Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317518860,
                                "gitlabId": 317518860,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729515,
                                    "isTestReportAvailable": false,
                                    "duration": 1062,
                                    "duration_inMinutes": 17.7,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:27.958Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317497596,
                                "gitlabId": 317497596,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729516,
                                    "isTestReportAvailable": false,
                                    "duration": 748,
                                    "duration_inMinutes": 12.47,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:28.025Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317490091,
                                "gitlabId": 317490091,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729517,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:28.100Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317473498,
                                "gitlabId": 317473498,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729519,
                                    "isTestReportAvailable": false,
                                    "duration": 737,
                                    "duration_inMinutes": 12.28,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:28.205Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317460005,
                                "gitlabId": 317460005,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729520,
                                    "isTestReportAvailable": false,
                                    "duration": 768,
                                    "duration_inMinutes": 12.8,
                                    "created_at": "Jun-09-21",
                                    "created_at_rawDateFormat": "2021-06-09T07:05:28.218Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317102275,
                                "gitlabId": 317102275,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729521,
                                    "isTestReportAvailable": false,
                                    "duration": 593,
                                    "duration_inMinutes": 9.88,
                                    "created_at": "Jun-08-21",
                                    "created_at_rawDateFormat": "2021-06-08T07:05:28.279Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317079279,
                                "gitlabId": 317079279,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729522,
                                    "isTestReportAvailable": false,
                                    "duration": 388,
                                    "duration_inMinutes": 6.47,
                                    "created_at": "Jun-08-21",
                                    "created_at_rawDateFormat": "2021-06-08T07:05:28.349Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317040076,
                                "gitlabId": 317040076,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729523,
                                    "isTestReportAvailable": false,
                                    "duration": 658,
                                    "duration_inMinutes": 10.97,
                                    "created_at": "Jun-08-21",
                                    "created_at_rawDateFormat": "2021-06-08T07:05:28.448Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317021177,
                                "gitlabId": 317021177,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729524,
                                    "isTestReportAvailable": false,
                                    "duration": 380,
                                    "duration_inMinutes": 6.33,
                                    "created_at": "Jun-08-21",
                                    "created_at_rawDateFormat": "2021-06-08T07:05:28.450Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317000110,
                                "gitlabId": 317000110,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729525,
                                    "isTestReportAvailable": false,
                                    "duration": 611,
                                    "duration_inMinutes": 10.18,
                                    "created_at": "Jun-08-21",
                                    "created_at_rawDateFormat": "2021-06-08T07:05:28.489Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 316988204,
                                "gitlabId": 316988204,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729526,
                                    "isTestReportAvailable": false,
                                    "duration": 475,
                                    "duration_inMinutes": 7.92,
                                    "created_at": "Jun-08-21",
                                    "created_at_rawDateFormat": "2021-06-08T07:05:28.578Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 312277777,
                                "gitlabId": 312277777,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729527,
                                    "isTestReportAvailable": false,
                                    "duration": 470,
                                    "duration_inMinutes": 7.83,
                                    "created_at": "May-31-21",
                                    "created_at_rawDateFormat": "2021-05-31T07:05:28.728Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 258703111,
                                "gitlabId": 258703111,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729528,
                                    "isTestReportAvailable": false,
                                    "duration": 1264,
                                    "duration_inMinutes": 21.07,
                                    "created_at": "Feb-19-21",
                                    "created_at_rawDateFormat": "2021-02-19T07:05:28.749Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 258624532,
                                "gitlabId": 258624532,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729539,
                                    "isTestReportAvailable": false,
                                    "duration": 413,
                                    "duration_inMinutes": 6.88,
                                    "created_at": "Feb-19-21",
                                    "created_at_rawDateFormat": "2021-02-19T07:05:29.810Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 251878171,
                                "gitlabId": 251878171,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729529,
                                    "isTestReportAvailable": false,
                                    "duration": 218,
                                    "duration_inMinutes": 3.63,
                                    "created_at": "Feb-05-21",
                                    "created_at_rawDateFormat": "2021-02-05T07:05:28.803Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 251348213,
                                "gitlabId": 251348213,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729537,
                                    "isTestReportAvailable": false,
                                    "duration": 210,
                                    "duration_inMinutes": 3.5,
                                    "created_at": "Feb-04-21",
                                    "created_at_rawDateFormat": "2021-02-04T07:05:29.714Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 251341843,
                                "gitlabId": 251341843,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729530,
                                    "isTestReportAvailable": false,
                                    "duration": 262,
                                    "duration_inMinutes": 4.37,
                                    "created_at": "Feb-04-21",
                                    "created_at_rawDateFormat": "2021-02-04T07:05:29.118Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 240620295,
                                "gitlabId": 240620295,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729531,
                                    "isTestReportAvailable": false,
                                    "duration": 242,
                                    "duration_inMinutes": 4.03,
                                    "created_at": "Jan-12-21",
                                    "created_at_rawDateFormat": "2021-01-12T07:05:29.199Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 240613922,
                                "gitlabId": 240613922,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729532,
                                    "isTestReportAvailable": false,
                                    "duration": 324,
                                    "duration_inMinutes": 5.4,
                                    "created_at": "Jan-12-21",
                                    "created_at_rawDateFormat": "2021-01-12T07:05:29.276Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 240003640,
                                "gitlabId": 240003640,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729533,
                                    "isTestReportAvailable": false,
                                    "duration": 322,
                                    "duration_inMinutes": 5.37,
                                    "created_at": "Jan-11-21",
                                    "created_at_rawDateFormat": "2021-01-11T07:05:29.373Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 239945319,
                                "gitlabId": 239945319,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729534,
                                    "isTestReportAvailable": false,
                                    "duration": 822,
                                    "duration_inMinutes": 13.7,
                                    "created_at": "Jan-11-21",
                                    "created_at_rawDateFormat": "2021-01-11T07:05:29.449Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 239940211,
                                "gitlabId": 239940211,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729535,
                                    "isTestReportAvailable": false,
                                    "duration": 286,
                                    "duration_inMinutes": 4.77,
                                    "created_at": "Jan-11-21",
                                    "created_at_rawDateFormat": "2021-01-11T07:05:29.565Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 239874628,
                                "gitlabId": 239874628,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729536,
                                    "isTestReportAvailable": false,
                                    "duration": 221,
                                    "duration_inMinutes": 3.68,
                                    "created_at": "Jan-11-21",
                                    "created_at_rawDateFormat": "2021-01-11T07:05:29.660Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 239868906,
                                "gitlabId": 239868906,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729540,
                                    "isTestReportAvailable": false,
                                    "duration": 370,
                                    "duration_inMinutes": 6.17,
                                    "created_at": "Jan-11-21",
                                    "created_at_rawDateFormat": "2021-01-11T07:05:29.920Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 238953202,
                                "gitlabId": 238953202,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729847,
                                    "isTestReportAvailable": false,
                                    "duration": 284,
                                    "duration_inMinutes": 4.73,
                                    "created_at": "Jan-08-21",
                                    "created_at_rawDateFormat": "2021-01-08T07:05:50.365Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 237563561,
                                "gitlabId": 237563561,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729849,
                                    "isTestReportAvailable": false,
                                    "duration": 552,
                                    "duration_inMinutes": 9.2,
                                    "created_at": "Jan-05-21",
                                    "created_at_rawDateFormat": "2021-01-05T07:05:50.517Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 236994147,
                                "gitlabId": 236994147,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729850,
                                    "isTestReportAvailable": false,
                                    "duration": 337,
                                    "duration_inMinutes": 5.62,
                                    "created_at": "Jan-04-21",
                                    "created_at_rawDateFormat": "2021-01-04T07:05:50.588Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 230207100,
                                "gitlabId": 230207100,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729851,
                                    "isTestReportAvailable": false,
                                    "duration": 355,
                                    "duration_inMinutes": 5.92,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:05:50.589Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 224804911,
                                "gitlabId": 224804911,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729852,
                                    "isTestReportAvailable": false,
                                    "duration": 281,
                                    "duration_inMinutes": 4.68,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:50.592Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 224794118,
                                "gitlabId": 224794118,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729853,
                                    "isTestReportAvailable": false,
                                    "duration": 330,
                                    "duration_inMinutes": 5.5,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:50.795Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 224792247,
                                "gitlabId": 224792247,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729854,
                                    "isTestReportAvailable": false,
                                    "duration": 236,
                                    "duration_inMinutes": 3.93,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:51.145Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 224778921,
                                "gitlabId": 224778921,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729857,
                                    "isTestReportAvailable": false,
                                    "duration": 276,
                                    "duration_inMinutes": 4.6,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:51.245Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 224775566,
                                "gitlabId": 224775566,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729855,
                                    "isTestReportAvailable": false,
                                    "duration": 247,
                                    "duration_inMinutes": 4.12,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:51.205Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 224772015,
                                "gitlabId": 224772015,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729856,
                                    "isTestReportAvailable": false,
                                    "duration": 226,
                                    "duration_inMinutes": 3.77,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:51.217Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 224764180,
                                "gitlabId": 224764180,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729858,
                                    "isTestReportAvailable": false,
                                    "duration": 230,
                                    "duration_inMinutes": 3.83,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:51.272Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 224756822,
                                "gitlabId": 224756822,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729859,
                                    "isTestReportAvailable": false,
                                    "duration": 397,
                                    "duration_inMinutes": 6.62,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:51.302Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 208259486,
                                "gitlabId": 208259486,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729860,
                                    "isTestReportAvailable": false,
                                    "duration": 385,
                                    "duration_inMinutes": 6.42,
                                    "created_at": "Oct-27-20",
                                    "created_at_rawDateFormat": "2020-10-27T07:05:51.436Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 208259237,
                                "gitlabId": 208259237,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729863,
                                    "isTestReportAvailable": false,
                                    "duration": 319,
                                    "duration_inMinutes": 5.32,
                                    "created_at": "Oct-27-20",
                                    "created_at_rawDateFormat": "2020-10-27T07:05:51.536Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 207736120,
                                "gitlabId": 207736120,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729861,
                                    "isTestReportAvailable": false,
                                    "duration": 415,
                                    "duration_inMinutes": 6.92,
                                    "created_at": "Oct-26-20",
                                    "created_at_rawDateFormat": "2020-10-26T07:05:51.478Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 206900142,
                                "gitlabId": 206900142,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729864,
                                    "isTestReportAvailable": false,
                                    "duration": 275,
                                    "duration_inMinutes": 4.58,
                                    "created_at": "Oct-23-20",
                                    "created_at_rawDateFormat": "2020-10-23T07:05:51.538Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 206898389,
                                "gitlabId": 206898389,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729862,
                                    "isTestReportAvailable": false,
                                    "duration": 217,
                                    "duration_inMinutes": 3.62,
                                    "created_at": "Oct-23-20",
                                    "created_at_rawDateFormat": "2020-10-23T07:05:51.533Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 206838827,
                                "gitlabId": 206838827,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729865,
                                    "isTestReportAvailable": false,
                                    "duration": 58,
                                    "duration_inMinutes": 0.97,
                                    "created_at": "Oct-23-20",
                                    "created_at_rawDateFormat": "2020-10-23T07:05:51.660Z",
                                    "testCoverage": null
                                }
                            }
                        ],
                        "groupInfo": {
                            "id": 29708,
                            "gitlabId": 6265245,
                            "name": "Stark-Ryan"
                        }
                    },
                    {
                        "id": 21624853,
                        "gitlabId": 21624853,
                        "name": "Stark-Ryan-3",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Stark-Ryan.git",
                        "stats": {
                            "id": 29793,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "406428057",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29759,
                            "gitlabId": 6265245,
                            "name": "Stark-Ryan"
                        }
                    },
                    {
                        "id": 21654681,
                        "gitlabId": 21654681,
                        "name": "Stark-Ryan-4",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Stark-Ryan.git",
                        "stats": {
                            "id": 29785,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "960956989",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29793,
                            "gitlabId": 6265245,
                            "name": "Stark-Ryan"
                        }
                    },
                    {
                        "id": 14613645,
                        "gitlabId": 14613645,
                        "name": "Stark-Ryan-4",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Stark-Ryan.git",
                        "stats": {
                            "id": 29786,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "1018293125",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29788,
                            "gitlabId": 6265245,
                            "name": "Stark-Ryan"
                        }
                    },
                    {
                        "id": 25018870,
                        "gitlabId": 25018870,
                        "name": "Stark-Ryan-6",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Stark-Ryan.git",
                        "stats": {
                            "id": 29784,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "27242004",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29785,
                            "gitlabId": 6265245,
                            "name": "Stark-Ryan"
                        }
                    },
                    {
                        "id": 17654207,
                        "gitlabId": 17654207,
                        "name": "Stark-Ryan-8",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Stark-Ryan.git",
                        "stats": {
                            "id": 29782,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "0",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29782,
                            "gitlabId": 6265245,
                            "name": "Stark-Ryan"
                        }
                    },
                    {
                        "id": 27515283,
                        "gitlabId": 27515283,
                        "name": "Stark-Ryan",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/webrcp.git",
                        "stats": {
                            "id": 29761,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "828375",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29777,
                            "gitlabId": 6265245,
                            "name": "Stark-Ryan"
                        }
                    },
                    {
                        "id": 17559731,
                        "gitlabId": 17559731,
                        "name": "Stark-Ryan23",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Stark-Ryan.git",
                        "stats": {
                            "id": 29767,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "167772",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29771,
                            "gitlabId": 6265245,
                            "name": "Stark-Ryan"
                        }
                    },
                    {
                        "id": 17654414,
                        "gitlabId": 17654414,
                        "name": "Stark-Ryan-65",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Stark-Ryan-db.git",
                        "stats": {
                            "id": 29750,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "5819596",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29757,
                            "gitlabId": 6265245,
                            "name": "Stark-Ryan"
                        }
                    },
                    {
                        "id": 17391314,
                        "gitlabId": 17391314,
                        "name": "Stark-Ryan-prototyp",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Stark-Ryan-prototyp.git",
                        "stats": {
                            "id": 29724,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "1667235",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29732,
                            "gitlabId": 6265245,
                            "name": "Stark-Ryan"
                        }
                    },
                    {
                        "id": 14613613,
                        "gitlabId": 14613613,
                        "name": "Stark-Ryan-26",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Stark-Ryan.git",
                        "stats": {
                            "id": 29731,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "29318184",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29744,
                            "gitlabId": 6265245,
                            "name": "Stark-Ryan"
                        }
                    }
                ],
                "subGroups": [],
                "stats": {
                    "id": 6722,
                    "isThereSubgroups": false,
                    "numberOfProjects": 13,
                    "testCoverageOfAllProjects": null,
                    "numberOfPipelines": 204,
                    "numberOfTestReports": 0
                }
            },
            {
                "id": 8198206,
                "tempData": false,
                "gitlabId": 8198206,
                "name": "Erdman-Schneider",
                "projects": [
                    {
                        "id": 15345678,
                        "gitlabId": 15345678,
                        "name": "Erdman-Schneider",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Erdman-Schneider.git",
                        "stats": {
                            "id": 29702,
                            "status": "success",
                            "numberOfPipelines": 39,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": true,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 297,
                            "averageDurationOfPipelines_inMinutes": 4.95,
                            "testCoverage": 91.51,
                            "numberOfSuccessfulPipelines": 23,
                            "numberOfFailedPipelines": 16,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": 58.97,
                            "totalRepoSize": "1593835",
                            "artifactsSize": "667427"
                        },
                        "pipelines": [
                            {
                                "id": 131731838,
                                "gitlabId": 131731838,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729874,
                                    "isTestReportAvailable": false,
                                    "duration": 465,
                                    "duration_inMinutes": 7.75,
                                    "created_at": "Apr-01-20",
                                    "created_at_rawDateFormat": "2020-04-01T07:05:52.171Z",
                                    "testCoverage": 91.51
                                }
                            },
                            {
                                "id": 131724910,
                                "gitlabId": 131724910,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729869,
                                    "isTestReportAvailable": false,
                                    "duration": 480,
                                    "duration_inMinutes": 8,
                                    "created_at": "Apr-01-20",
                                    "created_at_rawDateFormat": "2020-04-01T07:05:51.825Z",
                                    "testCoverage": 91.51
                                }
                            },
                            {
                                "id": 131724659,
                                "gitlabId": 131724659,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729867,
                                    "isTestReportAvailable": false,
                                    "duration": 364,
                                    "duration_inMinutes": 6.07,
                                    "created_at": "Apr-01-20",
                                    "created_at_rawDateFormat": "2020-04-01T07:05:51.812Z",
                                    "testCoverage": 91.51
                                }
                            },
                            {
                                "id": 131708901,
                                "gitlabId": 131708901,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729868,
                                    "isTestReportAvailable": false,
                                    "duration": 488,
                                    "duration_inMinutes": 8.13,
                                    "created_at": "Apr-01-20",
                                    "created_at_rawDateFormat": "2020-04-01T07:05:51.823Z",
                                    "testCoverage": 91.51
                                }
                            },
                            {
                                "id": 131701756,
                                "gitlabId": 131701756,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729866,
                                    "isTestReportAvailable": false,
                                    "duration": 343,
                                    "duration_inMinutes": 5.72,
                                    "created_at": "Apr-01-20",
                                    "created_at_rawDateFormat": "2020-04-01T07:05:51.796Z",
                                    "testCoverage": 41.28
                                }
                            },
                            {
                                "id": 131505327,
                                "gitlabId": 131505327,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729870,
                                    "isTestReportAvailable": false,
                                    "duration": 246,
                                    "duration_inMinutes": 4.1,
                                    "created_at": "Mar-31-20",
                                    "created_at_rawDateFormat": "2020-03-31T07:05:51.930Z",
                                    "testCoverage": 41.28
                                }
                            },
                            {
                                "id": 131469749,
                                "gitlabId": 131469749,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729875,
                                    "isTestReportAvailable": false,
                                    "duration": 325,
                                    "duration_inMinutes": 5.42,
                                    "created_at": "Mar-31-20",
                                    "created_at_rawDateFormat": "2020-03-31T07:05:52.324Z",
                                    "testCoverage": 91.51
                                }
                            },
                            {
                                "id": 131466988,
                                "gitlabId": 131466988,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729871,
                                    "isTestReportAvailable": false,
                                    "duration": 339,
                                    "duration_inMinutes": 5.65,
                                    "created_at": "Mar-31-20",
                                    "created_at_rawDateFormat": "2020-03-31T07:05:52.063Z",
                                    "testCoverage": 91.51
                                }
                            },
                            {
                                "id": 131448314,
                                "gitlabId": 131448314,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729873,
                                    "isTestReportAvailable": false,
                                    "duration": 332,
                                    "duration_inMinutes": 5.53,
                                    "created_at": "Mar-31-20",
                                    "created_at_rawDateFormat": "2020-03-31T07:05:52.116Z",
                                    "testCoverage": 91.74
                                }
                            },
                            {
                                "id": 131436377,
                                "gitlabId": 131436377,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729872,
                                    "isTestReportAvailable": false,
                                    "duration": 342,
                                    "duration_inMinutes": 5.7,
                                    "created_at": "Mar-31-20",
                                    "created_at_rawDateFormat": "2020-03-31T07:05:52.098Z",
                                    "testCoverage": 91.41
                                }
                            },
                            {
                                "id": 131380505,
                                "gitlabId": 131380505,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729878,
                                    "isTestReportAvailable": false,
                                    "duration": 348,
                                    "duration_inMinutes": 5.8,
                                    "created_at": "Mar-31-20",
                                    "created_at_rawDateFormat": "2020-03-31T07:05:52.428Z",
                                    "testCoverage": 92.62
                                }
                            },
                            {
                                "id": 131339960,
                                "gitlabId": 131339960,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729880,
                                    "isTestReportAvailable": false,
                                    "duration": 365,
                                    "duration_inMinutes": 6.08,
                                    "created_at": "Mar-31-20",
                                    "created_at_rawDateFormat": "2020-03-31T07:05:52.458Z",
                                    "testCoverage": 91.8
                                }
                            },
                            {
                                "id": 131320932,
                                "gitlabId": 131320932,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729876,
                                    "isTestReportAvailable": false,
                                    "duration": 417,
                                    "duration_inMinutes": 6.95,
                                    "created_at": "Mar-31-20",
                                    "created_at_rawDateFormat": "2020-03-31T07:05:52.373Z",
                                    "testCoverage": 91.8
                                }
                            },
                            {
                                "id": 131088396,
                                "gitlabId": 131088396,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729877,
                                    "isTestReportAvailable": false,
                                    "duration": 344,
                                    "duration_inMinutes": 5.73,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:52.395Z",
                                    "testCoverage": 91.82
                                }
                            },
                            {
                                "id": 131084143,
                                "gitlabId": 131084143,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729879,
                                    "isTestReportAvailable": false,
                                    "duration": 324,
                                    "duration_inMinutes": 5.4,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:52.436Z",
                                    "testCoverage": 91.82
                                }
                            },
                            {
                                "id": 131076153,
                                "gitlabId": 131076153,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729881,
                                    "isTestReportAvailable": false,
                                    "duration": 526,
                                    "duration_inMinutes": 8.77,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:52.617Z",
                                    "testCoverage": 91.82
                                }
                            },
                            {
                                "id": 131065625,
                                "gitlabId": 131065625,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729882,
                                    "isTestReportAvailable": false,
                                    "duration": 323,
                                    "duration_inMinutes": 5.38,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:52.692Z",
                                    "testCoverage": 91.82
                                }
                            },
                            {
                                "id": 131061026,
                                "gitlabId": 131061026,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729886,
                                    "isTestReportAvailable": false,
                                    "duration": 357,
                                    "duration_inMinutes": 5.95,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:52.736Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 131057830,
                                "gitlabId": 131057830,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729884,
                                    "isTestReportAvailable": false,
                                    "duration": 268,
                                    "duration_inMinutes": 4.47,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:52.731Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 131049277,
                                "gitlabId": 131049277,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729883,
                                    "isTestReportAvailable": false,
                                    "duration": 258,
                                    "duration_inMinutes": 4.3,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:52.702Z",
                                    "testCoverage": 83.64
                                }
                            },
                            {
                                "id": 131046304,
                                "gitlabId": 131046304,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729885,
                                    "isTestReportAvailable": false,
                                    "duration": 334,
                                    "duration_inMinutes": 5.57,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:52.735Z",
                                    "testCoverage": 83.64
                                }
                            },
                            {
                                "id": 131044505,
                                "gitlabId": 131044505,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729887,
                                    "isTestReportAvailable": false,
                                    "duration": 268,
                                    "duration_inMinutes": 4.47,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:52.864Z",
                                    "testCoverage": 83.64
                                }
                            },
                            {
                                "id": 131043552,
                                "gitlabId": 131043552,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729888,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:52.936Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 131043547,
                                "gitlabId": 131043547,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729890,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:53.029Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 131037105,
                                "gitlabId": 131037105,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729892,
                                    "isTestReportAvailable": false,
                                    "duration": 537,
                                    "duration_inMinutes": 8.95,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:53.159Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 131029385,
                                "gitlabId": 131029385,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729889,
                                    "isTestReportAvailable": false,
                                    "duration": 294,
                                    "duration_inMinutes": 4.9,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:53.005Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 130964941,
                                "gitlabId": 130964941,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729897,
                                    "isTestReportAvailable": false,
                                    "duration": 564,
                                    "duration_inMinutes": 9.4,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:53.567Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 130958220,
                                "gitlabId": 130958220,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729891,
                                    "isTestReportAvailable": false,
                                    "duration": 594,
                                    "duration_inMinutes": 9.9,
                                    "created_at": "Mar-30-20",
                                    "created_at_rawDateFormat": "2020-03-30T07:05:53.114Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 130305165,
                                "gitlabId": 130305165,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729893,
                                    "isTestReportAvailable": false,
                                    "duration": 439,
                                    "duration_inMinutes": 7.32,
                                    "created_at": "Mar-27-20",
                                    "created_at_rawDateFormat": "2020-03-27T07:05:53.198Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 130303664,
                                "gitlabId": 130303664,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729894,
                                    "isTestReportAvailable": false,
                                    "duration": 21,
                                    "duration_inMinutes": 0.35,
                                    "created_at": "Mar-27-20",
                                    "created_at_rawDateFormat": "2020-03-27T07:05:53.279Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 130302552,
                                "gitlabId": 130302552,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729900,
                                    "isTestReportAvailable": false,
                                    "duration": 136,
                                    "duration_inMinutes": 2.27,
                                    "created_at": "Mar-27-20",
                                    "created_at_rawDateFormat": "2020-03-27T07:05:53.765Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 130301676,
                                "gitlabId": 130301676,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729895,
                                    "isTestReportAvailable": false,
                                    "duration": 130,
                                    "duration_inMinutes": 2.17,
                                    "created_at": "Mar-27-20",
                                    "created_at_rawDateFormat": "2020-03-27T07:05:53.504Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 130285452,
                                "gitlabId": 130285452,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729899,
                                    "isTestReportAvailable": false,
                                    "duration": 121,
                                    "duration_inMinutes": 2.02,
                                    "created_at": "Mar-27-20",
                                    "created_at_rawDateFormat": "2020-03-27T07:05:53.676Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 130283179,
                                "gitlabId": 130283179,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729898,
                                    "isTestReportAvailable": false,
                                    "duration": 146,
                                    "duration_inMinutes": 2.43,
                                    "created_at": "Mar-27-20",
                                    "created_at_rawDateFormat": "2020-03-27T07:05:53.617Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 130282110,
                                "gitlabId": 130282110,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729896,
                                    "isTestReportAvailable": false,
                                    "duration": 144,
                                    "duration_inMinutes": 2.4,
                                    "created_at": "Mar-27-20",
                                    "created_at_rawDateFormat": "2020-03-27T07:05:53.531Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 130279150,
                                "gitlabId": 130279150,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729901,
                                    "isTestReportAvailable": false,
                                    "duration": 145,
                                    "duration_inMinutes": 2.42,
                                    "created_at": "Mar-27-20",
                                    "created_at_rawDateFormat": "2020-03-27T07:05:53.782Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 129944660,
                                "gitlabId": 129944660,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729902,
                                    "isTestReportAvailable": false,
                                    "duration": 156,
                                    "duration_inMinutes": 2.6,
                                    "created_at": "Mar-26-20",
                                    "created_at_rawDateFormat": "2020-03-26T07:05:53.793Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 129942921,
                                "gitlabId": 129942921,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729903,
                                    "isTestReportAvailable": false,
                                    "duration": 142,
                                    "duration_inMinutes": 2.37,
                                    "created_at": "Mar-26-20",
                                    "created_at_rawDateFormat": "2020-03-26T07:05:53.819Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 129938225,
                                "gitlabId": 129938225,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729904,
                                    "isTestReportAvailable": false,
                                    "duration": 142,
                                    "duration_inMinutes": 2.37,
                                    "created_at": "Mar-26-20",
                                    "created_at_rawDateFormat": "2020-03-26T07:05:53.879Z",
                                    "testCoverage": null
                                }
                            }
                        ],
                        "groupInfo": {
                            "id": 29709,
                            "gitlabId": 8198206,
                            "name": "Erdman-Schneider"
                        }
                    }
                ],
                "subGroups": [],
                "stats": {
                    "id": 6724,
                    "isThereSubgroups": false,
                    "numberOfProjects": 1,
                    "testCoverageOfAllProjects": 91.51,
                    "numberOfPipelines": 39,
                    "numberOfTestReports": 0
                }
            },
            {
                "id": 8198237,
                "tempData": false,
                "gitlabId": 8198237,
                "name": "Hoeger-Larkin",
                "projects": [
                    {
                        "id": 11617286,
                        "gitlabId": 11617286,
                        "name": "Hoeger-Larkin",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Hoeger-Larkin.git",
                        "stats": {
                            "id": 29788,
                            "status": "success",
                            "numberOfPipelines": 97,
                            "areTestsAvailable": true,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 59,
                            "averageDurationOfPipelines": 1181,
                            "averageDurationOfPipelines_inMinutes": 19.68,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 71,
                            "numberOfFailedPipelines": 11,
                            "numberOfCanceledPipelines": 15,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": 73.2,
                            "totalRepoSize": "361643376",
                            "artifactsSize": "31226370599"
                        },
                        "pipelines": [
                            {
                                "id": 488751708,
                                "gitlabId": 488751708,
                                "status": "success",
                                "testReport": {
                                    "id": 46760,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 39,
                                    "success_count": 169,
                                    "total_count": 208,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54099,
                                            "total_time": -0.26,
                                            "total_count": 208,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 39,
                                            "success_count": 169,
                                            "test_cases": [
                                                {
                                                    "id": 3555238,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554882,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554888,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554892,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554898,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554901,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554911,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554921,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554930,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554940,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554950,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554960,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554970,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554980,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554990,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555000,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555009,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555019,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555029,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555038,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555044,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555048,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555054,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555063,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555072,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555082,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555091,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555097,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555102,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555107,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555112,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555117,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555122,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555127,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555132,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555137,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555142,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555147,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555152,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555157,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555162,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555167,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555172,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555177,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555182,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555187,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555192,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555197,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555202,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555207,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555212,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555217,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555222,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555226,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555233,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555242,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555248,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555253,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555258,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555264,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555268,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555274,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555278,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555284,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555290,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555294,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555300,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555304,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555310,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555314,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555320,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555324,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555330,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555335,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555340,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555346,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555353,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555359,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555363,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555369,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555373,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555379,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555384,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555389,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555395,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555401,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555407,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555411,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555417,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555421,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555427,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555431,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555437,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555441,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555447,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555451,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555457,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555461,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555467,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555471,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555477,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555481,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555487,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555491,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555497,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555501,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555507,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555511,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555517,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555521,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555527,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555531,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555537,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555543,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555553,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555563,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555568,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555574,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555577,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555583,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555587,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555593,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555596,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555602,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555606,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555612,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555616,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555622,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555626,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555632,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555635,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555641,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555645,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555651,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555654,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "a QrCodeSpec should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555660,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555664,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555670,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555673,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555679,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555683,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555689,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555692,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555698,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555702,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555708,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555711,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555717,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555721,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555727,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555731,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555737,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555741,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555747,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555751,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555757,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555761,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555767,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555771,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555777,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555781,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555787,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555791,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555797,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555801,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555807,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555811,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555817,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555821,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555827,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555831,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555836,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555840,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555846,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555850,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555856,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555859,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555865,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555869,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555875,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555879,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555883,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555889,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555893,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555899,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555902,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555908,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdf with QR code and invoiceNo",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555912,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdf with QR code",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555918,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555922,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555928,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555932,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555938,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555941,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555947,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555951,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555957,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555961,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555967,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555971,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555977,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555981,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555987,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555991,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555997,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556001,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556006,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556011,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729910,
                                    "isTestReportAvailable": true,
                                    "duration": 875,
                                    "duration_inMinutes": 14.58,
                                    "created_at": "Mar-10-22",
                                    "created_at_rawDateFormat": "2022-03-10T07:05:54.168Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 488743752,
                                "gitlabId": 488743752,
                                "status": "success",
                                "testReport": {
                                    "id": 46762,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 39,
                                    "success_count": 169,
                                    "total_count": 208,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54098,
                                            "total_time": -0.26,
                                            "total_count": 208,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 39,
                                            "success_count": 169,
                                            "test_cases": [
                                                {
                                                    "id": 3555578,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556129,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556138,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556148,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555824,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555819,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555814,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555809,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555804,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555799,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555794,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555789,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555784,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555779,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555774,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555769,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555764,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555759,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555754,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555749,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555744,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555739,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555734,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555729,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555724,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555719,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555715,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555709,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555704,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "a QrCodeSpec should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555699,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555693,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555687,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555681,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555677,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555671,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555666,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554948,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554954,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554958,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554964,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554968,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554974,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554978,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554984,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554988,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554994,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554998,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555004,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555661,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555655,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555649,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555643,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555639,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555633,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555513,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555522,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555532,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555541,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555547,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555551,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555557,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555561,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555566,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555572,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556119,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555584,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555589,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555594,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555600,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555604,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555610,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555614,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555620,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555624,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555629,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556157,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556167,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556177,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556187,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556196,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556206,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556216,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556225,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556235,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556244,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556253,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556263,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555126,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555121,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555116,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555111,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555106,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555101,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555096,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555092,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555087,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555083,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555077,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555073,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556100,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556090,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556080,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556070,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdf with QR code",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556060,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdf with QR code and invoiceNo",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556051,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556041,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556031,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556022,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556012,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556002,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555992,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555982,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555972,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555962,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555952,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555943,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555933,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555923,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555913,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555904,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555894,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555884,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555876,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555870,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555866,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555860,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555853,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555847,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555841,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555837,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555829,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555251,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555257,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555261,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555270,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555276,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555286,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555295,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555305,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555315,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555325,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555334,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555344,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555354,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555364,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555374,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555383,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555393,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555403,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555413,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555423,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555433,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555443,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555453,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555463,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555473,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555483,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555493,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555503,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555067,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555062,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555057,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555052,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555047,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555042,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555037,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555033,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555027,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555023,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555017,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555014,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555008,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554877,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554881,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554887,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554891,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554897,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554900,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554910,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554920,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554928,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554934,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554938,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554944,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555131,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555136,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555141,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555146,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555151,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555156,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555161,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555166,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555171,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555176,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555181,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555186,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555191,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555196,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555201,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555206,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555211,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555216,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555221,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555225,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555231,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555239,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555245,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556110,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729905,
                                    "isTestReportAvailable": true,
                                    "duration": 1117,
                                    "duration_inMinutes": 18.62,
                                    "created_at": "Mar-10-22",
                                    "created_at_rawDateFormat": "2022-03-10T07:05:54.028Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 481658758,
                                "gitlabId": 481658758,
                                "status": "success",
                                "testReport": {
                                    "id": 46761,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 39,
                                    "success_count": 169,
                                    "total_count": 208,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54102,
                                            "total_time": -0.26,
                                            "total_count": 208,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 39,
                                            "success_count": 169,
                                            "test_cases": [
                                                {
                                                    "id": 3559052,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559042,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559036,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559032,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559026,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559022,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559016,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559012,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559006,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559002,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558996,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559853,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559863,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559873,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559883,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdf with QR code and invoiceNo",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559893,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdf with QR code",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559903,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559913,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559923,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558992,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559933,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559943,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559953,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559963,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559973,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559983,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559993,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560003,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560013,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560023,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560033,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560043,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560053,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560063,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560073,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560083,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560093,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559483,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559473,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559463,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559453,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559443,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559433,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559423,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558986,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558979,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558973,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558968,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558963,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558957,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558950,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558944,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558939,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559076,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559082,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559086,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559092,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559096,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559102,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559107,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559112,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559118,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559124,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559843,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559833,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559823,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559813,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559803,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559793,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559783,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559773,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559763,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559753,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559743,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559733,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559723,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559713,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559703,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559693,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559683,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559673,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559663,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559653,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559643,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559633,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559623,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559613,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558662,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558658,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558652,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558648,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558642,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558639,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558934,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558928,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558924,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558918,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558914,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558908,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558904,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558898,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558892,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558886,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558881,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558876,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558870,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558866,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558860,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558853,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558847,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558842,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558837,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558831,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558824,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558818,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558813,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558808,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558802,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559413,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559403,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559393,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559383,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559373,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559364,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "a QrCodeSpec should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559354,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559344,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559334,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559324,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559314,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559306,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559300,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559296,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559290,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559285,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559277,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559271,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559267,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559261,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559256,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559251,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559246,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559241,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559236,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559231,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559227,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559221,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559217,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558798,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558792,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558788,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558782,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558778,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558772,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558768,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558762,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558758,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558752,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559211,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559207,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559201,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559195,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559189,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559184,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559179,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559173,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559169,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559163,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559159,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559153,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559149,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559143,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559140,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559134,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559130,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559493,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559503,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559513,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559523,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559533,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559543,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559553,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559563,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559573,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559583,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559593,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559603,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558748,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558742,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558738,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558732,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558728,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558722,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558718,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558712,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558708,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558702,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558698,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558692,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558688,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558682,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558678,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558672,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558668,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559072,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559066,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559062,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559056,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559046,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729908,
                                    "isTestReportAvailable": true,
                                    "duration": 855,
                                    "duration_inMinutes": 14.25,
                                    "created_at": "Mar-01-22",
                                    "created_at_rawDateFormat": "2022-03-01T07:05:54.129Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 481642670,
                                "gitlabId": 481642670,
                                "status": "success",
                                "testReport": {
                                    "id": 46764,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 39,
                                    "success_count": 169,
                                    "total_count": 208,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54100,
                                            "total_time": -0.26,
                                            "total_count": 208,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 39,
                                            "success_count": 169,
                                            "test_cases": [
                                                {
                                                    "id": 3563058,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563098,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563093,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563088,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563083,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563078,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563073,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563068,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563063,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563053,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563048,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563043,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563038,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563033,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563028,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563023,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563018,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563013,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563008,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563003,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562998,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562993,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562988,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562983,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562978,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562973,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562968,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562963,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562958,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562953,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562948,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562943,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562938,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562933,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562928,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562923,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562918,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562913,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562908,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562903,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562898,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562893,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562888,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562883,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562878,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562873,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562868,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562863,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562858,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562853,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562848,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562843,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562838,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562833,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562828,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562823,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562818,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562813,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562808,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562803,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562798,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562793,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562788,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562783,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562778,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562773,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562768,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562763,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562758,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562753,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562748,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562743,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562738,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562733,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562728,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562723,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562718,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562713,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562708,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562703,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562698,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562693,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562688,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562683,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562678,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562673,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562668,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562663,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562658,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562653,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562648,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562643,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562634,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562624,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562615,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562609,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563425,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563420,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563415,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563410,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563406,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563401,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563396,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563391,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563386,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563381,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563376,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563370,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563367,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563361,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563357,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563351,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563347,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563341,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563337,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563331,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563327,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563321,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563317,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563311,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563307,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563301,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563297,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "a QrCodeSpec should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563291,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563287,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563281,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563277,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563271,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563267,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563261,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563257,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563251,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563247,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563241,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563237,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563231,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563227,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563221,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563217,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563211,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563207,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563201,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563197,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563191,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563189,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563180,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563174,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563170,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563164,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563160,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563154,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563150,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563146,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563140,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563136,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563130,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563123,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563118,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563113,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563108,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563103,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563516,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563522,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563525,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563531,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563535,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563541,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563545,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563551,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdf with QR code and invoiceNo",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563554,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdf with QR code",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563560,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563564,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563570,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563574,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563580,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563583,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563506,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563439,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563444,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563449,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563454,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563458,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563463,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563468,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563473,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563478,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563483,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563487,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563493,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563496,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563502,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563651,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563647,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563641,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563638,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563632,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563628,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563622,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563618,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563612,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563609,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563603,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563599,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563593,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563589,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563435,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563512,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563430,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729906,
                                    "isTestReportAvailable": true,
                                    "duration": 894,
                                    "duration_inMinutes": 14.9,
                                    "created_at": "Mar-01-22",
                                    "created_at_rawDateFormat": "2022-03-01T07:05:54.065Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 481560782,
                                "gitlabId": 481560782,
                                "status": "success",
                                "testReport": {
                                    "id": 46763,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 39,
                                    "success_count": 169,
                                    "total_count": 208,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54101,
                                            "total_time": -0.26,
                                            "total_count": 208,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 39,
                                            "success_count": 169,
                                            "test_cases": [
                                                {
                                                    "id": 3559562,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559907,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559902,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559897,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdf with QR code",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559892,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdf with QR code and invoiceNo",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559887,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558745,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558755,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558765,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558775,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558785,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558795,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558804,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558814,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558823,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558833,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558843,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558852,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558862,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558872,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558882,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558891,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558901,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558910,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558920,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558930,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558940,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558949,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558959,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558969,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558978,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558988,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558998,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559008,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559018,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559882,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559877,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559722,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559872,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559867,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559862,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559857,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559852,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559847,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559842,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559837,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559832,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559827,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559822,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559817,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559812,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559807,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559802,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559797,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559792,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559787,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559737,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559732,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559727,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559782,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559777,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559772,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559767,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559762,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559757,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559752,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559997,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559992,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559987,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559982,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559977,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559972,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559967,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559962,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559957,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559952,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559947,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559942,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559028,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559038,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559048,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559058,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559068,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559078,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559088,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559098,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559108,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559117,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559127,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559136,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559146,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559156,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559166,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559175,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559185,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559194,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559203,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559213,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559223,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559232,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559238,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559242,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559248,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559252,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559258,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559747,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559742,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559602,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559607,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559612,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559617,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559597,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559592,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559587,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559582,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559577,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559572,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559567,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559557,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559552,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559547,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559542,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559537,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559532,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559527,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559522,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559517,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559512,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559507,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559502,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559497,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559492,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559487,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559482,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559477,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559472,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559265,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559270,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559275,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559280,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559284,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559289,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559294,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559299,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559304,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559309,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559316,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559326,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559336,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559346,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559356,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559366,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559375,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559380,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559387,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559392,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559397,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559402,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559407,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559412,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559417,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559422,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559427,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559432,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559437,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559442,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559467,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559462,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559457,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559452,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559447,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559622,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559627,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559632,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "a QrCodeSpec should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559637,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559642,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559647,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559652,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559657,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559662,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559667,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559672,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559677,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559682,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559687,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559692,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559697,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559702,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559707,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559712,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559717,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559937,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559932,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559927,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559922,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559917,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559912,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558735,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558725,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558715,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558705,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558695,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558685,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558675,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558665,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558655,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558645,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558635,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729907,
                                    "isTestReportAvailable": true,
                                    "duration": 807,
                                    "duration_inMinutes": 13.45,
                                    "created_at": "Mar-01-22",
                                    "created_at_rawDateFormat": "2022-03-01T07:05:54.106Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 481548695,
                                "gitlabId": 481548695,
                                "status": "success",
                                "testReport": {
                                    "id": 46765,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 39,
                                    "success_count": 169,
                                    "total_count": 208,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54103,
                                            "total_time": -0.26,
                                            "total_count": 208,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 39,
                                            "success_count": 169,
                                            "test_cases": [
                                                {
                                                    "id": 3563147,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562985,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562980,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563157,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562645,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562640,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562790,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562795,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562800,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562805,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562975,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562970,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562965,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562690,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562695,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562765,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562700,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562705,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562710,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562715,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562720,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562725,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562730,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562735,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562740,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562745,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562750,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563167,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563177,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563183,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563184,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563190,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563196,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563206,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563216,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563226,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563236,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562810,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562815,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562820,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562825,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563045,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563040,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563035,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563030,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563025,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562830,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562835,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562840,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562845,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562850,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562855,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562860,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562960,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562955,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562950,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562945,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562940,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562935,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562930,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562925,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562920,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562915,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562910,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562865,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562870,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562875,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562880,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562885,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562890,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562895,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562900,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562905,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563060,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563065,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562685,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562680,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563137,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563405,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563070,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563075,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563080,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563085,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563090,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563095,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563100,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562675,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562670,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562665,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562660,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562655,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562650,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563105,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563110,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563115,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563120,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563125,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563131,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563142,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563246,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563379,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563456,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563452,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563446,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563441,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563434,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563428,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563423,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563417,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "a QrCodeSpec should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563412,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563375,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563365,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563356,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563346,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563336,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563326,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563316,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563306,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563296,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563286,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563276,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563266,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563256,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563399,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563395,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563389,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563385,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563055,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563050,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562770,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562775,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562780,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562785,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563020,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562760,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562755,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563015,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563010,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563005,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563000,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562995,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562990,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563655,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563829,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563839,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563849,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563859,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563869,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdf with QR code and invoiceNo",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563879,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdf with QR code",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563889,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563899,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563909,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563919,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563929,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563939,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563949,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563959,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563969,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563979,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563606,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563616,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563626,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563635,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563989,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563999,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564009,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564019,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564029,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564039,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564049,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564059,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564069,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564079,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563645,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563664,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563674,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563684,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563694,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563703,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563713,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563723,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563732,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563741,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563751,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563761,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563770,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563780,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563789,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563799,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563809,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563819,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563597,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563587,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563577,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563568,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563558,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563548,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563539,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563529,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563520,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563510,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563500,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563490,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563482,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563476,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563472,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563466,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563462,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729909,
                                    "isTestReportAvailable": true,
                                    "duration": 871,
                                    "duration_inMinutes": 14.52,
                                    "created_at": "Mar-01-22",
                                    "created_at_rawDateFormat": "2022-03-01T07:05:54.154Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 480925640,
                                "gitlabId": 480925640,
                                "status": "success",
                                "testReport": {
                                    "id": 46771,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 38,
                                    "success_count": 169,
                                    "total_count": 207,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54104,
                                            "total_time": -0.26,
                                            "total_count": 207,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 38,
                                            "success_count": 169,
                                            "test_cases": [
                                                {
                                                    "id": 3555648,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555657,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555667,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555832,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555823,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555813,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555803,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555793,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555783,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555773,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555763,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555753,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555743,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555733,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555723,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555714,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555705,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555695,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556386,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556392,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556396,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556402,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555676,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555686,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555256,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555260,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555266,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555936,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555930,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555926,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555920,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555916,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555910,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "a QrCodeSpec should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555905,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555900,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555895,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555890,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555885,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555880,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555871,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555861,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555851,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555842,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555414,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555424,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555434,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555444,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555454,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555464,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555474,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555272,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555280,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555071,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555061,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555053,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555043,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555034,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555028,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555024,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555282,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555288,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555292,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555298,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555302,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555308,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555312,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555318,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555322,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555328,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554939,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554945,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554949,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554955,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554959,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554965,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554969,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554975,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554979,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554985,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554989,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554995,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554999,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555005,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555010,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555018,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555331,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555337,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555341,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555347,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555350,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555356,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555360,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555366,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555370,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555376,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555380,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555386,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555390,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555396,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555404,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556097,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556087,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556077,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556067,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556057,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556047,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556037,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556028,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556018,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556009,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555999,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555995,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555989,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555985,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555979,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555975,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555969,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555965,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555959,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555954,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555948,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555080,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555090,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555100,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556203,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556193,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556183,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556174,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556164,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556154,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556144,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556135,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556125,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556116,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556106,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555942,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556212,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556222,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556231,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556241,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556250,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556256,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556260,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556266,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556270,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556276,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556280,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556286,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555110,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555120,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555130,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555140,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555150,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555484,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555494,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555504,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555514,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555524,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555533,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555542,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556290,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556296,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdf with QR code",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556300,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556306,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556310,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556316,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556322,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556328,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556333,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556339,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556345,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556351,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556357,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556363,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556367,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556373,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556377,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556383,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555552,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555562,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555570,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555580,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555590,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555599,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555160,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555170,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555180,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555190,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555200,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555210,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555220,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555229,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555232,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555237,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555241,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555247,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555250,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554908,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554914,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554918,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554924,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554929,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554935,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555609,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555619,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555628,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555638,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729911,
                                    "isTestReportAvailable": true,
                                    "duration": 1123,
                                    "duration_inMinutes": 18.72,
                                    "created_at": "Feb-28-22",
                                    "created_at_rawDateFormat": "2022-02-28T07:05:54.291Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 480921531,
                                "gitlabId": 480921531,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729915,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Feb-28-22",
                                    "created_at_rawDateFormat": "2022-02-28T07:05:54.534Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 475511643,
                                "gitlabId": 475511643,
                                "status": "success",
                                "testReport": {
                                    "id": 46776,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54105,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3563470,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563480,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563489,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563499,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563509,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563518,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564004,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563994,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563984,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563974,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563964,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563954,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563354,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563364,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563374,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563944,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563804,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564141,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564151,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564161,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563934,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563924,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563914,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563904,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563894,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563844,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563834,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563824,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563814,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563345,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563335,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563776,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563771,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563766,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563760,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563756,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563750,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563746,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563740,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563731,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563721,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563711,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563702,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563692,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563682,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563673,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563663,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563653,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563644,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563634,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563624,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563615,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563605,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563595,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563586,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563576,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563566,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563557,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563547,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563537,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563528,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563451,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563461,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563781,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563786,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564014,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564024,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564034,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564044,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564054,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564064,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563794,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564074,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564084,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564094,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564101,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564111,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564121,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564131,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563325,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563315,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563305,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563383,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563393,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563403,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563295,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563285,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563884,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563874,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563864,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563854,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563413,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563422,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563432,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563442,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563255,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562706,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562711,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562716,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562721,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562726,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562731,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562736,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562741,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562746,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562751,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563026,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563031,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563036,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563041,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563046,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563051,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563056,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563061,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563275,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563265,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563066,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562686,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563021,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563016,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563011,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563006,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563001,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562996,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562991,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562986,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562981,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562976,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562971,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562966,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562961,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562956,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562951,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562946,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562941,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562936,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562931,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562776,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562781,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562786,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562791,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562796,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562801,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562806,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562811,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562816,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562821,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562826,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562831,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562836,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562841,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562846,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562851,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562856,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562861,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562866,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562871,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562876,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562881,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562886,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562891,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562896,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562901,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562906,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562911,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562916,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562921,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562926,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562756,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562761,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562766,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562771,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563071,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563076,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563081,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563086,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563091,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563096,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563101,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563106,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563111,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563116,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563121,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563126,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563129,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563135,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563139,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563145,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563149,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563155,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563161,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563165,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563171,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563175,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563181,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563185,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563195,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563205,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563215,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563225,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563235,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563245,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562691,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562696,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562701,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729912,
                                    "isTestReportAvailable": true,
                                    "duration": 1206,
                                    "duration_inMinutes": 20.1,
                                    "created_at": "Feb-21-22",
                                    "created_at_rawDateFormat": "2022-02-21T07:05:54.391Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 475510943,
                                "gitlabId": 475510943,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729914,
                                    "isTestReportAvailable": false,
                                    "duration": 112,
                                    "duration_inMinutes": 1.87,
                                    "created_at": "Feb-21-22",
                                    "created_at_rawDateFormat": "2022-02-21T07:05:54.518Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 467946457,
                                "gitlabId": 467946457,
                                "status": "success",
                                "testReport": {
                                    "id": 46766,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 38,
                                    "success_count": 169,
                                    "total_count": 207,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54106,
                                            "total_time": -0.26,
                                            "total_count": 207,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 38,
                                            "success_count": 169,
                                            "test_cases": [
                                                {
                                                    "id": 3560238,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558943,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558947,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558953,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558956,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558962,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558966,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558972,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558976,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558982,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558985,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558991,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558995,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559001,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559005,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559011,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559015,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559021,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559025,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559031,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559035,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559041,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559045,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559051,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559055,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559061,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558733,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558739,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558743,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558749,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558753,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558759,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558763,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558769,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558773,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558779,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558783,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558789,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558794,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559618,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560278,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560268,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560258,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560248,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558937,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560228,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559291,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559301,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559310,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559315,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559320,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559325,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560218,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559330,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559335,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559340,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559345,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559350,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559355,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559360,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559365,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559370,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559378,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559388,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559398,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559408,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559418,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559428,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559438,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559448,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559458,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559468,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559478,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559488,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559498,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559508,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559908,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559898,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559888,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559878,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559065,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559071,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559075,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559081,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559085,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559091,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559095,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559101,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559105,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559111,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559115,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559121,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559126,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559131,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559137,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559144,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559150,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559154,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559160,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559165,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559170,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559176,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559182,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559188,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559192,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559198,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559204,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559214,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559224,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559233,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559243,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559253,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559262,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559272,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559281,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559608,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559598,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559588,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559578,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559568,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559558,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "a QrCodeSpec should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559548,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559538,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559528,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559518,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559628,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559638,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559648,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559658,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559668,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559678,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559688,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559698,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559708,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559718,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559728,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559738,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559748,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559758,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559768,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559778,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559788,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559798,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559808,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559818,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559828,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559838,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559848,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559868,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560208,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560198,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560188,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560178,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560168,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560158,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560148,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560138,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560128,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560118,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560108,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560098,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560088,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560078,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdf with QR code",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560068,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560058,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560048,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560038,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560028,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560018,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560008,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559998,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559988,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559978,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559968,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559958,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559948,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559938,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559928,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559918,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559858,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558799,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558805,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558811,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558817,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558821,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558827,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558830,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558836,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558840,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558846,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558850,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558856,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558859,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558865,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558869,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558875,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558879,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558885,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558889,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558895,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558900,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558905,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558911,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558915,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558921,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558925,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558931,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729913,
                                    "isTestReportAvailable": true,
                                    "duration": 807,
                                    "duration_inMinutes": 13.45,
                                    "created_at": "Feb-10-22",
                                    "created_at_rawDateFormat": "2022-02-10T07:05:54.453Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 467943573,
                                "gitlabId": 467943573,
                                "status": "failed",
                                "testReport": {
                                    "id": 46767,
                                    "error_count": 3,
                                    "failed_count": 3,
                                    "skipped_count": 25,
                                    "success_count": 144,
                                    "total_count": 175,
                                    "total_time": -0.22,
                                    "test_suites": [
                                        {
                                            "id": 54107,
                                            "total_time": -0.22,
                                            "total_count": 175,
                                            "error_count": 3,
                                            "failed_count": 3,
                                            "name": "test-ism",
                                            "skipped_count": 25,
                                            "success_count": 144,
                                            "test_cases": [
                                                {
                                                    "id": 3562999,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563009,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563019,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563029,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563039,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563049,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563059,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563069,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563079,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563089,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563099,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563109,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563119,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563132,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563141,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563151,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563156,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563162,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562979,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562969,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562959,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562949,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562939,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562929,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562919,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562909,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562899,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562889,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562879,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562779,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "error",
                                                    "system_output": "java.lang.NoClassDefFoundError: Could not initialize class sun.awt.X11GraphicsEnvironment\n\tat java.lang.Class.forName0(Native Method)\n\tat java.lang.Class.forName(Class.java:264)\n\tat java.awt.GraphicsEnvironment.createGE(GraphicsEnvironment.java:103)\n\tat java.awt.GraphicsEnvironment.getLocalGraphicsEnvironment(GraphicsEnvironment.java:82)\n\tat sun.awt.X11FontManager.isHeadless(X11FontManager.java:509)\n\tat sun.awt.X11FontManager.getFontPath(X11FontManager.java:786)\n\tat sun.font.SunFontManager.getPlatformFontPath(SunFontManager.java:3282)\n\tat sun.font.SunFontManager$10.run(SunFontManager.java:3308)\n\tat java.security.AccessController.doPrivileged(Native Method)\n\tat sun.font.SunFontManager.loadFonts(SunFontManager.java:3304)\n\tat sun.awt.X11FontManager.loadFonts(X11FontManager.java:460)\n\tat sun.font.SunFontManager.findFont2D(SunFontManager.java:2348)\n\tat java.awt.Font.getFont2D(Font.java:500)\n\tat java.awt.Font.getFamily(Font.java:1220)\n\tat java.awt.Font.getFamily_NoClientCode(Font.java:1194)\n\tat java.awt.Font.getFamily(Font.java:1186)\n\tat net.codecrete.qrbill.canvas.PNGCanvas.findFontFamily(PNGCanvas.java:111)\n\tat net.codecrete.qrbill.canvas.PNGCanvas.<init>(PNGCanvas.java:74)\n\tat net.codecrete.qrbill.generator.QRBill.createCanvas(QRBill.java:297)\n\tat net.codecrete.qrbill.generator.QRBill.generate(QRBill.java:128)\n\tat ch.petag.pdf.InpaymentSlipQRRenderer.render(InpaymentSlipQRRenderer.scala:66)\n\tat ch.petag.pdf.InpaymentSlipQRPdfGenerator.writeTo(InpaymentSlipQRPdfGenerator.scala:31)\n\tat ch.petag.pdf.InpaymentSlipQRPdfGenerator.writeTo(InpaymentSlipQRPdfGenerator.scala:20)\n\tat ch.petag.db.finance.InpaymentSlipSpec$$anonfun$1$$anonfun$apply$mcV$sp$2$$anonfun$apply$mcV$sp$5.apply(InpaymentSlipSpec.scala:45)\n\tat ch.petag.db.finance.InpaymentSlipSpec$$anonfun$1$$anonfun$apply$mcV$sp$2$$anonfun$apply$mcV$sp$5.apply(InpaymentSlipSpec.scala:41)\n\tat ch.petag.db.invoice.util.DBTestTrait$$anon$1.dbm(DBTestTrait.scala:12)\n\tat jdbt.runtime.Transaction.dbt(Transaction.java:162)\n\tat jdbt.runtime.Transaction.dbt(Transaction.java:251)\n\tat ch.petag.db.invoice.util.DBTestTrait$class.openSqlConnectionAndExecute(DBTestTrait.scala:14)\n\tat ch.petag.db.finance.InpaymentSlipSpec.openSqlConnectionAndExecute(InpaymentSlipSpec.scala:13)\n\tat ch.petag.db.finance.InpaymentSlipSpec$$anonfun$1$$anonfun$apply$mcV$sp$2.apply$mcV$sp(InpaymentSlipSpec.scala:41)\n\tat ch.petag.db.finance.InpaymentSlipSpec$$anonfun$1$$anonfun$apply$mcV$sp$2.apply(InpaymentSlipSpec.scala:22)\n\tat ch.petag.db.finance.InpaymentSlipSpec$$anonfun$1$$anonfun$apply$mcV$sp$2.apply(InpaymentSlipSpec.scala:22)\n\tat org.specs.specification.LifeCycle$class.withCurrent(ExampleLifeCycle.scala:66)\n\tat org.specs.specification.Examples.withCurrent(Examples.scala:52)\n\tat org.specs.specification.Examples$$anonfun$specifyExample$1.apply(Examples.scala:114)\n\tat org.specs.specification.Examples$$anonfun$specifyExample$1.apply(Examples.scala:114)\n\tat org.specs.specification.ExampleExecution$$anonfun$3$$anonfun$apply$5.apply(ExampleLifeCycle.scala:219)\n\tat scala.Option.getOrElse(Option.scala:120)\n\tat org.specs.specification.LifeCycle$class.executeExpectations(ExampleLifeCycle.scala:90)\n\tat org.specs.specification.BaseSpecification.executeExpectations(BaseSpecification.scala:58)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$class.id$1(ExampleContext.scala:32)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$class.executeExpectations(ExampleContext.scala:80)\n\tat org.specs.specification.Examples.executeExpectations(Examples.scala:52)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$class.id$1(ExampleContext.scala:32)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$class.executeExpectations(ExampleContext.scala:80)\n\tat org.specs.specification.Examples.executeExpectations(Examples.scala:52)\n\tat org.specs.specification.ExampleExecution$$anonfun$3.apply(ExampleLifeCycle.scala:219)\n\tat org.specs.specification.ExampleExecution$$anonfun$3.apply(ExampleLifeCycle.scala:198)\n\tat org.specs.specification.ExampleExecution$$anonfun$2.apply(ExampleLifeCycle.scala:181)\n\tat org.specs.specification.ExampleExecution.execute(ExampleLifeCycle.scala:252)\n\tat org.specs.specification.SpecificationExecutor$$anonfun$executeExample$3.apply(SpecificationExecutor.scala:70)\n\tat org.specs.specification.SpecificationExecutor$$anonfun$executeExample$3.apply(SpecificationExecutor.scala:70)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.SpecificationExecutor$class.executeExample(SpecificationExecutor.scala:70)\n\tat org.specs.specification.BaseSpecification.executeExample(BaseSpecification.scala:58)\n\tat org.specs.specification.BaseSpecification.executeExample(BaseSpecification.scala:58)\n\tat org.specs.specification.ExampleLifeCycle$$anonfun$executeExample$1.apply(ExampleLifeCycle.scala:125)\n\tat org.specs.specification.ExampleLifeCycle$$anonfun$executeExample$1.apply(ExampleLifeCycle.scala:125)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleLifeCycle$class.executeExample(ExampleLifeCycle.scala:125)\n\tat org.specs.specification.Examples.executeExample(Examples.scala:52)\n\tat org.specs.specification.Examples.executeExample(Examples.scala:52)\n\tat org.specs.specification.Examples$$anonfun$executeExamples$2.apply(Examples.scala:80)\n\tat org.specs.specification.Examples$$anonfun$executeExamples$2.apply(Examples.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.Examples.executeExamples(Examples.scala:80)\n\tat org.specs.specification.ExampleStructure$class.ownFailures(ExampleStructure.scala:58)\n\tat org.specs.specification.Examples.ownFailures(Examples.scala:52)\n\tat org.specs.specification.ExampleStructure$class.failures(ExampleStructure.scala:64)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.specification.ExampleStructure$$anonfun$failures$1.apply(ExampleStructure.scala:64)\n\tat org.specs.specification.ExampleStructure$$anonfun$failures$1.apply(ExampleStructure.scala:64)\n\tat scala.collection.TraversableLike$$anonfun$flatMap$1.apply(TraversableLike.scala:251)\n\tat scala.collection.TraversableLike$$anonfun$flatMap$1.apply(TraversableLike.scala:251)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat scala.collection.TraversableLike$class.flatMap(TraversableLike.scala:251)\n\tat scala.collection.AbstractTraversable.flatMap(Traversable.scala:105)\n\tat org.specs.specification.ExampleStructure$class.failures(ExampleStructure.scala:64)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.execute.HasResults$class.failureAndErrors(HasResults.scala:61)\n\tat org.specs.specification.Examples.failureAndErrors(Examples.scala:52)\n\tat org.specs.execute.HasResults$class.isOk(HasResults.scala:69)\n\tat org.specs.specification.Examples.isOk(Examples.scala:52)\n\tat org.specs.runner.NotifierRunner.reportSystem(NotifierRunner.scala:81)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:72)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:68)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat org.specs.runner.NotifierRunner.reportASpecification(NotifierRunner.scala:68)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:58)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:45)\n\tat org.specs.runner.Reporter$class.reportSpecs(Reporter.scala:195)\n\tat org.specs.runner.NotifierRunner.reportSpecs(NotifierRunner.scala:45)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:65)\n\tat sbt.RunnerWrapper$1.runRunner(FrameworkWrapper.java:203)\n\tat sbt.RunnerWrapper$1.execute(FrameworkWrapper.java:239)\n\tat sbt.TestRunner.runTest$1(TestFramework.scala:76)\n\tat sbt.TestRunner.run(TestFramework.scala:85)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$.sbt$TestFramework$$withContextLoader(TestFramework.scala:185)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFunction.apply(TestFramework.scala:207)\n\tat sbt.Tests$.sbt$Tests$$processRunnable$1(Tests.scala:239)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$4.work(System.scala:63)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.ErrorHandling$.wideConvert(ErrorHandling.scala:17)\n\tat sbt.Execute.work(Execute.scala:237)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.ConcurrentRestrictions$$anon$4$$anonfun$1.apply(ConcurrentRestrictions.scala:159)\n\tat sbt.CompletionService$$anon$2.call(CompletionService.scala:28)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.Executors$RunnableAdapter.call(Executors.java:511)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1142)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:617)\n\tat java.lang.Thread.run(Thread.java:748)\n"
                                                },
                                                {
                                                    "id": 3562789,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "error",
                                                    "system_output": "java.lang.NoClassDefFoundError: Could not initialize class sun.awt.X11GraphicsEnvironment\n\tat java.lang.Class.forName0(Native Method)\n\tat java.lang.Class.forName(Class.java:264)\n\tat java.awt.GraphicsEnvironment.createGE(GraphicsEnvironment.java:103)\n\tat java.awt.GraphicsEnvironment.getLocalGraphicsEnvironment(GraphicsEnvironment.java:82)\n\tat sun.awt.X11FontManager.isHeadless(X11FontManager.java:509)\n\tat sun.awt.X11FontManager.getFontPath(X11FontManager.java:786)\n\tat sun.font.SunFontManager.getPlatformFontPath(SunFontManager.java:3282)\n\tat sun.font.SunFontManager$10.run(SunFontManager.java:3308)\n\tat java.security.AccessController.doPrivileged(Native Method)\n\tat sun.font.SunFontManager.loadFonts(SunFontManager.java:3304)\n\tat sun.awt.X11FontManager.loadFonts(X11FontManager.java:460)\n\tat sun.font.SunFontManager.findFont2D(SunFontManager.java:2348)\n\tat java.awt.Font.getFont2D(Font.java:500)\n\tat java.awt.Font.getFamily(Font.java:1220)\n\tat java.awt.Font.getFamily_NoClientCode(Font.java:1194)\n\tat java.awt.Font.getFamily(Font.java:1186)\n\tat net.codecrete.qrbill.canvas.PNGCanvas.findFontFamily(PNGCanvas.java:111)\n\tat net.codecrete.qrbill.canvas.PNGCanvas.<init>(PNGCanvas.java:74)\n\tat net.codecrete.qrbill.generator.QRBill.createCanvas(QRBill.java:297)\n\tat net.codecrete.qrbill.generator.QRBill.generate(QRBill.java:128)\n\tat ch.petag.pdf.InpaymentSlipQRRenderer.render(InpaymentSlipQRRenderer.scala:66)\n\tat ch.petag.pdf.InpaymentSlipQRPdfGenerator.writeTo(InpaymentSlipQRPdfGenerator.scala:31)\n\tat ch.petag.pdf.PrepayInvoicePdfGenerator.createPdf(PrepayInvoicePdfGenerator.scala:52)\n\tat ch.petag.pdf.PrePayInvoicePdfGeneratorSpec$$anonfun$1$$anonfun$apply$3.apply$mcV$sp(PrePayInvoicePdfGeneratorSpec.scala:58)\n\tat ch.petag.pdf.PrePayInvoicePdfGeneratorSpec$$anonfun$1$$anonfun$apply$3.apply(PrePayInvoicePdfGeneratorSpec.scala:42)\n\tat ch.petag.pdf.PrePayInvoicePdfGeneratorSpec$$anonfun$1$$anonfun$apply$3.apply(PrePayInvoicePdfGeneratorSpec.scala:42)\n\tat org.specs.specification.LifeCycle$class.withCurrent(ExampleLifeCycle.scala:66)\n\tat org.specs.specification.Examples.withCurrent(Examples.scala:52)\n\tat org.specs.specification.Examples$$anonfun$specifyExample$1.apply(Examples.scala:114)\n\tat org.specs.specification.Examples$$anonfun$specifyExample$1.apply(Examples.scala:114)\n\tat org.specs.specification.ExampleExecution$$anonfun$3$$anonfun$apply$5.apply(ExampleLifeCycle.scala:219)\n\tat scala.Option.getOrElse(Option.scala:120)\n\tat org.specs.specification.LifeCycle$class.executeExpectations(ExampleLifeCycle.scala:90)\n\tat org.specs.specification.BaseSpecification.executeExpectations(BaseSpecification.scala:58)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$class.id$1(ExampleContext.scala:32)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$class.executeExpectations(ExampleContext.scala:80)\n\tat org.specs.specification.Examples.executeExpectations(Examples.scala:52)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$class.id$1(ExampleContext.scala:32)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$class.executeExpectations(ExampleContext.scala:80)\n\tat org.specs.specification.Examples.executeExpectations(Examples.scala:52)\n\tat org.specs.specification.ExampleExecution$$anonfun$3.apply(ExampleLifeCycle.scala:219)\n\tat org.specs.specification.ExampleExecution$$anonfun$3.apply(ExampleLifeCycle.scala:198)\n\tat org.specs.specification.ExampleExecution$$anonfun$2.apply(ExampleLifeCycle.scala:181)\n\tat org.specs.specification.ExampleExecution.execute(ExampleLifeCycle.scala:252)\n\tat org.specs.specification.SpecificationExecutor$$anonfun$executeExample$3.apply(SpecificationExecutor.scala:70)\n\tat org.specs.specification.SpecificationExecutor$$anonfun$executeExample$3.apply(SpecificationExecutor.scala:70)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.SpecificationExecutor$class.executeExample(SpecificationExecutor.scala:70)\n\tat org.specs.specification.BaseSpecification.executeExample(BaseSpecification.scala:58)\n\tat org.specs.specification.BaseSpecification.executeExample(BaseSpecification.scala:58)\n\tat org.specs.specification.ExampleLifeCycle$$anonfun$executeExample$1.apply(ExampleLifeCycle.scala:125)\n\tat org.specs.specification.ExampleLifeCycle$$anonfun$executeExample$1.apply(ExampleLifeCycle.scala:125)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleLifeCycle$class.executeExample(ExampleLifeCycle.scala:125)\n\tat org.specs.specification.Examples.executeExample(Examples.scala:52)\n\tat org.specs.specification.Examples.executeExample(Examples.scala:52)\n\tat org.specs.specification.Examples$$anonfun$executeExamples$2.apply(Examples.scala:80)\n\tat org.specs.specification.Examples$$anonfun$executeExamples$2.apply(Examples.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.Examples.executeExamples(Examples.scala:80)\n\tat org.specs.specification.ExampleStructure$class.ownFailures(ExampleStructure.scala:58)\n\tat org.specs.specification.Examples.ownFailures(Examples.scala:52)\n\tat org.specs.specification.ExampleStructure$class.failures(ExampleStructure.scala:64)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.specification.ExampleStructure$$anonfun$failures$1.apply(ExampleStructure.scala:64)\n\tat org.specs.specification.ExampleStructure$$anonfun$failures$1.apply(ExampleStructure.scala:64)\n\tat scala.collection.TraversableLike$$anonfun$flatMap$1.apply(TraversableLike.scala:251)\n\tat scala.collection.TraversableLike$$anonfun$flatMap$1.apply(TraversableLike.scala:251)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat scala.collection.TraversableLike$class.flatMap(TraversableLike.scala:251)\n\tat scala.collection.AbstractTraversable.flatMap(Traversable.scala:105)\n\tat org.specs.specification.ExampleStructure$class.failures(ExampleStructure.scala:64)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.execute.HasResults$class.failureAndErrors(HasResults.scala:61)\n\tat org.specs.specification.Examples.failureAndErrors(Examples.scala:52)\n\tat org.specs.execute.HasResults$class.isOk(HasResults.scala:69)\n\tat org.specs.specification.Examples.isOk(Examples.scala:52)\n\tat org.specs.runner.NotifierRunner.reportSystem(NotifierRunner.scala:81)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:72)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:68)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat org.specs.runner.NotifierRunner.reportASpecification(NotifierRunner.scala:68)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:58)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:45)\n\tat org.specs.runner.Reporter$class.reportSpecs(Reporter.scala:195)\n\tat org.specs.runner.NotifierRunner.reportSpecs(NotifierRunner.scala:45)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:65)\n\tat sbt.RunnerWrapper$1.runRunner(FrameworkWrapper.java:203)\n\tat sbt.RunnerWrapper$1.execute(FrameworkWrapper.java:239)\n\tat sbt.TestRunner.runTest$1(TestFramework.scala:76)\n\tat sbt.TestRunner.run(TestFramework.scala:85)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$.sbt$TestFramework$$withContextLoader(TestFramework.scala:185)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFunction.apply(TestFramework.scala:207)\n\tat sbt.Tests$.sbt$Tests$$processRunnable$1(Tests.scala:239)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$4.work(System.scala:63)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.ErrorHandling$.wideConvert(ErrorHandling.scala:17)\n\tat sbt.Execute.work(Execute.scala:237)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.ConcurrentRestrictions$$anon$4$$anonfun$1.apply(ConcurrentRestrictions.scala:159)\n\tat sbt.CompletionService$$anon$2.call(CompletionService.scala:28)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.Executors$RunnableAdapter.call(Executors.java:511)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1142)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:617)\n\tat java.lang.Thread.run(Thread.java:748)\n"
                                                },
                                                {
                                                    "id": 3562799,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdf with QR code",
                                                    "status": "error",
                                                    "system_output": "java.awt.AWTError: Can't connect to X11 window server using ':99.0' as the value of the DISPLAY variable.\n\tat sun.awt.X11GraphicsEnvironment.initDisplay(Native Method)\n\tat sun.awt.X11GraphicsEnvironment.access$200(X11GraphicsEnvironment.java:65)\n\tat sun.awt.X11GraphicsEnvironment$1.run(X11GraphicsEnvironment.java:115)\n\tat java.security.AccessController.doPrivileged(Native Method)\n\tat sun.awt.X11GraphicsEnvironment.<clinit>(X11GraphicsEnvironment.java:74)\n\tat java.lang.Class.forName0(Native Method)\n\tat java.lang.Class.forName(Class.java:264)\n\tat java.awt.GraphicsEnvironment.createGE(GraphicsEnvironment.java:103)\n\tat java.awt.GraphicsEnvironment.getLocalGraphicsEnvironment(GraphicsEnvironment.java:82)\n\tat sun.awt.X11FontManager.isHeadless(X11FontManager.java:509)\n\tat sun.awt.X11FontManager.getFontPath(X11FontManager.java:786)\n\tat sun.font.SunFontManager.getPlatformFontPath(SunFontManager.java:3282)\n\tat sun.font.SunFontManager$10.run(SunFontManager.java:3308)\n\tat java.security.AccessController.doPrivileged(Native Method)\n\tat sun.font.SunFontManager.loadFonts(SunFontManager.java:3304)\n\tat sun.awt.X11FontManager.loadFonts(X11FontManager.java:460)\n\tat sun.font.SunFontManager.findFont2D(SunFontManager.java:2348)\n\tat java.awt.Font.getFont2D(Font.java:500)\n\tat java.awt.Font.getFamily(Font.java:1220)\n\tat java.awt.Font.getFamily_NoClientCode(Font.java:1194)\n\tat java.awt.Font.getFamily(Font.java:1186)\n\tat net.codecrete.qrbill.canvas.PNGCanvas.findFontFamily(PNGCanvas.java:111)\n\tat net.codecrete.qrbill.canvas.PNGCanvas.<init>(PNGCanvas.java:74)\n\tat net.codecrete.qrbill.generator.QRBill.createCanvas(QRBill.java:297)\n\tat net.codecrete.qrbill.generator.QRBill.generate(QRBill.java:128)\n\tat ch.petag.pdf.InpaymentSlipQRRenderer.render(InpaymentSlipQRRenderer.scala:66)\n\tat ch.petag.pdf.InpaymentSlipQRPdfGenerator.writeTo(InpaymentSlipQRPdfGenerator.scala:31)\n\tat ch.petag.pdf.InpaymentSlipQRPdfGenerator.writeTo(InpaymentSlipQRPdfGenerator.scala:20)\n\tat ch.petag.pdf.QrCodeSpec$$anonfun$1$$anonfun$apply$1.apply$mcV$sp(QrCodeSpec.scala:13)\n\tat ch.petag.pdf.QrCodeSpec$$anonfun$1$$anonfun$apply$1.apply(QrCodeSpec.scala:11)\n\tat ch.petag.pdf.QrCodeSpec$$anonfun$1$$anonfun$apply$1.apply(QrCodeSpec.scala:11)\n\tat org.specs.specification.LifeCycle$class.withCurrent(ExampleLifeCycle.scala:66)\n\tat org.specs.specification.Examples.withCurrent(Examples.scala:52)\n\tat org.specs.specification.Examples$$anonfun$specifyExample$1.apply(Examples.scala:114)\n\tat org.specs.specification.Examples$$anonfun$specifyExample$1.apply(Examples.scala:114)\n\tat org.specs.specification.ExampleExecution$$anonfun$3$$anonfun$apply$5.apply(ExampleLifeCycle.scala:219)\n\tat scala.Option.getOrElse(Option.scala:120)\n\tat org.specs.specification.LifeCycle$class.executeExpectations(ExampleLifeCycle.scala:90)\n\tat org.specs.specification.BaseSpecification.executeExpectations(BaseSpecification.scala:58)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$class.id$1(ExampleContext.scala:32)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$class.executeExpectations(ExampleContext.scala:80)\n\tat org.specs.specification.Examples.executeExpectations(Examples.scala:52)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$class.id$1(ExampleContext.scala:32)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$class.executeExpectations(ExampleContext.scala:80)\n\tat org.specs.specification.Examples.executeExpectations(Examples.scala:52)\n\tat org.specs.specification.ExampleExecution$$anonfun$3.apply(ExampleLifeCycle.scala:219)\n\tat org.specs.specification.ExampleExecution$$anonfun$3.apply(ExampleLifeCycle.scala:198)\n\tat org.specs.specification.ExampleExecution$$anonfun$2.apply(ExampleLifeCycle.scala:181)\n\tat org.specs.specification.ExampleExecution.execute(ExampleLifeCycle.scala:252)\n\tat org.specs.specification.SpecificationExecutor$$anonfun$executeExample$3.apply(SpecificationExecutor.scala:70)\n\tat org.specs.specification.SpecificationExecutor$$anonfun$executeExample$3.apply(SpecificationExecutor.scala:70)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.SpecificationExecutor$class.executeExample(SpecificationExecutor.scala:70)\n\tat org.specs.specification.BaseSpecification.executeExample(BaseSpecification.scala:58)\n\tat org.specs.specification.BaseSpecification.executeExample(BaseSpecification.scala:58)\n\tat org.specs.specification.ExampleLifeCycle$$anonfun$executeExample$1.apply(ExampleLifeCycle.scala:125)\n\tat org.specs.specification.ExampleLifeCycle$$anonfun$executeExample$1.apply(ExampleLifeCycle.scala:125)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleLifeCycle$class.executeExample(ExampleLifeCycle.scala:125)\n\tat org.specs.specification.Examples.executeExample(Examples.scala:52)\n\tat org.specs.specification.Examples.executeExample(Examples.scala:52)\n\tat org.specs.specification.Examples$$anonfun$executeExamples$2.apply(Examples.scala:80)\n\tat org.specs.specification.Examples$$anonfun$executeExamples$2.apply(Examples.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.Examples.executeExamples(Examples.scala:80)\n\tat org.specs.specification.ExampleStructure$class.ownFailures(ExampleStructure.scala:58)\n\tat org.specs.specification.Examples.ownFailures(Examples.scala:52)\n\tat org.specs.specification.ExampleStructure$class.failures(ExampleStructure.scala:64)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.specification.ExampleStructure$$anonfun$failures$1.apply(ExampleStructure.scala:64)\n\tat org.specs.specification.ExampleStructure$$anonfun$failures$1.apply(ExampleStructure.scala:64)\n\tat scala.collection.TraversableLike$$anonfun$flatMap$1.apply(TraversableLike.scala:251)\n\tat scala.collection.TraversableLike$$anonfun$flatMap$1.apply(TraversableLike.scala:251)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat scala.collection.TraversableLike$class.flatMap(TraversableLike.scala:251)\n\tat scala.collection.AbstractTraversable.flatMap(Traversable.scala:105)\n\tat org.specs.specification.ExampleStructure$class.failures(ExampleStructure.scala:64)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.execute.HasResults$class.failureAndErrors(HasResults.scala:61)\n\tat org.specs.specification.Examples.failureAndErrors(Examples.scala:52)\n\tat org.specs.execute.HasResults$class.isOk(HasResults.scala:69)\n\tat org.specs.specification.Examples.isOk(Examples.scala:52)\n\tat org.specs.runner.NotifierRunner.reportSystem(NotifierRunner.scala:81)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:72)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:68)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat org.specs.runner.NotifierRunner.reportASpecification(NotifierRunner.scala:68)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:58)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:45)\n\tat org.specs.runner.Reporter$class.reportSpecs(Reporter.scala:195)\n\tat org.specs.runner.NotifierRunner.reportSpecs(NotifierRunner.scala:45)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:65)\n\tat sbt.RunnerWrapper$1.runRunner(FrameworkWrapper.java:203)\n\tat sbt.RunnerWrapper$1.execute(FrameworkWrapper.java:239)\n\tat sbt.TestRunner.runTest$1(TestFramework.scala:76)\n\tat sbt.TestRunner.run(TestFramework.scala:85)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$.sbt$TestFramework$$withContextLoader(TestFramework.scala:185)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFunction.apply(TestFramework.scala:207)\n\tat sbt.Tests$.sbt$Tests$$processRunnable$1(Tests.scala:239)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$4.work(System.scala:63)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.ErrorHandling$.wideConvert(ErrorHandling.scala:17)\n\tat sbt.Execute.work(Execute.scala:237)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.ConcurrentRestrictions$$anon$4$$anonfun$1.apply(ConcurrentRestrictions.scala:159)\n\tat sbt.CompletionService$$anon$2.call(CompletionService.scala:28)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.Executors$RunnableAdapter.call(Executors.java:511)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1142)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:617)\n\tat java.lang.Thread.run(Thread.java:748)\n"
                                                },
                                                {
                                                    "id": 3563166,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563172,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563176,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563182,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562869,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562859,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562849,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562839,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562829,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "a QrCodeSpec should",
                                                    "status": "failed",
                                                    "system_output": "java.lang.Exception: \n\tat org.specs.runner.NotifierRunner$$anonfun$reportSystem$3.apply(NotifierRunner.scala:84)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportSystem$3.apply(NotifierRunner.scala:84)\n\tat scala.collection.IndexedSeqOptimized$class.foreach(IndexedSeqOptimized.scala:33)\n\tat scala.collection.mutable.ArrayOps$ofRef.foreach(ArrayOps.scala:108)\n\tat org.specs.runner.NotifierRunner.reportSystem(NotifierRunner.scala:84)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:72)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:68)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat org.specs.runner.NotifierRunner.reportASpecification(NotifierRunner.scala:68)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:58)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:45)\n\tat org.specs.runner.Reporter$class.reportSpecs(Reporter.scala:195)\n\tat org.specs.runner.NotifierRunner.reportSpecs(NotifierRunner.scala:45)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:65)\n\tat sbt.RunnerWrapper$1.runRunner(FrameworkWrapper.java:203)\n\tat sbt.RunnerWrapper$1.execute(FrameworkWrapper.java:239)\n\tat sbt.TestRunner.runTest$1(TestFramework.scala:76)\n\tat sbt.TestRunner.run(TestFramework.scala:85)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$.sbt$TestFramework$$withContextLoader(TestFramework.scala:185)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFunction.apply(TestFramework.scala:207)\n\tat sbt.Tests$.sbt$Tests$$processRunnable$1(Tests.scala:239)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$4.work(System.scala:63)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.ErrorHandling$.wideConvert(ErrorHandling.scala:17)\n\tat sbt.Execute.work(Execute.scala:237)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.ConcurrentRestrictions$$anon$4$$anonfun$1.apply(ConcurrentRestrictions.scala:159)\n\tat sbt.CompletionService$$anon$2.call(CompletionService.scala:28)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.Executors$RunnableAdapter.call(Executors.java:511)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1142)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:617)\n\tat java.lang.Thread.run(Thread.java:748)\n"
                                                },
                                                {
                                                    "id": 3562819,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "failed",
                                                    "system_output": "java.lang.Exception: \n\tat org.specs.runner.NotifierRunner$$anonfun$reportSystem$3.apply(NotifierRunner.scala:84)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportSystem$3.apply(NotifierRunner.scala:84)\n\tat scala.collection.IndexedSeqOptimized$class.foreach(IndexedSeqOptimized.scala:33)\n\tat scala.collection.mutable.ArrayOps$ofRef.foreach(ArrayOps.scala:108)\n\tat org.specs.runner.NotifierRunner.reportSystem(NotifierRunner.scala:84)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:72)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:68)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat org.specs.runner.NotifierRunner.reportASpecification(NotifierRunner.scala:68)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:58)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:45)\n\tat org.specs.runner.Reporter$class.reportSpecs(Reporter.scala:195)\n\tat org.specs.runner.NotifierRunner.reportSpecs(NotifierRunner.scala:45)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:65)\n\tat sbt.RunnerWrapper$1.runRunner(FrameworkWrapper.java:203)\n\tat sbt.RunnerWrapper$1.execute(FrameworkWrapper.java:239)\n\tat sbt.TestRunner.runTest$1(TestFramework.scala:76)\n\tat sbt.TestRunner.run(TestFramework.scala:85)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$.sbt$TestFramework$$withContextLoader(TestFramework.scala:185)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFunction.apply(TestFramework.scala:207)\n\tat sbt.Tests$.sbt$Tests$$processRunnable$1(Tests.scala:239)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$4.work(System.scala:63)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.ErrorHandling$.wideConvert(ErrorHandling.scala:17)\n\tat sbt.Execute.work(Execute.scala:237)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.ConcurrentRestrictions$$anon$4$$anonfun$1.apply(ConcurrentRestrictions.scala:159)\n\tat sbt.CompletionService$$anon$2.call(CompletionService.scala:28)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.Executors$RunnableAdapter.call(Executors.java:511)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1142)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:617)\n\tat java.lang.Thread.run(Thread.java:748)\n"
                                                },
                                                {
                                                    "id": 3562809,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "failed",
                                                    "system_output": "java.lang.Exception: \n\tat org.specs.runner.NotifierRunner$$anonfun$reportSystem$3.apply(NotifierRunner.scala:84)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportSystem$3.apply(NotifierRunner.scala:84)\n\tat scala.collection.IndexedSeqOptimized$class.foreach(IndexedSeqOptimized.scala:33)\n\tat scala.collection.mutable.ArrayOps$ofRef.foreach(ArrayOps.scala:108)\n\tat org.specs.runner.NotifierRunner.reportSystem(NotifierRunner.scala:84)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:72)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:68)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat org.specs.runner.NotifierRunner.reportASpecification(NotifierRunner.scala:68)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:58)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:45)\n\tat org.specs.runner.Reporter$class.reportSpecs(Reporter.scala:195)\n\tat org.specs.runner.NotifierRunner.reportSpecs(NotifierRunner.scala:45)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:65)\n\tat sbt.RunnerWrapper$1.runRunner(FrameworkWrapper.java:203)\n\tat sbt.RunnerWrapper$1.execute(FrameworkWrapper.java:239)\n\tat sbt.TestRunner.runTest$1(TestFramework.scala:76)\n\tat sbt.TestRunner.run(TestFramework.scala:85)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$.sbt$TestFramework$$withContextLoader(TestFramework.scala:185)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFunction.apply(TestFramework.scala:207)\n\tat sbt.Tests$.sbt$Tests$$processRunnable$1(Tests.scala:239)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$4.work(System.scala:63)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.ErrorHandling$.wideConvert(ErrorHandling.scala:17)\n\tat sbt.Execute.work(Execute.scala:237)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.ConcurrentRestrictions$$anon$4$$anonfun$1.apply(ConcurrentRestrictions.scala:159)\n\tat sbt.CompletionService$$anon$2.call(CompletionService.scala:28)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.Executors$RunnableAdapter.call(Executors.java:511)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1142)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:617)\n\tat java.lang.Thread.run(Thread.java:748)\n"
                                                },
                                                {
                                                    "id": 3563187,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563194,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563200,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563204,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563210,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563214,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563220,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563224,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563230,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563234,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563240,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563244,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563250,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563254,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563260,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563264,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563270,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563274,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563280,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563284,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563290,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563294,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563300,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563304,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563310,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562989,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563380,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563519,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563524,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563530,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563534,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563540,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563544,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563549,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563553,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563559,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563563,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563569,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563572,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563578,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563582,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563588,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563592,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563598,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563601,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563607,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563611,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563617,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563621,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563627,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563630,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563636,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563640,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563646,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563650,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563656,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563659,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563665,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563669,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563675,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563679,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563685,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563689,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563695,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563701,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563707,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563712,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563717,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563722,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563727,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563733,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563737,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563742,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563747,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563752,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563757,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563762,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563767,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563775,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563779,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563785,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563790,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563795,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563800,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563805,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563810,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563815,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563820,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563825,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563830,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563835,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563840,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563845,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563850,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563855,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563860,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563865,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563870,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563875,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563880,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563885,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563890,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563895,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563900,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563314,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563320,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563324,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563330,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563334,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563340,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563344,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563350,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563355,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563360,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563366,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563373,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563390,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563400,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563409,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563419,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563429,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563438,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563448,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563457,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563467,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563477,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563486,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563492,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563498,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563504,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563508,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563514,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729917,
                                    "isTestReportAvailable": true,
                                    "duration": 164,
                                    "duration_inMinutes": 2.73,
                                    "created_at": "Feb-10-22",
                                    "created_at_rawDateFormat": "2022-02-10T07:05:54.580Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 467940524,
                                "gitlabId": 467940524,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729916,
                                    "isTestReportAvailable": false,
                                    "duration": 28,
                                    "duration_inMinutes": 0.47,
                                    "created_at": "Feb-10-22",
                                    "created_at_rawDateFormat": "2022-02-10T07:05:54.567Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 467929261,
                                "gitlabId": 467929261,
                                "status": "failed",
                                "testReport": {
                                    "id": 46770,
                                    "error_count": 3,
                                    "failed_count": 3,
                                    "skipped_count": 25,
                                    "success_count": 144,
                                    "total_count": 175,
                                    "total_time": -0.22,
                                    "test_suites": [
                                        {
                                            "id": 54109,
                                            "total_time": -0.22,
                                            "total_count": 175,
                                            "error_count": 3,
                                            "failed_count": 3,
                                            "name": "test-ism",
                                            "skipped_count": 25,
                                            "success_count": 144,
                                            "test_cases": [
                                                {
                                                    "id": 3555214,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555085,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555079,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555075,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555069,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555066,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555060,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555056,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555051,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555046,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555041,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555036,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555149,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555154,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555159,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555164,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555169,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555174,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555179,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555184,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555189,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555194,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555199,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555204,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555209,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555144,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555219,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555227,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555230,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555236,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555240,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555246,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555249,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555255,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555259,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555269,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555275,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555277,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555283,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555289,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555293,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555299,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555303,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555309,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555313,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555319,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555323,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555329,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555332,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555338,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555342,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555348,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555351,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555357,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555361,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555367,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555371,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555377,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555381,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555387,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555391,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555397,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555402,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555408,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555412,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555418,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555422,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555428,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555432,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555032,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555026,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555022,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555016,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555013,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555007,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555003,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554997,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554993,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554987,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554983,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554977,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "a QrCodeSpec should",
                                                    "status": "failed",
                                                    "system_output": "java.lang.Exception: \n\tat org.specs.runner.NotifierRunner$$anonfun$reportSystem$3.apply(NotifierRunner.scala:84)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportSystem$3.apply(NotifierRunner.scala:84)\n\tat scala.collection.IndexedSeqOptimized$class.foreach(IndexedSeqOptimized.scala:33)\n\tat scala.collection.mutable.ArrayOps$ofRef.foreach(ArrayOps.scala:108)\n\tat org.specs.runner.NotifierRunner.reportSystem(NotifierRunner.scala:84)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:72)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:68)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat org.specs.runner.NotifierRunner.reportASpecification(NotifierRunner.scala:68)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:58)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:45)\n\tat org.specs.runner.Reporter$class.reportSpecs(Reporter.scala:195)\n\tat org.specs.runner.NotifierRunner.reportSpecs(NotifierRunner.scala:45)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:65)\n\tat sbt.RunnerWrapper$1.runRunner(FrameworkWrapper.java:203)\n\tat sbt.RunnerWrapper$1.execute(FrameworkWrapper.java:239)\n\tat sbt.TestRunner.runTest$1(TestFramework.scala:76)\n\tat sbt.TestRunner.run(TestFramework.scala:85)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$.sbt$TestFramework$$withContextLoader(TestFramework.scala:185)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFunction.apply(TestFramework.scala:207)\n\tat sbt.Tests$.sbt$Tests$$processRunnable$1(Tests.scala:239)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$4.work(System.scala:63)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.ErrorHandling$.wideConvert(ErrorHandling.scala:17)\n\tat sbt.Execute.work(Execute.scala:237)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.ConcurrentRestrictions$$anon$4$$anonfun$1.apply(ConcurrentRestrictions.scala:159)\n\tat sbt.CompletionService$$anon$2.call(CompletionService.scala:28)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.Executors$RunnableAdapter.call(Executors.java:511)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1142)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:617)\n\tat java.lang.Thread.run(Thread.java:748)\n"
                                                },
                                                {
                                                    "id": 3554973,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "failed",
                                                    "system_output": "java.lang.Exception: \n\tat org.specs.runner.NotifierRunner$$anonfun$reportSystem$3.apply(NotifierRunner.scala:84)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportSystem$3.apply(NotifierRunner.scala:84)\n\tat scala.collection.IndexedSeqOptimized$class.foreach(IndexedSeqOptimized.scala:33)\n\tat scala.collection.mutable.ArrayOps$ofRef.foreach(ArrayOps.scala:108)\n\tat org.specs.runner.NotifierRunner.reportSystem(NotifierRunner.scala:84)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:72)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:68)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat org.specs.runner.NotifierRunner.reportASpecification(NotifierRunner.scala:68)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:58)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:45)\n\tat org.specs.runner.Reporter$class.reportSpecs(Reporter.scala:195)\n\tat org.specs.runner.NotifierRunner.reportSpecs(NotifierRunner.scala:45)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:65)\n\tat sbt.RunnerWrapper$1.runRunner(FrameworkWrapper.java:203)\n\tat sbt.RunnerWrapper$1.execute(FrameworkWrapper.java:239)\n\tat sbt.TestRunner.runTest$1(TestFramework.scala:76)\n\tat sbt.TestRunner.run(TestFramework.scala:85)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$.sbt$TestFramework$$withContextLoader(TestFramework.scala:185)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFunction.apply(TestFramework.scala:207)\n\tat sbt.Tests$.sbt$Tests$$processRunnable$1(Tests.scala:239)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$4.work(System.scala:63)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.ErrorHandling$.wideConvert(ErrorHandling.scala:17)\n\tat sbt.Execute.work(Execute.scala:237)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.ConcurrentRestrictions$$anon$4$$anonfun$1.apply(ConcurrentRestrictions.scala:159)\n\tat sbt.CompletionService$$anon$2.call(CompletionService.scala:28)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.Executors$RunnableAdapter.call(Executors.java:511)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1142)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:617)\n\tat java.lang.Thread.run(Thread.java:748)\n"
                                                },
                                                {
                                                    "id": 3555438,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555442,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555448,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555452,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555458,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555462,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555468,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555472,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555478,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555482,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555488,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555492,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555498,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555502,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555508,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555512,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555518,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555523,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555528,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555534,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555540,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555546,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555550,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555556,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555560,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555569,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555579,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555588,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555598,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555608,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555617,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555627,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555637,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555646,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555656,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555665,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555675,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555684,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555694,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555703,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555713,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555722,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555728,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555732,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555738,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555742,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555748,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555752,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555758,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555762,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555768,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555772,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555778,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555782,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555788,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555792,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555798,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555802,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555808,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554967,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "failed",
                                                    "system_output": "java.lang.Exception: \n\tat org.specs.runner.NotifierRunner$$anonfun$reportSystem$3.apply(NotifierRunner.scala:84)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportSystem$3.apply(NotifierRunner.scala:84)\n\tat scala.collection.IndexedSeqOptimized$class.foreach(IndexedSeqOptimized.scala:33)\n\tat scala.collection.mutable.ArrayOps$ofRef.foreach(ArrayOps.scala:108)\n\tat org.specs.runner.NotifierRunner.reportSystem(NotifierRunner.scala:84)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:72)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:68)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat org.specs.runner.NotifierRunner.reportASpecification(NotifierRunner.scala:68)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:58)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:45)\n\tat org.specs.runner.Reporter$class.reportSpecs(Reporter.scala:195)\n\tat org.specs.runner.NotifierRunner.reportSpecs(NotifierRunner.scala:45)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:65)\n\tat sbt.RunnerWrapper$1.runRunner(FrameworkWrapper.java:203)\n\tat sbt.RunnerWrapper$1.execute(FrameworkWrapper.java:239)\n\tat sbt.TestRunner.runTest$1(TestFramework.scala:76)\n\tat sbt.TestRunner.run(TestFramework.scala:85)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$.sbt$TestFramework$$withContextLoader(TestFramework.scala:185)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFunction.apply(TestFramework.scala:207)\n\tat sbt.Tests$.sbt$Tests$$processRunnable$1(Tests.scala:239)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$4.work(System.scala:63)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.ErrorHandling$.wideConvert(ErrorHandling.scala:17)\n\tat sbt.Execute.work(Execute.scala:237)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.ConcurrentRestrictions$$anon$4$$anonfun$1.apply(ConcurrentRestrictions.scala:159)\n\tat sbt.CompletionService$$anon$2.call(CompletionService.scala:28)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.Executors$RunnableAdapter.call(Executors.java:511)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1142)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:617)\n\tat java.lang.Thread.run(Thread.java:748)\n"
                                                },
                                                {
                                                    "id": 3554963,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdf with QR code",
                                                    "status": "error",
                                                    "system_output": "java.awt.AWTError: Can't connect to X11 window server using ':99.0' as the value of the DISPLAY variable.\n\tat sun.awt.X11GraphicsEnvironment.initDisplay(Native Method)\n\tat sun.awt.X11GraphicsEnvironment.access$200(X11GraphicsEnvironment.java:65)\n\tat sun.awt.X11GraphicsEnvironment$1.run(X11GraphicsEnvironment.java:115)\n\tat java.security.AccessController.doPrivileged(Native Method)\n\tat sun.awt.X11GraphicsEnvironment.<clinit>(X11GraphicsEnvironment.java:74)\n\tat java.lang.Class.forName0(Native Method)\n\tat java.lang.Class.forName(Class.java:264)\n\tat java.awt.GraphicsEnvironment.createGE(GraphicsEnvironment.java:103)\n\tat java.awt.GraphicsEnvironment.getLocalGraphicsEnvironment(GraphicsEnvironment.java:82)\n\tat sun.awt.X11FontManager.isHeadless(X11FontManager.java:509)\n\tat sun.awt.X11FontManager.getFontPath(X11FontManager.java:786)\n\tat sun.font.SunFontManager.getPlatformFontPath(SunFontManager.java:3282)\n\tat sun.font.SunFontManager$10.run(SunFontManager.java:3308)\n\tat java.security.AccessController.doPrivileged(Native Method)\n\tat sun.font.SunFontManager.loadFonts(SunFontManager.java:3304)\n\tat sun.awt.X11FontManager.loadFonts(X11FontManager.java:460)\n\tat sun.font.SunFontManager.findFont2D(SunFontManager.java:2348)\n\tat java.awt.Font.getFont2D(Font.java:500)\n\tat java.awt.Font.getFamily(Font.java:1220)\n\tat java.awt.Font.getFamily_NoClientCode(Font.java:1194)\n\tat java.awt.Font.getFamily(Font.java:1186)\n\tat net.codecrete.qrbill.canvas.PNGCanvas.findFontFamily(PNGCanvas.java:111)\n\tat net.codecrete.qrbill.canvas.PNGCanvas.<init>(PNGCanvas.java:74)\n\tat net.codecrete.qrbill.generator.QRBill.createCanvas(QRBill.java:297)\n\tat net.codecrete.qrbill.generator.QRBill.generate(QRBill.java:128)\n\tat ch.petag.pdf.InpaymentSlipQRRenderer.render(InpaymentSlipQRRenderer.scala:66)\n\tat ch.petag.pdf.InpaymentSlipQRPdfGenerator.writeTo(InpaymentSlipQRPdfGenerator.scala:31)\n\tat ch.petag.pdf.InpaymentSlipQRPdfGenerator.writeTo(InpaymentSlipQRPdfGenerator.scala:20)\n\tat ch.petag.pdf.QrCodeSpec$$anonfun$1$$anonfun$apply$1.apply$mcV$sp(QrCodeSpec.scala:13)\n\tat ch.petag.pdf.QrCodeSpec$$anonfun$1$$anonfun$apply$1.apply(QrCodeSpec.scala:11)\n\tat ch.petag.pdf.QrCodeSpec$$anonfun$1$$anonfun$apply$1.apply(QrCodeSpec.scala:11)\n\tat org.specs.specification.LifeCycle$class.withCurrent(ExampleLifeCycle.scala:66)\n\tat org.specs.specification.Examples.withCurrent(Examples.scala:52)\n\tat org.specs.specification.Examples$$anonfun$specifyExample$1.apply(Examples.scala:114)\n\tat org.specs.specification.Examples$$anonfun$specifyExample$1.apply(Examples.scala:114)\n\tat org.specs.specification.ExampleExecution$$anonfun$3$$anonfun$apply$5.apply(ExampleLifeCycle.scala:219)\n\tat scala.Option.getOrElse(Option.scala:120)\n\tat org.specs.specification.LifeCycle$class.executeExpectations(ExampleLifeCycle.scala:90)\n\tat org.specs.specification.BaseSpecification.executeExpectations(BaseSpecification.scala:58)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$class.id$1(ExampleContext.scala:32)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$class.executeExpectations(ExampleContext.scala:80)\n\tat org.specs.specification.Examples.executeExpectations(Examples.scala:52)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$class.id$1(ExampleContext.scala:32)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$class.executeExpectations(ExampleContext.scala:80)\n\tat org.specs.specification.Examples.executeExpectations(Examples.scala:52)\n\tat org.specs.specification.ExampleExecution$$anonfun$3.apply(ExampleLifeCycle.scala:219)\n\tat org.specs.specification.ExampleExecution$$anonfun$3.apply(ExampleLifeCycle.scala:198)\n\tat org.specs.specification.ExampleExecution$$anonfun$2.apply(ExampleLifeCycle.scala:181)\n\tat org.specs.specification.ExampleExecution.execute(ExampleLifeCycle.scala:252)\n\tat org.specs.specification.SpecificationExecutor$$anonfun$executeExample$3.apply(SpecificationExecutor.scala:70)\n\tat org.specs.specification.SpecificationExecutor$$anonfun$executeExample$3.apply(SpecificationExecutor.scala:70)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.SpecificationExecutor$class.executeExample(SpecificationExecutor.scala:70)\n\tat org.specs.specification.BaseSpecification.executeExample(BaseSpecification.scala:58)\n\tat org.specs.specification.BaseSpecification.executeExample(BaseSpecification.scala:58)\n\tat org.specs.specification.ExampleLifeCycle$$anonfun$executeExample$1.apply(ExampleLifeCycle.scala:125)\n\tat org.specs.specification.ExampleLifeCycle$$anonfun$executeExample$1.apply(ExampleLifeCycle.scala:125)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleLifeCycle$class.executeExample(ExampleLifeCycle.scala:125)\n\tat org.specs.specification.Examples.executeExample(Examples.scala:52)\n\tat org.specs.specification.Examples.executeExample(Examples.scala:52)\n\tat org.specs.specification.Examples$$anonfun$executeExamples$2.apply(Examples.scala:80)\n\tat org.specs.specification.Examples$$anonfun$executeExamples$2.apply(Examples.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.Examples.executeExamples(Examples.scala:80)\n\tat org.specs.specification.ExampleStructure$class.ownFailures(ExampleStructure.scala:58)\n\tat org.specs.specification.Examples.ownFailures(Examples.scala:52)\n\tat org.specs.specification.ExampleStructure$class.failures(ExampleStructure.scala:64)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.specification.ExampleStructure$$anonfun$failures$1.apply(ExampleStructure.scala:64)\n\tat org.specs.specification.ExampleStructure$$anonfun$failures$1.apply(ExampleStructure.scala:64)\n\tat scala.collection.TraversableLike$$anonfun$flatMap$1.apply(TraversableLike.scala:251)\n\tat scala.collection.TraversableLike$$anonfun$flatMap$1.apply(TraversableLike.scala:251)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat scala.collection.TraversableLike$class.flatMap(TraversableLike.scala:251)\n\tat scala.collection.AbstractTraversable.flatMap(Traversable.scala:105)\n\tat org.specs.specification.ExampleStructure$class.failures(ExampleStructure.scala:64)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.execute.HasResults$class.failureAndErrors(HasResults.scala:61)\n\tat org.specs.specification.Examples.failureAndErrors(Examples.scala:52)\n\tat org.specs.execute.HasResults$class.isOk(HasResults.scala:69)\n\tat org.specs.specification.Examples.isOk(Examples.scala:52)\n\tat org.specs.runner.NotifierRunner.reportSystem(NotifierRunner.scala:81)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:72)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:68)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat org.specs.runner.NotifierRunner.reportASpecification(NotifierRunner.scala:68)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:58)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:45)\n\tat org.specs.runner.Reporter$class.reportSpecs(Reporter.scala:195)\n\tat org.specs.runner.NotifierRunner.reportSpecs(NotifierRunner.scala:45)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:65)\n\tat sbt.RunnerWrapper$1.runRunner(FrameworkWrapper.java:203)\n\tat sbt.RunnerWrapper$1.execute(FrameworkWrapper.java:239)\n\tat sbt.TestRunner.runTest$1(TestFramework.scala:76)\n\tat sbt.TestRunner.run(TestFramework.scala:85)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$.sbt$TestFramework$$withContextLoader(TestFramework.scala:185)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFunction.apply(TestFramework.scala:207)\n\tat sbt.Tests$.sbt$Tests$$processRunnable$1(Tests.scala:239)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$4.work(System.scala:63)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.ErrorHandling$.wideConvert(ErrorHandling.scala:17)\n\tat sbt.Execute.work(Execute.scala:237)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.ConcurrentRestrictions$$anon$4$$anonfun$1.apply(ConcurrentRestrictions.scala:159)\n\tat sbt.CompletionService$$anon$2.call(CompletionService.scala:28)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.Executors$RunnableAdapter.call(Executors.java:511)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1142)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:617)\n\tat java.lang.Thread.run(Thread.java:748)\n"
                                                },
                                                {
                                                    "id": 3554957,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "error",
                                                    "system_output": "java.lang.NoClassDefFoundError: Could not initialize class sun.awt.X11GraphicsEnvironment\n\tat java.lang.Class.forName0(Native Method)\n\tat java.lang.Class.forName(Class.java:264)\n\tat java.awt.GraphicsEnvironment.createGE(GraphicsEnvironment.java:103)\n\tat java.awt.GraphicsEnvironment.getLocalGraphicsEnvironment(GraphicsEnvironment.java:82)\n\tat sun.awt.X11FontManager.isHeadless(X11FontManager.java:509)\n\tat sun.awt.X11FontManager.getFontPath(X11FontManager.java:786)\n\tat sun.font.SunFontManager.getPlatformFontPath(SunFontManager.java:3282)\n\tat sun.font.SunFontManager$10.run(SunFontManager.java:3308)\n\tat java.security.AccessController.doPrivileged(Native Method)\n\tat sun.font.SunFontManager.loadFonts(SunFontManager.java:3304)\n\tat sun.awt.X11FontManager.loadFonts(X11FontManager.java:460)\n\tat sun.font.SunFontManager.findFont2D(SunFontManager.java:2348)\n\tat java.awt.Font.getFont2D(Font.java:500)\n\tat java.awt.Font.getFamily(Font.java:1220)\n\tat java.awt.Font.getFamily_NoClientCode(Font.java:1194)\n\tat java.awt.Font.getFamily(Font.java:1186)\n\tat net.codecrete.qrbill.canvas.PNGCanvas.findFontFamily(PNGCanvas.java:111)\n\tat net.codecrete.qrbill.canvas.PNGCanvas.<init>(PNGCanvas.java:74)\n\tat net.codecrete.qrbill.generator.QRBill.createCanvas(QRBill.java:297)\n\tat net.codecrete.qrbill.generator.QRBill.generate(QRBill.java:128)\n\tat ch.petag.pdf.InpaymentSlipQRRenderer.render(InpaymentSlipQRRenderer.scala:66)\n\tat ch.petag.pdf.InpaymentSlipQRPdfGenerator.writeTo(InpaymentSlipQRPdfGenerator.scala:31)\n\tat ch.petag.pdf.PrepayInvoicePdfGenerator.createPdf(PrepayInvoicePdfGenerator.scala:52)\n\tat ch.petag.pdf.PrePayInvoicePdfGeneratorSpec$$anonfun$1$$anonfun$apply$3.apply$mcV$sp(PrePayInvoicePdfGeneratorSpec.scala:58)\n\tat ch.petag.pdf.PrePayInvoicePdfGeneratorSpec$$anonfun$1$$anonfun$apply$3.apply(PrePayInvoicePdfGeneratorSpec.scala:42)\n\tat ch.petag.pdf.PrePayInvoicePdfGeneratorSpec$$anonfun$1$$anonfun$apply$3.apply(PrePayInvoicePdfGeneratorSpec.scala:42)\n\tat org.specs.specification.LifeCycle$class.withCurrent(ExampleLifeCycle.scala:66)\n\tat org.specs.specification.Examples.withCurrent(Examples.scala:52)\n\tat org.specs.specification.Examples$$anonfun$specifyExample$1.apply(Examples.scala:114)\n\tat org.specs.specification.Examples$$anonfun$specifyExample$1.apply(Examples.scala:114)\n\tat org.specs.specification.ExampleExecution$$anonfun$3$$anonfun$apply$5.apply(ExampleLifeCycle.scala:219)\n\tat scala.Option.getOrElse(Option.scala:120)\n\tat org.specs.specification.LifeCycle$class.executeExpectations(ExampleLifeCycle.scala:90)\n\tat org.specs.specification.BaseSpecification.executeExpectations(BaseSpecification.scala:58)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$class.id$1(ExampleContext.scala:32)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$class.executeExpectations(ExampleContext.scala:80)\n\tat org.specs.specification.Examples.executeExpectations(Examples.scala:52)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$class.id$1(ExampleContext.scala:32)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$class.executeExpectations(ExampleContext.scala:80)\n\tat org.specs.specification.Examples.executeExpectations(Examples.scala:52)\n\tat org.specs.specification.ExampleExecution$$anonfun$3.apply(ExampleLifeCycle.scala:219)\n\tat org.specs.specification.ExampleExecution$$anonfun$3.apply(ExampleLifeCycle.scala:198)\n\tat org.specs.specification.ExampleExecution$$anonfun$2.apply(ExampleLifeCycle.scala:181)\n\tat org.specs.specification.ExampleExecution.execute(ExampleLifeCycle.scala:252)\n\tat org.specs.specification.SpecificationExecutor$$anonfun$executeExample$3.apply(SpecificationExecutor.scala:70)\n\tat org.specs.specification.SpecificationExecutor$$anonfun$executeExample$3.apply(SpecificationExecutor.scala:70)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.SpecificationExecutor$class.executeExample(SpecificationExecutor.scala:70)\n\tat org.specs.specification.BaseSpecification.executeExample(BaseSpecification.scala:58)\n\tat org.specs.specification.BaseSpecification.executeExample(BaseSpecification.scala:58)\n\tat org.specs.specification.ExampleLifeCycle$$anonfun$executeExample$1.apply(ExampleLifeCycle.scala:125)\n\tat org.specs.specification.ExampleLifeCycle$$anonfun$executeExample$1.apply(ExampleLifeCycle.scala:125)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleLifeCycle$class.executeExample(ExampleLifeCycle.scala:125)\n\tat org.specs.specification.Examples.executeExample(Examples.scala:52)\n\tat org.specs.specification.Examples.executeExample(Examples.scala:52)\n\tat org.specs.specification.Examples$$anonfun$executeExamples$2.apply(Examples.scala:80)\n\tat org.specs.specification.Examples$$anonfun$executeExamples$2.apply(Examples.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.Examples.executeExamples(Examples.scala:80)\n\tat org.specs.specification.ExampleStructure$class.ownFailures(ExampleStructure.scala:58)\n\tat org.specs.specification.Examples.ownFailures(Examples.scala:52)\n\tat org.specs.specification.ExampleStructure$class.failures(ExampleStructure.scala:64)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.specification.ExampleStructure$$anonfun$failures$1.apply(ExampleStructure.scala:64)\n\tat org.specs.specification.ExampleStructure$$anonfun$failures$1.apply(ExampleStructure.scala:64)\n\tat scala.collection.TraversableLike$$anonfun$flatMap$1.apply(TraversableLike.scala:251)\n\tat scala.collection.TraversableLike$$anonfun$flatMap$1.apply(TraversableLike.scala:251)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat scala.collection.TraversableLike$class.flatMap(TraversableLike.scala:251)\n\tat scala.collection.AbstractTraversable.flatMap(Traversable.scala:105)\n\tat org.specs.specification.ExampleStructure$class.failures(ExampleStructure.scala:64)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.execute.HasResults$class.failureAndErrors(HasResults.scala:61)\n\tat org.specs.specification.Examples.failureAndErrors(Examples.scala:52)\n\tat org.specs.execute.HasResults$class.isOk(HasResults.scala:69)\n\tat org.specs.specification.Examples.isOk(Examples.scala:52)\n\tat org.specs.runner.NotifierRunner.reportSystem(NotifierRunner.scala:81)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:72)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:68)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat org.specs.runner.NotifierRunner.reportASpecification(NotifierRunner.scala:68)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:58)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:45)\n\tat org.specs.runner.Reporter$class.reportSpecs(Reporter.scala:195)\n\tat org.specs.runner.NotifierRunner.reportSpecs(NotifierRunner.scala:45)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:65)\n\tat sbt.RunnerWrapper$1.runRunner(FrameworkWrapper.java:203)\n\tat sbt.RunnerWrapper$1.execute(FrameworkWrapper.java:239)\n\tat sbt.TestRunner.runTest$1(TestFramework.scala:76)\n\tat sbt.TestRunner.run(TestFramework.scala:85)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$.sbt$TestFramework$$withContextLoader(TestFramework.scala:185)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFunction.apply(TestFramework.scala:207)\n\tat sbt.Tests$.sbt$Tests$$processRunnable$1(Tests.scala:239)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$4.work(System.scala:63)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.ErrorHandling$.wideConvert(ErrorHandling.scala:17)\n\tat sbt.Execute.work(Execute.scala:237)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.ConcurrentRestrictions$$anon$4$$anonfun$1.apply(ConcurrentRestrictions.scala:159)\n\tat sbt.CompletionService$$anon$2.call(CompletionService.scala:28)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.Executors$RunnableAdapter.call(Executors.java:511)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1142)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:617)\n\tat java.lang.Thread.run(Thread.java:748)\n"
                                                },
                                                {
                                                    "id": 3554953,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "error",
                                                    "system_output": "java.lang.NoClassDefFoundError: Could not initialize class sun.awt.X11GraphicsEnvironment\n\tat java.lang.Class.forName0(Native Method)\n\tat java.lang.Class.forName(Class.java:264)\n\tat java.awt.GraphicsEnvironment.createGE(GraphicsEnvironment.java:103)\n\tat java.awt.GraphicsEnvironment.getLocalGraphicsEnvironment(GraphicsEnvironment.java:82)\n\tat sun.awt.X11FontManager.isHeadless(X11FontManager.java:509)\n\tat sun.awt.X11FontManager.getFontPath(X11FontManager.java:786)\n\tat sun.font.SunFontManager.getPlatformFontPath(SunFontManager.java:3282)\n\tat sun.font.SunFontManager$10.run(SunFontManager.java:3308)\n\tat java.security.AccessController.doPrivileged(Native Method)\n\tat sun.font.SunFontManager.loadFonts(SunFontManager.java:3304)\n\tat sun.awt.X11FontManager.loadFonts(X11FontManager.java:460)\n\tat sun.font.SunFontManager.findFont2D(SunFontManager.java:2348)\n\tat java.awt.Font.getFont2D(Font.java:500)\n\tat java.awt.Font.getFamily(Font.java:1220)\n\tat java.awt.Font.getFamily_NoClientCode(Font.java:1194)\n\tat java.awt.Font.getFamily(Font.java:1186)\n\tat net.codecrete.qrbill.canvas.PNGCanvas.findFontFamily(PNGCanvas.java:111)\n\tat net.codecrete.qrbill.canvas.PNGCanvas.<init>(PNGCanvas.java:74)\n\tat net.codecrete.qrbill.generator.QRBill.createCanvas(QRBill.java:297)\n\tat net.codecrete.qrbill.generator.QRBill.generate(QRBill.java:128)\n\tat ch.petag.pdf.InpaymentSlipQRRenderer.render(InpaymentSlipQRRenderer.scala:66)\n\tat ch.petag.pdf.InpaymentSlipQRPdfGenerator.writeTo(InpaymentSlipQRPdfGenerator.scala:31)\n\tat ch.petag.pdf.InpaymentSlipQRPdfGenerator.writeTo(InpaymentSlipQRPdfGenerator.scala:20)\n\tat ch.petag.db.finance.InpaymentSlipSpec$$anonfun$1$$anonfun$apply$mcV$sp$2$$anonfun$apply$mcV$sp$5.apply(InpaymentSlipSpec.scala:45)\n\tat ch.petag.db.finance.InpaymentSlipSpec$$anonfun$1$$anonfun$apply$mcV$sp$2$$anonfun$apply$mcV$sp$5.apply(InpaymentSlipSpec.scala:41)\n\tat ch.petag.db.invoice.util.DBTestTrait$$anon$1.dbm(DBTestTrait.scala:12)\n\tat jdbt.runtime.Transaction.dbt(Transaction.java:162)\n\tat jdbt.runtime.Transaction.dbt(Transaction.java:251)\n\tat ch.petag.db.invoice.util.DBTestTrait$class.openSqlConnectionAndExecute(DBTestTrait.scala:14)\n\tat ch.petag.db.finance.InpaymentSlipSpec.openSqlConnectionAndExecute(InpaymentSlipSpec.scala:13)\n\tat ch.petag.db.finance.InpaymentSlipSpec$$anonfun$1$$anonfun$apply$mcV$sp$2.apply$mcV$sp(InpaymentSlipSpec.scala:41)\n\tat ch.petag.db.finance.InpaymentSlipSpec$$anonfun$1$$anonfun$apply$mcV$sp$2.apply(InpaymentSlipSpec.scala:22)\n\tat ch.petag.db.finance.InpaymentSlipSpec$$anonfun$1$$anonfun$apply$mcV$sp$2.apply(InpaymentSlipSpec.scala:22)\n\tat org.specs.specification.LifeCycle$class.withCurrent(ExampleLifeCycle.scala:66)\n\tat org.specs.specification.Examples.withCurrent(Examples.scala:52)\n\tat org.specs.specification.Examples$$anonfun$specifyExample$1.apply(Examples.scala:114)\n\tat org.specs.specification.Examples$$anonfun$specifyExample$1.apply(Examples.scala:114)\n\tat org.specs.specification.ExampleExecution$$anonfun$3$$anonfun$apply$5.apply(ExampleLifeCycle.scala:219)\n\tat scala.Option.getOrElse(Option.scala:120)\n\tat org.specs.specification.LifeCycle$class.executeExpectations(ExampleLifeCycle.scala:90)\n\tat org.specs.specification.BaseSpecification.executeExpectations(BaseSpecification.scala:58)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$class.id$1(ExampleContext.scala:32)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$class.executeExpectations(ExampleContext.scala:80)\n\tat org.specs.specification.Examples.executeExpectations(Examples.scala:52)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$class.id$1(ExampleContext.scala:32)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$class.executeExpectations(ExampleContext.scala:80)\n\tat org.specs.specification.Examples.executeExpectations(Examples.scala:52)\n\tat org.specs.specification.ExampleExecution$$anonfun$3.apply(ExampleLifeCycle.scala:219)\n\tat org.specs.specification.ExampleExecution$$anonfun$3.apply(ExampleLifeCycle.scala:198)\n\tat org.specs.specification.ExampleExecution$$anonfun$2.apply(ExampleLifeCycle.scala:181)\n\tat org.specs.specification.ExampleExecution.execute(ExampleLifeCycle.scala:252)\n\tat org.specs.specification.SpecificationExecutor$$anonfun$executeExample$3.apply(SpecificationExecutor.scala:70)\n\tat org.specs.specification.SpecificationExecutor$$anonfun$executeExample$3.apply(SpecificationExecutor.scala:70)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.SpecificationExecutor$class.executeExample(SpecificationExecutor.scala:70)\n\tat org.specs.specification.BaseSpecification.executeExample(BaseSpecification.scala:58)\n\tat org.specs.specification.BaseSpecification.executeExample(BaseSpecification.scala:58)\n\tat org.specs.specification.ExampleLifeCycle$$anonfun$executeExample$1.apply(ExampleLifeCycle.scala:125)\n\tat org.specs.specification.ExampleLifeCycle$$anonfun$executeExample$1.apply(ExampleLifeCycle.scala:125)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleLifeCycle$class.executeExample(ExampleLifeCycle.scala:125)\n\tat org.specs.specification.Examples.executeExample(Examples.scala:52)\n\tat org.specs.specification.Examples.executeExample(Examples.scala:52)\n\tat org.specs.specification.Examples$$anonfun$executeExamples$2.apply(Examples.scala:80)\n\tat org.specs.specification.Examples$$anonfun$executeExamples$2.apply(Examples.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.Examples.executeExamples(Examples.scala:80)\n\tat org.specs.specification.ExampleStructure$class.ownFailures(ExampleStructure.scala:58)\n\tat org.specs.specification.Examples.ownFailures(Examples.scala:52)\n\tat org.specs.specification.ExampleStructure$class.failures(ExampleStructure.scala:64)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.specification.ExampleStructure$$anonfun$failures$1.apply(ExampleStructure.scala:64)\n\tat org.specs.specification.ExampleStructure$$anonfun$failures$1.apply(ExampleStructure.scala:64)\n\tat scala.collection.TraversableLike$$anonfun$flatMap$1.apply(TraversableLike.scala:251)\n\tat scala.collection.TraversableLike$$anonfun$flatMap$1.apply(TraversableLike.scala:251)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat scala.collection.TraversableLike$class.flatMap(TraversableLike.scala:251)\n\tat scala.collection.AbstractTraversable.flatMap(Traversable.scala:105)\n\tat org.specs.specification.ExampleStructure$class.failures(ExampleStructure.scala:64)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.execute.HasResults$class.failureAndErrors(HasResults.scala:61)\n\tat org.specs.specification.Examples.failureAndErrors(Examples.scala:52)\n\tat org.specs.execute.HasResults$class.isOk(HasResults.scala:69)\n\tat org.specs.specification.Examples.isOk(Examples.scala:52)\n\tat org.specs.runner.NotifierRunner.reportSystem(NotifierRunner.scala:81)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:72)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:68)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat org.specs.runner.NotifierRunner.reportASpecification(NotifierRunner.scala:68)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:58)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:45)\n\tat org.specs.runner.Reporter$class.reportSpecs(Reporter.scala:195)\n\tat org.specs.runner.NotifierRunner.reportSpecs(NotifierRunner.scala:45)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:65)\n\tat sbt.RunnerWrapper$1.runRunner(FrameworkWrapper.java:203)\n\tat sbt.RunnerWrapper$1.execute(FrameworkWrapper.java:239)\n\tat sbt.TestRunner.runTest$1(TestFramework.scala:76)\n\tat sbt.TestRunner.run(TestFramework.scala:85)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$.sbt$TestFramework$$withContextLoader(TestFramework.scala:185)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFunction.apply(TestFramework.scala:207)\n\tat sbt.Tests$.sbt$Tests$$processRunnable$1(Tests.scala:239)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$4.work(System.scala:63)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.ErrorHandling$.wideConvert(ErrorHandling.scala:17)\n\tat sbt.Execute.work(Execute.scala:237)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.ConcurrentRestrictions$$anon$4$$anonfun$1.apply(ConcurrentRestrictions.scala:159)\n\tat sbt.CompletionService$$anon$2.call(CompletionService.scala:28)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.Executors$RunnableAdapter.call(Executors.java:511)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1142)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:617)\n\tat java.lang.Thread.run(Thread.java:748)\n"
                                                },
                                                {
                                                    "id": 3555089,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555812,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555818,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555822,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555828,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555833,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555838,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555843,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555848,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555852,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555857,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555862,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555867,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555872,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555877,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555886,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555896,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555906,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555915,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555925,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555094,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555099,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555104,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555109,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555114,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555119,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555124,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555129,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555134,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555139,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729918,
                                    "isTestReportAvailable": true,
                                    "duration": 164,
                                    "duration_inMinutes": 2.73,
                                    "created_at": "Feb-10-22",
                                    "created_at_rawDateFormat": "2022-02-10T07:05:54.640Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 467903577,
                                "gitlabId": 467903577,
                                "status": "failed",
                                "testReport": {
                                    "id": 46774,
                                    "error_count": 3,
                                    "failed_count": 3,
                                    "skipped_count": 25,
                                    "success_count": 144,
                                    "total_count": 175,
                                    "total_time": -0.22,
                                    "test_suites": [
                                        {
                                            "id": 54108,
                                            "total_time": -0.22,
                                            "total_count": 175,
                                            "error_count": 3,
                                            "failed_count": 3,
                                            "name": "test-ism",
                                            "skipped_count": 25,
                                            "success_count": 144,
                                            "test_cases": [
                                                {
                                                    "id": 3555834,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555844,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555854,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555863,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555873,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555881,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555887,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555891,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555897,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555575,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555571,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555565,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555559,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554942,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "a QrCodeSpec should",
                                                    "status": "failed",
                                                    "system_output": "java.lang.Exception: \n\tat org.specs.runner.NotifierRunner$$anonfun$reportSystem$3.apply(NotifierRunner.scala:84)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportSystem$3.apply(NotifierRunner.scala:84)\n\tat scala.collection.IndexedSeqOptimized$class.foreach(IndexedSeqOptimized.scala:33)\n\tat scala.collection.mutable.ArrayOps$ofRef.foreach(ArrayOps.scala:108)\n\tat org.specs.runner.NotifierRunner.reportSystem(NotifierRunner.scala:84)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:72)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:68)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat org.specs.runner.NotifierRunner.reportASpecification(NotifierRunner.scala:68)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:58)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:45)\n\tat org.specs.runner.Reporter$class.reportSpecs(Reporter.scala:195)\n\tat org.specs.runner.NotifierRunner.reportSpecs(NotifierRunner.scala:45)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:65)\n\tat sbt.RunnerWrapper$1.runRunner(FrameworkWrapper.java:203)\n\tat sbt.RunnerWrapper$1.execute(FrameworkWrapper.java:239)\n\tat sbt.TestRunner.runTest$1(TestFramework.scala:76)\n\tat sbt.TestRunner.run(TestFramework.scala:85)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$.sbt$TestFramework$$withContextLoader(TestFramework.scala:185)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFunction.apply(TestFramework.scala:207)\n\tat sbt.Tests$.sbt$Tests$$processRunnable$1(Tests.scala:239)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$4.work(System.scala:63)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.ErrorHandling$.wideConvert(ErrorHandling.scala:17)\n\tat sbt.Execute.work(Execute.scala:237)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.ConcurrentRestrictions$$anon$4$$anonfun$1.apply(ConcurrentRestrictions.scala:159)\n\tat sbt.CompletionService$$anon$2.call(CompletionService.scala:28)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.Executors$RunnableAdapter.call(Executors.java:511)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1142)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:617)\n\tat java.lang.Thread.run(Thread.java:748)\n"
                                                },
                                                {
                                                    "id": 3554936,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "failed",
                                                    "system_output": "java.lang.Exception: \n\tat org.specs.runner.NotifierRunner$$anonfun$reportSystem$3.apply(NotifierRunner.scala:84)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportSystem$3.apply(NotifierRunner.scala:84)\n\tat scala.collection.IndexedSeqOptimized$class.foreach(IndexedSeqOptimized.scala:33)\n\tat scala.collection.mutable.ArrayOps$ofRef.foreach(ArrayOps.scala:108)\n\tat org.specs.runner.NotifierRunner.reportSystem(NotifierRunner.scala:84)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:72)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:68)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat org.specs.runner.NotifierRunner.reportASpecification(NotifierRunner.scala:68)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:58)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:45)\n\tat org.specs.runner.Reporter$class.reportSpecs(Reporter.scala:195)\n\tat org.specs.runner.NotifierRunner.reportSpecs(NotifierRunner.scala:45)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:65)\n\tat sbt.RunnerWrapper$1.runRunner(FrameworkWrapper.java:203)\n\tat sbt.RunnerWrapper$1.execute(FrameworkWrapper.java:239)\n\tat sbt.TestRunner.runTest$1(TestFramework.scala:76)\n\tat sbt.TestRunner.run(TestFramework.scala:85)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$.sbt$TestFramework$$withContextLoader(TestFramework.scala:185)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFunction.apply(TestFramework.scala:207)\n\tat sbt.Tests$.sbt$Tests$$processRunnable$1(Tests.scala:239)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$4.work(System.scala:63)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.ErrorHandling$.wideConvert(ErrorHandling.scala:17)\n\tat sbt.Execute.work(Execute.scala:237)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.ConcurrentRestrictions$$anon$4$$anonfun$1.apply(ConcurrentRestrictions.scala:159)\n\tat sbt.CompletionService$$anon$2.call(CompletionService.scala:28)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.Executors$RunnableAdapter.call(Executors.java:511)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1142)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:617)\n\tat java.lang.Thread.run(Thread.java:748)\n"
                                                },
                                                {
                                                    "id": 3554932,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "failed",
                                                    "system_output": "java.lang.Exception: \n\tat org.specs.runner.NotifierRunner$$anonfun$reportSystem$3.apply(NotifierRunner.scala:84)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportSystem$3.apply(NotifierRunner.scala:84)\n\tat scala.collection.IndexedSeqOptimized$class.foreach(IndexedSeqOptimized.scala:33)\n\tat scala.collection.mutable.ArrayOps$ofRef.foreach(ArrayOps.scala:108)\n\tat org.specs.runner.NotifierRunner.reportSystem(NotifierRunner.scala:84)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:72)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:68)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat org.specs.runner.NotifierRunner.reportASpecification(NotifierRunner.scala:68)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:58)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:45)\n\tat org.specs.runner.Reporter$class.reportSpecs(Reporter.scala:195)\n\tat org.specs.runner.NotifierRunner.reportSpecs(NotifierRunner.scala:45)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:65)\n\tat sbt.RunnerWrapper$1.runRunner(FrameworkWrapper.java:203)\n\tat sbt.RunnerWrapper$1.execute(FrameworkWrapper.java:239)\n\tat sbt.TestRunner.runTest$1(TestFramework.scala:76)\n\tat sbt.TestRunner.run(TestFramework.scala:85)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$.sbt$TestFramework$$withContextLoader(TestFramework.scala:185)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFunction.apply(TestFramework.scala:207)\n\tat sbt.Tests$.sbt$Tests$$processRunnable$1(Tests.scala:239)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$4.work(System.scala:63)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.ErrorHandling$.wideConvert(ErrorHandling.scala:17)\n\tat sbt.Execute.work(Execute.scala:237)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.ConcurrentRestrictions$$anon$4$$anonfun$1.apply(ConcurrentRestrictions.scala:159)\n\tat sbt.CompletionService$$anon$2.call(CompletionService.scala:28)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.Executors$RunnableAdapter.call(Executors.java:511)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1142)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:617)\n\tat java.lang.Thread.run(Thread.java:748)\n"
                                                },
                                                {
                                                    "id": 3554926,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdf with QR code",
                                                    "status": "error",
                                                    "system_output": "java.awt.AWTError: Can't connect to X11 window server using ':99.0' as the value of the DISPLAY variable.\n\tat sun.awt.X11GraphicsEnvironment.initDisplay(Native Method)\n\tat sun.awt.X11GraphicsEnvironment.access$200(X11GraphicsEnvironment.java:65)\n\tat sun.awt.X11GraphicsEnvironment$1.run(X11GraphicsEnvironment.java:115)\n\tat java.security.AccessController.doPrivileged(Native Method)\n\tat sun.awt.X11GraphicsEnvironment.<clinit>(X11GraphicsEnvironment.java:74)\n\tat java.lang.Class.forName0(Native Method)\n\tat java.lang.Class.forName(Class.java:264)\n\tat java.awt.GraphicsEnvironment.createGE(GraphicsEnvironment.java:103)\n\tat java.awt.GraphicsEnvironment.getLocalGraphicsEnvironment(GraphicsEnvironment.java:82)\n\tat sun.awt.X11FontManager.isHeadless(X11FontManager.java:509)\n\tat sun.awt.X11FontManager.getFontPath(X11FontManager.java:786)\n\tat sun.font.SunFontManager.getPlatformFontPath(SunFontManager.java:3282)\n\tat sun.font.SunFontManager$10.run(SunFontManager.java:3308)\n\tat java.security.AccessController.doPrivileged(Native Method)\n\tat sun.font.SunFontManager.loadFonts(SunFontManager.java:3304)\n\tat sun.awt.X11FontManager.loadFonts(X11FontManager.java:460)\n\tat sun.font.SunFontManager.findFont2D(SunFontManager.java:2348)\n\tat java.awt.Font.getFont2D(Font.java:500)\n\tat java.awt.Font.getFamily(Font.java:1220)\n\tat java.awt.Font.getFamily_NoClientCode(Font.java:1194)\n\tat java.awt.Font.getFamily(Font.java:1186)\n\tat net.codecrete.qrbill.canvas.PNGCanvas.findFontFamily(PNGCanvas.java:111)\n\tat net.codecrete.qrbill.canvas.PNGCanvas.<init>(PNGCanvas.java:74)\n\tat net.codecrete.qrbill.generator.QRBill.createCanvas(QRBill.java:297)\n\tat net.codecrete.qrbill.generator.QRBill.generate(QRBill.java:128)\n\tat ch.petag.pdf.InpaymentSlipQRRenderer.render(InpaymentSlipQRRenderer.scala:67)\n\tat ch.petag.pdf.InpaymentSlipQRPdfGenerator.writeTo(InpaymentSlipQRPdfGenerator.scala:31)\n\tat ch.petag.pdf.InpaymentSlipQRPdfGenerator.writeTo(InpaymentSlipQRPdfGenerator.scala:20)\n\tat ch.petag.pdf.QrCodeSpec$$anonfun$1$$anonfun$apply$1.apply$mcV$sp(QrCodeSpec.scala:13)\n\tat ch.petag.pdf.QrCodeSpec$$anonfun$1$$anonfun$apply$1.apply(QrCodeSpec.scala:11)\n\tat ch.petag.pdf.QrCodeSpec$$anonfun$1$$anonfun$apply$1.apply(QrCodeSpec.scala:11)\n\tat org.specs.specification.LifeCycle$class.withCurrent(ExampleLifeCycle.scala:66)\n\tat org.specs.specification.Examples.withCurrent(Examples.scala:52)\n\tat org.specs.specification.Examples$$anonfun$specifyExample$1.apply(Examples.scala:114)\n\tat org.specs.specification.Examples$$anonfun$specifyExample$1.apply(Examples.scala:114)\n\tat org.specs.specification.ExampleExecution$$anonfun$3$$anonfun$apply$5.apply(ExampleLifeCycle.scala:219)\n\tat scala.Option.getOrElse(Option.scala:120)\n\tat org.specs.specification.LifeCycle$class.executeExpectations(ExampleLifeCycle.scala:90)\n\tat org.specs.specification.BaseSpecification.executeExpectations(BaseSpecification.scala:58)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$class.id$1(ExampleContext.scala:32)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$class.executeExpectations(ExampleContext.scala:80)\n\tat org.specs.specification.Examples.executeExpectations(Examples.scala:52)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$class.id$1(ExampleContext.scala:32)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$class.executeExpectations(ExampleContext.scala:80)\n\tat org.specs.specification.Examples.executeExpectations(Examples.scala:52)\n\tat org.specs.specification.ExampleExecution$$anonfun$3.apply(ExampleLifeCycle.scala:219)\n\tat org.specs.specification.ExampleExecution$$anonfun$3.apply(ExampleLifeCycle.scala:198)\n\tat org.specs.specification.ExampleExecution$$anonfun$2.apply(ExampleLifeCycle.scala:181)\n\tat org.specs.specification.ExampleExecution.execute(ExampleLifeCycle.scala:252)\n\tat org.specs.specification.SpecificationExecutor$$anonfun$executeExample$3.apply(SpecificationExecutor.scala:70)\n\tat org.specs.specification.SpecificationExecutor$$anonfun$executeExample$3.apply(SpecificationExecutor.scala:70)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.SpecificationExecutor$class.executeExample(SpecificationExecutor.scala:70)\n\tat org.specs.specification.BaseSpecification.executeExample(BaseSpecification.scala:58)\n\tat org.specs.specification.BaseSpecification.executeExample(BaseSpecification.scala:58)\n\tat org.specs.specification.ExampleLifeCycle$$anonfun$executeExample$1.apply(ExampleLifeCycle.scala:125)\n\tat org.specs.specification.ExampleLifeCycle$$anonfun$executeExample$1.apply(ExampleLifeCycle.scala:125)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleLifeCycle$class.executeExample(ExampleLifeCycle.scala:125)\n\tat org.specs.specification.Examples.executeExample(Examples.scala:52)\n\tat org.specs.specification.Examples.executeExample(Examples.scala:52)\n\tat org.specs.specification.Examples$$anonfun$executeExamples$2.apply(Examples.scala:80)\n\tat org.specs.specification.Examples$$anonfun$executeExamples$2.apply(Examples.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.Examples.executeExamples(Examples.scala:80)\n\tat org.specs.specification.ExampleStructure$class.ownFailures(ExampleStructure.scala:58)\n\tat org.specs.specification.Examples.ownFailures(Examples.scala:52)\n\tat org.specs.specification.ExampleStructure$class.failures(ExampleStructure.scala:64)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.specification.ExampleStructure$$anonfun$failures$1.apply(ExampleStructure.scala:64)\n\tat org.specs.specification.ExampleStructure$$anonfun$failures$1.apply(ExampleStructure.scala:64)\n\tat scala.collection.TraversableLike$$anonfun$flatMap$1.apply(TraversableLike.scala:251)\n\tat scala.collection.TraversableLike$$anonfun$flatMap$1.apply(TraversableLike.scala:251)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat scala.collection.TraversableLike$class.flatMap(TraversableLike.scala:251)\n\tat scala.collection.AbstractTraversable.flatMap(Traversable.scala:105)\n\tat org.specs.specification.ExampleStructure$class.failures(ExampleStructure.scala:64)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.execute.HasResults$class.failureAndErrors(HasResults.scala:61)\n\tat org.specs.specification.Examples.failureAndErrors(Examples.scala:52)\n\tat org.specs.execute.HasResults$class.isOk(HasResults.scala:69)\n\tat org.specs.specification.Examples.isOk(Examples.scala:52)\n\tat org.specs.runner.NotifierRunner.reportSystem(NotifierRunner.scala:81)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:72)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:68)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat org.specs.runner.NotifierRunner.reportASpecification(NotifierRunner.scala:68)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:58)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:45)\n\tat org.specs.runner.Reporter$class.reportSpecs(Reporter.scala:195)\n\tat org.specs.runner.NotifierRunner.reportSpecs(NotifierRunner.scala:45)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:65)\n\tat sbt.RunnerWrapper$1.runRunner(FrameworkWrapper.java:203)\n\tat sbt.RunnerWrapper$1.execute(FrameworkWrapper.java:239)\n\tat sbt.TestRunner.runTest$1(TestFramework.scala:76)\n\tat sbt.TestRunner.run(TestFramework.scala:85)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$.sbt$TestFramework$$withContextLoader(TestFramework.scala:185)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFunction.apply(TestFramework.scala:207)\n\tat sbt.Tests$.sbt$Tests$$processRunnable$1(Tests.scala:239)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$4.work(System.scala:63)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.ErrorHandling$.wideConvert(ErrorHandling.scala:17)\n\tat sbt.Execute.work(Execute.scala:237)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.ConcurrentRestrictions$$anon$4$$anonfun$1.apply(ConcurrentRestrictions.scala:159)\n\tat sbt.CompletionService$$anon$2.call(CompletionService.scala:28)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.Executors$RunnableAdapter.call(Executors.java:511)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1142)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:617)\n\tat java.lang.Thread.run(Thread.java:748)\n"
                                                },
                                                {
                                                    "id": 3554922,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "error",
                                                    "system_output": "java.lang.NoClassDefFoundError: Could not initialize class sun.awt.X11GraphicsEnvironment\n\tat java.lang.Class.forName0(Native Method)\n\tat java.lang.Class.forName(Class.java:264)\n\tat java.awt.GraphicsEnvironment.createGE(GraphicsEnvironment.java:103)\n\tat java.awt.GraphicsEnvironment.getLocalGraphicsEnvironment(GraphicsEnvironment.java:82)\n\tat sun.awt.X11FontManager.isHeadless(X11FontManager.java:509)\n\tat sun.awt.X11FontManager.getFontPath(X11FontManager.java:786)\n\tat sun.font.SunFontManager.getPlatformFontPath(SunFontManager.java:3282)\n\tat sun.font.SunFontManager$10.run(SunFontManager.java:3308)\n\tat java.security.AccessController.doPrivileged(Native Method)\n\tat sun.font.SunFontManager.loadFonts(SunFontManager.java:3304)\n\tat sun.awt.X11FontManager.loadFonts(X11FontManager.java:460)\n\tat sun.font.SunFontManager.findFont2D(SunFontManager.java:2348)\n\tat java.awt.Font.getFont2D(Font.java:500)\n\tat java.awt.Font.getFamily(Font.java:1220)\n\tat java.awt.Font.getFamily_NoClientCode(Font.java:1194)\n\tat java.awt.Font.getFamily(Font.java:1186)\n\tat net.codecrete.qrbill.canvas.PNGCanvas.findFontFamily(PNGCanvas.java:111)\n\tat net.codecrete.qrbill.canvas.PNGCanvas.<init>(PNGCanvas.java:74)\n\tat net.codecrete.qrbill.generator.QRBill.createCanvas(QRBill.java:297)\n\tat net.codecrete.qrbill.generator.QRBill.generate(QRBill.java:128)\n\tat ch.petag.pdf.InpaymentSlipQRRenderer.render(InpaymentSlipQRRenderer.scala:67)\n\tat ch.petag.pdf.InpaymentSlipQRPdfGenerator.writeTo(InpaymentSlipQRPdfGenerator.scala:31)\n\tat ch.petag.pdf.PrepayInvoicePdfGenerator.createPdf(PrepayInvoicePdfGenerator.scala:52)\n\tat ch.petag.pdf.PrePayInvoicePdfGeneratorSpec$$anonfun$1$$anonfun$apply$3.apply$mcV$sp(PrePayInvoicePdfGeneratorSpec.scala:58)\n\tat ch.petag.pdf.PrePayInvoicePdfGeneratorSpec$$anonfun$1$$anonfun$apply$3.apply(PrePayInvoicePdfGeneratorSpec.scala:42)\n\tat ch.petag.pdf.PrePayInvoicePdfGeneratorSpec$$anonfun$1$$anonfun$apply$3.apply(PrePayInvoicePdfGeneratorSpec.scala:42)\n\tat org.specs.specification.LifeCycle$class.withCurrent(ExampleLifeCycle.scala:66)\n\tat org.specs.specification.Examples.withCurrent(Examples.scala:52)\n\tat org.specs.specification.Examples$$anonfun$specifyExample$1.apply(Examples.scala:114)\n\tat org.specs.specification.Examples$$anonfun$specifyExample$1.apply(Examples.scala:114)\n\tat org.specs.specification.ExampleExecution$$anonfun$3$$anonfun$apply$5.apply(ExampleLifeCycle.scala:219)\n\tat scala.Option.getOrElse(Option.scala:120)\n\tat org.specs.specification.LifeCycle$class.executeExpectations(ExampleLifeCycle.scala:90)\n\tat org.specs.specification.BaseSpecification.executeExpectations(BaseSpecification.scala:58)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$class.id$1(ExampleContext.scala:32)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$class.executeExpectations(ExampleContext.scala:80)\n\tat org.specs.specification.Examples.executeExpectations(Examples.scala:52)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$class.id$1(ExampleContext.scala:32)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$class.executeExpectations(ExampleContext.scala:80)\n\tat org.specs.specification.Examples.executeExpectations(Examples.scala:52)\n\tat org.specs.specification.ExampleExecution$$anonfun$3.apply(ExampleLifeCycle.scala:219)\n\tat org.specs.specification.ExampleExecution$$anonfun$3.apply(ExampleLifeCycle.scala:198)\n\tat org.specs.specification.ExampleExecution$$anonfun$2.apply(ExampleLifeCycle.scala:181)\n\tat org.specs.specification.ExampleExecution.execute(ExampleLifeCycle.scala:252)\n\tat org.specs.specification.SpecificationExecutor$$anonfun$executeExample$3.apply(SpecificationExecutor.scala:70)\n\tat org.specs.specification.SpecificationExecutor$$anonfun$executeExample$3.apply(SpecificationExecutor.scala:70)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.SpecificationExecutor$class.executeExample(SpecificationExecutor.scala:70)\n\tat org.specs.specification.BaseSpecification.executeExample(BaseSpecification.scala:58)\n\tat org.specs.specification.BaseSpecification.executeExample(BaseSpecification.scala:58)\n\tat org.specs.specification.ExampleLifeCycle$$anonfun$executeExample$1.apply(ExampleLifeCycle.scala:125)\n\tat org.specs.specification.ExampleLifeCycle$$anonfun$executeExample$1.apply(ExampleLifeCycle.scala:125)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleLifeCycle$class.executeExample(ExampleLifeCycle.scala:125)\n\tat org.specs.specification.Examples.executeExample(Examples.scala:52)\n\tat org.specs.specification.Examples.executeExample(Examples.scala:52)\n\tat org.specs.specification.Examples$$anonfun$executeExamples$2.apply(Examples.scala:80)\n\tat org.specs.specification.Examples$$anonfun$executeExamples$2.apply(Examples.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.Examples.executeExamples(Examples.scala:80)\n\tat org.specs.specification.ExampleStructure$class.ownFailures(ExampleStructure.scala:58)\n\tat org.specs.specification.Examples.ownFailures(Examples.scala:52)\n\tat org.specs.specification.ExampleStructure$class.failures(ExampleStructure.scala:64)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.specification.ExampleStructure$$anonfun$failures$1.apply(ExampleStructure.scala:64)\n\tat org.specs.specification.ExampleStructure$$anonfun$failures$1.apply(ExampleStructure.scala:64)\n\tat scala.collection.TraversableLike$$anonfun$flatMap$1.apply(TraversableLike.scala:251)\n\tat scala.collection.TraversableLike$$anonfun$flatMap$1.apply(TraversableLike.scala:251)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat scala.collection.TraversableLike$class.flatMap(TraversableLike.scala:251)\n\tat scala.collection.AbstractTraversable.flatMap(Traversable.scala:105)\n\tat org.specs.specification.ExampleStructure$class.failures(ExampleStructure.scala:64)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.execute.HasResults$class.failureAndErrors(HasResults.scala:61)\n\tat org.specs.specification.Examples.failureAndErrors(Examples.scala:52)\n\tat org.specs.execute.HasResults$class.isOk(HasResults.scala:69)\n\tat org.specs.specification.Examples.isOk(Examples.scala:52)\n\tat org.specs.runner.NotifierRunner.reportSystem(NotifierRunner.scala:81)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:72)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:68)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat org.specs.runner.NotifierRunner.reportASpecification(NotifierRunner.scala:68)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:58)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:45)\n\tat org.specs.runner.Reporter$class.reportSpecs(Reporter.scala:195)\n\tat org.specs.runner.NotifierRunner.reportSpecs(NotifierRunner.scala:45)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:65)\n\tat sbt.RunnerWrapper$1.runRunner(FrameworkWrapper.java:203)\n\tat sbt.RunnerWrapper$1.execute(FrameworkWrapper.java:239)\n\tat sbt.TestRunner.runTest$1(TestFramework.scala:76)\n\tat sbt.TestRunner.run(TestFramework.scala:85)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$.sbt$TestFramework$$withContextLoader(TestFramework.scala:185)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFunction.apply(TestFramework.scala:207)\n\tat sbt.Tests$.sbt$Tests$$processRunnable$1(Tests.scala:239)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$4.work(System.scala:63)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.ErrorHandling$.wideConvert(ErrorHandling.scala:17)\n\tat sbt.Execute.work(Execute.scala:237)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.ConcurrentRestrictions$$anon$4$$anonfun$1.apply(ConcurrentRestrictions.scala:159)\n\tat sbt.CompletionService$$anon$2.call(CompletionService.scala:28)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.Executors$RunnableAdapter.call(Executors.java:511)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1142)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:617)\n\tat java.lang.Thread.run(Thread.java:748)\n"
                                                },
                                                {
                                                    "id": 3554916,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "error",
                                                    "system_output": "java.lang.NoClassDefFoundError: Could not initialize class sun.awt.X11GraphicsEnvironment\n\tat java.lang.Class.forName0(Native Method)\n\tat java.lang.Class.forName(Class.java:264)\n\tat java.awt.GraphicsEnvironment.createGE(GraphicsEnvironment.java:103)\n\tat java.awt.GraphicsEnvironment.getLocalGraphicsEnvironment(GraphicsEnvironment.java:82)\n\tat sun.awt.X11FontManager.isHeadless(X11FontManager.java:509)\n\tat sun.awt.X11FontManager.getFontPath(X11FontManager.java:786)\n\tat sun.font.SunFontManager.getPlatformFontPath(SunFontManager.java:3282)\n\tat sun.font.SunFontManager$10.run(SunFontManager.java:3308)\n\tat java.security.AccessController.doPrivileged(Native Method)\n\tat sun.font.SunFontManager.loadFonts(SunFontManager.java:3304)\n\tat sun.awt.X11FontManager.loadFonts(X11FontManager.java:460)\n\tat sun.font.SunFontManager.findFont2D(SunFontManager.java:2348)\n\tat java.awt.Font.getFont2D(Font.java:500)\n\tat java.awt.Font.getFamily(Font.java:1220)\n\tat java.awt.Font.getFamily_NoClientCode(Font.java:1194)\n\tat java.awt.Font.getFamily(Font.java:1186)\n\tat net.codecrete.qrbill.canvas.PNGCanvas.findFontFamily(PNGCanvas.java:111)\n\tat net.codecrete.qrbill.canvas.PNGCanvas.<init>(PNGCanvas.java:74)\n\tat net.codecrete.qrbill.generator.QRBill.createCanvas(QRBill.java:297)\n\tat net.codecrete.qrbill.generator.QRBill.generate(QRBill.java:128)\n\tat ch.petag.pdf.InpaymentSlipQRRenderer.render(InpaymentSlipQRRenderer.scala:67)\n\tat ch.petag.pdf.InpaymentSlipQRPdfGenerator.writeTo(InpaymentSlipQRPdfGenerator.scala:31)\n\tat ch.petag.pdf.InpaymentSlipQRPdfGenerator.writeTo(InpaymentSlipQRPdfGenerator.scala:20)\n\tat ch.petag.db.finance.InpaymentSlipSpec$$anonfun$1$$anonfun$apply$mcV$sp$2$$anonfun$apply$mcV$sp$5.apply(InpaymentSlipSpec.scala:45)\n\tat ch.petag.db.finance.InpaymentSlipSpec$$anonfun$1$$anonfun$apply$mcV$sp$2$$anonfun$apply$mcV$sp$5.apply(InpaymentSlipSpec.scala:41)\n\tat ch.petag.db.invoice.util.DBTestTrait$$anon$1.dbm(DBTestTrait.scala:12)\n\tat jdbt.runtime.Transaction.dbt(Transaction.java:162)\n\tat jdbt.runtime.Transaction.dbt(Transaction.java:251)\n\tat ch.petag.db.invoice.util.DBTestTrait$class.openSqlConnectionAndExecute(DBTestTrait.scala:14)\n\tat ch.petag.db.finance.InpaymentSlipSpec.openSqlConnectionAndExecute(InpaymentSlipSpec.scala:13)\n\tat ch.petag.db.finance.InpaymentSlipSpec$$anonfun$1$$anonfun$apply$mcV$sp$2.apply$mcV$sp(InpaymentSlipSpec.scala:41)\n\tat ch.petag.db.finance.InpaymentSlipSpec$$anonfun$1$$anonfun$apply$mcV$sp$2.apply(InpaymentSlipSpec.scala:22)\n\tat ch.petag.db.finance.InpaymentSlipSpec$$anonfun$1$$anonfun$apply$mcV$sp$2.apply(InpaymentSlipSpec.scala:22)\n\tat org.specs.specification.LifeCycle$class.withCurrent(ExampleLifeCycle.scala:66)\n\tat org.specs.specification.Examples.withCurrent(Examples.scala:52)\n\tat org.specs.specification.Examples$$anonfun$specifyExample$1.apply(Examples.scala:114)\n\tat org.specs.specification.Examples$$anonfun$specifyExample$1.apply(Examples.scala:114)\n\tat org.specs.specification.ExampleExecution$$anonfun$3$$anonfun$apply$5.apply(ExampleLifeCycle.scala:219)\n\tat scala.Option.getOrElse(Option.scala:120)\n\tat org.specs.specification.LifeCycle$class.executeExpectations(ExampleLifeCycle.scala:90)\n\tat org.specs.specification.BaseSpecification.executeExpectations(BaseSpecification.scala:58)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$class.id$1(ExampleContext.scala:32)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$class.executeExpectations(ExampleContext.scala:80)\n\tat org.specs.specification.Examples.executeExpectations(Examples.scala:52)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2$$anonfun$apply$3.apply(ExampleContext.scala:81)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3$$anonfun$apply$2.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$class.id$1(ExampleContext.scala:32)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$1.apply(ExampleContext.scala:33)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:81)\n\tat org.specs.specification.ExampleContext$$anonfun$executeExpectations$3.apply(ExampleContext.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleContext$class.executeExpectations(ExampleContext.scala:80)\n\tat org.specs.specification.Examples.executeExpectations(Examples.scala:52)\n\tat org.specs.specification.ExampleExecution$$anonfun$3.apply(ExampleLifeCycle.scala:219)\n\tat org.specs.specification.ExampleExecution$$anonfun$3.apply(ExampleLifeCycle.scala:198)\n\tat org.specs.specification.ExampleExecution$$anonfun$2.apply(ExampleLifeCycle.scala:181)\n\tat org.specs.specification.ExampleExecution.execute(ExampleLifeCycle.scala:252)\n\tat org.specs.specification.SpecificationExecutor$$anonfun$executeExample$3.apply(SpecificationExecutor.scala:70)\n\tat org.specs.specification.SpecificationExecutor$$anonfun$executeExample$3.apply(SpecificationExecutor.scala:70)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.SpecificationExecutor$class.executeExample(SpecificationExecutor.scala:70)\n\tat org.specs.specification.BaseSpecification.executeExample(BaseSpecification.scala:58)\n\tat org.specs.specification.BaseSpecification.executeExample(BaseSpecification.scala:58)\n\tat org.specs.specification.ExampleLifeCycle$$anonfun$executeExample$1.apply(ExampleLifeCycle.scala:125)\n\tat org.specs.specification.ExampleLifeCycle$$anonfun$executeExample$1.apply(ExampleLifeCycle.scala:125)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.ExampleLifeCycle$class.executeExample(ExampleLifeCycle.scala:125)\n\tat org.specs.specification.Examples.executeExample(Examples.scala:52)\n\tat org.specs.specification.Examples.executeExample(Examples.scala:52)\n\tat org.specs.specification.Examples$$anonfun$executeExamples$2.apply(Examples.scala:80)\n\tat org.specs.specification.Examples$$anonfun$executeExamples$2.apply(Examples.scala:80)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.specification.Examples.executeExamples(Examples.scala:80)\n\tat org.specs.specification.ExampleStructure$class.ownFailures(ExampleStructure.scala:58)\n\tat org.specs.specification.Examples.ownFailures(Examples.scala:52)\n\tat org.specs.specification.ExampleStructure$class.failures(ExampleStructure.scala:64)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.specification.ExampleStructure$$anonfun$failures$1.apply(ExampleStructure.scala:64)\n\tat org.specs.specification.ExampleStructure$$anonfun$failures$1.apply(ExampleStructure.scala:64)\n\tat scala.collection.TraversableLike$$anonfun$flatMap$1.apply(TraversableLike.scala:251)\n\tat scala.collection.TraversableLike$$anonfun$flatMap$1.apply(TraversableLike.scala:251)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat scala.collection.TraversableLike$class.flatMap(TraversableLike.scala:251)\n\tat scala.collection.AbstractTraversable.flatMap(Traversable.scala:105)\n\tat org.specs.specification.ExampleStructure$class.failures(ExampleStructure.scala:64)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.specification.Examples.failures(Examples.scala:52)\n\tat org.specs.execute.HasResults$class.failureAndErrors(HasResults.scala:61)\n\tat org.specs.specification.Examples.failureAndErrors(Examples.scala:52)\n\tat org.specs.execute.HasResults$class.isOk(HasResults.scala:69)\n\tat org.specs.specification.Examples.isOk(Examples.scala:52)\n\tat org.specs.runner.NotifierRunner.reportSystem(NotifierRunner.scala:81)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:72)\n\tat org.specs.runner.NotifierRunner$$anonfun$reportASpecification$3.apply(NotifierRunner.scala:68)\n\tat scala.collection.immutable.List.foreach(List.scala:318)\n\tat org.specs.runner.NotifierRunner.reportASpecification(NotifierRunner.scala:68)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:58)\n\tat org.specs.runner.NotifierRunner.report(NotifierRunner.scala:45)\n\tat org.specs.runner.Reporter$class.reportSpecs(Reporter.scala:195)\n\tat org.specs.runner.NotifierRunner.reportSpecs(NotifierRunner.scala:45)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner$$anonfun$run$3.apply(TestInterfaceRunner.scala:72)\n\tat scala.Option.map(Option.scala:145)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:72)\n\tat org.specs.runner.TestInterfaceRunner.run(TestInterfaceRunner.scala:65)\n\tat sbt.RunnerWrapper$1.runRunner(FrameworkWrapper.java:203)\n\tat sbt.RunnerWrapper$1.execute(FrameworkWrapper.java:239)\n\tat sbt.TestRunner.runTest$1(TestFramework.scala:76)\n\tat sbt.TestRunner.run(TestFramework.scala:85)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1$$anonfun$apply$8.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$.sbt$TestFramework$$withContextLoader(TestFramework.scala:185)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFramework$$anon$2$$anonfun$$init$$1.apply(TestFramework.scala:202)\n\tat sbt.TestFunction.apply(TestFramework.scala:207)\n\tat sbt.Tests$.sbt$Tests$$processRunnable$1(Tests.scala:239)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.Tests$$anonfun$makeSerial$1.apply(Tests.scala:245)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$3$$anonfun$apply$2.apply(System.scala:44)\n\tat sbt.std.Transform$$anon$4.work(System.scala:63)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1$$anonfun$apply$1.apply(Execute.scala:228)\n\tat sbt.ErrorHandling$.wideConvert(ErrorHandling.scala:17)\n\tat sbt.Execute.work(Execute.scala:237)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.Execute$$anonfun$submit$1.apply(Execute.scala:228)\n\tat sbt.ConcurrentRestrictions$$anon$4$$anonfun$1.apply(ConcurrentRestrictions.scala:159)\n\tat sbt.CompletionService$$anon$2.call(CompletionService.scala:28)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.Executors$RunnableAdapter.call(Executors.java:511)\n\tat java.util.concurrent.FutureTask.run(FutureTask.java:266)\n\tat java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1142)\n\tat java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:617)\n\tat java.lang.Thread.run(Thread.java:748)\n"
                                                },
                                                {
                                                    "id": 3555555,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555549,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555545,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555539,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555536,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555506,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555500,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555496,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555490,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555486,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555480,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555362,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555358,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555352,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555349,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555343,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555339,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555333,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555327,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555321,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555317,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555476,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555470,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555466,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555460,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555456,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555450,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555446,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555440,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555436,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555430,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555530,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555526,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555520,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555516,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555510,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554946,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554952,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554956,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554962,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554966,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554972,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554976,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554982,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554986,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554992,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554996,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555002,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555006,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555012,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555015,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555021,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555025,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555031,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555035,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555040,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555045,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555050,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555642,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555311,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555306,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555301,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555296,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555291,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555285,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555281,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555271,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555265,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555262,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555252,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555243,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555234,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555224,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555218,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555213,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555208,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555203,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555426,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555420,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555416,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555410,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555406,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555400,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555398,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555392,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555388,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555382,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555378,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555372,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555636,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555198,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555193,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555188,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555183,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555674,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555668,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555662,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555658,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555652,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555647,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555630,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555623,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555618,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555368,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555055,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555059,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555065,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555068,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555074,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555613,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555607,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555603,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555597,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555591,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555585,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555581,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555680,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555685,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555690,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555696,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555700,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555706,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555712,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555718,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555725,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555735,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555745,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555755,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555765,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555775,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555785,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555795,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555178,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555173,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555168,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555163,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555158,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555153,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555148,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555143,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555138,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555133,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555128,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555123,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555118,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555113,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555108,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555103,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555098,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555093,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555088,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555084,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555078,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555805,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555815,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555825,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729919,
                                    "isTestReportAvailable": true,
                                    "duration": 169,
                                    "duration_inMinutes": 2.82,
                                    "created_at": "Feb-10-22",
                                    "created_at_rawDateFormat": "2022-02-10T07:05:54.714Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 465835052,
                                "gitlabId": 465835052,
                                "status": "success",
                                "testReport": {
                                    "id": 46768,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54112,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3559381,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558945,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558951,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558954,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558960,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558964,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558970,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558974,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558980,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558983,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558989,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558993,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558999,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559003,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559009,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559013,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559019,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559023,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559029,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559033,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559039,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559043,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559049,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559053,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559059,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559063,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559069,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559073,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559079,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559083,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559089,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559093,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559099,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559103,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559109,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559113,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559119,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559122,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559128,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559132,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559138,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559141,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559147,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559151,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559157,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559161,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559167,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559171,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559177,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559180,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559186,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559190,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559196,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559199,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559205,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559209,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559215,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559219,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559225,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559229,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559234,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559239,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559244,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559249,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559254,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559259,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559263,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559268,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559273,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559278,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559282,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559287,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559292,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559297,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559302,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559307,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559311,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559317,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559321,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559327,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559331,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559337,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559341,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559347,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559351,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559357,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559361,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559367,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559371,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559376,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559385,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559390,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559395,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559400,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559405,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559410,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559415,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559420,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559425,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559430,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559435,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559440,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559445,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559450,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559455,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559460,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559465,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559470,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559475,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559480,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559485,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559490,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559495,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559500,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559505,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559510,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559515,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559520,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559525,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559530,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559535,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559540,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559545,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559550,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559555,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559560,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559565,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559570,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559575,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559580,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559585,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559590,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559595,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559600,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559605,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559610,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559615,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559620,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559625,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559630,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559635,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559640,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559645,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559650,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559655,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559660,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559665,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559670,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559675,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559680,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559685,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559690,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559695,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559700,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559705,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559710,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559715,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559720,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559725,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559730,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559735,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559740,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559745,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559750,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559755,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559760,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559765,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559770,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559775,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559780,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559785,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559790,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559795,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559800,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559805,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559810,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559815,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559820,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559825,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559830,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559835,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559840,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559845,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559850,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559855,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559860,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559865,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559870,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559875,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559880,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559885,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559890,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559895,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559900,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559905,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559910,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559915,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559920,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559925,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559930,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559935,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559940,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559945,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559950,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559955,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729920,
                                    "isTestReportAvailable": true,
                                    "duration": 1128,
                                    "duration_inMinutes": 18.8,
                                    "created_at": "Feb-08-22",
                                    "created_at_rawDateFormat": "2022-02-08T07:05:54.779Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 465215147,
                                "gitlabId": 465215147,
                                "status": "failed",
                                "testReport": {
                                    "id": 46769,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 29,
                                    "success_count": 147,
                                    "total_count": 176,
                                    "total_time": -0.22,
                                    "test_suites": [
                                        {
                                            "id": 54110,
                                            "total_time": -0.22,
                                            "total_count": 176,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 29,
                                            "success_count": 147,
                                            "test_cases": [
                                                {
                                                    "id": 3563032,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563308,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563302,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563037,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563298,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563292,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563288,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563282,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563278,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563272,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563268,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563262,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563258,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563252,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563248,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563042,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563047,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563052,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563057,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563062,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563067,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563107,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563112,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563117,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563122,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563127,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563133,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563143,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563152,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563158,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563168,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563178,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563188,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563362,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563358,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563352,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563348,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563342,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563338,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563332,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563328,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563322,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563318,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563312,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563072,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563077,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563082,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563087,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563092,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563097,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563102,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563027,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563022,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563017,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563012,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563007,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563002,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562997,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562992,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562987,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562982,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562977,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562972,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562967,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562962,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562882,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562877,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562872,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562867,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562862,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562857,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562852,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562847,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562842,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562837,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562832,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562827,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562822,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562817,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563192,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563198,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563202,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563208,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562957,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562952,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562947,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562942,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562937,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562932,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562927,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562922,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562917,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563242,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563238,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563232,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563228,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563222,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563218,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563212,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562912,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562907,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562902,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562897,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562892,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562887,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563488,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563484,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563479,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563474,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563469,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563464,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563459,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563436,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563431,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563426,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563421,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563416,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563411,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563407,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563402,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563397,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563392,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563387,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563382,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563377,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563371,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563368,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563610,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563613,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563619,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563517,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563623,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563629,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563633,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563639,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563642,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563677,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563681,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563687,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563691,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563697,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563700,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563706,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563590,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563594,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563523,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563526,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563532,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563536,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563542,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563546,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563552,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563555,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563600,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563604,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563648,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563652,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a valid qr code",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563658,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563494,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563668,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563671,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563561,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563565,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563571,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563575,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563581,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563584,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563513,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563507,
                                                    "classname": "ch.petag.pdf.QrCodeSpec",
                                                    "execution_time": 0,
                                                    "name": "a QrCodeSpec should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563503,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563497,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563455,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563450,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563445,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563440,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563662,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729924,
                                    "isTestReportAvailable": true,
                                    "duration": 703,
                                    "duration_inMinutes": 11.72,
                                    "created_at": "Feb-07-22",
                                    "created_at_rawDateFormat": "2022-02-07T07:05:54.931Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 455052353,
                                "gitlabId": 455052353,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729921,
                                    "isTestReportAvailable": false,
                                    "duration": 63,
                                    "duration_inMinutes": 1.05,
                                    "created_at": "Jan-24-22",
                                    "created_at_rawDateFormat": "2022-01-24T07:05:54.848Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 455019790,
                                "gitlabId": 455019790,
                                "status": "success",
                                "testReport": {
                                    "id": 46772,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54111,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3559034,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559040,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559406,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559401,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559396,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559391,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559386,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559382,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559377,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559372,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559368,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559362,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559358,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559352,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559348,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559342,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559338,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559332,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559328,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559322,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559318,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559312,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559308,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559303,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559298,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559090,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559586,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559591,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559596,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559601,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559070,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559064,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559050,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559054,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559661,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559666,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559671,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559676,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559681,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559686,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559691,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559696,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559701,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559706,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559711,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559716,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559721,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559501,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559726,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559731,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559736,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559741,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559746,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559506,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559511,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558741,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558747,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558751,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558757,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558761,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558767,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558771,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558777,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559516,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559521,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559526,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559531,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559536,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559541,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559546,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559551,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559044,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559436,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559431,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559426,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559421,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559416,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559411,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558781,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558787,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558791,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558797,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558801,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558807,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558810,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558816,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558820,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558826,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558829,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558835,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558839,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558845,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558849,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558854,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558858,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558864,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558868,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558874,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558878,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558884,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558888,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558894,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558897,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558903,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558907,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558913,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558917,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558923,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558927,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558933,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558936,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558942,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558946,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558952,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558955,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558961,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558965,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558971,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558975,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558981,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558984,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558990,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558994,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559000,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559004,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559010,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559014,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559020,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559024,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559030,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559220,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559216,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559210,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559206,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559200,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559197,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559191,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559187,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559181,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559178,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559172,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559168,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559162,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559158,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559152,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559496,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559491,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559486,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559481,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559476,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559471,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559466,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559461,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559606,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559611,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559616,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559621,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559626,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559631,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559636,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559641,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559646,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559651,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559656,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559456,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559451,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559446,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559441,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559060,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559084,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559080,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559074,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559556,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559561,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559566,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559571,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559576,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559581,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559148,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559142,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559139,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559133,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559129,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559123,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559120,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559114,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559110,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559104,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559100,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559094,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559293,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559288,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559283,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559279,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559274,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559269,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559264,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559260,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559255,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559250,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559245,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559240,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559235,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559230,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559226,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729922,
                                    "isTestReportAvailable": true,
                                    "duration": 849,
                                    "duration_inMinutes": 14.15,
                                    "created_at": "Jan-24-22",
                                    "created_at_rawDateFormat": "2022-01-24T07:05:54.900Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 454982221,
                                "gitlabId": 454982221,
                                "status": "success",
                                "testReport": {
                                    "id": 46775,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54113,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3562964,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563064,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563074,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563084,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563094,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563104,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563114,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563124,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563339,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563333,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563329,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563323,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563319,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563313,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563309,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563303,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563299,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563293,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563289,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563283,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563128,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563134,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563203,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563199,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563263,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563279,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563273,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563269,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563193,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563138,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563186,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562974,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562984,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562994,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563209,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563213,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563219,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563223,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563229,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563233,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563239,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563243,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563249,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563253,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563259,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563343,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563004,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563014,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563179,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563173,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563169,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563163,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563159,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563153,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563148,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563144,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563024,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563034,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563044,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563054,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563501,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563505,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563511,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563515,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563521,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563527,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563533,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563585,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563579,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563573,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563567,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563562,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563556,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563550,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563543,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563538,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563683,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563688,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563993,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563998,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564003,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564008,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564013,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564018,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564023,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564028,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563485,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563481,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563475,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563471,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563465,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563460,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563453,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563447,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563443,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563437,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563433,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563427,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563424,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563418,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563414,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563693,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563698,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563704,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563708,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563714,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563718,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563724,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563730,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563736,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563743,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563753,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563763,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563772,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563782,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563791,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563798,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563803,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563808,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563813,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563818,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563823,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563828,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563833,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563838,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563843,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563848,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563853,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563858,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563602,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563614,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563620,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563625,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563631,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563637,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563643,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563649,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563654,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563660,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563666,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563672,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563678,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563408,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563404,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563398,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563394,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563388,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563384,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563378,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563372,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563369,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563363,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563359,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563353,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563349,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563863,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563868,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563873,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563878,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563883,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563888,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563893,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563898,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563903,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563908,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563913,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563918,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563923,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563928,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563933,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563938,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563943,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563948,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563953,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563958,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563963,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563968,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563973,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563978,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563983,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563988,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564124,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564118,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564114,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564108,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564104,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564098,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564093,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564088,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564083,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564078,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564073,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564068,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564063,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564058,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564053,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564048,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564043,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564038,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564033,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563491,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563495,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563596,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563608,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563591,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729923,
                                    "isTestReportAvailable": true,
                                    "duration": 1294,
                                    "duration_inMinutes": 21.57,
                                    "created_at": "Jan-24-22",
                                    "created_at_rawDateFormat": "2022-01-24T07:05:54.928Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 449739051,
                                "gitlabId": 449739051,
                                "status": "success",
                                "testReport": {
                                    "id": 46773,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54114,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3555595,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555601,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555605,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555611,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555615,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555621,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555625,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555631,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555634,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555640,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555644,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555650,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555653,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555659,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555663,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555669,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555672,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555678,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555682,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555688,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555691,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555697,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555701,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555707,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555710,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555716,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555720,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555125,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555135,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555155,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555145,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556098,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556093,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556088,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555567,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555564,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555558,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555554,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555548,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555544,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555538,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555535,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555529,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555525,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555519,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555515,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555509,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555505,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555499,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555495,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555489,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555485,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555479,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555475,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555469,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555465,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555459,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555455,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555449,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555445,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555439,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555726,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555730,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555736,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555740,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555746,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555750,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555756,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555760,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555766,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555770,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555776,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555780,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555786,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555790,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555796,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555800,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555806,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555810,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555816,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555820,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555826,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555830,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555835,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555839,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555845,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555849,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555855,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555858,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556083,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556078,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556073,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556068,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3554991,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555001,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555011,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556063,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555435,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555429,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555425,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555419,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556058,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556053,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556048,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555165,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555175,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555185,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555195,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555205,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555215,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555223,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555228,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555235,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556165,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556160,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556155,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556150,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556145,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556141,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556136,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556131,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556126,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556122,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556117,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556112,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556107,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556103,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555415,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555409,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555405,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555399,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555394,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555385,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555375,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555365,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555355,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555345,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555336,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555326,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555316,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555307,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555297,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555287,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555279,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555273,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555267,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555263,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555254,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555244,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555864,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555868,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555874,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555878,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555882,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555888,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555892,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555898,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555901,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555907,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555911,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555917,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555921,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555927,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555931,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555937,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555940,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555946,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555950,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555956,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555960,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555966,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555970,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555976,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555980,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555986,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555990,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555996,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556000,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556005,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556010,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556015,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556019,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556024,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556029,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556034,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556038,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556043,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555020,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555030,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555039,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555049,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555058,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555064,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555070,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555076,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555081,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555086,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555095,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555105,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555115,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555573,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555576,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555582,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555586,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555592,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729925,
                                    "isTestReportAvailable": true,
                                    "duration": 2226,
                                    "duration_inMinutes": 37.1,
                                    "created_at": "Jan-17-22",
                                    "created_at_rawDateFormat": "2022-01-17T07:05:55.020Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 435082060,
                                "gitlabId": 435082060,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729927,
                                    "isTestReportAvailable": false,
                                    "duration": 1127,
                                    "duration_inMinutes": 18.78,
                                    "created_at": "Dec-22-21",
                                    "created_at_rawDateFormat": "2021-12-22T07:05:55.227Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 389221315,
                                "gitlabId": 389221315,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729933,
                                    "isTestReportAvailable": false,
                                    "duration": 907,
                                    "duration_inMinutes": 15.12,
                                    "created_at": "Oct-15-21",
                                    "created_at_rawDateFormat": "2021-10-15T07:05:55.511Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 389091653,
                                "gitlabId": 389091653,
                                "status": "success",
                                "testReport": {
                                    "id": 46777,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54115,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3563801,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564523,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564527,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564533,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564536,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564542,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564546,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564552,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564555,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564561,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564565,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564571,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564575,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564581,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564585,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564591,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564595,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564601,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564605,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564611,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564614,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564620,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564624,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564630,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564634,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564640,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564644,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564649,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564653,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564659,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564517,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564513,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564507,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564503,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564497,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564493,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564487,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564483,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564477,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564474,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564468,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564464,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564458,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564454,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564448,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564445,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564439,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564435,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564429,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564425,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564420,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564416,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564411,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564406,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564401,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564396,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564391,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564386,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564381,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564376,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564371,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564366,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564361,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564356,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564351,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564346,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564341,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564336,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564331,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564326,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564322,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564316,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564312,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564306,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564303,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564297,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564293,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564288,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564283,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564278,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564273,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564268,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564263,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564258,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564253,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564248,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564243,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564238,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564234,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564229,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564224,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564219,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564214,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564209,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564205,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564200,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564195,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564190,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564185,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564180,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564175,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564170,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564166,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564162,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564156,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564152,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564146,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564142,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564136,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564132,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564126,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564122,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564116,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564112,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564106,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564102,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564096,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564091,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564086,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564081,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564076,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564071,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564066,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564061,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564056,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564051,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564046,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564041,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564036,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564031,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564026,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564021,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564016,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564011,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564006,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564001,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563996,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563991,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563986,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563981,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563976,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563971,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563966,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563961,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563956,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563951,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563946,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563941,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563936,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563931,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563926,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563921,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563916,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563911,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563906,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563901,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563896,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563891,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563886,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563881,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563876,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563871,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563866,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563861,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563856,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563851,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563846,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563841,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563836,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563831,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563826,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563821,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563816,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563811,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563806,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563796,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563792,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563787,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563783,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563777,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563773,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563768,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563764,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563758,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563754,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563748,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563744,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563738,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563734,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563728,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563725,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563719,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563715,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563709,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563705,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563699,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563696,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563690,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563686,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563680,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563676,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563670,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563667,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563661,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563657,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729930,
                                    "isTestReportAvailable": true,
                                    "duration": 891,
                                    "duration_inMinutes": 14.85,
                                    "created_at": "Oct-15-21",
                                    "created_at_rawDateFormat": "2021-10-15T07:05:55.446Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 389079438,
                                "gitlabId": 389079438,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729929,
                                    "isTestReportAvailable": false,
                                    "duration": 880,
                                    "duration_inMinutes": 14.67,
                                    "created_at": "Oct-15-21",
                                    "created_at_rawDateFormat": "2021-10-15T07:05:55.363Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 386235269,
                                "gitlabId": 386235269,
                                "status": "success",
                                "testReport": {
                                    "id": 46778,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54116,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3559619,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560494,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560490,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560484,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560480,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560209,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560214,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560219,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560224,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560229,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560234,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560239,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560244,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560249,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560254,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560259,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560264,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560269,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560274,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560279,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560284,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560289,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560294,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560299,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560304,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560309,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560314,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560319,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560324,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560329,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560334,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560339,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560344,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560349,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560356,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560361,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560367,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560371,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560377,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560381,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560474,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560471,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560465,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560461,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560455,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560451,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560445,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560441,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560435,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560431,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560427,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560421,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560417,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560411,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560407,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560401,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560397,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560391,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560387,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559709,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559714,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559719,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559724,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559729,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559734,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559474,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559479,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559484,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559489,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559739,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559744,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559749,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559754,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559759,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559764,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559769,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559774,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559779,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559784,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559789,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559794,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559799,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559804,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559809,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559814,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559819,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559824,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559829,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559834,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559839,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559844,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559849,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559854,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559859,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559864,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559869,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559874,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559879,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559884,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559889,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559894,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559494,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559499,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559504,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559509,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559514,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559519,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559524,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559529,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559534,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559539,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559544,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559549,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559554,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559559,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559564,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559569,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559574,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559579,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559584,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559589,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559594,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559599,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559604,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559899,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559904,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559909,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559914,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559919,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559924,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559929,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559934,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559939,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559944,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559949,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559954,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559959,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559964,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559969,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559974,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559979,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559984,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559989,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559994,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559999,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560004,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560009,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560014,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560019,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560024,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560029,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560034,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560039,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560044,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560049,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560054,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560059,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560064,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560069,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560074,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560079,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560084,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560089,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560094,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560099,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560104,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560109,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560114,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560119,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560124,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560129,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560134,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560139,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560144,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560149,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560154,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560159,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560164,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560169,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560174,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560179,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560184,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560189,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560194,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560199,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560204,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559609,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559614,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559624,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559629,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559634,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559639,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559644,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559649,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559654,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559659,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559664,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559669,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559674,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559679,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559684,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559689,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559694,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559699,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559704,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729926,
                                    "isTestReportAvailable": true,
                                    "duration": 843,
                                    "duration_inMinutes": 14.05,
                                    "created_at": "Oct-11-21",
                                    "created_at_rawDateFormat": "2021-10-11T07:05:55.198Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 386231826,
                                "gitlabId": 386231826,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729928,
                                    "isTestReportAvailable": false,
                                    "duration": 81,
                                    "duration_inMinutes": 1.35,
                                    "created_at": "Oct-11-21",
                                    "created_at_rawDateFormat": "2021-10-11T07:05:55.288Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 386202403,
                                "gitlabId": 386202403,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729931,
                                    "isTestReportAvailable": false,
                                    "duration": 1073,
                                    "duration_inMinutes": 17.88,
                                    "created_at": "Oct-11-21",
                                    "created_at_rawDateFormat": "2021-10-11T07:05:55.458Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 386201060,
                                "gitlabId": 386201060,
                                "status": "canceled",
                                "testReport": {
                                    "id": 46779,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54117,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3563947,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563942,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563937,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563932,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563927,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563922,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563917,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563912,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563907,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563902,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563897,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563892,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563887,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563882,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563877,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563872,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563867,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563862,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563857,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563852,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563847,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563842,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563837,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563832,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563827,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563822,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563817,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563812,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563807,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563802,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563797,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563793,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563788,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564398,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564404,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564408,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564414,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564418,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564424,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564428,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564434,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564438,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564444,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564449,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564455,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564459,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564465,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564201,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564470,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564476,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564482,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564486,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564492,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564496,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564502,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564506,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564512,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564516,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564522,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564526,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564532,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564206,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564210,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564215,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564220,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564225,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564230,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564235,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564239,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564244,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564249,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564254,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564259,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564264,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564269,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564274,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564279,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564287,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564296,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564302,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564307,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564313,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564317,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564323,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564330,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564335,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564340,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564344,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564349,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564354,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564359,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564364,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564369,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564374,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564379,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563784,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563778,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563774,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563769,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563765,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563759,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563755,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563749,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563745,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563739,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563735,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563729,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563726,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563720,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563716,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563710,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564384,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564844,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564834,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564824,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564815,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564805,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564795,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564537,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564543,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564548,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564554,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564560,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564564,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564570,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564594,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564584,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564580,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564574,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564388,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564394,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563952,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564604,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564600,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564590,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564786,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564057,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564052,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564047,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564042,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564037,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564032,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564027,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564022,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564017,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564012,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564007,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564002,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563997,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563992,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563987,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563982,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563977,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563972,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563967,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563962,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563957,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564062,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564067,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564072,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564077,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564082,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564087,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564092,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564097,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564103,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564107,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564113,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564117,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564123,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564127,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564133,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564137,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564143,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564147,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564153,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564157,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564163,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564167,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564171,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564176,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564181,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564186,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564191,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564196,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564776,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564766,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564756,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564746,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564736,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564727,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564853,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564717,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564707,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564697,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564688,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564678,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564668,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564658,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564648,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564639,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564629,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564621,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564615,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564610,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729932,
                                    "isTestReportAvailable": true,
                                    "duration": 989,
                                    "duration_inMinutes": 16.48,
                                    "created_at": "Oct-11-21",
                                    "created_at_rawDateFormat": "2021-10-11T07:05:55.497Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 378022630,
                                "gitlabId": 378022630,
                                "status": "success",
                                "testReport": {
                                    "id": 46783,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54119,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3556887,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555935,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555945,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555955,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555964,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555974,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555984,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555994,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556003,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556008,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556014,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556021,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556026,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556032,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556036,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556042,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556046,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556052,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556056,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556062,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556066,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556072,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556076,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556082,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556086,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556092,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556096,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556102,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556109,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556114,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556120,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556124,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556130,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556134,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556140,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556147,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556152,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556158,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556162,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556168,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556172,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556178,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556182,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556188,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556192,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556198,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556202,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556208,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556215,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556220,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556226,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556230,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556236,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556240,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556246,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556254,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556264,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556274,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556284,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556294,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556304,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556314,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556324,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556334,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556343,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556352,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556359,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556368,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556378,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556388,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556397,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556403,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556409,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556415,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556420,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556425,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556431,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556435,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556441,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556444,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556450,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556454,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556460,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556464,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556469,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556474,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556479,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556484,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556489,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556494,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556499,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556504,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556509,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556514,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556519,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556524,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556529,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556534,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556538,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556543,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556548,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556553,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556558,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556563,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556568,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556573,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556578,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556583,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556588,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556593,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556598,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556603,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556608,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556613,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556618,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556623,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556628,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556633,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556638,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556643,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556647,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556653,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556660,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556665,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556670,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556675,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556680,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556685,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556690,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556695,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556700,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556705,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556710,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556715,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556721,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556726,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556732,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556736,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556742,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556746,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556752,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556759,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556764,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556770,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556774,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556780,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556785,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556791,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556798,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556803,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556809,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556813,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556819,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556823,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556829,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556833,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556839,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556843,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556849,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556853,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556858,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556863,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556867,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556872,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556877,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556882,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556892,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556897,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556902,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556907,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556912,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556917,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556922,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556927,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556932,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556937,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556942,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556947,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556952,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556957,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556962,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556967,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556972,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556977,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556982,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556987,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556992,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556997,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557002,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557007,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557012,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557017,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557022,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557027,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557032,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557037,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557042,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557047,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557052,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557057,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557062,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557067,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557072,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557077,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557082,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729934,
                                    "isTestReportAvailable": true,
                                    "duration": 1551,
                                    "duration_inMinutes": 25.85,
                                    "created_at": "Sep-27-21",
                                    "created_at_rawDateFormat": "2021-09-27T07:05:55.608Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 378001939,
                                "gitlabId": 378001939,
                                "status": "success",
                                "testReport": {
                                    "id": 46794,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54118,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3556712,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556706,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556702,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556696,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556692,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556686,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556319,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556315,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556309,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556305,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556299,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556295,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556289,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556285,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556421,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556430,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556440,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556449,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556459,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556468,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556478,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556488,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556498,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556508,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556518,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556528,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556537,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556547,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556557,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556567,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556577,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556587,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556597,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556607,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556617,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556627,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556637,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556646,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556652,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556656,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556662,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556666,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556672,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556676,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556682,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556869,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556874,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556879,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556884,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556889,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556894,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556899,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556904,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556909,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556914,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556919,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556169,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556163,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556159,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556153,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556149,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556143,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556139,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556133,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556128,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556121,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556115,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556111,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556105,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556101,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556095,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556091,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556085,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556081,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556075,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556071,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556065,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556061,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556055,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556924,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556929,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556007,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557059,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557054,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557049,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557044,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557039,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557034,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557029,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557024,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557019,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557014,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557009,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557004,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555968,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555973,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555978,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555983,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555988,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555993,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555998,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556004,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556027,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556033,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556040,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556045,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556050,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556411,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556401,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556393,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556387,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556382,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556376,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556371,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556364,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556358,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556354,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556348,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556344,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556338,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556335,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556329,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556325,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556850,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556844,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556840,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556834,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556830,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556824,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556820,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556814,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556810,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556934,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556939,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556944,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556949,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556954,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556959,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556279,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556275,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556269,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556265,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556259,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556173,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556179,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556186,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556191,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556197,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556201,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556207,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556211,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556217,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556221,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556227,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556234,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556239,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556245,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556249,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556255,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556964,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556969,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556974,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556979,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556984,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556989,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556994,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556999,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555949,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556804,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556800,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556794,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556790,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556784,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556781,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556775,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556771,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556765,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555944,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555939,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555934,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555929,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555924,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555919,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555914,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555909,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555903,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556013,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556017,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556023,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555963,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555953,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3555958,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556854,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556859,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556864,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556761,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556755,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556751,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556745,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556741,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556735,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556731,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556725,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556722,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556716,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729935,
                                    "isTestReportAvailable": true,
                                    "duration": 901,
                                    "duration_inMinutes": 15.02,
                                    "created_at": "Sep-27-21",
                                    "created_at_rawDateFormat": "2021-09-27T07:05:55.693Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 377943273,
                                "gitlabId": 377943273,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729936,
                                    "isTestReportAvailable": false,
                                    "duration": 914,
                                    "duration_inMinutes": 15.23,
                                    "created_at": "Sep-27-21",
                                    "created_at_rawDateFormat": "2021-09-27T07:05:55.744Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 377910539,
                                "gitlabId": 377910539,
                                "status": "success",
                                "testReport": {
                                    "id": 46782,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54122,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3560120,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559960,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559965,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559970,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559975,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559980,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559985,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559990,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559995,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560000,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560005,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560010,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560015,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560020,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560025,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560030,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560035,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560040,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560045,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560050,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560055,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560060,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560065,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560070,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560075,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560080,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560085,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560090,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560095,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560100,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560105,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560110,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560115,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560125,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560130,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560135,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560140,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560145,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560150,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560155,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560160,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560165,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560170,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560175,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560180,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560185,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560190,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560195,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560200,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560205,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560210,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560215,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560220,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560225,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560230,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560235,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560240,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560245,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560250,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560255,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560260,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560265,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560270,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560275,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560280,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560285,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560290,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560295,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560300,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560305,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560310,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560315,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560320,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560325,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560330,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560335,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560340,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560345,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560351,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560359,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560360,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560366,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560370,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560376,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560380,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560386,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560390,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560396,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560400,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560406,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560410,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560416,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560420,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560426,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560430,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560438,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560444,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560448,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560454,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560459,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560464,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560470,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560477,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560483,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560489,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560499,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560509,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560519,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560529,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560539,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560549,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560559,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560569,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560579,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560589,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560599,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560600,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560606,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560610,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560616,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560620,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560626,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560630,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560636,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560640,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560646,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560650,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560656,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560660,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560666,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560670,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560676,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560680,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560686,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560690,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560696,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560700,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560706,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560710,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560716,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560720,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560726,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560730,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560736,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560740,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560746,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560752,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560756,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560762,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560766,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560772,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560775,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560781,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560785,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560791,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560795,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560801,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560804,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560810,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560814,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560820,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560824,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560830,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560834,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560840,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560844,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560850,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560854,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560860,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560864,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560870,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560874,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560880,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560884,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560890,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560894,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560900,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560903,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560909,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560913,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560919,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560923,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560929,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560932,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560938,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560942,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560948,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560952,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560958,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560962,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560968,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560972,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560978,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560982,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560988,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560992,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560998,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561002,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561008,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561012,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561018,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561022,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561028,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561031,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561037,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729942,
                                    "isTestReportAvailable": true,
                                    "duration": 817,
                                    "duration_inMinutes": 13.62,
                                    "created_at": "Sep-27-21",
                                    "created_at_rawDateFormat": "2021-09-27T07:05:56.173Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 377908914,
                                "gitlabId": 377908914,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729937,
                                    "isTestReportAvailable": false,
                                    "duration": 71,
                                    "duration_inMinutes": 1.18,
                                    "created_at": "Sep-27-21",
                                    "created_at_rawDateFormat": "2021-09-27T07:05:55.759Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 377892603,
                                "gitlabId": 377892603,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729940,
                                    "isTestReportAvailable": false,
                                    "duration": 137,
                                    "duration_inMinutes": 2.28,
                                    "created_at": "Sep-27-21",
                                    "created_at_rawDateFormat": "2021-09-27T07:05:56.057Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 376951709,
                                "gitlabId": 376951709,
                                "status": "success",
                                "testReport": {
                                    "id": 46780,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54120,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3564095,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563905,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563910,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563915,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563920,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563925,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563930,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563935,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563940,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563945,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563950,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563955,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563960,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563965,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563970,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563975,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563980,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563985,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563990,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3563995,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564000,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564005,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564010,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564015,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564020,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564025,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564030,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564035,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564040,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564045,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564050,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564055,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564060,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564065,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564070,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564075,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564080,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564085,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564090,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564100,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564105,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564110,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564115,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564120,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564125,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564130,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564135,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564140,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564145,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564150,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564155,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564160,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564165,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564172,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564177,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564183,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564187,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564193,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564197,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564203,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564207,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564213,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564217,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564223,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564227,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564233,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564240,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564245,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564250,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564256,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564262,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564266,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564272,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564276,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564282,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564286,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564292,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564301,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564311,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564321,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564328,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564333,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564338,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564345,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564350,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564355,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564360,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564365,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564370,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564375,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564380,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564390,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564400,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564410,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564419,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564426,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564430,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564436,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564441,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564447,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564453,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564457,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564463,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564467,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564473,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564478,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564484,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564488,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564494,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564498,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564504,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564508,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564514,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564518,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564524,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564529,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564535,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564541,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564545,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564551,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564556,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564562,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564566,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564572,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564576,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564582,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564586,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564592,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564596,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564602,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564607,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564613,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564619,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564623,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564628,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564633,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564638,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564643,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564650,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564654,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564660,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564664,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564670,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564674,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564680,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564684,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564690,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564696,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564701,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564706,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564711,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564716,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564721,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564726,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564731,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564738,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564742,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564748,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564752,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564758,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564762,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564768,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564772,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564778,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564782,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564788,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564794,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564799,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564804,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564809,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564814,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564819,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564826,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564830,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564836,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564843,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564849,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564855,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564859,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564865,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564874,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564883,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564892,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564902,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564912,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564921,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564931,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564941,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564950,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564960,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564970,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564980,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564990,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565000,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565010,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565020,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565030,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565040,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565050,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565060,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565070,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565080,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565090,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565100,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565110,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729938,
                                    "isTestReportAvailable": true,
                                    "duration": 866,
                                    "duration_inMinutes": 14.43,
                                    "created_at": "Sep-24-21",
                                    "created_at_rawDateFormat": "2021-09-24T07:05:55.864Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 376657090,
                                "gitlabId": 376657090,
                                "status": "success",
                                "testReport": {
                                    "id": 46781,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54121,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3560036,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560041,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560046,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560553,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560557,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560563,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560567,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560573,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560316,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560311,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560306,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560301,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560577,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560583,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560587,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560593,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560597,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560605,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560715,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560725,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560735,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560744,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560750,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560760,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559931,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559936,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559941,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560615,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560625,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560635,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560645,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560655,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560665,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560675,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560685,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560695,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560705,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559796,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559791,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559786,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559781,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559776,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559771,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560507,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560503,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560497,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560493,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560156,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560449,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560439,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560429,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560425,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560419,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560414,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560409,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560404,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560399,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560394,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560389,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560383,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560379,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560373,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560369,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560363,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560357,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560353,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560346,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560341,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560336,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560331,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560326,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560321,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559886,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559891,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559896,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559901,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559906,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559911,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559916,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559921,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559926,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559866,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559861,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559856,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559851,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559846,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559841,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559836,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559831,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559826,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559821,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559816,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559811,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559806,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559801,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560151,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560146,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560141,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560136,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560131,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560126,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560121,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560116,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560111,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560106,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560101,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560096,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560091,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560086,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560513,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560517,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560523,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560527,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560533,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560537,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560081,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560076,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560071,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560066,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560061,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560056,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560051,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559946,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559951,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559956,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559961,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559966,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559971,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559751,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559756,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559761,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559766,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560487,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560478,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560468,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560458,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559976,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559981,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559986,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559991,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560296,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560291,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560286,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560281,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560276,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560271,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560266,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560261,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560256,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560251,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560246,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560241,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560236,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560231,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560226,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560221,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560216,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560211,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560206,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560201,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559881,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559876,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559871,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560196,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560191,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560186,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560181,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560176,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559996,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560001,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560171,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560166,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560161,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560769,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560779,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560789,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560798,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560807,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560817,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560827,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560837,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560847,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560857,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560867,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560877,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560887,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560896,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560906,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560916,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560925,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560935,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560945,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560955,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560965,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560975,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560985,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560995,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560006,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560011,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560016,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560021,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560026,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560543,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560547,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560031,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729939,
                                    "isTestReportAvailable": true,
                                    "duration": 1284,
                                    "duration_inMinutes": 21.4,
                                    "created_at": "Sep-24-21",
                                    "created_at_rawDateFormat": "2021-09-24T07:05:55.997Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 376145451,
                                "gitlabId": 376145451,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729941,
                                    "isTestReportAvailable": false,
                                    "duration": 1349,
                                    "duration_inMinutes": 22.48,
                                    "created_at": "Sep-23-21",
                                    "created_at_rawDateFormat": "2021-09-23T07:05:56.163Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 376133991,
                                "gitlabId": 376133991,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729944,
                                    "isTestReportAvailable": false,
                                    "duration": 868,
                                    "duration_inMinutes": 14.47,
                                    "created_at": "Sep-23-21",
                                    "created_at_rawDateFormat": "2021-09-23T07:05:56.201Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 373846577,
                                "gitlabId": 373846577,
                                "status": "success",
                                "testReport": {
                                    "id": 46787,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54123,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3564168,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564851,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564846,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564841,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564837,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564832,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564827,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564822,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564818,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564194,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564188,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564184,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564363,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564368,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564373,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564378,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564383,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564387,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564393,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564397,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564403,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564407,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564413,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564417,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564813,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564808,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564803,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564798,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564793,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564423,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564427,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564433,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564437,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564443,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564446,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565121,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565125,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565131,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564452,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564456,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564789,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564784,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564953,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564948,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564944,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564938,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564934,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564928,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564462,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564466,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564472,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564475,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564481,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564485,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564491,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564495,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564501,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564505,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564511,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564515,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564521,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564525,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564531,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564534,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564924,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564919,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564915,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564909,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564905,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564899,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564895,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564889,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564885,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564314,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564309,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564304,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564299,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564294,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564290,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564284,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564281,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564275,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564271,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564265,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564261,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565115,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565111,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565105,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565102,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565097,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565092,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565087,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565082,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565077,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565072,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565067,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565062,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565057,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565052,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565047,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565042,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565037,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565032,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565027,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565022,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565017,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565012,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565007,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565002,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564997,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564992,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564987,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564982,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564977,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564972,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564967,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564962,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564957,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564540,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564544,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564550,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564553,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564559,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564563,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564569,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564573,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564579,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564583,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564589,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564593,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564599,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564603,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564609,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564612,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564618,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564622,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564627,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564632,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564637,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564642,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564646,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564651,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564656,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564661,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564666,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564671,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564676,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564681,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564686,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564691,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564695,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564700,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564705,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564710,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564715,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564720,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564725,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564730,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564734,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564739,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564744,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564749,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564754,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564759,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564764,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564769,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564774,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564779,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564255,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564252,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564246,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564242,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564089,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564178,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564174,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564099,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564109,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564329,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564334,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564339,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564343,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564348,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564353,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564119,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564129,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564139,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564149,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564159,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564236,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564879,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564325,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564319,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564876,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564870,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564232,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564226,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564358,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564221,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564216,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564211,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564204,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564198,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564861,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564866,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564856,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729943,
                                    "isTestReportAvailable": true,
                                    "duration": 831,
                                    "duration_inMinutes": 13.85,
                                    "created_at": "Sep-20-21",
                                    "created_at_rawDateFormat": "2021-09-20T07:05:56.180Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 373830666,
                                "gitlabId": 373830666,
                                "status": "success",
                                "testReport": {
                                    "id": 46788,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54124,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3556427,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557180,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557170,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557160,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557150,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557140,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557130,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557120,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557110,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557100,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557090,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557080,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557070,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556817,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556822,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556827,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556832,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556837,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556842,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556847,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556852,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556860,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556870,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556880,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556890,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556900,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556910,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556920,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556930,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556940,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556950,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556960,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556970,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556980,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556990,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557000,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557010,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557020,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557030,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557040,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557050,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557060,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556224,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556229,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556233,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556238,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556243,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556361,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556366,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556370,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556375,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556380,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556385,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556390,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556395,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556399,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556405,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556408,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556414,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556418,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556424,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556433,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556437,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556443,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556447,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556453,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556456,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556462,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556466,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556472,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556476,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556482,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556486,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556492,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556496,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556502,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556016,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556020,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556025,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556219,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556214,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556210,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556205,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556200,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556195,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556190,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556185,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556181,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556176,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556171,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556166,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556161,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556156,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556151,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556146,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556142,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556137,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556132,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556127,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556123,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556118,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556113,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556108,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556104,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556099,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556248,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556252,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556258,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556262,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556268,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556272,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556278,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556282,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556288,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556292,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556298,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556302,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556308,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556312,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556318,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556321,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556327,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556331,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556337,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556341,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556347,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556350,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556356,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556506,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556512,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556516,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556522,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556526,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556532,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556536,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556542,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556546,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556552,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556556,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556562,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556566,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556572,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556576,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556582,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556586,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556592,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556596,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556602,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556606,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556612,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556616,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556622,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556625,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556631,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556635,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556641,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556645,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556650,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556655,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556030,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556035,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556039,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556044,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556049,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556054,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556059,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556064,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556069,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556074,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556079,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556084,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556089,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556094,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556659,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556664,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556669,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556674,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556679,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556684,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556689,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556694,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556699,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556704,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556709,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556714,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556719,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556724,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556729,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556734,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556739,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556744,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556749,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556754,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556758,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556763,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556768,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556773,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556778,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556783,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556788,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556793,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556797,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556802,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556807,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556812,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729945,
                                    "isTestReportAvailable": true,
                                    "duration": 853,
                                    "duration_inMinutes": 14.22,
                                    "created_at": "Sep-20-21",
                                    "created_at_rawDateFormat": "2021-09-20T07:05:56.276Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 371132123,
                                "gitlabId": 371132123,
                                "status": "success",
                                "testReport": {
                                    "id": 46784,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54125,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3565143,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564231,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564222,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564724,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564733,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564743,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564753,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564763,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564773,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564783,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564792,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565445,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565440,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565310,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565314,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565319,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565435,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565324,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565329,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564212,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564202,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564192,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564182,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564173,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564128,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564134,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564138,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564144,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564148,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564154,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564158,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564164,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565430,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565541,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565536,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565532,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565527,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565522,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565517,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565513,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565508,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565503,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565498,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565494,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565489,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565484,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565479,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565475,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565426,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565421,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565416,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565411,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565407,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565402,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565397,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565392,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565387,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565382,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565377,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565372,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565368,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565363,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565358,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565353,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564963,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564958,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564952,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564943,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564933,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564923,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564914,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564904,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564894,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564886,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564880,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564875,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564869,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564860,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564850,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564840,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564831,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564821,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564812,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564802,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565333,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565338,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565343,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565348,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564422,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564432,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564442,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564451,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564461,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564471,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564480,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564490,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564500,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564510,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564520,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564530,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564539,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564549,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564558,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564568,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564578,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564588,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564598,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564608,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564617,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564626,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564241,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565139,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565133,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565126,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565116,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565107,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565098,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565093,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565088,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565083,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565078,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565073,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565153,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565163,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565173,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565183,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565190,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565194,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565200,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565204,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565210,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565214,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565220,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565224,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565230,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565235,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565240,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565246,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565253,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565259,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565264,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565269,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565275,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565280,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565286,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565290,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565295,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565300,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565305,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564636,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564645,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564655,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564665,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565470,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565465,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565460,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565455,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565450,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565068,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565063,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565058,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565053,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565048,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565043,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565038,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565033,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565028,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565023,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565018,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565013,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565008,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565003,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564998,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564993,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564988,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564983,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564978,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564973,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564968,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564675,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564685,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564694,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564704,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564714,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564409,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564415,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564405,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564399,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564395,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564389,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564385,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564377,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564367,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564357,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564347,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564337,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564327,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564318,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564308,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564298,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564289,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564280,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564270,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564260,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564251,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729949,
                                    "isTestReportAvailable": true,
                                    "duration": 877,
                                    "duration_inMinutes": 14.62,
                                    "created_at": "Sep-15-21",
                                    "created_at_rawDateFormat": "2021-09-15T07:05:56.515Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 368706916,
                                "gitlabId": 368706916,
                                "status": "success",
                                "testReport": {
                                    "id": 46785,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54126,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3560792,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560802,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560808,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560818,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560828,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560838,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560848,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560858,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560868,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560878,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560888,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560898,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560907,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560917,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560927,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560936,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560946,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560956,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560966,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560976,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560986,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560996,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561006,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561016,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561026,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561035,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561045,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561054,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561064,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561074,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560002,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560007,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560012,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560017,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560022,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560027,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560032,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560037,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560042,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560047,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560052,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560057,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560062,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560067,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560072,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560558,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560548,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560538,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560528,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560518,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560508,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560498,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560488,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560479,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560469,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560460,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560450,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560440,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560433,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560423,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560413,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560403,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560393,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560384,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560102,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560097,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560092,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560087,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560082,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560077,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561275,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561279,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561285,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561291,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561250,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561245,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561240,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561235,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561230,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561225,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561220,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561215,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561210,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561205,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561200,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561195,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561190,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561185,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561180,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561175,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561170,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561165,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561160,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561155,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561150,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561145,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561140,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561135,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560631,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560637,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560641,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560647,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560651,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560657,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560661,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560667,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560671,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560677,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560681,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560687,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560691,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560697,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560701,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560707,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560711,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560717,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560721,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560727,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560731,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560737,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560741,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560747,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560753,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560757,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560763,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560767,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560773,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560776,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560782,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560786,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561255,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561260,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561265,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561270,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560627,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560621,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560617,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560611,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560607,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560601,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560598,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560588,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560578,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560568,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561130,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561125,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561120,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561112,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561103,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561093,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561083,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560374,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560364,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560354,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560350,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560347,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560342,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560337,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560332,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560327,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560322,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560317,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560312,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560307,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560302,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560297,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560292,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560287,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560282,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560277,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560272,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560267,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560262,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560232,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560227,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560222,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560217,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560212,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560207,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560202,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560197,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560192,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560187,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560182,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560177,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560172,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560167,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560162,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560157,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560152,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560147,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560142,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560137,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560132,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560127,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560122,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560117,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560112,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560107,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560257,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560252,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560247,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560242,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560237,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560796,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729951,
                                    "isTestReportAvailable": true,
                                    "duration": 839,
                                    "duration_inMinutes": 13.98,
                                    "created_at": "Sep-10-21",
                                    "created_at_rawDateFormat": "2021-09-10T07:05:56.708Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 368696706,
                                "gitlabId": 368696706,
                                "status": "success",
                                "testReport": {
                                    "id": 46786,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54127,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3564257,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565428,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565438,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565448,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565458,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565468,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565477,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565487,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565496,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565506,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565515,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564440,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564431,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564421,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564412,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564402,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564392,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564382,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564372,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564362,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564352,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564342,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564332,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564324,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564320,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564315,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564310,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564305,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564300,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564295,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564291,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564285,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564277,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564267,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564247,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564237,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564228,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564218,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564208,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564199,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564189,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564179,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564169,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565162,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565157,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565152,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565147,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565129,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565124,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565119,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565112,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565106,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565101,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565096,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565091,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565086,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565081,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565076,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565071,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565066,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565061,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565056,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565051,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565046,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565041,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565036,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565031,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565026,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565021,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565016,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565011,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565006,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565001,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564996,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564991,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565142,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565138,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565132,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564986,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564981,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564976,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564971,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564966,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564961,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564956,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564951,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564946,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564940,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564935,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564929,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564925,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564918,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564913,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564908,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564903,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564898,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564893,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564888,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564884,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564878,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564873,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564867,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564862,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564857,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564852,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564847,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564842,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564838,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564833,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564828,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564823,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565167,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565171,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565176,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565181,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565186,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565193,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565199,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565203,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565209,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565213,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565219,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565223,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565229,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565233,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565239,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565243,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565249,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565252,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565258,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565262,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565268,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565272,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565278,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565284,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565293,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565303,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565312,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565322,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564817,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564811,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564807,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564801,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564797,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564790,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564785,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564780,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564775,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564770,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564765,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564760,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564755,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564750,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564745,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564740,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564735,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564729,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564723,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564719,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564713,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564709,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564703,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564699,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564692,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564687,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564682,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564677,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564672,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564667,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564662,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564657,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564652,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564647,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564641,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564635,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564631,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564625,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564616,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564606,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564597,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564587,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564577,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564567,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564557,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564547,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564538,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564528,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564519,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564509,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564499,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564489,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565331,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565341,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565351,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565361,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565370,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565380,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565390,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565400,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565409,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565419,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564479,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564469,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564460,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564450,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729948,
                                    "isTestReportAvailable": true,
                                    "duration": 903,
                                    "duration_inMinutes": 15.05,
                                    "created_at": "Sep-10-21",
                                    "created_at_rawDateFormat": "2021-09-10T07:05:56.463Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 366458570,
                                "gitlabId": 366458570,
                                "status": "success",
                                "testReport": {
                                    "id": 46789,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54129,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3557063,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557068,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557073,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557078,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557083,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557088,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557093,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557098,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557103,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557108,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557663,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557657,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557653,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557647,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557643,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557637,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557633,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557627,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557624,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557618,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557609,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557599,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557590,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557580,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557570,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557560,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557551,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557541,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557532,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557522,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557512,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557502,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557492,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557483,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557473,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557464,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557454,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557445,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557435,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557426,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557416,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557406,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557397,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557387,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557378,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557368,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557358,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557348,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557339,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557329,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557319,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557310,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557300,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557291,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557281,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557113,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557118,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557123,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557128,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557133,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557138,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557143,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557148,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557153,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557158,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557163,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557168,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557273,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557268,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557263,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557258,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557253,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557248,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557243,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557238,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557233,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557228,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557223,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557218,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557213,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557208,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557203,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557198,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557193,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557188,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557183,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557178,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556517,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556513,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556507,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556503,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556497,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556493,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556487,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556483,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556477,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556473,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556467,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556458,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556448,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556438,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556429,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556419,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556273,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556283,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556293,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556303,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556313,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556323,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556332,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556342,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556353,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557173,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556998,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557003,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557008,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557013,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557018,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557023,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557028,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557033,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556769,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556779,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556789,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556799,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556808,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556818,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556828,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556838,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556848,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556857,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556862,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556868,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556873,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556878,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556883,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556888,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556893,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556898,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556903,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556908,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556913,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556918,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556923,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556928,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556933,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556938,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556943,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556948,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556953,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556958,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556963,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556968,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556973,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556978,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556983,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556988,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556993,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557038,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556701,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556711,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556720,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556730,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556740,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556750,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556760,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556691,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556681,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556671,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556661,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556651,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556642,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556636,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556632,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556626,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556619,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556614,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556609,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556604,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556599,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556594,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556589,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556410,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556400,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556391,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556381,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556372,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556362,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556584,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556579,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556574,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556569,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556564,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556559,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556554,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556549,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556544,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556539,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556533,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556527,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556523,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557043,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557048,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557053,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557058,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729946,
                                    "isTestReportAvailable": true,
                                    "duration": 1461,
                                    "duration_inMinutes": 24.35,
                                    "created_at": "Sep-07-21",
                                    "created_at_rawDateFormat": "2021-09-07T07:05:56.425Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 366444479,
                                "gitlabId": 366444479,
                                "status": "success",
                                "testReport": {
                                    "id": 46790,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54128,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3557076,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556320,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556326,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556330,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556336,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556340,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556346,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556349,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556355,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556360,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556365,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556369,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556374,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556379,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556384,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556389,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556394,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556398,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556404,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556407,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556413,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556417,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556423,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556426,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556432,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556436,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556442,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556446,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556452,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556455,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556461,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556465,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556471,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556475,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556481,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556485,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556491,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556495,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556501,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556505,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556511,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556515,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556521,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556525,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556531,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556535,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556541,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556545,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556551,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556555,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556561,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556565,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556571,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556575,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556581,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556585,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556591,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556595,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556601,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556605,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556611,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556615,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556621,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556624,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556630,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556634,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556640,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556644,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556649,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556654,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556658,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556663,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556668,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556673,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556678,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556683,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556688,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556693,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556698,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556703,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556708,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556713,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556718,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556723,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556728,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556733,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556738,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556743,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556748,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556753,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556757,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556762,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556767,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556772,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556777,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556782,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556787,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556792,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556796,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556801,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556806,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556811,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556816,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556821,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556826,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556831,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556836,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556841,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556846,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556851,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556856,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556861,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556866,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556871,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556876,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556881,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556886,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556891,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556896,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556901,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556906,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556911,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556916,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556921,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556926,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556931,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556936,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556941,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556946,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556951,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556956,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556961,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556966,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556971,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556976,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556981,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556986,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556991,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556996,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557001,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557006,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557011,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557016,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557021,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557026,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557031,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557036,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557041,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557046,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557051,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557056,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557061,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557066,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557071,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557081,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557086,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557091,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557096,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557101,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557106,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557111,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557116,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557121,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557126,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557131,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557136,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557141,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557146,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557151,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557156,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557161,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557166,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557171,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557176,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556170,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556175,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556180,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556184,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556189,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556194,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556199,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556204,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556209,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556213,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556218,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556223,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556228,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556232,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556237,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556242,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556247,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556251,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556257,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556261,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556267,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556271,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556277,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556281,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556287,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556291,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556297,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556301,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556307,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556311,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556317,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729947,
                                    "isTestReportAvailable": true,
                                    "duration": 976,
                                    "duration_inMinutes": 16.27,
                                    "created_at": "Sep-07-21",
                                    "created_at_rawDateFormat": "2021-09-07T07:05:56.456Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 365980046,
                                "gitlabId": 365980046,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729950,
                                    "isTestReportAvailable": false,
                                    "duration": 1482,
                                    "duration_inMinutes": 24.7,
                                    "created_at": "Sep-06-21",
                                    "created_at_rawDateFormat": "2021-09-06T07:05:56.615Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 365915798,
                                "gitlabId": 365915798,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729953,
                                    "isTestReportAvailable": false,
                                    "duration": 1526,
                                    "duration_inMinutes": 25.43,
                                    "created_at": "Sep-06-21",
                                    "created_at_rawDateFormat": "2021-09-06T07:05:56.835Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 364975870,
                                "gitlabId": 364975870,
                                "status": "success",
                                "testReport": {
                                    "id": 46791,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54132,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3561374,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561364,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561244,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561249,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561254,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561259,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561264,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561269,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561274,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561280,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561284,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561289,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561294,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561299,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561304,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561309,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561314,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561319,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561324,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561329,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561334,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561339,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561344,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561349,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561354,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561359,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560467,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560473,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560476,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560482,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560486,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560492,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560496,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560502,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560506,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560512,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560516,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560522,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560526,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560532,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560536,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560542,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560546,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560552,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560398,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560402,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560408,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560412,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560556,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560562,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560566,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560572,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560576,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560582,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560586,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560592,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560596,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560603,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560609,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560613,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560619,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560623,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560629,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560633,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560639,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560643,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560649,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560653,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560659,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560663,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560669,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560673,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560679,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560683,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560689,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560338,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560693,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560699,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560703,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560709,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560713,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560719,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560724,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560729,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560734,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560739,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560749,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560758,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560768,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560778,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560787,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560797,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560806,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560812,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560816,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560822,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560826,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560832,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560836,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560842,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560846,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560852,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560856,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560862,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560866,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560872,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560876,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560882,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560886,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560428,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560422,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560328,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560318,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560308,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560298,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560288,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560358,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560362,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560368,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560372,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560378,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560418,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560382,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560388,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560392,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560432,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560437,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560443,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560447,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560453,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560457,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560463,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560892,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560897,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560905,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560911,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560915,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560921,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560926,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560934,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560940,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560944,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560950,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560954,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560960,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560964,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560970,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560974,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560980,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560984,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560990,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560994,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561000,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561004,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561010,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561014,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561020,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561025,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561032,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561038,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561042,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560348,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561048,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561051,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561057,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561061,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561067,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561071,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561077,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561080,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561086,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561090,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561096,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561100,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561106,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561110,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561115,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561119,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561124,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561129,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561134,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561139,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561144,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561149,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561154,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561159,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561164,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561169,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561174,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561179,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561184,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561189,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561194,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561199,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561204,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561209,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561214,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561219,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561224,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561229,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561234,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561239,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561384,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561379,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561369,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729952,
                                    "isTestReportAvailable": true,
                                    "duration": 968,
                                    "duration_inMinutes": 16.13,
                                    "created_at": "Sep-03-21",
                                    "created_at_rawDateFormat": "2021-09-03T07:05:56.760Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 364966637,
                                "gitlabId": 364966637,
                                "status": "success",
                                "testReport": {
                                    "id": 46792,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54130,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3564882,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564887,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564891,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564897,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564900,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564906,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564910,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564916,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564920,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564926,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564930,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564936,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564939,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564945,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564949,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564954,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564959,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564964,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564969,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564974,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564979,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564984,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564989,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564994,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564999,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565004,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565009,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565014,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565019,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565024,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564693,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564689,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564683,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564679,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564673,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564669,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564663,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565029,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565034,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565039,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565044,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565049,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565054,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565059,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565064,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565069,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565074,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565079,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565084,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565089,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565094,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565686,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565682,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565676,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565673,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565667,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565663,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565659,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565653,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565649,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565643,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565639,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565634,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565629,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565624,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565619,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565614,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565178,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565188,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565191,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565197,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565201,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565207,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565211,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565217,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565260,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565256,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565250,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565247,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565241,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565237,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565231,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565227,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565401,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565396,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565391,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565386,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565381,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565376,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565371,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565609,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565604,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565599,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565594,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565589,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565406,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565410,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565415,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565420,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565425,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565429,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565434,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565439,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565444,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565449,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565454,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565459,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565464,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565469,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565474,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565478,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565483,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565488,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565493,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565497,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565502,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565507,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565512,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565367,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565362,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565357,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565521,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565564,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565559,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565554,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565550,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565545,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565540,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565266,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565270,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565276,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565279,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565285,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565289,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565294,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565299,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565304,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565309,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565313,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565318,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565323,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565328,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564698,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564702,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564708,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564712,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564718,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564722,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564728,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564732,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564737,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564741,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564747,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564751,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564757,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564761,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564767,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564771,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564777,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565221,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564781,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564787,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564791,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564796,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564800,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564806,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564810,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564816,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564820,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564825,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564829,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564835,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564839,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564845,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564848,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565332,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565337,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565342,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565347,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565352,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565535,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565531,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565526,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565516,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565584,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565579,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565574,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565569,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564868,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564877,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564858,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564864,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564872,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565099,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565103,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565108,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565113,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565117,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565122,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565127,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565137,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565148,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565158,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565168,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564854,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729956,
                                    "isTestReportAvailable": true,
                                    "duration": 1355,
                                    "duration_inMinutes": 22.58,
                                    "created_at": "Sep-03-21",
                                    "created_at_rawDateFormat": "2021-09-03T07:05:56.952Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 364964765,
                                "gitlabId": 364964765,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729954,
                                    "isTestReportAvailable": false,
                                    "duration": 103,
                                    "duration_inMinutes": 1.72,
                                    "created_at": "Sep-03-21",
                                    "created_at_rawDateFormat": "2021-09-03T07:05:56.880Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 364924919,
                                "gitlabId": 364924919,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729955,
                                    "isTestReportAvailable": false,
                                    "duration": 1159,
                                    "duration_inMinutes": 19.32,
                                    "created_at": "Sep-03-21",
                                    "created_at_rawDateFormat": "2021-09-03T07:05:56.904Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 364908914,
                                "gitlabId": 364908914,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729957,
                                    "isTestReportAvailable": false,
                                    "duration": 1301,
                                    "duration_inMinutes": 21.68,
                                    "created_at": "Sep-03-21",
                                    "created_at_rawDateFormat": "2021-09-03T07:05:56.972Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 359731760,
                                "gitlabId": 359731760,
                                "status": "success",
                                "testReport": {
                                    "id": 46802,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54131,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3560545,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560541,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560535,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560531,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560525,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560521,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560515,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560511,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560505,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560501,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561485,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561475,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561465,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561455,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561445,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561435,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561425,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561415,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561405,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561395,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561385,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561375,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561365,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561355,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560495,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560491,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560485,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560481,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560475,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560472,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560466,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560462,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560901,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560895,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560891,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560885,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560881,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560875,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560871,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560865,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560861,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560855,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560851,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560845,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560841,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560835,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560831,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560825,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560821,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560815,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560811,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560805,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560799,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560793,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560788,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560783,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560777,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560770,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560764,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560759,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560754,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560748,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560173,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560183,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560193,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560203,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560213,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560223,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560233,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560243,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560253,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560263,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560273,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560283,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560293,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560303,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560313,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560323,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560333,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560343,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560352,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560355,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560365,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560375,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560385,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560395,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560405,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560415,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560424,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560163,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560153,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560143,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560133,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560123,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560113,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560103,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560742,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560738,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560732,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560728,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560722,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560718,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560712,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560708,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560702,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560698,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560692,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560688,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560682,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560678,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560672,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560668,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560662,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560658,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560652,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560648,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560642,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560638,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560632,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560628,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561087,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561091,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561097,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561102,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561107,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561116,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561126,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561136,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561146,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561156,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561166,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561176,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561186,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561196,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561206,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561216,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561226,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561236,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561246,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561256,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561266,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561276,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561286,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561295,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561305,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561315,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561325,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561335,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561345,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560434,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560436,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560442,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560446,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560452,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560456,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560622,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560618,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560612,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560608,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560602,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560595,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561062,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561068,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561073,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561081,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561058,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561052,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561044,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561039,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561033,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561029,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560591,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561023,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561019,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561013,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561009,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561003,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560999,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560993,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560989,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560983,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560979,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560973,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560969,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560963,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560959,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560953,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560949,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560943,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560939,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560933,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560930,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560924,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560920,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560914,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560910,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560904,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560585,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560581,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560575,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560571,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560565,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560561,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560555,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560551,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729963,
                                    "isTestReportAvailable": true,
                                    "duration": 1035,
                                    "duration_inMinutes": 17.25,
                                    "created_at": "Aug-26-21",
                                    "created_at_rawDateFormat": "2021-08-26T07:05:57.308Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 355439205,
                                "gitlabId": 355439205,
                                "status": "success",
                                "testReport": {
                                    "id": 46793,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54133,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3565803,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565267,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565271,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565277,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565282,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565288,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565297,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565307,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565316,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565326,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565335,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565345,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565355,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565365,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565375,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565384,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565394,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565404,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565413,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565423,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565432,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565442,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565452,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565462,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565472,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565481,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565491,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565500,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565510,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565519,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565529,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565538,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565548,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565557,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565562,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565567,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565572,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565577,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565582,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565587,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565592,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565597,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565602,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565607,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565612,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565617,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565622,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565627,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565632,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565637,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565646,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565656,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565665,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565670,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565675,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565680,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565685,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565693,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565703,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565713,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565723,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565733,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565743,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565753,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565763,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565773,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565783,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565793,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565813,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565823,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565833,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565843,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565852,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565862,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565872,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565882,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565892,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565898,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565902,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565908,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565912,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565918,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565922,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565927,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565931,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565936,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565941,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565946,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565951,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565956,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565961,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565966,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565969,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565974,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565979,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565987,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565996,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566005,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566015,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566025,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566035,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566045,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566055,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566064,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566074,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566084,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566093,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566103,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566113,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566123,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566132,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566142,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566152,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566162,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566171,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566181,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566191,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566200,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566210,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566219,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566229,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566239,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566248,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566258,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566268,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566278,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566288,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566297,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566303,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566307,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566313,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566317,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566323,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566327,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566333,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566337,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566343,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566348,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566354,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566361,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566371,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566381,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566390,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566400,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564863,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564871,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564881,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564890,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564896,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564901,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564907,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564911,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564917,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564922,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564927,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564932,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564937,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564942,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564947,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564955,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564965,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564975,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564985,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3564995,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565005,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565015,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565025,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565035,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565045,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565055,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565065,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565075,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565085,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565095,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565104,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565109,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565114,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565118,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565123,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565128,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565134,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565144,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565149,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565154,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565159,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565164,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565172,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565177,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565182,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565187,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565192,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565198,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565202,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565208,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565212,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565218,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565222,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565228,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565232,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565238,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565242,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565248,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565251,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565257,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565261,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729958,
                                    "isTestReportAvailable": true,
                                    "duration": 1006,
                                    "duration_inMinutes": 16.77,
                                    "created_at": "Aug-18-21",
                                    "created_at_rawDateFormat": "2021-08-18T07:05:57.146Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 330158740,
                                "gitlabId": 330158740,
                                "status": "success",
                                "testReport": {
                                    "id": 46795,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54134,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3556975,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556965,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556955,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556945,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556935,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556925,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556915,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557225,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557235,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557245,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557255,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557265,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557275,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557284,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557294,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557303,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557313,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557322,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557332,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557342,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557351,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557361,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557371,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557381,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557390,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557400,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557409,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557419,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557429,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557438,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557448,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557457,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557467,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557476,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557486,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557496,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557505,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557515,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557525,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557535,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557544,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557554,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557564,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557573,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557583,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556905,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556895,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556885,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556875,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556865,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557593,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557602,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557612,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557620,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557630,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557640,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557650,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557660,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557670,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557680,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557690,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557700,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557709,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557719,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557728,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557738,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557747,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557757,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557766,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557776,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557786,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557796,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557805,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557815,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557825,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557834,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557844,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557854,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557863,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557873,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557882,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557892,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557901,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557911,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556855,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556845,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556835,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556825,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556815,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556805,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556795,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556786,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556776,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556766,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556756,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556747,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556737,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556727,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556717,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556707,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556697,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556687,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556677,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556667,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556657,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556648,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556639,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556629,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556620,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556610,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556600,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556590,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556580,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556570,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556560,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556550,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556540,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556530,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556520,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556510,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556500,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556490,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556480,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556470,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556463,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556457,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556451,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556445,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556439,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556434,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556428,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556422,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556416,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556412,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556406,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557215,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557205,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557195,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557185,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557175,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557165,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557155,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557145,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557135,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557125,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557115,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557105,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557095,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557085,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557075,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557065,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557055,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557045,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557035,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557025,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557015,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557005,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556995,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3556985,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558202,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558124,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558119,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558114,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558108,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558102,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558097,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558091,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558082,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558072,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558063,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558053,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558044,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558034,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558025,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558015,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557920,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557930,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557939,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557949,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557958,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557968,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557977,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557987,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557996,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558006,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558232,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558227,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558222,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558217,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558212,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558207,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558197,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558191,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558187,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558181,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558176,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558169,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558164,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558159,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558154,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558149,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558144,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558139,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558134,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558129,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729959,
                                    "isTestReportAvailable": true,
                                    "duration": 999,
                                    "duration_inMinutes": 16.65,
                                    "created_at": "Jul-01-21",
                                    "created_at_rawDateFormat": "2021-07-01T07:05:57.153Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 330139989,
                                "gitlabId": 330139989,
                                "status": "success",
                                "testReport": {
                                    "id": 46796,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54135,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3565601,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565606,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565611,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565616,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565621,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565626,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565631,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565636,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565641,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565645,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565651,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565655,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565661,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565669,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565169,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565533,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565539,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565543,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565549,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565556,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565561,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565566,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565571,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565576,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565581,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565586,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565591,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565165,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566230,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565292,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565283,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565274,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565265,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565255,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566225,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566220,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566216,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566211,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566206,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566201,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566197,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565679,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566259,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566264,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565216,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565206,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565412,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565688,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565698,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565708,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565718,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565447,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565453,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565457,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565463,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565467,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565473,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565480,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565485,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565490,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565495,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565501,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565505,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565511,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565518,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565523,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565528,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565160,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565155,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565150,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565145,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565141,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565136,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565130,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565120,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566269,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566274,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566279,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566284,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566289,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566294,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566298,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566304,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565196,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565728,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565738,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565189,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565184,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565179,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565174,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565443,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565437,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565433,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566192,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566187,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566182,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566177,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566172,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566168,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565298,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565302,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565308,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565315,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565320,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565325,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565330,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565336,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565340,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565346,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565350,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565356,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565360,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565366,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565374,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565379,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565385,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566163,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566158,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565930,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565926,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565921,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565917,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565911,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566249,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566254,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566235,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566240,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566245,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565907,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565901,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565897,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565889,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565879,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565874,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565869,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565864,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565859,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565854,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565848,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565838,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565828,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565818,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565808,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565798,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565788,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565778,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565768,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565758,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565748,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565226,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565236,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565245,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566153,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566148,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566085,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566080,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566075,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566070,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566065,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566061,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566056,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566051,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566046,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566041,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566036,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566031,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566026,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566021,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566016,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566011,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566006,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566001,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565997,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565992,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565988,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565983,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565978,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565972,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565968,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565960,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566143,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566138,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566133,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566129,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566124,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566119,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566114,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566109,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566104,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566099,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566094,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566090,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565389,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565395,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565399,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565405,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565935,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565940,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565945,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565950,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565955,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565417,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565422,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565427,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565596,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729960,
                                    "isTestReportAvailable": true,
                                    "duration": 1386,
                                    "duration_inMinutes": 23.1,
                                    "created_at": "Jul-01-21",
                                    "created_at_rawDateFormat": "2021-07-01T07:05:57.161Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 325866454,
                                "gitlabId": 325866454,
                                "status": "success",
                                "testReport": {
                                    "id": 46798,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54136,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3560951,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561137,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561132,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561127,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561122,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561117,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560928,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560922,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560918,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560912,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560908,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560902,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560899,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560893,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560889,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560883,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560554,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560550,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560544,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560540,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560534,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561386,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561381,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561376,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561371,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561366,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561361,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561356,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561351,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561346,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561341,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561336,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561331,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561326,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561257,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561262,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561267,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561560,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561566,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561571,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561577,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561581,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560761,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560765,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560771,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560931,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560500,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560504,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560510,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560514,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560520,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561182,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561187,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561192,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561197,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561202,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561207,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561212,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561456,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561451,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561446,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561441,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561436,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561431,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561426,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561421,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561416,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561411,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561406,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561401,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561252,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561247,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561242,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561237,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561232,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561227,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560774,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560780,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560784,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560790,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560794,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560800,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560803,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560809,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560813,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560819,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560823,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560829,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560833,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560839,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560843,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560849,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560853,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560859,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560863,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560869,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560873,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560879,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561272,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561147,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561152,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561157,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561162,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561113,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561108,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561104,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561098,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561094,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561088,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561084,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561078,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561075,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561069,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561065,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560560,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560564,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560570,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560574,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560580,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560584,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560590,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560594,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560604,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560614,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561396,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561391,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561059,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560530,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560524,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561277,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561282,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561287,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561292,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561296,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561301,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561306,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561311,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561316,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561321,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561556,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561551,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561546,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561541,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561536,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561531,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561526,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561521,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561516,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561511,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561506,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561501,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561496,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561491,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561486,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561481,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561476,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561471,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561466,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561222,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561217,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561461,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561167,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561172,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561177,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561055,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561049,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561046,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561040,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561036,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561030,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561027,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561021,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561017,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561011,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561007,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561001,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560997,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560991,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560987,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560981,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560977,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560971,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560967,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560961,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560957,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561142,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560947,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560941,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560937,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560624,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560634,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560644,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560654,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560664,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560674,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560684,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560694,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560704,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560714,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560723,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560733,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560743,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560745,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560751,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3560755,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729961,
                                    "isTestReportAvailable": true,
                                    "duration": 2021,
                                    "duration_inMinutes": 33.68,
                                    "created_at": "Jun-23-21",
                                    "created_at_rawDateFormat": "2021-06-23T07:05:57.219Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 325823399,
                                "gitlabId": 325823399,
                                "status": "success",
                                "testReport": {
                                    "id": 46799,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54137,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3565799,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565809,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565441,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565436,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565608,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565618,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565971,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565965,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565959,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565949,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565939,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565929,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565920,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565914,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565910,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565904,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565900,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565894,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565888,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565884,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565878,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565873,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565868,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565863,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565858,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565853,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565849,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565844,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565839,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565834,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565829,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565824,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565819,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565814,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565234,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565244,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565254,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565263,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565135,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565140,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565146,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565151,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565156,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565161,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565166,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565170,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565175,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565180,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565185,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565195,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565205,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565215,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565225,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565431,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565424,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565418,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565414,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565408,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565403,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565398,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565393,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565388,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565383,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565378,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565373,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565369,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565364,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565359,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565354,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565349,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565344,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565339,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565334,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565327,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565321,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565317,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565311,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565648,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565658,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565666,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566190,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566186,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566180,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566176,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566170,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566166,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566160,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566156,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566150,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566146,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566140,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566134,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566128,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566122,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566118,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566112,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566108,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566102,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566095,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566089,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566083,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566079,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566071,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566066,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566060,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566054,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566050,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566044,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566040,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566034,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566030,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566024,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565628,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565638,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565273,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565281,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565287,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565291,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565296,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565301,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565306,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566311,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566306,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566301,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566296,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566292,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566286,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566282,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566276,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566272,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566266,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566262,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566256,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566253,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566247,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566243,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565672,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566237,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566020,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566014,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566010,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566004,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565995,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565986,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565981,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565976,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566233,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566228,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566224,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566218,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566214,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566208,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566202,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566196,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565446,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565451,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565456,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565461,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565466,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565471,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565476,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565482,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565486,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565492,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565499,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565504,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565509,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565514,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565520,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565524,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565530,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565537,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565542,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565547,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565552,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565558,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565568,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565578,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565588,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565598,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565779,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565784,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565789,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565794,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565804,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565678,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565684,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565689,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565694,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565699,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565704,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565709,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565714,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565719,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565724,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565729,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565734,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565739,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565744,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565749,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565754,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565759,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565764,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565769,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565774,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729962,
                                    "isTestReportAvailable": true,
                                    "duration": 2259,
                                    "duration_inMinutes": 37.65,
                                    "created_at": "Jun-23-21",
                                    "created_at_rawDateFormat": "2021-06-23T07:05:57.281Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 325787236,
                                "gitlabId": 325787236,
                                "status": "success",
                                "testReport": {
                                    "id": 46797,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54139,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3558123,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558118,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558113,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558104,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558099,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558094,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558148,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558143,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558089,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558085,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558079,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558074,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558051,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558047,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558109,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558068,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558062,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558057,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558138,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558133,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558128,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557685,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557679,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557675,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557669,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557665,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557659,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557655,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557649,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557644,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557638,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557634,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557628,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557622,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557227,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557222,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557217,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557087,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557092,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557212,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557207,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557202,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557197,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557192,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557187,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557242,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557247,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557252,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557257,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557262,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557267,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557272,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557277,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557283,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557288,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557293,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557298,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557305,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557309,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557315,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557321,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557326,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557331,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557336,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557341,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557346,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557353,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557357,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557363,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557367,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557389,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557394,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557399,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557404,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557411,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557415,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557421,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557425,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557431,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557437,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557442,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557447,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557452,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557459,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557463,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557469,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557475,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557480,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557485,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557490,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557494,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557499,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557504,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557509,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557514,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557519,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557524,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557616,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557611,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557606,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557601,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557595,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557589,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557585,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557579,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557575,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557569,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557563,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557556,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557550,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557546,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557539,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557534,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557529,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557373,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557377,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557383,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557182,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557803,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557809,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557812,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557818,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557822,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557793,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557789,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557783,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557779,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557774,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557770,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557764,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557760,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557754,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557749,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557743,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557737,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557732,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557726,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557722,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557716,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557711,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557237,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557232,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557177,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557172,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557167,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557162,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557157,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557152,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557147,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557142,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557137,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557132,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557127,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557122,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557117,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557112,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557107,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557861,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557857,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557867,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557872,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557878,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557884,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557889,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557895,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557899,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557905,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557910,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557916,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557922,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557971,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557975,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557981,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557986,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557992,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557998,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558003,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558009,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558013,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558019,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558024,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558030,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558036,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558041,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557927,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557933,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557937,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557943,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557948,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557954,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557960,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557965,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557851,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557847,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557102,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557828,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557832,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557838,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557841,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557097,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557799,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557705,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557699,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557695,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557689,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729964,
                                    "isTestReportAvailable": true,
                                    "duration": 2175,
                                    "duration_inMinutes": 36.25,
                                    "created_at": "Jun-23-21",
                                    "created_at_rawDateFormat": "2021-06-23T07:05:57.429Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 325782117,
                                "gitlabId": 325782117,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729968,
                                    "isTestReportAvailable": false,
                                    "duration": 394,
                                    "duration_inMinutes": 6.57,
                                    "created_at": "Jun-23-21",
                                    "created_at_rawDateFormat": "2021-06-23T07:05:57.584Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 325780864,
                                "gitlabId": 325780864,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729965,
                                    "isTestReportAvailable": false,
                                    "duration": 479,
                                    "duration_inMinutes": 7.98,
                                    "created_at": "Jun-23-21",
                                    "created_at_rawDateFormat": "2021-06-23T07:05:57.443Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 325036057,
                                "gitlabId": 325036057,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729966,
                                    "isTestReportAvailable": false,
                                    "duration": 2202,
                                    "duration_inMinutes": 36.7,
                                    "created_at": "Jun-22-21",
                                    "created_at_rawDateFormat": "2021-06-22T07:05:57.503Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 323273283,
                                "gitlabId": 323273283,
                                "status": "success",
                                "testReport": {
                                    "id": 46800,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54138,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3557581,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557843,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557849,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557852,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557858,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557862,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557868,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557871,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557877,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557881,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557887,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557890,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557896,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557900,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557906,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557909,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557915,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557919,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557925,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557928,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557934,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557938,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557944,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557947,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557953,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557957,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557963,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557966,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557972,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557833,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557829,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557823,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557820,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557814,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557264,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557269,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557274,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557279,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557282,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557287,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557292,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557297,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557301,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557306,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557311,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557316,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557320,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557325,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557330,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557335,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557340,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557345,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557349,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557354,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557359,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557364,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557369,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557374,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557379,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557810,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557804,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557800,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557384,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557388,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557393,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557398,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557403,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557407,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557412,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557417,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557422,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557427,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557432,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557436,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557441,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557446,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557451,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557455,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557460,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557465,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557470,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557474,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557479,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557484,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557489,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557493,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557498,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557503,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557508,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557513,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557518,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557523,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557528,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557533,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557538,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557542,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557547,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557552,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557557,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557561,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557566,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557571,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557576,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557586,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557591,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557596,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557600,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557605,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557610,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557615,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557619,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557625,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557629,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557635,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557639,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557645,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557648,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557654,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557658,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557664,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557668,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557674,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557678,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557684,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557976,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557982,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557985,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557991,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557688,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557694,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557839,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557723,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557717,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557714,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557708,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557064,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557069,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557074,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557079,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557084,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557089,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557094,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557099,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557104,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557109,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557114,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557119,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557124,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557129,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557134,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557139,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557144,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557698,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557704,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557794,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557790,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557784,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557781,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557775,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557771,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557765,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557761,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557755,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557752,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557746,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557742,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557736,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557733,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557727,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557149,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557154,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557159,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557164,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557169,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557174,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557179,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557184,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557189,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557194,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557199,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557204,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557209,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557214,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557219,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557224,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557229,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557234,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557239,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557244,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557249,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557254,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557259,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557995,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558023,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558029,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558033,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558001,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558004,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558010,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558014,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558052,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558048,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558042,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558039,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558020,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729967,
                                    "isTestReportAvailable": true,
                                    "duration": 1258,
                                    "duration_inMinutes": 20.97,
                                    "created_at": "Jun-18-21",
                                    "created_at_rawDateFormat": "2021-06-18T07:05:57.557Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 323272589,
                                "gitlabId": 323272589,
                                "status": "success",
                                "testReport": {
                                    "id": 46801,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54142,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3562029,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562034,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562039,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562045,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562051,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562057,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562061,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561293,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561297,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561302,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561307,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561312,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561317,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561322,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561327,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561332,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561337,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561342,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561347,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561352,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561357,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561362,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561367,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561372,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561377,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561382,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561387,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561392,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561397,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561402,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561407,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561412,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561417,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561422,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561178,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561183,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561188,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561193,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561198,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561203,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561208,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561213,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561218,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561223,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561228,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561233,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561238,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561243,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561248,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561253,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561258,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561263,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561268,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561288,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561283,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561278,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561273,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561427,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561432,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561437,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561442,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561447,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561452,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561457,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561462,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561467,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561472,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561477,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561482,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561487,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561492,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561497,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561502,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561507,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561512,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561517,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561522,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561527,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561532,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561537,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561542,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561547,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561552,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561557,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561562,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561568,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561572,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561578,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561582,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561588,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561592,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561598,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561601,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561607,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561611,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561617,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561621,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561627,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561630,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561636,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561640,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561646,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561650,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561656,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561660,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561666,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561669,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561675,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561679,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561685,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561689,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561695,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561699,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561705,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561709,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561715,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561719,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561725,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561729,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561735,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561739,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561745,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561749,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561755,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561759,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561765,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561769,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561775,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561779,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561785,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561789,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561795,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561799,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561805,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561809,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561815,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561819,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561825,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561829,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561835,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561839,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561845,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561849,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561855,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561859,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561865,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561869,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561875,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561879,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561885,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561889,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561895,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561898,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561904,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561908,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561914,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561918,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561924,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561927,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561041,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561047,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561050,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561056,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561060,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561066,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561070,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561076,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561079,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561085,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561089,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561095,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561099,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561105,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561109,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561114,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561118,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561123,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561128,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561133,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561138,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561143,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561148,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561153,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561158,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561163,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561168,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561173,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561933,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561937,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561943,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561947,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561953,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561958,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561963,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561969,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561975,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561981,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561985,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561991,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561996,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562001,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562007,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562013,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562019,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562023,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729969,
                                    "isTestReportAvailable": true,
                                    "duration": 1230,
                                    "duration_inMinutes": 20.5,
                                    "created_at": "Jun-18-21",
                                    "created_at_rawDateFormat": "2021-06-18T07:05:57.623Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 323242629,
                                "gitlabId": 323242629,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729970,
                                    "isTestReportAvailable": false,
                                    "duration": 1414,
                                    "duration_inMinutes": 23.57,
                                    "created_at": "Jun-18-21",
                                    "created_at_rawDateFormat": "2021-06-18T07:05:57.695Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 323241498,
                                "gitlabId": 323241498,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729971,
                                    "isTestReportAvailable": false,
                                    "duration": 1419,
                                    "duration_inMinutes": 23.65,
                                    "created_at": "Jun-18-21",
                                    "created_at_rawDateFormat": "2021-06-18T07:05:57.727Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 320469273,
                                "gitlabId": 320469273,
                                "status": "success",
                                "testReport": {
                                    "id": 46803,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54140,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3566811,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565652,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565657,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565662,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565671,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565681,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565690,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565695,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565700,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565647,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566468,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566474,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566479,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566485,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566491,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566495,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566501,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566505,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566511,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566515,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566521,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566525,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566531,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566535,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566541,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566545,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566551,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566555,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566561,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566565,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566571,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566575,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566581,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566585,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566591,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566595,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566601,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566605,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566611,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566615,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565642,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565633,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565623,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565613,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565603,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565593,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565583,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565573,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565563,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565553,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565544,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565534,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565525,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566620,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566625,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566630,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566635,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566639,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566644,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566649,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566654,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566659,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566664,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566670,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566675,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566681,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566686,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566691,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566696,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566701,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566706,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566711,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566716,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566721,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566726,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566731,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566736,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566741,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566746,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566751,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566756,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566761,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566766,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566771,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566776,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566781,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566786,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566791,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566796,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566801,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566806,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566816,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566299,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566290,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566280,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566270,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566260,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566251,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566241,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566231,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566222,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566212,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566203,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566193,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566183,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566174,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566164,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566154,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566144,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566135,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566125,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566115,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566105,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566096,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566086,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566076,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566067,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566057,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566047,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566037,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566027,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566017,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566007,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566000,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565994,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565989,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565984,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565977,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565967,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565962,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565957,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565952,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565947,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565942,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565937,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565932,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565928,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565923,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565919,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565913,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565909,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565903,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565899,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565893,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565887,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565883,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565875,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565865,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565855,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565845,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565840,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565835,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565830,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565825,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565820,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565815,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565810,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565805,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565800,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565795,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565790,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565785,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565780,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565775,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565770,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565765,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565760,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565755,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565750,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565745,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565740,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565735,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565730,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565725,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565720,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565715,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565710,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565705,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566309,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566319,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566329,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566339,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566349,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566358,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566363,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566368,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566373,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566378,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566383,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566388,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566392,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566397,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566402,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566407,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566412,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566417,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566422,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566427,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566433,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566438,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566444,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566448,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566454,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566458,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566464,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729972,
                                    "isTestReportAvailable": true,
                                    "duration": 6362,
                                    "duration_inMinutes": 106.03,
                                    "created_at": "Jun-14-21",
                                    "created_at_rawDateFormat": "2021-06-14T07:05:57.745Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317031653,
                                "gitlabId": 317031653,
                                "status": "success",
                                "testReport": {
                                    "id": 46805,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54141,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3562752,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561480,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561470,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561460,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561450,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561440,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561430,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561420,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561901,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561911,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561015,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561024,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561034,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561043,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561053,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561063,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561792,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561782,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561772,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561762,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561752,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561742,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561732,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561722,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561712,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561702,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561692,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561682,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561672,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561662,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561652,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561643,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561633,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561623,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561614,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561005,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561604,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561594,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561585,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561575,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561567,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561561,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561559,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561550,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561540,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561530,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561520,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561510,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561500,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561410,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561400,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561390,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561380,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561370,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561360,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561350,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561340,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561330,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561320,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562200,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562210,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562220,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562230,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562239,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562249,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562259,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562269,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562278,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562288,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562298,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562308,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562318,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562328,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562625,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562629,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562635,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562642,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562647,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562652,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562657,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562662,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562667,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562672,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562677,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562682,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562687,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562692,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562697,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562702,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562707,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562712,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562717,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562722,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562727,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562732,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562737,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562742,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562747,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561490,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562812,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562807,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562802,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562797,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562792,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562787,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562782,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562777,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562772,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562767,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562762,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562757,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561920,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562338,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562348,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562357,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562367,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562377,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562387,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562397,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562407,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562417,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562426,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562436,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561930,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561940,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562445,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562455,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562465,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562474,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562484,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562493,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562503,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562513,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561310,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561300,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561290,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561281,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561271,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561261,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561251,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561241,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561231,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561221,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561949,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561959,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561968,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561978,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561987,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561997,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562006,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562016,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562025,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562035,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562044,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562054,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562063,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562072,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562082,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562091,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562101,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562111,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562120,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562130,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562140,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562150,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562160,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562170,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562180,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562190,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561211,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561201,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561191,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561181,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561171,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561161,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561151,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561141,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561131,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561121,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561111,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561101,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561092,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561082,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561072,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562523,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562532,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562542,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562551,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562561,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562571,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562581,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562591,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562600,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562610,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562619,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561802,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561812,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561822,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561832,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561842,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561852,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561862,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561872,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561882,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561891,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729973,
                                    "isTestReportAvailable": true,
                                    "duration": 2588,
                                    "duration_inMinutes": 43.13,
                                    "created_at": "Jun-08-21",
                                    "created_at_rawDateFormat": "2021-06-08T07:05:57.827Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 317024218,
                                "gitlabId": 317024218,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729974,
                                    "isTestReportAvailable": false,
                                    "duration": 398,
                                    "duration_inMinutes": 6.63,
                                    "created_at": "Jun-08-21",
                                    "created_at_rawDateFormat": "2021-06-08T07:05:57.857Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 314756335,
                                "gitlabId": 314756335,
                                "status": "success",
                                "testReport": {
                                    "id": 46804,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54143,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3565551,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565546,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565895,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565905,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565915,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565924,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565934,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565944,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565954,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565964,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565970,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565975,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565980,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565985,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565990,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565993,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565999,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566002,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566008,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566012,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566018,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566022,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566028,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566032,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566038,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566042,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566048,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566052,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566058,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566062,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566291,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566068,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566072,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566077,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565762,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565757,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565752,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565747,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565742,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565737,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565732,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565727,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565722,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565717,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565712,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565707,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565702,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565697,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565692,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565687,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565683,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565677,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565674,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565668,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565664,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565660,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565654,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565650,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565644,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565640,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565635,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565630,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566081,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566087,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566091,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566097,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566100,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566106,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566110,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566116,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566120,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566126,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566130,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566136,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566139,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566145,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566149,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566155,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566159,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566165,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565625,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565620,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565615,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565610,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565605,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565600,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565595,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565590,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565585,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565580,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565575,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565570,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565565,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566169,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566175,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566178,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566184,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566188,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566194,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566198,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566204,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566207,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566580,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566574,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566570,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566564,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566560,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566554,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566550,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566544,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566540,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566534,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566530,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566524,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566520,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566514,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566510,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566504,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566500,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566213,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566217,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566223,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566227,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566232,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566236,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566242,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566246,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566252,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566255,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566261,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566494,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566490,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566486,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566481,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566476,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566471,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566467,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566462,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566457,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566452,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566447,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566442,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566437,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566432,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566428,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566424,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566418,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566414,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566408,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566404,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566398,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566395,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566389,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566265,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566271,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566275,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566281,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566285,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566385,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566379,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566375,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566369,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566350,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566345,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566340,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566335,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566330,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566325,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566320,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566315,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566310,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566305,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566300,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566295,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566365,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566359,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566355,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565767,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565772,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565777,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565782,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565787,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565792,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565797,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565802,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565807,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565812,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565817,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565822,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565827,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565832,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565837,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565842,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565847,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565851,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565857,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565861,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565867,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565871,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565877,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565881,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565886,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565891,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565555,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565560,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729975,
                                    "isTestReportAvailable": true,
                                    "duration": 1443,
                                    "duration_inMinutes": 24.05,
                                    "created_at": "Jun-04-21",
                                    "created_at_rawDateFormat": "2021-06-04T07:05:57.911Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 313596314,
                                "gitlabId": 313596314,
                                "status": "failed",
                                "testReport": {
                                    "id": 46814,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54144,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3557983,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557978,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558078,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558083,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558088,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558092,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558098,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558101,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558107,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558111,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558117,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558121,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557974,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558127,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558131,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558137,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558141,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558147,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558007,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558151,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558157,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558161,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558167,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558002,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557997,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557993,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557988,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558026,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558021,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558016,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558012,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558031,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558035,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558040,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558045,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558050,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558054,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558059,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558064,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558069,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558073,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557376,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557372,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557568,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557574,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557578,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557584,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557588,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557594,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557598,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557603,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557607,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557613,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557617,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557621,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557626,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557631,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557636,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557641,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557646,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557651,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557656,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557661,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557666,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557671,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557676,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557681,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557686,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557691,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557696,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557701,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557715,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557720,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557725,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557729,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557734,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557739,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557969,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557964,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557959,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557955,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557950,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557945,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557940,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557936,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557931,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557926,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557921,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557917,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557912,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557907,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557744,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557748,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557753,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557758,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557763,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557767,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557772,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557777,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557888,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557366,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557362,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557356,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557352,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557347,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557343,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557879,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557874,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557869,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557864,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557443,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557439,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557434,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557430,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557424,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557420,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557414,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557410,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557710,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557706,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557337,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557333,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557893,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557898,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557327,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557323,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557318,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557314,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557308,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557304,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557299,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557840,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557883,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557845,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557850,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557855,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557860,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557295,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557289,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557285,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557405,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557401,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557280,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557276,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557271,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557266,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557261,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557256,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557251,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557246,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557241,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557236,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557231,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557226,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557221,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557216,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557902,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557835,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557181,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557186,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557191,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557196,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557201,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557206,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557211,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557782,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557787,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557792,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557797,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557802,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557806,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557811,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557530,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557536,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557540,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557545,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557549,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557555,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557559,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557565,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557526,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557520,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557516,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557510,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557506,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557500,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557497,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557491,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557487,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557481,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557477,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557472,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557468,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557462,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557458,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557453,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557449,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557816,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557821,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557826,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557831,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557395,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557391,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557386,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557382,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729976,
                                    "isTestReportAvailable": true,
                                    "duration": 1290,
                                    "duration_inMinutes": 21.5,
                                    "created_at": "Jun-02-21",
                                    "created_at_rawDateFormat": "2021-06-02T07:05:57.974Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 313057460,
                                "gitlabId": 313057460,
                                "status": "success",
                                "testReport": {
                                    "id": 46806,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54145,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3566293,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565691,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565696,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565701,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565706,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565711,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565716,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565721,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565726,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565731,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565736,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565741,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565746,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565751,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565756,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565761,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565766,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565771,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565776,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565781,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565786,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565791,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565796,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565801,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565806,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565811,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565816,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565821,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565826,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565831,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565836,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565841,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565846,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565850,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565856,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565860,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565866,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565870,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565876,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565880,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565885,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565890,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565896,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565906,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565916,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565925,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565933,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565938,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565943,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565948,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565953,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565958,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565963,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565973,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565982,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565991,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3565998,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566003,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566009,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566013,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566019,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566023,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566029,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566033,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566039,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566043,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566049,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566053,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566059,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566063,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566069,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566073,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566078,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566082,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566088,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566092,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566098,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566101,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566107,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566111,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566117,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566121,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566127,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566131,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566137,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566141,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566147,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566151,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566157,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566161,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566167,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566173,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566179,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566185,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566189,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566195,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566199,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566205,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566209,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566215,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566221,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566226,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566234,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566238,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566244,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566250,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566257,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566263,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566267,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566273,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566277,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566283,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566287,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566302,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566312,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566322,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566332,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566342,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566352,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566360,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566366,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566370,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566376,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566380,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566386,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566393,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566399,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566405,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566409,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566415,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566419,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566425,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566434,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566443,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566453,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566463,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566473,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566482,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566492,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566496,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566502,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566506,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566512,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566516,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566522,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566526,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566532,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566536,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566542,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566546,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566552,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566556,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566562,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566566,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566572,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566576,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566582,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566586,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566592,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566596,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566602,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566606,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566612,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566621,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566631,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566641,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566650,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566660,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566669,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566679,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566689,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566699,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566709,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566719,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566729,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566739,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566749,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566759,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566769,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566779,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566789,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566799,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566809,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566819,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566829,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566838,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566845,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566853,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566861,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566869,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566877,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566885,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566893,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566901,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566909,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566917,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566925,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566933,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566941,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566949,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566957,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566965,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566973,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566981,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566989,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729977,
                                    "isTestReportAvailable": true,
                                    "duration": 1586,
                                    "duration_inMinutes": 26.43,
                                    "created_at": "Jun-01-21",
                                    "created_at_rawDateFormat": "2021-06-01T07:05:57.989Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 312770147,
                                "gitlabId": 312770147,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729978,
                                    "isTestReportAvailable": false,
                                    "duration": 3631,
                                    "duration_inMinutes": 60.52,
                                    "created_at": "Jun-01-21",
                                    "created_at_rawDateFormat": "2021-06-01T07:05:58.010Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 312473469,
                                "gitlabId": 312473469,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729979,
                                    "isTestReportAvailable": false,
                                    "duration": 2461,
                                    "duration_inMinutes": 41.02,
                                    "created_at": "May-31-21",
                                    "created_at_rawDateFormat": "2021-05-31T07:05:58.097Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 312473174,
                                "gitlabId": 312473174,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729980,
                                    "isTestReportAvailable": false,
                                    "duration": 276,
                                    "duration_inMinutes": 4.6,
                                    "created_at": "May-31-21",
                                    "created_at_rawDateFormat": "2021-05-31T07:05:58.116Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 298468618,
                                "gitlabId": 298468618,
                                "status": "success",
                                "testReport": {
                                    "id": 46808,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54146,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3561586,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561303,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561308,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561313,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561318,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561323,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561328,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561333,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561338,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561343,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561348,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561353,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561358,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561363,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561368,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561373,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561378,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561383,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561388,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561393,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561398,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561403,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561408,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561413,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561418,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561423,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561428,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561433,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561438,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561443,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561448,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561453,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561458,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561463,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561468,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561473,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561478,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561483,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561488,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561493,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561498,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561503,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561508,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561513,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561518,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561523,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561528,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561533,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561538,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561543,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561548,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561553,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561558,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561563,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561569,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561570,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561576,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561580,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561298,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561590,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561596,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561599,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561605,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561609,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561615,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561619,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561625,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561628,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561634,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561638,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561644,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561648,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561654,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561658,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561664,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561667,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561673,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561677,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561683,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561687,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561693,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561697,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561703,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561707,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561713,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561717,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561723,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561727,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561733,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561737,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561743,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561747,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561753,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561757,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561763,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561767,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561773,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561777,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561783,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561787,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561793,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561797,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561803,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561807,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561813,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561817,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561823,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561827,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561833,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561837,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561843,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561847,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561853,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561857,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561863,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561867,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561873,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561877,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561883,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561887,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561893,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561896,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561902,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561906,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561912,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561916,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561922,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561925,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561931,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561935,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561941,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561945,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561951,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561954,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561960,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561964,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561970,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561973,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561979,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561983,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561989,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561992,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561998,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562002,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562008,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562011,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562017,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562021,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562027,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562030,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562036,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562040,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562046,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562049,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562055,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562059,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562065,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562068,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562074,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562078,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562084,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562088,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562094,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562097,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562103,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562107,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562113,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562117,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562123,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562126,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562132,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562136,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562142,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562146,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562152,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562156,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562162,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562166,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562172,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562176,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562182,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562186,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562192,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562196,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562202,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562206,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562212,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562216,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562222,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562226,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562232,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562236,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562242,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562245,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562251,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562255,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562261,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562265,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562271,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562275,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562281,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562284,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562290,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562294,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562300,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729981,
                                    "isTestReportAvailable": true,
                                    "duration": 1780,
                                    "duration_inMinutes": 29.67,
                                    "created_at": "May-06-21",
                                    "created_at_rawDateFormat": "2021-05-06T07:05:58.174Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 298467323,
                                "gitlabId": 298467323,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729982,
                                    "isTestReportAvailable": false,
                                    "duration": 99,
                                    "duration_inMinutes": 1.65,
                                    "created_at": "May-06-21",
                                    "created_at_rawDateFormat": "2021-05-06T07:05:58.232Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 298431919,
                                "gitlabId": 298431919,
                                "status": "success",
                                "testReport": {
                                    "id": 46807,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54147,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3566950,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566946,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566942,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566938,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566934,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566930,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566926,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566922,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566700,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566705,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566710,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566715,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566720,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566725,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566730,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566735,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566740,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566745,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566750,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566755,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566760,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566765,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566770,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566775,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566780,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566785,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566790,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566795,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566800,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566805,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566810,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566815,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566820,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566825,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566830,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566835,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566839,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566843,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566846,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566850,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566854,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566858,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566862,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566866,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566870,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566874,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566878,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566882,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566886,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566890,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566894,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566430,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566436,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566439,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566445,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566449,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566455,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566459,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566465,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566469,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566475,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566478,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566484,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566488,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566493,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566498,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566503,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566508,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566513,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566518,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566898,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566902,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566906,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566910,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566914,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566918,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566523,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566528,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566533,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566538,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566543,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566548,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566553,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566558,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566563,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567161,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567158,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567155,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567152,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567149,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567146,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567143,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567140,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567137,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567134,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567131,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567128,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567125,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567122,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567119,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567116,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567113,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567110,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567107,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567104,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567101,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567098,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567095,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567092,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567089,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567086,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566308,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566314,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566318,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566324,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566328,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566334,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566338,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566344,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566347,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566353,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566357,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566362,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566367,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566372,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566377,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566382,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566387,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567164,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566994,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566986,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566982,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566978,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566974,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566970,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566966,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566962,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566958,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566954,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567014,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567011,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567008,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567005,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567002,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566999,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566997,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566990,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566391,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566396,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566401,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566406,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566411,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566416,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566421,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566568,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566573,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566578,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566583,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566588,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566593,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566598,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566603,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566608,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566613,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566617,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566623,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566626,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566632,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566636,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566642,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566646,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566652,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566655,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566661,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566665,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566671,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566674,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566680,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566685,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566690,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566695,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566426,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567083,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567080,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567077,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567074,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567071,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567068,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567065,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567062,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567059,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567056,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567053,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567050,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567047,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567044,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567041,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567038,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567035,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567032,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567029,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567026,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567023,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567020,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567017,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729983,
                                    "isTestReportAvailable": true,
                                    "duration": 2428,
                                    "duration_inMinutes": 40.47,
                                    "created_at": "May-06-21",
                                    "created_at_rawDateFormat": "2021-05-06T07:05:58.242Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 298419805,
                                "gitlabId": 298419805,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729984,
                                    "isTestReportAvailable": false,
                                    "duration": 1208,
                                    "duration_inMinutes": 20.13,
                                    "created_at": "May-06-21",
                                    "created_at_rawDateFormat": "2021-05-06T07:05:58.282Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 260882846,
                                "gitlabId": 260882846,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729988,
                                    "isTestReportAvailable": false,
                                    "duration": 46,
                                    "duration_inMinutes": 0.77,
                                    "created_at": "Feb-24-21",
                                    "created_at_rawDateFormat": "2021-02-24T07:05:58.541Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 260882207,
                                "gitlabId": 260882207,
                                "status": "success",
                                "testReport": {
                                    "id": 46815,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54149,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3557751,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557756,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557762,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557769,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557778,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557788,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557808,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557970,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557961,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557951,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557942,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557932,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557923,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557913,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557904,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557894,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557885,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557875,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557866,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558018,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557980,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558320,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558310,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558008,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557999,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557989,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558314,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558027,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557798,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557667,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557673,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557677,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557683,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557687,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557693,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557697,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557856,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557846,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557837,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557827,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557817,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557703,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557707,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557713,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557718,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557724,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557730,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557735,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557741,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557745,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558340,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558334,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558330,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558324,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558867,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558413,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558409,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558478,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558473,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558468,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558304,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558746,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558750,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558756,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558760,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558766,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558770,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558776,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558780,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558786,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558790,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558796,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558360,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558364,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558370,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558429,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558373,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558379,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558383,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558809,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558806,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558800,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558607,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558601,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558598,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558592,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558588,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558583,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558578,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558573,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558568,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558563,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558558,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558403,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558399,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558393,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558389,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558037,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558046,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558056,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558065,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558075,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558084,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558093,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558103,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558112,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558122,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558132,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558142,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558152,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558162,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558172,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558182,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558192,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558201,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558211,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558650,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558656,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558660,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558553,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558548,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558543,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558538,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558533,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558528,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558523,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558518,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558513,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558508,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558503,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558498,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558493,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558488,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558483,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558423,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558419,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558941,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558935,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558932,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558926,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558922,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558916,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558912,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558906,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558902,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558896,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558893,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558887,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558883,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558877,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558873,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558863,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558463,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558458,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558453,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558666,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558448,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558443,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558438,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558433,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558646,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558640,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558637,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558631,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558627,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558621,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558617,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558611,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558857,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558855,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558848,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558844,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558838,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558834,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558828,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558825,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558819,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558815,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558221,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558231,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558241,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558251,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558261,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558271,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558281,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558291,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558344,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558350,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558354,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558670,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558676,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558680,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558686,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558690,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558696,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558700,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558706,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558710,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558716,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558720,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558726,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558730,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558736,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558740,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558301,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729985,
                                    "isTestReportAvailable": true,
                                    "duration": 2422,
                                    "duration_inMinutes": 40.37,
                                    "created_at": "Feb-24-21",
                                    "created_at_rawDateFormat": "2021-02-24T07:05:58.396Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 260881094,
                                "gitlabId": 260881094,
                                "status": "success",
                                "testReport": {
                                    "id": 46811,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54148,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3558125,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558135,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558145,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558382,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558386,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558392,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558396,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558402,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558406,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558412,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558416,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557984,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558485,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558422,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558426,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558432,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558005,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558435,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558440,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558445,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558450,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558455,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558213,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557897,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557903,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557908,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557914,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557918,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557924,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557929,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557935,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557941,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557946,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558460,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558465,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558470,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558475,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558480,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558038,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558043,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558049,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558223,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558233,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558243,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557952,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558011,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558017,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558022,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558028,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558032,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557956,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557962,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557967,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557973,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557979,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557891,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558253,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557886,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557880,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557876,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557870,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557865,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557990,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557994,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558000,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558194,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558203,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558155,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558165,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558263,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558273,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558283,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558293,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558303,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558307,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558174,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558184,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558055,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558060,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558066,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558070,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558076,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558081,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558087,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558095,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558105,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558115,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558353,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558358,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558363,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558369,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558376,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557456,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557450,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557444,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557440,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557433,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557428,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557642,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557652,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557662,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557672,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557682,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557692,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557702,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557712,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557721,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557731,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557740,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557750,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557759,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557768,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557773,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557780,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557785,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557791,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557795,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557801,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557807,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557813,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557819,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557824,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557830,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557836,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557842,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557848,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557853,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557859,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558347,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557317,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557423,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557418,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557413,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557408,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557402,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558343,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558337,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557350,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557338,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557324,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557328,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557334,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557488,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557495,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557501,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557507,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557511,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557517,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557521,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557527,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557531,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557537,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557543,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557548,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557553,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557558,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557562,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557567,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557572,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557577,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557582,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557587,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557592,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557597,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557604,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557608,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558313,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557482,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557614,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557623,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557632,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557190,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557200,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557210,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557220,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557230,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557240,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557250,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557260,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557270,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557278,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557286,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557290,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557296,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557302,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557307,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557312,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557478,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557471,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557466,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557461,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557370,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557365,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557360,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557355,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557344,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558333,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558327,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558323,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558317,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557396,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557392,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557385,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557380,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3557375,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729986,
                                    "isTestReportAvailable": true,
                                    "duration": 1956,
                                    "duration_inMinutes": 32.6,
                                    "created_at": "Feb-24-21",
                                    "created_at_rawDateFormat": "2021-02-24T07:05:58.469Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 258032884,
                                "gitlabId": 258032884,
                                "status": "success",
                                "testReport": {
                                    "id": 46809,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54152,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3561637,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561515,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561505,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561495,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562110,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562106,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562100,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562092,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562087,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562081,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562077,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562071,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562062,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562052,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562043,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562033,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562024,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562014,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562005,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561995,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561986,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561976,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561967,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561957,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561948,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561938,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561929,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561919,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561909,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561900,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561890,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561880,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562287,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562293,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562297,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562303,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562307,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562313,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562317,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562323,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562327,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562333,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562337,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562343,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562347,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562353,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562358,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562366,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562372,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562376,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562382,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562386,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562392,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562396,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562402,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562406,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562412,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562416,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562422,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562427,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561642,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561647,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561653,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561661,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561671,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561681,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561691,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561701,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561602,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561608,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561613,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561618,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561624,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561711,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561721,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561731,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561741,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561751,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561761,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561771,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561781,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561791,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561801,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561811,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561821,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561831,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561841,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561851,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561861,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562279,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562274,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562268,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562264,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562258,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562254,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562248,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562240,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562235,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562229,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562225,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562219,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562215,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562209,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562205,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562199,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562195,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562189,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562185,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562179,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562175,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562169,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562165,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562159,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562155,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562149,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562434,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562440,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562444,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562450,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562453,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562459,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562463,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562469,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562473,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562479,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562483,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562489,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562494,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562499,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562508,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562512,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562518,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562522,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562528,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562533,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562540,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562546,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562550,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562556,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562560,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562566,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562570,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562576,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562580,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562586,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562590,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562596,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562601,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562608,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562614,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562618,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562623,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562628,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562145,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562139,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562135,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562129,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562121,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562116,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561871,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561595,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561589,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561584,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561579,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561573,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561631,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561565,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562633,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562638,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562644,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562654,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562664,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562674,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562684,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562694,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562704,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562714,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562724,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562734,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562744,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562754,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562764,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562774,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562784,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562794,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562804,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562814,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562824,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562834,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562844,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562854,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562864,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562874,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562884,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562894,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562904,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562914,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562924,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562934,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562944,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562954,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561555,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561545,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561535,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561525,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729990,
                                    "isTestReportAvailable": true,
                                    "duration": 634,
                                    "duration_inMinutes": 10.57,
                                    "created_at": "Feb-18-21",
                                    "created_at_rawDateFormat": "2021-02-18T07:05:58.698Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 257595748,
                                "gitlabId": 257595748,
                                "status": "success",
                                "testReport": {
                                    "id": 46810,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54150,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3567170,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566316,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566321,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566326,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566331,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566336,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566341,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566346,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566351,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567376,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566356,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566364,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566374,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566384,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566394,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566403,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566413,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566423,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566431,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566441,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566451,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566461,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566470,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566480,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566489,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566499,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566509,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566519,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566529,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566539,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566549,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566559,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566569,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566579,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566589,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566599,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566609,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566618,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566628,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566637,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566647,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566657,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566666,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566676,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566684,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566694,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566704,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566714,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566724,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566734,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566744,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566754,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566764,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566774,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566784,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566794,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566804,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566814,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566824,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566834,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566841,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566849,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566857,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566865,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566873,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567377,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567378,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567379,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567380,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567381,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567382,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567383,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567384,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567385,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567386,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567387,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567388,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567389,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566881,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566889,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566897,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566905,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566913,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566921,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566929,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566937,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566945,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566953,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566961,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566969,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566977,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566985,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566993,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566998,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567004,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567010,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567016,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567022,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567028,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567034,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567040,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567046,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567052,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567058,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567064,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567070,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567076,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567082,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567088,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567094,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567100,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567106,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567112,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567118,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567124,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567130,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567136,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567142,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567148,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567154,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567160,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567166,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567174,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567178,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567182,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567186,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567190,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567194,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567198,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567202,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567206,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567210,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567214,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567218,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567222,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567226,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567230,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567234,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567238,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567242,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567246,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567250,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567254,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567258,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567262,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567266,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567270,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567274,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567278,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567367,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567368,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567369,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567374,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567359,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567357,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567355,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567353,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567351,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567349,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567343,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567341,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567331,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567333,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567335,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567337,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567347,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567345,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567329,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567327,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567325,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567323,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567321,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567319,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567317,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567315,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567313,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567311,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567309,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567307,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567305,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567303,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567301,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567299,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567371,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567372,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567373,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567297,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567295,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567293,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567291,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567289,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567287,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567285,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567283,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567281,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567370,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567339,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567360,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567361,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567362,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567363,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567364,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567365,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567366,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567375,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729987,
                                    "isTestReportAvailable": true,
                                    "duration": 3999,
                                    "duration_inMinutes": 66.65,
                                    "created_at": "Feb-17-21",
                                    "created_at_rawDateFormat": "2021-02-17T07:05:58.512Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 257087735,
                                "gitlabId": 257087735,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729989,
                                    "isTestReportAvailable": false,
                                    "duration": 1382,
                                    "duration_inMinutes": 23.03,
                                    "created_at": "Feb-16-21",
                                    "created_at_rawDateFormat": "2021-02-16T07:05:58.578Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 257077829,
                                "gitlabId": 257077829,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729994,
                                    "isTestReportAvailable": false,
                                    "duration": 776,
                                    "duration_inMinutes": 12.93,
                                    "created_at": "Feb-16-21",
                                    "created_at_rawDateFormat": "2021-02-16T07:05:58.826Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 256438948,
                                "gitlabId": 256438948,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729991,
                                    "isTestReportAvailable": false,
                                    "duration": 1054,
                                    "duration_inMinutes": 17.57,
                                    "created_at": "Feb-15-21",
                                    "created_at_rawDateFormat": "2021-02-15T07:05:58.733Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 229906147,
                                "gitlabId": 229906147,
                                "status": "success",
                                "testReport": {
                                    "id": 46812,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54151,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3562381,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562204,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562198,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562194,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562188,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562184,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562178,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562174,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562168,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562164,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562158,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562154,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562148,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562144,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562138,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562134,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562128,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561389,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561394,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561399,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561404,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561409,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561414,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561419,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562302,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562306,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562312,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562316,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562322,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562326,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562332,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562336,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562342,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562346,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562352,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562356,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562362,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562365,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562371,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562375,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562385,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562391,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562395,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562401,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562405,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562411,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562415,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562421,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562425,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562431,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562435,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562441,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562446,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562454,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562460,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562464,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562470,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562475,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562482,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562125,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562119,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562115,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562109,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562105,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562099,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562096,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562090,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562086,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562080,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562076,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562070,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562064,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562058,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562053,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562048,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562042,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562038,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562032,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562026,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562020,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562015,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562010,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562004,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562000,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561994,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561988,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561982,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561977,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561972,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561966,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561962,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561956,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561950,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561944,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561939,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561934,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561928,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561921,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561915,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561910,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561905,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561899,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561892,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561886,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561881,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561876,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561870,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561866,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561860,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561856,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561850,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561846,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561840,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561836,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561830,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561826,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561820,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561816,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561810,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561806,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561800,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561796,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561790,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561786,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561780,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561776,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561770,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561766,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561760,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561756,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561750,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561746,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561740,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561736,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561730,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561726,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561720,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561716,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561710,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561706,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561700,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561696,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561690,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561686,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561680,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561676,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561670,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561663,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561657,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561651,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561641,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561632,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561622,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561612,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561603,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561593,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561583,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561574,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561564,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561554,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561549,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561544,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561539,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561534,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561529,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561524,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561519,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561514,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561509,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561504,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561499,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561494,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561489,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561484,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561479,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561474,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561469,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561464,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561459,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561454,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561449,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561444,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561439,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561434,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561429,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561424,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562208,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562214,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562218,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562224,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562228,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562234,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562238,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562244,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562247,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562253,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562257,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562263,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562267,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562273,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562277,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562283,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562286,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562292,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562296,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729992,
                                    "isTestReportAvailable": true,
                                    "duration": 1095,
                                    "duration_inMinutes": 18.25,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:05:58.781Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 229905862,
                                "gitlabId": 229905862,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729993,
                                    "isTestReportAvailable": false,
                                    "duration": 224,
                                    "duration_inMinutes": 3.73,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:05:58.808Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 229325002,
                                "gitlabId": 229325002,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729995,
                                    "isTestReportAvailable": false,
                                    "duration": 461,
                                    "duration_inMinutes": 7.68,
                                    "created_at": "Dec-14-20",
                                    "created_at_rawDateFormat": "2020-12-14T07:05:58.942Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 229317450,
                                "gitlabId": 229317450,
                                "status": "success",
                                "testReport": {
                                    "id": 46813,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54153,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3567312,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566773,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566768,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566763,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566758,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566753,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566748,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567302,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567304,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567306,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567308,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567310,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567314,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566483,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566477,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566472,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566971,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566975,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566979,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566983,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566987,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566991,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566995,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567001,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567007,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567013,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567019,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567025,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567031,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567037,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567043,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567049,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567055,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567061,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567067,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567073,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567079,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567085,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566743,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566738,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566733,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566728,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566723,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566718,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566713,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566708,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566703,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566698,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566693,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566688,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566683,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566678,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566673,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566668,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566662,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566656,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566651,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566645,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566640,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566633,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566627,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566622,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566616,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566607,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566597,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566587,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566577,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566567,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566557,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566547,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566537,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566527,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566517,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566507,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566497,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566487,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567091,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567097,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567103,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567109,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567115,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567121,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567127,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567133,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567139,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567145,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567151,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567157,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567163,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567168,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567172,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567176,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567180,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567184,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567188,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567192,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567196,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567200,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567204,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567208,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567212,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567216,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567220,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567224,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567228,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567232,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567236,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567240,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567244,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567248,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567252,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567256,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567260,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567264,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567268,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566466,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566460,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566456,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567316,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566450,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566446,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566440,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566435,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566429,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566420,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566410,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567272,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566935,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566931,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566927,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566923,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566919,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566915,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566911,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566907,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566903,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566899,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566895,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566891,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566887,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566883,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566879,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566875,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566871,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566867,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566863,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566859,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566855,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566851,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566847,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566842,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566837,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566833,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566828,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566823,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566818,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566813,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566808,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566803,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566798,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566793,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566788,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566783,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566778,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566939,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566943,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566947,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566951,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566955,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566959,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566963,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566967,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567276,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567280,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567282,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567284,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567286,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567288,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567290,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567292,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567294,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567296,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567298,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567300,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567318,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567354,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567352,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567350,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567348,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567346,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567344,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567342,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567340,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567338,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567336,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567358,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567334,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567332,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567330,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567328,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567326,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567324,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567322,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567320,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567356,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 730002,
                                    "isTestReportAvailable": true,
                                    "duration": 961,
                                    "duration_inMinutes": 16.02,
                                    "created_at": "Dec-14-20",
                                    "created_at_rawDateFormat": "2020-12-14T07:05:59.328Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 229316635,
                                "gitlabId": 229316635,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729996,
                                    "isTestReportAvailable": false,
                                    "duration": 737,
                                    "duration_inMinutes": 12.28,
                                    "created_at": "Dec-14-20",
                                    "created_at_rawDateFormat": "2020-12-14T07:05:59.005Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 221534956,
                                "gitlabId": 221534956,
                                "status": "success",
                                "testReport": {
                                    "id": 46816,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54154,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3558338,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558328,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558318,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558348,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559087,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559097,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559106,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559116,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559125,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559135,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559145,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559155,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559379,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559295,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559286,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559276,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559266,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559257,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559247,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559237,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559228,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559222,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559218,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559212,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559208,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559202,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559193,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559183,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559174,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559164,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559329,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558130,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558126,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558120,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558116,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558110,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558106,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558100,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558096,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558090,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558086,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558080,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558077,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558071,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558067,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558061,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558058,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559323,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559319,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558890,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558899,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558909,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558308,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558298,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558294,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558288,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558258,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558254,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558248,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558244,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558238,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558234,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558228,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558224,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558218,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558214,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558208,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558204,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558199,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558195,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558189,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558185,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558179,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558175,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558170,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558486,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558491,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558496,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558501,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558506,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558511,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558516,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558521,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558526,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558531,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558536,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558541,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558546,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558551,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558556,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558561,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558566,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558571,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558576,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558581,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558586,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558595,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558604,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558610,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558614,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558620,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558624,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558630,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558634,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558644,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558654,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558664,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558674,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558684,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558694,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558704,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558166,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558160,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558156,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558150,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558146,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558140,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558136,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558284,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558714,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558724,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558734,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558744,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558754,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558764,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558481,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558476,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558471,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558466,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558461,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558456,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558451,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558446,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558441,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558436,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558427,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558417,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558407,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558397,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558387,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558377,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558367,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558357,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558774,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558784,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558793,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558803,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558812,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558278,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558274,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558268,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558264,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558919,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558929,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558938,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558948,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558997,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559007,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559017,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559027,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559037,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559047,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559057,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559067,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558958,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558967,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559434,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559429,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559424,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559419,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559414,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559409,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559404,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559399,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559394,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559389,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558977,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559469,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559464,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559459,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559454,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559449,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559444,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559439,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558987,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558822,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559384,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558832,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558841,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558851,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558861,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559305,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559313,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558871,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559374,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559369,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559363,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559359,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559353,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559349,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3558880,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559343,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559339,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559333,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3559077,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729997,
                                    "isTestReportAvailable": true,
                                    "duration": 3063,
                                    "duration_inMinutes": 51.05,
                                    "created_at": "Nov-26-20",
                                    "created_at_rawDateFormat": "2020-11-26T07:05:59.034Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 221530593,
                                "gitlabId": 221530593,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729998,
                                    "isTestReportAvailable": false,
                                    "duration": 20,
                                    "duration_inMinutes": 0.33,
                                    "created_at": "Nov-26-20",
                                    "created_at_rawDateFormat": "2020-11-26T07:05:59.061Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 221511431,
                                "gitlabId": 221511431,
                                "status": "success",
                                "testReport": {
                                    "id": 46818,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54155,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3567021,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567279,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567277,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567275,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567273,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567271,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567269,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567267,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567265,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567263,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567261,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567259,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567257,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567255,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567253,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567251,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567249,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567247,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567245,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567243,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567241,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567239,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567237,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567235,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567233,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567231,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567229,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567227,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567225,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567223,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567221,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567219,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567217,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567215,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567213,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567211,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567209,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567207,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567205,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567203,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567201,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567199,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567197,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567195,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567193,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567191,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567189,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567187,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567185,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567183,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567181,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567179,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567177,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567175,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567173,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567171,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567169,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567167,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567165,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567162,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567159,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567156,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567153,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567150,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567147,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567144,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567141,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567138,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567135,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567132,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567129,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567126,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567123,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567120,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567117,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567114,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567111,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567108,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567105,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567102,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567099,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567096,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567093,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567090,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567087,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567084,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567081,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567078,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567075,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567072,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567069,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567066,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567063,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567060,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567057,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567054,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567051,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567048,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567045,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567042,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567039,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567036,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567033,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567030,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567027,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567024,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567018,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567015,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567012,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567009,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567006,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567003,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3567000,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566996,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566992,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566988,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566984,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566980,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566976,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566972,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566968,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566964,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566960,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566956,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566952,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566948,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566944,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566940,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566936,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566932,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566928,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566924,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566920,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566916,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566912,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566908,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566904,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566900,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566896,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566892,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566888,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566884,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566880,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566876,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566872,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566868,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566864,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566860,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566856,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566852,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566848,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566844,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566840,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566836,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566832,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566827,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566822,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566817,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566812,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566807,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566802,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566797,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566792,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566787,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566782,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566777,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566772,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566767,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566762,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566757,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566752,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566747,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566742,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566737,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566732,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566727,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566722,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566717,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566712,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566707,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566702,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566697,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566692,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566687,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566682,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566677,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566672,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566667,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566663,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566658,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566653,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566648,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566643,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566638,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566634,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566629,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566624,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566619,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566614,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566610,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566604,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566600,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566594,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566590,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3566584,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 729999,
                                    "isTestReportAvailable": true,
                                    "duration": 2873,
                                    "duration_inMinutes": 47.88,
                                    "created_at": "Nov-26-20",
                                    "created_at_rawDateFormat": "2020-11-26T07:05:59.083Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 221511105,
                                "gitlabId": 221511105,
                                "status": "success",
                                "testReport": {
                                    "id": 46817,
                                    "error_count": 0,
                                    "failed_count": 0,
                                    "skipped_count": 37,
                                    "success_count": 168,
                                    "total_count": 205,
                                    "total_time": -0.26,
                                    "test_suites": [
                                        {
                                            "id": 54156,
                                            "total_time": -0.26,
                                            "total_count": 205,
                                            "error_count": 0,
                                            "failed_count": 0,
                                            "name": "test-ism",
                                            "skipped_count": 37,
                                            "success_count": 168,
                                            "test_cases": [
                                                {
                                                    "id": 3561903,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561894,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice should contain flatrate offer in between months specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561888,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561884,
                                                    "classname": "ch.petag.db.invoice.TestMultipleBillingAccountIssueSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561878,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562041,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn eine Stufe schlechter",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562047,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " 2 Stufen) schlechter als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562050,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der EDV-Kenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562056,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn Anforderung nicht erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562060,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching von Branchenwissen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562066,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Führerausweise should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562069,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung voll erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562075,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn nur 1 von 2 geforderten Ausweisen",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562079,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn kein geforderter Ausweis",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562584,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "needs local wkhtmlToPdf application",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562578,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562574,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "not working",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562568,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562564,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail with single entry",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562558,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a employer mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562555,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a seeker mail",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562549,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562545,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a Email",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562539,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "be stored in temp folder as html",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562536,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "create a Invoice Batch to pay some bills or prepayments",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562530,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562526,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf with individual discounts",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562520,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562516,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562510,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561874,
                                                    "classname": "ch.petag.db.invoice.TestFlatDiscountWithExpiryDateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562506,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561868,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "mark clicks as invoiced",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561864,
                                                    "classname": "ch.petag.db.invoice.TestClicksToFlatrateBillingAccountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561858,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks on both types of offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561854,
                                                    "classname": "ch.petag.db.invoice.TestClickOnOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561629,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerEmployer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561626,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "Create Impayment Slip should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562501,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562497,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for flat invoice details without addtional cost, so the overview table should not be shown in the pdf",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562491,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a pdf for standard and flat invoice details",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561620,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id, should result in one final click",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561616,
                                                    "classname": "ch.petag.db.clicks.StandardProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561610,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "generate clicks with same tracking id on different publications, should result in two clicks",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561606,
                                                    "classname": "ch.petag.db.clicks.MultiplePublicationProfileClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561600,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "all password hashes are same length",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561597,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return false for a incorrect password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561591,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "return true for the correct password and hash value",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561587,
                                                    "classname": "ch.petag.PasswordSpecs",
                                                    "execution_time": 0,
                                                    "name": "the userdbobj password features should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562266,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer flatrate invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562173,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Beschäftigungsdauer should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562167,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Berufserfahrung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562163,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigngsart should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562153,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Piquetarbeitszeiten",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562147,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Wochenarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562183,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Beschäftigungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562177,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561848,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with clicks at flat offers",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561844,
                                                    "classname": "ch.petag.db.invoice.TestClickOnFlatOffersSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561838,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate two valid invoices",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561834,
                                                    "classname": "ch.petag.db.invoice.TestChangeBillingAccountFlatrateSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561828,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561824,
                                                    "classname": "ch.petag.db.invoice.StandardTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561818,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561814,
                                                    "classname": "ch.petag.db.invoice.ServiceSpecialDiscountsInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561808,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks for Offer = Normal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561804,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "track clicks should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561798,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561794,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561788,
                                                    "classname": "ch.petag.db.invoice.FlatTurnoverDiscountSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561784,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561778,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561774,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561768,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561764,
                                                    "classname": "ch.petag.db.invoice.CreateStandardDiscountInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561758,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561754,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561748,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a introductory and standard discount invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561744,
                                                    "classname": "ch.petag.db.invoice.CreateSpecialDiscountFlatInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561738,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a standard invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561734,
                                                    "classname": "ch.petag.db.invoice.CreateServiceStandardInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service standard invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561728,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice wich only calculates discount for the additional_services",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562487,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate Prepay Invoice as expected",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562481,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562085,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561724,
                                                    "classname": "ch.petag.db.invoice.CreateServiceFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create service flatrate invoice with service_discount specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561718,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562262,
                                                    "classname": "ch.petag.pdf.employee.RecruiterEmployeePDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562256,
                                                    "classname": "ch.petag.pdf.employee.EmployeeStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562252,
                                                    "classname": "ch.petag.pdf.employee.EmployeeFlatPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employee flat invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562246,
                                                    "classname": "ch.petag.pdf.client.ClientPDFOnlyFlatGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562243,
                                                    "classname": "ch.petag.pdf.client.ClientPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "creates client invoice pdfs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562237,
                                                    "classname": "ch.petag.pdf.PrePayInvoicePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a PrepayInvoicePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562233,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a InpaymentPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562227,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "a prepareSeekerNotificationResults should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562223,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "a CheckNotificationDuration should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562089,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Fertigungskenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562095,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Programmierkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562098,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Verantwortung von Mitarbeitern' should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562104,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562108,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Differenz von +- 1 Stufe",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562217,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562213,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Branchen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562207,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "ignoriere, wenn keine Angaben gemacht wurden",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562203,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Jahreslohns should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562197,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Reisebereitschaft should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562114,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching Budgetverantwortung should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562118,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Führungsfunktionen should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562124,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching 'Erfahrungsumfang in Geschäftsleitung / Verwaltungsrat should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562127,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Tätigkeitsfelder should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562133,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562137,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Arbeitszeiten should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562143,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Schichtarbeitszeit",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562478,
                                                    "classname": "ch.petag.pdf.InpaymentPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "generate InpaymentSlip Pdfs with BAckground",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562472,
                                                    "classname": "ch.petag.notification.SeekerProfileNotificationSpec",
                                                    "execution_time": 0,
                                                    "name": "find results in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562468,
                                                    "classname": "ch.petag.notification.NotificationDurationSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562462,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562458,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " eine Übereinstimmung",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562452,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "not working, dont know, what it does",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562449,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "update fields in the database",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562443,
                                                    "classname": "ch.petag.db.invoice.InvoiceClicksSpec",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562439,
                                                    "classname": "ch.petag.db.invoice.CreateStandardEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562433,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562430,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "use only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562193,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, bei Übereinstimmung mit Wertbereichen und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562187,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "70% sein, wenn Übereinstimmung mit festen Werten und 10% Toleranz",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562424,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "only if db is broken",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562420,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "create yearly offer flatrates correclty",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562414,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "call the sql method without exceptions",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562410,
                                                    "classname": "ch.petag.db.finance.InpaymentSlipSpec",
                                                    "execution_time": 0,
                                                    "name": "be created for non-related stuff ",
                                                    "status": "skipped",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562404,
                                                    "classname": "Url2PdfConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A Url2PdfConverter should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562400,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert multiline in html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562394,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert a long line into html",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562390,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "convert simple Strings to HTML NodeSequences",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562384,
                                                    "classname": "StringToHTMLConverterSpec",
                                                    "execution_time": 0,
                                                    "name": "A HTML Mail Generator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562380,
                                                    "classname": "SearchProfilePdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A SearchProfilePdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562374,
                                                    "classname": "JobOfferPdfGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "A JobOfferPdfGenerator should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562370,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a joboffer notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562364,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send prepay email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562361,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send invoice notification email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562355,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send recommendation email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562351,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send publication email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562345,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send apply email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562341,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send seeker delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562335,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send employer delete Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562331,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send missing geo info  should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562157,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Funktion should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562325,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send user invitation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562321,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send password lost Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562315,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send username changed Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562311,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "send Activation Email should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562305,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a employer registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562301,
                                                    "classname": "EmailSpec",
                                                    "execution_time": 0,
                                                    "name": "a seeker registration E-Mail should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562295,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Import type 4 test batch",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562291,
                                                    "classname": "ch.petag.postfinance.PostfinanceSpec",
                                                    "execution_time": 0,
                                                    "name": "Postfinance import should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562285,
                                                    "classname": "ch.petag.postfinance.CustomInvoiceBatchSpec",
                                                    "execution_time": 0,
                                                    "name": "CustomInvoiceBatch should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562282,
                                                    "classname": "ch.petag.pdf.standard.recruiter.RecruiterStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create recruiter standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562276,
                                                    "classname": "ch.petag.pdf.standard.employer.InvoicePDFWithIndividualDiscountSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562272,
                                                    "classname": "ch.petag.pdf.standard.employer.EmployerStandardPDFGeneratorSpec",
                                                    "execution_time": 0,
                                                    "name": "a create employer standard invoice pdf should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561714,
                                                    "classname": "ch.petag.db.invoice.CreateRequestFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create request flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561708,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid prepay invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561704,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561698,
                                                    "classname": "ch.petag.db.invoice.CreatePrepayInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561694,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a flatrate invoice with some data",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561688,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create flatrate invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561684,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate invoices for each employee",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561678,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "an employer with 2 employees should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561674,
                                                    "classname": "ch.petag.db.invoice.CreateOfferFlatrateEmployeeInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561668,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561665,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561659,
                                                    "classname": "ch.petag.db.invoice.CreateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a cleanup task should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561655,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "generate a valid client invoice",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561649,
                                                    "classname": "ch.petag.db.invoice.CreateClientInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561645,
                                                    "classname": "ch.petag.db.invoice.CallCreateAllInvoicesSpecs",
                                                    "execution_time": 0,
                                                    "name": "a create all invoice specs should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561639,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "extractCostPerClient should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561635,
                                                    "classname": "ch.petag.db.finance.InvoiceHeadQListRowSpec",
                                                    "execution_time": 0,
                                                    "name": "calculate the invoice values correctly",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562003,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn später verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562009,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Geschlechts should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562012,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562018,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% bei Geschlecht egal",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562022,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% bei keiner Übereinstmmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562028,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Sprachkenntnisse should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562031,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn Anforderung erfüllt",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3562037,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besser als Anforderung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561999,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn früher verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561993,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn zum gleichen Zeitpunkt verfügbar",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561990,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Verfügbarkeit should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561984,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn keine Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561980,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": " einer Übereinstimmung",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561974,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Erwerbssituaton should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561971,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn schlechterer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561965,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn besserer Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561961,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn gleicher Bildungsgrad",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561955,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching des Bildungsgrads should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561952,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "0% sein, wenn > -+ 4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561946,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "50% sein, wenn +-4 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561942,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "80% sein, wenn +- 2 Jahre",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561936,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "100% sein, wenn alter im angegebenen Bereich",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561932,
                                                    "classname": "ch.petag.db.matching.MatchingSpec",
                                                    "execution_time": 0,
                                                    "name": "Matching der Altersangabe should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561926,
                                                    "classname": "ch.petag.db.lib.M13Spec",
                                                    "execution_time": 0,
                                                    "name": "M13 Invoice (Anforderung #955) should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561923,
                                                    "classname": "ch.petag.db.jobs.PublicationJobSpec",
                                                    "execution_time": 0,
                                                    "name": "a PublicationJob should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561917,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "generate a invoice with all offers even when its changed from per click to flatrate",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561913,
                                                    "classname": "ch.petag.db.invoice.bugs.OfferClickNotIncludedInInvoiceSpec",
                                                    "execution_time": 0,
                                                    "name": "a invoice should",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561907,
                                                    "classname": "ch.petag.db.invoice.TestShowOfferInMultipleFlatrateInvoiceSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                },
                                                {
                                                    "id": 3561897,
                                                    "classname": "ch.petag.db.invoice.TestOfferInFlatrateInvoiceNotShownSpecs",
                                                    "execution_time": 0,
                                                    "name": "create a invoices, to check correct handling of offers for the detail page in flatrates",
                                                    "status": "success",
                                                    "system_output": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "stats": {
                                    "id": 730000,
                                    "isTestReportAvailable": true,
                                    "duration": 2406,
                                    "duration_inMinutes": 40.1,
                                    "created_at": "Nov-26-20",
                                    "created_at_rawDateFormat": "2020-11-26T07:05:59.216Z",
                                    "testCoverage": null
                                }
                            }
                        ],
                        "groupInfo": {
                            "id": 29711,
                            "gitlabId": 8198237,
                            "name": "Hoeger-Larkin"
                        }
                    }
                ],
                "subGroups": [],
                "stats": {
                    "id": 6732,
                    "isThereSubgroups": false,
                    "numberOfProjects": 1,
                    "testCoverageOfAllProjects": null,
                    "numberOfPipelines": 97,
                    "numberOfTestReports": 59
                }
            },
            {
                "id": 8198028,
                "tempData": false,
                "gitlabId": 8198028,
                "name": "Flatley-LLC",
                "projects": [
                    {
                        "id": 26759290,
                        "gitlabId": 26759290,
                        "name": "Flatley-LLC-documentation",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/documentation.git",
                        "stats": {
                            "id": 29703,
                            "status": "failed",
                            "numberOfPipelines": 4,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 62,
                            "averageDurationOfPipelines_inMinutes": 1.03,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 4,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": 0,
                            "totalRepoSize": "1897922",
                            "artifactsSize": "105364"
                        },
                        "pipelines": [
                            {
                                "id": 306479416,
                                "gitlabId": 306479416,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729759,
                                    "isTestReportAvailable": false,
                                    "duration": 13,
                                    "duration_inMinutes": 0.22,
                                    "created_at": "May-20-21",
                                    "created_at_rawDateFormat": "2021-05-20T07:05:45.191Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 306478228,
                                "gitlabId": 306478228,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729761,
                                    "isTestReportAvailable": false,
                                    "duration": 8,
                                    "duration_inMinutes": 0.13,
                                    "created_at": "May-20-21",
                                    "created_at_rawDateFormat": "2021-05-20T07:05:45.374Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 306463879,
                                "gitlabId": 306463879,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729762,
                                    "isTestReportAvailable": false,
                                    "duration": 69,
                                    "duration_inMinutes": 1.15,
                                    "created_at": "May-20-21",
                                    "created_at_rawDateFormat": "2021-05-20T07:05:45.400Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 306461868,
                                "gitlabId": 306461868,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729765,
                                    "isTestReportAvailable": false,
                                    "duration": 156,
                                    "duration_inMinutes": 2.6,
                                    "created_at": "May-20-21",
                                    "created_at_rawDateFormat": "2021-05-20T07:05:45.580Z",
                                    "testCoverage": null
                                }
                            }
                        ],
                        "groupInfo": {
                            "id": 29712,
                            "gitlabId": 8198028,
                            "name": "Flatley-LLC"
                        }
                    },
                    {
                        "id": 15010766,
                        "gitlabId": 15010766,
                        "name": "Flatley-LLC-bdc",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/bdc.git",
                        "stats": {
                            "id": 29708,
                            "status": "failed",
                            "numberOfPipelines": 1,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 1140,
                            "averageDurationOfPipelines_inMinutes": 19,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 1,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": 0,
                            "totalRepoSize": "214695936",
                            "artifactsSize": "42898"
                        },
                        "pipelines": [
                            {
                                "id": 91486527,
                                "gitlabId": 91486527,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730085,
                                    "isTestReportAvailable": false,
                                    "duration": 1140,
                                    "duration_inMinutes": 19,
                                    "created_at": "Oct-25-19",
                                    "created_at_rawDateFormat": "2019-10-25T07:06:05.127Z",
                                    "testCoverage": null
                                }
                            }
                        ],
                        "groupInfo": {
                            "id": 29714,
                            "gitlabId": 8198028,
                            "name": "Flatley-LLC"
                        }
                    },
                    {
                        "id": 15169148,
                        "gitlabId": 15169148,
                        "name": "Flatley-LLC-care",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Flatley-LLC.git",
                        "stats": {
                            "id": 29707,
                            "status": "failed",
                            "numberOfPipelines": 88,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 357,
                            "averageDurationOfPipelines_inMinutes": 5.95,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 36,
                            "numberOfFailedPipelines": 39,
                            "numberOfCanceledPipelines": 13,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": 40.91,
                            "totalRepoSize": "25302138",
                            "artifactsSize": "2690159"
                        },
                        "pipelines": [
                            {
                                "id": 116514635,
                                "gitlabId": 116514635,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730086,
                                    "isTestReportAvailable": false,
                                    "duration": 5,
                                    "duration_inMinutes": 0.08,
                                    "created_at": "Feb-10-20",
                                    "created_at_rawDateFormat": "2020-02-10T07:06:05.172Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 116503748,
                                "gitlabId": 116503748,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730087,
                                    "isTestReportAvailable": false,
                                    "duration": 4,
                                    "duration_inMinutes": 0.07,
                                    "created_at": "Feb-10-20",
                                    "created_at_rawDateFormat": "2020-02-10T07:06:05.226Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 116502568,
                                "gitlabId": 116502568,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730088,
                                    "isTestReportAvailable": false,
                                    "duration": 4,
                                    "duration_inMinutes": 0.07,
                                    "created_at": "Feb-10-20",
                                    "created_at_rawDateFormat": "2020-02-10T07:06:05.227Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 116501211,
                                "gitlabId": 116501211,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730089,
                                    "isTestReportAvailable": false,
                                    "duration": 4,
                                    "duration_inMinutes": 0.07,
                                    "created_at": "Feb-10-20",
                                    "created_at_rawDateFormat": "2020-02-10T07:06:05.368Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 116497652,
                                "gitlabId": 116497652,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730091,
                                    "isTestReportAvailable": false,
                                    "duration": 5,
                                    "duration_inMinutes": 0.08,
                                    "created_at": "Feb-10-20",
                                    "created_at_rawDateFormat": "2020-02-10T07:06:05.552Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 116448732,
                                "gitlabId": 116448732,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730090,
                                    "isTestReportAvailable": false,
                                    "duration": 4,
                                    "duration_inMinutes": 0.07,
                                    "created_at": "Feb-10-20",
                                    "created_at_rawDateFormat": "2020-02-10T07:06:05.472Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 116427801,
                                "gitlabId": 116427801,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730092,
                                    "isTestReportAvailable": false,
                                    "duration": 595,
                                    "duration_inMinutes": 9.92,
                                    "created_at": "Feb-10-20",
                                    "created_at_rawDateFormat": "2020-02-10T07:06:05.564Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 115138237,
                                "gitlabId": 115138237,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730093,
                                    "isTestReportAvailable": false,
                                    "duration": 652,
                                    "duration_inMinutes": 10.87,
                                    "created_at": "Feb-05-20",
                                    "created_at_rawDateFormat": "2020-02-05T07:06:05.699Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102919970,
                                "gitlabId": 102919970,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730095,
                                    "isTestReportAvailable": false,
                                    "duration": 814,
                                    "duration_inMinutes": 13.57,
                                    "created_at": "Dec-13-19",
                                    "created_at_rawDateFormat": "2019-12-13T07:06:05.818Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102917858,
                                "gitlabId": 102917858,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730094,
                                    "isTestReportAvailable": false,
                                    "duration": 309,
                                    "duration_inMinutes": 5.15,
                                    "created_at": "Dec-13-19",
                                    "created_at_rawDateFormat": "2019-12-13T07:06:05.744Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102905021,
                                "gitlabId": 102905021,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730097,
                                    "isTestReportAvailable": false,
                                    "duration": 304,
                                    "duration_inMinutes": 5.07,
                                    "created_at": "Dec-13-19",
                                    "created_at_rawDateFormat": "2019-12-13T07:06:06.052Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102902063,
                                "gitlabId": 102902063,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730100,
                                    "isTestReportAvailable": false,
                                    "duration": 360,
                                    "duration_inMinutes": 6,
                                    "created_at": "Dec-13-19",
                                    "created_at_rawDateFormat": "2019-12-13T07:06:06.168Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102886807,
                                "gitlabId": 102886807,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730096,
                                    "isTestReportAvailable": false,
                                    "duration": 242,
                                    "duration_inMinutes": 4.03,
                                    "created_at": "Dec-13-19",
                                    "created_at_rawDateFormat": "2019-12-13T07:06:06.007Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102884658,
                                "gitlabId": 102884658,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730098,
                                    "isTestReportAvailable": false,
                                    "duration": 134,
                                    "duration_inMinutes": 2.23,
                                    "created_at": "Dec-13-19",
                                    "created_at_rawDateFormat": "2019-12-13T07:06:06.062Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102877865,
                                "gitlabId": 102877865,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 730099,
                                    "isTestReportAvailable": false,
                                    "duration": 5122,
                                    "duration_inMinutes": 85.37,
                                    "created_at": "Dec-13-19",
                                    "created_at_rawDateFormat": "2019-12-13T07:06:06.131Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102867321,
                                "gitlabId": 102867321,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730101,
                                    "isTestReportAvailable": false,
                                    "duration": 613,
                                    "duration_inMinutes": 10.22,
                                    "created_at": "Dec-13-19",
                                    "created_at_rawDateFormat": "2019-12-13T07:06:06.266Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102514418,
                                "gitlabId": 102514418,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730103,
                                    "isTestReportAvailable": false,
                                    "duration": 634,
                                    "duration_inMinutes": 10.57,
                                    "created_at": "Dec-12-19",
                                    "created_at_rawDateFormat": "2019-12-12T07:06:06.346Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102513696,
                                "gitlabId": 102513696,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730102,
                                    "isTestReportAvailable": false,
                                    "duration": 71,
                                    "duration_inMinutes": 1.18,
                                    "created_at": "Dec-12-19",
                                    "created_at_rawDateFormat": "2019-12-12T07:06:06.313Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102502156,
                                "gitlabId": 102502156,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730104,
                                    "isTestReportAvailable": false,
                                    "duration": 70,
                                    "duration_inMinutes": 1.17,
                                    "created_at": "Dec-12-19",
                                    "created_at_rawDateFormat": "2019-12-12T07:06:06.404Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102500723,
                                "gitlabId": 102500723,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730105,
                                    "isTestReportAvailable": false,
                                    "duration": 261,
                                    "duration_inMinutes": 4.35,
                                    "created_at": "Dec-12-19",
                                    "created_at_rawDateFormat": "2019-12-12T07:06:06.416Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102499232,
                                "gitlabId": 102499232,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730106,
                                    "isTestReportAvailable": false,
                                    "duration": 228,
                                    "duration_inMinutes": 3.8,
                                    "created_at": "Dec-12-19",
                                    "created_at_rawDateFormat": "2019-12-12T07:06:06.526Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102340492,
                                "gitlabId": 102340492,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730108,
                                    "isTestReportAvailable": false,
                                    "duration": 224,
                                    "duration_inMinutes": 3.73,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:06.606Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102334033,
                                "gitlabId": 102334033,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730107,
                                    "isTestReportAvailable": false,
                                    "duration": 275,
                                    "duration_inMinutes": 4.58,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:06.604Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102328381,
                                "gitlabId": 102328381,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730109,
                                    "isTestReportAvailable": false,
                                    "duration": 176,
                                    "duration_inMinutes": 2.93,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:06.668Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102320016,
                                "gitlabId": 102320016,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730110,
                                    "isTestReportAvailable": false,
                                    "duration": 145,
                                    "duration_inMinutes": 2.42,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:06.675Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102317286,
                                "gitlabId": 102317286,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730112,
                                    "isTestReportAvailable": false,
                                    "duration": 38,
                                    "duration_inMinutes": 0.63,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:06.873Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102315487,
                                "gitlabId": 102315487,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730113,
                                    "isTestReportAvailable": false,
                                    "duration": 158,
                                    "duration_inMinutes": 2.63,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:06.881Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102315344,
                                "gitlabId": 102315344,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 730111,
                                    "isTestReportAvailable": false,
                                    "duration": 171,
                                    "duration_inMinutes": 2.85,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:06.868Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102313268,
                                "gitlabId": 102313268,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730114,
                                    "isTestReportAvailable": false,
                                    "duration": 231,
                                    "duration_inMinutes": 3.85,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:06.942Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102310270,
                                "gitlabId": 102310270,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730115,
                                    "isTestReportAvailable": false,
                                    "duration": 178,
                                    "duration_inMinutes": 2.97,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:06.956Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102309874,
                                "gitlabId": 102309874,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 730116,
                                    "isTestReportAvailable": false,
                                    "duration": 40,
                                    "duration_inMinutes": 0.67,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:07.140Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102303411,
                                "gitlabId": 102303411,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730119,
                                    "isTestReportAvailable": false,
                                    "duration": 162,
                                    "duration_inMinutes": 2.7,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:07.317Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102300305,
                                "gitlabId": 102300305,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730145,
                                    "isTestReportAvailable": false,
                                    "duration": 173,
                                    "duration_inMinutes": 2.88,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:09.466Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102299963,
                                "gitlabId": 102299963,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 730118,
                                    "isTestReportAvailable": false,
                                    "duration": 24,
                                    "duration_inMinutes": 0.4,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:07.224Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102299185,
                                "gitlabId": 102299185,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730117,
                                    "isTestReportAvailable": false,
                                    "duration": 67,
                                    "duration_inMinutes": 1.12,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:07.210Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102297799,
                                "gitlabId": 102297799,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730120,
                                    "isTestReportAvailable": false,
                                    "duration": 80,
                                    "duration_inMinutes": 1.33,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:07.455Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102297750,
                                "gitlabId": 102297750,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 730121,
                                    "isTestReportAvailable": false,
                                    "duration": 18,
                                    "duration_inMinutes": 0.3,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:07.631Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102295696,
                                "gitlabId": 102295696,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730127,
                                    "isTestReportAvailable": false,
                                    "duration": 64,
                                    "duration_inMinutes": 1.07,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:08.191Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102294414,
                                "gitlabId": 102294414,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730125,
                                    "isTestReportAvailable": false,
                                    "duration": 64,
                                    "duration_inMinutes": 1.07,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:08.016Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102292330,
                                "gitlabId": 102292330,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730123,
                                    "isTestReportAvailable": false,
                                    "duration": 165,
                                    "duration_inMinutes": 2.75,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:07.763Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102292067,
                                "gitlabId": 102292067,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 730124,
                                    "isTestReportAvailable": false,
                                    "duration": 58,
                                    "duration_inMinutes": 0.97,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:07.952Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102287351,
                                "gitlabId": 102287351,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730135,
                                    "isTestReportAvailable": false,
                                    "duration": 173,
                                    "duration_inMinutes": 2.88,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:08.864Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102286100,
                                "gitlabId": 102286100,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730126,
                                    "isTestReportAvailable": false,
                                    "duration": 112,
                                    "duration_inMinutes": 1.87,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:08.051Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102284009,
                                "gitlabId": 102284009,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730128,
                                    "isTestReportAvailable": false,
                                    "duration": 243,
                                    "duration_inMinutes": 4.05,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:08.262Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102283762,
                                "gitlabId": 102283762,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730129,
                                    "isTestReportAvailable": false,
                                    "duration": 109,
                                    "duration_inMinutes": 1.82,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:08.303Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102274198,
                                "gitlabId": 102274198,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730130,
                                    "isTestReportAvailable": false,
                                    "duration": 199,
                                    "duration_inMinutes": 3.32,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:08.315Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102273631,
                                "gitlabId": 102273631,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730131,
                                    "isTestReportAvailable": false,
                                    "duration": 110,
                                    "duration_inMinutes": 1.83,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:08.473Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102273114,
                                "gitlabId": 102273114,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 730132,
                                    "isTestReportAvailable": false,
                                    "duration": 122,
                                    "duration_inMinutes": 2.03,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:08.510Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102271959,
                                "gitlabId": 102271959,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730134,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:08.698Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102271679,
                                "gitlabId": 102271679,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730133,
                                    "isTestReportAvailable": false,
                                    "duration": 168,
                                    "duration_inMinutes": 2.8,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:08.604Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102270603,
                                "gitlabId": 102270603,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730136,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:08.922Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102261833,
                                "gitlabId": 102261833,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730142,
                                    "isTestReportAvailable": false,
                                    "duration": 99,
                                    "duration_inMinutes": 1.65,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:09.276Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102255039,
                                "gitlabId": 102255039,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730137,
                                    "isTestReportAvailable": false,
                                    "duration": 136,
                                    "duration_inMinutes": 2.27,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:08.925Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102247655,
                                "gitlabId": 102247655,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730138,
                                    "isTestReportAvailable": false,
                                    "duration": 44,
                                    "duration_inMinutes": 0.73,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:08.975Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102246266,
                                "gitlabId": 102246266,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730139,
                                    "isTestReportAvailable": false,
                                    "duration": 263,
                                    "duration_inMinutes": 4.38,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:09.138Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102244743,
                                "gitlabId": 102244743,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730151,
                                    "isTestReportAvailable": false,
                                    "duration": 72,
                                    "duration_inMinutes": 1.2,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:09.898Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102240480,
                                "gitlabId": 102240480,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730140,
                                    "isTestReportAvailable": false,
                                    "duration": 726,
                                    "duration_inMinutes": 12.1,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:09.203Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102236669,
                                "gitlabId": 102236669,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 730141,
                                    "isTestReportAvailable": false,
                                    "duration": 689,
                                    "duration_inMinutes": 11.48,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:09.247Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102228555,
                                "gitlabId": 102228555,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 730143,
                                    "isTestReportAvailable": false,
                                    "duration": 1058,
                                    "duration_inMinutes": 17.63,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:09.413Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102227293,
                                "gitlabId": 102227293,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 730144,
                                    "isTestReportAvailable": false,
                                    "duration": 230,
                                    "duration_inMinutes": 3.83,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:09.460Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102225673,
                                "gitlabId": 102225673,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730146,
                                    "isTestReportAvailable": false,
                                    "duration": 74,
                                    "duration_inMinutes": 1.23,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:09.502Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102224805,
                                "gitlabId": 102224805,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 730147,
                                    "isTestReportAvailable": false,
                                    "duration": 202,
                                    "duration_inMinutes": 3.37,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:09.568Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102221815,
                                "gitlabId": 102221815,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 730148,
                                    "isTestReportAvailable": false,
                                    "duration": 1125,
                                    "duration_inMinutes": 18.75,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:09.662Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102218952,
                                "gitlabId": 102218952,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730149,
                                    "isTestReportAvailable": false,
                                    "duration": 1130,
                                    "duration_inMinutes": 18.83,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:09.716Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102216373,
                                "gitlabId": 102216373,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730153,
                                    "isTestReportAvailable": false,
                                    "duration": 1121,
                                    "duration_inMinutes": 18.68,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:09.977Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102214790,
                                "gitlabId": 102214790,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730150,
                                    "isTestReportAvailable": false,
                                    "duration": 1096,
                                    "duration_inMinutes": 18.27,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:09.794Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102213404,
                                "gitlabId": 102213404,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730155,
                                    "isTestReportAvailable": false,
                                    "duration": 55,
                                    "duration_inMinutes": 0.92,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:10.087Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102212762,
                                "gitlabId": 102212762,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730152,
                                    "isTestReportAvailable": false,
                                    "duration": 81,
                                    "duration_inMinutes": 1.35,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:09.938Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102208647,
                                "gitlabId": 102208647,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730156,
                                    "isTestReportAvailable": false,
                                    "duration": 1105,
                                    "duration_inMinutes": 18.42,
                                    "created_at": "Dec-11-19",
                                    "created_at_rawDateFormat": "2019-12-11T07:06:10.165Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102077523,
                                "gitlabId": 102077523,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730154,
                                    "isTestReportAvailable": false,
                                    "duration": 1038,
                                    "duration_inMinutes": 17.3,
                                    "created_at": "Dec-10-19",
                                    "created_at_rawDateFormat": "2019-12-10T07:06:10.066Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102077408,
                                "gitlabId": 102077408,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730158,
                                    "isTestReportAvailable": false,
                                    "duration": 40,
                                    "duration_inMinutes": 0.67,
                                    "created_at": "Dec-10-19",
                                    "created_at_rawDateFormat": "2019-12-10T07:06:10.323Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102076799,
                                "gitlabId": 102076799,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730157,
                                    "isTestReportAvailable": false,
                                    "duration": 81,
                                    "duration_inMinutes": 1.35,
                                    "created_at": "Dec-10-19",
                                    "created_at_rawDateFormat": "2019-12-10T07:06:10.203Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102075705,
                                "gitlabId": 102075705,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730163,
                                    "isTestReportAvailable": false,
                                    "duration": 1144,
                                    "duration_inMinutes": 19.07,
                                    "created_at": "Dec-10-19",
                                    "created_at_rawDateFormat": "2019-12-10T07:06:10.557Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102071213,
                                "gitlabId": 102071213,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 730159,
                                    "isTestReportAvailable": false,
                                    "duration": 1043,
                                    "duration_inMinutes": 17.38,
                                    "created_at": "Dec-10-19",
                                    "created_at_rawDateFormat": "2019-12-10T07:06:10.341Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102056756,
                                "gitlabId": 102056756,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730160,
                                    "isTestReportAvailable": false,
                                    "duration": 1007,
                                    "duration_inMinutes": 16.78,
                                    "created_at": "Dec-10-19",
                                    "created_at_rawDateFormat": "2019-12-10T07:06:10.355Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102045231,
                                "gitlabId": 102045231,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730162,
                                    "isTestReportAvailable": false,
                                    "duration": 3600,
                                    "duration_inMinutes": 60,
                                    "created_at": "Dec-10-19",
                                    "created_at_rawDateFormat": "2019-12-10T07:06:10.555Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102044831,
                                "gitlabId": 102044831,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730161,
                                    "isTestReportAvailable": false,
                                    "duration": 4,
                                    "duration_inMinutes": 0.07,
                                    "created_at": "Dec-10-19",
                                    "created_at_rawDateFormat": "2019-12-10T07:06:10.471Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102044009,
                                "gitlabId": 102044009,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730165,
                                    "isTestReportAvailable": false,
                                    "duration": 4,
                                    "duration_inMinutes": 0.07,
                                    "created_at": "Dec-10-19",
                                    "created_at_rawDateFormat": "2019-12-10T07:06:10.591Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102043334,
                                "gitlabId": 102043334,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730164,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Dec-10-19",
                                    "created_at_rawDateFormat": "2019-12-10T07:06:10.589Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 102006147,
                                "gitlabId": 102006147,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730169,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Dec-10-19",
                                    "created_at_rawDateFormat": "2019-12-10T07:06:10.851Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 101986784,
                                "gitlabId": 101986784,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730166,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Dec-10-19",
                                    "created_at_rawDateFormat": "2019-12-10T07:06:10.747Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 101969524,
                                "gitlabId": 101969524,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730168,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Dec-10-19",
                                    "created_at_rawDateFormat": "2019-12-10T07:06:10.833Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 98700637,
                                "gitlabId": 98700637,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730167,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-26-19",
                                    "created_at_rawDateFormat": "2019-11-26T07:06:10.832Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 98608899,
                                "gitlabId": 98608899,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730171,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-26-19",
                                    "created_at_rawDateFormat": "2019-11-26T07:06:10.990Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 98284685,
                                "gitlabId": 98284685,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730170,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-25-19",
                                    "created_at_rawDateFormat": "2019-11-25T07:06:10.984Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 98254971,
                                "gitlabId": 98254971,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730173,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-25-19",
                                    "created_at_rawDateFormat": "2019-11-25T07:06:11.202Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 98252686,
                                "gitlabId": 98252686,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730175,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-25-19",
                                    "created_at_rawDateFormat": "2019-11-25T07:06:11.303Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 97899256,
                                "gitlabId": 97899256,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730176,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Nov-22-19",
                                    "created_at_rawDateFormat": "2019-11-22T07:06:11.354Z",
                                    "testCoverage": null
                                }
                            }
                        ],
                        "groupInfo": {
                            "id": 29715,
                            "gitlabId": 8198028,
                            "name": "Flatley-LLC"
                        }
                    },
                    {
                        "id": 27161946,
                        "gitlabId": 27161946,
                        "name": "Flatley-LLC-43",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Flatley-LLC.git",
                        "stats": {
                            "id": 29753,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "216457543",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29748,
                            "gitlabId": 8198028,
                            "name": "Flatley-LLC"
                        }
                    },
                    {
                        "id": 26534547,
                        "gitlabId": 26534547,
                        "name": "Flatley-LLC-86",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Flatley-LLC-docker.git",
                        "stats": {
                            "id": 29740,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "933232",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29752,
                            "gitlabId": 8198028,
                            "name": "Flatley-LLC"
                        }
                    },
                    {
                        "id": 26534504,
                        "gitlabId": 26534504,
                        "name": "Flatley-LLC-Nestjs",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Flatley-LLC.git",
                        "stats": {
                            "id": 29783,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "0",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29794,
                            "gitlabId": 8198028,
                            "name": "Flatley-LLC"
                        }
                    },
                    {
                        "id": 24654587,
                        "gitlabId": 24654587,
                        "name": "Flatley-LLC-22",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Flatley-LLC/more.git",
                        "stats": {
                            "id": 29789,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "66804776",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29791,
                            "gitlabId": 8198028,
                            "name": "Flatley-LLC"
                        }
                    },
                    {
                        "id": 15287857,
                        "gitlabId": 15287857,
                        "name": "Flatley-LLC-evaluation",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Flatley-LLC-evaluation.git",
                        "stats": {
                            "id": 29759,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "2338324",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29772,
                            "gitlabId": 8198028,
                            "name": "Flatley-LLC"
                        }
                    },
                    {
                        "id": 14408705,
                        "gitlabId": 14408705,
                        "name": "Flatley-LLC-Plugin",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Flatley-LLC-plugin.git",
                        "stats": {
                            "id": 29778,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "807403",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29766,
                            "gitlabId": 8198028,
                            "name": "Flatley-LLC"
                        }
                    },
                    {
                        "id": 24838819,
                        "gitlabId": 24838819,
                        "name": "Flatley-LLC-gwb",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Flatley-LLC-gwb.git",
                        "stats": {
                            "id": 29774,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "5274337",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29760,
                            "gitlabId": 8198028,
                            "name": "Flatley-LLC"
                        }
                    },
                    {
                        "id": 26534119,
                        "gitlabId": 26534119,
                        "name": "Flatley-LLC-Testing",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Flatley-LLC-testing.git",
                        "stats": {
                            "id": 29729,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "0",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29736,
                            "gitlabId": 8198028,
                            "name": "Flatley-LLC"
                        }
                    },
                    {
                        "id": 24425235,
                        "gitlabId": 24425235,
                        "name": "Flatley-LLC-Sis",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Flatley-LLCsis.git",
                        "stats": {
                            "id": 29730,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "13516144",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29741,
                            "gitlabId": 8198028,
                            "name": "Flatley-LLC"
                        }
                    }
                ],
                "subGroups": [],
                "stats": {
                    "id": 6710,
                    "isThereSubgroups": false,
                    "numberOfProjects": 12,
                    "testCoverageOfAllProjects": null,
                    "numberOfPipelines": 93,
                    "numberOfTestReports": 0
                }
            },
            {
                "id": 8652138,
                "tempData": false,
                "gitlabId": 8652138,
                "name": "Bühler",
                "projects": [
                    {
                        "id": 20174130,
                        "gitlabId": 20174130,
                        "name": "Bühler",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Bühler.git",
                        "stats": {
                            "id": 29709,
                            "status": "success",
                            "numberOfPipelines": 97,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": true,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 445,
                            "averageDurationOfPipelines_inMinutes": 7.42,
                            "testCoverage": 18.75,
                            "numberOfSuccessfulPipelines": 66,
                            "numberOfFailedPipelines": 24,
                            "numberOfCanceledPipelines": 6,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": 68.04,
                            "totalRepoSize": "48842670",
                            "artifactsSize": "7277031604"
                        },
                        "pipelines": [
                            {
                                "id": 482961508,
                                "gitlabId": 482961508,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729763,
                                    "isTestReportAvailable": false,
                                    "duration": 307,
                                    "duration_inMinutes": 5.12,
                                    "created_at": "Mar-02-22",
                                    "created_at_rawDateFormat": "2022-03-02T07:05:45.489Z",
                                    "testCoverage": 18.75
                                }
                            },
                            {
                                "id": 405983937,
                                "gitlabId": 405983937,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729764,
                                    "isTestReportAvailable": false,
                                    "duration": 291,
                                    "duration_inMinutes": 4.85,
                                    "created_at": "Nov-10-21",
                                    "created_at_rawDateFormat": "2021-11-10T07:05:45.522Z",
                                    "testCoverage": 18.71
                                }
                            },
                            {
                                "id": 387426403,
                                "gitlabId": 387426403,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729766,
                                    "isTestReportAvailable": false,
                                    "duration": 329,
                                    "duration_inMinutes": 5.48,
                                    "created_at": "Oct-13-21",
                                    "created_at_rawDateFormat": "2021-10-13T07:05:45.714Z",
                                    "testCoverage": 18.75
                                }
                            },
                            {
                                "id": 384025761,
                                "gitlabId": 384025761,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729770,
                                    "isTestReportAvailable": false,
                                    "duration": 339,
                                    "duration_inMinutes": 5.65,
                                    "created_at": "Oct-07-21",
                                    "created_at_rawDateFormat": "2021-10-07T07:05:45.873Z",
                                    "testCoverage": 18.75
                                }
                            },
                            {
                                "id": 375721210,
                                "gitlabId": 375721210,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729790,
                                    "isTestReportAvailable": false,
                                    "duration": 282,
                                    "duration_inMinutes": 4.7,
                                    "created_at": "Sep-23-21",
                                    "created_at_rawDateFormat": "2021-09-23T07:05:47.117Z",
                                    "testCoverage": 18.76
                                }
                            },
                            {
                                "id": 371858667,
                                "gitlabId": 371858667,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729767,
                                    "isTestReportAvailable": false,
                                    "duration": 318,
                                    "duration_inMinutes": 5.3,
                                    "created_at": "Sep-16-21",
                                    "created_at_rawDateFormat": "2021-09-16T07:05:45.748Z",
                                    "testCoverage": 18.76
                                }
                            },
                            {
                                "id": 340738713,
                                "gitlabId": 340738713,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729769,
                                    "isTestReportAvailable": false,
                                    "duration": 342,
                                    "duration_inMinutes": 5.7,
                                    "created_at": "Jul-21-21",
                                    "created_at_rawDateFormat": "2021-07-21T07:05:45.866Z",
                                    "testCoverage": 18.74
                                }
                            },
                            {
                                "id": 340732813,
                                "gitlabId": 340732813,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729768,
                                    "isTestReportAvailable": false,
                                    "duration": 452,
                                    "duration_inMinutes": 7.53,
                                    "created_at": "Jul-21-21",
                                    "created_at_rawDateFormat": "2021-07-21T07:05:45.830Z",
                                    "testCoverage": 18.74
                                }
                            },
                            {
                                "id": 340732482,
                                "gitlabId": 340732482,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729771,
                                    "isTestReportAvailable": false,
                                    "duration": 350,
                                    "duration_inMinutes": 5.83,
                                    "created_at": "Jul-21-21",
                                    "created_at_rawDateFormat": "2021-07-21T07:05:45.993Z",
                                    "testCoverage": 18.74
                                }
                            },
                            {
                                "id": 340490330,
                                "gitlabId": 340490330,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729772,
                                    "isTestReportAvailable": false,
                                    "duration": 356,
                                    "duration_inMinutes": 5.93,
                                    "created_at": "Jul-21-21",
                                    "created_at_rawDateFormat": "2021-07-21T07:05:46.002Z",
                                    "testCoverage": 18.74
                                }
                            },
                            {
                                "id": 340444378,
                                "gitlabId": 340444378,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729773,
                                    "isTestReportAvailable": false,
                                    "duration": 696,
                                    "duration_inMinutes": 11.6,
                                    "created_at": "Jul-21-21",
                                    "created_at_rawDateFormat": "2021-07-21T07:05:46.099Z",
                                    "testCoverage": 18.74
                                }
                            },
                            {
                                "id": 340106880,
                                "gitlabId": 340106880,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729777,
                                    "isTestReportAvailable": false,
                                    "duration": 547,
                                    "duration_inMinutes": 9.12,
                                    "created_at": "Jul-20-21",
                                    "created_at_rawDateFormat": "2021-07-20T07:05:46.287Z",
                                    "testCoverage": 18.75
                                }
                            },
                            {
                                "id": 340067552,
                                "gitlabId": 340067552,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729774,
                                    "isTestReportAvailable": false,
                                    "duration": 409,
                                    "duration_inMinutes": 6.82,
                                    "created_at": "Jul-20-21",
                                    "created_at_rawDateFormat": "2021-07-20T07:05:46.134Z",
                                    "testCoverage": 18.75
                                }
                            },
                            {
                                "id": 340066090,
                                "gitlabId": 340066090,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729775,
                                    "isTestReportAvailable": false,
                                    "duration": 502,
                                    "duration_inMinutes": 8.37,
                                    "created_at": "Jul-20-21",
                                    "created_at_rawDateFormat": "2021-07-20T07:05:46.266Z",
                                    "testCoverage": 18.75
                                }
                            },
                            {
                                "id": 340059029,
                                "gitlabId": 340059029,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729776,
                                    "isTestReportAvailable": false,
                                    "duration": 674,
                                    "duration_inMinutes": 11.23,
                                    "created_at": "Jul-20-21",
                                    "created_at_rawDateFormat": "2021-07-20T07:05:46.268Z",
                                    "testCoverage": 18.75
                                }
                            },
                            {
                                "id": 340049805,
                                "gitlabId": 340049805,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729779,
                                    "isTestReportAvailable": false,
                                    "duration": 519,
                                    "duration_inMinutes": 8.65,
                                    "created_at": "Jul-20-21",
                                    "created_at_rawDateFormat": "2021-07-20T07:05:46.384Z",
                                    "testCoverage": 18.75
                                }
                            },
                            {
                                "id": 337482518,
                                "gitlabId": 337482518,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729778,
                                    "isTestReportAvailable": false,
                                    "duration": 359,
                                    "duration_inMinutes": 5.98,
                                    "created_at": "Jul-15-21",
                                    "created_at_rawDateFormat": "2021-07-15T07:05:46.383Z",
                                    "testCoverage": 18.75
                                }
                            },
                            {
                                "id": 337030784,
                                "gitlabId": 337030784,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729780,
                                    "isTestReportAvailable": false,
                                    "duration": 332,
                                    "duration_inMinutes": 5.53,
                                    "created_at": "Jul-14-21",
                                    "created_at_rawDateFormat": "2021-07-14T07:05:46.517Z",
                                    "testCoverage": 18.75
                                }
                            },
                            {
                                "id": 337001650,
                                "gitlabId": 337001650,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729781,
                                    "isTestReportAvailable": false,
                                    "duration": 350,
                                    "duration_inMinutes": 5.83,
                                    "created_at": "Jul-14-21",
                                    "created_at_rawDateFormat": "2021-07-14T07:05:46.603Z",
                                    "testCoverage": 18.75
                                }
                            },
                            {
                                "id": 331915633,
                                "gitlabId": 331915633,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729783,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Jul-05-21",
                                    "created_at_rawDateFormat": "2021-07-05T07:05:46.780Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 331914005,
                                "gitlabId": 331914005,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729784,
                                    "isTestReportAvailable": false,
                                    "duration": 100,
                                    "duration_inMinutes": 1.67,
                                    "created_at": "Jul-05-21",
                                    "created_at_rawDateFormat": "2021-07-05T07:05:46.815Z",
                                    "testCoverage": 24.94
                                }
                            },
                            {
                                "id": 331033081,
                                "gitlabId": 331033081,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729782,
                                    "isTestReportAvailable": false,
                                    "duration": 54,
                                    "duration_inMinutes": 0.9,
                                    "created_at": "Jul-02-21",
                                    "created_at_rawDateFormat": "2021-07-02T07:05:46.634Z",
                                    "testCoverage": 25.35
                                }
                            },
                            {
                                "id": 330892952,
                                "gitlabId": 330892952,
                                "status": "manual",
                                "testReport": null,
                                "stats": {
                                    "id": 729785,
                                    "isTestReportAvailable": false,
                                    "duration": 346,
                                    "duration_inMinutes": 5.77,
                                    "created_at": "Jul-02-21",
                                    "created_at_rawDateFormat": "2021-07-02T07:05:46.823Z",
                                    "testCoverage": 18.75
                                }
                            },
                            {
                                "id": 311144190,
                                "gitlabId": 311144190,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729786,
                                    "isTestReportAvailable": false,
                                    "duration": 490,
                                    "duration_inMinutes": 8.17,
                                    "created_at": "May-28-21",
                                    "created_at_rawDateFormat": "2021-05-28T07:05:46.865Z",
                                    "testCoverage": 18.75
                                }
                            },
                            {
                                "id": 311136933,
                                "gitlabId": 311136933,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729787,
                                    "isTestReportAvailable": false,
                                    "duration": 519,
                                    "duration_inMinutes": 8.65,
                                    "created_at": "May-28-21",
                                    "created_at_rawDateFormat": "2021-05-28T07:05:46.904Z",
                                    "testCoverage": 18.75
                                }
                            },
                            {
                                "id": 311118364,
                                "gitlabId": 311118364,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729789,
                                    "isTestReportAvailable": false,
                                    "duration": 531,
                                    "duration_inMinutes": 8.85,
                                    "created_at": "May-28-21",
                                    "created_at_rawDateFormat": "2021-05-28T07:05:47.103Z",
                                    "testCoverage": 18.75
                                }
                            },
                            {
                                "id": 298977059,
                                "gitlabId": 298977059,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729788,
                                    "isTestReportAvailable": false,
                                    "duration": 647,
                                    "duration_inMinutes": 10.78,
                                    "created_at": "May-07-21",
                                    "created_at_rawDateFormat": "2021-05-07T07:05:47.086Z",
                                    "testCoverage": 18.75
                                }
                            },
                            {
                                "id": 298868842,
                                "gitlabId": 298868842,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729792,
                                    "isTestReportAvailable": false,
                                    "duration": 494,
                                    "duration_inMinutes": 8.23,
                                    "created_at": "May-07-21",
                                    "created_at_rawDateFormat": "2021-05-07T07:05:47.377Z",
                                    "testCoverage": 18.75
                                }
                            },
                            {
                                "id": 298509801,
                                "gitlabId": 298509801,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729800,
                                    "isTestReportAvailable": false,
                                    "duration": 3603,
                                    "duration_inMinutes": 60.05,
                                    "created_at": "May-06-21",
                                    "created_at_rawDateFormat": "2021-05-06T07:05:47.680Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 293096694,
                                "gitlabId": 293096694,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729794,
                                    "isTestReportAvailable": false,
                                    "duration": 564,
                                    "duration_inMinutes": 9.4,
                                    "created_at": "Apr-27-21",
                                    "created_at_rawDateFormat": "2021-04-27T07:05:47.403Z",
                                    "testCoverage": 18.71
                                }
                            },
                            {
                                "id": 282115076,
                                "gitlabId": 282115076,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729791,
                                    "isTestReportAvailable": false,
                                    "duration": 118,
                                    "duration_inMinutes": 1.97,
                                    "created_at": "Apr-06-21",
                                    "created_at_rawDateFormat": "2021-04-06T07:05:47.373Z",
                                    "testCoverage": 18.5
                                }
                            },
                            {
                                "id": 281866671,
                                "gitlabId": 281866671,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729795,
                                    "isTestReportAvailable": false,
                                    "duration": 437,
                                    "duration_inMinutes": 7.28,
                                    "created_at": "Apr-06-21",
                                    "created_at_rawDateFormat": "2021-04-06T07:05:47.609Z",
                                    "testCoverage": 18.1
                                }
                            },
                            {
                                "id": 280142652,
                                "gitlabId": 280142652,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729793,
                                    "isTestReportAvailable": false,
                                    "duration": 425,
                                    "duration_inMinutes": 7.08,
                                    "created_at": "Apr-01-21",
                                    "created_at_rawDateFormat": "2021-04-01T07:05:47.382Z",
                                    "testCoverage": 18.11
                                }
                            },
                            {
                                "id": 280021598,
                                "gitlabId": 280021598,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729796,
                                    "isTestReportAvailable": false,
                                    "duration": 508,
                                    "duration_inMinutes": 8.47,
                                    "created_at": "Apr-01-21",
                                    "created_at_rawDateFormat": "2021-04-01T07:05:47.620Z",
                                    "testCoverage": 10.39
                                }
                            },
                            {
                                "id": 280019984,
                                "gitlabId": 280019984,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729798,
                                    "isTestReportAvailable": false,
                                    "duration": 566,
                                    "duration_inMinutes": 9.43,
                                    "created_at": "Apr-01-21",
                                    "created_at_rawDateFormat": "2021-04-01T07:05:47.661Z",
                                    "testCoverage": 10.39
                                }
                            },
                            {
                                "id": 279294426,
                                "gitlabId": 279294426,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729797,
                                    "isTestReportAvailable": false,
                                    "duration": 544,
                                    "duration_inMinutes": 9.07,
                                    "created_at": "Mar-31-21",
                                    "created_at_rawDateFormat": "2021-03-31T07:05:47.660Z",
                                    "testCoverage": 10.36
                                }
                            },
                            {
                                "id": 279253195,
                                "gitlabId": 279253195,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729799,
                                    "isTestReportAvailable": false,
                                    "duration": 465,
                                    "duration_inMinutes": 7.75,
                                    "created_at": "Mar-31-21",
                                    "created_at_rawDateFormat": "2021-03-31T07:05:47.675Z",
                                    "testCoverage": 10.36
                                }
                            },
                            {
                                "id": 278738264,
                                "gitlabId": 278738264,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729802,
                                    "isTestReportAvailable": false,
                                    "duration": 455,
                                    "duration_inMinutes": 7.58,
                                    "created_at": "Mar-30-21",
                                    "created_at_rawDateFormat": "2021-03-30T07:05:47.899Z",
                                    "testCoverage": 10.36
                                }
                            },
                            {
                                "id": 278686642,
                                "gitlabId": 278686642,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729801,
                                    "isTestReportAvailable": false,
                                    "duration": 449,
                                    "duration_inMinutes": 7.48,
                                    "created_at": "Mar-30-21",
                                    "created_at_rawDateFormat": "2021-03-30T07:05:47.891Z",
                                    "testCoverage": 10.36
                                }
                            },
                            {
                                "id": 275675322,
                                "gitlabId": 275675322,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729803,
                                    "isTestReportAvailable": false,
                                    "duration": 564,
                                    "duration_inMinutes": 9.4,
                                    "created_at": "Mar-24-21",
                                    "created_at_rawDateFormat": "2021-03-24T07:05:47.914Z",
                                    "testCoverage": 10.36
                                }
                            },
                            {
                                "id": 272048654,
                                "gitlabId": 272048654,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729805,
                                    "isTestReportAvailable": false,
                                    "duration": 540,
                                    "duration_inMinutes": 9,
                                    "created_at": "Mar-17-21",
                                    "created_at_rawDateFormat": "2021-03-17T07:05:48.007Z",
                                    "testCoverage": 10.38
                                }
                            },
                            {
                                "id": 271807945,
                                "gitlabId": 271807945,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729804,
                                    "isTestReportAvailable": false,
                                    "duration": 516,
                                    "duration_inMinutes": 8.6,
                                    "created_at": "Mar-17-21",
                                    "created_at_rawDateFormat": "2021-03-17T07:05:47.992Z",
                                    "testCoverage": 10.38
                                }
                            },
                            {
                                "id": 271800377,
                                "gitlabId": 271800377,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729806,
                                    "isTestReportAvailable": false,
                                    "duration": 505,
                                    "duration_inMinutes": 8.42,
                                    "created_at": "Mar-17-21",
                                    "created_at_rawDateFormat": "2021-03-17T07:05:48.098Z",
                                    "testCoverage": 10.38
                                }
                            },
                            {
                                "id": 271780295,
                                "gitlabId": 271780295,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729807,
                                    "isTestReportAvailable": false,
                                    "duration": 2433,
                                    "duration_inMinutes": 40.55,
                                    "created_at": "Mar-17-21",
                                    "created_at_rawDateFormat": "2021-03-17T07:05:48.164Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 254176657,
                                "gitlabId": 254176657,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729808,
                                    "isTestReportAvailable": false,
                                    "duration": 723,
                                    "duration_inMinutes": 12.05,
                                    "created_at": "Feb-10-21",
                                    "created_at_rawDateFormat": "2021-02-10T07:05:48.173Z",
                                    "testCoverage": 9.54
                                }
                            },
                            {
                                "id": 244799484,
                                "gitlabId": 244799484,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729809,
                                    "isTestReportAvailable": false,
                                    "duration": 408,
                                    "duration_inMinutes": 6.8,
                                    "created_at": "Jan-21-21",
                                    "created_at_rawDateFormat": "2021-01-21T07:05:48.219Z",
                                    "testCoverage": 9.55
                                }
                            },
                            {
                                "id": 233364748,
                                "gitlabId": 233364748,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729811,
                                    "isTestReportAvailable": false,
                                    "duration": 323,
                                    "duration_inMinutes": 5.38,
                                    "created_at": "Dec-22-20",
                                    "created_at_rawDateFormat": "2020-12-22T07:05:48.386Z",
                                    "testCoverage": 9.55
                                }
                            },
                            {
                                "id": 233361460,
                                "gitlabId": 233361460,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729814,
                                    "isTestReportAvailable": false,
                                    "duration": 417,
                                    "duration_inMinutes": 6.95,
                                    "created_at": "Dec-22-20",
                                    "created_at_rawDateFormat": "2020-12-22T07:05:48.486Z",
                                    "testCoverage": 9.55
                                }
                            },
                            {
                                "id": 233361199,
                                "gitlabId": 233361199,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729810,
                                    "isTestReportAvailable": false,
                                    "duration": 78,
                                    "duration_inMinutes": 1.3,
                                    "created_at": "Dec-22-20",
                                    "created_at_rawDateFormat": "2020-12-22T07:05:48.359Z",
                                    "testCoverage": 9.55
                                }
                            },
                            {
                                "id": 233356532,
                                "gitlabId": 233356532,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729812,
                                    "isTestReportAvailable": false,
                                    "duration": 299,
                                    "duration_inMinutes": 4.98,
                                    "created_at": "Dec-22-20",
                                    "created_at_rawDateFormat": "2020-12-22T07:05:48.427Z",
                                    "testCoverage": 9.55
                                }
                            },
                            {
                                "id": 233344052,
                                "gitlabId": 233344052,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729815,
                                    "isTestReportAvailable": false,
                                    "duration": 348,
                                    "duration_inMinutes": 5.8,
                                    "created_at": "Dec-22-20",
                                    "created_at_rawDateFormat": "2020-12-22T07:05:48.497Z",
                                    "testCoverage": 9.55
                                }
                            },
                            {
                                "id": 232899846,
                                "gitlabId": 232899846,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729813,
                                    "isTestReportAvailable": false,
                                    "duration": 934,
                                    "duration_inMinutes": 15.57,
                                    "created_at": "Dec-21-20",
                                    "created_at_rawDateFormat": "2020-12-21T07:05:48.479Z",
                                    "testCoverage": 9.55
                                }
                            },
                            {
                                "id": 232887768,
                                "gitlabId": 232887768,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729816,
                                    "isTestReportAvailable": false,
                                    "duration": 1543,
                                    "duration_inMinutes": 25.72,
                                    "created_at": "Dec-21-20",
                                    "created_at_rawDateFormat": "2020-12-21T07:05:48.624Z",
                                    "testCoverage": 9.55
                                }
                            },
                            {
                                "id": 229428812,
                                "gitlabId": 229428812,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729817,
                                    "isTestReportAvailable": false,
                                    "duration": 271,
                                    "duration_inMinutes": 4.52,
                                    "created_at": "Dec-14-20",
                                    "created_at_rawDateFormat": "2020-12-14T07:05:48.727Z",
                                    "testCoverage": 9.62
                                }
                            },
                            {
                                "id": 229420436,
                                "gitlabId": 229420436,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729818,
                                    "isTestReportAvailable": false,
                                    "duration": 88,
                                    "duration_inMinutes": 1.47,
                                    "created_at": "Dec-14-20",
                                    "created_at_rawDateFormat": "2020-12-14T07:05:48.832Z",
                                    "testCoverage": 8.77
                                }
                            },
                            {
                                "id": 229419948,
                                "gitlabId": 229419948,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729820,
                                    "isTestReportAvailable": false,
                                    "duration": 60,
                                    "duration_inMinutes": 1,
                                    "created_at": "Dec-14-20",
                                    "created_at_rawDateFormat": "2020-12-14T07:05:48.857Z",
                                    "testCoverage": 8.77
                                }
                            },
                            {
                                "id": 229344251,
                                "gitlabId": 229344251,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729834,
                                    "isTestReportAvailable": false,
                                    "duration": 309,
                                    "duration_inMinutes": 5.15,
                                    "created_at": "Dec-14-20",
                                    "created_at_rawDateFormat": "2020-12-14T07:05:49.763Z",
                                    "testCoverage": 9.55
                                }
                            },
                            {
                                "id": 228512069,
                                "gitlabId": 228512069,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729819,
                                    "isTestReportAvailable": false,
                                    "duration": 328,
                                    "duration_inMinutes": 5.47,
                                    "created_at": "Dec-11-20",
                                    "created_at_rawDateFormat": "2020-12-11T07:05:48.856Z",
                                    "testCoverage": 9.55
                                }
                            },
                            {
                                "id": 228506622,
                                "gitlabId": 228506622,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729821,
                                    "isTestReportAvailable": false,
                                    "duration": 109,
                                    "duration_inMinutes": 1.82,
                                    "created_at": "Dec-11-20",
                                    "created_at_rawDateFormat": "2020-12-11T07:05:48.895Z",
                                    "testCoverage": 9.4
                                }
                            },
                            {
                                "id": 228500410,
                                "gitlabId": 228500410,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729822,
                                    "isTestReportAvailable": false,
                                    "duration": 6,
                                    "duration_inMinutes": 0.1,
                                    "created_at": "Dec-11-20",
                                    "created_at_rawDateFormat": "2020-12-11T07:05:48.984Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 228496368,
                                "gitlabId": 228496368,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729823,
                                    "isTestReportAvailable": false,
                                    "duration": 167,
                                    "duration_inMinutes": 2.78,
                                    "created_at": "Dec-11-20",
                                    "created_at_rawDateFormat": "2020-12-11T07:05:49.085Z",
                                    "testCoverage": 9.65
                                }
                            },
                            {
                                "id": 228494667,
                                "gitlabId": 228494667,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729827,
                                    "isTestReportAvailable": false,
                                    "duration": 417,
                                    "duration_inMinutes": 6.95,
                                    "created_at": "Dec-11-20",
                                    "created_at_rawDateFormat": "2020-12-11T07:05:49.396Z",
                                    "testCoverage": 9.43
                                }
                            },
                            {
                                "id": 228491894,
                                "gitlabId": 228491894,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729825,
                                    "isTestReportAvailable": false,
                                    "duration": 335,
                                    "duration_inMinutes": 5.58,
                                    "created_at": "Dec-11-20",
                                    "created_at_rawDateFormat": "2020-12-11T07:05:49.269Z",
                                    "testCoverage": 9.43
                                }
                            },
                            {
                                "id": 228452419,
                                "gitlabId": 228452419,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729824,
                                    "isTestReportAvailable": false,
                                    "duration": 333,
                                    "duration_inMinutes": 5.55,
                                    "created_at": "Dec-11-20",
                                    "created_at_rawDateFormat": "2020-12-11T07:05:49.205Z",
                                    "testCoverage": 10.25
                                }
                            },
                            {
                                "id": 226255790,
                                "gitlabId": 226255790,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729826,
                                    "isTestReportAvailable": false,
                                    "duration": 47,
                                    "duration_inMinutes": 0.78,
                                    "created_at": "Dec-07-20",
                                    "created_at_rawDateFormat": "2020-12-07T07:05:49.286Z",
                                    "testCoverage": 22.05
                                }
                            },
                            {
                                "id": 226242172,
                                "gitlabId": 226242172,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729828,
                                    "isTestReportAvailable": false,
                                    "duration": 53,
                                    "duration_inMinutes": 0.88,
                                    "created_at": "Dec-07-20",
                                    "created_at_rawDateFormat": "2020-12-07T07:05:49.414Z",
                                    "testCoverage": 26.55
                                }
                            },
                            {
                                "id": 225399238,
                                "gitlabId": 225399238,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729829,
                                    "isTestReportAvailable": false,
                                    "duration": 479,
                                    "duration_inMinutes": 7.98,
                                    "created_at": "Dec-04-20",
                                    "created_at_rawDateFormat": "2020-12-04T07:05:49.478Z",
                                    "testCoverage": 10.25
                                }
                            },
                            {
                                "id": 225395567,
                                "gitlabId": 225395567,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729830,
                                    "isTestReportAvailable": false,
                                    "duration": 434,
                                    "duration_inMinutes": 7.23,
                                    "created_at": "Dec-04-20",
                                    "created_at_rawDateFormat": "2020-12-04T07:05:49.526Z",
                                    "testCoverage": 10.25
                                }
                            },
                            {
                                "id": 225313208,
                                "gitlabId": 225313208,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729833,
                                    "isTestReportAvailable": false,
                                    "duration": 452,
                                    "duration_inMinutes": 7.53,
                                    "created_at": "Dec-04-20",
                                    "created_at_rawDateFormat": "2020-12-04T07:05:49.730Z",
                                    "testCoverage": 10.09
                                }
                            },
                            {
                                "id": 225312846,
                                "gitlabId": 225312846,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729831,
                                    "isTestReportAvailable": false,
                                    "duration": 32,
                                    "duration_inMinutes": 0.53,
                                    "created_at": "Dec-04-20",
                                    "created_at_rawDateFormat": "2020-12-04T07:05:49.676Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 225311711,
                                "gitlabId": 225311711,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 729832,
                                    "isTestReportAvailable": false,
                                    "duration": 165,
                                    "duration_inMinutes": 2.75,
                                    "created_at": "Dec-04-20",
                                    "created_at_rawDateFormat": "2020-12-04T07:05:49.682Z",
                                    "testCoverage": 10.09
                                }
                            },
                            {
                                "id": 225295179,
                                "gitlabId": 225295179,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729836,
                                    "isTestReportAvailable": false,
                                    "duration": 509,
                                    "duration_inMinutes": 8.48,
                                    "created_at": "Dec-04-20",
                                    "created_at_rawDateFormat": "2020-12-04T07:05:49.826Z",
                                    "testCoverage": 10.09
                                }
                            },
                            {
                                "id": 225202130,
                                "gitlabId": 225202130,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729835,
                                    "isTestReportAvailable": false,
                                    "duration": 233,
                                    "duration_inMinutes": 3.88,
                                    "created_at": "Dec-04-20",
                                    "created_at_rawDateFormat": "2020-12-04T07:05:49.789Z",
                                    "testCoverage": 26.13
                                }
                            },
                            {
                                "id": 225184073,
                                "gitlabId": 225184073,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729837,
                                    "isTestReportAvailable": false,
                                    "duration": 583,
                                    "duration_inMinutes": 9.72,
                                    "created_at": "Dec-04-20",
                                    "created_at_rawDateFormat": "2020-12-04T07:05:49.975Z",
                                    "testCoverage": 10.09
                                }
                            },
                            {
                                "id": 224928443,
                                "gitlabId": 224928443,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729839,
                                    "isTestReportAvailable": false,
                                    "duration": 609,
                                    "duration_inMinutes": 10.15,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:50.014Z",
                                    "testCoverage": 10.09
                                }
                            },
                            {
                                "id": 224920827,
                                "gitlabId": 224920827,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729838,
                                    "isTestReportAvailable": false,
                                    "duration": 302,
                                    "duration_inMinutes": 5.03,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:49.998Z",
                                    "testCoverage": 10.09
                                }
                            },
                            {
                                "id": 224903609,
                                "gitlabId": 224903609,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729841,
                                    "isTestReportAvailable": false,
                                    "duration": 635,
                                    "duration_inMinutes": 10.58,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:50.090Z",
                                    "testCoverage": 10.09
                                }
                            },
                            {
                                "id": 224890486,
                                "gitlabId": 224890486,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729840,
                                    "isTestReportAvailable": false,
                                    "duration": 486,
                                    "duration_inMinutes": 8.1,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:50.060Z",
                                    "testCoverage": 8.18
                                }
                            },
                            {
                                "id": 224888920,
                                "gitlabId": 224888920,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 729842,
                                    "isTestReportAvailable": false,
                                    "duration": 735,
                                    "duration_inMinutes": 12.25,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:50.098Z",
                                    "testCoverage": 10.09
                                }
                            },
                            {
                                "id": 224888469,
                                "gitlabId": 224888469,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729843,
                                    "isTestReportAvailable": false,
                                    "duration": 409,
                                    "duration_inMinutes": 6.82,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:50.248Z",
                                    "testCoverage": 8.18
                                }
                            },
                            {
                                "id": 224887431,
                                "gitlabId": 224887431,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729844,
                                    "isTestReportAvailable": false,
                                    "duration": 200,
                                    "duration_inMinutes": 3.33,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:50.274Z",
                                    "testCoverage": 9.25
                                }
                            },
                            {
                                "id": 224861835,
                                "gitlabId": 224861835,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729845,
                                    "isTestReportAvailable": false,
                                    "duration": 182,
                                    "duration_inMinutes": 3.03,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:50.319Z",
                                    "testCoverage": 9.15
                                }
                            },
                            {
                                "id": 224859514,
                                "gitlabId": 224859514,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729846,
                                    "isTestReportAvailable": false,
                                    "duration": 179,
                                    "duration_inMinutes": 2.98,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:50.336Z",
                                    "testCoverage": 9.25
                                }
                            },
                            {
                                "id": 224854896,
                                "gitlabId": 224854896,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 729848,
                                    "isTestReportAvailable": false,
                                    "duration": 157,
                                    "duration_inMinutes": 2.62,
                                    "created_at": "Dec-03-20",
                                    "created_at_rawDateFormat": "2020-12-03T07:05:50.384Z",
                                    "testCoverage": 9.41
                                }
                            },
                            {
                                "id": 223786225,
                                "gitlabId": 223786225,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730071,
                                    "isTestReportAvailable": false,
                                    "duration": 514,
                                    "duration_inMinutes": 8.57,
                                    "created_at": "Dec-01-20",
                                    "created_at_rawDateFormat": "2020-12-01T07:06:04.299Z",
                                    "testCoverage": 10.05
                                }
                            },
                            {
                                "id": 223781699,
                                "gitlabId": 223781699,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730073,
                                    "isTestReportAvailable": false,
                                    "duration": 492,
                                    "duration_inMinutes": 8.2,
                                    "created_at": "Dec-01-20",
                                    "created_at_rawDateFormat": "2020-12-01T07:06:04.320Z",
                                    "testCoverage": 10.05
                                }
                            },
                            {
                                "id": 223778201,
                                "gitlabId": 223778201,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730072,
                                    "isTestReportAvailable": false,
                                    "duration": 362,
                                    "duration_inMinutes": 6.03,
                                    "created_at": "Dec-01-20",
                                    "created_at_rawDateFormat": "2020-12-01T07:06:04.318Z",
                                    "testCoverage": 10.04
                                }
                            },
                            {
                                "id": 223679107,
                                "gitlabId": 223679107,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730077,
                                    "isTestReportAvailable": false,
                                    "duration": 309,
                                    "duration_inMinutes": 5.15,
                                    "created_at": "Dec-01-20",
                                    "created_at_rawDateFormat": "2020-12-01T07:06:04.625Z",
                                    "testCoverage": 10.04
                                }
                            },
                            {
                                "id": 222069619,
                                "gitlabId": 222069619,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 730078,
                                    "isTestReportAvailable": false,
                                    "duration": 739,
                                    "duration_inMinutes": 12.32,
                                    "created_at": "Nov-27-20",
                                    "created_at_rawDateFormat": "2020-11-27T07:06:04.733Z",
                                    "testCoverage": 8.06
                                }
                            },
                            {
                                "id": 215105260,
                                "gitlabId": 215105260,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730079,
                                    "isTestReportAvailable": false,
                                    "duration": 353,
                                    "duration_inMinutes": 5.88,
                                    "created_at": "Nov-12-20",
                                    "created_at_rawDateFormat": "2020-11-12T07:06:04.758Z",
                                    "testCoverage": 10.09
                                }
                            },
                            {
                                "id": 215102441,
                                "gitlabId": 215102441,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730076,
                                    "isTestReportAvailable": false,
                                    "duration": 306,
                                    "duration_inMinutes": 5.1,
                                    "created_at": "Nov-12-20",
                                    "created_at_rawDateFormat": "2020-11-12T07:06:04.596Z",
                                    "testCoverage": 10.09
                                }
                            },
                            {
                                "id": 215097595,
                                "gitlabId": 215097595,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730083,
                                    "isTestReportAvailable": false,
                                    "duration": 337,
                                    "duration_inMinutes": 5.62,
                                    "created_at": "Nov-12-20",
                                    "created_at_rawDateFormat": "2020-11-12T07:06:04.971Z",
                                    "testCoverage": 10.09
                                }
                            },
                            {
                                "id": 215074759,
                                "gitlabId": 215074759,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730080,
                                    "isTestReportAvailable": false,
                                    "duration": 375,
                                    "duration_inMinutes": 6.25,
                                    "created_at": "Nov-12-20",
                                    "created_at_rawDateFormat": "2020-11-12T07:06:04.795Z",
                                    "testCoverage": 10.09
                                }
                            },
                            {
                                "id": 215062766,
                                "gitlabId": 215062766,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730081,
                                    "isTestReportAvailable": false,
                                    "duration": 350,
                                    "duration_inMinutes": 5.83,
                                    "created_at": "Nov-12-20",
                                    "created_at_rawDateFormat": "2020-11-12T07:06:04.886Z",
                                    "testCoverage": 10.09
                                }
                            },
                            {
                                "id": 214745433,
                                "gitlabId": 214745433,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730082,
                                    "isTestReportAvailable": false,
                                    "duration": 448,
                                    "duration_inMinutes": 7.47,
                                    "created_at": "Nov-11-20",
                                    "created_at_rawDateFormat": "2020-11-11T07:06:04.938Z",
                                    "testCoverage": 10.04
                                }
                            },
                            {
                                "id": 214580427,
                                "gitlabId": 214580427,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730084,
                                    "isTestReportAvailable": false,
                                    "duration": 307,
                                    "duration_inMinutes": 5.12,
                                    "created_at": "Nov-11-20",
                                    "created_at_rawDateFormat": "2020-11-11T07:06:05.098Z",
                                    "testCoverage": 10.04
                                }
                            },
                            {
                                "id": 214579102,
                                "gitlabId": 214579102,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 730122,
                                    "isTestReportAvailable": false,
                                    "duration": 280,
                                    "duration_inMinutes": 4.67,
                                    "created_at": "Nov-11-20",
                                    "created_at_rawDateFormat": "2020-11-11T07:06:07.686Z",
                                    "testCoverage": 10.04
                                }
                            }
                        ],
                        "groupInfo": {
                            "id": 29713,
                            "gitlabId": 8652138,
                            "name": "Bühler"
                        }
                    }
                ],
                "subGroups": [],
                "stats": {
                    "id": 6709,
                    "isThereSubgroups": false,
                    "numberOfProjects": 1,
                    "testCoverageOfAllProjects": 18.75,
                    "numberOfPipelines": 97,
                    "numberOfTestReports": 0
                }
            },
            {
                "id": 10405659,
                "tempData": false,
                "gitlabId": 10405659,
                "name": "Gebhardt",
                "projects": [
                    {
                        "id": 23111818,
                        "gitlabId": 23111818,
                        "name": "Gebhardt",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/Gebhardt.git",
                        "stats": {
                            "id": 29714,
                            "status": "success",
                            "numberOfPipelines": 19,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": true,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 756,
                            "averageDurationOfPipelines_inMinutes": 12.6,
                            "testCoverage": 66.04,
                            "numberOfSuccessfulPipelines": 8,
                            "numberOfFailedPipelines": 6,
                            "numberOfCanceledPipelines": 5,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": 42.11,
                            "totalRepoSize": "1499463",
                            "artifactsSize": "1638818"
                        },
                        "pipelines": [
                            {
                                "id": 230149651,
                                "gitlabId": 230149651,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728174,
                                    "isTestReportAvailable": false,
                                    "duration": 953,
                                    "duration_inMinutes": 15.88,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:42.032Z",
                                    "testCoverage": 66.04
                                }
                            },
                            {
                                "id": 230099077,
                                "gitlabId": 230099077,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 728176,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:42.126Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 230024232,
                                "gitlabId": 230024232,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728183,
                                    "isTestReportAvailable": false,
                                    "duration": 1270,
                                    "duration_inMinutes": 21.17,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:42.617Z",
                                    "testCoverage": 66.04
                                }
                            },
                            {
                                "id": 230023221,
                                "gitlabId": 230023221,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728179,
                                    "isTestReportAvailable": false,
                                    "duration": 1277,
                                    "duration_inMinutes": 21.28,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:42.426Z",
                                    "testCoverage": 66.04
                                }
                            },
                            {
                                "id": 230015893,
                                "gitlabId": 230015893,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728178,
                                    "isTestReportAvailable": false,
                                    "duration": 1002,
                                    "duration_inMinutes": 16.7,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:42.336Z",
                                    "testCoverage": 66.04
                                }
                            },
                            {
                                "id": 230013744,
                                "gitlabId": 230013744,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 728177,
                                    "isTestReportAvailable": false,
                                    "duration": 35,
                                    "duration_inMinutes": 0.58,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:42.312Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 230012918,
                                "gitlabId": 230012918,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 728180,
                                    "isTestReportAvailable": false,
                                    "duration": 117,
                                    "duration_inMinutes": 1.95,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:42.482Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 230006717,
                                "gitlabId": 230006717,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728182,
                                    "isTestReportAvailable": false,
                                    "duration": null,
                                    "duration_inMinutes": 0,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:42.599Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 229996437,
                                "gitlabId": 229996437,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728184,
                                    "isTestReportAvailable": false,
                                    "duration": 1285,
                                    "duration_inMinutes": 21.42,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:42.715Z",
                                    "testCoverage": 66.04
                                }
                            },
                            {
                                "id": 229962237,
                                "gitlabId": 229962237,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728181,
                                    "isTestReportAvailable": false,
                                    "duration": 997,
                                    "duration_inMinutes": 16.62,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:42.586Z",
                                    "testCoverage": 66.04
                                }
                            },
                            {
                                "id": 229961525,
                                "gitlabId": 229961525,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 728186,
                                    "isTestReportAvailable": false,
                                    "duration": 100,
                                    "duration_inMinutes": 1.67,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:42.874Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 229957720,
                                "gitlabId": 229957720,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728185,
                                    "isTestReportAvailable": false,
                                    "duration": 302,
                                    "duration_inMinutes": 5.03,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:42.746Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 229954073,
                                "gitlabId": 229954073,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728191,
                                    "isTestReportAvailable": false,
                                    "duration": 1488,
                                    "duration_inMinutes": 24.8,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:43.045Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 229944700,
                                "gitlabId": 229944700,
                                "status": "success",
                                "testReport": null,
                                "stats": {
                                    "id": 728188,
                                    "isTestReportAvailable": false,
                                    "duration": 942,
                                    "duration_inMinutes": 15.7,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:42.967Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 229943507,
                                "gitlabId": 229943507,
                                "status": "canceled",
                                "testReport": null,
                                "stats": {
                                    "id": 728187,
                                    "isTestReportAvailable": false,
                                    "duration": 325,
                                    "duration_inMinutes": 5.42,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:42.958Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 229936231,
                                "gitlabId": 229936231,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728189,
                                    "isTestReportAvailable": false,
                                    "duration": 284,
                                    "duration_inMinutes": 4.73,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:42.988Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 229932939,
                                "gitlabId": 229932939,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728190,
                                    "isTestReportAvailable": false,
                                    "duration": 194,
                                    "duration_inMinutes": 3.23,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:42.993Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 229930037,
                                "gitlabId": 229930037,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728192,
                                    "isTestReportAvailable": false,
                                    "duration": 193,
                                    "duration_inMinutes": 3.22,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:43.161Z",
                                    "testCoverage": null
                                }
                            },
                            {
                                "id": 229905835,
                                "gitlabId": 229905835,
                                "status": "failed",
                                "testReport": null,
                                "stats": {
                                    "id": 728196,
                                    "isTestReportAvailable": false,
                                    "duration": 3604,
                                    "duration_inMinutes": 60.07,
                                    "created_at": "Dec-15-20",
                                    "created_at_rawDateFormat": "2020-12-15T07:03:43.407Z",
                                    "testCoverage": null
                                }
                            }
                        ],
                        "groupInfo": {
                            "id": 29717,
                            "gitlabId": 10405659,
                            "name": "Gebhardt"
                        }
                    }
                ],
                "subGroups": [],
                "stats": {
                    "id": 6711,
                    "isThereSubgroups": false,
                    "numberOfProjects": 1,
                    "testCoverageOfAllProjects": 66.04,
                    "numberOfPipelines": 19,
                    "numberOfTestReports": 0
                }
            },
            {
                "id": 9942353,
                "tempData": false,
                "gitlabId": 9942353,
                "name": "Riedl-KG",
                "projects": [
                    {
                        "id": 22109440,
                        "gitlabId": 22109440,
                        "name": "Riedl-KG",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/configurator.git",
                        "stats": {
                            "id": 29744,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "209715",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29755,
                            "gitlabId": 9942353,
                            "name": "Riedl-KG"
                        }
                    }
                ],
                "subGroups": [],
                "stats": {
                    "id": 6731,
                    "isThereSubgroups": false,
                    "numberOfProjects": 1,
                    "testCoverageOfAllProjects": null,
                    "numberOfPipelines": 0,
                    "numberOfTestReports": 0
                }
            },
            {
                "id": 7457493,
                "tempData": false,
                "gitlabId": 7457493,
                "name": "Petersen",
                "projects": [
                    {
                        "id": 17590152,
                        "gitlabId": 17590152,
                        "name": "Petersen-view",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/topology-view.git",
                        "stats": {
                            "id": 29794,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "60335063",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29792,
                            "gitlabId": 7457493,
                            "name": "Petersen"
                        }
                    },
                    {
                        "id": 17662400,
                        "gitlabId": 17662400,
                        "name": "tables-display",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/tables-display.git",
                        "stats": {
                            "id": 29765,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "0",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29756,
                            "gitlabId": 7457493,
                            "name": "Petersen"
                        }
                    }
                ],
                "subGroups": [],
                "stats": {
                    "id": 6726,
                    "isThereSubgroups": false,
                    "numberOfProjects": 2,
                    "testCoverageOfAllProjects": null,
                    "numberOfPipelines": 0,
                    "numberOfTestReports": 0
                }
            },
            {
                "id": 6204332,
                "tempData": false,
                "gitlabId": 6204332,
                "name": "Kramer",
                "projects": [
                    {
                        "id": 14615962,
                        "gitlabId": 14615962,
                        "name": "Kramer-1",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/matrix.git",
                        "stats": {
                            "id": 29776,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "0",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29787,
                            "gitlabId": 6204332,
                            "name": "Kramer"
                        }
                    },
                    {
                        "id": 14616018,
                        "gitlabId": 14616018,
                        "name": "MyAccount",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/my-account.git",
                        "stats": {
                            "id": 29764,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "0",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29775,
                            "gitlabId": 6204332,
                            "name": "Kramer"
                        }
                    },
                    {
                        "id": 14616041,
                        "gitlabId": 14616041,
                        "name": "Portal Evaluation",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/evaluation.git",
                        "stats": {
                            "id": 29763,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "0",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29773,
                            "gitlabId": 6204332,
                            "name": "Kramer"
                        }
                    }
                ],
                "subGroups": [],
                "stats": {
                    "id": 6727,
                    "isThereSubgroups": false,
                    "numberOfProjects": 3,
                    "testCoverageOfAllProjects": null,
                    "numberOfPipelines": 0,
                    "numberOfTestReports": 0
                }
            },
            {
                "id": 8198288,
                "tempData": false,
                "gitlabId": 8198288,
                "name": "Bachmann",
                "projects": [
                    {
                        "id": 14044833,
                        "gitlabId": 14044833,
                        "name": "Bachmann",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/uttgart.git",
                        "stats": {
                            "id": 29771,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "0",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29767,
                            "gitlabId": 8198288,
                            "name": "Bachmann"
                        }
                    }
                ],
                "subGroups": [],
                "stats": {
                    "id": 6728,
                    "isThereSubgroups": false,
                    "numberOfProjects": 1,
                    "testCoverageOfAllProjects": null,
                    "numberOfPipelines": 0,
                    "numberOfTestReports": 0
                }
            },
            {
                "id": 12325679,
                "tempData": false,
                "gitlabId": 12325679,
                "name": "Brenner",
                "projects": [
                    {
                        "id": 27242748,
                        "gitlabId": 27242748,
                        "name": "Brenner-confluence",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/confluence.git",
                        "stats": {
                            "id": 29769,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "293601",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29765,
                            "gitlabId": 12325679,
                            "name": "Brenner"
                        }
                    }
                ],
                "subGroups": [],
                "stats": {
                    "id": 6729,
                    "isThereSubgroups": false,
                    "numberOfProjects": 1,
                    "testCoverageOfAllProjects": null,
                    "numberOfPipelines": 0,
                    "numberOfTestReports": 0
                }
            },
            {
                "id": 11617957,
                "tempData": false,
                "gitlabId": 11617957,
                "name": "Marquardt",
                "projects": [
                    {
                        "id": 25679057,
                        "gitlabId": 25679057,
                        "name": "Marquardt",
                        "urlToRepo": "https://gitlab.com/w11k-devs/customers/check.git",
                        "stats": {
                            "id": 29758,
                            "status": null,
                            "numberOfPipelines": 0,
                            "areTestsAvailable": false,
                            "areTestCoveragesAvailable": false,
                            "numberOfTestReports": 0,
                            "averageDurationOfPipelines": 0,
                            "averageDurationOfPipelines_inMinutes": 0,
                            "testCoverage": null,
                            "numberOfSuccessfulPipelines": 0,
                            "numberOfFailedPipelines": 0,
                            "numberOfCanceledPipelines": 0,
                            "numberOfRunningPipelines": 0,
                            "numberOfSkippedPipelines": 0,
                            "pipelinesSuccessRatio": null,
                            "totalRepoSize": "4645191",
                            "artifactsSize": "0"
                        },
                        "pipelines": [],
                        "groupInfo": {
                            "id": 29761,
                            "gitlabId": 11617957,
                            "name": "Marquardt"
                        }
                    }
                ],
                "subGroups": [],
                "stats": {
                    "id": 6730,
                    "isThereSubgroups": false,
                    "numberOfProjects": 1,
                    "testCoverageOfAllProjects": null,
                    "numberOfPipelines": 0,
                    "numberOfTestReports": 0
                }
            }
        ],
        "stats": {
            "id": 6725,
            "isThereSubgroups": true,
            "numberOfProjects": 47,
            "testCoverageOfAllProjects": 301.29,
            "numberOfPipelines": 1064,
            "numberOfTestReports": 127
        }
    }
]
